var kA = Object.defineProperty;
var jA = (e, t, r) => t in e ? kA(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r;
var $ = (e, t, r) => jA(e, typeof t != "symbol" ? t + "" : t, r);
import { useFlags as UA } from "launchdarkly-react-client-sdk";
const fz = {
  request: {
    status: 400,
    error: {
      name: "Request Error",
      message: "There was something wrong with the request that you made."
    }
  },
  notFound: {
    status: 404,
    error: {
      name: "Not Found Error",
      message: "The resource you requested was not found."
    }
  },
  data: {
    status: 500,
    error: {
      name: "Data Error",
      message: "Our apologies, there was a problem with retrieving the data."
    }
  },
  config: {
    status: 500,
    error: {
      name: "Config Error",
      message: "The system is not configured as expected."
    }
  },
  root: {
    status: 400,
    error: {
      name: "Root User Error",
      message: "You are logged in as a root user, but are trying to use a feature that does not work for root accounts."
    }
  },
  general: {
    status: 500,
    error: {
      name: "General Error",
      message: "Our apologies, we encountered an error when trying to fulfill your request."
    }
  }
};
function Du(e) {
  const t = Object.values(e).filter((n) => typeof n == "number");
  return Object.entries(e).filter(([n, i]) => t.indexOf(+n) === -1).map(([n, i]) => i);
}
function gf(e, t = "|") {
  return e.map((r) => hg(r)).join(t);
}
function Mu(e, t) {
  return typeof t == "bigint" ? t.toString() : t;
}
class $A {
  constructor(t) {
    this._getter = t, this._value = void 0;
  }
  get value() {
    const t = this._getter;
    return t !== void 0 && (this._value = t(), this._getter = void 0), this._value;
  }
}
function ta(e) {
  return new $A(e);
}
function lg(e) {
  return e == null;
}
function Ol(e) {
  const t = e.startsWith("^") ? 1 : 0, r = e.endsWith("$") ? e.length - 1 : e.length;
  return e.slice(t, r);
}
function cg(e, t) {
  const r = e / t, n = Math.round(r), i = 4 * Number.EPSILON * Math.max(Math.abs(r), 1);
  return Math.abs(r - n) < i ? 0 : r - n;
}
function Fr(e, t, r) {
  Object.defineProperty(e, t, {
    value: r,
    writable: !0,
    enumerable: !0,
    configurable: !0
  });
}
function wl(e) {
  const t = Object.getOwnPropertyDescriptor(e, "shape");
  return t != null && t.get ? t.get.raw : t == null ? void 0 : t.value;
}
function kr(e) {
  return wl(e._zod.def) ?? e._zod.def.shape;
}
function fg(e, t, r) {
  Object.defineProperty(e, t, {
    get() {
      const n = r();
      return Fr(this, t, n), n;
    },
    enumerable: !0,
    configurable: !0
  });
}
function dg(e, t, r) {
  t in e ? Fr(e, t, r) : e[t] = r;
}
function Un(e, t, r, n) {
  const i = kr(t);
  for (const o of r) {
    const s = Object.getOwnPropertyDescriptor(i, o);
    s.enumerable && (s.get ? fg(e, o, () => {
      const a = t._zod.def.shape[o];
      return n ? n(a, o) : a;
    }) : dg(e, o, n ? n(s.value, o) : s.value));
  }
}
function FA(e, t) {
  for (const r of Reflect.ownKeys(t)) {
    const n = Object.getOwnPropertyDescriptor(t, r);
    n.enumerable && (n.get ? fg(e, r, () => t[r]) : dg(e, r, n.value));
  }
}
function kt(...e) {
  const t = {};
  for (const r of e) {
    const n = Object.getOwnPropertyDescriptors(r);
    Object.assign(t, n);
  }
  return Object.defineProperties({}, t);
}
function zt(e) {
  return JSON.stringify(e);
}
function GA(e) {
  return e.toLowerCase().trim().replace(/[^\w\s-]/g, "").replace(/[\s_-]+/g, "-").replace(/^-+|-+$/g, "");
}
const pg = "captureStackTrace" in Error ? Error.captureStackTrace : (...e) => {
};
function Fo(e) {
  return typeof e == "object" && e !== null && !Array.isArray(e);
}
const zA = /* @__PURE__ */ ta(() => {
  var e;
  if (_t.jitless || typeof navigator < "u" && ((e = navigator == null ? void 0 : navigator.userAgent) != null && e.includes("Cloudflare")))
    return !1;
  try {
    const t = Function;
    return new t(""), !0;
  } catch {
    return !1;
  }
});
function $n(e) {
  if (Fo(e) === !1)
    return !1;
  const t = e.constructor;
  if (t === void 0 || typeof t != "function")
    return !0;
  const r = t.prototype;
  return !(Fo(r) === !1 || Object.prototype.hasOwnProperty.call(r, "isPrototypeOf") === !1);
}
function Nl(e) {
  return $n(e) ? { ...e } : Array.isArray(e) ? [...e] : e instanceof Map ? new Map(e) : e instanceof Set ? new Set(e) : e;
}
const Lu = /* @__PURE__ */ new Set(["string", "number", "symbol"]);
function bi(e) {
  return e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
function Gr(e, t, r) {
  const n = new e._zod.constr(t ?? e._zod.def);
  return (!t || r != null && r.parent) && (n._zod.parent = e), n;
}
function se(e) {
  const t = e;
  if (!t)
    return {};
  if (typeof t == "string")
    return { error: () => t };
  if ((t == null ? void 0 : t.message) !== void 0) {
    if ((t == null ? void 0 : t.error) !== void 0)
      throw new Error("Cannot specify both `message` and `error` params");
    t.error = t.message;
  }
  return delete t.message, typeof t.error == "string" ? { ...t, error: () => t.error } : t;
}
function hg(e) {
  return typeof e == "bigint" ? e.toString() + "n" : typeof e == "string" ? `"${e}"` : `${e}`;
}
function BA(e) {
  return Object.keys(e).filter((t) => e[t]._zod.optin !== void 0 && e[t]._zod.optout === "optional");
}
const mg = {
  safeint: [Number.MIN_SAFE_INTEGER, Number.MAX_SAFE_INTEGER],
  int32: [-2147483648, 2147483647],
  uint32: [0, 4294967295],
  float32: [-34028234663852886e22, 34028234663852886e22],
  float64: [-Number.MAX_VALUE, Number.MAX_VALUE]
}, VA = {
  int64: [/* @__PURE__ */ BigInt("-9223372036854775808"), /* @__PURE__ */ BigInt("9223372036854775807")],
  uint64: [/* @__PURE__ */ BigInt(0), /* @__PURE__ */ BigInt("18446744073709551615")]
};
function WA(e, t) {
  const r = e._zod.def, n = r.checks;
  if (n && n.length > 0)
    throw new Error(".pick() cannot be used on object schemas containing refinements");
  const o = {};
  return Un(o, e, ra(e, t)), Gr(e, kt(r, { shape: o, checks: [] }));
}
function ra(e, t) {
  var i;
  const r = kr(e), n = [];
  for (const o of Reflect.ownKeys(t)) {
    if (!((i = Object.getOwnPropertyDescriptor(r, o)) != null && i.enumerable))
      throw new Error(`Unrecognized key: "${String(o)}"`);
    t[o] && n.push(o);
  }
  return n;
}
function qA(e, t) {
  const r = e._zod.def, n = r.checks;
  if (n && n.length > 0)
    throw new Error(".omit() cannot be used on object schemas containing refinements");
  const o = new Set(ra(e, t)), s = {};
  return Un(s, e, Reflect.ownKeys(kr(e)).filter((a) => !o.has(a))), Gr(e, kt(r, { shape: s, checks: [] }));
}
function HA(e, t) {
  if (!$n(t))
    throw new Error("Invalid input to extend: expected a plain object");
  const r = e._zod.def.checks;
  if (r && r.length > 0) {
    const i = kr(e);
    for (const o of Reflect.ownKeys(t))
      if (Object.getOwnPropertyDescriptor(i, o) !== void 0)
        throw new Error("Cannot overwrite keys on object schemas containing refinements. Use `.safeExtend()` instead.");
  }
  return Gr(e, kt(e._zod.def, { shape: Eg(e, t) }));
}
function Eg(e, t) {
  const r = {};
  return Un(r, e, Reflect.ownKeys(kr(e))), FA(r, t), r;
}
function YA(e, t) {
  if (!$n(t))
    throw new Error("Invalid input to safeExtend: expected a plain object");
  return Gr(e, kt(e._zod.def, { shape: Eg(e, t) }));
}
function ZA(e, t) {
  var i, o;
  if (!((i = t == null ? void 0 : t._zod) != null && i.def))
    throw new Error("Invalid input to merge: expected an object schema. To merge a plain shape, use `.extend()`.");
  if ((o = e._zod.def.checks) != null && o.length)
    throw new Error(".merge() cannot be used on object schemas containing refinements. Use .safeExtend() instead.");
  const r = {};
  Un(r, e, Reflect.ownKeys(kr(e))), Un(r, t, Reflect.ownKeys(kr(t)));
  const n = kt(e._zod.def, {
    shape: r,
    get catchall() {
      return t._zod.def.catchall;
    },
    checks: t._zod.def.checks ?? []
  });
  return Gr(e, n);
}
function yf(e, t, r, n = "partial") {
  const o = t._zod.def.checks;
  if (o && o.length > 0)
    throw new Error(`.${n}() cannot be used on object schemas containing refinements`);
  const a = r ? new Set(ra(t, r)) : void 0, l = {};
  return Un(l, t, Reflect.ownKeys(kr(t)), e && ((f, u) => a && !a.has(u) ? f : new e({ type: "optional", innerType: f }))), Gr(t, kt(t._zod.def, { shape: l, checks: [] }));
}
function JA(e, t, r) {
  const n = r ? new Set(ra(t, r)) : void 0, i = {};
  return Un(i, t, Reflect.ownKeys(kr(t)), (o, s) => (
    // overwrite with non-optional
    n && !n.has(s) ? o : new e({ type: "nonoptional", innerType: o })
  )), Gr(t, kt(t._zod.def, { shape: i }));
}
function Gt(e, t = 0) {
  var r;
  if (e.aborted === !0)
    return !0;
  for (let n = t; n < e.issues.length; n++)
    if (((r = e.issues[n]) == null ? void 0 : r.continue) !== !0)
      return !0;
  return !1;
}
function KA(e, t = 0) {
  var r;
  if (e.aborted === !0)
    return !0;
  for (let n = t; n < e.issues.length; n++)
    if (((r = e.issues[n]) == null ? void 0 : r.continue) === !1)
      return !0;
  return !1;
}
function lr(e, t) {
  return t.map((r) => {
    var n;
    return (n = r).path ?? (n.path = []), r.path.unshift(e), r;
  });
}
function Ui(e) {
  return typeof e == "string" ? e : e == null ? void 0 : e.message;
}
function xu(e) {
  const t = [];
  for (const r of e ?? []) {
    const n = r._zod.def;
    if (!/_(length|size)$|_equals$/.test(n.check))
      break;
    const i = n.maximum ?? n.length ?? n.size;
    i >= 0 && t.push([i, r]);
  }
  return t;
}
function ku(e, t, r) {
  var n;
  for (let i = t; i < e.length; i++)
    (n = e[i]).schema ?? (n.schema = r);
}
function fr(e, t, r) {
  var l, f, u, h, E, d, g, y, b, _;
  var n;
  const i = (f = (l = e.inst) == null ? void 0 : l._zod) == null ? void 0 : f.traits;
  i != null && i.has("$ZodType") && (i.has("$ZodCheck") ? (n = e).schema ?? (n.schema = e.inst) : e.schema = e.inst);
  const o = e.schema !== e.inst ? (h = (u = e.schema) == null ? void 0 : u._zod.def) == null ? void 0 : h.error : void 0, s = e.message ? e.message : Ui((g = (d = (E = e.inst) == null ? void 0 : E._zod.def) == null ? void 0 : d.error) == null ? void 0 : g.call(d, e)) ?? Ui(o == null ? void 0 : o(e)) ?? Ui((y = t == null ? void 0 : t.error) == null ? void 0 : y.call(t, e)) ?? Ui((b = r.customError) == null ? void 0 : b.call(r, e)) ?? Ui((_ = r.localeError) == null ? void 0 : _.call(r, e)) ?? "Invalid input", a = {};
  for (const I of Object.keys(e))
    I === "inst" || I === "schema" || I === "continue" || I === "input" || I === "__proto__" || (a[I] = e[I]);
  return a.path ?? (a.path = []), a.message = s, t != null && t.reportInput && (a.input = e.input), a;
}
function Cl(e) {
  return e instanceof Set ? "set" : e instanceof Map ? "map" : e instanceof File ? "file" : "unknown";
}
const XA = /[\uD800-\uDBFF]/;
function na(e) {
  const t = e.length;
  if (!XA.test(e))
    return t;
  let r = t;
  for (let n = 0; n < t - 1; n++)
    (e.charCodeAt(n) & 64512) === 55296 && (e.charCodeAt(n + 1) & 64512) === 56320 && (r--, n++);
  return r;
}
function Pl(e) {
  return Array.isArray(e) ? "array" : typeof e == "string" ? "string" : "unknown";
}
function QA(e) {
  const t = typeof e;
  switch (t) {
    case "number":
      return Number.isNaN(e) ? "nan" : "number";
    case "object": {
      if (e === null)
        return "null";
      if (Array.isArray(e))
        return "array";
      const r = e;
      if (r && Object.getPrototypeOf(r) !== Object.prototype && "constructor" in r && r.constructor)
        return r.constructor.name;
    }
  }
  return t;
}
function Go(...e) {
  const [t, r, n] = e;
  return typeof t == "string" ? {
    message: t,
    code: "custom",
    input: r,
    inst: n
  } : { ...t };
}
function ev(e, t) {
  for (const r in t) {
    const n = Object.getOwnPropertyDescriptor(t, r);
    n.get ? Object.defineProperty(e, r, { ...n, enumerable: !1 }) : tv(e, r, n.value);
  }
}
function Qr(e, t, r, n = !0) {
  return Object.defineProperty(e, t, { configurable: !0, writable: !0, enumerable: n, value: r }), r;
}
function gg(e, t, r) {
  return Qr(e, t, r, !1);
}
function Dl(e, t) {
  for (const r in e) {
    const n = e[r];
    Object.defineProperty(t, r, {
      configurable: !0,
      enumerable: !0,
      get() {
        return Qr(this, r, n(this));
      },
      set(i) {
        Qr(this, r, i);
      }
    });
  }
  return t;
}
function tv(e, t, r) {
  Object.defineProperty(e, t, {
    configurable: !0,
    get() {
      return this == null ? r : Qr(this, t, r.bind(this));
    },
    set(n) {
      Qr(this, t, n);
    }
  });
}
function rv(e, t) {
  const r = Object.getPrototypeOf(e);
  return t in r ? void 0 : r;
}
let xa, Yr = !1;
const nv = {
  configurable: !0,
  get() {
    Yr = !0;
  }
};
function ke(e, t, r) {
  const n = Object.getPrototypeOf(e._zod);
  if (t in n && xa !== e._zod) {
    xa = void 0;
    return;
  }
  xa = e._zod, Object.defineProperty(n, t, {
    configurable: !0,
    get() {
      Object.defineProperty(this, t, nv);
      const i = Yr;
      Yr = !1;
      try {
        const o = r(this);
        return Yr ? delete this[t] : Object.defineProperty(this, t, { configurable: !0, writable: !0, value: o }), Yr = Yr || i, o;
      } catch (o) {
        throw delete this[t], Yr = Yr || i, o;
      }
    },
    set(i) {
      Object.defineProperty(this, t, { configurable: !0, writable: !0, value: i });
    }
  });
}
function iv(e, t, r, n) {
  const i = rv(e, t);
  i && Object.defineProperty(i, t, {
    configurable: !0,
    get() {
      const o = { configurable: !0, writable: !0, enumerable: n, value: void 0 };
      return Object.defineProperty(this, t, o), o.value = r(this), Object.defineProperty(this, t, o), o.value;
    },
    set(o) {
      Object.defineProperty(this, t, { configurable: !0, writable: !0, enumerable: n, value: o });
    }
  });
}
const yg = "~constantCatch";
function ov(e) {
  const t = () => e;
  return t[yg] = !0, t;
}
var Tf;
const ka = { value: void 0, enumerable: !1 };
let bf = "captureStackTrace" in Error ? Error : null;
function sv(e) {
  const t = bf;
  if (t) {
    const r = t.stackTraceLimit;
    if (typeof r == "number") {
      try {
        t.stackTraceLimit = 0;
      } catch {
        return bf = null, new e();
      }
      try {
        return new e();
      } finally {
        t.stackTraceLimit = r;
      }
    }
  }
  return new e();
}
function Y(e, t, r, n) {
  const i = {};
  function o(E) {
    this.def = E, this.constr = h, this.traits = /* @__PURE__ */ new Set();
  }
  o.prototype = i;
  const s = r, a = s && /* @__PURE__ */ new WeakSet();
  function l(E, d) {
    if (E._zod) {
      if (E._zod.traits.has(e))
        return;
    } else {
      ka.value = new o(d);
      try {
        Object.defineProperty(E, "_zod", ka);
      } finally {
        ka.value = void 0;
      }
    }
    if (E._zod.traits.add(e), t(E, d), a) {
      const y = Object.getPrototypeOf(E), b = E._zod.constr.prototype;
      let _ = y;
      for (; _ && _ !== b; )
        _ = Object.getPrototypeOf(_);
      const I = _ ?? y;
      a.has(I) || (a.add(I), ev(I, s));
    }
    const g = h.prototype;
    for (const y in g)
      Object.prototype.hasOwnProperty.call(g, y) && (y in E || (E[y] = g[y].bind(E)));
  }
  const f = (n == null ? void 0 : n.Parent) ?? Object;
  class u extends f {
  }
  Object.defineProperty(u, "name", { value: e });
  function h(E) {
    var b;
    const d = n != null && n.Parent ? sv(u) : this;
    l(d, E);
    const g = d._zod.deferred;
    if (g) {
      for (const _ of g)
        _();
      d._zod.deferred = void 0;
    }
    const y = (b = globalThis.__zod_globalConfig) == null ? void 0 : b.postProcessor;
    return y && y(d), d;
  }
  return Object.defineProperty(h, "init", { value: l }), Object.defineProperty(h, Symbol.hasInstance, {
    value: (E) => {
      var d, g;
      return n != null && n.Parent && E instanceof n.Parent ? !0 : (g = (d = E == null ? void 0 : E._zod) == null ? void 0 : d.traits) == null ? void 0 : g.has(e);
    }
  }), Object.defineProperty(h, "name", { value: e }), h;
}
class Kr extends Error {
  constructor() {
    super("Encountered Promise during synchronous parse. Use .parseAsync() instead.");
  }
}
class Tg extends Error {
  constructor(t) {
    super(`Encountered unidirectional transform during encode: ${t}`), this.name = "ZodEncodeError";
  }
}
(Tf = globalThis).__zod_globalConfig ?? (Tf.__zod_globalConfig = {});
const _t = globalThis.__zod_globalConfig;
function qt(e) {
  return e && Object.assign(_t, e), _t;
}
class bg {
  constructor(t = [], r = {}) {
    this.content = [], this.indent = 0, this.args = t, this.closed = r;
  }
  // the compiler catches a child's throw and keeps writing into this doc, so the indent has to unwind with it
  indented(t) {
    this.indent += 1;
    try {
      t(this);
    } finally {
      this.indent -= 1;
    }
  }
  write(t) {
    if (typeof t == "function") {
      t(this, { execution: "sync" }), t(this, { execution: "async" });
      return;
    }
    const n = t.split(`
`).filter((s) => s), i = Math.min(...n.map((s) => s.length - s.trimStart().length)), o = n.map((s) => s.slice(i)).map((s) => " ".repeat(this.indent * 2) + s);
    for (const s of o)
      this.content.push(s);
  }
  compile() {
    const t = Function, r = (this == null ? void 0 : this.content) ?? [""];
    return new t(...Object.keys(this.closed), `return function (${this.args.join(", ")}) {
${r.join(`
`)}
};`)(...Object.values(this.closed));
  }
}
class av extends Error {
  constructor() {
    super("Cannot parse a reference cycle that closes through a transform"), this.name = "ZodCyclicError";
  }
}
const ju = "~memo", Af = [];
function Ag(e) {
  return e !== null && typeof e == "object";
}
function ja(e) {
  return e.map((t) => t.path ? { ...t, path: t.path.slice() } : { ...t });
}
const vg = /* @__PURE__ */ new WeakMap(), mi = 0, Ss = 1, ko = 2;
function jo(e, t, r) {
  const n = vg.get(e);
  if (n !== void 0)
    return n ? ko : mi;
  if (t.has(e))
    return ko;
  t.add(e);
  let i = mi;
  const o = (u) => {
    if (i !== ko && (u != null && u._zod)) {
      const h = jo(u, t, r);
      h > i && (i = h);
    }
  }, s = (u, h) => {
    var d;
    let E = mi;
    for (const g of Reflect.ownKeys(u)) {
      const y = Object.getOwnPropertyDescriptor(u, g);
      if (!y.enumerable)
        continue;
      const b = y.get ? Ss : (d = y.value) != null && d._zod ? jo(y.value, t, r) : mi;
      b > E && (E = b);
    }
    return E;
  }, a = (u) => {
    u > i && (i = u);
  }, l = e._zod.def;
  switch (l.type) {
    case "object": {
      const u = wl(l);
      a(u ? s(u) : Ss), o(l.catchall);
      break;
    }
    case "array":
      o(l.element);
      break;
    case "tuple":
      for (const u of l.items)
        o(u);
      o(l.rest);
      break;
    case "record":
    case "map":
      o(l.keyType), o(l.valueType);
      break;
    case "set":
      o(l.valueType);
      break;
    case "union":
      for (const u of l.options)
        o(u);
      break;
    case "intersection":
      o(l.left), o(l.right);
      break;
    case "optional":
    case "nullable":
    case "default":
    case "prefault":
    case "catch":
    case "readonly":
    case "nonoptional":
    case "promise":
    case "success":
      o(l.innerType);
      break;
    case "pipe":
      o(l.in), o(l.out);
      break;
    case "function":
      o(l.input), o(l.output);
      break;
    // `$ZodLazy` caches its inner on the def, so a resolved edge is followed exactly
    case "lazy": {
      const u = l._cachedInner ?? (r ? e._zod.innerType : void 0);
      a(u ? jo(u, t, !1) : Ss);
      break;
    }
    // a leaf by choice: `parts` are regex fragments, not data positions
    case "template_literal":
    // leaves
    case "string":
    case "number":
    case "int":
    case "boolean":
    case "bigint":
    case "symbol":
    case "undefined":
    case "null":
    case "void":
    case "never":
    case "any":
    case "unknown":
    case "date":
    case "nan":
    case "enum":
    case "literal":
    case "file":
    case "transform":
    case "custom":
      break;
    default:
      for (const u in l) {
        const h = Object.getOwnPropertyDescriptor(l, u);
        if (!h || h.get)
          continue;
        const E = h.value;
        if (!(!E || typeof E != "object")) {
          if (E._zod)
            o(E);
          else if (Array.isArray(E))
            for (const d of E)
              o(d);
        }
      }
  }
  return t.delete(e), uv(e, i);
}
function uv(e, t) {
  return t !== Ss && vg.set(e, t === ko), t;
}
function Sg(e) {
  return jo(e, /* @__PURE__ */ new Set(), !0) !== mi;
}
function lv(e, t) {
  let r = e.buckets.get(t);
  return r || (r = /* @__PURE__ */ new WeakMap(), e.buckets.set(t, r)), r;
}
let os;
const ss = [], cv = {
  alloc(e, t, r) {
    const n = os;
    if (!n)
      return r;
    os = void 0;
    const i = { value: r, issues: null };
    return n.set(t.value, i), ss.push(i), r;
  },
  guard(e) {
    var t;
    (t = e._zod).deferred ?? (t.deferred = []), e._zod.deferred.push(() => {
      const r = e._zod.parse, n = (i, o) => {
        if (o.direction !== "backward" && Ig(o, i.value))
          throw new av();
        return r(i, o);
      };
      e._zod.parse = n, e._zod.run === r && (e._zod.run = n);
    });
  },
  attach(e) {
    var t;
    let r, n = !1, i, o;
    (t = e._zod).deferred ?? (t.deferred = []), e._zod.deferred.push(() => {
      const s = e._zod.parse, a = (l, f) => {
        if (r === void 0) {
          const _ = jo(e, /* @__PURE__ */ new Set(), !1);
          if (_ === mi)
            return e._zod.parse = s, e._zod.run === a && (e._zod.run = s), s(l, f);
          _ === ko || n ? r = !0 : n = !0;
        }
        const u = l.value;
        if (!Ag(u))
          return s(l, f);
        let h = f[ju];
        h || (h = { buckets: /* @__PURE__ */ new WeakMap(), backEdges: void 0 }, f[ju] = h);
        let E;
        i === f ? E = o : (E = lv(h, e), i = f, o = E);
        const d = E.get(u);
        if (d)
          return l.value = d.value, d.issues ? d.issues.length && l.issues.push(...ja(d.issues)) : (l.memo = !0, h.backEdges ?? (h.backEdges = /* @__PURE__ */ new WeakSet()), h.backEdges.add(d.value)), l;
        os = E;
        const g = ss.length, y = s(l, f);
        os = void 0;
        const b = ss.length > g ? ss.pop() : void 0;
        return y instanceof Promise ? y.then((_) => (b && (b.issues = _.issues.length ? ja(_.issues) : Af), _)) : (b && (b.issues = y.issues.length ? ja(y.issues) : Af), y);
      };
      e._zod.parse = a, e._zod.run === s && (e._zod.run = a);
    });
  }
};
function fv() {
  return cv;
}
function Ig(e, t) {
  var n;
  const r = (n = e[ju]) == null ? void 0 : n.backEdges;
  return r !== void 0 && Ag(t) && r.has(t);
}
const dv = /^[cC][0-9a-z]{6,}$/, pv = /^[0-9a-z]+$/, hv = /^[0-7][0-9A-HJKMNP-TV-Za-hjkmnp-tv-z]{25}$/, mv = /^[0-9a-vA-V]{20}$/, Ev = /^[A-Za-z0-9]{27}$/, gv = /^[a-zA-Z0-9_-]{21}$/;
function yv(e) {
  return new RegExp(`^[a-zA-Z0-9_-]{${e}}$`);
}
const Tv = /^P(?:(\d+W)|(?!.*W)(?=\d|T\d)(\d+Y)?(\d+M)?(\d+D)?(T(?=\d)(\d+H)?(\d+M)?(\d+([.,]\d+)?S)?)?)$/, bv = /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12})$/, vf = (e) => e ? new RegExp(`^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-${e}[0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12})$`) : /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/, Av = /^(?:[A-Za-z0-9_'+\-]+\.)*[A-Za-z0-9_'+\-]*[A-Za-z0-9_+-]@(?:[A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$/, vv = "^(?=[\\s\\S]*[\\p{Extended_Pictographic}\\p{Regional_Indicator}\\u20E3])[\\p{Extended_Pictographic}\\p{Emoji_Component}]+$";
function Sv() {
  return new RegExp(vv, "u");
}
const Iv = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/, _v = /^(([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:))$/, Rv = /^((25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/([0-9]|[1-2][0-9]|3[0-2])$/, Ov = /^(([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:))\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/, wv = /^$|^(?:[0-9a-zA-Z+/]{4})*(?:(?:[0-9a-zA-Z+/]{2}==)|(?:[0-9a-zA-Z+/]{3}=))?$/, Nv = /^(?:[A-Za-z0-9_-]{4})*(?:[A-Za-z0-9_-]{2,3})?$/, Cv = /^https?$/, Pv = /^\+[1-9]\d{6,14}$/, Dv = /^\d(?:[ -]?\d){11,18}$/, Mv = /^[A-Z]{2}(?!00|01|99)\d{2}[A-Z0-9]{11,30}$/, _g = "(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))";
function Lv(e) {
  return new RegExp(`^${e}$`);
}
const xv = /* @__PURE__ */ Lv(_g);
function Uu(e) {
  const t = "(?:[01]\\d|2[0-3]):[0-5]\\d";
  return typeof e.precision == "number" ? e.precision === -1 ? `${t}` : e.precision === 0 ? `${t}:[0-5]\\d` : `${t}:[0-5]\\d\\.\\d{${e.precision}}` : e.seconds ? `${t}:[0-5]\\d(?:\\.\\d+)?` : `${t}(?::[0-5]\\d(?:\\.\\d+)?)?`;
}
function kv(e) {
  return new RegExp(`^${Uu(e)}$`);
}
function jv(e) {
  const t = ["Z"];
  e.offset && t.push("([+-](?:[01]\\d|2[0-3]):[0-5]\\d)");
  const r = `${Uu({ precision: e.precision, seconds: !0 })}(?:${t.join("|")})`, n = e.local ? `${r}|${Uu({ precision: e.precision })}` : r;
  return new RegExp(`^${_g}T(?:${n})$`);
}
const Uv = /^[\s\S]{0,}$/, $v = /^-?\d+$/, ia = /^-?\d+(?:\.\d+)?$/, Fv = /^(?:true|false)$/i, Gv = /^undefined$/i, zv = /^[^A-Z]*$/, Bv = /^[^a-z]*$/, mt = /* @__PURE__ */ Y("$ZodCheck", (e, t) => {
  var r;
  e._zod ?? (e._zod = {}), e._zod.def = t, (r = e._zod).onattach ?? (r.onattach = []);
}), Ml = (e) => {
  const t = e.value;
  return !lg(t) && t.size !== void 0;
}, Ll = (e) => {
  const t = e.value;
  return !lg(t) && t.length !== void 0;
}, Ps = {
  number: "number",
  bigint: "bigint",
  object: "date"
}, Rg = /* @__PURE__ */ Y("$ZodCheckLessThan", (e, t) => {
  mt.init(e, t);
  const r = Ps[typeof t.value];
  e._zod.check = (n) => {
    (t.inclusive ? n.value <= t.value : n.value < t.value) || n.issues.push({
      origin: Ps[typeof n.value] ?? r,
      code: "too_big",
      maximum: typeof t.value == "object" ? t.value.getTime() : t.value,
      input: n.value,
      inclusive: t.inclusive,
      inst: e,
      continue: !t.abort
    });
  };
}), Og = /* @__PURE__ */ Y("$ZodCheckGreaterThan", (e, t) => {
  mt.init(e, t);
  const r = Ps[typeof t.value];
  e._zod.check = (n) => {
    (t.inclusive ? n.value >= t.value : n.value > t.value) || n.issues.push({
      origin: Ps[typeof n.value] ?? r,
      code: "too_small",
      minimum: typeof t.value == "object" ? t.value.getTime() : t.value,
      input: n.value,
      inclusive: t.inclusive,
      inst: e,
      continue: !t.abort
    });
  };
}), Vv = /* @__PURE__ */ Y("$ZodCheckMultipleOf", (e, t) => {
  mt.init(e, t), e._zod.check = (r) => {
    if (typeof r.value != typeof t.value)
      throw new Error("Cannot mix number and bigint in multiple_of check.");
    (typeof r.value == "bigint" ? (
      // `value % 0n` throws, and nothing is a multiple of zero — the number branch already fails this way via NaN
      t.value !== BigInt(0) && r.value % t.value === BigInt(0)
    ) : cg(r.value, t.value) === 0) || r.issues.push({
      origin: typeof r.value,
      code: "not_multiple_of",
      divisor: t.value,
      input: r.value,
      inst: e,
      continue: !t.abort
    });
  };
}), Wv = /* @__PURE__ */ Y("$ZodCheckNumberFormat", (e, t) => {
  var s;
  mt.init(e, t), t.format = t.format || "float64";
  const r = (s = t.format) == null ? void 0 : s.includes("int"), n = r ? "int" : "number", [i, o] = mg[t.format];
  e._zod.check = (a) => {
    const l = a.value;
    if (r) {
      if (!Number.isInteger(l)) {
        a.issues.push({
          expected: n,
          format: t.format,
          code: "invalid_type",
          continue: !1,
          input: l,
          inst: e
        });
        return;
      }
      if (!Number.isSafeInteger(l)) {
        l > 0 ? a.issues.push({
          input: l,
          code: "too_big",
          maximum: Number.MAX_SAFE_INTEGER,
          note: "Integers must be within the safe integer range.",
          inst: e,
          origin: n,
          inclusive: !0,
          continue: !t.abort
        }) : a.issues.push({
          input: l,
          code: "too_small",
          minimum: Number.MIN_SAFE_INTEGER,
          note: "Integers must be within the safe integer range.",
          inst: e,
          origin: n,
          inclusive: !0,
          continue: !t.abort
        });
        return;
      }
    }
    l < i && a.issues.push({
      origin: "number",
      input: l,
      code: "too_small",
      minimum: i,
      inclusive: !0,
      inst: e,
      continue: !t.abort
    }), l > o && a.issues.push({
      origin: "number",
      input: l,
      code: "too_big",
      maximum: o,
      inclusive: !0,
      inst: e,
      continue: !t.abort
    });
  };
}), qv = /* @__PURE__ */ Y("$ZodCheckMaxSize", (e, t) => {
  var r;
  mt.init(e, t), (r = e._zod.def).when ?? (r.when = Ml), e._zod.check = (n) => {
    const i = n.value;
    i.size <= t.maximum || n.issues.push({
      origin: Cl(i),
      code: "too_big",
      maximum: t.maximum,
      inclusive: !0,
      input: i,
      inst: e,
      continue: !t.abort
    });
  };
}), Hv = /* @__PURE__ */ Y("$ZodCheckMinSize", (e, t) => {
  var r;
  mt.init(e, t), (r = e._zod.def).when ?? (r.when = Ml), e._zod.check = (n) => {
    const i = n.value;
    i.size >= t.minimum || n.issues.push({
      origin: Cl(i),
      code: "too_small",
      minimum: t.minimum,
      inclusive: !0,
      input: i,
      inst: e,
      continue: !t.abort
    });
  };
}), Yv = /* @__PURE__ */ Y("$ZodCheckSizeEquals", (e, t) => {
  var r;
  mt.init(e, t), (r = e._zod.def).when ?? (r.when = Ml), e._zod.check = (n) => {
    const i = n.value, o = i.size;
    if (o === t.size)
      return;
    const s = o > t.size;
    n.issues.push({
      origin: Cl(i),
      ...s ? { code: "too_big", maximum: t.size } : { code: "too_small", minimum: t.size },
      inclusive: !0,
      exact: !0,
      input: n.value,
      inst: e,
      continue: !t.abort
    });
  };
}), Zv = /* @__PURE__ */ Y("$ZodCheckMaxLength", (e, t) => {
  var r;
  mt.init(e, t), (r = e._zod.def).when ?? (r.when = Ll), e._zod.check = (n) => {
    const i = n.value, o = i.length;
    if ((typeof i == "string" && o > t.maximum ? na(i) : o) <= t.maximum)
      return;
    const a = Pl(i);
    n.issues.push({
      origin: a,
      code: "too_big",
      maximum: t.maximum,
      inclusive: !0,
      input: i,
      inst: e,
      continue: !t.abort
    });
  };
}), Jv = /* @__PURE__ */ Y("$ZodCheckMinLength", (e, t) => {
  var r;
  mt.init(e, t), (r = e._zod.def).when ?? (r.when = Ll), e._zod.check = (n) => {
    const i = n.value, o = i.length;
    if ((typeof i == "string" && o >= t.minimum && o < t.minimum * 2 ? na(i) : o) >= t.minimum)
      return;
    const a = Pl(i);
    n.issues.push({
      origin: a,
      code: "too_small",
      minimum: t.minimum,
      inclusive: !0,
      input: i,
      inst: e,
      continue: !t.abort
    });
  };
}), Kv = /* @__PURE__ */ Y("$ZodCheckLengthEquals", (e, t) => {
  var r;
  mt.init(e, t), (r = e._zod.def).when ?? (r.when = Ll), e._zod.check = (n) => {
    const i = n.value, o = i.length, s = typeof i == "string" && o >= t.length && o <= t.length * 2 ? na(i) : o;
    if (s === t.length)
      return;
    const a = Pl(i), l = s > t.length;
    n.issues.push({
      origin: a,
      ...l ? { code: "too_big", maximum: t.length } : { code: "too_small", minimum: t.length },
      inclusive: !0,
      exact: !0,
      input: n.value,
      inst: e,
      continue: !t.abort
    });
  };
}), oa = /* @__PURE__ */ Y("$ZodCheckStringFormat", (e, t) => {
  var r, n;
  mt.init(e, t), t.pattern ? (r = e._zod).check ?? (r.check = (i) => {
    t.pattern.lastIndex = 0, !t.pattern.test(i.value) && i.issues.push({
      origin: "string",
      code: "invalid_format",
      format: t.format,
      input: i.value,
      ...t.pattern ? { pattern: t.pattern.toString() } : {},
      inst: e,
      continue: !t.abort
    });
  }) : (n = e._zod).check ?? (n.check = () => {
  });
}), Xv = /* @__PURE__ */ Y("$ZodCheckRegex", (e, t) => {
  oa.init(e, t), e._zod.check = (r) => {
    t.pattern.lastIndex = 0, !t.pattern.test(r.value) && r.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "regex",
      input: r.value,
      pattern: t.pattern.toString(),
      inst: e,
      continue: !t.abort
    });
  };
}), Qv = /* @__PURE__ */ Y("$ZodCheckLowerCase", (e, t) => {
  t.pattern ?? (t.pattern = zv), oa.init(e, t);
}), eS = /* @__PURE__ */ Y("$ZodCheckUpperCase", (e, t) => {
  t.pattern ?? (t.pattern = Bv), oa.init(e, t);
}), tS = /* @__PURE__ */ Y("$ZodCheckIncludes", (e, t) => {
  mt.init(e, t);
  const r = bi(t.includes), n = new RegExp(typeof t.position == "number" ? `^.{${t.position},}${r}` : r);
  t.pattern = n, e._zod.check = (i) => {
    i.value.includes(t.includes, t.position) || i.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "includes",
      includes: t.includes,
      input: i.value,
      inst: e,
      continue: !t.abort
    });
  };
}), rS = /* @__PURE__ */ Y("$ZodCheckStartsWith", (e, t) => {
  mt.init(e, t);
  const r = new RegExp(`^${bi(t.prefix)}.*`);
  t.pattern ?? (t.pattern = r), e._zod.check = (n) => {
    n.value.startsWith(t.prefix) || n.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "starts_with",
      prefix: t.prefix,
      input: n.value,
      inst: e,
      continue: !t.abort
    });
  };
}), nS = /* @__PURE__ */ Y("$ZodCheckEndsWith", (e, t) => {
  mt.init(e, t);
  const r = new RegExp(`.*${bi(t.suffix)}$`);
  t.pattern ?? (t.pattern = r), e._zod.check = (n) => {
    n.value.endsWith(t.suffix) || n.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "ends_with",
      suffix: t.suffix,
      input: n.value,
      inst: e,
      continue: !t.abort
    });
  };
}), iS = /* @__PURE__ */ Y("$ZodCheckOverwrite", (e, t) => {
  mt.init(e, t), e._zod.check = (r) => {
    r.value = t.tx(r.value);
  };
});
function oS() {
  const e = this._zod;
  return e.message ?? (e.message = JSON.stringify(e.def, Mu, 2)), e.message;
}
function sS(e) {
  this._zod.message = e;
}
const aS = {
  get: oS,
  set: sS,
  enumerable: !0,
  configurable: !0
}, Ua = { value: void 0, enumerable: !1 }, Sf = /* @__PURE__ */ new WeakSet([Object.prototype, Error.prototype]), uS = (e, t) => {
  e.name = "$ZodError", Ua.value = t, Object.defineProperty(e, "issues", Ua), Ua.value = void 0, Object.defineProperty(e, "message", aS);
  const r = Object.getPrototypeOf(e);
  Sf.has(r) || (Sf.add(r), Object.defineProperty(r, "toString", {
    configurable: !0,
    enumerable: !1,
    get() {
      const n = () => this.message;
      return Object.defineProperty(this, "toString", { value: n, configurable: !0, writable: !0 }), n;
    },
    set(n) {
      Object.defineProperty(this, "toString", { value: n, configurable: !0, writable: !0 });
    }
  }));
}, lS = Y("$ZodError", uS);
function cS(e, t, r) {
  return Object.prototype.hasOwnProperty.call(e, t) || (t === "__proto__" ? Object.defineProperty(e, t, { value: r(), writable: !0, enumerable: !0, configurable: !0 }) : e[t] = r()), e[t];
}
function fS(e, t = (r) => r.message) {
  const r = {}, n = [];
  for (const i of e.issues)
    i.path.length > 0 ? cS(r, i.path[0], () => []).push(t(i)) : n.push(t(i));
  return { formErrors: n, fieldErrors: r };
}
function dS(e, t = (r) => r.message) {
  const r = { _errors: [] }, n = (i, o = []) => {
    for (const s of i.issues)
      if (s.code === "invalid_union" && s.errors.length)
        s.errors.map((a) => n({ issues: a }, [...o, ...s.path]));
      else if (s.code === "invalid_key")
        n({ issues: s.issues }, [...o, ...s.path]);
      else if (s.code === "invalid_element")
        n({ issues: s.issues }, [...o, ...s.path]);
      else {
        const a = [...o, ...s.path];
        if (a.length === 0)
          r._errors.push(t(s));
        else {
          let l = r, f = 0;
          for (; f < a.length; ) {
            const u = a[f], h = f === a.length - 1;
            if (u === "_errors") {
              h && l._errors.push(t(s)), f++;
              continue;
            }
            Object.prototype.hasOwnProperty.call(l, u) || Object.defineProperty(l, u, {
              value: { _errors: [] },
              enumerable: !0,
              writable: !0,
              configurable: !0
            });
            const E = l[u];
            h && E._errors.push(t(s)), l = E, f++;
          }
        }
      }
  };
  return n(e), r;
}
function sa(e, t) {
  return { callee: (t == null ? void 0 : t.callee) ?? e, Err: t == null ? void 0 : t.Err };
}
const xl = (e) => {
  const t = (r, n, i, o) => {
    const s = i ? { ...i, async: !1 } : { async: !1 }, a = r._zod.run({ value: n, issues: [] }, s);
    if (a instanceof Promise)
      throw new Kr();
    if (a.issues.length) {
      const l = new ((o == null ? void 0 : o.Err) ?? e)(a.issues.map((f) => fr(f, s, qt())));
      throw pg(l, (o == null ? void 0 : o.callee) ?? t), l;
    }
    return a.value;
  };
  return t;
}, kl = (e) => {
  const t = async (r, n, i, o) => {
    const s = i ? { ...i, async: !0 } : { async: !0 };
    let a = r._zod.run({ value: n, issues: [] }, s);
    if (a instanceof Promise && (a = await a), a.issues.length) {
      const l = new ((o == null ? void 0 : o.Err) ?? e)(a.issues.map((f) => fr(f, s, qt())));
      throw pg(l, (o == null ? void 0 : o.callee) ?? t), l;
    }
    return a.value;
  };
  return t;
}, jl = (e) => (t, r, n) => {
  const i = n ? { ...n, async: !1 } : { async: !1 }, o = t._zod.run({ value: r, issues: [] }, i);
  if (o instanceof Promise)
    throw new Kr();
  return o.issues.length ? wg(e, o.issues, i) : { success: !0, data: o.value };
};
function wg(e, t, r) {
  let n;
  return {
    success: !1,
    get error() {
      return n || (n = new e(t.map((i) => fr(i, r, qt()))), t = void 0, r = void 0), n;
    },
    set error(i) {
      n = i, t = void 0, r = void 0;
    }
  };
}
const Ul = (e) => async (t, r, n) => {
  const i = n ? { ...n, async: !0 } : { async: !0 };
  let o = t._zod.run({ value: r, issues: [] }, i);
  return o instanceof Promise && (o = await o), o.issues.length ? wg(e, o.issues, i) : { success: !0, data: o.value };
}, pS = /* @__PURE__ */ Symbol.for("zod.compile.invalid"), hS = /* @__PURE__ */ Symbol.for("zod.compile.fallback"), mS = ((e, t, r) => {
  const n = e._zod.bag.validator;
  if (n !== void 0) {
    if (n(t) !== pS)
      return !0;
    if (n.definite === !0 && r === void 0)
      return !1;
  }
  return ES(e, t, r);
});
function ES(e, t, r) {
  const n = r ? { ...r, async: !1, abortEarly: !0 } : { async: !1, abortEarly: !0 }, i = e._zod.bag.fallbackRun;
  let o;
  if (i ? (n[hS] = !0, o = i({ value: t, issues: [] }, n)) : o = e._zod.run({ value: t, issues: [] }, n), o instanceof Promise)
    throw new Kr();
  return o.issues.length === 0;
}
const gS = async (e, t, r) => {
  const n = r ? { ...r, async: !0, abortEarly: !0 } : { async: !0, abortEarly: !0 };
  let i = e._zod.run({ value: t, issues: [] }, n);
  return i instanceof Promise && (i = await i), i.issues.length === 0;
}, yS = (e) => {
  const t = xl(e), r = (n, i, o, s) => {
    const a = o ? { ...o, direction: "backward" } : { direction: "backward" };
    return t(n, i, a, sa(r, s));
  };
  return r;
}, TS = (e) => {
  const t = xl(e), r = (n, i, o, s) => t(n, i, o, sa(r, s));
  return r;
}, bS = (e) => {
  const t = kl(e), r = async (n, i, o, s) => {
    const a = o ? { ...o, direction: "backward" } : { direction: "backward" };
    return await t(n, i, a, sa(r, s));
  };
  return r;
}, AS = (e) => {
  const t = kl(e), r = async (n, i, o, s) => await t(n, i, o, sa(r, s));
  return r;
}, vS = (e) => (t, r, n) => {
  const i = n ? { ...n, direction: "backward" } : { direction: "backward" };
  return jl(e)(t, r, i);
}, SS = (e) => (t, r, n) => jl(e)(t, r, n), IS = (e) => async (t, r, n) => {
  const i = n ? { ...n, direction: "backward" } : { direction: "backward" };
  return Ul(e)(t, r, i);
}, _S = (e) => async (t, r, n) => Ul(e)(t, r, n), RS = {
  major: 4,
  minor: 6,
  patch: 7
}, Ve = /* @__PURE__ */ Y("$ZodType", (e, t) => {
  var o;
  var r;
  e ?? (e = {}), e._zod.def = t, e._zod.bag = e._zod.bag || {}, e._zod.version = RS;
  const n = e._zod.def.checks, i = e._zod.traits.has("$ZodCheck") ? [e, ...n ?? []] : n != null && n.length ? [...n] : [];
  for (const s of i)
    for (const a of s._zod.onattach)
      a(e);
  if (i.length === 0)
    (r = e._zod).deferred ?? (r.deferred = []), (o = e._zod.deferred) == null || o.push(() => {
      e._zod.run = e._zod.parse;
    });
  else {
    const s = (l, f, u) => {
      if (l.memo)
        return l;
      let h = Gt(l), E;
      for (const d of f) {
        if (d._zod.def.when) {
          if (KA(l) || !d._zod.def.when(l))
            continue;
        } else if (h)
          continue;
        const g = l.issues.length, y = d._zod.check(l);
        if (y instanceof Promise && (u == null ? void 0 : u.async) === !1)
          throw new Kr();
        if (E || y instanceof Promise)
          E = (E ?? Promise.resolve()).then(async () => {
            await y, l.issues.length !== g && (ku(l.issues, g, e), h || (h = Gt(l, g)));
          });
        else {
          if (l.issues.length === g)
            continue;
          ku(l.issues, g, e), h || (h = Gt(l, g));
        }
      }
      return E ? E.then(() => l) : l;
    }, a = (l, f, u) => {
      if (Gt(l))
        return l.aborted = !0, l;
      const h = s(f, i, u);
      if (h instanceof Promise) {
        if (u.async === !1)
          throw new Kr();
        return h.then((E) => e._zod.parse(E, u));
      }
      return e._zod.parse(h, u);
    };
    e._zod.run = (l, f) => {
      if (f.skipChecks)
        return e._zod.parse(l, f);
      if (f.direction === "backward") {
        const h = e._zod.parse({ value: l.value, issues: [] }, { ...f, skipChecks: !0 });
        return h instanceof Promise ? h.then((E) => a(E, l, f)) : a(h, l, f);
      }
      const u = e._zod.parse(l, f);
      if (u instanceof Promise) {
        if (f.async === !1)
          throw new Kr();
        return u.then((h) => s(h, i, f));
      }
      return s(u, i, f);
    };
  }
}, {
  // Wrappers extend this by installing a richer factory over it; reading it eagerly would defeat the laziness.
  get "~standard"() {
    return gg(this, "~standard", Cg(this));
  },
  set "~standard"(e) {
    Qr(this, "~standard", e);
  }
}), Ng = (e, t) => e.issues.length ? { issues: e.issues.map((r) => fr(r, t, qt())) } : { value: e.value };
async function OS(e, t) {
  const r = { async: !0 };
  return Ng(await e._zod.run({ value: t, issues: [] }, r), r);
}
function Cg(e) {
  return {
    validate: (t) => {
      const r = { async: !1 };
      try {
        const n = e._zod.run({ value: t, issues: [] }, r);
        if (!(n instanceof Promise))
          return Ng(n, r);
      } catch {
      }
      return OS(e, t);
    },
    vendor: "zod",
    version: 1
  };
}
const $l = /* @__PURE__ */ Y("$ZodString", (e, t) => {
  Ve.init(e, t), e._zod.pattern = t.pattern ?? Uv, e._zod.parse = (r, n) => {
    if (t.coerce)
      try {
        r.value = String(r.value);
      } catch {
      }
    return typeof r.value == "string" || r.issues.push({
      expected: "string",
      code: "invalid_type",
      input: r.value,
      inst: e
    }), r;
  };
}), Qe = /* @__PURE__ */ Y("$ZodStringFormat", (e, t) => {
  oa.init(e, t), $l.init(e, t);
}), wS = /* @__PURE__ */ Y("$ZodGUID", (e, t) => {
  t.pattern ?? (t.pattern = bv), Qe.init(e, t);
}), NS = /* @__PURE__ */ Y("$ZodUUID", (e, t) => {
  if (t.version) {
    const n = {
      v1: 1,
      v2: 2,
      v3: 3,
      v4: 4,
      v5: 5,
      v6: 6,
      v7: 7,
      v8: 8
    }[t.version];
    if (n === void 0)
      throw new Error(`Invalid UUID version: "${t.version}"`);
    t.pattern ?? (t.pattern = vf(n));
  } else
    t.pattern ?? (t.pattern = vf());
  Qe.init(e, t);
}), CS = /* @__PURE__ */ Y("$ZodEmail", (e, t) => {
  t.pattern ?? (t.pattern = Av), Qe.init(e, t);
}), Pg = 1, Ds = 2;
function Dg(e) {
  try {
    return typeof URL < "u" && typeof URL.canParse == "function" ? URL.canParse(e) : (new URL(e), !0);
  } catch {
    return !1;
  }
}
function Mg(e, t) {
  return !("normalize" in t) && !("hostname" in t) && !("protocol" in t) ? Dg(e) || Ds : PS(e, t);
}
function PS(e, t) {
  var r;
  if (!t.normalize && ((r = t.protocol) == null ? void 0 : r.source) === Cv.source && !/^https?:\/\//i.test(e))
    return Pg;
  try {
    if (typeof URL < "u") {
      const n = URL;
      if (typeof n.parse == "function")
        return n.parse(e) ?? Ds;
    }
    return new URL(e);
  } catch {
    return Ds;
  }
}
const DS = /[\t\n\r]/g;
function $u(e) {
  return e.replace(DS, "");
}
function Lg(e, t) {
  return t.lastIndex = 0, t.test(e.hostname);
}
function xg(e, t) {
  return t.lastIndex = 0, t.test(e.protocol.endsWith(":") ? e.protocol.slice(0, -1) : e.protocol);
}
const MS = /* @__PURE__ */ Y("$ZodURL", (e, t) => {
  Qe.init(e, t), e._zod.check = (r) => {
    try {
      const n = r.value.trim(), i = Mg(n, t);
      if (i === Pg) {
        r.issues.push({
          code: "invalid_format",
          format: "url",
          note: "Invalid URL format",
          input: r.value,
          inst: e,
          continue: !t.abort
        });
        return;
      }
      if (i === Ds) {
        r.issues.push({
          code: "invalid_format",
          format: "url",
          input: r.value,
          inst: e,
          continue: !t.abort
        });
        return;
      }
      if (i === !0) {
        r.value = $u(n);
        return;
      }
      t.hostname && !Lg(i, t.hostname) && r.issues.push({
        code: "invalid_format",
        format: "url",
        note: "Invalid hostname",
        pattern: t.hostname.source,
        input: r.value,
        inst: e,
        continue: !t.abort
      }), t.protocol && !xg(i, t.protocol) && r.issues.push({
        code: "invalid_format",
        format: "url",
        note: "Invalid protocol",
        pattern: t.protocol.source,
        input: r.value,
        inst: e,
        continue: !t.abort
      }), r.value = t.normalize ? i.href : $u(n);
      return;
    } catch {
      r.issues.push({
        code: "invalid_format",
        format: "url",
        input: r.value,
        inst: e,
        continue: !t.abort
      });
    }
  };
}), LS = /* @__PURE__ */ Y("$ZodEmoji", (e, t) => {
  t.pattern ?? (t.pattern = Sv()), Qe.init(e, t);
}), xS = /* @__PURE__ */ Y("$ZodNanoID", (e, t) => {
  if (t.length !== void 0 && (!Number.isInteger(t.length) || t.length < 1))
    throw new Error(`Invalid nanoid length: ${t.length}`);
  t.pattern ?? (t.pattern = t.length === void 0 ? gv : yv(t.length)), Qe.init(e, t);
}), kS = /* @__PURE__ */ Y("$ZodCUID", (e, t) => {
  t.pattern ?? (t.pattern = dv), Qe.init(e, t);
}), jS = /* @__PURE__ */ Y("$ZodCUID2", (e, t) => {
  t.pattern ?? (t.pattern = pv), Qe.init(e, t);
}), US = /* @__PURE__ */ Y("$ZodULID", (e, t) => {
  t.pattern ?? (t.pattern = hv), Qe.init(e, t);
}), $S = /* @__PURE__ */ Y("$ZodXID", (e, t) => {
  t.pattern ?? (t.pattern = mv), Qe.init(e, t);
}), FS = /* @__PURE__ */ Y("$ZodKSUID", (e, t) => {
  t.pattern ?? (t.pattern = Ev), Qe.init(e, t);
}), GS = /* @__PURE__ */ Y("$ZodISODateTime", (e, t) => {
  t.pattern ?? (t.pattern = jv(t)), Qe.init(e, t);
}), zS = /* @__PURE__ */ Y("$ZodISODate", (e, t) => {
  t.pattern ?? (t.pattern = xv), Qe.init(e, t);
}), BS = /* @__PURE__ */ Y("$ZodISOTime", (e, t) => {
  t.pattern ?? (t.pattern = kv(t)), Qe.init(e, t);
}), VS = /* @__PURE__ */ Y("$ZodISODuration", (e, t) => {
  t.pattern ?? (t.pattern = Tv), Qe.init(e, t);
}), WS = /* @__PURE__ */ Y("$ZodIPv4", (e, t) => {
  t.pattern ?? (t.pattern = Iv), Qe.init(e, t);
}), qS = /^[0-9a-fA-F:.]+$/;
function Fl(e) {
  return qS.test(e) ? Dg(`http://[${e}]`) : !1;
}
const HS = /* @__PURE__ */ Y("$ZodIPv6", (e, t) => {
  t.pattern ?? (t.pattern = _v), Qe.init(e, t), e._zod.check = (r) => {
    Fl(r.value) || r.issues.push({
      code: "invalid_format",
      format: "ipv6",
      input: r.value,
      inst: e,
      continue: !t.abort
    });
  };
}), YS = /* @__PURE__ */ Y("$ZodCIDRv4", (e, t) => {
  t.pattern ?? (t.pattern = Rv), Qe.init(e, t);
});
function kg(e) {
  const t = e.split("/");
  if (t.length !== 2)
    return !1;
  const [r, n] = t;
  if (!n)
    return !1;
  const i = Number(n);
  return `${i}` !== n || i < 0 || i > 128 ? !1 : Fl(r);
}
const ZS = /* @__PURE__ */ Y("$ZodCIDRv6", (e, t) => {
  t.pattern ?? (t.pattern = Ov), Qe.init(e, t), e._zod.check = (r) => {
    kg(r.value) || r.issues.push({
      code: "invalid_format",
      format: "cidrv6",
      input: r.value,
      inst: e,
      continue: !t.abort
    });
  };
});
function Gl(e) {
  if (e === "")
    return !0;
  if (/\s/.test(e) || e.length % 4 !== 0)
    return !1;
  try {
    return atob(e), !0;
  } catch {
    return !1;
  }
}
const jg = /^[0-9a-zA-Z+/]*={0,2}$/, JS = /* @__PURE__ */ Y("$ZodBase64", (e, t) => {
  t.pattern ?? (t.pattern = jg), Qe.init(e, t), e._zod.check = (r) => {
    Gl(r.value) || r.issues.push({
      code: "invalid_format",
      format: "base64",
      input: r.value,
      inst: e,
      continue: !t.abort
    });
  };
}), zl = /^[A-Za-z0-9_-]*$/;
function Ug(e) {
  if (!zl.test(e))
    return !1;
  const t = e.replace(/[-_]/g, (n) => n === "-" ? "+" : "/"), r = t.padEnd(Math.ceil(t.length / 4) * 4, "=");
  return Gl(r);
}
const KS = /* @__PURE__ */ Y("$ZodBase64URL", (e, t) => {
  t.pattern ?? (t.pattern = zl), Qe.init(e, t), e._zod.check = (r) => {
    Ug(r.value) || r.issues.push({
      code: "invalid_format",
      format: "base64url",
      input: r.value,
      inst: e,
      continue: !t.abort
    });
  };
}), XS = /* @__PURE__ */ Y("$ZodE164", (e, t) => {
  t.pattern ?? (t.pattern = Pv), Qe.init(e, t);
}), QS = /[- ]/g;
function e0(e) {
  let t = e.length, r = 1, n = 0;
  for (; t; ) {
    const i = e.charCodeAt(--t) - 48;
    r ^= 1, n += r ? [0, 2, 4, 6, 8, 1, 3, 5, 7, 9][i] : i;
  }
  return n % 10 === 0;
}
function t0(e) {
  return Dv.test(e) ? e0(e.replace(QS, "")) : !1;
}
function r0(e) {
  let t = 0;
  const r = e.length;
  for (let n = 4; n < r; n++) {
    const i = e.charCodeAt(n);
    t = (i >= 65 ? t * 100 + (i - 55) : t * 10 + (i - 48)) % 97;
  }
  for (let n = 0; n < 4; n++) {
    const i = e.charCodeAt(n);
    t = (i >= 65 ? t * 100 + (i - 55) : t * 10 + (i - 48)) % 97;
  }
  return t === 1;
}
function n0(e) {
  return Mv.test(e) ? r0(e) : !1;
}
function $g(e, t = null) {
  try {
    const r = e.split(".");
    if (r.length !== 3)
      return !1;
    const [n] = r;
    if (!n)
      return !1;
    const i = JSON.parse(atob(n));
    return !("typ" in i && (i == null ? void 0 : i.typ) !== "JWT" || !i.alg || t && (!("alg" in i) || i.alg !== t));
  } catch {
    return !1;
  }
}
const i0 = /* @__PURE__ */ Y("$ZodJWT", (e, t) => {
  Qe.init(e, t), e._zod.check = (r) => {
    $g(r.value, t.alg) || r.issues.push({
      code: "invalid_format",
      format: "jwt",
      input: r.value,
      inst: e,
      continue: !t.abort
    });
  };
}), Fg = /* @__PURE__ */ Y("$ZodNumber", (e, t) => {
  Ve.init(e, t), e._zod.pattern = ia, e._zod.parse = (r, n) => {
    if (t.coerce)
      try {
        r.value = Number(r.value);
      } catch {
      }
    const i = r.value;
    if (typeof i == "number" && !Number.isNaN(i) && Number.isFinite(i))
      return r;
    const o = typeof i == "number" ? Number.isNaN(i) ? "NaN" : Number.isFinite(i) ? void 0 : String(i) : void 0;
    return r.issues.push({
      expected: "number",
      code: "invalid_type",
      input: i,
      inst: e,
      ...o ? { received: o } : {}
    }), r;
  };
}), o0 = /* @__PURE__ */ Y("$ZodNumberFormat", (e, t) => {
  Wv.init(e, t), Fg.init(e, t);
}), s0 = /* @__PURE__ */ Y("$ZodBoolean", (e, t) => {
  Ve.init(e, t), e._zod.pattern = Fv, e._zod.parse = (r, n) => {
    if (t.coerce)
      try {
        r.value = !!r.value;
      } catch {
      }
    const i = r.value;
    return typeof i == "boolean" || r.issues.push({
      expected: "boolean",
      code: "invalid_type",
      input: i,
      inst: e
    }), r;
  };
}), a0 = /* @__PURE__ */ Y("$ZodUndefined", (e, t) => {
  Ve.init(e, t), e._zod.pattern = Gv, e._zod.values = /* @__PURE__ */ new Set([void 0]), e._zod.parse = (r, n) => {
    const i = r.value;
    return typeof i > "u" || r.issues.push({
      expected: "undefined",
      code: "invalid_type",
      input: i,
      inst: e
    }), r;
  };
}), u0 = /* @__PURE__ */ Y("$ZodUnknown", (e, t) => {
  Ve.init(e, t), e._zod.parse = (r) => r;
}), l0 = /* @__PURE__ */ Y("$ZodNever", (e, t) => {
  Ve.init(e, t), e._zod.parse = (r, n) => (r.issues.push({
    expected: "never",
    code: "invalid_type",
    input: r.value,
    inst: e
  }), r);
}), c0 = /* @__PURE__ */ Y("$ZodDate", (e, t) => {
  Ve.init(e, t), e._zod.parse = (r, n) => {
    if (t.coerce)
      try {
        r.value = new Date(r.value);
      } catch {
      }
    const i = r.value, o = i instanceof Date;
    return o && !Number.isNaN(i.getTime()) || r.issues.push({
      expected: "date",
      code: "invalid_type",
      input: i,
      ...o ? { received: "Invalid Date" } : {},
      inst: e
    }), r;
  };
});
function Gg(e, t) {
  const r = xu(e._zod.def.checks);
  if (!r.length)
    return;
  const n = Math.min(...r.map((o) => o[0])), i = e._zod.parse;
  e._zod.parse = (o, s) => {
    const a = t(o.value);
    if (a > n && !(s != null && s.skipChecks) && (s == null ? void 0 : s.direction) !== "backward") {
      for (const [l, f] of xu(e._zod.def.checks))
        if (a > l && f._zod.def.when(o)) {
          const u = o.issues.length;
          return f._zod.check(o), o.issues[u].continue = !1, ku(o.issues, u, e), o;
        }
    }
    return i(o, s);
  };
}
const f0 = (e) => Array.isArray(e) ? e.length : -1, d0 = (e) => e instanceof Map ? e.size : -1;
function If(e, t, r) {
  e.issues.length && t.issues.push(...lr(r, e.issues)), t.value[r] = e.value;
}
const p0 = /* @__PURE__ */ Y("$ZodArray", (e, t) => {
  Ve.init(e, t);
  const r = _t.memoizer;
  r == null || r.attach(e), e._zod.parse = (n, i) => {
    const o = n.value;
    if (!Array.isArray(o))
      return n.issues.push({
        expected: "array",
        code: "invalid_type",
        input: o,
        inst: e
      }), n;
    n.value = r ? r.alloc(e, n, Array(o.length), i) : Array(o.length);
    const s = [], a = i == null ? void 0 : i.abortEarly;
    for (let l = 0; l < o.length; l++) {
      const f = o[l], u = t.element._zod.run({
        value: f,
        issues: []
      }, i);
      if (u instanceof Promise)
        s.push(u.then((h) => If(h, n, l)));
      else if (If(u, n, l), a && u.issues.length !== 0 && Gt(u))
        break;
    }
    return s.length ? Promise.all(s).then(() => n) : n;
  }, Gg(e, f0);
});
function Ms(e, t, r, n, i, o) {
  const s = r in n, a = o === "optional";
  if (!(!s && a && i === "optional")) {
    if (e.issues.length) {
      if (i !== void 0 && a && !s)
        return;
      t.issues.push(...lr(r, e.issues));
    }
    if (!s && i === void 0) {
      e.issues.length || t.issues.push({
        code: "invalid_type",
        expected: "nonoptional",
        input: void 0,
        path: [r]
      });
      return;
    }
    e.value === void 0 ? (s || i === "defaulted" && !a) && (t.value[r] = void 0) : t.value[r] = e.value;
  }
}
const h0 = [];
function zg(e) {
  var s, a, l, f;
  const t = Object.keys(e.shape), r = Object.getOwnPropertySymbols(e.shape), n = r.length ? r : h0, i = n.length ? [...t, ...n] : t;
  for (const u of i)
    if (!((f = (l = (a = (s = e.shape) == null ? void 0 : s[u]) == null ? void 0 : a._zod) == null ? void 0 : l.traits) != null && f.has("$ZodType")))
      throw new Error(`Invalid element at key "${String(u)}": expected a Zod schema`);
  const o = BA(e.shape);
  return {
    ...e,
    allKeys: i,
    symbolKeys: n,
    // string-only: handleCatchall matches it against `for...in`, which never yields a symbol
    keySet: new Set(t),
    numKeys: t.length,
    optionalKeys: new Set(o)
  };
}
function Bg(e, t, r, n, i, o, s) {
  const a = [], l = i.keySet, f = i.catchall._zod, u = f.def.type, h = f.optin, E = f.optout;
  let d = 0;
  for (const g in t) {
    if (s && r.issues.length !== d) {
      if (Gt(r, d))
        break;
      d = r.issues.length;
    }
    if (l.has(g))
      continue;
    if (g === "__proto__") {
      u === "never" && a.push(g);
      continue;
    }
    if (u === "never") {
      a.push(g);
      continue;
    }
    const y = f.run({ value: t[g], issues: [] }, n);
    y instanceof Promise ? e.push(y.then((b) => Ms(b, r, g, t, h, E))) : Ms(y, r, g, t, h, E);
  }
  return a.length && r.issues.push({
    code: "unrecognized_keys",
    keys: a,
    input: t,
    inst: o,
    // Describes the shape of the input, not the validity of the parsed value, so it never aborts. The parse still fails; the schema's own checks just get to run first, and an enclosing intersection can reconcile the key against a sibling operand.
    continue: !0
  }), e.length ? Promise.all(e).then(() => r) : r;
}
const m0 = /* @__PURE__ */ Y("$ZodObject", (e, t) => {
  Ve.init(e, t);
  const r = Object.getOwnPropertyDescriptor(t, "shape"), n = r != null && r.get ? r.get.raw : t.shape ?? {};
  if (n) {
    const f = () => {
      const u = { ...n };
      return Object.defineProperty(t, "shape", { value: u }), f.raw = u, u;
    };
    f.raw = n, Object.defineProperty(t, "shape", { get: f });
  }
  const i = ta(() => zg(t));
  ke(e, "propValues", (f) => {
    const u = f.def.shape, h = {};
    for (const E in u) {
      const d = u[E]._zod;
      if (d.values) {
        Object.prototype.hasOwnProperty.call(h, E) || Fr(h, E, /* @__PURE__ */ new Set());
        for (const g of d.values)
          h[E].add(g);
        d.optin !== void 0 && h[E].add(void 0);
      }
    }
    return h;
  });
  const o = Fo, s = t.catchall;
  let a;
  const l = _t.memoizer;
  l == null || l.attach(e), e._zod.parse = (f, u) => {
    a ?? (a = i.value);
    const h = f.value;
    if (!o(h))
      return f.issues.push({
        expected: "object",
        code: "invalid_type",
        input: h,
        inst: e
      }), f;
    f.value = l ? l.alloc(e, f, {}, u) : {};
    const E = [], d = a.shape, g = u == null ? void 0 : u.abortEarly;
    let y = f.issues.length;
    for (const b of a.allKeys) {
      if (g && f.issues.length !== y) {
        if (Gt(f, y))
          break;
        y = f.issues.length;
      }
      if (b === "__proto__")
        continue;
      const _ = d[b], I = _._zod.optin, w = _._zod.optout, L = _._zod.run({ value: h[b], issues: [] }, u);
      L instanceof Promise ? E.push(L.then((R) => Ms(R, f, b, h, I, w))) : Ms(L, f, b, h, I, w);
    }
    return s ? Bg(E, h, f, u, i.value, e, g === !0) : E.length ? Promise.all(E).then(() => f) : f;
  };
}), E0 = /* @__PURE__ */ Y("$ZodObjectJIT", (e, t) => {
  m0.init(e, t);
  const r = e._zod.parse, n = ta(() => zg(t)), i = _t.memoizer, o = (d) => {
    var R, D;
    const g = n.value, y = g.symbolKeys, b = new bg(["payload", "ctx"], { shape: d, inst: e, memo: i, syms: y }), _ = (P) => `shape[${P}]._zod.run({ value: input[${P}], issues: [] }, ctx)`, I = (P, O) => `
          let ${P}_ab = false;
          for (let i = 0; i < ${P}.issues.length; i++) {
            const iss = ${P}.issues[i];
            iss.path = iss.path ? [${O}, ...iss.path] : [${O}];
            payload.issues.push(iss);
            if (iss.continue !== true) ${P}_ab = true;
          }
          if (${P}_ab && ctx && ctx.abortEarly) {
            payload.value = newResult;
            return payload;
          }`;
    b.write("const input = payload.value;");
    const w = /* @__PURE__ */ Object.create(null);
    let L = 0;
    for (const P of g.allKeys)
      w[P] = `key_${L++}`;
    b.write(i ? "const newResult = memo.alloc(inst, payload, {}, ctx);" : "const newResult = {};");
    for (const P of g.allKeys) {
      if (P === "__proto__")
        continue;
      const O = w[P], F = typeof P == "symbol" ? `syms[${y.indexOf(P)}]` : zt(P), U = `${F} in input`, z = d[P], V = (R = z == null ? void 0 : z._zod) == null ? void 0 : R.optin, ae = V !== void 0, q = ((D = z == null ? void 0 : z._zod) == null ? void 0 : D.optout) === "optional";
      if (b.write(`const ${O} = ${_(F)};`), ae && q) {
        const x = V === "optional" ? `${O}_present` : `${O}.value !== undefined || ${O}_present`;
        b.write(`
        const ${O}_present = ${U};
        if (!${O}.issues.length || ${O}_present) {
          if (${O}.issues.length) {${I(O, F)}
          }

          if (${x}) {
            newResult[${F}] = ${O}.value;
          }
        }

      `);
      } else ae ? (b.write(`
        if (${O}.issues.length) {${I(O, F)}
        }
      `), V === "defaulted" ? b.write(`newResult[${F}] = ${O}.value;`) : b.write(`
        if (${O}.value !== undefined || ${U}) {
          newResult[${F}] = ${O}.value;
        }
      `)) : b.write(`
        const ${O}_present = ${U};
        if (${O}.issues.length) {${I(O, F)}
        }
        if (!${O}_present && !${O}.issues.length) {
          payload.issues.push({
            code: "invalid_type",
            expected: "nonoptional",
            input: undefined,
            path: [${F}]
          });
          if (ctx && ctx.abortEarly) {
            payload.value = newResult;
            return payload;
          }
        }

        if (${O}_present) {
          newResult[${F}] = ${O}.value;
        }

      `);
    }
    return b.write("payload.value = newResult;"), b.write("return payload;"), b.compile();
  };
  let s;
  const a = Fo, l = !_t.jitless, u = l && zA.value, h = t.catchall;
  let E;
  e._zod.parse = (d, g) => {
    E ?? (E = n.value);
    const y = d.value;
    return a(y) ? l && u && (g == null ? void 0 : g.async) === !1 && g.jitless !== !0 ? (s || (s = o(t.shape)), d = s(d, g), h ? Bg([], y, d, g, E, e, (g == null ? void 0 : g.abortEarly) === !0) : d) : r(d, g) : (d.issues.push({
      expected: "object",
      code: "invalid_type",
      input: y,
      inst: e
    }), d);
  };
});
function _f(e, t, r, n) {
  for (const o of e)
    if (o.issues.length === 0)
      return t.value = o.value, t;
  const i = e.filter((o) => !Gt(o));
  return i.length === 1 ? (t.value = i[0].value, i[0]) : (t.issues.push({
    code: "invalid_union",
    input: t.value,
    inst: r,
    errors: e.map((o) => o.issues.map((s) => fr(s, n, qt())))
  }), t);
}
const Vg = /* @__PURE__ */ Y("$ZodUnion", (e, t) => {
  Ve.init(e, t), ke(e, "optin", (n) => n.def.options.some((i) => i._zod.optin === "defaulted") ? "defaulted" : n.def.options.some((i) => i._zod.optin !== void 0) ? "optional" : void 0), ke(e, "optout", (n) => n.def.options.some((i) => i._zod.optout === "optional") ? "optional" : void 0), ke(e, "values", (n) => {
    if (n.def.options.every((i) => i._zod.values))
      return new Set(n.def.options.flatMap((i) => Array.from(i._zod.values)));
  }), ke(e, "pattern", (n) => {
    if (n.def.options.every((i) => i._zod.pattern)) {
      const i = n.def.options.map((o) => o._zod.pattern);
      return new RegExp(`^(${i.map((o) => Ol(o.source)).join("|")})$`);
    }
  });
  const r = t.options.length === 1 ? t.options[0]._zod.run : null;
  e._zod.parse = (n, i) => {
    if (r)
      return r(n, i);
    let o = !1;
    const s = [];
    for (const a of t.options) {
      const l = a._zod.run({
        value: n.value,
        issues: []
      }, i);
      if (l instanceof Promise)
        s.push(l), o = !0;
      else {
        if (l.issues.length === 0)
          return l;
        s.push(l);
      }
    }
    return o ? Promise.all(s).then((a) => _f(a, n, e, i)) : _f(s, n, e, i);
  };
});
function g0(e) {
  var r;
  const t = /* @__PURE__ */ new Map();
  for (const n of e.options) {
    const i = (r = n._zod.propValues) == null ? void 0 : r[e.discriminator];
    if (!i || i.size === 0)
      throw new Error(`Invalid discriminated union option at index "${e.options.indexOf(n)}"`);
    for (const o of i)
      if (t.has(o)) {
        if (o !== void 0)
          throw new Error(`Duplicate discriminator value "${String(o)}"`);
        t.set(o, null);
      } else
        t.set(o, n);
  }
  return t;
}
const y0 = /* @__PURE__ */ Y("$ZodDiscriminatedUnion", (e, t) => {
  t.inclusive = !1, Vg.init(e, t);
  const r = e._zod.parse;
  ke(e, "propValues", (i) => {
    var a, l;
    const o = {};
    let s = 0;
    for (const f of i.def.options) {
      const u = f._zod.propValues;
      if (!u || Object.keys(u).length === 0)
        throw new Error(`Invalid discriminated union option at index "${i.def.options.indexOf(f)}"`);
      (a = u[i.def.discriminator]) != null && a.has(void 0) && s++;
      for (const [h, E] of Object.entries(u)) {
        Object.prototype.hasOwnProperty.call(o, h) || Fr(o, h, /* @__PURE__ */ new Set());
        for (const d of E)
          o[h].add(d);
      }
    }
    return !i.def.unionFallback && s > 1 && ((l = o[i.def.discriminator]) == null || l.delete(void 0)), o;
  }), t.options.forEach((i, o) => {
    const s = wl(i._zod.def);
    if (s && !Object.prototype.hasOwnProperty.call(s, t.discriminator))
      throw new Error(`Invalid discriminated union option at index "${o}"`);
  });
  const n = ta(() => g0(t));
  e._zod.parse = (i, o) => {
    const s = i.value;
    if (!Fo(s))
      return i.issues.push({
        code: "invalid_type",
        expected: "object",
        input: s,
        inst: e
      }), i;
    const a = s == null ? void 0 : s[t.discriminator], l = n.value.get(a);
    return l && (a !== void 0 || o.direction !== "backward") ? l._zod.run(i, o) : t.unionFallback || o.direction === "backward" ? r(i, o) : (i.issues.push({
      code: "invalid_union",
      errors: [],
      note: "No matching discriminator",
      discriminator: t.discriminator,
      options: Array.from(n.value.keys()).filter((f) => n.value.get(f) !== null),
      input: s,
      path: [t.discriminator],
      inst: e
    }), i);
  };
}), T0 = /* @__PURE__ */ Y("$ZodIntersection", (e, t) => {
  Ve.init(e, t), e._zod.parse = (r, n) => {
    const i = r.value, o = t.left._zod.run({ value: i, issues: [] }, n), s = t.right._zod.run({ value: i, issues: [] }, n);
    return o instanceof Promise || s instanceof Promise ? Promise.all([o, s]).then(([l, f]) => Rf(r, l, f)) : Rf(r, o, s);
  };
});
function Ls(e, t) {
  if (e === t)
    return { valid: !0, data: e };
  if (e instanceof Date && t instanceof Date && +e == +t)
    return { valid: !0, data: e };
  if ($n(e) && $n(t)) {
    const r = Object.keys(t), n = Object.keys(e).filter((o) => r.indexOf(o) !== -1), i = { ...e, ...t };
    Object.prototype.hasOwnProperty.call(i, "__proto__") && delete i.__proto__;
    for (const o of n) {
      if (o === "__proto__")
        continue;
      const s = Ls(e[o], t[o]);
      if (!s.valid)
        return {
          valid: !1,
          mergeErrorPath: [o, ...s.mergeErrorPath]
        };
      i[o] = s.data;
    }
    return { valid: !0, data: i };
  }
  if (Array.isArray(e) && Array.isArray(t)) {
    if (e.length !== t.length)
      return { valid: !1, mergeErrorPath: [] };
    const r = [];
    for (let n = 0; n < e.length; n++) {
      const i = e[n], o = t[n], s = Ls(i, o);
      if (!s.valid)
        return {
          valid: !1,
          mergeErrorPath: [n, ...s.mergeErrorPath]
        };
      r.push(s.data);
    }
    return { valid: !0, data: r };
  }
  return { valid: !1, mergeErrorPath: [] };
}
function Rf(e, t, r) {
  const n = /* @__PURE__ */ new Map();
  let i;
  const o = /* @__PURE__ */ new Map(), s = (f, u) => {
    var E, d;
    let h;
    if (f.code === "unrecognized_keys" && !((E = f.path) != null && E.length))
      i ?? (i = f), h = f.keys;
    else if (f.code === "invalid_key" && f.origin === "record" && ((d = f.path) == null ? void 0 : d.length) === 1) {
      const g = String(f.path[0]);
      o.has(g) || o.set(g, f), h = [g];
    } else
      return !1;
    for (const g of h)
      n.has(g) || n.set(g, {}), n.get(g)[u] = !0;
    return !0;
  };
  for (const f of t.issues)
    s(f, "l") || e.issues.push(f);
  for (const f of r.issues)
    s(f, "r") || e.issues.push(f);
  const a = [...n].filter(([, f]) => f.l && f.r).map(([f]) => f);
  if (a.length) {
    const f = i ? a.filter((u) => i.keys.includes(u)) : [];
    f.length && e.issues.push({ ...i, keys: f });
    for (const u of a)
      !f.includes(u) && o.has(u) && e.issues.push(o.get(u));
  }
  const l = Ls(t.value, r.value);
  if (!l.valid) {
    if (Gt(e))
      return e;
    throw new Error(`Unmergable intersection. Error path: ${JSON.stringify(l.mergeErrorPath)}`);
  }
  return e.value = l.data, e;
}
const b0 = /* @__PURE__ */ Y("$ZodTuple", (e, t) => {
  Ve.init(e, t);
  const r = t.items, n = _t.memoizer;
  n == null || n.attach(e), e._zod.parse = (i, o) => {
    const s = i.value;
    if (!Array.isArray(s))
      return i.issues.push({
        input: s,
        inst: e,
        expected: "tuple",
        code: "invalid_type"
      }), i;
    i.value = n ? n.alloc(e, i, [], o) : [];
    const a = [], l = Of(r, "optin"), f = Of(r, "optout");
    if (!t.rest) {
      if (s.length < l)
        return i.issues.push({
          code: "too_small",
          minimum: l,
          inclusive: !0,
          input: s,
          inst: e,
          origin: "array"
        }), i;
      s.length > r.length && i.issues.push({
        code: "too_big",
        maximum: r.length,
        inclusive: !0,
        input: s,
        inst: e,
        origin: "array"
      });
    }
    const u = new Array(r.length), h = t.rest ? o == null ? void 0 : o.abortEarly : void 0;
    let E = !1;
    for (let d = 0; d < r.length; d++) {
      const g = r[d]._zod.run({ value: s[d], issues: [] }, o);
      g instanceof Promise ? a.push(g.then((y) => {
        u[d] = y;
      })) : (u[d] = g, h && !E && g.issues.length && (E = Gt(g)));
    }
    if (t.rest && !E) {
      let d = r.length - 1;
      const g = s.slice(r.length);
      let y = i.issues.length;
      for (const b of g) {
        if (h && i.issues.length !== y) {
          if (Gt(i, y))
            break;
          y = i.issues.length;
        }
        d++;
        const _ = t.rest._zod.run({ value: b, issues: [] }, o);
        _ instanceof Promise ? a.push(_.then((I) => wf(I, i, d))) : wf(_, i, d);
      }
    }
    return a.length ? Promise.all(a).then(() => Nf(u, i, r, s, f)) : Nf(u, i, r, s, f);
  };
});
function Of(e, t) {
  for (let r = e.length - 1; r >= 0; r--)
    if (!(t === "optin" ? e[r]._zod.optin !== void 0 : e[r]._zod.optout === "optional"))
      return r + 1;
  return 0;
}
function wf(e, t, r) {
  e.issues.length && t.issues.push(...lr(r, e.issues)), t.value[r] = e.value;
}
function Nf(e, t, r, n, i) {
  for (let o = 0; o < r.length; o++) {
    const s = e[o], a = o < n.length;
    if (!a && o >= i && r[o]._zod.optin === "optional") {
      t.value.length = o;
      break;
    }
    if (s.issues.length) {
      if (!a && o >= i) {
        t.value.length = o;
        break;
      }
      t.issues.push(...lr(o, s.issues));
    }
    t.value[o] = s.value;
  }
  for (let o = t.value.length - 1; o >= n.length && (r[o]._zod.optout === "optional" && t.value[o] === void 0); o--)
    t.value.length = o;
  return t;
}
const A0 = /* @__PURE__ */ Y("$ZodRecord", (e, t) => {
  Ve.init(e, t);
  const r = _t.memoizer;
  r == null || r.attach(e), e._zod.parse = (n, i) => {
    const o = n.value;
    if (!$n(o))
      return n.issues.push({
        expected: "record",
        code: "invalid_type",
        input: o,
        inst: e
      }), n;
    const s = [], a = t.keyType._zod.values;
    if (a && !t.partial) {
      n.value = r ? r.alloc(e, n, {}, i) : {};
      const l = /* @__PURE__ */ new Set();
      for (const u of a)
        if (typeof u == "string" || typeof u == "number" || typeof u == "symbol") {
          if (l.add(typeof u == "number" ? u.toString() : u), u === "__proto__")
            continue;
          const h = t.keyType._zod.run({ value: u, issues: [] }, i);
          if (h instanceof Promise)
            throw new Error("Async schemas not supported in object keys currently");
          if (h.issues.length) {
            n.issues.push({
              code: "invalid_key",
              origin: "record",
              issues: h.issues.map((g) => fr(g, i, qt())),
              input: u,
              path: [u],
              inst: e
            });
            continue;
          }
          const E = h.value;
          if (E === "__proto__")
            continue;
          const d = t.valueType._zod.run({ value: o[u], issues: [] }, i);
          d instanceof Promise ? s.push(d.then((g) => {
            g.issues.length && n.issues.push(...lr(u, g.issues)), n.value[E] = g.value;
          })) : (d.issues.length && n.issues.push(...lr(u, d.issues)), n.value[E] = d.value);
        }
      let f;
      for (const u in o)
        if (!l.has(u))
          if (t.mode === "loose") {
            if (u === "__proto__")
              continue;
            n.value[u] = o[u];
          } else
            f = f ?? [], f.push(u);
      f && f.length > 0 && n.issues.push({
        code: "unrecognized_keys",
        input: o,
        inst: e,
        keys: f,
        continue: !0
      });
    } else {
      n.value = r ? r.alloc(e, n, {}, i) : {};
      let l;
      for (const f of Reflect.ownKeys(o)) {
        if (f === "__proto__" || !Object.prototype.propertyIsEnumerable.call(o, f))
          continue;
        let u = t.keyType._zod.run({ value: f, issues: [] }, i);
        if (u instanceof Promise)
          throw new Error("Async schemas not supported in object keys currently");
        if (typeof f == "string" && ia.test(f) && u.issues.length) {
          const g = t.keyType._zod.run({ value: Number(f), issues: [] }, i);
          if (g instanceof Promise)
            throw new Error("Async schemas not supported in object keys currently");
          g.issues.length === 0 && (u = g);
        }
        if (u.issues.length) {
          t.mode === "loose" ? n.value[f] = o[f] : a ? (l = l ?? [], l.push(f)) : n.issues.push({
            code: "invalid_key",
            origin: "record",
            issues: u.issues.map((g) => fr(g, i, qt())),
            input: f,
            path: [f],
            inst: e
          });
          continue;
        }
        const E = u.value;
        if (E === "__proto__")
          continue;
        const d = t.valueType._zod.run({ value: o[f], issues: [] }, i);
        d instanceof Promise ? s.push(d.then((g) => {
          g.issues.length && n.issues.push(...lr(f, g.issues)), n.value[E] = g.value;
        })) : (d.issues.length && n.issues.push(...lr(f, d.issues)), n.value[E] = d.value);
      }
      l && l.length > 0 && n.issues.push({
        code: "unrecognized_keys",
        input: o,
        inst: e,
        keys: l,
        continue: !0
      });
    }
    return s.length ? Promise.all(s).then(() => n) : n;
  };
}), v0 = /* @__PURE__ */ Y("$ZodMap", (e, t) => {
  Ve.init(e, t);
  const r = _t.memoizer;
  r == null || r.attach(e), e._zod.parse = (n, i) => {
    const o = n.value;
    if (!(o instanceof Map))
      return n.issues.push({
        expected: "map",
        code: "invalid_type",
        input: o,
        inst: e
      }), n;
    const s = [];
    n.value = r ? r.alloc(e, n, /* @__PURE__ */ new Map(), i) : /* @__PURE__ */ new Map();
    const a = i == null ? void 0 : i.abortEarly;
    let l = n.issues.length;
    for (const [f, u] of o) {
      if (a && n.issues.length !== l) {
        if (Gt(n, l))
          break;
        l = n.issues.length;
      }
      const h = t.keyType._zod.run({ value: f, issues: [] }, i), E = t.valueType._zod.run({ value: u, issues: [] }, i);
      h instanceof Promise || E instanceof Promise ? s.push(Promise.all([h, E]).then(([d, g]) => {
        Cf(d, g, n, f, o, e, i);
      })) : Cf(h, E, n, f, o, e, i);
    }
    return s.length ? Promise.all(s).then(() => n) : n;
  }, Gg(e, d0);
});
function Cf(e, t, r, n, i, o, s) {
  e.issues.length && (Lu.has(typeof n) ? r.issues.push(...lr(n, e.issues)) : r.issues.push({
    code: "invalid_key",
    origin: "map",
    input: i,
    inst: o,
    issues: e.issues.map((a) => fr(a, s, qt()))
  })), t.issues.length && (Lu.has(typeof n) ? r.issues.push(...lr(n, t.issues)) : r.issues.push({
    origin: "map",
    code: "invalid_element",
    input: i,
    inst: o,
    key: n,
    issues: t.issues.map((a) => fr(a, s, qt()))
  })), r.value.set(e.value, t.value);
}
const S0 = /* @__PURE__ */ Y("$ZodEnum", (e, t) => {
  Ve.init(e, t);
  const r = Du(t.entries), n = new Set(r);
  e._zod.values = n, ke(e, "pattern", (i) => {
    const o = Du(i.def.entries).filter((s) => Lu.has(typeof s));
    return new RegExp(o.length ? `^(${o.map((s) => bi(s.toString())).join("|")})$` : "^[^\\s\\S]$");
  }), e._zod.parse = (i, o) => {
    const s = i.value;
    return n.has(s) || i.issues.push({
      code: "invalid_value",
      values: r,
      input: s,
      inst: e
    }), i;
  };
}), I0 = /* @__PURE__ */ Y("$ZodLiteral", (e, t) => {
  Ve.init(e, t);
  const r = new Set(t.values);
  e._zod.values = r, ke(e, "pattern", (n) => {
    const i = n.def.values;
    return new RegExp(i.length ? `^(${i.map((o) => typeof o == "string" ? bi(o) : o ? bi(o.toString()) : String(o)).join("|")})$` : "^[^\\s\\S]$");
  }), e._zod.parse = (n, i) => {
    const o = n.value;
    return r.has(o) || n.issues.push({
      code: "invalid_value",
      values: t.values,
      input: o,
      inst: e
    }), n;
  };
}), _0 = /* @__PURE__ */ Y("$ZodTransform", (e, t) => {
  var r;
  Ve.init(e, t), e._zod.optin = "optional", (r = _t.memoizer) == null || r.guard(e), e._zod.parse = (n, i) => {
    if (i.direction === "backward")
      throw new Tg(e.constructor.name);
    const o = t.transform(n.value, n);
    if (i.async)
      return (o instanceof Promise ? o : Promise.resolve(o)).then((a) => (n.value = a, n));
    if (o instanceof Promise)
      throw new Kr();
    return n.value = o, n;
  };
});
function Pf(e, t) {
  return e.value = t.issues.length ? void 0 : t.value, e;
}
const Wg = /* @__PURE__ */ Y("$ZodOptional", (e, t) => {
  Ve.init(e, t), ke(e, "optin", (r) => r.def.innerType._zod.optin === "defaulted" ? "defaulted" : "optional"), e._zod.optout = "optional", ke(e, "values", (r) => {
    const n = r.def.innerType._zod.values;
    return n ? /* @__PURE__ */ new Set([...n, void 0]) : void 0;
  }), ke(e, "pattern", (r) => {
    const n = r.def.innerType._zod.pattern;
    return n ? new RegExp(`^(${Ol(n.source)})?$`) : void 0;
  }), e._zod.parse = (r, n) => {
    if (r.value === void 0) {
      if (t.innerType._zod.optin !== "defaulted")
        return r;
      const i = t.innerType._zod.run({ value: r.value, issues: [] }, n);
      return i instanceof Promise ? i.then((o) => Pf(r, o)) : Pf(r, i);
    }
    return t.innerType._zod.run(r, n);
  };
}), R0 = /* @__PURE__ */ Y("$ZodExactOptional", (e, t) => {
  Wg.init(e, t), ke(e, "values", (r) => r.def.innerType._zod.values), ke(e, "pattern", (r) => r.def.innerType._zod.pattern), e._zod.parse = (r, n) => t.innerType._zod.run(r, n);
}), O0 = /* @__PURE__ */ Y("$ZodNullable", (e, t) => {
  Ve.init(e, t), ke(e, "optin", (r) => r.def.innerType._zod.optin), ke(e, "optout", (r) => r.def.innerType._zod.optout), ke(e, "pattern", (r) => {
    const n = r.def.innerType._zod.pattern;
    return n ? new RegExp(`^(${Ol(n.source)}|null)$`) : void 0;
  }), ke(e, "values", (r) => r.def.innerType._zod.values ? /* @__PURE__ */ new Set([...r.def.innerType._zod.values, null]) : void 0), e._zod.parse = (r, n) => r.value === null ? r : t.innerType._zod.run(r, n);
}), w0 = /* @__PURE__ */ Y("$ZodDefault", (e, t) => {
  Ve.init(e, t), e._zod.optin = "defaulted", ke(e, "values", (r) => r.def.innerType._zod.values), e._zod.parse = (r, n) => {
    if (n.direction === "backward")
      return t.innerType._zod.run(r, n);
    if (r.value === void 0)
      return r.value = t.defaultValue, r;
    const i = t.innerType._zod.run(r, n);
    return i instanceof Promise ? i.then((o) => Df(o, t)) : Df(i, t);
  };
});
function Df(e, t) {
  return e.value === void 0 && (e.value = t.defaultValue), e;
}
const N0 = /* @__PURE__ */ Y("$ZodPrefault", (e, t) => {
  Ve.init(e, t), e._zod.optin = "defaulted", ke(e, "values", (r) => r.def.innerType._zod.values), e._zod.parse = (r, n) => (n.direction === "backward" || r.value === void 0 && (r.value = t.defaultValue), t.innerType._zod.run(r, n));
}), C0 = /* @__PURE__ */ Y("$ZodNonOptional", (e, t) => {
  Ve.init(e, t), ke(e, "values", (r) => {
    const n = r.def.innerType._zod.values;
    return n ? new Set([...n].filter((i) => i !== void 0)) : void 0;
  }), e._zod.parse = (r, n) => {
    const i = t.innerType._zod.run(r, n);
    return i instanceof Promise ? i.then((o) => Mf(o, e)) : Mf(i, e);
  };
});
function Mf(e, t) {
  return !e.issues.length && e.value === void 0 && e.issues.push({
    code: "invalid_type",
    expected: "nonoptional",
    input: e.value,
    inst: t
  }), e;
}
function Lf(e, t, r, n) {
  return t.issues.length ? (e.value = r.catchValue({
    ...t,
    value: e.value,
    error: {
      issues: t.issues.map((i) => fr(i, n, qt()))
    },
    input: e.value
  }), e) : (e.value = t.value, t.memo && (e.memo = !0), e);
}
const P0 = /* @__PURE__ */ Y("$ZodCatch", (e, t) => {
  Ve.init(e, t), ke(e, "optin", (r) => r.def.innerType._zod.optin === "defaulted" ? "defaulted" : "optional"), ke(e, "optout", (r) => r.def.innerType._zod.optout), ke(e, "values", (r) => r.def.innerType._zod.values), e._zod.parse = (r, n) => {
    if (n.direction === "backward")
      return t.innerType._zod.run(r, n);
    const i = t.innerType._zod.run({ value: r.value, issues: [] }, n);
    return i instanceof Promise ? i.then((o) => Lf(r, o, t, n)) : Lf(r, i, t, n);
  };
}), qg = /* @__PURE__ */ Y("$ZodPipe", (e, t) => {
  Ve.init(e, t), ke(e, "values", (r) => r.def.in._zod.values), ke(e, "optin", (r) => r.def.in._zod.optin), ke(e, "optout", (r) => r.def.out._zod.optout), ke(e, "propValues", (r) => r.def.in._zod.propValues), e._zod.parse = (r, n) => {
    if (n.direction === "backward") {
      const o = t.out._zod.run(r, n);
      return o instanceof Promise ? o.then((s) => as(s, t.in, n)) : as(o, t.in, n);
    }
    const i = t.in._zod.run(r, n);
    return i instanceof Promise ? i.then((o) => as(o, t.out, n)) : as(i, t.out, n);
  };
});
function as(e, t, r) {
  return e.issues.some((n) => n.code !== "unrecognized_keys") ? (e.aborted = !0, e) : t._zod.run({ value: e.value, issues: e.issues }, r);
}
const D0 = /* @__PURE__ */ Y("$ZodPreprocess", (e, t) => {
  qg.init(e, t);
}), M0 = /* @__PURE__ */ Y("$ZodReadonly", (e, t) => {
  Ve.init(e, t), ke(e, "propValues", (r) => r.def.innerType._zod.propValues), ke(e, "values", (r) => r.def.innerType._zod.values), ke(e, "optin", (r) => {
    var n, i;
    return (i = (n = r.def.innerType) == null ? void 0 : n._zod) == null ? void 0 : i.optin;
  }), ke(e, "optout", (r) => {
    var n, i;
    return (i = (n = r.def.innerType) == null ? void 0 : n._zod) == null ? void 0 : i.optout;
  }), e._zod.parse = (r, n) => {
    if (n.direction === "backward")
      return t.innerType._zod.run(r, n);
    const i = t.innerType._zod.run(r, n);
    return i instanceof Promise ? i.then(xf) : xf(i);
  };
});
function xf(e) {
  return e.memo || (e.value = Object.freeze(e.value)), e;
}
const L0 = /* @__PURE__ */ Y("$ZodCustom", (e, t) => {
  mt.init(e, t), Ve.init(e, t), e._zod.parse = (r, n) => r, e._zod.check = (r) => {
    const n = r.value, i = t.fn(n);
    if (i instanceof Promise)
      return i.then((o) => kf(o, r, n, e));
    kf(i, r, n, e);
  };
});
function kf(e, t, r, n) {
  if (!e) {
    const i = {
      code: "custom",
      input: r,
      inst: n,
      // incorporates params.error into issue reporting
      path: [...n._zod.def.path ?? []],
      // incorporates params.error into issue reporting
      continue: !n._zod.def.abort
      // params: inst._zod.def.params,
    };
    n._zod.def.params && (i.params = n._zod.def.params), t.issues.push(Go(i));
  }
}
const Ht = Symbol.for("zod.compile.invalid"), jf = Symbol.for("zod.compile.fallback");
class Ai extends Error {
  constructor(t = "z.compile does not support async refinements, transforms, or checks") {
    super(t), this.name = "ZodCompileAsyncError";
  }
}
class Me extends Error {
  constructor(t, r = !0) {
    super(`z.compile does not support ${t}; this schema must use the runtime parser`), this.name = "ZodCompileUnsupportedError", this.islandable = r;
  }
}
function x0(e, t) {
  try {
    return Bl(e, { assertOnly: !0 });
  } catch {
    return t;
  }
}
function k0(e, t) {
  try {
    const r = Bl(e), n = j0(e, r);
    return n._zod.bag.validator = x0(e, r), n;
  } catch (r) {
    throw r;
  }
}
function j0(e, t) {
  if (Sg(e))
    throw new Me("a schema whose subtree contains a reference cycle");
  const r = Gr(e), n = e._zod.run, i = n.__originalRun ?? n, o = (s, a) => {
    if (a != null && a.async || (a == null ? void 0 : a.direction) === "backward" || a != null && a.skipChecks || a != null && a[jf] || a && Ig(a, s.value))
      return i(s, a);
    const l = t(s.value);
    return l !== Ht ? (s.value = l, s) : (a && (a[jf] = !0), i(s, a));
  };
  return o.__originalRun = i, r._zod.bag.fallbackRun = i, r._zod.bag.validator = t, r._zod.run = o, n.__originalRun || U0(r, e, t), r;
}
function U0(e, t, r) {
  const n = e, i = t;
  if (typeof i.safeParse == "function") {
    const o = i.safeParse;
    n.safeParse = (s, a) => {
      const l = r(s);
      return l !== Ht ? { success: !0, data: l } : o(s, a);
    };
  }
  if (typeof i.parse == "function") {
    const o = i.parse;
    n.parse = (s, a) => {
      const l = r(s);
      return l !== Ht ? l : o(s, a);
    };
  }
}
function Bl(e, t) {
  let r = !0;
  try {
    r = Sg(e);
  } catch {
  }
  if (r)
    throw new Me("a schema whose subtree contains a reference cycle");
  const n = {
    constants: /* @__PURE__ */ new Map(),
    constantCounter: 0,
    varCounter: 0,
    definite: !0
  }, i = new bg(["input"]), o = Ke(i, n, e, "input", !(t != null && t.assertOnly));
  i.write(o === null ? "return true;" : `return ${o};`);
  const s = ["INVALID", ...n.constants.keys()], a = [Ht, ...n.constants.values()], l = i.content.join(`
`), f = t != null && t.debug ? s.length > 0 ? `// Constants: ${s.join(", ")}
${l}` : l : "", u = Function, h = `return (input) => {
${l}
}`;
  let E;
  try {
    E = new u(...s, h)(...a);
  } catch (d) {
    throw new Me(`this schema (generated code failed to evaluate: ${d.message})`);
  }
  return t != null && t.debug && (E.code = f), E.definite = n.definite, E;
}
function ye(e, t) {
  for (const [n, i] of e.constants)
    if (i === t)
      return n;
  const r = `c${e.constantCounter++}`;
  return e.constants.set(r, t), r;
}
function Fn(e, t) {
  return e.definite = !1, ye(e, t);
}
function he(e) {
  return `v${e.varCounter++}`;
}
function $0(e, t) {
  const r = e._zod.run({ value: t, issues: [] }, {});
  if (r && typeof r.then == "function")
    return Ht;
  const n = r;
  return n.issues.length === 0 ? n.value : Ht;
}
function At(e, t, r, n, i = !0) {
  const o = e.content.length, s = t.constants.size, a = t.constantCounter, l = t.varCounter;
  try {
    return Ke(e, t, r, n, i);
  } catch (f) {
    if (!(f instanceof Me) || !f.islandable)
      throw f;
    if (e.content.length = o, t.constants.size > s) {
      const u = Array.from(t.constants.keys()).slice(s);
      for (const h of u)
        t.constants.delete(h);
    }
    return t.constantCounter = a, t.varCounter = l, F0(e, t, r, n);
  }
}
function F0(e, t, r, n) {
  t.definite = !1;
  const i = ye(t, r), o = ye(t, $0), s = he(t);
  return e.write(`const ${s} = ${o}(${i}, ${n});`), e.write(`if (${s} === INVALID) return INVALID;`), s;
}
const G0 = /* @__PURE__ */ new Set([
  "max_size",
  "min_size",
  "size_equals",
  "max_length",
  "min_length",
  "length_equals"
]);
function z0(e, t, r, n) {
  const i = r._zod.def.checks;
  if (!i || i.length === 0)
    return n;
  let o = n;
  for (const s of i) {
    const a = s._zod.def;
    if (a.when && !G0.has(a.check))
      throw new Me('check with a custom "when" condition');
    switch (a.check) {
      case "greater_than":
        B0(e, t, a, o);
        break;
      case "less_than":
        V0(e, t, a, o);
        break;
      case "multiple_of":
        W0(e, t, a, o);
        break;
      case "number_format":
        Yg(e, a, o);
        break;
      case "min_length": {
        const l = Zr(a.minimum, "min_length"), f = $a(e, t, o, `${o}.length >= ${l} && ${o}.length < ${a.minimum * 2}`);
        e.write(`if (${f} < ${l}) return INVALID;`);
        break;
      }
      case "max_length": {
        const l = Zr(a.maximum, "max_length"), f = $a(e, t, o, `${o}.length > ${l}`);
        e.write(`if (${f} > ${l}) return INVALID;`);
        break;
      }
      case "length_equals": {
        const l = Zr(a.length, "length_equals"), f = $a(e, t, o, `${o}.length >= ${l} && ${o}.length <= ${a.length * 2}`);
        e.write(`if (${f} !== ${l}) return INVALID;`);
        break;
      }
      case "min_size":
        e.write(`if (${o}.size < ${Zr(a.minimum, "min_size")}) return INVALID;`);
        break;
      case "max_size":
        e.write(`if (${o}.size > ${Zr(a.maximum, "max_size")}) return INVALID;`);
        break;
      case "size_equals":
        e.write(`if (${o}.size !== ${Zr(a.size, "size_equals")}) return INVALID;`);
        break;
      case "string_format":
        o = Zg(e, t, a, o);
        break;
      case "custom":
        o = K0(e, t, s, o);
        break;
      case "bigint_format":
        q0(e, a, o);
        break;
      case "mime_type":
        H0(e, t, a, o);
        break;
      case "property":
        Z0(e, t, a, o);
        break;
      case "properties":
        Y0(e, t, a, o);
        break;
      case "overwrite": {
        const l = he(t);
        J0(e, t, s, o, l), o = l;
        break;
      }
      default:
        throw new Me(`check type ${a.check}`);
    }
  }
  return o;
}
function $a(e, t, r, n) {
  const i = ye(t, na), o = he(t);
  return e.write(`const ${o} = typeof ${r} === "string" && ${n} ? ${i}(${r}) : ${r}.length;`), o;
}
function Zr(e, t) {
  if (typeof e != "number" || !Number.isFinite(e))
    throw new Me(`${t} bound of type ${typeof e}`);
  return `${e}`;
}
function Hg(e, t) {
  if (typeof t == "bigint")
    return `${t}n`;
  if (typeof t == "number") {
    if (Number.isNaN(t))
      throw new Me("comparison check with NaN bound");
    return `${t}`;
  }
  if (t instanceof Date) {
    if (Number.isNaN(t.getTime()))
      throw new Me("comparison check with Invalid Date bound");
    return ye(e, t);
  }
  throw new Me(`comparison check bound of type ${typeof t}`);
}
function B0(e, t, r, n) {
  const i = r.inclusive ? "<" : "<=";
  e.write(`if (${n} ${i} ${Hg(t, r.value)}) return INVALID;`);
}
function V0(e, t, r, n) {
  const i = r.inclusive ? ">" : ">=";
  e.write(`if (${n} ${i} ${Hg(t, r.value)}) return INVALID;`);
}
function W0(e, t, r, n) {
  if (typeof r.value == "bigint") {
    if (r.value === BigInt(0))
      throw new Me("multiple_of check with a zero divisor");
    e.write(`if (${n} % ${r.value}n !== 0n) return INVALID;`);
  } else {
    const i = ye(t, cg);
    e.write(`if (${i}(${n}, ${Zr(r.value, "multiple_of")}) !== 0) return INVALID;`);
  }
}
function Yg(e, t, r) {
  const n = t.format;
  switch (n) {
    case "safeint":
      e.write(`if (!Number.isSafeInteger(${r})) return INVALID;`);
      break;
    case "int32":
      e.write(`if (!Number.isInteger(${r}) || ${r} < -2147483648 || ${r} > 2147483647) return INVALID;`);
      break;
    case "uint32":
      e.write(`if (!Number.isInteger(${r}) || ${r} < 0 || ${r} > 4294967295) return INVALID;`);
      break;
    case "float32":
      e.write(`if (!Number.isFinite(${r}) || ${r} < -3.4028234663852886e38 || ${r} > 3.4028234663852886e38) return INVALID;`);
      break;
    case "float64":
      e.write(`if (!Number.isFinite(${r})) return INVALID;`);
      break;
    default:
      throw new Me(`number format ${n}`);
  }
}
function q0(e, t, r) {
  const n = t.format;
  if (n)
    switch (n) {
      case "int64":
        e.write(`if (${r} < -9223372036854775808n || ${r} > 9223372036854775807n) return INVALID;`);
        break;
      case "uint64":
        e.write(`if (${r} < 0n || ${r} > 18446744073709551615n) return INVALID;`);
        break;
      default:
        throw new Me(`bigint format ${n}`);
    }
}
function H0(e, t, r, n) {
  const i = r.mime;
  if (i && i.length > 0) {
    const o = ye(t, new Set(i));
    e.write(`if (!${o}.has(${n}.type)) return INVALID;`);
  }
}
function Y0(e, t, r, n) {
  if (r.when)
    throw new Me('check with a custom "when" condition');
  e.write(`if (${n} == null) return INVALID;`);
  const i = r.shape;
  for (const o of Reflect.ownKeys(i)) {
    const s = typeof o == "symbol" ? ye(t, o) : zt(o), a = he(t);
    e.write(`const ${a} = ${n}[${s}];`), At(e, t, i[o], a, !1);
  }
}
function Z0(e, t, r, n) {
  const i = `${n}[${JSON.stringify(r.property)}]`;
  Ke(e, t, r.schema, i);
}
function J0(e, t, r, n, i) {
  const o = r._zod.def.tx;
  if (!o)
    throw new Me("overwrite check without a transform function");
  if (Gn(o))
    throw new Ai("z.compile: async overwrite transforms are not supported");
  const s = ye(t, o);
  e.write(`const ${i} = ${s}(${n});`);
}
function Fu() {
  throw new Kr();
}
function Vl(e) {
  this.issues.push(e);
}
function K0(e, t, r, n) {
  const i = r._zod.def;
  if (i.fn) {
    if (Gn(i.fn))
      throw new Ai("z.compile: async .refine() predicates are not supported");
    const o = Fn(t, i.fn), s = ye(t, Fu), a = he(t);
    return e.write(`const ${a} = ${o}(${n});`), e.write(`if (${a} instanceof Promise) ${s}();`), e.write(`if (!${a}) return INVALID;`), n;
  }
  if (r._zod.check) {
    if (Gn(r._zod.check))
      throw new Ai("z.compile: async .superRefine() / check functions are not supported");
    const o = r._zod.check, a = Fn(t, (f) => {
      const u = { value: f, issues: [], addIssue: Vl };
      return o(u) instanceof Promise && Fu(), u.issues.length === 0 ? u.value : Ht;
    }), l = he(t);
    return e.write(`const ${l} = ${a}(${n});`), e.write(`if (${l} === INVALID) return INVALID;`), l;
  }
  throw new Me("custom check without a predicate or check function");
}
const X0 = /* @__PURE__ */ new Set([
  "cidrv4",
  "cuid",
  "cuid2",
  "date",
  "datetime",
  "duration",
  "e164",
  "email",
  "emoji",
  "ends_with",
  "guid",
  "includes",
  "ipv4",
  "ksuid",
  "lowercase",
  "mac",
  "nanoid",
  "regex",
  "starts_with",
  "time",
  "ulid",
  "uppercase",
  "uuid",
  "xid"
]);
function Zg(e, t, r, n, i = !0) {
  const o = r.format;
  if (o === "base64") {
    const f = ye(t, Gl);
    return e.write(`if (!${f}(${n})) return INVALID;`), n;
  }
  if (o === "base64url") {
    const f = ye(t, Ug);
    return e.write(`if (!${f}(${n})) return INVALID;`), n;
  }
  if (o === "jwt") {
    const f = ye(t, $g), u = ye(t, r.alg ?? null);
    return e.write(`if (!${f}(${n}, ${u})) return INVALID;`), n;
  }
  if (o === "ipv6") {
    const f = ye(t, Fl);
    return e.write(`if (!${f}(${n})) return INVALID;`), n;
  }
  if (o === "cidrv6") {
    const f = ye(t, kg);
    return e.write(`if (!${f}(${n})) return INVALID;`), n;
  }
  if (o === "credit_card") {
    const f = ye(t, t0);
    return e.write(`if (!${f}(${n})) return INVALID;`), n;
  }
  if (o === "iban") {
    const f = ye(t, n0);
    return e.write(`if (!${f}(${n})) return INVALID;`), n;
  }
  const s = r;
  if (o === "url" || o === "httpurl" || s.normalize || s.hostname !== void 0 || s.protocol !== void 0) {
    const f = ye(t, Mg), u = ye(t, r), h = he(t), E = he(t);
    if (e.write(`const ${h} = ${n}.trim();`), e.write(`const ${E} = ${f}(${h}, ${u});`), e.write(`if (typeof ${E} === "number") return INVALID;`), s.hostname !== void 0) {
      const y = ye(t, Lg);
      e.write(`if (!${y}(${E}, ${u}.hostname)) return INVALID;`);
    }
    if (s.protocol !== void 0) {
      const y = ye(t, xg);
      e.write(`if (!${y}(${E}, ${u}.protocol)) return INVALID;`);
    }
    if (!i)
      return null;
    const d = he(t), g = s.normalize ? `${E}.href` : `${ye(t, $u)}(${h})`;
    return e.write(`const ${d} = ${g};`), d;
  }
  const a = r.fn;
  if (a) {
    if (Gn(a))
      throw new Me(`async string format ${o}`);
    const f = ye(t, a);
    return e.write(`if (!${f}(${n})) return INVALID;`), n;
  }
  if (X0.has(o) && r.pattern) {
    const f = ye(t, r.pattern);
    return e.write(`${f}.lastIndex = 0;`), e.write(`if (!${f}.test(${n})) return INVALID;`), n;
  }
  const l = r.format;
  switch (l) {
    case "regex":
      throw new Me("regex format without a pattern");
    case "lowercase":
      e.write(`if (${n} !== ${n}.toLowerCase()) return INVALID;`);
      break;
    case "uppercase":
      e.write(`if (${n} !== ${n}.toUpperCase()) return INVALID;`);
      break;
    case "includes":
      e.write(`if (!${n}.includes(${zt(r.includes)})) return INVALID;`);
      break;
    case "starts_with": {
      const f = r.prefix;
      e.write(`if (${n}.slice(0, ${f.length}) !== ${zt(f)}) return INVALID;`);
      break;
    }
    case "ends_with": {
      const f = r.suffix;
      e.write(`if (${n}.slice(-${f.length}) !== ${zt(f)}) return INVALID;`);
      break;
    }
    default:
      throw new Me(`string format ${l}`);
  }
  return n;
}
function Ke(e, t, r, n, i = !0) {
  var f;
  const o = r._zod.def, s = o.type;
  if (o.coerce)
    throw new Me(`coercion (z.coerce.${s}())`);
  const a = i || !!((f = o.checks) != null && f.length);
  let l;
  switch (s) {
    case "string":
      l = Q0(e, t, r, n, a);
      break;
    case "number":
      l = eI(e, r, n);
      break;
    case "boolean":
      l = tI(e, n);
      break;
    case "bigint":
      l = rI(e, r, n);
      break;
    case "symbol":
      l = nI(e, n);
      break;
    case "undefined":
      l = iI(e, n);
      break;
    case "null":
      l = oI(e, n);
      break;
    case "any":
    case "unknown":
      l = n;
      break;
    case "never":
      e.write("return INVALID;"), l = n;
      break;
    case "void":
      l = sI(e, n);
      break;
    case "nan":
      l = aI(e, n);
      break;
    case "date":
      l = uI(e, n);
      break;
    case "object":
      l = lI(e, t, r, n, a);
      break;
    case "optional":
      l = cI(e, t, r, n, a);
      break;
    case "nullable":
      l = pI(e, t, r, n, a);
      break;
    case "array":
      l = hI(e, t, r, n, a);
      break;
    case "literal":
      l = mI(e, t, r, n);
      break;
    case "enum":
      l = EI(e, t, r, n);
      break;
    case "readonly": {
      const u = $f(e, t, r, n), h = he(t);
      e.write(`const ${h} = Object.freeze(${u});`), l = h;
      break;
    }
    case "success":
      $f(e, t, r, n), l = "true";
      break;
    case "default":
    case "prefault":
      l = gI(e, t, r, n);
      break;
    case "nonoptional":
      l = yI(e, t, r, n);
      break;
    case "tuple":
      l = TI(e, t, r, n);
      break;
    case "union":
      l = bI(e, t, r, n);
      break;
    case "intersection":
      l = SI(e, t, r, n);
      break;
    case "record":
      l = II(e, t, r, n);
      break;
    case "map":
      l = RI(e, t, r, n);
      break;
    case "set":
      l = OI(e, t, r, n);
      break;
    case "file":
      l = wI(e, n);
      break;
    case "template_literal":
      l = NI(e, t, r, n);
      break;
    case "lazy":
      l = CI(e, t, r, n);
      break;
    case "pipe":
      l = PI(e, t, r, n);
      break;
    case "custom":
      l = DI(e, t, r, n);
      break;
    case "transform":
      l = xI(e, t, r, n);
      break;
    case "catch":
      l = LI(e, t, r, n);
      break;
    default:
      throw new Me(`schema type ${s}`);
  }
  return l === null ? null : z0(e, t, r, l);
}
function Q0(e, t, r, n, i = !0) {
  e.write(`if (typeof ${n} !== "string") return INVALID;`);
  const o = r._zod.def;
  return o.format === void 0 ? n : Zg(e, t, o, n, i);
}
function eI(e, t, r) {
  e.write(`if (typeof ${r} !== "number" || !Number.isFinite(${r})) return INVALID;`);
  const n = t._zod.def;
  return n.check === "number_format" && n.format && Yg(e, { format: n.format }, r), r;
}
function tI(e, t) {
  return e.write(`if (typeof ${t} !== "boolean") return INVALID;`), t;
}
function rI(e, t, r) {
  e.write(`if (typeof ${r} !== "bigint") return INVALID;`);
  const n = t._zod.def;
  if (n.format)
    switch (n.format) {
      case "int64":
        e.write(`if (${r} < -9223372036854775808n || ${r} > 9223372036854775807n) return INVALID;`);
        break;
      case "uint64":
        e.write(`if (${r} < 0n || ${r} > 18446744073709551615n) return INVALID;`);
        break;
    }
  return r;
}
function nI(e, t) {
  return e.write(`if (typeof ${t} !== "symbol") return INVALID;`), t;
}
function iI(e, t) {
  return e.write(`if (${t} !== undefined) return INVALID;`), t;
}
function oI(e, t) {
  return e.write(`if (${t} !== null) return INVALID;`), t;
}
function sI(e, t) {
  return e.write(`if (${t} !== undefined) return INVALID;`), t;
}
function aI(e, t) {
  return e.write(`if (typeof ${t} !== "number" || !Number.isNaN(${t})) return INVALID;`), t;
}
function uI(e, t) {
  return e.write(`if (!(${t} instanceof Date) || Number.isNaN(${t}.getTime())) return INVALID;`), t;
}
function lI(e, t, r, n, i = !0) {
  var I;
  const o = r._zod.def;
  e.write(`if (typeof ${n} !== "object" || ${n} === null || Array.isArray(${n})) return INVALID;`);
  const s = o.shape, a = Object.keys(s), l = Object.getOwnPropertySymbols(s), f = l.length ? [...a, ...l] : a, u = (w) => typeof w == "symbol" ? ye(t, w) : zt(w), h = (w) => typeof w == "symbol" ? `[${u(w)}]` : zt(w), E = s;
  if (a.includes("__proto__"))
    throw new Me('object shape key "__proto__"');
  const d = /* @__PURE__ */ new Map();
  for (const w of f) {
    const L = E[w], R = u(w), D = he(t);
    if (e.write(`const ${D} = ${n}[${R}];`), L._zod.optin !== void 0) {
      const P = he(t);
      e.write(`let ${P} = (() => {`), e.indented((O) => {
        const F = At(O, t, L, D);
        O.write(`return ${F};`);
      }), e.write("})();"), L._zod.optout === "optional" ? (e.write(`if (${P} === INVALID) {`), e.indented((O) => {
        O.write(`if (${R} in ${n}) return INVALID;`), O.write(`${P} = undefined;`);
      }), e.write("}")) : e.write(`if (${P} === INVALID) return INVALID;`), d.set(w, P);
    } else {
      dI(L) && e.write(`if (!(${R} in ${n})) return INVALID;`);
      const P = At(e, t, L, D, i);
      P !== null && d.set(w, P);
    }
  }
  const g = o.catchall;
  let y = "none";
  if (g) {
    const w = g._zod.def.type;
    if (w === "never") {
      const L = a.map((R) => `k !== ${zt(R)}`).join(" && ") || "true";
      e.write(`for (const k in ${n}) {`), e.indented((R) => {
        R.write(`if (${L}) return INVALID;`);
      }), e.write("}");
    } else (w === "unknown" || w === "any") && !((I = g._zod.def.checks) != null && I.length) ? y = "passthrough" : y = "schema";
  }
  const b = he(t), _ = f.some((w) => Uf(E[w]) || Gu(E[w]));
  if (!i) {
    if (y === "schema") {
      const w = a.length > 0 ? ye(t, new Set(a)) : null;
      e.write(`for (const k in ${n}) {`), e.indented((L) => {
        L.write('if (k === "__proto__") continue;'), w && L.write(`if (${w}.has(k)) continue;`);
        const R = he(t);
        L.write(`const ${R} = ${n}[k];`), At(L, t, g, R, !1);
      }), e.write("}");
    }
    return null;
  }
  if (_) {
    e.write(`const ${b} = {};`);
    for (const w of f) {
      const L = u(w), R = d.get(w);
      Gu(E[w]) ? e.write(`if (${L} in ${n}) ${b}[${L}] = ${R};`) : Uf(E[w]) ? e.write(`if (${R} !== undefined || ${L} in ${n}) ${b}[${L}] = ${R};`) : e.write(`${b}[${L}] = ${R};`);
    }
  } else {
    const w = f.map((L) => `${h(L)}: ${d.get(L)}`).join(", ");
    e.write(`const ${b} = { ${w} };`);
  }
  if (y !== "none") {
    const w = a.length > 0 ? ye(t, new Set(a)) : null;
    e.write(`for (const k in ${n}) {`), e.indented((L) => {
      if (L.write('if (k === "__proto__") continue;'), w && L.write(`if (${w}.has(k)) continue;`), y === "passthrough")
        L.write(`${b}[k] = ${n}[k];`);
      else {
        const R = he(t);
        L.write(`const ${R} = ${n}[k];`);
        const D = At(L, t, g, R);
        L.write(`${b}[k] = ${D};`);
      }
    }), e.write("}");
  }
  return b;
}
function cI(e, t, r, n, i = !0) {
  const o = r._zod.def;
  if (fI(r))
    return Ke(e, t, o.innerType, n, i);
  if (o.innerType._zod.optin === "defaulted") {
    const a = he(t), l = he(t);
    return e.write(`let ${a};`), e.write(`if (${n} === undefined) {`), e.indented((f) => {
      f.write(`const ${l} = (() => {`), f.indented((u) => {
        const h = Ke(u, t, o.innerType, n);
        u.write(`return ${h};`);
      }), f.write("})();"), f.write(`if (${l} !== INVALID) ${a} = ${l};`);
    }), e.write("} else {"), e.indented((f) => {
      const u = Ke(f, t, o.innerType, n);
      f.write(`${a} = ${u};`);
    }), e.write("}"), a;
  }
  const s = i ? he(t) : null;
  return s && e.write(`let ${s};`), e.write(`if (${n} !== undefined) {`), e.indented((a) => {
    const l = Ke(a, t, o.innerType, n, i);
    s && l !== null && a.write(`${s} = ${l};`);
  }), e.write("}"), s;
}
function fI(e) {
  var t;
  return ((t = e._zod.traits) == null ? void 0 : t.has("$ZodExactOptional")) === !0;
}
function dI(e) {
  return e._zod.optin === void 0 && Mn(e);
}
function Mn(e) {
  var r, n;
  if (e._zod.def.coerce)
    return !0;
  const t = e._zod.def;
  switch (t.type) {
    case "any":
    case "unknown":
    case "undefined":
    case "void":
    case "default":
    case "prefault":
    case "transform":
    case "custom":
    case "lazy":
      return !0;
    case "string":
    case "number":
    case "boolean":
    case "bigint":
    case "symbol":
    case "null":
    case "never":
    case "nan":
    case "date":
    case "object":
    case "array":
    case "tuple":
    case "record":
    case "map":
    case "set":
    case "file":
    case "template_literal":
      return !1;
    case "nonoptional":
      return t.innerType ? Mn(t.innerType) : !1;
    case "literal":
      return !!((r = t.values) != null && r.includes(void 0));
    case "enum":
      return !!((n = e._zod.values) != null && n.has(void 0));
    case "optional":
    case "nullable":
    case "readonly":
    case "success":
      return t.innerType ? Mn(t.innerType) : !0;
    case "catch":
      return !0;
    case "union":
      return t.options ? t.options.some(Mn) : !0;
    case "intersection":
      return !t.left || !t.right ? !0 : Mn(t.left) && Mn(t.right);
    case "pipe":
      return t.in ? Mn(t.in) : !0;
    default:
      return !0;
  }
}
function Gu(e) {
  return e._zod.optin === "optional" && e._zod.optout === "optional";
}
function Uf(e) {
  return (e._zod.optin !== "defaulted" || e._zod.optout === "optional") && pi(e);
}
function pi(e) {
  var r, n;
  const t = e._zod.def;
  switch (t.type) {
    case "string":
    case "number":
    case "boolean":
    case "bigint":
    case "symbol":
    case "null":
    case "nan":
    case "date":
    case "object":
    case "array":
    case "tuple":
    case "record":
    case "map":
    case "set":
    case "file":
    case "template_literal":
    case "never":
    case "success":
      return !1;
    case "literal":
      return !!((r = t.values) != null && r.includes(void 0));
    case "enum":
      return !!((n = e._zod.values) != null && n.has(void 0));
    case "optional":
      return !0;
    case "nullable":
    case "readonly":
    case "nonoptional":
      return t.innerType ? pi(t.innerType) : !0;
    case "union":
      return t.options ? t.options.some(pi) : !0;
    case "intersection":
      return !t.left || !t.right || pi(t.left) || pi(t.right);
    case "pipe":
      return t.out ? pi(t.out) : !0;
    default:
      return !0;
  }
}
function pI(e, t, r, n, i = !0) {
  const o = r._zod.def, s = i ? he(t) : null;
  return s && e.write(`let ${s} = null;`), e.write(`if (${n} !== null) {`), e.indented((a) => {
    const l = Ke(a, t, o.innerType, n, i);
    s && l !== null && a.write(`${s} = ${l};`);
  }), e.write("}"), s;
}
function Wl(e, t, r) {
  for (const [n, i] of xu(t._zod.def.checks))
    e.write(`if (${r} > ${Zr(n, i._zod.def.check)}) return INVALID;`);
}
function hI(e, t, r, n, i = !0) {
  const o = r._zod.def;
  e.write(`if (!Array.isArray(${n})) return INVALID;`), Wl(e, r, `${n}.length`);
  const s = i ? he(t) : null, a = he(t), l = he(t);
  return s && e.write(`const ${s} = new Array(${n}.length);`), e.write(`for (let ${a} = 0; ${a} < ${n}.length; ${a}++) {`), e.indented((f) => {
    f.write(`const ${l} = ${n}[${a}];`);
    const u = At(f, t, o.element, l, i);
    s && u !== null && f.write(`${s}[${a}] = ${u};`);
  }), e.write("}"), s;
}
function mI(e, t, r, n) {
  const o = r._zod.def.values;
  if (o.length !== 1) {
    const a = ye(t, new Set(o));
    return e.write(`if (!${a}.has(${n})) return INVALID;`), n;
  }
  const s = o[0];
  if (typeof s == "number" && Number.isNaN(s)) {
    const a = ye(t, new Set(o));
    return e.write(`if (!${a}.has(${n})) return INVALID;`), n;
  }
  if (typeof s == "string")
    e.write(`if (${n} !== ${zt(s)}) return INVALID;`);
  else if (typeof s == "number" || typeof s == "boolean")
    e.write(`if (${n} !== ${s}) return INVALID;`);
  else if (s === null)
    e.write(`if (${n} !== null) return INVALID;`);
  else if (s === void 0)
    e.write(`if (${n} !== undefined) return INVALID;`);
  else if (typeof s == "bigint")
    e.write(`if (${n} !== ${s}n) return INVALID;`);
  else
    throw new Me(`literal type ${typeof s}`);
  return n;
}
function EI(e, t, r, n) {
  const i = r._zod.values;
  if (!i)
    throw new Me("enum schema without enumerated values");
  const o = ye(t, i);
  return e.write(`if (!${o}.has(${n})) return INVALID;`), n;
}
function $f(e, t, r, n) {
  const i = r._zod.def;
  return Ke(e, t, i.innerType, n);
}
function gI(e, t, r, n) {
  const i = r._zod.def, s = Object.getOwnPropertyDescriptor(r._zod.def, "defaultValue") ? () => r._zod.def.defaultValue : void 0;
  if (r._zod.def.type === "prefault") {
    if (!s)
      return Ke(e, t, i.innerType, n);
    const l = ye(t, s), f = he(t);
    return e.write(`let ${f} = ${n};`), e.write(`if (${n} === undefined) ${f} = ${l}();`), Ke(e, t, i.innerType, f);
  }
  const a = he(t);
  if (s) {
    const l = ye(t, s), f = ye(t, Nl);
    e.write(`let ${a};`), e.write(`if (${n} === undefined) {`), e.indented((u) => {
      u.write(`${a} = ${f}(${l}());`);
    }), e.write("} else {"), e.indented((u) => {
      const h = Ke(u, t, i.innerType, n);
      u.write(`${a} = ${h} === undefined ? ${f}(${l}()) : ${h};`);
    }), e.write("}");
  } else
    e.write(`let ${a};`), e.write(`if (${n} !== undefined) {`), e.indented((l) => {
      const f = Ke(l, t, i.innerType, n);
      l.write(`${a} = ${f};`);
    }), e.write("}");
  return a;
}
function yI(e, t, r, n) {
  const i = r._zod.def, o = Ke(e, t, i.innerType, n), s = he(t);
  return e.write(`const ${s} = ${o};`), e.write(`if (${s} === undefined) return INVALID;`), s;
}
function TI(e, t, r, n) {
  const i = r._zod.def, o = i.items, s = i.rest;
  e.write(`if (!Array.isArray(${n})) return INVALID;`);
  const a = Ff(o, "optin"), l = Ff(o, "optout");
  s ? e.write(`if (${n}.length < ${a}) return INVALID;`) : e.write(`if (${n}.length < ${a} || ${n}.length > ${o.length}) return INVALID;`);
  const f = he(t);
  e.write(`const ${f} = [];`);
  for (let u = 0; u < o.length; u++) {
    const h = o[u];
    if (u >= l)
      e.write(`if (${f}.length === ${u}) {`), e.indented((E) => {
        E.write(`if (${u} < ${n}.length) {`), E.indented((d) => {
          const g = he(t);
          d.write(`const ${g} = ${n}[${u}];`);
          const y = At(d, t, h, g);
          d.write(`${f}[${u}] = ${y};`);
        }), E.write("} else {"), E.indented((d) => {
          if (Gu(h)) {
            d.write(`${f}.length = ${u};`);
            return;
          }
          const g = he(t), y = he(t);
          d.write(`const ${g} = undefined;`), d.write(`const ${y} = (() => {`), d.indented((b) => {
            const _ = At(b, t, h, g);
            b.write(`return ${_};`);
          }), d.write("})();"), d.write(`if (${y} === INVALID || ${y} === undefined) ${f}.length = ${u};`), d.write(`else ${f}[${u}] = ${y};`);
        }), E.write("}");
      }), e.write("}");
    else {
      const E = he(t);
      e.write(`const ${E} = ${n}[${u}];`);
      const d = At(e, t, h, E);
      e.write(`${f}[${u}] = ${d};`);
    }
  }
  if (s) {
    const u = he(t), h = he(t);
    e.write(`for (let ${u} = ${o.length}; ${u} < ${n}.length; ${u}++) {`), e.indented((E) => {
      E.write(`const ${h} = ${n}[${u}];`);
      const d = At(E, t, s, h);
      E.write(`${f}[${u}] = ${d};`);
    }), e.write("}");
  }
  return f;
}
function Ff(e, t) {
  for (let r = e.length - 1; r >= 0; r--)
    if (!(t === "optin" ? e[r]._zod.optin !== void 0 : e[r]._zod.optout === "optional"))
      return r + 1;
  return 0;
}
function bI(e, t, r, n) {
  const i = r._zod.def, o = i.options;
  if (i.discriminator)
    return AI(e, t, i, n);
  if (i.inclusive === !1)
    throw new Me("exclusive unions (z.xor)");
  if (o.length === 0)
    return e.write("return INVALID;"), n;
  if (o.length === 1)
    return Ke(e, t, o[0], n);
  if (o.every((l) => {
    var f;
    return l._zod.def.type === "literal" && !((f = l._zod.def.checks) != null && f.length);
  })) {
    const l = new Set(o.flatMap((u) => u._zod.def.values)), f = ye(t, l);
    return e.write(`if (!${f}.has(${n})) return INVALID;`), n;
  }
  const a = he(t);
  e.write(`let ${a};`);
  for (let l = 0; l < o.length; l++) {
    const f = o[l];
    l === 0 ? e.write(`${a} = (() => {`) : e.write(`if (${a} === INVALID) ${a} = (() => {`), e.indented((u) => {
      const h = Ke(u, t, f, n);
      u.write(`return ${h};`);
    }), e.write("})();");
  }
  return e.write(`if (${a} === INVALID) return INVALID;`), a;
}
function AI(e, t, r, n) {
  var l;
  if (r.unionFallback)
    throw new Me("discriminated union with unionFallback");
  if (r.options.length === 0)
    return e.write("return INVALID;"), n;
  const i = he(t), o = he(t);
  e.write(`const ${i} = ${n}?.[${zt(r.discriminator)}];`), e.write(`let ${o};`);
  let s = !0;
  const a = /* @__PURE__ */ new Set();
  for (const f of r.options) {
    const u = (l = f._zod.propValues) == null ? void 0 : l[r.discriminator];
    if (!u || u.size === 0)
      throw new Me("discriminated union option without static discriminator values");
    for (const d of u) {
      if (a.has(d))
        throw new Me(`duplicate discriminator value ${String(d)}`);
      a.add(d);
    }
    const h = Array.from(u, (d) => vI(t, i, d)), E = s ? "if" : "else if";
    e.write(`${E} (${h.join(" || ")}) {`), e.indented((d) => {
      const g = Ke(d, t, f, n);
      d.write(`${o} = ${g};`);
    }), e.write("}"), s = !1;
  }
  return e.write("else { return INVALID; }"), o;
}
function vI(e, t, r) {
  if (typeof r == "string")
    return `${t} === ${zt(r)}`;
  if (typeof r == "number")
    return Number.isNaN(r) ? `Number.isNaN(${t})` : `${t} === ${r}`;
  if (typeof r == "boolean")
    return `${t} === ${r}`;
  if (r === null)
    return `${t} === null`;
  if (r === void 0)
    return `${t} === undefined`;
  if (typeof r == "bigint")
    return `${t} === ${r}n`;
  if (typeof r == "symbol") {
    const n = ye(e, r);
    return `${t} === ${n}`;
  }
  throw new Me(`literal discriminator value ${String(r)}`);
}
function SI(e, t, r, n) {
  const i = r._zod.def;
  t.definite = !1;
  const o = At(e, t, i.left, n), s = At(e, t, i.right, n), a = ye(t, Ls), l = he(t);
  return e.write(`const ${l} = ${a}(${o}, ${s});`), e.write(`if (!${l}.valid) return INVALID;`), `${l}.data`;
}
function II(e, t, r, n) {
  var d;
  const i = r._zod.def, o = ye(t, $n);
  e.write(`if (!${o}(${n})) return INVALID;`);
  const s = he(t), a = he(t), l = he(t);
  e.write(`const ${s} = {};`);
  const f = i, u = f.partial ? void 0 : i.keyType._zod.values;
  if (u) {
    const g = [];
    for (const b of u) {
      if (!(typeof b == "string" || typeof b == "number" || typeof b == "symbol"))
        throw new Me(`record key value ${String(b)}`);
      const _ = typeof b == "number" ? b.toString() : b;
      if (_ === "__proto__")
        throw new Me('record key "__proto__"');
      g.push(_);
      const I = ye(t, b), w = Ke(e, t, i.keyType, I), L = he(t);
      e.write(`const ${L} = ${n}[${_I(t, _)}];`);
      const R = At(e, t, i.valueType, L);
      e.write(`${s}[${w}] = ${R};`);
    }
    const y = ye(t, new Set(g));
    return e.write(`for (const ${a} in ${n}) {`), e.indented((b) => {
      b.write(`if (${y}.has(${a})) continue;`), f.mode === "loose" ? b.write(`if (${a} !== "__proto__") ${s}[${a}] = ${n}[${a}];`) : b.write("return INVALID;");
    }), e.write("}"), s;
  }
  const h = i.keyType._zod.def;
  if (!(h.type === "string" && h.format === void 0 && !h.coerce && (((d = h.checks) == null ? void 0 : d.length) ?? 0) === 0)) {
    const g = i.mode === "loose", y = Bl(i.keyType);
    y.definite === !1 && (t.definite = !1);
    const b = ye(t, y), _ = ye(t, ia), I = he(t);
    return Gf(e, t, n, a, (w) => {
      w.write(`let ${I} = ${b}(${a});`), w.write(`if (${I} === INVALID && typeof ${a} === "string" && ${_}.test(${a})) ${I} = ${b}(Number(${a}));`), g ? w.write(`if (${I} === INVALID) { ${s}[${a}] = ${n}[${a}]; continue; }`) : w.write(`if (${I} === INVALID) return INVALID;`), w.write(`if (${I} === "__proto__") continue;`);
      const L = he(t);
      w.write(`const ${L} = ${n}[${a}];`);
      const R = At(w, t, i.valueType, L);
      w.write(`${s}[${I}] = ${R};`);
    }), s;
  }
  return Gf(e, t, n, a, (g) => {
    g.write(`const ${l} = ${n}[${a}];`);
    const y = At(g, t, i.valueType, l);
    g.write(`${s}[${a}] = ${y};`);
  }, "return INVALID;"), s;
}
function Gf(e, t, r, n, i, o) {
  const s = ye(t, Object.prototype.propertyIsEnumerable), a = he(t), l = he(t), f = he(t);
  e.write(`const ${a} = Object.getOwnPropertySymbols(${r});`), e.write(`const ${l} = Object.getOwnPropertyNames(${r});`), e.write(`for (let ${f} = 0; ${f} < ${l}.length; ${f}++) {`), e.indented((u) => {
    u.write(`const ${n} = ${l}[${f}];`), u.write(`if (${n} === "__proto__" || !${s}.call(${r}, ${n})) continue;`), i(u);
  }), e.write("}"), e.write(`for (let ${f} = 0; ${f} < ${a}.length; ${f}++) {`), e.indented((u) => {
    u.write(`const ${n} = ${a}[${f}];`), u.write(`if (!${s}.call(${r}, ${n})) continue;`), o ? u.write(o) : i(u);
  }), e.write("}");
}
function _I(e, t) {
  return typeof t == "string" ? zt(t) : ye(e, t);
}
function RI(e, t, r, n) {
  const i = r._zod.def;
  e.write(`if (!(${n} instanceof Map)) return INVALID;`), Wl(e, r, `${n}.size`);
  const o = he(t), s = he(t), a = he(t);
  return e.write(`const ${o} = new Map();`), e.write(`for (const [${s}, ${a}] of ${n}) {`), e.indented((l) => {
    const f = Ke(l, t, i.keyType, s), u = Ke(l, t, i.valueType, a);
    l.write(`${o}.set(${f}, ${u});`);
  }), e.write("}"), o;
}
function OI(e, t, r, n) {
  const i = r._zod.def;
  e.write(`if (!(${n} instanceof Set)) return INVALID;`), Wl(e, r, `${n}.size`);
  const o = he(t), s = he(t);
  return e.write(`const ${o} = new Set();`), e.write(`for (const ${s} of ${n}) {`), e.indented((a) => {
    const l = Ke(a, t, i.valueType, s);
    a.write(`${o}.add(${l});`);
  }), e.write("}"), o;
}
function wI(e, t) {
  return e.write(`if (!(${t} instanceof File)) return INVALID;`), t;
}
function NI(e, t, r, n) {
  e.write(`if (typeof ${n} !== "string") return INVALID;`);
  const i = r._zod.pattern;
  if (i) {
    const o = ye(t, i);
    e.write(`${o}.lastIndex = 0;`), e.write(`if (!${o}.test(${n})) return INVALID;`);
  }
  return n;
}
function CI(e, t, r, n) {
  const i = r._zod.def, o = Fn(t, i.getter), s = ye(t, { parser: null });
  e.write(`if (!${s}.parser) {`), e.indented((l) => {
    l.write(`const inner = ${o}();`), l.write(`${s}.parser = function(input) {`), l.indented((f) => {
      f.write("const result = inner._zod.run({ value: input, issues: [] }, {});"), f.write("return result.issues.length === 0 ? result.value : INVALID;");
    }), l.write("};");
  }), e.write("}");
  const a = he(t);
  return e.write(`const ${a} = ${s}.parser(${n});`), e.write(`if (${a} === INVALID) return INVALID;`), a;
}
function PI(e, t, r, n) {
  const i = r._zod.def, o = Ke(e, t, i.in, n);
  if (i.transform) {
    if (Gn(i.transform))
      throw new Ai("z.compile: async transforms in pipes are not supported");
    const s = i.transform, l = Fn(t, (u) => {
      const h = { value: u, issues: [], addIssue: Vl }, E = s(u, h);
      return E instanceof Promise ? Ht : h.issues.length === 0 ? E : Ht;
    }), f = he(t);
    return e.write(`const ${f} = ${l}(${o});`), e.write(`if (${f} === INVALID) return INVALID;`), Ke(e, t, i.out, f);
  } else
    return Ke(e, t, i.out, o);
}
function Gn(e) {
  return typeof e == "function" && (e.constructor.name === "AsyncFunction" || e[Symbol.toStringTag] === "AsyncFunction");
}
function DI(e, t, r, n) {
  const i = r._zod.def;
  if (i.fn) {
    if (Gn(i.fn))
      throw new Ai("z.compile: async custom predicates are not supported");
    const o = Fn(t, i.fn), s = ye(t, Fu), a = he(t);
    e.write(`const ${a} = ${o}(${n});`), e.write(`if (${a} instanceof Promise) ${s}();`), e.write(`if (!${a}) return INVALID;`);
  } else
    throw new Me("custom schema without a predicate function");
  return n;
}
function MI(e, t, r) {
  const n = e._zod.run({ value: r, issues: [] }, {});
  if (n && typeof n.then == "function")
    return Ht;
  const i = n;
  return i.issues.length === 0 ? i.value : t();
}
function LI(e, t, r, n) {
  const i = r._zod.def;
  if (!i.catchValue[yg])
    throw new Me("catch with a callback (only a constant catch value compiles)", !1);
  const o = he(t);
  e.write(`let ${o} = (() => {`), e.indented((f) => {
    const u = At(f, t, i.innerType, n);
    f.write(`return ${u};`);
  }), e.write("})();");
  const s = ye(t, i.innerType), a = Fn(t, i.catchValue), l = ye(t, MI);
  return e.write(`if (${o} === INVALID) {`), e.indented((f) => {
    f.write(`${o} = ${l}(${s}, ${a}, ${n});`), f.write(`if (${o} === INVALID) return INVALID;`);
  }), e.write("}"), o;
}
function xI(e, t, r, n) {
  const i = r._zod.def;
  if (i.transform) {
    if (Gn(i.transform))
      throw new Ai("z.compile: async transforms are not supported");
    const o = i.transform, a = Fn(t, (f) => {
      const u = { value: f, issues: [], addIssue: Vl }, h = o(f, u);
      return h instanceof Promise ? Ht : u.issues.length === 0 ? h : Ht;
    }), l = he(t);
    return e.write(`const ${l} = ${a}(${n});`), e.write(`if (${l} === INVALID) return INVALID;`), l;
  }
  return n;
}
const kI = () => {
  const e = {
    string: { unit: "characters", verb: "to have" },
    file: { unit: "bytes", verb: "to have" },
    array: { unit: "items", verb: "to have" },
    set: { unit: "items", verb: "to have" },
    map: { unit: "entries", verb: "to have" }
  };
  function t(o) {
    return e[o] ?? null;
  }
  const r = {
    regex: "input",
    email: "email address",
    url: "URL",
    emoji: "emoji",
    uuid: "UUID",
    uuidv4: "UUIDv4",
    uuidv6: "UUIDv6",
    nanoid: "nanoid",
    guid: "GUID",
    cuid: "cuid",
    cuid2: "cuid2",
    ulid: "ULID",
    xid: "XID",
    ksuid: "KSUID",
    datetime: "ISO datetime",
    date: "ISO date",
    time: "ISO time",
    duration: "ISO duration",
    ipv4: "IPv4 address",
    ipv6: "IPv6 address",
    mac: "MAC address",
    cidrv4: "IPv4 range",
    cidrv6: "IPv6 range",
    base64: "base64-encoded string",
    base64url: "base64url-encoded string",
    json_string: "JSON string",
    e164: "E.164 number",
    currency_code: "currency code",
    credit_card: "credit card number",
    iban: "IBAN",
    jwt: "JWT",
    template_literal: "input"
  }, n = {
    // Compatibility: "nan" -> "NaN" for display
    nan: "NaN"
    // All other type names omitted - they fall back to raw values via ?? operator
  };
  function i(o, s) {
    return o === "number" && typeof s == "number" && !Number.isFinite(s) ? String(s) : n[o] ?? o;
  }
  return (o) => {
    switch (o.code) {
      case "invalid_type": {
        const s = i(o.expected), a = QA(o.input), l = i(a, o.input);
        return `Invalid input: expected ${s}, received ${l}`;
      }
      case "invalid_value":
        return o.values.length === 1 ? `Invalid input: expected ${hg(o.values[0])}` : `Invalid option: expected one of ${gf(o.values, "|")}`;
      case "too_big": {
        const s = o.exact ? "exactly " : o.inclusive ? "<=" : "<", a = t(o.origin);
        return a ? `Too big: expected ${o.origin ?? "value"} to have ${s}${o.maximum.toString()} ${a.unit ?? "elements"}` : `Too big: expected ${o.origin ?? "value"} to be ${s}${o.maximum.toString()}`;
      }
      case "too_small": {
        const s = o.exact ? "exactly " : o.inclusive ? ">=" : ">", a = t(o.origin);
        return a ? `Too small: expected ${o.origin} to have ${s}${o.minimum.toString()} ${a.unit}` : `Too small: expected ${o.origin} to be ${s}${o.minimum.toString()}`;
      }
      case "invalid_format": {
        const s = o;
        return s.format === "starts_with" ? `Invalid string: must start with "${s.prefix}"` : s.format === "ends_with" ? `Invalid string: must end with "${s.suffix}"` : s.format === "includes" ? `Invalid string: must include "${s.includes}"` : s.format === "regex" ? `Invalid string: must match pattern ${s.pattern}` : `Invalid ${r[s.format] ?? o.format}`;
      }
      case "not_multiple_of":
        return `Invalid number: must be a multiple of ${o.divisor}`;
      case "unrecognized_keys":
        return `Unrecognized key${o.keys.length > 1 ? "s" : ""}: ${gf(o.keys, ", ")}`;
      case "invalid_key":
        return `Invalid key in ${o.origin}`;
      case "invalid_union":
        return o.options && Array.isArray(o.options) && o.options.length > 0 ? `Invalid discriminator value. Expected ${o.options.map((a) => `'${a}'`).join(" | ")}` : o.inclusive === !1 ? "Invalid input: more than one option matched" : "Invalid input";
      case "invalid_element":
        return `Invalid value in ${o.origin}`;
      default:
        return "Invalid input";
    }
  };
};
function jI() {
  return {
    localeError: kI()
  };
}
var zf;
class UI {
  constructor() {
    this._map = /* @__PURE__ */ new WeakMap(), this._idmap = /* @__PURE__ */ new Map();
  }
  add(t, ...r) {
    const n = r[0];
    return this._map.set(t, n), n && typeof n == "object" && "id" in n && this._idmap.set(n.id, t), this;
  }
  clear() {
    return this._map = /* @__PURE__ */ new WeakMap(), this._idmap = /* @__PURE__ */ new Map(), this;
  }
  remove(t) {
    const r = this._map.get(t);
    return r && typeof r == "object" && "id" in r && this._idmap.delete(r.id), this._map.delete(t), this;
  }
  get(t) {
    const r = t._zod.parent;
    if (r) {
      const n = { ...this.get(r) ?? {} };
      delete n.id;
      const i = { ...n, ...this._map.get(t) };
      return Object.keys(i).length ? i : void 0;
    }
    return this._map.get(t);
  }
  has(t) {
    return this._map.has(t);
  }
}
function $I() {
  return new UI();
}
(zf = globalThis).__zod_globalRegistry ?? (zf.__zod_globalRegistry = $I());
const Mo = globalThis.__zod_globalRegistry;
function ql(e) {
  return e.checks && (e.checks = [...e.checks]), e;
}
// @__NO_SIDE_EFFECTS__
function FI(e, t) {
  return new e(ql({ type: "string", ...se(t) }));
}
// @__NO_SIDE_EFFECTS__
function GI(e, t) {
  return new e({
    type: "string",
    format: "email",
    check: "string_format",
    abort: !1,
    ...se(t)
  });
}
// @__NO_SIDE_EFFECTS__
function zI(e, t) {
  return new e({
    type: "string",
    format: "guid",
    check: "string_format",
    abort: !1,
    ...se(t)
  });
}
// @__NO_SIDE_EFFECTS__
function BI(e, t) {
  return new e({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    ...se(t)
  });
}
// @__NO_SIDE_EFFECTS__
function VI(e, t) {
  return new e({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    version: "v4",
    ...se(t)
  });
}
// @__NO_SIDE_EFFECTS__
function WI(e, t) {
  return new e({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    version: "v6",
    ...se(t)
  });
}
// @__NO_SIDE_EFFECTS__
function qI(e, t) {
  return new e({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    version: "v7",
    ...se(t)
  });
}
// @__NO_SIDE_EFFECTS__
function HI(e, t) {
  return new e({
    type: "string",
    format: "url",
    check: "string_format",
    abort: !1,
    ...se(t)
  });
}
// @__NO_SIDE_EFFECTS__
function YI(e, t) {
  return new e({
    type: "string",
    format: "emoji",
    check: "string_format",
    abort: !1,
    ...se(t)
  });
}
// @__NO_SIDE_EFFECTS__
function ZI(e, t) {
  return new e({
    type: "string",
    format: "nanoid",
    check: "string_format",
    abort: !1,
    ...se(t)
  });
}
// @__NO_SIDE_EFFECTS__
function JI(e, t) {
  return new e({
    type: "string",
    format: "cuid",
    check: "string_format",
    abort: !1,
    ...se(t)
  });
}
// @__NO_SIDE_EFFECTS__
function KI(e, t) {
  return new e({
    type: "string",
    format: "cuid2",
    check: "string_format",
    abort: !1,
    ...se(t)
  });
}
// @__NO_SIDE_EFFECTS__
function XI(e, t) {
  return new e({
    type: "string",
    format: "ulid",
    check: "string_format",
    abort: !1,
    ...se(t)
  });
}
// @__NO_SIDE_EFFECTS__
function QI(e, t) {
  return new e({
    type: "string",
    format: "xid",
    check: "string_format",
    abort: !1,
    ...se(t)
  });
}
// @__NO_SIDE_EFFECTS__
function e_(e, t) {
  return new e({
    type: "string",
    format: "ksuid",
    check: "string_format",
    abort: !1,
    ...se(t)
  });
}
// @__NO_SIDE_EFFECTS__
function t_(e, t) {
  return new e({
    type: "string",
    format: "ipv4",
    check: "string_format",
    abort: !1,
    ...se(t)
  });
}
// @__NO_SIDE_EFFECTS__
function r_(e, t) {
  return new e({
    type: "string",
    format: "ipv6",
    check: "string_format",
    abort: !1,
    ...se(t)
  });
}
// @__NO_SIDE_EFFECTS__
function n_(e, t) {
  return new e({
    type: "string",
    format: "cidrv4",
    check: "string_format",
    abort: !1,
    ...se(t)
  });
}
// @__NO_SIDE_EFFECTS__
function i_(e, t) {
  return new e({
    type: "string",
    format: "cidrv6",
    check: "string_format",
    abort: !1,
    ...se(t)
  });
}
// @__NO_SIDE_EFFECTS__
function o_(e, t) {
  return new e({
    type: "string",
    format: "base64",
    check: "string_format",
    abort: !1,
    ...se(t)
  });
}
// @__NO_SIDE_EFFECTS__
function s_(e, t) {
  return new e({
    type: "string",
    format: "base64url",
    check: "string_format",
    abort: !1,
    ...se(t)
  });
}
// @__NO_SIDE_EFFECTS__
function a_(e, t) {
  return new e({
    type: "string",
    format: "e164",
    check: "string_format",
    abort: !1,
    ...se(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Jg(e, t) {
  return new e({
    type: "string",
    format: "jwt",
    check: "string_format",
    abort: !1,
    ...se(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Kg(e, t) {
  return new e({
    type: "string",
    format: "datetime",
    check: "string_format",
    offset: !1,
    local: !1,
    precision: null,
    ...se(t)
  });
}
// @__NO_SIDE_EFFECTS__
function u_(e, t) {
  return new e({
    type: "string",
    format: "date",
    check: "string_format",
    ...se(t)
  });
}
// @__NO_SIDE_EFFECTS__
function l_(e, t) {
  return new e({
    type: "string",
    format: "time",
    check: "string_format",
    precision: null,
    ...se(t)
  });
}
// @__NO_SIDE_EFFECTS__
function c_(e, t) {
  return new e({
    type: "string",
    format: "duration",
    check: "string_format",
    ...se(t)
  });
}
// @__NO_SIDE_EFFECTS__
function f_(e, t) {
  return new e(ql({ type: "number", checks: [], ...se(t) }));
}
// @__NO_SIDE_EFFECTS__
function d_(e, t) {
  return new e(ql({ type: "number", coerce: !0, checks: [], ...se(t) }));
}
// @__NO_SIDE_EFFECTS__
function p_(e, t) {
  return new e({
    type: "number",
    check: "number_format",
    abort: !1,
    format: "safeint",
    ...se(t)
  });
}
// @__NO_SIDE_EFFECTS__
function h_(e, t) {
  return new e({
    type: "boolean",
    ...se(t)
  });
}
// @__NO_SIDE_EFFECTS__
function m_(e, t) {
  return new e({
    type: "undefined",
    ...se(t)
  });
}
// @__NO_SIDE_EFFECTS__
function E_(e) {
  return new e({
    type: "unknown"
  });
}
// @__NO_SIDE_EFFECTS__
function g_(e, t) {
  return new e({
    type: "never",
    ...se(t)
  });
}
// @__NO_SIDE_EFFECTS__
function y_(e, t) {
  return new e({
    type: "date",
    coerce: !0,
    ...se(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Bf(e, t) {
  return new Rg({
    check: "less_than",
    ...se(t),
    value: e,
    inclusive: !1
  });
}
// @__NO_SIDE_EFFECTS__
function Is(e, t) {
  return new Rg({
    check: "less_than",
    ...se(t),
    value: e,
    inclusive: !0
  });
}
// @__NO_SIDE_EFFECTS__
function Vf(e, t) {
  return new Og({
    check: "greater_than",
    ...se(t),
    value: e,
    inclusive: !1
  });
}
// @__NO_SIDE_EFFECTS__
function _s(e, t) {
  return new Og({
    check: "greater_than",
    ...se(t),
    value: e,
    inclusive: !0
  });
}
// @__NO_SIDE_EFFECTS__
function Wf(e, t) {
  return new Vv({
    check: "multiple_of",
    ...se(t),
    value: e
  });
}
// @__NO_SIDE_EFFECTS__
function T_(e, t) {
  return new qv({
    check: "max_size",
    ...se(t),
    maximum: e
  });
}
// @__NO_SIDE_EFFECTS__
function qf(e, t) {
  return new Hv({
    check: "min_size",
    ...se(t),
    minimum: e
  });
}
// @__NO_SIDE_EFFECTS__
function b_(e, t) {
  return new Yv({
    check: "size_equals",
    ...se(t),
    size: e
  });
}
// @__NO_SIDE_EFFECTS__
function Xg(e, t) {
  return new Zv({
    check: "max_length",
    ...se(t),
    maximum: e
  });
}
// @__NO_SIDE_EFFECTS__
function xs(e, t) {
  return new Jv({
    check: "min_length",
    ...se(t),
    minimum: e
  });
}
// @__NO_SIDE_EFFECTS__
function Qg(e, t) {
  return new Kv({
    check: "length_equals",
    ...se(t),
    length: e
  });
}
// @__NO_SIDE_EFFECTS__
function A_(e, t) {
  return new Xv({
    check: "string_format",
    format: "regex",
    ...se(t),
    pattern: e
  });
}
// @__NO_SIDE_EFFECTS__
function v_(e) {
  return new Qv({
    check: "string_format",
    format: "lowercase",
    ...se(e)
  });
}
// @__NO_SIDE_EFFECTS__
function S_(e) {
  return new eS({
    check: "string_format",
    format: "uppercase",
    ...se(e)
  });
}
// @__NO_SIDE_EFFECTS__
function I_(e, t) {
  return new tS({
    check: "string_format",
    format: "includes",
    ...se(t),
    includes: e
  });
}
// @__NO_SIDE_EFFECTS__
function __(e, t) {
  return new rS({
    check: "string_format",
    format: "starts_with",
    ...se(t),
    prefix: e
  });
}
// @__NO_SIDE_EFFECTS__
function R_(e, t) {
  return new nS({
    check: "string_format",
    format: "ends_with",
    ...se(t),
    suffix: e
  });
}
// @__NO_SIDE_EFFECTS__
function Di(e) {
  return new iS({
    check: "overwrite",
    tx: e
  });
}
// @__NO_SIDE_EFFECTS__
function O_(e) {
  return /* @__PURE__ */ Di((t) => t.normalize(e));
}
// @__NO_SIDE_EFFECTS__
function w_() {
  return /* @__PURE__ */ Di((e) => e.trim());
}
// @__NO_SIDE_EFFECTS__
function N_() {
  return /* @__PURE__ */ Di((e) => e.toLowerCase());
}
// @__NO_SIDE_EFFECTS__
function C_() {
  return /* @__PURE__ */ Di((e) => e.toUpperCase());
}
// @__NO_SIDE_EFFECTS__
function P_() {
  return /* @__PURE__ */ Di((e) => GA(e));
}
// @__NO_SIDE_EFFECTS__
function D_(e, t, r) {
  return new e({
    type: "array",
    element: t,
    // get element() {
    //   return element;
    // },
    ...se(r)
  });
}
// @__NO_SIDE_EFFECTS__
function M_(e, t, r) {
  return new e({
    type: "custom",
    check: "custom",
    fn: t,
    ...se(r)
  });
}
// @__NO_SIDE_EFFECTS__
function L_(e, t) {
  const r = /* @__PURE__ */ x_((n) => (n.addIssue = (i) => {
    if (typeof i == "string")
      n.issues.push(Go(i, n.value, r._zod.def));
    else {
      const o = i;
      o.fatal && (o.continue = !1), o.code ?? (o.code = "custom"), "input" in o || (o.input = n.value), o.inst ?? (o.inst = r), o.continue ?? (o.continue = !r._zod.def.abort), n.issues.push(Go(o));
    }
  }, e(n.value, n)), t);
  return r;
}
// @__NO_SIDE_EFFECTS__
function x_(e, t) {
  const r = new mt({
    check: "custom",
    ...se(t)
  });
  return r._zod.check = e, r;
}
function Uo(e, ...t) {
  for (const r of t)
    for (const n of Reflect.ownKeys(r))
      Object.prototype.propertyIsEnumerable.call(r, n) && Fr(e, n, r[n]);
  return e;
}
function ey(e) {
  let t = (e == null ? void 0 : e.target) ?? "draft-2020-12";
  return t === "draft-4" && (t = "draft-04"), t === "draft-7" && (t = "draft-07"), {
    processors: e.processors ?? {},
    metadataRegistry: (e == null ? void 0 : e.metadata) ?? Mo,
    target: t,
    unrepresentable: (e == null ? void 0 : e.unrepresentable) ?? "throw",
    override: (e == null ? void 0 : e.override) ?? (() => {
    }),
    io: (e == null ? void 0 : e.io) ?? "output",
    counter: 0,
    seen: /* @__PURE__ */ new Map(),
    sharedDefsExtractedFor: void 0,
    sharedEmitDoneFor: void 0,
    cycles: (e == null ? void 0 : e.cycles) ?? "ref",
    reused: (e == null ? void 0 : e.reused) ?? "inline",
    intersections: [],
    deferred: [],
    external: (e == null ? void 0 : e.external) ?? void 0
  };
}
function or(e, t, r, n, i) {
  const o = typeof t.unrepresentable == "function" ? t.unrepresentable({ zodSchema: e, path: n.path, message: i }) : t.unrepresentable;
  if (o === "any")
    return !1;
  if (o === void 0 || o === "throw")
    throw new Error(i);
  return Object.assign(r, o), !0;
}
function it(e, t, r = { path: [], schemaPath: [] }) {
  var u, h;
  var n;
  const i = e._zod.def, o = t.seen.get(e);
  if (o)
    return o.count++, r.schemaPath.includes(e) && (o.cycle = r.path), o.schema;
  const s = { schema: {}, count: 1, cycle: void 0, path: r.path };
  t.seen.set(e, s), t.sharedDefsExtractedFor = void 0, t.sharedEmitDoneFor = void 0;
  const a = (h = (u = e._zod).toJSONSchema) == null ? void 0 : h.call(u);
  if (a)
    s.schema = a;
  else {
    const E = {
      ...r,
      schemaPath: [...r.schemaPath, e],
      path: r.path
    };
    if (e._zod.processJSONSchema)
      e._zod.processJSONSchema(t, s.schema, E);
    else {
      const g = s.schema, y = t.processors[i.type];
      if (!y)
        throw new Error(`[toJSONSchema]: Non-representable type encountered: ${i.type}`);
      y(e, t, g, E);
    }
    const d = e._zod.parent;
    d && (s.ref || (s.ref = d), it(d, t, E), t.seen.get(d).isParent = !0);
  }
  const l = t.metadataRegistry.get(e);
  return l && Uo(s.schema, l), t.io === "input" && It(e) && (delete s.schema.examples, delete s.schema.default), t.io === "input" && "_prefault" in s.schema && ((n = s.schema).default ?? (n.default = s.schema._prefault)), delete s.schema._prefault, t.seen.get(e).schema;
}
function Hf(e) {
  return e.replace(/~/g, "~0").replace(/\//g, "~1");
}
function ty(e, t) {
  var s, a, l, f;
  const r = e.seen.get(t);
  if (!r)
    throw new Error("Unprocessed schema. This is a bug in Zod.");
  if (e.external && e.sharedDefsExtractedFor === e.external)
    return;
  const n = /* @__PURE__ */ new Map();
  for (const u of e.seen.entries()) {
    const h = (s = e.metadataRegistry.get(u[0])) == null ? void 0 : s.id;
    if (h) {
      const E = n.get(h);
      if (E && E !== u[0])
        throw new Error(`Duplicate schema id "${h}" detected during JSON Schema conversion. Two different schemas cannot share the same id when converted together.`);
      n.set(h, u[0]);
    }
  }
  const i = (u) => {
    var y;
    const h = e.target === "draft-2020-12" ? "$defs" : "definitions";
    if (e.external) {
      const b = (y = e.external.registry.get(u[0])) == null ? void 0 : y.id, _ = e.external.uri ?? ((w) => w);
      if (b)
        return { ref: _(b) };
      const I = u[1].defId ?? u[1].schema.id ?? `schema${e.counter++}`;
      return u[1].defId = I, { defId: I, ref: `${_("__shared")}#/${h}/${Hf(I)}` };
    }
    const E = "#", d = `${E}/${h}/`;
    if (u[1] === r && !u[1].schema.id)
      return { ref: E };
    const g = u[1].schema.id ?? `__schema${e.counter++}`;
    return { defId: g, ref: d + Hf(g) };
  }, o = (u) => {
    if (u[1].schema.$ref)
      return;
    const h = u[1], { ref: E, defId: d } = i(u);
    h.def = { ...h.schema }, d && (h.defId = d);
    const g = h.schema;
    for (const y in g)
      delete g[y];
    g.$ref = E;
  };
  if (e.cycles === "throw")
    for (const u of e.seen.entries()) {
      const h = u[1];
      if (h.cycle)
        throw new Error(`Cycle detected: #/${(a = h.cycle) == null ? void 0 : a.join("/")}/<root>

Set the \`cycles\` parameter to \`"ref"\` to resolve cyclical schemas with defs.`);
    }
  for (const u of e.seen.entries()) {
    const h = u[1];
    if (t === u[0]) {
      o(u);
      continue;
    }
    if (e.external) {
      const d = (l = e.external.registry.get(u[0])) == null ? void 0 : l.id;
      if (t !== u[0] && d) {
        o(u);
        continue;
      }
    }
    if ((f = e.metadataRegistry.get(u[0])) == null ? void 0 : f.id) {
      o(u);
      continue;
    }
    if (h.cycle) {
      o(u);
      continue;
    }
    h.count > 1 && e.reused === "ref" && o(u);
  }
  e.external && (e.sharedDefsExtractedFor = e.external);
}
function ry(e) {
  const t = e.anyOf;
  if (!Array.isArray(t) || t.length === 0 || e.type !== void 0)
    return;
  const r = [];
  for (const n of t) {
    if (!n || typeof n != "object")
      return;
    ry(n);
    const i = Object.keys(n);
    if (i.length !== 1 || i[0] !== "type")
      return;
    const o = n.type;
    for (const s of Array.isArray(o) ? o : [o]) {
      if (typeof s != "string")
        return;
      r.includes(s) || r.push(s);
    }
  }
  delete e.anyOf, e.type = r.length === 1 ? r[0] : r;
}
const ny = /* @__PURE__ */ new Set(["type", "properties", "required", "additionalProperties"]), Yf = ["oneOf", "anyOf"];
function Zf(e) {
  const t = e.additionalProperties;
  return t === void 0 || t === !1 || typeof t != "object" || t === null ? null : Object.keys(t).length ? t : null;
}
function zu(e) {
  var o;
  const t = [];
  for (const s of e) {
    if (typeof s != "object" || s.type !== "object")
      return null;
    for (const a in s)
      if (!ny.has(a))
        return null;
    t.push(s);
  }
  const r = {}, n = /* @__PURE__ */ new Set();
  for (const s of t) {
    for (const a in s.properties) {
      if (Object.prototype.hasOwnProperty.call(r, a))
        continue;
      const l = [];
      for (const u of t) {
        const h = ((o = u.properties) == null ? void 0 : o[a]) ?? Zf(u);
        h != null && (l.some((E) => JSON.stringify(E) === JSON.stringify(h)) || l.push(h));
      }
      const f = l.length === 1 ? l[0] : zu(l) ?? { allOf: l };
      Fr(r, a, f);
    }
    for (const a of s.required ?? [])
      n.add(a);
  }
  const i = { type: "object", properties: r };
  if (n.size && (i.required = [...n]), t.every((s) => s.additionalProperties === !1))
    i.additionalProperties = !1;
  else {
    const s = [];
    for (const a of t) {
      const l = Zf(a);
      l && !s.some((f) => JSON.stringify(f) === JSON.stringify(l)) && s.push(l);
    }
    s.length === 1 ? i.additionalProperties = s[0] : s.length > 1 && (i.additionalProperties = { allOf: s });
  }
  return i;
}
function k_(e) {
  const t = e.allOf;
  if (!Array.isArray(t) || t.length < 2)
    return;
  for (const i of ny)
    if (i in e)
      return;
  const r = t.filter((i) => Yf.some((o) => Array.isArray(i[o])));
  let n = null;
  if (!r.length)
    n = zu(t);
  else {
    const i = r[0], o = Yf.find((l) => Array.isArray(i[l]));
    if (Object.keys(i).length !== 1)
      return;
    const s = t.filter((l) => l !== i), a = i[o].map((l) => zu([...s, l]));
    if (a.some((l) => !l))
      return;
    n = { [o]: a };
  }
  n && (delete e.allOf, Uo(e, n));
}
function iy(e, t) {
  var a, l, f, u;
  const r = e.seen.get(t);
  if (!r)
    throw new Error("Unprocessed schema. This is a bug in Zod.");
  const n = (h) => {
    const E = e.seen.get(h);
    if (E.ref === null)
      return;
    const d = E.def ?? E.schema, g = { ...d }, y = E.ref;
    if (E.ref = null, y) {
      n(y);
      const _ = e.seen.get(y), I = _.schema;
      if (I.$ref && (e.target === "draft-07" || e.target === "draft-04" || e.target === "openapi-3.0") ? (d.allOf = d.allOf ?? [], d.allOf.push(I)) : Uo(d, I), Uo(d, g), h._zod.parent === y)
        for (const L in d)
          L === "$ref" || L === "allOf" || L in g || delete d[L];
      if (I.$ref && _.def)
        for (const L in d)
          L === "$ref" || L === "allOf" || L in _.def && JSON.stringify(d[L]) === JSON.stringify(_.def[L]) && delete d[L];
    }
    const b = h._zod.parent;
    if (b && b !== y) {
      n(b);
      const _ = e.seen.get(b);
      if (_ != null && _.schema.$ref && (d.$ref = _.schema.$ref, _.def))
        for (const I in d)
          I === "$ref" || I === "allOf" || I in _.def && JSON.stringify(d[I]) === JSON.stringify(_.def[I]) && delete d[I];
    }
    e.override({
      zodSchema: h,
      jsonSchema: d,
      path: E.path ?? []
    });
  };
  if (!e.external || e.sharedEmitDoneFor !== e.external) {
    for (const h of [...e.seen.entries()].reverse())
      n(h[0]);
    if (e.target !== "openapi-3.0")
      for (const h of e.seen.entries())
        ry(h[1].def ?? h[1].schema);
    for (const h of e.deferred)
      h();
    if (e.intersections.length) {
      const h = /* @__PURE__ */ new Map();
      for (const E of e.seen.values())
        for (const d of [E.schema, E.def]) {
          const g = d == null ? void 0 : d.allOf;
          if (!Array.isArray(g))
            continue;
          const y = h.get(g);
          y ? y.push(d) : h.set(g, [d]);
        }
      for (const E of e.intersections)
        for (const d of h.get(E) ?? [])
          k_(d);
    }
  }
  const i = {};
  if (e.target === "draft-2020-12" ? i.$schema = "https://json-schema.org/draft/2020-12/schema" : e.target === "draft-07" ? i.$schema = "http://json-schema.org/draft-07/schema#" : e.target === "draft-04" ? i.$schema = "http://json-schema.org/draft-04/schema#" : e.target, (a = e.external) != null && a.uri) {
    const h = (l = e.external.registry.get(t)) == null ? void 0 : l.id;
    if (!h)
      throw new Error("Schema is missing an `id` property");
    i.$id = e.external.uri(h);
  }
  Uo(i, r.defId ? r.schema : r.def ?? r.schema);
  const o = (f = e.metadataRegistry.get(t)) == null ? void 0 : f.id;
  o !== void 0 && i.id === o && delete i.id;
  const s = ((u = e.external) == null ? void 0 : u.defs) ?? {};
  if (!e.external || e.sharedEmitDoneFor !== e.external)
    for (const h of e.seen.entries()) {
      const E = h[1];
      E.def && E.defId && (E.def.id === E.defId && delete E.def.id, Fr(s, E.defId, E.def));
    }
  e.external && (e.sharedEmitDoneFor = e.external), e.external || Object.keys(s).length > 0 && (e.target === "draft-2020-12" ? i.$defs = s : i.definitions = s);
  try {
    const h = JSON.parse(JSON.stringify(i));
    return Object.defineProperty(h, "~standard", {
      value: {
        ...t["~standard"],
        jsonSchema: {
          input: ks(t, "input", e.processors),
          output: ks(t, "output", e.processors)
        }
      },
      enumerable: !1,
      writable: !1
    }), h;
  } catch {
    throw new Error("Error converting schema to JSON.");
  }
}
function It(e, t) {
  const r = t ?? { seen: /* @__PURE__ */ new Set() };
  if (r.seen.has(e))
    return !1;
  r.seen.add(e);
  const n = e._zod.def;
  if (n.type === "transform")
    return !0;
  if (n.type === "array")
    return It(n.element, r);
  if (n.type === "set")
    return It(n.valueType, r);
  if (n.type === "lazy")
    return It(n.getter(), r);
  if (n.type === "promise" || n.type === "optional" || n.type === "nonoptional" || n.type === "nullable" || n.type === "readonly" || n.type === "default" || n.type === "prefault" || n.type === "catch")
    return It(n.innerType, r);
  if (n.type === "intersection")
    return It(n.left, r) || It(n.right, r);
  if (n.type === "record" || n.type === "map")
    return It(n.keyType, r) || It(n.valueType, r);
  if (n.type === "pipe")
    return e._zod.traits.has("$ZodCodec") ? !0 : It(n.in, r) || It(n.out, r);
  if (n.type === "object") {
    for (const i in n.shape)
      if (It(n.shape[i], r))
        return !0;
    return !1;
  }
  if (n.type === "union") {
    for (const i of n.options)
      if (It(i, r))
        return !0;
    return !1;
  }
  if (n.type === "tuple") {
    for (const i of n.items)
      if (It(i, r))
        return !0;
    return !!(n.rest && It(n.rest, r));
  }
  return !1;
}
const j_ = (e, t = {}) => (r) => {
  const n = ey({ ...r, processors: t });
  return it(e, n), ty(n, e), iy(n, e);
}, ks = (e, t, r = {}) => (n) => {
  const { libraryOptions: i, target: o } = n ?? {}, s = ey({ ...i ?? {}, target: o, io: t, processors: r });
  return it(e, s), ty(s, e), iy(s, e);
}, vi = (e, t, r) => {
  (e[t] === void 0 || r > e[t]) && (e[t] = r);
}, Si = (e, t, r) => {
  (e[t] === void 0 || r < e[t]) && (e[t] = r);
}, Jf = (e, t) => {
  vi(e, "minimum", t), Si(e, "maximum", t);
}, oy = (e, t) => {
  e.multipleOf ?? (e.multipleOf = []), e.multipleOf.includes(t) || e.multipleOf.push(t);
}, sy = (e, t) => {
  e.patterns ?? (e.patterns = /* @__PURE__ */ new Set()), e.patterns.add(t);
}, ay = (e, t) => {
  e.mime = e.mime ? e.mime.filter((r) => t.includes(r)) : [...t];
}, uy = (e, t) => {
  e.format = t, t.includes("int") && (e.isInt = !0);
}, Kf = (e, t) => vi(e, "minimum", t.minimum), Xf = (e, t) => Si(e, "maximum", t.maximum), Qf = (e) => (t, r) => {
  uy(t, r.format);
  const [n, i] = e[r.format];
  vi(t, "minimum", n), Si(t, "maximum", i);
}, Fa = {
  greater_than: (e, t) => vi(e, t.inclusive ? "minimum" : "exclusiveMinimum", t.value),
  less_than: (e, t) => Si(e, t.inclusive ? "maximum" : "exclusiveMaximum", t.value),
  multiple_of: (e, t) => oy(e, t.value),
  number_format: Qf(mg),
  bigint_format: Qf(VA),
  min_length: Kf,
  max_length: Xf,
  length_equals: (e, t) => Jf(e, t.length),
  min_size: Kf,
  max_size: Xf,
  size_equals: (e, t) => Jf(e, t.size),
  string_format: (e, t) => {
    uy(e, t.format), t.pattern && sy(e, t.pattern), (t.format === "base64" || t.format === "base64url") && (e.contentEncoding = t.format), (t.local || t.precision === -1) && (e.laxFormat = !0);
  },
  mime_type: (e, t) => ay(e, t.mime)
};
function Ct(e) {
  var o;
  const t = {}, r = e._zod.def, n = e._zod.traits.has("$ZodCheck") ? [e, ...r.checks ?? []] : r.checks ?? [];
  for (const s of n)
    (o = Fa[s._zod.def.check]) == null || o.call(Fa, t, s._zod.def);
  const i = e._zod.bag;
  i.minimum !== void 0 && vi(t, "minimum", i.minimum), i.exclusiveMinimum !== void 0 && vi(t, "exclusiveMinimum", i.exclusiveMinimum), i.maximum !== void 0 && Si(t, "maximum", i.maximum), i.exclusiveMaximum !== void 0 && Si(t, "exclusiveMaximum", i.exclusiveMaximum), i.multipleOf !== void 0 && oy(t, i.multipleOf), i.format !== void 0 && (t.format ?? (t.format = i.format), i.format.includes("int") && (t.isInt = !0)), i.mime && ay(t, i.mime);
  for (const s of i.patterns ?? [])
    sy(t, s);
  return t;
}
const U_ = {
  guid: "uuid",
  url: "uri",
  datetime: "date-time",
  json_string: "json-string",
  regex: ""
  // do not set
}, $_ = /* @__PURE__ */ new Map([
  [jg, wv],
  [zl, Nv]
]), ly = (e) => $_.get(e) ?? e, F_ = (e, t, r, n) => {
  const i = r;
  i.type = "string";
  const { minimum: o, maximum: s, format: a, patterns: l, contentEncoding: f, laxFormat: u } = Ct(e);
  if (typeof o == "number" && (i.minLength = o), typeof s == "number" && (i.maxLength = s), a && (i.format = U_[a] ?? a, i.format === "" && delete i.format, (a === "time" || u) && delete i.format), f && (i.contentEncoding = f), l && l.size > 0) {
    const h = [...l].map(ly);
    h.length === 1 ? i.pattern = h[0].source : h.length > 1 && (i.allOf = [
      ...h.map((E) => ({
        ...t.target === "draft-07" || t.target === "draft-04" || t.target === "openapi-3.0" ? { type: "string" } : {},
        pattern: E.source
      }))
    ]);
  }
}, G_ = (e, t, r, n) => {
  const i = r, { minimum: o, maximum: s, multipleOf: a, exclusiveMaximum: l, exclusiveMinimum: f, isInt: u } = Ct(e);
  i.type = u ? "integer" : "number";
  const h = typeof f == "number" && f >= (o ?? Number.NEGATIVE_INFINITY), E = typeof l == "number" && l <= (s ?? Number.POSITIVE_INFINITY), d = t.target === "draft-04" || t.target === "openapi-3.0";
  if (h ? d ? (i.minimum = f, i.exclusiveMinimum = !0) : i.exclusiveMinimum = f : typeof o == "number" && (i.minimum = o), E ? d ? (i.maximum = l, i.exclusiveMaximum = !0) : i.exclusiveMaximum = l : typeof s == "number" && (i.maximum = s), a) {
    const g = /* @__PURE__ */ new Set();
    for (const _ of a)
      Number.isFinite(_) && _ !== 0 ? g.add(Math.abs(_)) : or(e, t, i, n, `A multipleOf divisor of ${_} cannot be represented in JSON Schema`);
    const [y, ...b] = g;
    y !== void 0 && (i.multipleOf = y), b.length && (i.allOf = [...i.allOf ?? [], ...b.map((_) => ({ multipleOf: _ }))]);
  }
}, z_ = (e, t, r, n) => {
  r.type = "boolean";
}, B_ = (e, t, r, n) => {
  or(e, t, r, n, "Undefined cannot be represented in JSON Schema");
}, V_ = (e, t, r, n) => {
  r.not = {};
}, W_ = (e, t, r, n) => {
}, q_ = (e, t, r, n) => {
  or(e, t, r, n, "Date cannot be represented in JSON Schema");
}, H_ = (e, t, r, n) => {
  const i = e._zod.def, o = Du(i.entries);
  if (o.length === 0) {
    r.not = {};
    return;
  }
  o.every((s) => typeof s == "number") && (r.type = "number"), o.every((s) => typeof s == "string") && (r.type = "string"), r.enum = o;
}, Y_ = (e, t, r, n) => {
  const i = e._zod.def;
  if (i.values.length === 0) {
    r.not = {};
    return;
  }
  const o = [];
  for (const s of i.values)
    if (s === void 0) {
      if (or(e, t, r, n, "Literal `undefined` cannot be represented in JSON Schema"))
        return;
    } else if (typeof s == "bigint") {
      if (or(e, t, r, n, "BigInt literals cannot be represented in JSON Schema"))
        return;
      o.push(Number(s));
    } else
      o.push(s);
  if (o.length !== 0) if (o.length === 1) {
    const s = o[0];
    r.type = s === null ? "null" : typeof s, t.target === "draft-04" || t.target === "openapi-3.0" ? r.enum = [s] : r.const = s;
  } else
    o.every((s) => typeof s == "number") && (r.type = "number"), o.every((s) => typeof s == "string") && (r.type = "string"), o.every((s) => typeof s == "boolean") && (r.type = "boolean"), o.every((s) => s === null) && (r.type = "null"), r.enum = o;
}, Z_ = (e, t, r, n) => {
  or(e, t, r, n, "Custom types cannot be represented in JSON Schema");
}, J_ = (e, t, r, n) => {
  or(e, t, r, n, "Transforms cannot be represented in JSON Schema");
}, K_ = (e, t, r, n) => {
  or(e, t, r, n, "Map cannot be represented in JSON Schema");
}, X_ = (e, t, r, n) => {
  const i = r, o = e._zod.def, { minimum: s, maximum: a } = Ct(e);
  typeof s == "number" && (i.minItems = s), typeof a == "number" && (i.maxItems = a), i.type = "array", i.items = it(o.element, t, {
    ...n,
    path: [...n.path, "items"]
  });
};
function zo(e) {
  const t = e._zod.def;
  return t.type === "pipe" && t.in._zod.traits.has("$ZodTransform") ? zo(t.out) : t.type === "catch" ? zo(t.innerType) : e._zod.optin;
}
const Q_ = (e, t, r, n) => {
  var f;
  const i = r, o = e._zod.def, s = o.shape;
  if (Object.getOwnPropertySymbols(s).length && or(e, t, i, n, "Symbol keys cannot be represented in JSON Schema"))
    return;
  i.type = "object", i.properties = {};
  for (const u in s)
    Fr(i.properties, u, it(s[u], t, {
      ...n,
      path: [...n.path, "properties", u]
    }));
  const l = [];
  for (const u of Object.keys(s)) {
    const h = o.shape[u];
    (t.io === "input" ? zo(h) === void 0 : h._zod.optout === void 0) && l.push(u);
  }
  l.length > 0 && (i.required = l), ((f = o.catchall) == null ? void 0 : f._zod.def.type) === "never" ? i.additionalProperties = !1 : o.catchall ? o.catchall && (i.additionalProperties = it(o.catchall, t, {
    ...n,
    path: [...n.path, "additionalProperties"]
  })) : t.io === "output" && (i.additionalProperties = !1);
}, eR = (e, t, r, n) => {
  const i = e._zod.def, o = i.inclusive === !1, s = i.options.map((a, l) => it(a, t, {
    ...n,
    path: [...n.path, o ? "oneOf" : "anyOf", l]
  }));
  o ? r.oneOf = s : r.anyOf = s;
}, tR = (e, t, r, n) => {
  const i = e._zod.def, o = it(i.left, t, {
    ...n,
    path: [...n.path, "allOf", 0]
  }), s = it(i.right, t, {
    ...n,
    path: [...n.path, "allOf", 1]
  }), a = (f) => "allOf" in f && Object.keys(f).length === 1, l = [
    ...a(o) ? o.allOf : [o],
    ...a(s) ? s.allOf : [s]
  ];
  r.allOf = l, t.intersections.push(l);
}, rR = (e, t, r, n) => {
  const i = r, o = e._zod.def;
  i.type = "array";
  const s = t.target === "draft-2020-12" ? "prefixItems" : "items", a = t.target === "draft-2020-12" || t.target === "openapi-3.0" ? "items" : "additionalItems", l = o.items.map((y, b) => it(y, t, {
    ...n,
    path: [...n.path, s, b]
  })), f = o.rest ? it(o.rest, t, {
    ...n,
    path: [...n.path, a, ...t.target === "openapi-3.0" ? [o.items.length] : []]
  }) : null;
  let u = o.items.length;
  for (; u > 0; ) {
    const y = o.items[u - 1];
    if (!(t.io === "input" ? zo(y) !== void 0 : y._zod.optout === "optional"))
      break;
    u--;
  }
  const h = o.items.length, E = !o.rest;
  t.target === "draft-2020-12" ? (i.prefixItems = l, E ? i.items = !1 : f && (i.items = f), u > 0 && (i.minItems = u), E && (i.maxItems = h)) : t.target === "openapi-3.0" ? (i.items = {
    anyOf: l
  }, f && i.items.anyOf.push(f), u > 0 && (i.minItems = u), E && (i.maxItems = h)) : (i.items = l, E ? i.additionalItems = !1 : f && (i.additionalItems = f), u > 0 && (i.minItems = u), E && (i.maxItems = h));
  const { minimum: d, maximum: g } = Ct(e);
  typeof d == "number" && (i.minItems = d), typeof g == "number" && (i.maxItems = g);
};
function Bu(e, t, r) {
  var g;
  if (t.$ref) {
    if (r.has(t))
      return t;
    r.add(t);
    const y = (g = e.get(t)) == null ? void 0 : g.def;
    if (!y)
      return t;
    const b = Bu(e, y, r);
    return b === y ? t : b;
  }
  for (const y of ["anyOf", "oneOf"]) {
    const b = t[y];
    if (!Array.isArray(b))
      continue;
    const _ = b.map((I) => Bu(e, I, r));
    _.some((I, w) => I !== b[w]) && (t = { ...t, [y]: _ });
  }
  const n = Array.isArray(t.type) ? t.type : [t.type], i = !n.includes("string") && n.some((y) => y === "number" || y === "integer"), o = t.enum ?? (t.const !== void 0 ? [t.const] : void 0);
  if (!i && !(o != null && o.some((y) => typeof y == "number")))
    return t;
  const { minimum: s, maximum: a, exclusiveMinimum: l, exclusiveMaximum: f, multipleOf: u, format: h, id: E, ...d } = t;
  return d.enum ? d.enum = d.enum.map((y) => typeof y == "number" ? String(y) : y) : typeof d.const == "number" && (d.const = String(d.const)), i && (d.type = "string", o || (d.pattern = (n.includes("number") ? ia : $v).source)), d;
}
const Vu = /* @__PURE__ */ new WeakMap();
function nR(e) {
  var n;
  const t = /* @__PURE__ */ new Map();
  for (const i of e.seen.values())
    i.def && !t.has(i.schema) && t.set(i.schema, i);
  const r = /* @__PURE__ */ new Map();
  for (const i of Vu.get(e) ?? []) {
    const o = e.seen.get(i), s = (n = (o == null ? void 0 : o.def) ?? (o == null ? void 0 : o.schema)) == null ? void 0 : n.propertyNames;
    if (!s || s === !0 || r.has(s))
      continue;
    const a = Bu(t, s, /* @__PURE__ */ new Set());
    a !== s && r.set(s, a);
  }
  if (r.size)
    for (const i of e.seen.values())
      for (const o of [i.schema, i.def]) {
        const s = o && r.get(o.propertyNames);
        s && (o.propertyNames = s);
      }
}
const iR = (e, t, r, n) => {
  const i = r, o = e._zod.def;
  i.type = "object";
  const s = o.keyType, a = Ct(s).patterns;
  if (o.mode === "loose" && a && a.size > 0) {
    const u = it(o.valueType, t, {
      ...n,
      path: [...n.path, "patternProperties", "*"]
    });
    i.patternProperties = {};
    for (const h of a)
      Fr(i.patternProperties, ly(h).source, u);
  } else {
    if (t.target === "draft-07" || t.target === "draft-2020-12") {
      i.propertyNames = it(o.keyType, t, {
        ...n,
        path: [...n.path, "propertyNames"]
      });
      let u = Vu.get(t);
      u || (u = [], Vu.set(t, u), t.deferred.push(() => nR(t))), u.push(e);
    }
    i.additionalProperties = it(o.valueType, t, {
      ...n,
      path: [...n.path, "additionalProperties"]
    });
  }
  const l = s._zod.values, f = t.io === "input" && zo(o.valueType) !== void 0;
  if (l && !o.partial && !f) {
    const u = [...l].filter((h) => typeof h == "string" || typeof h == "number");
    u.length > 0 && (i.required = u.map(String));
  }
}, oR = (e, t, r, n) => {
  const i = e._zod.def, o = it(i.innerType, t, n), s = t.seen.get(e);
  t.target === "openapi-3.0" ? (s.ref = i.innerType, r.nullable = !0) : r.anyOf = [o, { type: "null" }];
}, sR = (e, t, r, n) => {
  const i = e._zod.def;
  it(i.innerType, t, n);
  const o = t.seen.get(e);
  o.ref = i.innerType;
}, Hl = Symbol();
function cy(e, t, r, n, i) {
  let o = !1;
  const s = JSON.stringify(e, (a, l) => typeof l != "bigint" ? l : (o = !0, null));
  return o ? (or(t, r, n, i, "BigInt defaults cannot be represented in JSON Schema"), Hl) : JSON.parse(s);
}
const aR = (e, t, r, n) => {
  const i = e._zod.def;
  it(i.innerType, t, n);
  const o = t.seen.get(e);
  o.ref = i.innerType;
  const s = cy(i.defaultValue, e, t, r, n);
  s !== Hl && (r.default = s);
}, uR = (e, t, r, n) => {
  const i = e._zod.def;
  it(i.innerType, t, n);
  const o = t.seen.get(e);
  if (o.ref = i.innerType, t.io !== "input")
    return;
  const s = cy(i.defaultValue, e, t, r, n);
  s !== Hl && (r._prefault = s);
}, lR = (e, t, r, n) => {
  const i = e._zod.def;
  it(i.innerType, t, n);
  const o = t.seen.get(e);
  o.ref = i.innerType;
  let s;
  try {
    s = i.catchValue(void 0);
  } catch {
    or(e, t, r, n, "Dynamic catch values are not supported in JSON Schema");
    return;
  }
  r.default = s;
}, cR = (e, t, r, n) => {
  const i = e._zod.def, o = i.in._zod.traits.has("$ZodTransform"), s = t.io === "input" ? o ? i.out : i.in : i.out;
  it(s, t, n);
  const a = t.seen.get(e);
  a.ref = s;
}, fR = (e, t, r, n) => {
  const i = e._zod.def;
  it(i.innerType, t, n);
  const o = t.seen.get(e);
  o.ref = i.innerType, r.readOnly = !0;
}, fy = (e, t, r, n) => {
  const i = e._zod.def;
  it(i.innerType, t, n);
  const o = t.seen.get(e);
  o.ref = i.innerType;
};
let Ga = !1;
_t.postProcessor = (e) => {
  var n;
  if (Ga)
    return;
  const t = (n = e._zod) == null ? void 0 : n.run;
  if (typeof t != "function")
    return;
  const r = (i, o) => {
    if (o != null && o.async || (o == null ? void 0 : o.direction) === "backward" || o != null && o.skipChecks)
      return t(i, o);
    Ga = !0;
    try {
      if (_t.jitless)
        return e._zod.run = t, t(i, o);
      const s = k0(e, { strict: !0 });
      e._zod.run = s._zod.run, e._zod.bag.fallbackRun = s._zod.bag.fallbackRun, e._zod.bag.validator = s._zod.bag.validator;
    } catch {
      e._zod.run = t;
    } finally {
      Ga = !1;
    }
    return e._zod.run(i, o);
  };
  r.__originalRun = t, e._zod.run = r;
};
const ed = /* @__PURE__ */ new WeakSet([Object.prototype, Error.prototype]);
function us(e, t, r) {
  Object.defineProperty(e, t, {
    configurable: !0,
    enumerable: !1,
    get() {
      const n = r(this);
      return Object.defineProperty(this, t, { value: n, configurable: !0, writable: !0 }), n;
    },
    set(n) {
      Object.defineProperty(this, t, { value: n, configurable: !0, writable: !0 });
    }
  });
}
const dR = (e, t) => {
  lS.init(e, t), e.name = "ZodError";
  const r = Object.getPrototypeOf(e);
  ed.has(r) || (ed.add(r), us(r, "format", (n) => (i) => dS(n, i)), us(r, "flatten", (n) => (i) => fS(n, i)), us(r, "addIssue", (n) => (i) => {
    n.issues.push(i), n.message = JSON.stringify(n.issues, Mu, 2);
  }), us(r, "addIssues", (n) => (i) => {
    n.issues.push(...i), n.message = JSON.stringify(n.issues, Mu, 2);
  }), Object.defineProperty(r, "isEmpty", {
    configurable: !0,
    enumerable: !1,
    get() {
      return this.issues.length === 0;
    }
  }));
}, Jt = /* @__PURE__ */ Y("ZodError", dR, void 0, {
  Parent: Error
}), pR = /* @__PURE__ */ xl(Jt), hR = /* @__PURE__ */ kl(Jt), mR = /* @__PURE__ */ jl(Jt), ER = /* @__PURE__ */ Ul(Jt), gR = /* @__PURE__ */ yS(Jt), yR = /* @__PURE__ */ TS(Jt), TR = /* @__PURE__ */ bS(Jt), bR = /* @__PURE__ */ AS(Jt), AR = /* @__PURE__ */ vS(Jt), vR = /* @__PURE__ */ SS(Jt), SR = /* @__PURE__ */ IS(Jt), IR = /* @__PURE__ */ _S(Jt);
function _R() {
  _t.localeError || qt(jI());
}
function Mi() {
  _t.memoizer || qt({ memoizer: fv() });
}
const qe = /* @__PURE__ */ Y("ZodType", (e, t) => (_R(), Ve.init(e, t), e.def = t, e.type = t.type, e), {
  check(...e) {
    const t = this.def;
    return this.clone(kt(t, {
      checks: [
        ...t.checks ?? [],
        ...e.map((r) => typeof r == "function" ? { _zod: { check: r, def: { check: "custom" }, onattach: [] } } : r)
      ]
    }), { parent: !0 });
  },
  with(...e) {
    return this.check(...e);
  },
  clone(e, t) {
    return Gr(this, e, t);
  },
  brand() {
    return this;
  },
  register(e, t) {
    return e.add(this, t), this;
  },
  refine(e, t) {
    return this.check(vO(e, t));
  },
  superRefine(e, t) {
    return this.check(SO(e, t));
  },
  overwrite(e) {
    return this.check(/* @__PURE__ */ Di(e));
  },
  optional() {
    return td(this);
  },
  exactOptional() {
    return lO(this);
  },
  nullable() {
    return rd(this);
  },
  nullish() {
    return td(rd(this));
  },
  nonoptional(e) {
    return mO(this, e);
  },
  array() {
    return k(this);
  },
  or(e) {
    return St([this, e]);
  },
  and(e) {
    return iO(this, e);
  },
  transform(e) {
    return nd(this, gy(e));
  },
  default(e) {
    return dO(this, e);
  },
  prefault(e) {
    return hO(this, e);
  },
  catch(e) {
    return gO(this, e);
  },
  pipe(e) {
    return nd(this, e);
  },
  readonly() {
    return bO(this);
  },
  describe(e) {
    const t = this.clone();
    return Mo.add(t, { description: e }), t;
  },
  meta(...e) {
    if (e.length === 0)
      return Mo.get(this);
    const t = this.clone();
    return Mo.add(t, e[0]), t;
  },
  isOptional() {
    return this.safeParse(void 0).success;
  },
  isNullable() {
    return this.safeParse(null).success;
  },
  apply(e, ...t) {
    return t.length === 0 ? e(this) : e(this, ...t);
  },
  // Overrides core's `~standard` to add `jsonSchema`. Must stay a prototype entry: redefining it per instance demotes instances to dictionary mode.
  get "~standard"() {
    return gg(this, "~standard", {
      ...Cg(this),
      jsonSchema: {
        input: ks(this, "input"),
        output: ks(this, "output")
      }
    });
  },
  set "~standard"(e) {
    Qr(this, "~standard", e);
  },
  parse: function e(t, r) {
    return pR(this, t, r, { callee: e });
  },
  parseAsync: async function e(t, r) {
    return await hR(this, t, r, { callee: e });
  },
  safeParse(e, t) {
    return mR(this, e, t);
  },
  async safeParseAsync(e, t) {
    return ER(this, e, t);
  },
  // `spa` is an alias: same function object as `safeParseAsync`, as before.
  get spa() {
    return this == null ? void 0 : this.safeParseAsync;
  },
  set spa(e) {
    Qr(this, "spa", e);
  },
  validate(e, t) {
    return mS(this, e, t);
  },
  validateAsync(e, t) {
    return gS(this, e, t);
  },
  encode: function e(t, r) {
    return gR(this, t, r, { callee: e });
  },
  decode: function e(t, r) {
    return yR(this, t, r, { callee: e });
  },
  encodeAsync: async function e(t, r) {
    return await TR(this, t, r, { callee: e });
  },
  decodeAsync: async function e(t, r) {
    return await bR(this, t, r, { callee: e });
  },
  safeEncode(e, t) {
    return AR(this, e, t);
  },
  safeDecode(e, t) {
    return vR(this, e, t);
  },
  async safeEncodeAsync(e, t) {
    return SR(this, e, t);
  },
  async safeDecodeAsync(e, t) {
    return IR(this, e, t);
  },
  toJSONSchema(e) {
    return j_(this, {})(e);
  },
  // Reads through to the registry on every access, so it must not cache.
  get description() {
    var e;
    return (e = Mo.get(this)) == null ? void 0 : e.description;
  },
  // No setter: `schema._def = x` throws, as it did when `_def` was a non-writable own property.
  get _def() {
    return this._zod.def;
  }
}), dy = /* @__PURE__ */ Y(
  "_ZodString",
  (e, t) => {
    $l.init(e, t), qe.init(e, t), e._zod.processJSONSchema = (r, n, i) => F_(e, r, n);
  },
  /* @__PURE__ */ Dl({
    format: (e) => Ct(e).format ?? null,
    minLength: (e) => Ct(e).minimum ?? null,
    maxLength: (e) => Ct(e).maximum ?? null
  }, {
    regex(...e) {
      return this.check(/* @__PURE__ */ A_(...e));
    },
    includes(...e) {
      return this.check(/* @__PURE__ */ I_(...e));
    },
    startsWith(...e) {
      return this.check(/* @__PURE__ */ __(...e));
    },
    endsWith(...e) {
      return this.check(/* @__PURE__ */ R_(...e));
    },
    min(...e) {
      return this.check(/* @__PURE__ */ xs(...e));
    },
    max(...e) {
      return this.check(/* @__PURE__ */ Xg(...e));
    },
    length(...e) {
      return this.check(/* @__PURE__ */ Qg(...e));
    },
    nonempty(...e) {
      return this.check(/* @__PURE__ */ xs(1, ...e));
    },
    lowercase(e) {
      return this.check(/* @__PURE__ */ v_(e));
    },
    uppercase(e) {
      return this.check(/* @__PURE__ */ S_(e));
    },
    trim() {
      return this.check(/* @__PURE__ */ w_());
    },
    normalize(...e) {
      return this.check(/* @__PURE__ */ O_(...e));
    },
    toLowerCase() {
      return this.check(/* @__PURE__ */ N_());
    },
    toUpperCase() {
      return this.check(/* @__PURE__ */ C_());
    },
    slugify() {
      return this.check(/* @__PURE__ */ P_());
    }
  })
), RR = /* @__PURE__ */ Y("ZodString", (e, t) => {
  $l.init(e, t), dy.init(e, t);
}, {
  email(e) {
    return this.check(/* @__PURE__ */ GI(CR, e));
  },
  url(e) {
    return this.check(/* @__PURE__ */ HI(DR, e));
  },
  jwt(e) {
    return this.check(/* @__PURE__ */ Jg(hy, e));
  },
  emoji(e) {
    return this.check(/* @__PURE__ */ YI(MR, e));
  },
  guid(e) {
    return this.check(/* @__PURE__ */ zI(PR, e));
  },
  uuid(e) {
    return this.check(/* @__PURE__ */ BI(ls, e));
  },
  uuidv4(e) {
    return this.check(/* @__PURE__ */ VI(ls, e));
  },
  uuidv6(e) {
    return this.check(/* @__PURE__ */ WI(ls, e));
  },
  uuidv7(e) {
    return this.check(/* @__PURE__ */ qI(ls, e));
  },
  nanoid(e) {
    return this.check(/* @__PURE__ */ ZI(LR, e));
  },
  cuid(e) {
    return this.check(/* @__PURE__ */ JI(xR, e));
  },
  cuid2(e) {
    return this.check(/* @__PURE__ */ KI(kR, e));
  },
  ulid(e) {
    return this.check(/* @__PURE__ */ XI(jR, e));
  },
  base64(e) {
    return this.check(/* @__PURE__ */ o_(VR, e));
  },
  base64url(e) {
    return this.check(/* @__PURE__ */ s_(WR, e));
  },
  xid(e) {
    return this.check(/* @__PURE__ */ QI(UR, e));
  },
  ksuid(e) {
    return this.check(/* @__PURE__ */ e_($R, e));
  },
  ipv4(e) {
    return this.check(/* @__PURE__ */ t_(FR, e));
  },
  ipv6(e) {
    return this.check(/* @__PURE__ */ r_(GR, e));
  },
  cidrv4(e) {
    return this.check(/* @__PURE__ */ n_(zR, e));
  },
  cidrv6(e) {
    return this.check(/* @__PURE__ */ i_(BR, e));
  },
  e164(e) {
    return this.check(/* @__PURE__ */ a_(qR, e));
  },
  datetime(e) {
    return this.check(/* @__PURE__ */ Kg(py, e));
  },
  date(e) {
    return this.check(/* @__PURE__ */ u_(OR, e));
  },
  time(e) {
    return this.check(/* @__PURE__ */ l_(wR, e));
  },
  duration(e) {
    return this.check(/* @__PURE__ */ c_(NR, e));
  }
});
function A(e) {
  return /* @__PURE__ */ FI(RR, e);
}
const tt = /* @__PURE__ */ Y("ZodStringFormat", (e, t) => {
  Qe.init(e, t), dy.init(e, t);
}), py = /* @__PURE__ */ Y("ZodISODateTime", (e, t) => {
  GS.init(e, t), tt.init(e, t);
}), OR = /* @__PURE__ */ Y("ZodISODate", (e, t) => {
  zS.init(e, t), tt.init(e, t);
}), wR = /* @__PURE__ */ Y("ZodISOTime", (e, t) => {
  BS.init(e, t), tt.init(e, t);
}), NR = /* @__PURE__ */ Y("ZodISODuration", (e, t) => {
  VS.init(e, t), tt.init(e, t);
}), CR = /* @__PURE__ */ Y("ZodEmail", (e, t) => {
  CS.init(e, t), tt.init(e, t);
}), PR = /* @__PURE__ */ Y("ZodGUID", (e, t) => {
  wS.init(e, t), tt.init(e, t);
}), ls = /* @__PURE__ */ Y("ZodUUID", (e, t) => {
  NS.init(e, t), tt.init(e, t);
}), DR = /* @__PURE__ */ Y("ZodURL", (e, t) => {
  MS.init(e, t), tt.init(e, t);
}), MR = /* @__PURE__ */ Y("ZodEmoji", (e, t) => {
  LS.init(e, t), tt.init(e, t);
}), LR = /* @__PURE__ */ Y("ZodNanoID", (e, t) => {
  xS.init(e, t), tt.init(e, t);
}), xR = /* @__PURE__ */ Y("ZodCUID", (e, t) => {
  kS.init(e, t), tt.init(e, t);
}), kR = /* @__PURE__ */ Y("ZodCUID2", (e, t) => {
  jS.init(e, t), tt.init(e, t);
}), jR = /* @__PURE__ */ Y("ZodULID", (e, t) => {
  US.init(e, t), tt.init(e, t);
}), UR = /* @__PURE__ */ Y("ZodXID", (e, t) => {
  $S.init(e, t), tt.init(e, t);
}), $R = /* @__PURE__ */ Y("ZodKSUID", (e, t) => {
  FS.init(e, t), tt.init(e, t);
}), FR = /* @__PURE__ */ Y("ZodIPv4", (e, t) => {
  WS.init(e, t), tt.init(e, t);
}), GR = /* @__PURE__ */ Y("ZodIPv6", (e, t) => {
  HS.init(e, t), tt.init(e, t);
}), zR = /* @__PURE__ */ Y("ZodCIDRv4", (e, t) => {
  YS.init(e, t), tt.init(e, t);
}), BR = /* @__PURE__ */ Y("ZodCIDRv6", (e, t) => {
  ZS.init(e, t), tt.init(e, t);
}), VR = /* @__PURE__ */ Y("ZodBase64", (e, t) => {
  JS.init(e, t), tt.init(e, t);
}), WR = /* @__PURE__ */ Y("ZodBase64URL", (e, t) => {
  KS.init(e, t), tt.init(e, t);
}), qR = /* @__PURE__ */ Y("ZodE164", (e, t) => {
  XS.init(e, t), tt.init(e, t);
}), hy = /* @__PURE__ */ Y("ZodJWT", (e, t) => {
  i0.init(e, t), tt.init(e, t);
});
function HR(e) {
  return /* @__PURE__ */ Jg(hy, e);
}
const Yl = /* @__PURE__ */ Y(
  "ZodNumber",
  (e, t) => {
    Fg.init(e, t), qe.init(e, t), e._zod.processJSONSchema = (r, n, i) => G_(e, r, n, i), e.isFinite = !0;
  },
  /* @__PURE__ */ Dl({
    minValue: (e) => {
      const { minimum: t, exclusiveMinimum: r } = Ct(e);
      return Math.max(t ?? Number.NEGATIVE_INFINITY, r ?? Number.NEGATIVE_INFINITY);
    },
    maxValue: (e) => {
      const { maximum: t, exclusiveMaximum: r } = Ct(e);
      return Math.min(t ?? Number.POSITIVE_INFINITY, r ?? Number.POSITIVE_INFINITY);
    },
    isInt: (e) => {
      const { isInt: t, multipleOf: r } = Ct(e);
      return !!t || !!(r != null && r.some(Number.isSafeInteger));
    },
    format: (e) => Ct(e).format ?? null
  }, {
    gt(e, t) {
      return this.check(/* @__PURE__ */ Vf(e, t));
    },
    gte(e, t) {
      return this.check(/* @__PURE__ */ _s(e, t));
    },
    min(e, t) {
      return this.check(/* @__PURE__ */ _s(e, t));
    },
    lt(e, t) {
      return this.check(/* @__PURE__ */ Bf(e, t));
    },
    lte(e, t) {
      return this.check(/* @__PURE__ */ Is(e, t));
    },
    max(e, t) {
      return this.check(/* @__PURE__ */ Is(e, t));
    },
    int(e) {
      return this.check(Wu(e));
    },
    safe(e) {
      return this.check(Wu(e));
    },
    positive(e) {
      return this.check(/* @__PURE__ */ Vf(0, e));
    },
    nonnegative(e) {
      return this.check(/* @__PURE__ */ _s(0, e));
    },
    negative(e) {
      return this.check(/* @__PURE__ */ Bf(0, e));
    },
    nonpositive(e) {
      return this.check(/* @__PURE__ */ Is(0, e));
    },
    multipleOf(e, t) {
      return this.check(/* @__PURE__ */ Wf(e, t));
    },
    step(e, t) {
      return this.check(/* @__PURE__ */ Wf(e, t));
    },
    finite() {
      return this;
    }
  })
);
function v(e) {
  return /* @__PURE__ */ f_(Yl, e);
}
const YR = /* @__PURE__ */ Y("ZodNumberFormat", (e, t) => {
  o0.init(e, t), Yl.init(e, t);
});
function Wu(e) {
  return /* @__PURE__ */ p_(YR, e);
}
const ZR = /* @__PURE__ */ Y("ZodBoolean", (e, t) => {
  s0.init(e, t), qe.init(e, t), e._zod.processJSONSchema = (r, n, i) => z_(e, r, n);
});
function ie(e) {
  return /* @__PURE__ */ h_(ZR, e);
}
const JR = /* @__PURE__ */ Y("ZodUndefined", (e, t) => {
  a0.init(e, t), qe.init(e, t), e._zod.processJSONSchema = (r, n, i) => B_(e, r, n, i);
});
function Xr(e) {
  return /* @__PURE__ */ m_(JR, e);
}
const KR = /* @__PURE__ */ Y("ZodUnknown", (e, t) => {
  u0.init(e, t), qe.init(e, t), e._zod.processJSONSchema = (r, n, i) => W_();
});
function lt() {
  return /* @__PURE__ */ E_(KR);
}
const XR = /* @__PURE__ */ Y("ZodNever", (e, t) => {
  l0.init(e, t), qe.init(e, t), e._zod.processJSONSchema = (r, n, i) => V_(e, r, n);
});
function QR(e) {
  return /* @__PURE__ */ g_(XR, e);
}
const eO = /* @__PURE__ */ Y(
  "ZodDate",
  (e, t) => {
    c0.init(e, t), qe.init(e, t), e._zod.processJSONSchema = (r, n, i) => q_(e, r, n, i), e.min = (r, n) => e.check(/* @__PURE__ */ _s(r, n)), e.max = (r, n) => e.check(/* @__PURE__ */ Is(r, n));
  },
  /* @__PURE__ */ Dl({
    minDate: (e) => {
      const { minimum: t } = Ct(e);
      return t ? new Date(t) : null;
    },
    maxDate: (e) => {
      const { maximum: t } = Ct(e);
      return t ? new Date(t) : null;
    }
  }, {})
), tO = /* @__PURE__ */ Y("ZodArray", (e, t) => {
  Mi(), p0.init(e, t), qe.init(e, t), e._zod.processJSONSchema = (r, n, i) => X_(e, r, n, i), e.element = t.element;
}, {
  min(e, t) {
    return this.check(/* @__PURE__ */ xs(e, t));
  },
  nonempty(e) {
    return this.check(/* @__PURE__ */ xs(1, e));
  },
  max(e, t) {
    return this.check(/* @__PURE__ */ Xg(e, t));
  },
  length(e, t) {
    return this.check(/* @__PURE__ */ Qg(e, t));
  },
  unwrap() {
    return this.element;
  }
});
function k(e, t) {
  return /* @__PURE__ */ D_(tO, e, t);
}
const my = /* @__PURE__ */ Y("ZodObject", (e, t) => {
  Mi(), E0.init(e, t), qe.init(e, t), e._zod.processJSONSchema = (r, n, i) => Q_(e, r, n, i), iv(e, "shape", (r) => r._zod.def.shape, !1);
}, {
  keyof() {
    return pe(Object.keys(this._zod.def.shape));
  },
  catchall(e) {
    return this.clone(kt(this._zod.def, { catchall: e }));
  },
  passthrough() {
    return this.clone(kt(this._zod.def, { catchall: lt() }));
  },
  loose() {
    return this.clone(kt(this._zod.def, { catchall: lt() }));
  },
  strict() {
    return this.clone(kt(this._zod.def, { catchall: QR() }));
  },
  strip() {
    return this.clone(kt(this._zod.def, { catchall: void 0 }));
  },
  extend(e) {
    return HA(this, e);
  },
  safeExtend(e) {
    return YA(this, e);
  },
  merge(e) {
    return ZA(this, e);
  },
  pick(e) {
    return WA(this, e);
  },
  omit(e) {
    return qA(this, e);
  },
  partial(...e) {
    return yf(Jl, this, e[0]);
  },
  exactPartial(...e) {
    return yf(yy, this, e[0], "exactPartial");
  },
  required(...e) {
    return JA(Ty, this, e[0]);
  }
});
function N(e, t) {
  const r = {
    type: "object",
    shape: e ?? {},
    ...se(t)
  };
  return new my(r);
}
function rn(e, t) {
  return new my({
    type: "object",
    shape: e,
    catchall: lt(),
    ...se(t)
  });
}
const Ey = /* @__PURE__ */ Y("ZodUnion", (e, t) => {
  Vg.init(e, t), qe.init(e, t), e._zod.processJSONSchema = (r, n, i) => eR(e, r, n, i), e.options = t.options;
});
function St(e, t) {
  return new Ey({
    type: "union",
    options: e,
    ...se(t)
  });
}
const rO = /* @__PURE__ */ Y("ZodDiscriminatedUnion", (e, t) => {
  Ey.init(e, t), y0.init(e, t);
});
function hr(e, t, r) {
  return new rO({
    type: "union",
    options: t,
    discriminator: e,
    ...se(r)
  });
}
const nO = /* @__PURE__ */ Y("ZodIntersection", (e, t) => {
  T0.init(e, t), qe.init(e, t), e._zod.processJSONSchema = (r, n, i) => tR(e, r, n, i);
});
function iO(e, t) {
  return new nO({
    type: "intersection",
    left: e,
    right: t
  });
}
const oO = /* @__PURE__ */ Y("ZodTuple", (e, t) => {
  Mi(), b0.init(e, t), qe.init(e, t), e._zod.processJSONSchema = (r, n, i) => rR(e, r, n, i);
}, {
  rest(e) {
    return this.clone({
      ...this._zod.def,
      rest: e
    });
  },
  partial() {
    var t;
    const e = this._zod.def;
    if ((t = e.checks) != null && t.length)
      throw new Error(".partial() cannot be used on tuple schemas containing refinements");
    return this.clone({
      ...e,
      items: e.items.map((r) => new Jl({ type: "optional", innerType: r }))
    });
  }
});
function Zl(e, t, r) {
  const n = t instanceof Ve, i = n ? r : t, o = n ? t : null;
  return new oO({
    type: "tuple",
    items: e,
    rest: o,
    ...se(i)
  });
}
const qu = /* @__PURE__ */ Y("ZodRecord", (e, t) => {
  Mi(), A0.init(e, t), qe.init(e, t), e._zod.processJSONSchema = (r, n, i) => iR(e, r, n, i), e.keyType = t.keyType, e.valueType = t.valueType;
});
function jt(e, t, r) {
  return !t || !t._zod ? new qu({
    type: "record",
    keyType: A(),
    valueType: e,
    ...se(t)
  }) : new qu({
    type: "record",
    keyType: e,
    valueType: t,
    ...se(r)
  });
}
function ht(e, t, r) {
  return new qu({
    type: "record",
    keyType: e,
    valueType: t,
    ...se(r),
    partial: !0
  });
}
const sO = /* @__PURE__ */ Y("ZodMap", (e, t) => {
  Mi(), v0.init(e, t), qe.init(e, t), e._zod.processJSONSchema = (r, n, i) => K_(e, r, n, i), e.keyType = t.keyType, e.valueType = t.valueType, e.min = (...r) => e.check(/* @__PURE__ */ qf(...r)), e.nonempty = (r) => e.check(/* @__PURE__ */ qf(1, r)), e.max = (...r) => e.check(/* @__PURE__ */ T_(...r)), e.size = (...r) => e.check(/* @__PURE__ */ b_(...r));
});
function za(e, t, r) {
  return new sO({
    type: "map",
    keyType: e,
    valueType: t,
    ...se(r)
  });
}
const Hu = /* @__PURE__ */ Y("ZodEnum", (e, t) => {
  S0.init(e, t), qe.init(e, t), e._zod.processJSONSchema = (n, i, o) => H_(e, n, i), e.enum = t.entries, e.options = [...e._zod.values];
  const r = new Set(Object.keys(t.entries));
  e.extract = (n, i) => {
    const o = {};
    for (const s of n)
      if (r.has(s))
        o[s] = t.entries[s];
      else
        throw new Error(`Key ${s} not found in enum`);
    return new Hu({
      ...t,
      checks: [],
      ...se(i),
      entries: o
    });
  }, e.exclude = (n, i) => {
    const o = { ...t.entries };
    for (const s of n)
      if (r.has(s))
        delete o[s];
      else
        throw new Error(`Key ${s} not found in enum`);
    return new Hu({
      ...t,
      checks: [],
      ...se(i),
      entries: o
    });
  };
});
function pe(e, t) {
  const r = Array.isArray(e) ? Object.fromEntries(e.map((n) => [n, n])) : e;
  return new Hu({
    type: "enum",
    entries: r,
    ...se(t)
  });
}
const aO = /* @__PURE__ */ Y("ZodLiteral", (e, t) => {
  I0.init(e, t), qe.init(e, t), e._zod.processJSONSchema = (r, n, i) => Y_(e, r, n, i), e.values = new Set(t.values), Object.defineProperty(e, "value", {
    get() {
      if (t.values.length > 1)
        throw new Error("This schema contains multiple valid literal values. Use `.values` instead.");
      return t.values[0];
    }
  });
});
function fe(e, t) {
  return new aO({
    type: "literal",
    values: Array.isArray(e) ? e : [e],
    ...se(t)
  });
}
const uO = /* @__PURE__ */ Y("ZodTransform", (e, t) => {
  Mi(), _0.init(e, t), qe.init(e, t), e._zod.processJSONSchema = (r, n, i) => J_(e, r, n, i), e._zod.parse = (r, n) => {
    if (n.direction === "backward")
      throw new Tg(e.constructor.name);
    r.addIssue = (o) => {
      if (typeof o == "string")
        r.issues.push(Go(o, r.value, t));
      else {
        const s = o;
        s.fatal && (s.continue = !1), s.code ?? (s.code = "custom"), "input" in s || (s.input = r.value), s.inst ?? (s.inst = e), r.issues.push(Go(s));
      }
    };
    const i = t.transform(r.value, r);
    return i instanceof Promise ? i.then((o) => (r.value = o, r)) : (r.value = i, r);
  };
});
function gy(e) {
  return new uO({
    type: "transform",
    transform: e
  });
}
const Jl = /* @__PURE__ */ Y("ZodOptional", (e, t) => {
  Wg.init(e, t), qe.init(e, t), e._zod.processJSONSchema = (r, n, i) => fy(e, r, n, i), e.unwrap = () => e._zod.def.innerType;
});
function td(e) {
  return new Jl({
    type: "optional",
    innerType: e
  });
}
const yy = /* @__PURE__ */ Y("ZodExactOptional", (e, t) => {
  R0.init(e, t), qe.init(e, t), e._zod.processJSONSchema = (r, n, i) => fy(e, r, n, i), e.unwrap = () => e._zod.def.innerType;
});
function lO(e) {
  return new yy({
    type: "optional",
    innerType: e
  });
}
const cO = /* @__PURE__ */ Y("ZodNullable", (e, t) => {
  O0.init(e, t), qe.init(e, t), e._zod.processJSONSchema = (r, n, i) => oR(e, r, n, i), e.unwrap = () => e._zod.def.innerType;
});
function rd(e) {
  return new cO({
    type: "nullable",
    innerType: e
  });
}
const fO = /* @__PURE__ */ Y("ZodDefault", (e, t) => {
  w0.init(e, t), qe.init(e, t), e._zod.processJSONSchema = (r, n, i) => aR(e, r, n, i), e.unwrap = () => e._zod.def.innerType, e.removeDefault = e.unwrap;
});
function dO(e, t) {
  return new fO({
    type: "default",
    innerType: e,
    get defaultValue() {
      return typeof t == "function" ? t() : Nl(t);
    }
  });
}
const pO = /* @__PURE__ */ Y("ZodPrefault", (e, t) => {
  N0.init(e, t), qe.init(e, t), e._zod.processJSONSchema = (r, n, i) => uR(e, r, n, i), e.unwrap = () => e._zod.def.innerType;
});
function hO(e, t) {
  return new pO({
    type: "prefault",
    innerType: e,
    get defaultValue() {
      return typeof t == "function" ? t() : Nl(t);
    }
  });
}
const Ty = /* @__PURE__ */ Y("ZodNonOptional", (e, t) => {
  C0.init(e, t), qe.init(e, t), e._zod.processJSONSchema = (r, n, i) => sR(e, r, n, i), e.unwrap = () => e._zod.def.innerType;
});
function mO(e, t) {
  return new Ty({
    type: "nonoptional",
    innerType: e,
    ...se(t)
  });
}
const EO = /* @__PURE__ */ Y("ZodCatch", (e, t) => {
  P0.init(e, t), qe.init(e, t), e._zod.processJSONSchema = (r, n, i) => lR(e, r, n, i), e.unwrap = () => e._zod.def.innerType, e.removeCatch = e.unwrap;
});
function gO(e, t) {
  return new EO({
    type: "catch",
    innerType: e,
    catchValue: typeof t == "function" ? t : ov(t)
  });
}
const by = /* @__PURE__ */ Y("ZodPipe", (e, t) => {
  qg.init(e, t), qe.init(e, t), e._zod.processJSONSchema = (r, n, i) => cR(e, r, n, i), e.in = t.in, e.out = t.out;
});
function nd(e, t) {
  return new by({
    type: "pipe",
    in: e,
    out: t
    // ...util.normalizeParams(params),
  });
}
const yO = /* @__PURE__ */ Y("ZodPreprocess", (e, t) => {
  by.init(e, t), D0.init(e, t);
}), TO = /* @__PURE__ */ Y("ZodReadonly", (e, t) => {
  M0.init(e, t), qe.init(e, t), e._zod.processJSONSchema = (r, n, i) => fR(e, r, n, i), e.unwrap = () => e._zod.def.innerType;
});
function bO(e) {
  return new TO({
    type: "readonly",
    innerType: e
  });
}
const AO = /* @__PURE__ */ Y("ZodCustom", (e, t) => {
  L0.init(e, t), qe.init(e, t), e._zod.processJSONSchema = (r, n, i) => Z_(e, r, n, i);
});
function vO(e, t = {}) {
  return /* @__PURE__ */ M_(AO, e, t);
}
function SO(e, t) {
  return /* @__PURE__ */ L_(e, t);
}
function Kl(e, t) {
  return new yO({
    type: "pipe",
    in: gy(e),
    out: t
  });
}
function Xl(e) {
  return /* @__PURE__ */ Kg(py, e);
}
function id(e) {
  return /* @__PURE__ */ d_(Yl, e);
}
function IO(e) {
  return /* @__PURE__ */ y_(eO, e);
}
function Ql(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var ii = {}, oi = {}, $i = {}, ln = {}, od;
function ec() {
  if (od) return ln;
  od = 1, Object.defineProperty(ln, "__esModule", { value: !0 }), ln.APP_ID_TO_NAME_MAP = ln.EAppId = void 0;
  var e;
  return (function(t) {
    t.TE_ACTIVITIES = "TE_ACTIVITIES", t.TE_ADMIN = "TE_ADMIN", t.TE_ALLOCATE = "TE_ALLOCATE", t.TE_ALLOCATE_PREFERENTIAL = "TE_ALLOCATE_PREFERENTIAL", t.TE_ATTENDANCE = "TE_ATTENDANCE", t.TE_AUTOPILOT = "TE_AUTOPILOT", t.TE_CALENDAR_INTEGRATION = "TE_CALENDAR_INTEGRATION", t.TE_CORE = "TE_CORE", t.TE_CURRICULUM = "TE_CURRICULUM", t.TE_DATA_MANAGER = "TE_DATA_MANAGER", t.TE_DEBIT = "TE_DEBIT", t.TE_EVALUATION = "TE_EVALUATION", t.TE_EVENT_BROKER = "TE_EVENT_BROKER", t.TE_EXAM = "TE_EXAM", t.TE_EXAM_V3 = "TE_EXAM_V3", t.TE_FLOW = "TE_FLOW", t.TE_HUB = "TE_HUB", t.TE_INSIGHT = "TE_INSIGHT", t.TE_PLAN = "TE_PLAN", t.TE_PREFERENCES = "TE_PREFERENCES", t.TE_REGISTRATION = "TE_REGISTRATION", t.TE_REPORTING = "TE_REPORTING", t.TE_RESERVE = "TE_RESERVE", t.TE_SEAT_MANAGEMENT = "TE_SEAT_MANAGEMENT", t.TE_STATISTICS = "TE_STATISTICS", t.TE_STUDY_GUIDE = "TE_STUDY_GUIDE", t.TE_STUDY_PLANNER = "TE_STUDY_PLANNER", t.TE_VIEWER = "TE_VIEWER", t.TE_WORKLOAD = "TE_WORKLOAD", t.JAVA_CLIENT = "JAVA_CLIENT", t.TE_AM = "TE_AM", t.TE_PORTAL = "TE_PORTAL", t.TE_MCP = "TE_MCP", t.TE_REST = "TE_REST", t.TE_SERVER_THREAD = "TE_SERVER_THREAD", t.TE_SOAP = "TE_SOAP";
  })(e || (ln.EAppId = e = {})), ln.APP_ID_TO_NAME_MAP = {
    // Products
    [e.TE_ACTIVITIES]: "Activities",
    [e.TE_ADMIN]: "Admin",
    [e.TE_ALLOCATE]: "Allocate",
    [e.TE_ALLOCATE_PREFERENTIAL]: "Allocate Preferential",
    [e.TE_ATTENDANCE]: "Attendance",
    [e.TE_AUTOPILOT]: "Autopilot",
    [e.TE_CALENDAR_INTEGRATION]: "Calendar Integration",
    [e.TE_CORE]: "Core",
    [e.TE_CURRICULUM]: "Curriculum",
    [e.TE_DATA_MANAGER]: "Data Manager",
    [e.TE_DEBIT]: "Debit",
    [e.TE_EVALUATION]: "Evaluation",
    [e.TE_EVENT_BROKER]: "Event Broker",
    [e.TE_EXAM]: "Exam",
    [e.TE_EXAM_V3]: "Assessment",
    [e.TE_FLOW]: "Flow",
    [e.TE_HUB]: "Hub",
    [e.TE_INSIGHT]: "Insight",
    [e.TE_PLAN]: "Plan",
    [e.TE_PREFERENCES]: "Preferences",
    [e.TE_REGISTRATION]: "Registration",
    [e.TE_REPORTING]: "Reporting",
    [e.TE_RESERVE]: "Reserve",
    [e.TE_SEAT_MANAGEMENT]: "Seat Management",
    [e.TE_STATISTICS]: "Statistics",
    [e.TE_STUDY_GUIDE]: "Study Guide",
    [e.TE_STUDY_PLANNER]: "Study Planner",
    [e.TE_VIEWER]: "Viewer",
    [e.TE_WORKLOAD]: "Workload",
    // Supporting apps
    [e.JAVA_CLIENT]: "Java Client",
    [e.TE_AM]: "Activity Manager",
    [e.TE_PORTAL]: "Portal",
    [e.TE_MCP]: "MCP",
    [e.TE_REST]: "REST",
    [e.TE_SERVER_THREAD]: "Server Thread",
    [e.TE_SOAP]: "SOAP"
  }, ln;
}
var sd;
function _O() {
  if (sd) return $i;
  sd = 1, Object.defineProperty($i, "__esModule", { value: !0 }), $i.AppIdsArr = void 0;
  const e = ec();
  return $i.AppIdsArr = Object.values(e.EAppId), $i;
}
var st = {}, cn = {}, ad;
function tc() {
  if (ad) return cn;
  ad = 1, Object.defineProperty(cn, "__esModule", { value: !0 }), cn.EScopeLevel = cn.EPermissionTypes = void 0;
  var e;
  (function(r) {
    r.SCOPE = "SCOPE", r.APP_PERMISSION = "APP_PERMISSION";
  })(e || (cn.EPermissionTypes = e = {}));
  var t;
  return (function(r) {
    r.ADMIN = "ADMIN", r.SUPER = "SUPER";
  })(t || (cn.EScopeLevel = t = {})), cn;
}
var ud;
function Ay() {
  if (ud) return st;
  ud = 1, Object.defineProperty(st, "__esModule", { value: !0 }), st.adminLevelAppPermissions = st.ScopeLevelArr = st.SCOPE_LEVEL_ADMIN = st.SCOPE_LEVEL_SUPER = st.TE_SOAP_SCOPE = st.TE_SERVER_THREAD_SCOPE = st.TE_ROOT_USER = st.SERVICE_ACCOUNT = void 0;
  const e = tc();
  return st.SERVICE_ACCOUNT = "SERVICE_ACCOUNT", st.TE_ROOT_USER = "TE_ROOT_USER", st.TE_SERVER_THREAD_SCOPE = "TE_SERVER_THREAD::user", st.TE_SOAP_SCOPE = "TE_SOAP::user", st.SCOPE_LEVEL_SUPER = e.EScopeLevel.SUPER, st.SCOPE_LEVEL_ADMIN = e.EScopeLevel.ADMIN, st.ScopeLevelArr = [e.EScopeLevel.ADMIN, e.EScopeLevel.SUPER], st.adminLevelAppPermissions = [
    "TE_ADMIN::manageUsers",
    "TE_ADMIN::viewCullingReport",
    "TE_ADMIN::manageObjects",
    "TE_ADMIN::exportObjects",
    "TE_ADMIN::importObjects",
    "TE_ADMIN::manageTimeRules",
    "TE_CORE::activityManager",
    "TE_CORE::noTimeRules",
    "TE_CORE::setOrganizationsOnReservations",
    "TE_CORE::managePeriods",
    "TE_CORE::teExam",
    "TE_CORE::manageViews",
    "TE_RESERVE::noTimeRules",
    "TE_EXAM::supervisor",
    "TE_EXAM::supervisorCoordinator",
    "TE_EXAM::dec",
    "TE_EXAM::decCoordinator",
    "TE_EXAM::cea",
    "TE_EXAM_V3::invigilator",
    "TE_EXAM_V3::manager",
    "TE_PREFERENCES::recipient",
    "TE_HUB::student",
    "TE_HUB::invigilator",
    "TE_ACTIVITIES::readReservationTemplates"
  ], st;
}
var Fi = {}, si = {}, ct = {}, ld;
function rc() {
  if (ld) return ct;
  ld = 1, Object.defineProperty(ct, "__esModule", { value: !0 }), ct.SAMLIdentifierFormat = ct.EUserObjectMatching = ct.EApplySSOPermissions = ct.EAuthSaml2SigantureAlgorithm = ct.EAuthSaml2Signing = ct.EAuthLogLevel = ct.EAuthStrategy = void 0;
  var e;
  (function(s) {
    s.TE_IDP = "TE_IDP", s.SAML2 = "SAML2", s.CAS = "CAS";
  })(e || (ct.EAuthStrategy = e = {}));
  var t;
  (function(s) {
    s.NONE = "NONE", s.LOW = "LOW", s.HIGH = "HIGH", s.DEBUG = "DEBUG";
  })(t || (ct.EAuthLogLevel = t = {}));
  var r;
  (function(s) {
    s.NONE = "NONE", s.SIGN = "SIGN", s.REQUIRED = "REQUIRED";
  })(r || (ct.EAuthSaml2Signing = r = {}));
  var n;
  (function(s) {
    s.SHA1 = "sha1", s.SHA256 = "sha256", s.SHA512 = "sha512";
  })(n || (ct.EAuthSaml2SigantureAlgorithm = n = {}));
  var i;
  (function(s) {
    s.ALWAYS = "ALWAYS", s.NEW_USERS = "NEW_USERS", s.NEVER = "NEVER";
  })(i || (ct.EApplySSOPermissions = i = {}));
  var o;
  return (function(s) {
    s.OBJECT_EXTID = "OBJECT_EXTID", s.OBJECT_FIELD = "OBJECT_FIELD";
  })(o || (ct.EUserObjectMatching = o = {})), ct.SAMLIdentifierFormat = {
    Unspecified: "urn:oasis:names:tc:SAML:1.1:nameid-format:unspecified",
    Email: "urn:oasis:names:tc:SAML:1.1:nameid-format:emailAddress",
    Persistent: "urn:oasis:names:tc:SAML:2.0:nameid-format:persistent",
    Transient: "urn:oasis:names:tc:SAML:2.0:nameid-format:transient"
  }, ct;
}
var Gi = {}, cd;
function RO() {
  if (cd) return Gi;
  cd = 1, Object.defineProperty(Gi, "__esModule", { value: !0 }), Gi.ESuiteId = void 0;
  var e;
  return (function(t) {
    t.CURRICULUM = "CURRICULUM", t.WORKLOAD = "WORKLOAD", t.SCHEDULING = "SCHEDULING", t.ENGAGEMENT = "ENGAGEMENT";
  })(e || (Gi.ESuiteId = e = {})), Gi;
}
var zi = {}, fd;
function vy() {
  if (fd) return zi;
  fd = 1, Object.defineProperty(zi, "__esModule", { value: !0 }), zi.EAuth = void 0;
  var e;
  return (function(t) {
    t.NOT_AUTHENTICATED = "NOT_AUTHENTICATED", t.AUTHENTICATED = "AUTHENTICATED", t.PENDING = "PENDING";
  })(e || (zi.EAuth = e = {})), zi;
}
var fn = {}, dd;
function Sy() {
  if (dd) return fn;
  dd = 1, Object.defineProperty(fn, "__esModule", { value: !0 }), fn.EExternalServiceMethods = fn.EExternalServices = void 0;
  var e;
  (function(r) {
    r.AUTH_SERVICE = "AUTH_SERVICE", r.USER_SERVICE = "USER_SERVICE", r.ORGANIZATION_SERVICE = "ORGANIZATION_SERVICE", r.APP_SERVICE = "APP_SERVICE", r.BACKUP_SERVICE = "BACKUP_SERVICE", r.TE_SERVER = "TE_SERVER", r.INTEGRATION_SERVICE = "INTEGRATION_SERVICE", r.PATHWAY_SERVICE = "PATHWAY_SERVICE", r.TE_PREFERENCES = "TE_PREFERENCES", r.ACTIVITY_MANAGER = "ACTIVITY_MANAGER", r.ACTIVITY_IMPORTER = "ACTIVITY_IMPORTER", r.REPORTING = "REPORTING", r.NOTIFICATION = "NOTIFICATION_SERVICE", r.EXAM_V3 = "EXAM_V3", r.HUB_SERVICE = "HUB_SERVICE", r.OBJECTS_BATCH_SERVICE = "OBJECTS_BATCH_SERVICE";
  })(e || (fn.EExternalServices = e = {}));
  var t;
  return (function(r) {
    r.GET = "get", r.POST = "post", r.PUT = "put", r.PATCH = "patch", r.DELETE = "delete";
  })(t || (fn.EExternalServiceMethods = t = {})), fn;
}
var Bi = {}, pd;
function OO() {
  if (pd) return Bi;
  pd = 1, Object.defineProperty(Bi, "__esModule", { value: !0 }), Bi.EPaddingRuleType = void 0;
  var e;
  return (function(t) {
    t.DIRECT = "DIRECT", t.TRAVEL_TIME = "TRAVEL_TIME";
  })(e || (Bi.EPaddingRuleType = e = {})), Bi;
}
var Vi = {}, hd;
function nc() {
  if (hd) return Vi;
  hd = 1, Object.defineProperty(Vi, "__esModule", { value: !0 }), Vi.ERegion = void 0;
  var e;
  return (function(t) {
    t.ANZ = "ANZ", t.EU_EES = "EU_EES", t.SGP = "SGP", t.UK = "UK";
  })(e || (Vi.ERegion = e = {})), Vi;
}
var Xt = {}, md;
function Iy() {
  if (md) return Xt;
  md = 1, Object.defineProperty(Xt, "__esModule", { value: !0 }), Xt.ERelativeTimeTypes = Xt.EReservationPeriodType = Xt.EWeekdaySelection = Xt.EWeekdays = void 0;
  var e;
  (function(i) {
    i.MON = "MON", i.TUE = "TUE", i.WED = "WED", i.THU = "THU", i.FRI = "FRI", i.SAT = "SAT", i.SUN = "SUN";
  })(e || (Xt.EWeekdays = e = {}));
  var t;
  (function(i) {
    i.noWeekDaySelection = "no_weekday_selection";
  })(t || (Xt.EWeekdaySelection = t = {}));
  var r;
  (function(i) {
    i.NONE = "NONE", i.RESERVATION_PERIOD = "RESERVATION_PERIOD", i.DAY = "DAY", i.WEEK = "WEEK", i.MONTH = "MONTH", i.YEAR = "YEAR";
  })(r || (Xt.EReservationPeriodType = r = {}));
  var n;
  return (function(i) {
    i.DAYS = "DAYS", i.HOURS = "HOURS", i.MINUTES = "MINUTES";
  })(n || (Xt.ERelativeTimeTypes = n = {})), Xt;
}
var Wi = {}, Ed;
function _y() {
  if (Ed) return Wi;
  Ed = 1, Object.defineProperty(Wi, "__esModule", { value: !0 }), Wi.ETokenType = void 0;
  var e;
  return (function(t) {
    t.M2M = "M2M", t.USER = "USER";
  })(e || (Wi.ETokenType = e = {})), Wi;
}
var dn = {}, gd;
function wO() {
  if (gd) return dn;
  gd = 1, Object.defineProperty(dn, "__esModule", { value: !0 }), dn.EUserAllowJavaClientAccess = dn.EUserVisibility = void 0;
  var e;
  (function(r) {
    r.STANDARD = "STANDARD", r.READ_ONLY = "READ_ONLY", r.HIDDEN = "HIDDEN";
  })(e || (dn.EUserVisibility = e = {}));
  var t;
  return (function(r) {
    r.STANDARD = "STANDARD", r.YES = "YES", r.NO = "NO";
  })(t || (dn.EUserAllowJavaClientAccess = t = {})), dn;
}
var qi = {}, yd;
function NO() {
  if (yd) return qi;
  yd = 1, Object.defineProperty(qi, "__esModule", { value: !0 }), qi.EOrganizationType = void 0;
  var e;
  return (function(t) {
    t.CUSTOMER_PRODUCTION = "CUSTOMER_PRODUCTION", t.CUSTOMER_TESTING = "CUSTOMER_TESTING", t.INTERNAL_PRODUCTION = "INTERNAL_PRODUCTION", t.INTERNAL_OTHER = "INTERNAL_OTHER";
  })(e || (qi.EOrganizationType = e = {})), qi;
}
var yr = {}, Td;
function Ry() {
  if (Td) return yr;
  Td = 1, Object.defineProperty(yr, "__esModule", { value: !0 }), yr.EPreferencesFilter = yr.EPersonalDataCheck = yr.EFieldType = void 0;
  var e;
  (function(n) {
    n.TEXT = "TEXT", n.SIGNATURE = "SIGNATURE", n.EMAIL = "EMAIL", n.URL = "URL", n.TELEPHONE = "TELEPHONE", n.CATEGORY = "CATEGORY", n.COMMENT = "COMMENT", n.INTEGER = "INTEGER", n.LENGTH = "LENGTH", n.CHECKBOX = "CHECKBOX", n.REFERENCE = "REFERENCE", n.NON_SEARCHABLE_TEXT = "NON_SEARCHABLE_TEXT", n.NON_SEARCHABLE_REFERENCE = "NON_SEARCHABLE_REFERENCE";
  })(e || (yr.EFieldType = e = {}));
  var t;
  (function(n) {
    n.STANDARD = "STANDARD", n.YES = "YES", n.NO = "NO";
  })(t || (yr.EPersonalDataCheck = t = {}));
  var r;
  return (function(n) {
    n.CHOICE1 = "[0-9]", n.CHOICE2 = "[0-9\\- +]", n.CHOICE3 = "[0-9a-z]", n.CHOICE4 = "[0-9a-zA-ZåäöÅÄÖ_-]", n.CHOICE5 = "[@_\\-\\.0-9a-zA-Z]", n.CHOICE6 = "[@_\\-\\.0-9a-zA-ZåäöÅÄÖ]";
  })(r || (yr.EPreferencesFilter = r = {})), yr;
}
var pn = {}, bd;
function CO() {
  if (bd) return pn;
  bd = 1, Object.defineProperty(pn, "__esModule", { value: !0 }), pn.EMatchMode = pn.EOperator = void 0;
  var e;
  (function(r) {
    r.E = "=", r.GTE = ">=", r.GT = ">", r.LTE = "<=", r.LT = "<";
  })(e || (pn.EOperator = e = {}));
  var t;
  return (function(r) {
    r.MATCH_ONE = "MATCH_ONE", r.MATCH_ALL = "MATCH_ALL";
  })(t || (pn.EMatchMode = t = {})), pn;
}
var Tr = {}, Ad;
function PO() {
  if (Ad) return Tr;
  Ad = 1, Object.defineProperty(Tr, "__esModule", { value: !0 }), Tr.ELoggedEventType = Tr.ELoggedEventItemDataType = Tr.ELoggedEventLevel = void 0;
  var e;
  (function(n) {
    n.LOW = "LOW", n.MEDIUM = "MEDIUM", n.HIGH = "HIGH", n.CRITICAL = "CRITICAL";
  })(e || (Tr.ELoggedEventLevel = e = {}));
  var t;
  (function(n) {
    n.TEXT = "text/plain", n.JSON = "application/json";
  })(t || (Tr.ELoggedEventItemDataType = t = {}));
  var r;
  return (function(n) {
    n.MIGRATION = "MIGRATION", n.IMPORT = "IMPORT", n.SSO = "SSO";
  })(r || (Tr.ELoggedEventType = r = {})), Tr;
}
var hn = {}, vd;
function DO() {
  if (vd) return hn;
  vd = 1, Object.defineProperty(hn, "__esModule", { value: !0 }), hn.EPersonalInformation = hn.EProperty = void 0;
  var e;
  (function(r) {
    r.STANDARD = "STANDARD", r.ABSTRACT = "ABSTRACT", r.VIRTUAL_STANDARD = "VIRTUAL_STANDARD", r.VIRTUAL_ABSTRACT = "VIRTUAL_ABSTRACT", r.TEMPLATE_OBJECT = "TEMPLATE_OBJECT";
  })(e || (hn.EProperty = e = {}));
  var t;
  return (function(r) {
    r.YES = "YES", r.NO = "NO", r.STANDARD = "STANDARD";
  })(t || (hn.EPersonalInformation = t = {})), hn;
}
var mn = {}, Sd;
function Oy() {
  if (Sd) return mn;
  Sd = 1, Object.defineProperty(mn, "__esModule", { value: !0 }), mn.EPeriodAccess = mn.ETimeIntervals = void 0;
  var e;
  (function(r) {
    r.DATE = "DATE", r.YEAR = "YEAR", r.WEEK = "WEEK", r.WEEK_NUMBER = "WEEK_NUMBER", r.MONTH = "MONTH", r.DAY = "DAY", r.WEEKDAY = "WEEKDAY", r.TIME = "TIME", r.NONE = "-";
  })(e || (mn.ETimeIntervals = e = {}));
  var t;
  return (function(r) {
    r.PUBLIC = "PUBLIC", r.LIMITED = "LIMITED", r.HIDDEN = "HIDDEN";
  })(t || (mn.EPeriodAccess = t = {})), mn;
}
var Hi = {}, Id;
function wy() {
  if (Id) return Hi;
  Id = 1, Object.defineProperty(Hi, "__esModule", { value: !0 }), Hi.ERelationType = void 0;
  var e;
  return (function(t) {
    t.USE_ONLY = "USE_ONLY", t.STRICT = "STRICT", t.DYNAMIC = "DYNAMIC";
  })(e || (Hi.ERelationType = e = {})), Hi;
}
var at = {}, _d;
function Ny() {
  if (_d) return at;
  _d = 1, Object.defineProperty(at, "__esModule", { value: !0 }), at.EReservationStatuses = at.ETemplateType = at.ETemplateTypesText = at.EOptionalRelation = at.EObjectProperty = at.EMandatoryProperty = at.EReservationKind = at.EDefaultStatus = void 0;
  var e;
  (function(l) {
    l.CONFIRMED = "CONFIRMED", l.PLANNED = "PLANNED", l.PRELIMINARY = "PRELIMINARY";
  })(e || (at.EDefaultStatus = e = {}));
  var t;
  (function(l) {
    l.PHYSICAL = "PHYSICAL", l.PHYSICAL_DOUBLE = "PHYSICAL_DOUBLE", l.ABSTRACT = "ABSTRACT", l.ABSTRACT_DISPLAY = "ABSTRACT_DISPLAY";
  })(t || (at.EReservationKind = t = {}));
  var r;
  (function(l) {
    l.MANDATORY = "MANDATORY", l.COMBINATION = "COMBINATION", l.OPTIONAL = "OPTIONAL";
  })(r || (at.EMandatoryProperty = r = {}));
  var n;
  (function(l) {
    l.OBJECT = "OBJECT", l.VIRTUAL = "VIRTUAL", l.INCOMPLETE = "INCOMPLETE";
  })(n || (at.EObjectProperty = n = {}));
  var i;
  (function(l) {
    l.NONE = "NONE", l.OPTIONAL = "OPTIONAL", l.ABSTRACT = "ABSTRACT";
  })(i || (at.EOptionalRelation = i = {}));
  var o;
  (function(l) {
    l.STANDARD = "STANDARD", l.NEVER = "NEVER", l.ALWAYS = "ALWAYS";
  })(o || (at.ETemplateTypesText = o = {}));
  var s;
  (function(l) {
    l.RESERVATION = "RESERVATION", l.AVAILABILITY = "AVAILABILITY", l.INFO_RESERVATION = "INFO_RESERVATION";
  })(s || (at.ETemplateType = s = {}));
  var a;
  return (function(l) {
    l.UNKNOWN = "UNKNOWN", l.Reservation = "A_RESERVATION", l.Availability = "A_AVAILABILITY", l.Info = "A_INFO", l.Complete = "B_COMPLETE", l.Incomplete = "B_INCOMPLETE", l.Confirmed = "C_CONFIRMED", l.Preliminary = "C_PRELIMINARY", l.Planned = "C_PLANNED", l.Requested = "C_REQUESTED", l.Rejected = "C_REJECTED", l.Time = "D_TIME", l.WaitingList = "D_WAITING_LIST";
  })(a || (at.EReservationStatuses = a = {})), at;
}
var Yi = {}, Rd;
function MO() {
  if (Rd) return Yi;
  Rd = 1, Object.defineProperty(Yi, "__esModule", { value: !0 }), Yi.EAcceptJavaClient = void 0;
  var e;
  return (function(t) {
    t.YES = "YES", t.NO = "NO", t.DEFAULT = "DEFAULT";
  })(e || (Yi.EAcceptJavaClient = e = {})), Yi;
}
var Zi = {}, Od;
function LO() {
  if (Od) return Zi;
  Od = 1, Object.defineProperty(Zi, "__esModule", { value: !0 }), Zi.EFieldMappingModes = void 0;
  var e;
  return (function(t) {
    t.RAW = "RAW", t.FREE_MAPPING = "FREE_MAPPING", t.MAPPED = "MAPPED";
  })(e || (Zi.EFieldMappingModes = e = {})), Zi;
}
var Ji = {}, wd;
function xO() {
  if (wd) return Ji;
  wd = 1, Object.defineProperty(Ji, "__esModule", { value: !0 }), Ji.ETEReportingDataSource = void 0;
  var e;
  return (function(t) {
    t.SCHEDULE_GENERATOR = "SCHEDULE_GENERATOR", t.RESERVATIONS = "RESERVATIONS", t.ORDERS = "ORDERS", t.EXAMS = "EXAMS", t.FORMS = "FORMS", t.ACTIVITIES = "ACTIVITIES";
  })(e || (Ji.ETEReportingDataSource = e = {})), Ji;
}
var br = {}, Nd;
function kO() {
  if (Nd) return br;
  Nd = 1, Object.defineProperty(br, "__esModule", { value: !0 }), br.EAppProperties = br.EObjectTypeMappingStatuses = br.EApplicationObjectTypeGroup = void 0;
  var e;
  (function(n) {
    n.NONE = "NONE", n.ROOM = "ROOM", n.PROFESSOR = "PROFESSOR", n.COURSE = "COURSE", n.COURSE_INFORMATION = "COURSE_INFORMATION", n.INVOICING = "INVOICING", n.STUDENT_SET = "STUDENT_SET", n.STUDENT_SET_GROUP = "STUDENT_SET_GROUP", n.PROGRAM = "PROGRAM", n.ACTIVITY_TYPE = "ACTIVITY_TYPE", n.STUDENT = "STUDENT", n.STAFF = "STAFF", n.CHANGE_REQUEST = "CHANGE_REQUEST", n.INVIGILATOR = "INVIGILATOR";
  })(e || (br.EApplicationObjectTypeGroup = e = {}));
  var t;
  (function(n) {
    n.NOT_TESTED = "NOT_TESTED", n.NOT_MAPPED = "NOT_MAPPED", n.MAPPED = "MAPPED", n.TESTED = "TESTED", n.FAILED = "FAILED";
  })(t || (br.EObjectTypeMappingStatuses = t = {}));
  var r;
  return (function(n) {
    n.NONE = "NONE", n.NAME = "NAME", n.LABEL = "LABEL", n.EMAIL = "EMAIL", n.FIRST_NAME = "FIRST_NAME", n.LAST_NAME = "LAST_NAME", n.TITLE = "TITLE", n.ID = "ID", n.SEMESTER = "SEMESTER", n.MAX_STUDENTS = "MAX_STUDENTS", n.ACTIVITY_TYPE = "ACTIVITY_TYPE", n.START_DATE = "START_DATE", n.END_DATE = "END_DATE", n.BUFFER = "BUFFER", n.HIDETRACK = "HIDETRACK", n.DEDICATETRACK = "DEDICATETRACK", n.TRACK = "TRACK", n.SEATS = "SEATS", n.COURSE_OCCURENCE = "COURSE_OCCURENCE", n.PLANNED_SIZE = "PLANNED_SIZE", n.PROGRAM = "PROGRAM", n.ROOM_NAME = "ROOM_NAME", n.ROOM_TYPE = "ROOM_TYPE", n.BUILDING = "BUILDING", n.CAMPUS = "CAMPUS", n.REASONABLE_ADJUSTMENT = "REASONABLE_ADJUSTMENT";
  })(r || (br.EAppProperties = r = {})), br;
}
var Mt = {}, Cd;
function jO() {
  if (Cd) return Mt;
  Cd = 1, Object.defineProperty(Mt, "__esModule", { value: !0 }), Mt.CalculatedValueProps = Mt.ECalculatedValueKey = Mt.EReportTemplateType = Mt.EReportingCapacitySource = Mt.EReportingTimeType = void 0;
  var e;
  (function(i) {
    i.FIXED_HOUR = "FIXED_HOUR", i.TIME_RANGE = "TIME_RANGE", i.MAX_HOURS = "MAX_HOURS";
  })(e || (Mt.EReportingTimeType = e = {}));
  var t;
  (function(i) {
    i.FROM_FIELD = "FROM_FIELD", i.FROM_MEMBERSHIP = "FROM_MEMBERSHIP";
  })(t || (Mt.EReportingCapacitySource = t = {}));
  var r;
  (function(i) {
    i.UTILIZATION = "UTILIZATION", i.LOAD = "LOAD", i.DEMAND_ANALYTIC = "DEMAND_ANALYTIC", i.HEATMAP = "HEATMAP";
  })(r || (Mt.EReportTemplateType = r = {}));
  var n;
  return (function(i) {
    i.FREQUENCY = "frequency", i.OCCUPANCY = "occupancy", i.UTILIZATION = "utilization", i.BOOKED_HOURS = "bookedHours", i.AVAILABLE_HOUR = "availableHour", i.LOAD_PERCENTAGE = "loadPercentage", i.WEEKS_ABOVE_TARGET = "weeksAboveTarget", i.DEMAND_PERCENTAGE = "demandPercentage";
  })(n || (Mt.ECalculatedValueKey = n = {})), Mt.CalculatedValueProps = {
    [n.FREQUENCY]: { label: "Frequency", templateType: r.UTILIZATION },
    [n.OCCUPANCY]: { label: "Occupancy", templateType: r.UTILIZATION },
    [n.UTILIZATION]: { label: "Utilization", templateType: r.UTILIZATION },
    [n.BOOKED_HOURS]: { label: "Booked Hours", templateType: r.LOAD },
    [n.AVAILABLE_HOUR]: { label: "Available Hours", templateType: r.LOAD },
    [n.LOAD_PERCENTAGE]: { label: "Load", templateType: r.LOAD },
    [n.WEEKS_ABOVE_TARGET]: {
      label: "Weeks Above Target",
      templateType: r.DEMAND_ANALYTIC
    },
    [n.DEMAND_PERCENTAGE]: {
      label: "Average Weekly Demand",
      templateType: r.DEMAND_ANALYTIC
    }
  }, Mt;
}
var Pd;
function Rt() {
  return Pd || (Pd = 1, (function(e) {
    var t = si && si.__createBinding || (Object.create ? (function(U, z, V, ae) {
      ae === void 0 && (ae = V);
      var q = Object.getOwnPropertyDescriptor(z, V);
      (!q || ("get" in q ? !z.__esModule : q.writable || q.configurable)) && (q = { enumerable: !0, get: function() {
        return z[V];
      } }), Object.defineProperty(U, ae, q);
    }) : (function(U, z, V, ae) {
      ae === void 0 && (ae = V), U[ae] = z[V];
    })), r = si && si.__exportStar || function(U, z) {
      for (var V in U) V !== "default" && !Object.prototype.hasOwnProperty.call(z, V) && t(z, U, V);
    };
    Object.defineProperty(e, "__esModule", { value: !0 }), e.EReportTemplateType = e.EReportingCapacitySource = e.EReportingTimeType = e.EAppProperties = e.EObjectTypeMappingStatuses = e.EApplicationObjectTypeGroup = e.ETEReportingDataSource = e.EFieldMappingModes = e.EAcceptJavaClient = e.EReservationStatuses = e.ETemplateType = e.ETemplateTypesText = e.EOptionalRelation = e.EObjectProperty = e.EMandatoryProperty = e.EReservationKind = e.EDefaultStatus = e.ERelationType = e.EPeriodAccess = e.ETimeIntervals = e.EPersonalInformation = e.EProperty = e.EOperator = e.EMatchMode = e.EPreferencesFilter = e.EPersonalDataCheck = e.EFieldType = e.EOrganizationType = e.EUserVisibility = e.EUserAllowJavaClientAccess = e.ETokenType = e.EWeekdaySelection = e.EWeekdays = e.EReservationPeriodType = e.ERelativeTimeTypes = e.ERegion = e.EScopeLevel = e.EPermissionTypes = e.EPaddingRuleType = e.EExternalServices = e.EExternalServiceMethods = e.EAuth = e.ESuiteId = e.EAppId = e.EUserObjectMatching = e.EAuthStrategy = e.EAuthSaml2Signing = e.EAuthSaml2SigantureAlgorithm = e.EAuthLogLevel = e.EApplySSOPermissions = void 0, e.CalculatedValueProps = e.ECalculatedValueKey = void 0;
    var n = rc();
    Object.defineProperty(e, "EApplySSOPermissions", { enumerable: !0, get: function() {
      return n.EApplySSOPermissions;
    } }), Object.defineProperty(e, "EAuthLogLevel", { enumerable: !0, get: function() {
      return n.EAuthLogLevel;
    } }), Object.defineProperty(e, "EAuthSaml2SigantureAlgorithm", { enumerable: !0, get: function() {
      return n.EAuthSaml2SigantureAlgorithm;
    } }), Object.defineProperty(e, "EAuthSaml2Signing", { enumerable: !0, get: function() {
      return n.EAuthSaml2Signing;
    } }), Object.defineProperty(e, "EAuthStrategy", { enumerable: !0, get: function() {
      return n.EAuthStrategy;
    } }), Object.defineProperty(e, "EUserObjectMatching", { enumerable: !0, get: function() {
      return n.EUserObjectMatching;
    } });
    var i = ec();
    Object.defineProperty(e, "EAppId", { enumerable: !0, get: function() {
      return i.EAppId;
    } });
    var o = RO();
    Object.defineProperty(e, "ESuiteId", { enumerable: !0, get: function() {
      return o.ESuiteId;
    } });
    var s = vy();
    Object.defineProperty(e, "EAuth", { enumerable: !0, get: function() {
      return s.EAuth;
    } });
    var a = Sy();
    Object.defineProperty(e, "EExternalServiceMethods", { enumerable: !0, get: function() {
      return a.EExternalServiceMethods;
    } }), Object.defineProperty(e, "EExternalServices", { enumerable: !0, get: function() {
      return a.EExternalServices;
    } });
    var l = OO();
    Object.defineProperty(e, "EPaddingRuleType", { enumerable: !0, get: function() {
      return l.EPaddingRuleType;
    } });
    var f = tc();
    Object.defineProperty(e, "EPermissionTypes", { enumerable: !0, get: function() {
      return f.EPermissionTypes;
    } }), Object.defineProperty(e, "EScopeLevel", { enumerable: !0, get: function() {
      return f.EScopeLevel;
    } });
    var u = nc();
    Object.defineProperty(e, "ERegion", { enumerable: !0, get: function() {
      return u.ERegion;
    } });
    var h = Iy();
    Object.defineProperty(e, "ERelativeTimeTypes", { enumerable: !0, get: function() {
      return h.ERelativeTimeTypes;
    } }), Object.defineProperty(e, "EReservationPeriodType", { enumerable: !0, get: function() {
      return h.EReservationPeriodType;
    } }), Object.defineProperty(e, "EWeekdays", { enumerable: !0, get: function() {
      return h.EWeekdays;
    } }), Object.defineProperty(e, "EWeekdaySelection", { enumerable: !0, get: function() {
      return h.EWeekdaySelection;
    } });
    var E = _y();
    Object.defineProperty(e, "ETokenType", { enumerable: !0, get: function() {
      return E.ETokenType;
    } });
    var d = wO();
    Object.defineProperty(e, "EUserAllowJavaClientAccess", { enumerable: !0, get: function() {
      return d.EUserAllowJavaClientAccess;
    } }), Object.defineProperty(e, "EUserVisibility", { enumerable: !0, get: function() {
      return d.EUserVisibility;
    } });
    var g = NO();
    Object.defineProperty(e, "EOrganizationType", { enumerable: !0, get: function() {
      return g.EOrganizationType;
    } });
    var y = Ry();
    Object.defineProperty(e, "EFieldType", { enumerable: !0, get: function() {
      return y.EFieldType;
    } }), Object.defineProperty(e, "EPersonalDataCheck", { enumerable: !0, get: function() {
      return y.EPersonalDataCheck;
    } }), Object.defineProperty(e, "EPreferencesFilter", { enumerable: !0, get: function() {
      return y.EPreferencesFilter;
    } });
    var b = CO();
    Object.defineProperty(e, "EMatchMode", { enumerable: !0, get: function() {
      return b.EMatchMode;
    } }), Object.defineProperty(e, "EOperator", { enumerable: !0, get: function() {
      return b.EOperator;
    } }), r(PO(), e);
    var _ = DO();
    Object.defineProperty(e, "EProperty", { enumerable: !0, get: function() {
      return _.EProperty;
    } }), Object.defineProperty(e, "EPersonalInformation", { enumerable: !0, get: function() {
      return _.EPersonalInformation;
    } });
    var I = Oy();
    Object.defineProperty(e, "ETimeIntervals", { enumerable: !0, get: function() {
      return I.ETimeIntervals;
    } }), Object.defineProperty(e, "EPeriodAccess", { enumerable: !0, get: function() {
      return I.EPeriodAccess;
    } });
    var w = wy();
    Object.defineProperty(e, "ERelationType", { enumerable: !0, get: function() {
      return w.ERelationType;
    } });
    var L = Ny();
    Object.defineProperty(e, "EDefaultStatus", { enumerable: !0, get: function() {
      return L.EDefaultStatus;
    } }), Object.defineProperty(e, "EReservationKind", { enumerable: !0, get: function() {
      return L.EReservationKind;
    } }), Object.defineProperty(e, "EMandatoryProperty", { enumerable: !0, get: function() {
      return L.EMandatoryProperty;
    } }), Object.defineProperty(e, "EObjectProperty", { enumerable: !0, get: function() {
      return L.EObjectProperty;
    } }), Object.defineProperty(e, "EOptionalRelation", { enumerable: !0, get: function() {
      return L.EOptionalRelation;
    } }), Object.defineProperty(e, "ETemplateTypesText", { enumerable: !0, get: function() {
      return L.ETemplateTypesText;
    } }), Object.defineProperty(e, "ETemplateType", { enumerable: !0, get: function() {
      return L.ETemplateType;
    } }), Object.defineProperty(e, "EReservationStatuses", { enumerable: !0, get: function() {
      return L.EReservationStatuses;
    } });
    var R = MO();
    Object.defineProperty(e, "EAcceptJavaClient", { enumerable: !0, get: function() {
      return R.EAcceptJavaClient;
    } });
    var D = LO();
    Object.defineProperty(e, "EFieldMappingModes", { enumerable: !0, get: function() {
      return D.EFieldMappingModes;
    } });
    var P = xO();
    Object.defineProperty(e, "ETEReportingDataSource", { enumerable: !0, get: function() {
      return P.ETEReportingDataSource;
    } });
    var O = kO();
    Object.defineProperty(e, "EApplicationObjectTypeGroup", { enumerable: !0, get: function() {
      return O.EApplicationObjectTypeGroup;
    } }), Object.defineProperty(e, "EObjectTypeMappingStatuses", { enumerable: !0, get: function() {
      return O.EObjectTypeMappingStatuses;
    } }), Object.defineProperty(e, "EAppProperties", { enumerable: !0, get: function() {
      return O.EAppProperties;
    } });
    var F = jO();
    Object.defineProperty(e, "EReportingTimeType", { enumerable: !0, get: function() {
      return F.EReportingTimeType;
    } }), Object.defineProperty(e, "EReportingCapacitySource", { enumerable: !0, get: function() {
      return F.EReportingCapacitySource;
    } }), Object.defineProperty(e, "EReportTemplateType", { enumerable: !0, get: function() {
      return F.EReportTemplateType;
    } }), Object.defineProperty(e, "ECalculatedValueKey", { enumerable: !0, get: function() {
      return F.ECalculatedValueKey;
    } }), Object.defineProperty(e, "CalculatedValueProps", { enumerable: !0, get: function() {
      return F.CalculatedValueProps;
    } });
  })(si)), si;
}
var Dd;
function UO() {
  if (Dd) return Fi;
  Dd = 1, Object.defineProperty(Fi, "__esModule", { value: !0 }), Fi.FieldMappingModeProps = void 0;
  const e = Rt();
  return Fi.FieldMappingModeProps = {
    [e.EFieldMappingModes.RAW]: {
      label: "Only first primary field"
    },
    [e.EFieldMappingModes.FREE_MAPPING]: {
      label: "Free field selection"
    },
    [e.EFieldMappingModes.MAPPED]: {
      label: "Predetermined fields"
    }
  }, Fi;
}
var Ar = {}, Md;
function $O() {
  if (Md) return Ar;
  Md = 1, Object.defineProperty(Ar, "__esModule", { value: !0 }), Ar.AppPropertyProps = Ar.ObjectTypeGroupProps = Ar.ObjectTypeMappingStatusProps = void 0;
  const e = Rt();
  return Ar.ObjectTypeMappingStatusProps = {
    [e.EObjectTypeMappingStatuses.NOT_TESTED]: {
      label: "Not mapped",
      color: "#ffdd5c"
    },
    [e.EObjectTypeMappingStatuses.NOT_MAPPED]: {
      label: "Not mapped",
      color: "#ffdd5c"
    },
    [e.EObjectTypeMappingStatuses.MAPPED]: {
      label: "Mapped",
      color: "#3fa5b3"
    },
    [e.EObjectTypeMappingStatuses.TESTED]: {
      label: "Tested",
      color: "#29b68f"
    },
    [e.EObjectTypeMappingStatuses.FAILED]: {
      label: "Failed",
      color: "#ff6357"
    }
  }, Ar.ObjectTypeGroupProps = {
    [e.EApplicationObjectTypeGroup.NONE]: {
      label: "None"
    },
    [e.EApplicationObjectTypeGroup.ROOM]: {
      label: "Room"
    },
    [e.EApplicationObjectTypeGroup.PROFESSOR]: {
      label: "Professor"
    },
    [e.EApplicationObjectTypeGroup.COURSE]: {
      label: "Course"
    },
    [e.EApplicationObjectTypeGroup.COURSE_INFORMATION]: {
      label: "Course Information"
    },
    [e.EApplicationObjectTypeGroup.INVOICING]: {
      label: "Invoicing"
    },
    [e.EApplicationObjectTypeGroup.STUDENT_SET]: {
      label: "Student set"
    },
    [e.EApplicationObjectTypeGroup.STUDENT_SET_GROUP]: {
      label: "Student set group"
    },
    [e.EApplicationObjectTypeGroup.PROGRAM]: {
      label: "Program"
    },
    [e.EApplicationObjectTypeGroup.ACTIVITY_TYPE]: {
      label: "Activity type"
    },
    [e.EApplicationObjectTypeGroup.STUDENT]: {
      label: "Student"
    },
    [e.EApplicationObjectTypeGroup.STAFF]: {
      label: "Staff"
    },
    [e.EApplicationObjectTypeGroup.CHANGE_REQUEST]: {
      label: "Change request"
    },
    [e.EApplicationObjectTypeGroup.INVIGILATOR]: {
      label: "Invigilator"
    }
  }, Ar.AppPropertyProps = {
    [e.EAppProperties.NONE]: {
      label: "None"
    },
    [e.EAppProperties.EMAIL]: {
      label: "Email"
    },
    [e.EAppProperties.LABEL]: {
      label: "Label"
    },
    [e.EAppProperties.TITLE]: {
      label: "Title"
    },
    [e.EAppProperties.SEMESTER]: {
      label: "Semester"
    },
    [e.EAppProperties.MAX_STUDENTS]: {
      label: "Max class size"
    },
    [e.EAppProperties.ACTIVITY_TYPE]: {
      label: "Activity type"
    },
    [e.EAppProperties.START_DATE]: {
      label: "Start date"
    },
    [e.EAppProperties.END_DATE]: {
      label: "End date"
    },
    [e.EAppProperties.TRACK]: {
      label: "Group number"
    },
    [e.EAppProperties.SEATS]: {
      label: "Capacity"
    },
    [e.EAppProperties.BUFFER]: {
      label: "Buffer"
    },
    [e.EAppProperties.HIDETRACK]: {
      label: "Hide track"
    },
    [e.EAppProperties.DEDICATETRACK]: {
      label: "Dedicate track"
    },
    [e.EAppProperties.FIRST_NAME]: {
      label: "First name"
    },
    [e.EAppProperties.LAST_NAME]: {
      label: "Last name"
    },
    [e.EAppProperties.NAME]: {
      label: "Study combination: id"
    },
    [e.EAppProperties.COURSE_OCCURENCE]: {
      label: "Course occurence"
    },
    [e.EAppProperties.PLANNED_SIZE]: {
      label: "Planned size"
    },
    [e.EAppProperties.ID]: {
      label: "Id"
    },
    [e.EAppProperties.PROGRAM]: {
      label: "Program"
    },
    [e.EAppProperties.ROOM_NAME]: {
      label: "Room name"
    },
    [e.EAppProperties.ROOM_TYPE]: {
      label: "Room type"
    },
    [e.EAppProperties.BUILDING]: {
      label: "Building"
    },
    [e.EAppProperties.CAMPUS]: {
      label: "Campus"
    },
    [e.EAppProperties.REASONABLE_ADJUSTMENT]: {
      label: "Reasonable adjustment"
    }
  }, Ar;
}
var Ki = {}, Ld;
function FO() {
  if (Ld) return Ki;
  Ld = 1, Object.defineProperty(Ki, "__esModule", { value: !0 }), Ki.DefaultTEExamObjectTypesMapping = void 0;
  const e = Rt();
  return Ki.DefaultTEExamObjectTypesMapping = [
    {
      applicationObjectTypeName: "room",
      applicationObjectTypeGroup: e.EApplicationObjectTypeGroup.ROOM,
      applicationObjectTypeLabel: "Room",
      // User is free to override, but we provide a default
      status: e.EObjectTypeMappingStatuses.NOT_MAPPED,
      fields: [
        {
          appFieldName: "name",
          fieldLabel: "Name"
          // User can override but we provide default
        },
        {
          appFieldName: "description",
          fieldLabel: "Description"
          // User can override but we provide default
        },
        {
          appFieldName: "capacity",
          fieldLabel: "Capacity"
          // User can override but we provide default
        },
        {
          appFieldName: "building",
          fieldLabel: "Building"
          // User can override but we provide default
        },
        {
          appFieldName: "campus",
          fieldLabel: "Campus"
          // User can override but we provide default
        },
        {
          appFieldName: "floor",
          fieldLabel: "Floor"
          // User can override but we provide default
        },
        {
          appFieldName: "address",
          fieldLabel: "Address"
          // User can override but we provide default
        },
        {
          appFieldName: "pricePerSeatPerHour",
          fieldLabel: "Price per seat per hour"
          // User can override but we provide default
        },
        {
          appFieldName: "roomType",
          fieldLabel: "Room type"
          // User can override but we provide default
        }
      ]
    },
    {
      applicationObjectTypeName: "professor",
      applicationObjectTypeGroup: e.EApplicationObjectTypeGroup.PROFESSOR,
      objectTypeExtId: null,
      // This is set in the mapping by the user, not in the template
      applicationObjectTypeLabel: "Professor",
      // User is free to override, but we provide a default
      status: e.EObjectTypeMappingStatuses.NOT_MAPPED,
      labelField: null,
      secondaryLabelField: null,
      fields: [
        {
          appFieldName: "name",
          fieldLabel: "Name"
          // User can override but we provide default
        },
        {
          appFieldName: "id",
          fieldLabel: "Id"
          // User can override but we provide default
        },
        {
          appFieldName: "email",
          fieldLabel: "Email"
          // User can override but we provide default
        },
        {
          appFieldName: "department",
          fieldLabel: "Department"
          // User can override but we provide default
        }
      ]
    },
    {
      applicationObjectTypeName: "coordinator",
      applicationObjectTypeGroup: e.EApplicationObjectTypeGroup.PROFESSOR,
      objectTypeExtId: null,
      // This is set in the mapping by the user, not in the template
      applicationObjectTypeLabel: "Coordinator",
      // User is free to override, but we provide a default
      status: e.EObjectTypeMappingStatuses.NOT_MAPPED,
      labelField: null,
      secondaryLabelField: null,
      fields: [
        {
          appFieldName: "name",
          fieldLabel: "Name"
          // User can override but we provide default
        },
        {
          appFieldName: "id",
          fieldLabel: "Id"
          // User can override but we provide default
        },
        {
          appFieldName: "email",
          fieldLabel: "Email"
          // User can override but we provide default
        },
        {
          appFieldName: "department",
          fieldLabel: "Department"
          // User can override but we provide default
        }
      ]
    },
    {
      applicationObjectTypeName: "course",
      applicationObjectTypeGroup: e.EApplicationObjectTypeGroup.COURSE_INFORMATION,
      objectTypeExtId: null,
      // This is set in the mapping by the user, not in the template
      applicationObjectTypeLabel: "Course",
      // User is free to override, but we provide a default
      status: e.EObjectTypeMappingStatuses.NOT_MAPPED,
      labelField: null,
      secondaryLabelField: null,
      fields: [
        {
          appFieldName: "name",
          fieldLabel: "Name"
          // User can override but we provide default
        },
        {
          appFieldName: "code",
          fieldLabel: "Code"
          // User can override but we provide default
        },
        {
          appFieldName: "credits",
          fieldLabel: "Credits"
          // User can override but we provide default
        },
        {
          appFieldName: "courseCode",
          fieldLabel: "Course Code"
          // User can override but we provide default
        },
        {
          appFieldName: "department",
          appProperty: null,
          fieldExtId: null,
          fieldLabel: "Department"
        }
      ]
    },
    {
      applicationObjectTypeName: "courseEvent",
      applicationObjectTypeGroup: e.EApplicationObjectTypeGroup.COURSE_INFORMATION,
      objectTypeExtId: null,
      // This is set in the mapping by the user, not in the template
      applicationObjectTypeLabel: "Course Event",
      // User is free to override, but we provide a default
      status: e.EObjectTypeMappingStatuses.NOT_MAPPED,
      labelField: null,
      secondaryLabelField: null,
      fields: [
        {
          appFieldName: "name",
          fieldLabel: "Name"
          // User can override but we provide default
        },
        {
          appFieldName: "id",
          fieldLabel: "Id"
          // User can override but we provide default
        },
        {
          appFieldName: "number",
          fieldLabel: "Number"
          // User can override but we provide default
        },
        {
          appFieldName: "courseName",
          fieldLabel: "Course name"
          // User can override but we provide default
        },
        {
          appFieldName: "courseCode",
          fieldLabel: "Course code"
          // User can override but we provide default
        },
        {
          appFieldName: "department",
          fieldLabel: "Department"
          // User can override but we provide default
        }
      ]
    },
    {
      applicationObjectTypeName: "module",
      applicationObjectTypeGroup: e.EApplicationObjectTypeGroup.COURSE_INFORMATION,
      objectTypeExtId: null,
      // This is set in the mapping by the user, not in the template
      applicationObjectTypeLabel: "Module",
      // User is free to override, but we provide a default
      status: e.EObjectTypeMappingStatuses.NOT_MAPPED,
      labelField: null,
      secondaryLabelField: null,
      fields: [
        {
          appFieldName: "name",
          fieldLabel: "Name"
          // User can override but we provide default
        },
        {
          appFieldName: "id",
          fieldLabel: "Id"
          // User can override but we provide default
        },
        {
          appFieldName: "credits",
          fieldLabel: "Credits"
          // User can override but we provide default
        },
        {
          appFieldName: "moduleId",
          fieldLabel: "Module Id"
          // User can override but we provide default
        },
        {
          appFieldName: "code",
          appProperty: null,
          fieldExtId: null,
          fieldLabel: "Code"
        },
        {
          appFieldName: "courseCode",
          appProperty: null,
          fieldExtId: null,
          fieldLabel: "Course Code"
        },
        {
          appFieldName: "department",
          appProperty: null,
          fieldExtId: null,
          fieldLabel: "Department"
        }
      ]
    },
    {
      applicationObjectTypeName: "coursePart",
      applicationObjectTypeGroup: e.EApplicationObjectTypeGroup.COURSE_INFORMATION,
      objectTypeExtId: null,
      // This is set in the mapping by the user, not in the template
      applicationObjectTypeLabel: "Course Part",
      // User is free to override, but we provide a default
      status: e.EObjectTypeMappingStatuses.NOT_MAPPED,
      labelField: null,
      secondaryLabelField: null,
      fields: [
        {
          appFieldName: "name",
          fieldLabel: "Name"
          // User can override but we provide default
        },
        {
          appFieldName: "id",
          fieldLabel: "Id"
          // User can override but we provide default
        },
        {
          appFieldName: "credits",
          fieldLabel: "Credits"
          // User can override but we provide default
        },
        {
          appFieldName: "code",
          appProperty: null,
          fieldExtId: null,
          fieldLabel: "Code"
        },
        {
          appFieldName: "courseCode",
          appProperty: null,
          fieldExtId: null,
          fieldLabel: "Course Code"
        },
        {
          appFieldName: "department",
          appProperty: null,
          fieldExtId: null,
          fieldLabel: "Department"
        }
      ]
    },
    {
      applicationObjectTypeName: "program",
      applicationObjectTypeGroup: e.EApplicationObjectTypeGroup.COURSE_INFORMATION,
      objectTypeExtId: null,
      // This is set in the mapping by the user, not in the template
      applicationObjectTypeLabel: "Program",
      // User is free to override, but we provide a default
      status: e.EObjectTypeMappingStatuses.NOT_MAPPED,
      labelField: null,
      secondaryLabelField: null,
      fields: [
        {
          appFieldName: "name",
          fieldLabel: "Name"
          // User can override but we provide default
        },
        {
          appFieldName: "id",
          fieldLabel: "Id"
          // User can override but we provide default
        },
        {
          appFieldName: "number",
          fieldLabel: "Number"
          // User can override but we provide default
        },
        {
          appFieldName: "code",
          appProperty: null,
          fieldExtId: null,
          fieldLabel: "Code"
        },
        {
          appFieldName: "credits",
          appProperty: null,
          fieldExtId: null,
          fieldLabel: "Credits"
        },
        {
          appFieldName: "courseCode",
          appProperty: null,
          fieldExtId: null,
          fieldLabel: "Course Code"
        },
        {
          appFieldName: "department",
          appProperty: null,
          fieldExtId: null,
          fieldLabel: "Department"
        }
      ]
    },
    {
      applicationObjectTypeName: "studentGroup",
      applicationObjectTypeGroup: e.EApplicationObjectTypeGroup.COURSE_INFORMATION,
      objectTypeExtId: null,
      // This is set in the mapping by the user, not in the template
      applicationObjectTypeLabel: "Student Group",
      // User is free to override, but we provide a default
      status: e.EObjectTypeMappingStatuses.NOT_MAPPED,
      labelField: null,
      secondaryLabelField: null,
      fields: [
        {
          appFieldName: "name",
          fieldLabel: "Name"
          // User can override but we provide default
        },
        {
          appFieldName: "id",
          fieldLabel: "Id"
          // User can override but we provide default
        },
        {
          appFieldName: "number",
          fieldLabel: "Number"
          // User can override but we provide default
        },
        {
          appFieldName: "courseName",
          fieldLabel: "Course name"
          // User can override but we provide default
        },
        {
          appFieldName: "courseCode",
          fieldLabel: "Course code"
          // User can override but we provide default
        },
        {
          appFieldName: "department",
          fieldLabel: "Department"
          // User can override but we provide default
        }
      ]
    },
    {
      applicationObjectTypeName: "costCenter",
      applicationObjectTypeGroup: e.EApplicationObjectTypeGroup.INVOICING,
      objectTypeExtId: null,
      // This is set in the mapping by the user, not in the template
      applicationObjectTypeLabel: "Cost center",
      // User is free to override, but we provide a default
      status: e.EObjectTypeMappingStatuses.NOT_MAPPED,
      labelField: null,
      secondaryLabelField: null,
      fields: [
        {
          appFieldName: "name",
          fieldLabel: "Name"
          // User can override but we provide default
        },
        {
          appFieldName: "id",
          fieldLabel: "Id"
          // User can override but we provide default
        }
      ]
    },
    {
      applicationObjectTypeName: "department",
      applicationObjectTypeGroup: e.EApplicationObjectTypeGroup.INVOICING,
      objectTypeExtId: null,
      // This is set in the mapping by the user, not in the template
      applicationObjectTypeLabel: "Department",
      // User is free to override, but we provide a default
      status: e.EObjectTypeMappingStatuses.NOT_MAPPED,
      labelField: null,
      secondaryLabelField: null,
      fields: [
        {
          appFieldName: "name",
          fieldLabel: "Name"
          // User can override but we provide default
        },
        {
          appFieldName: "code",
          fieldLabel: "code"
          // User can override but we provide default
        }
      ]
    },
    {
      applicationObjectTypeName: "externalCustomer",
      applicationObjectTypeGroup: e.EApplicationObjectTypeGroup.INVOICING,
      objectTypeExtId: null,
      // This is set in the mapping by the user, not in the template
      applicationObjectTypeLabel: "External Customer",
      // User is free to override, but we provide a default
      status: e.EObjectTypeMappingStatuses.NOT_MAPPED,
      labelField: null,
      secondaryLabelField: null,
      fields: [
        {
          appFieldName: "name",
          fieldLabel: "Name"
          // User can override but we provide default
        },
        {
          appFieldName: "id",
          fieldLabel: "Id"
          // User can override but we provide default
        }
      ]
    }
  ], Ki;
}
var yt = {}, xd;
function GO() {
  return xd || (xd = 1, Object.defineProperty(yt, "__esModule", { value: !0 }), yt.mongoReactSortOrderMapping = yt.mongoSortOrders = yt.studentSetGenerationStatusStringValues = yt.dataManagerObjectReviewStatusses = yt.generateStudentSetsSortableFields = yt.reviewByCourseSortableFields = yt.reviewByStudyCombinationSortableFields = void 0, yt.reviewByStudyCombinationSortableFields = [
    "inputObject.inputContent.expectedEnrollment",
    "inputObject.inputContent.status",
    "reviewStatus",
    "metadata.courses",
    "metadata.totalCredits",
    "inputObject.inputContent.historicalEnrollmentCopyForSortingAndFiltering"
  ], yt.reviewByCourseSortableFields = [
    "name",
    "combinationIds",
    "expectedEnrollmentOfCourse",
    "expectedEnrollmentOfStudyCombinations",
    "expectedEnrollmentDiff",
    "numberOfStudyCombinations"
  ], yt.generateStudentSetsSortableFields = [
    "studentSetGenerationStatusString",
    "metadata.courses",
    "inputObject.inputContent.historicalEnrollmentCopyForSortingAndFiltering"
  ], yt.dataManagerObjectReviewStatusses = ["NOT_REVIEWED", "KEEP", "REJECTED", "DELETED"], yt.studentSetGenerationStatusStringValues = [
    "ACTIVITY_DATA_ERROR",
    "GENERATION_ERROR",
    "ALLOCATION_ERROR",
    "DEALLOCATION_ERROR",
    "COMPLETE",
    "GENERATING",
    "STUDENT_SETS_GENERATED",
    "STUDENT_SETS_ALLOCATED"
  ], yt.mongoSortOrders = [-1, 1], yt.mongoReactSortOrderMapping = {
    asc: 1,
    desc: -1
  }), yt;
}
var Ot = {}, kd;
function zO() {
  return kd || (kd = 1, Object.defineProperty(Ot, "__esModule", { value: !0 }), Ot.CALENDAR_WEEK_MODE = Ot.FORM_SOURCE = Ot.AUTO_CALCULATION = Ot.EVENT_OUTSIDE_ENUM = Ot.FORM_TYPE = Ot.FORM_STATUS_TYPE = void 0, Ot.FORM_STATUS_TYPE = {
    FORM_STATUS_DRAFT: "FORM_STATUS_DRAFT",
    FORM_STATUS_ACTIVE: "FORM_STATUS_ACTIVE",
    FORM_STATUS_ARCHIVED: "FORM_STATUS_ARCHIVED",
    FORM_STATUS_PUBLISHED: "FORM_STATUS_PUBLISHED"
  }, Ot.FORM_TYPE = {
    REGULAR: "REGULAR",
    AVAILABILITY: "AVAILABILITY",
    UNAVAILABILITY: "UNAVAILABILITY",
    PATHWAYS: "PATHWAYS"
  }, Ot.EVENT_OUTSIDE_ENUM = {
    MANUAL: "MANUAL",
    MODIFY: "MODIFY",
    REMOVE: "REMOVE"
  }, Ot.AUTO_CALCULATION = {
    TRACKS: "TRACKS",
    MAX_CLASS_SIZE: "MAX_CLASS_SIZE",
    OFF: "OFF"
  }, Ot.FORM_SOURCE = {
    ACTIVITY_CREATE_TEMPLATE: "ACTIVITY_CREATE_TEMPLATE"
  }, Ot.CALENDAR_WEEK_MODE = {
    INDIVIDUAL: "individual",
    RECURRING: "recurring"
  }), Ot;
}
var cs = {}, jd;
function BO() {
  return jd || (jd = 1, Object.defineProperty(cs, "__esModule", { value: !0 }), cs.FORM_INSTANCE_STATUS_TYPE = void 0, cs.FORM_INSTANCE_STATUS_TYPE = {
    NOT_SENT: "NOT_SENT",
    SENT: "SENT",
    OPENED: "OPENED",
    DRAFT: "DRAFT",
    SUBMITTED: "SUBMITTED",
    OVERDUE: "OVERDUE",
    INVALIDATE: "INVALIDATE",
    DECLINED: "DECLINED",
    COLLABORATED: "COLLABORATED"
  }), cs;
}
var ai = {}, Ud;
function VO() {
  return Ud || (Ud = 1, Object.defineProperty(ai, "__esModule", { value: !0 }), ai.TE_CORE_SCHEDULING_PROGRESS = ai.TE_CORE_ACCEPTANCE_STATUS = void 0, ai.TE_CORE_ACCEPTANCE_STATUS = {
    NOT_SET: "NOT_SET",
    ACCEPTED: "ACCEPTED",
    REJECTED: "REJECTED"
  }, ai.TE_CORE_SCHEDULING_PROGRESS = {
    NOT_SCHEDULED: "NOT_SCHEDULED",
    IN_PROGRESS: "IN_PROGRESS",
    SCHEDULING_FINISHED: "SCHEDULING_FINISHED"
  }), ai;
}
var ui = {}, $d;
function WO() {
  return $d || ($d = 1, Object.defineProperty(ui, "__esModule", { value: !0 }), ui.pathwayStatuses = ui.pathwaysNameSuffixTypes = void 0, ui.pathwaysNameSuffixTypes = {
    ALPHA: "ALPHA",
    DECIMAL: "DECIMAL",
    ROMAN: "ROMAN"
  }, ui.pathwayStatuses = {
    NEW: "NEW",
    ACCEPTED: "ACCEPTED",
    EDITED: "EDITED",
    REJECTED: "REJECTED"
  }), ui;
}
var Wr = {}, Fd;
function qO() {
  return Fd || (Fd = 1, Object.defineProperty(Wr, "__esModule", { value: !0 }), Wr.exportedUserColumns = Wr.TEUserImportPropertiesArr = Wr.userProfilePropertiesArr = void 0, Wr.userProfilePropertiesArr = [
    "id",
    "legacyId",
    "profileName",
    "description",
    "contactEmail",
    "standardOrganization",
    "organizationsAndRoles",
    "scopes",
    "appPermissions",
    "userObjects",
    "inactiveSince"
  ], Wr.TEUserImportPropertiesArr = [
    "inactiveSince",
    "username",
    "email",
    "firstName",
    "lastName",
    "language",
    "dateFormat",
    "timezone",
    "displayTimezones",
    "visibility",
    "personalData",
    "description",
    "recoveryEmail",
    "contactEmail",
    "standardOrganization",
    "organizationsAndRoles",
    "scopes",
    "appPermissions",
    "userObjects",
    "lockedForExternalAuthentication"
  ], Wr.exportedUserColumns = {
    id: "Profile ID",
    profileName: "Profile Name",
    email: "Email",
    username: "User Name",
    firstName: "First Name",
    lastName: "Last Name",
    contactEmail: "Contact Email",
    userObjects: "User Objects",
    standardOrganization: "Standard Organization",
    organizationsAndRoles: "Org Nodes & Roles",
    scopes: "Scopes",
    appPermissions: "App Permissions",
    language: "Language",
    inactiveSince: "Inactive Since",
    logins: "Last Login",
    visibility: "Visibility",
    description: "Description",
    lockedForExternalAuthentication: "Locked for External Authentication"
  }), Wr;
}
var fs = {}, Gd;
function HO() {
  return Gd || (Gd = 1, Object.defineProperty(fs, "__esModule", { value: !0 }), fs.TERootUserInfoPropertiesArr = void 0, fs.TERootUserInfoPropertiesArr = ["id", "firstName", "lastName", "email"]), fs;
}
var ds = {}, zd;
function YO() {
  return zd || (zd = 1, Object.defineProperty(ds, "__esModule", { value: !0 }), ds.FINGERPRINT_COOKIE_NAME = void 0, ds.FINGERPRINT_COOKIE_NAME = "te_fingerprint"), ds;
}
var Xi = {}, Bd;
function Cy() {
  if (Bd) return Xi;
  Bd = 1, Object.defineProperty(Xi, "__esModule", { value: !0 }), Xi.REGION_LOCATIONS = void 0;
  const e = nc();
  return Xi.REGION_LOCATIONS = {
    [e.ERegion.ANZ]: "anz",
    [e.ERegion.EU_EES]: "eu",
    [e.ERegion.SGP]: "sgp",
    [e.ERegion.UK]: "uk"
  }, Xi;
}
var Vd;
function Py() {
  return Vd || (Vd = 1, (function(e) {
    var t = oi && oi.__createBinding || (Object.create ? (function(l, f, u, h) {
      h === void 0 && (h = u);
      var E = Object.getOwnPropertyDescriptor(f, u);
      (!E || ("get" in E ? !f.__esModule : E.writable || E.configurable)) && (E = { enumerable: !0, get: function() {
        return f[u];
      } }), Object.defineProperty(l, h, E);
    }) : (function(l, f, u, h) {
      h === void 0 && (h = u), l[h] = f[u];
    })), r = oi && oi.__exportStar || function(l, f) {
      for (var u in l) u !== "default" && !Object.prototype.hasOwnProperty.call(f, u) && t(f, l, u);
    };
    Object.defineProperty(e, "__esModule", { value: !0 }), e.DefaultTEExamObjectTypesMapping = e.ObjectTypeGroupProps = e.AppPropertyProps = e.ObjectTypeMappingStatusProps = e.FieldMappingModeProps = e.SERVICE_ACCOUNT = e.TE_ROOT_USER = e.SCOPE_LEVEL_SUPER = e.SCOPE_LEVEL_ADMIN = e.ScopeLevelArr = e.AppIdsArr = void 0;
    const n = _O();
    Object.defineProperty(e, "AppIdsArr", { enumerable: !0, get: function() {
      return n.AppIdsArr;
    } });
    const i = Ay();
    Object.defineProperty(e, "ScopeLevelArr", { enumerable: !0, get: function() {
      return i.ScopeLevelArr;
    } }), Object.defineProperty(e, "SCOPE_LEVEL_ADMIN", { enumerable: !0, get: function() {
      return i.SCOPE_LEVEL_ADMIN;
    } }), Object.defineProperty(e, "SCOPE_LEVEL_SUPER", { enumerable: !0, get: function() {
      return i.SCOPE_LEVEL_SUPER;
    } }), Object.defineProperty(e, "TE_ROOT_USER", { enumerable: !0, get: function() {
      return i.TE_ROOT_USER;
    } }), Object.defineProperty(e, "SERVICE_ACCOUNT", { enumerable: !0, get: function() {
      return i.SERVICE_ACCOUNT;
    } });
    const o = UO();
    Object.defineProperty(e, "FieldMappingModeProps", { enumerable: !0, get: function() {
      return o.FieldMappingModeProps;
    } });
    const s = $O();
    Object.defineProperty(e, "AppPropertyProps", { enumerable: !0, get: function() {
      return s.AppPropertyProps;
    } }), Object.defineProperty(e, "ObjectTypeMappingStatusProps", { enumerable: !0, get: function() {
      return s.ObjectTypeMappingStatusProps;
    } }), Object.defineProperty(e, "ObjectTypeGroupProps", { enumerable: !0, get: function() {
      return s.ObjectTypeGroupProps;
    } });
    const a = FO();
    Object.defineProperty(e, "DefaultTEExamObjectTypesMapping", { enumerable: !0, get: function() {
      return a.DefaultTEExamObjectTypesMapping;
    } }), e.default = {
      AppIdsArr: n.AppIdsArr,
      ScopeLevelArr: i.ScopeLevelArr,
      SCOPE_LEVEL_ADMIN: i.SCOPE_LEVEL_ADMIN,
      SCOPE_LEVEL_SUPER: i.SCOPE_LEVEL_SUPER,
      TE_ROOT_USER: i.TE_ROOT_USER,
      SERVICE_ACCOUNT: i.SERVICE_ACCOUNT,
      FieldMappingModeProps: o.FieldMappingModeProps,
      ObjectTypeMappingStatusProps: s.ObjectTypeMappingStatusProps,
      AppPropertyProps: s.AppPropertyProps,
      ObjectTypeGroupProps: s.ObjectTypeGroupProps,
      DefaultTEExamObjectTypesMapping: a.DefaultTEExamObjectTypesMapping
    }, r(GO(), e), r(zO(), e), r(BO(), e), r(VO(), e), r(WO(), e), r(qO(), e), r(HO(), e), r(YO(), e), r(Cy(), e);
  })(oi)), oi;
}
var li = {}, Wd = {}, qd;
function ZO() {
  return qd || (qd = 1, Object.defineProperty(Wd, "__esModule", { value: !0 })), Wd;
}
var Hd = {}, Yd;
function JO() {
  return Yd || (Yd = 1, Object.defineProperty(Hd, "__esModule", { value: !0 })), Hd;
}
var ps = {}, Zd;
function KO() {
  return Zd || (Zd = 1, Object.defineProperty(ps, "__esModule", { value: !0 }), ps.SERVICE_ACCOUNT_USE_WITH_CAUTION = void 0, ps.SERVICE_ACCOUNT_USE_WITH_CAUTION = "SERVICE_ACCOUNT_USE_WITH_CAUTION"), ps;
}
var Jd = {}, Kd;
function XO() {
  return Kd || (Kd = 1, Object.defineProperty(Jd, "__esModule", { value: !0 })), Jd;
}
var Xd = {}, Qd;
function QO() {
  return Qd || (Qd = 1, Object.defineProperty(Xd, "__esModule", { value: !0 })), Xd;
}
var ep = {}, tp;
function ew() {
  return tp || (tp = 1, Object.defineProperty(ep, "__esModule", { value: !0 })), ep;
}
var rp = {}, np;
function tw() {
  return np || (np = 1, Object.defineProperty(rp, "__esModule", { value: !0 })), rp;
}
var ip = {}, op;
function rw() {
  return op || (op = 1, Object.defineProperty(ip, "__esModule", { value: !0 })), ip;
}
var sp = {}, ap;
function nw() {
  return ap || (ap = 1, Object.defineProperty(sp, "__esModule", { value: !0 })), sp;
}
var up = {}, lp;
function iw() {
  return lp || (lp = 1, Object.defineProperty(up, "__esModule", { value: !0 })), up;
}
var cp = {}, fp;
function ow() {
  return fp || (fp = 1, Object.defineProperty(cp, "__esModule", { value: !0 })), cp;
}
var dp = {}, pp;
function sw() {
  return pp || (pp = 1, Object.defineProperty(dp, "__esModule", { value: !0 })), dp;
}
var hp = {}, mp;
function aw() {
  return mp || (mp = 1, Object.defineProperty(hp, "__esModule", { value: !0 })), hp;
}
var vr = {}, Ep;
function uw() {
  if (Ep) return vr;
  Ep = 1, Object.defineProperty(vr, "__esModule", { value: !0 }), vr.EFullWeekDays = vr.ETimeScope = vr.EDynamicAvailabilityType = void 0;
  var e;
  (function(n) {
    n.TOTAL_HOURS = "TOTAL_HOURS", n.CONSECUTIVE_HOURS = "CONSECUTIVE_HOURS", n.FREE_TIME = "FREE_TIME", n.TOTAL_RESERVATIONS = "TOTAL_RESERVATIONS";
  })(e || (vr.EDynamicAvailabilityType = e = {}));
  var t;
  (function(n) {
    n.DAILY = "DAILY", n.WEEKLY = "WEEKLY";
  })(t || (vr.ETimeScope = t = {}));
  var r;
  return (function(n) {
    n.SUNDAY = "SUNDAY", n.MONDAY = "MONDAY", n.TUESDAY = "TUESDAY", n.WEDNESDAY = "WEDNESDAY", n.THURSDAY = "THURSDAY", n.FRIDAY = "FRIDAY", n.SATURDAY = "SATURDAY";
  })(r || (vr.EFullWeekDays = r = {})), vr;
}
var gp = {}, yp;
function lw() {
  return yp || (yp = 1, Object.defineProperty(gp, "__esModule", { value: !0 })), gp;
}
var Tp = {}, bp;
function cw() {
  return bp || (bp = 1, Object.defineProperty(Tp, "__esModule", { value: !0 })), Tp;
}
var Ap = {}, vp;
function fw() {
  return vp || (vp = 1, Object.defineProperty(Ap, "__esModule", { value: !0 })), Ap;
}
var Sp;
function dw() {
  return Sp || (Sp = 1, (function(e) {
    var t = li && li.__createBinding || (Object.create ? (function(u, h, E, d) {
      d === void 0 && (d = E);
      var g = Object.getOwnPropertyDescriptor(h, E);
      (!g || ("get" in g ? !h.__esModule : g.writable || g.configurable)) && (g = { enumerable: !0, get: function() {
        return h[E];
      } }), Object.defineProperty(u, d, g);
    }) : (function(u, h, E, d) {
      d === void 0 && (d = E), u[d] = h[E];
    })), r = li && li.__exportStar || function(u, h) {
      for (var E in u) E !== "default" && !Object.prototype.hasOwnProperty.call(h, E) && t(h, u, E);
    };
    Object.defineProperty(e, "__esModule", { value: !0 }), e.SERVICE_ACCOUNT_USE_WITH_CAUTION = e.ETokenType = e.EWeekdaySelection = e.EWeekdays = e.EReservationPeriodType = e.ERelativeTimeTypes = e.EPermissionTypes = e.EExternalServices = e.EExternalServiceMethods = e.EAuth = e.EAppId = void 0;
    var n = ec();
    Object.defineProperty(e, "EAppId", { enumerable: !0, get: function() {
      return n.EAppId;
    } });
    var i = vy();
    Object.defineProperty(e, "EAuth", { enumerable: !0, get: function() {
      return i.EAuth;
    } });
    var o = Sy();
    Object.defineProperty(e, "EExternalServiceMethods", { enumerable: !0, get: function() {
      return o.EExternalServiceMethods;
    } }), Object.defineProperty(e, "EExternalServices", { enumerable: !0, get: function() {
      return o.EExternalServices;
    } });
    var s = tc();
    Object.defineProperty(e, "EPermissionTypes", { enumerable: !0, get: function() {
      return s.EPermissionTypes;
    } });
    var a = Iy();
    Object.defineProperty(e, "ERelativeTimeTypes", { enumerable: !0, get: function() {
      return a.ERelativeTimeTypes;
    } }), Object.defineProperty(e, "EReservationPeriodType", { enumerable: !0, get: function() {
      return a.EReservationPeriodType;
    } }), Object.defineProperty(e, "EWeekdays", { enumerable: !0, get: function() {
      return a.EWeekdays;
    } }), Object.defineProperty(e, "EWeekdaySelection", { enumerable: !0, get: function() {
      return a.EWeekdaySelection;
    } });
    var l = _y();
    Object.defineProperty(e, "ETokenType", { enumerable: !0, get: function() {
      return l.ETokenType;
    } }), r(ZO(), e), r(JO(), e);
    var f = KO();
    Object.defineProperty(e, "SERVICE_ACCOUNT_USE_WITH_CAUTION", { enumerable: !0, get: function() {
      return f.SERVICE_ACCOUNT_USE_WITH_CAUTION;
    } }), r(rc(), e), r(XO(), e), r(QO(), e), r(ew(), e), r(tw(), e), r(rw(), e), r(nw(), e), r(iw(), e), r(ow(), e), r(sw(), e), r(aw(), e), r(uw(), e), r(lw(), e), r(cw(), e), r(fw(), e);
  })(li)), li;
}
var Ip = {}, Qi = {}, eo = {}, _p;
function pw() {
  if (_p) return eo;
  _p = 1, Object.defineProperty(eo, "__esModule", { value: !0 }), eo.ESAMLParameterType = void 0;
  var e;
  return (function(t) {
    t.CUSTOM_PARAMETERS = "CUSTOM_PARAMETERS", t.RELAY_STATE = "RELAY_STATE";
  })(e || (eo.ESAMLParameterType = e = {})), eo;
}
var Rp;
function hw() {
  if (Rp) return Qi;
  Rp = 1, Object.defineProperty(Qi, "__esModule", { value: !0 }), Qi.createAuthConfig = void 0;
  const e = Rt(), t = pw(), r = rc(), n = (i) => {
    var o, s, a, l;
    return {
      id: i.id,
      name: i.name,
      description: i.description,
      strategy: i.strategy || e.EAuthStrategy.TE_IDP,
      config: i.strategy === e.EAuthStrategy.SAML2 ? Object.assign(Object.assign({}, i.config), { parameterType: ((o = i.config) === null || o === void 0 ? void 0 : o.parameterType) || t.ESAMLParameterType.CUSTOM_PARAMETERS, signAuthnRequest: (a = (s = i.config) === null || s === void 0 ? void 0 : s.signAuthnRequest) !== null && a !== void 0 ? a : !0, identifierFormat: ((l = i.config) === null || l === void 0 ? void 0 : l.identifierFormat) || r.SAMLIdentifierFormat.Email }) : Object.assign(Object.assign({}, i.config), { useMFA: i.config.useMFA || !1 }),
      active: i.active || !1,
      default: i.default || !1,
      enabledForAppIds: i.enabledForAppIds || []
    };
  };
  return Qi.createAuthConfig = n, Qi;
}
var to = {}, En = {}, Op;
function mw() {
  if (Op) return En;
  Op = 1, Object.defineProperty(En, "__esModule", { value: !0 }), En.EImportStatus = En.EImportType = void 0;
  var e;
  (function(r) {
    r.ORGANIZATION_HIERARCHY = "ORGANIZATION_HIERARCHY", r.USERS = "USERS", r.AUTH_CONFIGS = "AUTH_CONFIGS";
  })(e || (En.EImportType = e = {}));
  var t;
  return (function(r) {
    r.SUCCESS = "SUCCESS", r.FAILURE = "FAILURE";
  })(t || (En.EImportStatus = t = {})), En;
}
var wp;
function Ew() {
  if (wp) return to;
  wp = 1, Object.defineProperty(to, "__esModule", { value: !0 }), to.createImport = void 0;
  const e = mw(), t = (r) => ({
    id: r.id,
    type: r.type || e.EImportType.ORGANIZATION_HIERARCHY,
    settings: r.settings || { fromCustomerSignature: "" },
    status: r.status || e.EImportStatus.FAILURE,
    log: r.log || [],
    timestamp: r.timestamp
  });
  return to.createImport = t, to;
}
var ro = {}, Np;
function gw() {
  if (Np) return ro;
  Np = 1, Object.defineProperty(ro, "__esModule", { value: !0 }), ro.createAltDesignation = void 0;
  const e = (t) => ({
    language: t,
    name: "",
    description: ""
  });
  return ro.createAltDesignation = e, ro;
}
var no = {}, io = {}, Cp;
function Dy() {
  if (Cp) return io;
  Cp = 1, Object.defineProperty(io, "__esModule", { value: !0 }), io.EOrganizationVisibility = void 0;
  var e;
  return (function(t) {
    t.PUBLIC = "PUBLIC", t.HIDDEN = "HIDDEN", t.PRIVATE = "PRIVATE";
  })(e || (io.EOrganizationVisibility = e = {})), io;
}
var Pp;
function yw() {
  if (Pp) return no;
  Pp = 1, Object.defineProperty(no, "__esModule", { value: !0 }), no.createOrganization = void 0;
  const e = Rt(), t = Dy(), r = (n) => ({
    id: n.id,
    name: n.name,
    customerSignature: n.customerSignature,
    customerLogo: n.customerLogo,
    customerColor: n.customerColor,
    teServerUrl: n.teServerUrl,
    public: n.public,
    inactive: !1,
    inactiveSince: null,
    enabledProducts: n.enabledProducts || [],
    type: n.type || e.EOrganizationType.CUSTOMER_PRODUCTION,
    visibility: n.visibility || t.EOrganizationVisibility.PUBLIC,
    rootUserPermissions: n.rootUserPermissions || [],
    rootUserStandardOrganizationNode: n.rootUserStandardOrganizationNode,
    region: n.region,
    cluster: n.cluster,
    database: n.database,
    language: n.language,
    dateFormat: n.dateFormat
  });
  return no.createOrganization = r, no;
}
var oo = {}, Dp;
function Tw() {
  if (Dp) return oo;
  Dp = 1, Object.defineProperty(oo, "__esModule", { value: !0 }), oo.createOrganizationNode = void 0;
  const e = (t) => ({
    id: t.id,
    extId: t.extId || void 0,
    legacyId: t.legacyId || void 0,
    name: t.name,
    description: t.description || void 0,
    parentNodeIds: t.parentNodeIds || []
  });
  return oo.createOrganizationNode = e, oo;
}
var Mp = {}, Lp;
function bw() {
  return Lp || (Lp = 1, (function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.createOrganizationTreeNode = void 0;
    const t = (r) => ({
      id: r.id,
      children: (r.children || []).map((n) => (0, e.createOrganizationTreeNode)(n)),
      name: r.name,
      virtualId: r.virtualId
    });
    e.createOrganizationTreeNode = t;
  })(Mp)), Mp;
}
var so = {}, xp;
function Aw() {
  if (xp) return so;
  xp = 1, Object.defineProperty(so, "__esModule", { value: !0 }), so.createPaddingRule = void 0;
  const e = Rt(), t = (r) => ({
    id: r.id,
    paddingType: r.paddingType || e.EPaddingRuleType.DIRECT,
    name: r.name || "",
    description: r.description || "",
    includeAbstractObjects: r.includeAbstractObjects || !1,
    rule: r.rule || {
      objectsOnReservation: [],
      impactedObjects: [],
      paddingBefore: 0,
      paddingAfter: 0
    },
    history: r.history
  });
  return so.createPaddingRule = t, so;
}
var ao = {}, kp;
function vw() {
  if (kp) return ao;
  kp = 1, Object.defineProperty(ao, "__esModule", { value: !0 }), ao.createPermission = void 0;
  const e = Rt(), t = (r) => ({
    type: r.type || e.EPermissionTypes.SCOPE,
    value: r.value,
    name: r.name,
    description: r.description || void 0,
    requiredScopeLevel: r.requiredScopeLevel || void 0
  });
  return ao.createPermission = t, ao;
}
var Sr = {}, jp;
function Sw() {
  if (jp) return Sr;
  jp = 1, Object.defineProperty(Sr, "__esModule", { value: !0 }), Sr.createRolePermissionGroup = Sr.createRolePermission = Sr.createRole = void 0;
  const e = (n) => ({
    id: n.id,
    name: n.name,
    description: n.description || "",
    rolePermissions: n.rolePermissions || []
  });
  Sr.createRole = e;
  const t = (n) => ({
    id: n.id,
    name: n.name,
    rolePermissionGroup: n.rolePermissionGroup,
    groupActions: n.groupActions || []
  });
  Sr.createRolePermission = t;
  const r = (n) => ({
    id: n.id,
    groupActions: n.groupActions || []
  });
  return Sr.createRolePermissionGroup = r, Sr;
}
var uo = {}, Up;
function Iw() {
  if (Up) return uo;
  Up = 1, Object.defineProperty(uo, "__esModule", { value: !0 }), uo.createSOAPConnectionSettings = void 0;
  const e = (t) => ({
    username: t.username || "",
    password: t.password || "",
    certificateKey: t.certificateKey || "",
    baseUrl: t.baseUrl || ""
  });
  return uo.createSOAPConnectionSettings = e, uo;
}
var Qt = {}, $p;
function _w() {
  if ($p) return Qt;
  $p = 1, Object.defineProperty(Qt, "__esModule", { value: !0 }), Qt.createEmptyTWeekdaySelection = Qt.createTTime = Qt.createEmptyTTime = Qt.createEmptyTTimeRule = void 0;
  const e = Rt(), t = () => ({
    name: "",
    id: 0,
    description: "",
    history: [],
    weekdays: [e.EWeekdays.MON, e.EWeekdays.TUE, e.EWeekdays.WED, e.EWeekdays.THU, e.EWeekdays.FRI, e.EWeekdays.SAT, e.EWeekdays.SUN],
    clockTimeStart: 28800,
    clockTimeEnd: 64800,
    standardStep: 900,
    minimumStep: 900,
    beginStep: 900,
    importStep: 900,
    minimumLength: 1800,
    maximumLength: 86400,
    defaultLength: 3600,
    beginOffset: 0,
    relativeStartTime: -15552e3,
    relativeEndTime: 4752e4,
    useStartTimeToOpenNextDay: !1,
    useSeparateCancellationRules: !1,
    relativeCancellationStartTime: -15552e3,
    relativeCancellationEndTime: 4752e4,
    reservationPeriod1: e.EReservationPeriodType.NONE,
    reservationLength1: 0,
    reservationCount1: 0,
    reservationPeriod2: e.EReservationPeriodType.NONE,
    reservationLength2: 0,
    reservationCount2: 0,
    useModifiedByWhenCalculatingUserQuota: !1,
    templates: []
  });
  Qt.createEmptyTTimeRule = t;
  const r = () => ({
    clockTimeStart: 28800,
    clockTimeEnd: 36e3
  });
  Qt.createEmptyTTime = r;
  const n = (o, s) => ({
    clockTimeStart: o,
    clockTimeEnd: s
  });
  Qt.createTTime = n;
  const i = () => ({
    weekdays: [],
    times: []
  });
  return Qt.createEmptyTWeekdaySelection = i, Qt;
}
var Lt = {}, Fp;
function Rw() {
  if (Fp) return Lt;
  Fp = 1, Object.defineProperty(Lt, "__esModule", { value: !0 }), Lt.createUnsignedFromM2MUser = Lt.createUnsignedReadOnlyFromTERootUser = Lt.createUnsignedFromTERootUser = Lt.createUnsignedReadOnlyFromTEUser = Lt.createUnsignedFromTEUser = void 0;
  const e = Rt(), t = Ay(), r = (a, l, f, u) => {
    var h;
    return {
      region: l,
      id: a.id || "",
      type: e.ETokenType.USER,
      username: a.username,
      email: a.email,
      organizationId: f,
      customerSignature: u,
      appPermissions: a.appPermissions,
      scopes: a.scopes,
      profile: { id: a.id, profileName: a.profileName },
      profiles: ((h = a.profiles) === null || h === void 0 ? void 0 : h.filter(({ inactiveSince: E }) => E === null).map(({ id: E, profileName: d }) => ({ id: E, profileName: d }))) || [],
      organizationsAndRoles: a.organizationsAndRoles
    };
  };
  Lt.createUnsignedFromTEUser = r;
  const n = (a, l, f, u) => ({
    region: l,
    id: a.id || "",
    type: e.ETokenType.USER,
    email: a.email,
    username: a.username,
    organizationId: f,
    customerSignature: u,
    appPermissions: [],
    scopes: ["TE_Viewer::readOnly"]
  });
  Lt.createUnsignedReadOnlyFromTEUser = n;
  const i = (a, l, f, u) => ({
    region: l,
    id: a.id || "",
    type: e.ETokenType.USER,
    email: a.email,
    organizationId: f,
    customerSignature: u,
    appPermissions: [],
    scopes: [t.TE_ROOT_USER]
  });
  Lt.createUnsignedFromTERootUser = i;
  const o = (a, l, f, u) => ({
    region: l,
    id: a.id || "",
    type: e.ETokenType.USER,
    email: a.email,
    organizationId: f,
    customerSignature: u,
    appPermissions: [],
    scopes: ["TE_Viewer::readOnly"]
  });
  Lt.createUnsignedReadOnlyFromTERootUser = o;
  const s = (a, l, f, u) => ({
    region: l,
    id: a.id || "",
    type: e.ETokenType.M2M,
    organizationId: f,
    customerSignature: u,
    appPermissions: a.appPermissions,
    scopes: a.scopes,
    organizationsAndRoles: a.organizationsAndRoles
  });
  return Lt.createUnsignedFromM2MUser = s, Lt;
}
var lo = {}, Gp;
function Ow() {
  if (Gp) return lo;
  Gp = 1, Object.defineProperty(lo, "__esModule", { value: !0 }), lo.createTokenPermissions = void 0;
  const e = (t) => ({
    appPermissions: t.appPermissions || [],
    scopes: t.scopes || []
  });
  return lo.createTokenPermissions = e, lo;
}
var co = {}, zp;
function ww() {
  if (zp) return co;
  zp = 1, Object.defineProperty(co, "__esModule", { value: !0 }), co.createEmptyType = void 0;
  const e = () => ({
    name: "",
    extId: "",
    id: 0,
    active: !0,
    personalData: !1,
    sensitiveData: !1,
    description: "",
    altDesignations: [],
    allowStandardObjects: !1,
    allowAbstractObjects: !1,
    allowVirtualObjects: !1,
    personType: !1,
    locationType: !1,
    aliasType: 0,
    externalOwner: "",
    subTypes: [],
    fields: [],
    parentFields: [],
    organizations: [],
    reservationTemplates: [],
    documentation: "",
    history: [],
    skipLastReserved: !1
  });
  return co.createEmptyType = e, co;
}
var Bp = {}, Vp;
function Nw() {
  return Vp || (Vp = 1, (function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.createUserCSVMapper = e.mapUserCSVData = e.getLabelForUser = e.createFromTemplateWithNewUsernameAndAuthConfig = e.createUser = void 0;
    const t = Py(), r = Rt(), n = (u) => ({
      inactiveSince: u.inactiveSince,
      id: u.id,
      /**
       * DESCRIPTIVES
       */
      username: u.username,
      email: u.email,
      firstName: u.firstName,
      lastName: u.lastName,
      recoveryEmail: u.recoveryEmail,
      contactEmail: u.contactEmail,
      /**
       * LEGACY INFORMATION
       */
      legacyId: u.legacyId || null,
      /**
       * CONFIG SETTINGS
       */
      language: u.language,
      dateFormat: u.dateFormat,
      displayTimezones: u.displayTimezones,
      timezone: u.timezone,
      visibility: u.visibility || r.EUserVisibility.STANDARD,
      personalData: u.personalData,
      description: u.description,
      /**
       * ORGANIZATIONS AND PERMISSIONS
       */
      standardOrganization: u.standardOrganization,
      organizationsAndRoles: u.organizationsAndRoles,
      scopes: u.scopes,
      appPermissions: u.appPermissions,
      profileName: u.profileName,
      profiles: u.profiles,
      /**
       * USER OBJECTS
       */
      userObjects: u.userObjects,
      /**
       * AUTH CONFIGS
       */
      authConfigId: u.authConfigId,
      logins: u.logins || [],
      createdBy: u.createdBy,
      history: u.history || [],
      lockedForExternalAuthentication: u.lockedForExternalAuthentication || !1,
      createdAt: u.createdAt,
      updatedAt: u.updatedAt
    });
    e.createUser = n;
    const i = (u, h, E) => ({
      inactiveSince: null,
      id: u.id,
      /**
       * DESCRIPTIVES
       */
      username: h,
      email: "",
      firstName: null,
      lastName: null,
      recoveryEmail: null,
      contactEmail: null,
      /**
       * LEGACY INFORMATION
       */
      legacyId: null,
      /**
       * CONFIG SETTINGS
       */
      language: u.language,
      dateFormat: u.dateFormat,
      displayTimezones: u.displayTimezones,
      timezone: u.timezone,
      visibility: r.EUserVisibility.STANDARD,
      personalData: !0,
      description: null,
      /**
       * ORGANIZATIONS AND PERMISSIONS
       */
      standardOrganization: u.standardOrganization,
      organizationsAndRoles: u.organizationsAndRoles,
      scopes: u.scopes,
      appPermissions: u.appPermissions,
      /**
       * USER OBJECTS
       */
      userObjects: u.userObjects,
      /**
       * AUTH CONFIGS
       */
      authConfigId: E,
      logins: [],
      createdBy: "External IdP",
      history: [],
      lockedForExternalAuthentication: !1
    });
    e.createFromTemplateWithNewUsernameAndAuthConfig = i;
    const o = (u) => u.firstName && u.lastName ? `${u.firstName} ${u.lastName}` : u.username ? u.username : u.email ? u.email : "";
    e.getLabelForUser = o;
    const s = {
      id: (u) => u.toString(),
      appPermissions: (u) => u.join(", "),
      lockedForExternalAuthentication: (u) => u ? "Yes" : "No",
      organizationsAndRoles: (u, h) => u.map(([E, d]) => [h[E], d].join("|")).join("; "),
      scopes: (u) => u.join(", "),
      standardOrganization: (u, h) => u && h[u] || u,
      userObjects: (u) => u.join(", "),
      inactiveSince: (u) => u ? new Date(u * 1e3).toISOString() : null,
      logins: (u) => u.length === 0 ? "never" : new Date(u[0].login * 1e3).toISOString()
    }, a = (u) => Object.entries(u), l = (u, h) => {
      const E = Object.keys(t.exportedUserColumns).reduce((d, g) => (d[g] = u[g], d), {});
      return a(E).forEach(([d, g]) => {
        var y;
        const b = s[d];
        E[d] = (y = b == null ? void 0 : b(g, h)) !== null && y !== void 0 ? y : g;
      }), E;
    };
    e.mapUserCSVData = l;
    const f = (u) => (h) => (0, e.mapUserCSVData)(h, u);
    e.createUserCSVMapper = f;
  })(Bp)), Bp;
}
var fo = {}, Wp;
function Cw() {
  if (Wp) return fo;
  Wp = 1, Object.defineProperty(fo, "__esModule", { value: !0 }), fo.createM2MUser = void 0;
  const e = Rt(), t = (r) => ({
    inactiveSince: r.inactiveSince,
    id: r.id,
    /**
     * DESCRIPTIVES
     */
    name: r.name,
    contactEmail: r.contactEmail,
    /**
     * CONFIG SETTINGS
     */
    language: r.language,
    visibility: r.visibility || e.EUserVisibility.STANDARD,
    description: r.description,
    /**
     * ORGANIZATIONS AND PERMISSIONS
     */
    standardOrganization: r.standardOrganization,
    organizationsAndRoles: r.organizationsAndRoles,
    scopes: r.scopes,
    appPermissions: r.appPermissions,
    /**
     * AUTH CONFIGS
     */
    createdBy: r.createdBy,
    history: r.history || [],
    createdAt: r.createdAt,
    updatedAt: r.updatedAt
  });
  return fo.createM2MUser = t, fo;
}
var Ir = {}, qp;
function Pw() {
  if (qp) return Ir;
  qp = 1, Object.defineProperty(Ir, "__esModule", { value: !0 }), Ir.createEmptyAPIProperty = Ir.createEmptyAPIPropertyGroup = Ir.createEmptyApi = void 0;
  const e = () => ({
    isActive: !0,
    id: 0,
    name: "",
    signature: "",
    validFrom: null,
    expires: null,
    certificateName: "",
    certificateRegistered: Date.now(),
    certificateExpires: 0,
    certificateIssuer: "-",
    propertyGroups: [],
    description: ""
  });
  Ir.createEmptyApi = e;
  const t = () => ({
    id: 0,
    signature: "",
    name: "",
    properties: []
  });
  Ir.createEmptyAPIPropertyGroup = t;
  const r = () => ({
    id: 0,
    signature: "",
    name: "",
    isActive: !0,
    description: "",
    organizations: [],
    properties: ""
  });
  return Ir.createEmptyAPIProperty = r, Ir;
}
var gn = {}, Hp;
function Dw() {
  if (Hp) return gn;
  Hp = 1, Object.defineProperty(gn, "__esModule", { value: !0 }), gn.createAvailabilityTypesItem = gn.createEmptyAvailabilityRelationType = void 0;
  const e = () => ({
    name: "",
    extId: "",
    id: 0,
    description: "",
    constitutesObstacles: !1,
    occupiedByDefault: !1,
    availabilityTypes: []
  });
  gn.createEmptyAvailabilityRelationType = e;
  const t = (r) => ({
    type: r,
    ownObject: !1,
    userObject: !1
  });
  return gn.createAvailabilityTypesItem = t, gn;
}
var yn = {}, Yp;
function Mw() {
  if (Yp) return yn;
  Yp = 1, Object.defineProperty(yn, "__esModule", { value: !0 }), yn.createEmptyField = yn.createEmptyCategory = void 0;
  const e = Ry(), t = () => ({
    label: ""
  });
  yn.createEmptyCategory = t;
  const r = () => ({
    fieldType: "",
    name: "",
    id: 0,
    extId: "",
    personalData: e.EPersonalDataCheck.NO,
    description: "",
    altDesignations: [],
    filter: e.EPreferencesFilter.CHOICE1,
    length: 0,
    min: 0,
    max: 100,
    sumType: 0,
    topLevelType: 0,
    titleType: 0,
    refSeparator: " ",
    searchableInReservationList: !1,
    reservationTextField: !1,
    mandatory: !1,
    unique: !1,
    multiple: !1,
    editable: !1,
    searchable: !1,
    listable: !1,
    primary: !1,
    sortable: !1,
    virtualCategory: "",
    abstractCategory: "",
    defaultValue: "",
    checkSum: 0,
    categories: [],
    referenceFields: [],
    types: [],
    reservationTemplates: [],
    organizations: [],
    documentation: "",
    history: [],
    memberMaxCount: !1,
    memberMaxType: 0
  });
  return yn.createEmptyField = r, yn;
}
var po = {}, Zp;
function Lw() {
  if (Zp) return po;
  Zp = 1, Object.defineProperty(po, "__esModule", { value: !0 }), po.createEmptyFieldRelation = void 0;
  const e = () => ({
    name: "",
    id: 0,
    description: "",
    sourceField: null,
    matchField: null,
    operator: null,
    matchMode: null,
    reservationTemplates: [],
    documentation: "",
    history: []
  });
  return po.createEmptyFieldRelation = e, po;
}
var Tn = {}, ho = {}, Jp;
function xw() {
  if (Jp) return ho;
  Jp = 1, Object.defineProperty(ho, "__esModule", { value: !0 }), ho.EReservationKindMemberType = void 0;
  var e;
  return (function(t) {
    t.ABSTRACT = "ABSTRACT", t.PHYSICAL = "PHYSICAL";
  })(e || (ho.EReservationKindMemberType = e = {})), ho;
}
var Kp;
function kw() {
  if (Kp) return Tn;
  Kp = 1, Object.defineProperty(Tn, "__esModule", { value: !0 }), Tn.createEmptyMemberType = Tn.createMemberTypesItem = void 0;
  const e = xw(), t = (n, i) => ({
    type: n,
    memberLevel: i
  });
  Tn.createMemberTypesItem = t;
  const r = () => ({
    name: "",
    id: 0,
    reservationKind: e.EReservationKindMemberType.PHYSICAL,
    description: "",
    memberTypes: []
  });
  return Tn.createEmptyMemberType = r, Tn;
}
var er = {}, Xp;
function jw() {
  if (Xp) return er;
  Xp = 1, Object.defineProperty(er, "__esModule", { value: !0 }), er.createEmptyTEObject = er.createAvailabilityRelations = er.createDateRangeRelations = er.createDateRange = void 0;
  const e = Rt(), t = 31556926, r = (s) => ({
    objectId: s,
    start: parseInt((Date.now() / 1e3).toFixed(), 10),
    end: parseInt((Date.now() / 1e3).toFixed(), 10) + t
  });
  er.createDateRange = r;
  const n = (s) => ({
    objectIds: [s],
    start: parseInt((Date.now() / 1e3).toFixed(), 10),
    end: parseInt((Date.now() / 1e3).toFixed(), 10) + t
  });
  er.createDateRangeRelations = n;
  const i = (s) => ({
    availabilityTypeId: s,
    objectIds: []
  });
  er.createAvailabilityRelations = i;
  const o = (s, a) => ({
    id: 0,
    extId: "",
    property: e.EProperty.STANDARD,
    personalInformation: e.EPersonalInformation.STANDARD,
    fields: a.map((l) => ({ fieldId: l, values: [] })),
    types: [s],
    created: parseInt((Date.now() / 1e3).toFixed(), 10),
    createdBy: "",
    active: !0,
    members: [],
    relations: [],
    availabilityRelations: [],
    optionalRelations: [],
    organizations: []
  });
  return er.createEmptyTEObject = o, er;
}
var bn = {}, Qp;
function Uw() {
  if (Qp) return bn;
  Qp = 1, Object.defineProperty(bn, "__esModule", { value: !0 }), bn.createEmptyPeriod = bn.createPeriodInterval = void 0;
  const e = Oy(), t = (o) => o === e.ETimeIntervals.WEEK ? 1 : o === e.ETimeIntervals.YEAR ? 2021 : o === e.ETimeIntervals.MONTH ? 2 : o === e.ETimeIntervals.DATE ? 2021.01 : o === e.ETimeIntervals.DAY || o === e.ETimeIntervals.WEEKDAY ? 1 : o === e.ETimeIntervals.TIME ? 0 : o === e.ETimeIntervals.WEEK_NUMBER ? 1 : Date.now(), r = (o) => o === e.ETimeIntervals.WEEK ? 52 : o === e.ETimeIntervals.YEAR ? 2022 : o === e.ETimeIntervals.MONTH ? 12 : o === e.ETimeIntervals.DATE ? 2022.01 : o === e.ETimeIntervals.DAY ? 28 : o === e.ETimeIntervals.WEEKDAY ? 6 : o === e.ETimeIntervals.TIME ? 17 : o === e.ETimeIntervals.WEEK_NUMBER ? 52 : Date.now(), n = (o) => ({
    type: o,
    start: t(o),
    end: r(o)
  });
  bn.createPeriodInterval = n;
  const i = () => ({
    name: "",
    shortName: "",
    id: 0,
    description: "",
    userAccess: e.EPeriodAccess.PUBLIC,
    intervals: [],
    childPeriods: [],
    history: []
  });
  return bn.createEmptyPeriod = i, bn;
}
var An = {}, eh;
function $w() {
  if (eh) return An;
  eh = 1, Object.defineProperty(An, "__esModule", { value: !0 }), An.createEmptyRelationType = An.createRelationTypesItem = void 0;
  const e = wy(), t = (n) => ({
    type: n,
    helpType: !1
  });
  An.createRelationTypesItem = t;
  const r = () => ({
    name: "",
    id: 0,
    description: "",
    relationType: e.ERelationType.USE_ONLY,
    relationTypes: [],
    reservationTemplates: []
  });
  return An.createEmptyRelationType = r, An;
}
var _r = {}, th;
function Fw() {
  if (th) return _r;
  th = 1, Object.defineProperty(_r, "__esModule", { value: !0 }), _r.createEmptyReservationTemplate = _r.createTemplateType = _r.createEmptyReservationMode = void 0;
  const e = Ny(), t = () => ({
    name: "",
    extId: "",
    id: 0,
    description: "",
    showInClient: !1,
    showInCulling: !1,
    altDesignations: [],
    reservationTemplates: [],
    documentation: "",
    history: []
  });
  _r.createEmptyReservationMode = t;
  const r = (i) => ({
    type: i,
    min: 1,
    max: 5,
    reservationKind: e.EReservationKind.ABSTRACT,
    mandatoryProperty: e.EMandatoryProperty.OPTIONAL,
    objectProperty: e.EObjectProperty.OBJECT,
    memberType: 0,
    availabilityType: 0,
    requestType: !1,
    cancelNoPermisson: !1,
    optionalRelation: e.EOptionalRelation.NONE,
    automaticObjectSelection: !1,
    reservationText: e.ETemplateTypesText.STANDARD,
    obstacleText: e.ETemplateTypesText.STANDARD,
    padding: !1,
    sizeReservationType: !1
  });
  _r.createTemplateType = r;
  const n = () => ({
    name: "",
    templateType: e.ETemplateType.RESERVATION,
    timeRule: 0,
    privateRole: 0,
    standardOrganization: 0,
    defaultStatus: e.EDefaultStatus.CONFIRMED,
    active: !0,
    affectOrders: !1,
    id: 0,
    deleteWhenCulling: !1,
    types: [],
    typeCombinations: [],
    relationTypes: [],
    fields: [],
    reservationModes: [],
    organizations: [],
    documentation: "This is some documentation",
    history: [],
    objectSizeFieldId: 0,
    objectSizeSecondFieldId: 0,
    objectCapacityFieldId: 0
  });
  return _r.createEmptyReservationTemplate = n, _r;
}
var vn = {}, rh;
function Gw() {
  if (rh) return vn;
  rh = 1, Object.defineProperty(vn, "__esModule", { value: !0 }), vn.createTimeZone = vn.createEmptyTimeZone = void 0;
  const e = () => ({
    id: 0,
    extId: "",
    name: "",
    timeZone: "",
    identifiers: [],
    daylightSavingsTime: "",
    isDefault: !1,
    offset: ""
  });
  vn.createEmptyTimeZone = e;
  const t = (r) => ({
    id: r.id,
    extId: r.extId,
    name: r.name,
    identifiers: r.identifiers,
    timeZone: r.zoneId,
    daylightSavingsTime: r.daylightSavingsTime,
    isDefault: r.isDefault,
    offset: r.offset
  });
  return vn.createTimeZone = t, vn;
}
var nh = {}, ih;
function zw() {
  return ih || (ih = 1, (function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.createReservationMapping = e.createReservationParamMapping = void 0;
    const t = (n) => ({
      appFieldId: n.appFieldId || "",
      fieldLabel: n.fieldLabel || "",
      fieldExt: n.fieldExt || ""
    });
    e.createReservationParamMapping = t;
    const r = (n) => ({
      appId: n.appId,
      paramMappings: (n.paramMappings || []).map(e.createReservationParamMapping)
    });
    e.createReservationMapping = r;
  })(nh)), nh;
}
var Sn = {}, oh;
function Bw() {
  if (oh) return Sn;
  oh = 1, Object.defineProperty(Sn, "__esModule", { value: !0 }), Sn.createFieldMapping = Sn.createObjectTypeMapping = void 0;
  const e = Rt(), t = (n) => ({
    applicationObjectTypeName: n.applicationObjectTypeName || "",
    applicationObjectTypeGroup: n.applicationObjectTypeGroup || "",
    objectTypeExtId: n.objectTypeExtId || null,
    objectTypeId: n.objectTypeId || null,
    applicationObjectTypeLabel: n.applicationObjectTypeLabel || "",
    status: n.status || e.EObjectTypeMappingStatuses.NOT_MAPPED,
    labelField: n.labelField || null,
    secondaryLabelField: n.secondaryLabelField || null,
    fields: n.fields || ""
  });
  Sn.createObjectTypeMapping = t;
  const r = (n) => ({
    appFieldName: n.appFieldName || "",
    appProperty: n.appProperty || "",
    isSearchable: n.isSearchable || "",
    defaultSorting: n.defaultSorting,
    fieldExtId: n.fieldExtId || null,
    fieldId: n.fieldId || null,
    fieldLabel: n.fieldLabel || "",
    allocationFieldFromObject: n.allocationFieldFromObject || ""
  });
  return Sn.createFieldMapping = r, Sn;
}
var sh = {}, ah;
function Vw() {
  return ah || (ah = 1, (function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.getRedirectUri = e.getCustomerPrefix = e.removeCloudPrefix = e.transformCustomerSignature = e.transformCustomerSignatureDashed = e.redirectURIs = void 0;
    const t = Cy(), r = "timeedit.dev", n = "timeedit.io", i = "test.timeedit.net", o = "timeedit.net";
    e.redirectURIs = {
      development: {
        TE_ADMIN: (u) => "http://localhost:3004",
        TE_ALLOCATE: (u) => "http://localhost:5174",
        TE_AUTOPILOT: (u) => "",
        TE_CORE: (u) => `https://core.timeedit.dev/${u}/client`,
        TE_CURRICULUM: (u) => "http://localhost:3000",
        TE_DATA_MANAGER: (u) => "http://localhost:3060",
        TE_EVALUATION: (u) => "http://localhost:3000",
        TE_EXAM: (u) => "http://localhost:3999",
        TE_EXAM_V3: (u) => `http://localhost:3000/${u}`,
        TE_HUB: (u) => `http://localhost:3008/${u}`,
        TE_PLAN: (u) => `https://cloud.timeedit.net/${u}/web`,
        TE_PORTAL: (u) => `http://localhost:1337/${u}`,
        TE_PREFERENCES: (u) => "http://localhost:3005",
        TE_REGISTRATION: (u) => "http://localhost:5173",
        TE_REPORTING: (u) => "http://localhost:3201",
        TE_RESERVE: (u) => `https://cloud.timeedit.net/${u}/web`,
        TE_STUDY_GUIDE: (u) => "http://localhost:3000",
        TE_STUDY_PLANNER: (u) => `http://localhost:3030/${u}`,
        TE_VIEWER: (u) => `https://cloud.timeedit.net/${u}/web`,
        TE_WORKLOAD: (u) => "http://localhost:3000"
      },
      beta: {
        TE_ADMIN: (u) => `https://admin.timeedit.dev/${(0, e.transformCustomerSignature)(u)}`,
        TE_ALLOCATE: (u) => `https://allocate.timeedit.dev/${(0, e.transformCustomerSignature)(u)}`,
        TE_AUTOPILOT: (u) => "",
        TE_CORE: (u) => `https://core.timeedit.dev/${(0, e.transformCustomerSignature)(u)}/client`,
        TE_CURRICULUM: (u) => `https://${(0, e.transformCustomerSignatureDashed)(u)}.curriculum.timeedit.dev`,
        TE_DATA_MANAGER: (u) => `https://data-manager.timeedit.dev/${(0, e.transformCustomerSignature)(u)}`,
        TE_EVALUATION: (u) => `https://${(0, e.transformCustomerSignatureDashed)(u)}.evaluation.timeedit.dev`,
        TE_EXAM: (u) => `https://exam.timeedit.dev/${(0, e.transformCustomerSignature)(u)}`,
        TE_EXAM_V3: (u) => `https://assessment.timeedit.dev/${(0, e.transformCustomerSignature)(u)}`,
        TE_HUB: (u) => `https://hub.timeedit.dev/${(0, e.transformCustomerSignature)(u)}`,
        TE_PLAN: (u) => `https://cloud.timeedit.dev/${(0, e.transformCustomerSignature)(u)}/web`,
        TE_PORTAL: (u) => `https://portal.timeedit.dev/${(0, e.transformCustomerSignature)(u)}`,
        TE_PREFERENCES: (u) => "https://new-preferences.timeedit.dev",
        TE_REGISTRATION: (u) => `https://registration.timeedit.dev/${(0, e.transformCustomerSignature)(u)}`,
        TE_REPORTING: (u) => "https://reporting.timeedit.dev",
        TE_RESERVE: (u) => `https://cloud.timeedit.dev/${(0, e.transformCustomerSignature)(u)}/web`,
        TE_STUDY_GUIDE: (u) => `https://${(0, e.transformCustomerSignatureDashed)(u)}.studyguide.timeedit.dev`,
        TE_STUDY_PLANNER: (u, h) => l(r, u, h),
        TE_VIEWER: (u) => `https://cloud.timeedit.dev/${(0, e.transformCustomerSignature)(u)}/web`,
        TE_WORKLOAD: (u) => `https://${(0, e.transformCustomerSignatureDashed)(u)}.curriculum.timeedit.dev`
      },
      staging: {
        TE_ADMIN: (u) => `https://admin.timeedit.io/${(0, e.transformCustomerSignature)(u)}`,
        TE_ALLOCATE: (u) => `https://allocate.timeedit.io/${(0, e.transformCustomerSignature)(u)}`,
        TE_AUTOPILOT: (u) => "",
        TE_CORE: (u) => `https://core.timeedit.io/${(0, e.transformCustomerSignature)(u)}/client`,
        TE_CURRICULUM: (u) => `https://${(0, e.transformCustomerSignatureDashed)(u)}.curriculum.timeedit.io`,
        TE_DATA_MANAGER: (u) => `https://data-manager.timeedit.io/${(0, e.transformCustomerSignature)(u)}`,
        TE_EVALUATION: (u) => `https://${(0, e.transformCustomerSignatureDashed)(u)}.evaluation.timeedit.io`,
        TE_EXAM: (u) => `https://exam-v3.timeedit.io/${(0, e.transformCustomerSignature)(u)}`,
        TE_EXAM_V3: (u) => `https://assessment.timeedit.io/${(0, e.transformCustomerSignature)(u)}`,
        TE_HUB: (u) => `https://hub.timeedit.io/${(0, e.transformCustomerSignature)(u)}`,
        TE_PLAN: (u) => `https://cloud.timeedit.io/${(0, e.transformCustomerSignature)(u)}/web`,
        TE_PORTAL: (u) => `https://portal.timeedit.io/${(0, e.transformCustomerSignature)(u)}`,
        TE_PREFERENCES: (u) => "https://new-preferences.timeedit.io",
        TE_REGISTRATION: (u) => `https://registration.timeedit.io/${(0, e.transformCustomerSignature)(u)}`,
        TE_REPORTING: (u) => "https://reporting.timeedit.io",
        TE_RESERVE: (u) => `https://cloud.timeedit.io/${(0, e.transformCustomerSignature)(u)}/web`,
        TE_STUDY_GUIDE: (u) => `https://${(0, e.transformCustomerSignatureDashed)(u)}.studyguide.timeedit.io`,
        TE_STUDY_PLANNER: (u, h) => l(n, u, h),
        TE_VIEWER: (u) => `https://cloud.timeedit.io/${(0, e.transformCustomerSignature)(u)}/web`,
        TE_WORKLOAD: (u) => `https://${(0, e.transformCustomerSignatureDashed)(u)}.curriculum.timeedit.io`
      },
      test: {
        TE_ADMIN: (u) => `https://admin.test.timeedit.net/${(0, e.transformCustomerSignature)(u)}`,
        TE_ALLOCATE: (u) => `https://allocate.test.timeedit.net/${(0, e.transformCustomerSignature)(u)}`,
        TE_AUTOPILOT: (u) => "",
        TE_CORE: (u) => `https://core.test.timeedit.net/${(0, e.transformCustomerSignature)(u)}/client`,
        TE_CURRICULUM: (u) => `https://${(0, e.transformCustomerSignatureDashed)(u)}.curriculum.test.timeedit.net`,
        TE_DATA_MANAGER: (u) => `https://data-manager.test.timeedit.net/${(0, e.transformCustomerSignature)(u)}`,
        TE_EVALUATION: (u) => `https://${(0, e.transformCustomerSignatureDashed)(u)}.evaluation.test.timeedit.net`,
        TE_EXAM: (u) => `https://exam.test.timeedit.net/${(0, e.transformCustomerSignature)(u)}`,
        TE_EXAM_V3: (u) => `https://assessment.test.timeedit.net/${(0, e.transformCustomerSignature)(u)}`,
        TE_HUB: (u) => `https://hub.test.timeedit.net/${(0, e.transformCustomerSignature)(u)}`,
        TE_PLAN: (u) => `https://cloud.test.timeedit.net/${(0, e.transformCustomerSignature)(u)}/web`,
        TE_PORTAL: (u) => `http://portal.test.timeedit.net/${(0, e.transformCustomerSignature)(u)}`,
        TE_PREFERENCES: (u) => "https://preferences.test.timeedit.net",
        TE_REGISTRATION: (u) => `https://registration.test.timeedit.net/${(0, e.transformCustomerSignature)(u)}`,
        TE_REPORTING: (u) => "https://reporting.test.timeedit.net",
        TE_RESERVE: (u) => `https://cloud.test.timeedit.net/${(0, e.transformCustomerSignature)(u)}/web`,
        TE_STUDY_GUIDE: (u) => `https://${(0, e.transformCustomerSignatureDashed)(u)}.studyguide.test.timeedit.net`,
        TE_STUDY_PLANNER: (u, h) => l(i, u, h),
        TE_VIEWER: (u) => `https://cloud.test.timeedit.net/${(0, e.transformCustomerSignature)(u)}/web`,
        TE_WORKLOAD: (u) => `https://${(0, e.transformCustomerSignatureDashed)(u)}.curriculum.test.timeedit.net`
      },
      production: {
        TE_ADMIN: (u) => `https://admin.timeedit.net/${(0, e.transformCustomerSignature)(u)}`,
        TE_ALLOCATE: (u) => `https://allocate.timeedit.net/${(0, e.transformCustomerSignature)(u)}`,
        TE_AUTOPILOT: (u) => "",
        TE_CORE: (u) => `https://core.timeedit.net/${(0, e.transformCustomerSignature)(u)}/client`,
        TE_CURRICULUM: (u) => `https://${(0, e.transformCustomerSignatureDashed)(u)}.curriculum.timeedit.net`,
        TE_DATA_MANAGER: (u) => `https://data-manager.timeedit.net/${(0, e.transformCustomerSignature)(u)}`,
        TE_EVALUATION: (u) => `https://${(0, e.transformCustomerSignatureDashed)(u)}.evaluation.timeedit.net`,
        TE_EXAM: (u) => `https://exam.timeedit.net/${(0, e.transformCustomerSignature)(u)}`,
        TE_EXAM_V3: (u) => `https://assessment.timeedit.net/${(0, e.transformCustomerSignature)(u)}`,
        TE_HUB: (u) => `https://hub.timeedit.net/${(0, e.transformCustomerSignature)(u)}`,
        TE_PLAN: (u) => `https://cloud.timeedit.net/${(0, e.transformCustomerSignature)(u)}/web`,
        TE_PORTAL: (u) => `https://portal.timeedit.net/${(0, e.transformCustomerSignature)(u)}`,
        TE_PREFERENCES: (u) => "https://preferences.timeedit.net",
        TE_REGISTRATION: (u) => `https://registration.timeedit.net/${(0, e.transformCustomerSignature)(u)}`,
        TE_REPORTING: (u) => "https://reporting.timeedit.net",
        TE_RESERVE: (u) => `https://cloud.timeedit.net/${(0, e.transformCustomerSignature)(u)}/web`,
        TE_STUDY_GUIDE: (u) => `https://${(0, e.transformCustomerSignatureDashed)(u)}.studyguide.timeedit.net`,
        TE_STUDY_PLANNER: (u, h) => l(o, u, h),
        TE_VIEWER: (u) => `https://cloud.timeedit.net/${(0, e.transformCustomerSignature)(u)}/web`,
        TE_WORKLOAD: (u) => `https://${(0, e.transformCustomerSignatureDashed)(u)}.curriculum.timeedit.net`
      }
    };
    const s = (u) => u.replace(/_/g, "-").replace(/^cloud-/, "");
    e.transformCustomerSignatureDashed = s;
    const a = (u) => u.replace(/^cloud_/, "");
    e.transformCustomerSignature = a, e.removeCloudPrefix = e.transformCustomerSignature, e.getCustomerPrefix = e.transformCustomerSignatureDashed;
    const l = (u, h, E) => `https://${E ? `studyplanner.${t.REGION_LOCATIONS[E]}.${u}` : `studyplanner.${u}`}/${(0, e.transformCustomerSignature)(h)}`, f = (u, h, E, d) => {
      var g;
      const y = (g = e.redirectURIs[E]) === null || g === void 0 ? void 0 : g[u];
      if (typeof y == "function")
        return y(h, d);
    };
    e.getRedirectUri = f;
  })(sh)), sh;
}
var mo = {}, uh;
function Ww() {
  if (uh) return mo;
  uh = 1, Object.defineProperty(mo, "__esModule", { value: !0 }), mo.convertPartialAttributesRowToAffiliation = e, mo.convertPartialAttributesMatchingToAffiliations = t;
  function e(r, n, i) {
    const [o, s, a, l, f] = r, u = o.map(([E, d]) => ({
      attribute: E,
      value: d
    })), h = s.map(([E, d]) => ({
      organizationId: E,
      role: d
    }));
    return {
      authConfigId: n,
      label: f,
      priority: i,
      matchingCriteria: u,
      organizationsAndRoles: h,
      scopes: [],
      appPermissions: [],
      userObjects: l,
      standardOrganization: a
    };
  }
  function t(r, n) {
    return r.map((i, o) => e(i, n, o));
  }
  return mo;
}
var lh;
function qw() {
  return lh || (lh = 1, (function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.createReservationParamMapping = e.createReservationMapping = e.createTimeZone = e.createTemplateType = e.createEmptyReservationTemplate = e.createEmptyReservationMode = e.createEmptyRelationType = e.createRelationTypesItem = e.createPeriodInterval = e.createEmptyPeriod = e.createEmptyTEObject = e.createDateRangeRelations = e.createAvailabilityRelations = e.createDateRange = e.createMemberTypesItem = e.createEmptyMemberType = e.createEmptyFieldRelation = e.createEmptyCategory = e.createEmptyField = e.createAvailabilityTypesItem = e.createEmptyAvailabilityRelationType = e.createEmptyApi = e.createM2MUser = e.mapUserCSVData = e.getLabelForUser = e.createUser = e.createUserCSVMapper = e.createEmptyType = e.createTokenPermissions = e.createUnsignedReadOnlyFromTEUser = e.createUnsignedReadOnlyFromTERootUser = e.createUnsignedFromTERootUser = e.createUnsignedFromM2MUser = e.createUnsignedFromTEUser = e.createEmptyTTime = e.createEmptyTTimeRule = e.createEmptyTWeekdaySelection = e.createTTime = e.createSOAPConnectionSettings = e.createRolePermissionGroup = e.createRolePermission = e.createRole = e.createPermission = e.createPaddingRule = e.createOrganizationTreeNode = e.createOrganizationNode = e.createOrganization = e.createAltDesignation = e.createImport = e.createAuthConfig = void 0, e.convertPartialAttributesMatchingToAffiliations = e.convertPartialAttributesRowToAffiliation = e.redirectURIs = e.getRedirectUri = e.createFieldMapping = e.createObjectTypeMapping = void 0;
    var t = hw();
    Object.defineProperty(e, "createAuthConfig", { enumerable: !0, get: function() {
      return t.createAuthConfig;
    } });
    var r = Ew();
    Object.defineProperty(e, "createImport", { enumerable: !0, get: function() {
      return r.createImport;
    } });
    var n = gw();
    Object.defineProperty(e, "createAltDesignation", { enumerable: !0, get: function() {
      return n.createAltDesignation;
    } });
    var i = yw();
    Object.defineProperty(e, "createOrganization", { enumerable: !0, get: function() {
      return i.createOrganization;
    } });
    var o = Tw();
    Object.defineProperty(e, "createOrganizationNode", { enumerable: !0, get: function() {
      return o.createOrganizationNode;
    } });
    var s = bw();
    Object.defineProperty(e, "createOrganizationTreeNode", { enumerable: !0, get: function() {
      return s.createOrganizationTreeNode;
    } });
    var a = Aw();
    Object.defineProperty(e, "createPaddingRule", { enumerable: !0, get: function() {
      return a.createPaddingRule;
    } });
    var l = vw();
    Object.defineProperty(e, "createPermission", { enumerable: !0, get: function() {
      return l.createPermission;
    } });
    var f = Sw();
    Object.defineProperty(e, "createRole", { enumerable: !0, get: function() {
      return f.createRole;
    } }), Object.defineProperty(e, "createRolePermission", { enumerable: !0, get: function() {
      return f.createRolePermission;
    } }), Object.defineProperty(e, "createRolePermissionGroup", { enumerable: !0, get: function() {
      return f.createRolePermissionGroup;
    } });
    var u = Iw();
    Object.defineProperty(e, "createSOAPConnectionSettings", { enumerable: !0, get: function() {
      return u.createSOAPConnectionSettings;
    } });
    var h = _w();
    Object.defineProperty(e, "createTTime", { enumerable: !0, get: function() {
      return h.createTTime;
    } }), Object.defineProperty(e, "createEmptyTWeekdaySelection", { enumerable: !0, get: function() {
      return h.createEmptyTWeekdaySelection;
    } }), Object.defineProperty(e, "createEmptyTTimeRule", { enumerable: !0, get: function() {
      return h.createEmptyTTimeRule;
    } }), Object.defineProperty(e, "createEmptyTTime", { enumerable: !0, get: function() {
      return h.createEmptyTTime;
    } });
    var E = Rw();
    Object.defineProperty(e, "createUnsignedFromTEUser", { enumerable: !0, get: function() {
      return E.createUnsignedFromTEUser;
    } }), Object.defineProperty(e, "createUnsignedFromM2MUser", { enumerable: !0, get: function() {
      return E.createUnsignedFromM2MUser;
    } }), Object.defineProperty(e, "createUnsignedFromTERootUser", { enumerable: !0, get: function() {
      return E.createUnsignedFromTERootUser;
    } }), Object.defineProperty(e, "createUnsignedReadOnlyFromTERootUser", { enumerable: !0, get: function() {
      return E.createUnsignedReadOnlyFromTERootUser;
    } }), Object.defineProperty(e, "createUnsignedReadOnlyFromTEUser", { enumerable: !0, get: function() {
      return E.createUnsignedReadOnlyFromTEUser;
    } });
    var d = Ow();
    Object.defineProperty(e, "createTokenPermissions", { enumerable: !0, get: function() {
      return d.createTokenPermissions;
    } });
    var g = ww();
    Object.defineProperty(e, "createEmptyType", { enumerable: !0, get: function() {
      return g.createEmptyType;
    } });
    var y = Nw();
    Object.defineProperty(e, "createUserCSVMapper", { enumerable: !0, get: function() {
      return y.createUserCSVMapper;
    } }), Object.defineProperty(e, "createUser", { enumerable: !0, get: function() {
      return y.createUser;
    } }), Object.defineProperty(e, "getLabelForUser", { enumerable: !0, get: function() {
      return y.getLabelForUser;
    } }), Object.defineProperty(e, "mapUserCSVData", { enumerable: !0, get: function() {
      return y.mapUserCSVData;
    } });
    var b = Cw();
    Object.defineProperty(e, "createM2MUser", { enumerable: !0, get: function() {
      return b.createM2MUser;
    } });
    var _ = Pw();
    Object.defineProperty(e, "createEmptyApi", { enumerable: !0, get: function() {
      return _.createEmptyApi;
    } });
    var I = Dw();
    Object.defineProperty(e, "createEmptyAvailabilityRelationType", { enumerable: !0, get: function() {
      return I.createEmptyAvailabilityRelationType;
    } }), Object.defineProperty(e, "createAvailabilityTypesItem", { enumerable: !0, get: function() {
      return I.createAvailabilityTypesItem;
    } });
    var w = Mw();
    Object.defineProperty(e, "createEmptyField", { enumerable: !0, get: function() {
      return w.createEmptyField;
    } }), Object.defineProperty(e, "createEmptyCategory", { enumerable: !0, get: function() {
      return w.createEmptyCategory;
    } });
    var L = Lw();
    Object.defineProperty(e, "createEmptyFieldRelation", { enumerable: !0, get: function() {
      return L.createEmptyFieldRelation;
    } });
    var R = kw();
    Object.defineProperty(e, "createEmptyMemberType", { enumerable: !0, get: function() {
      return R.createEmptyMemberType;
    } }), Object.defineProperty(e, "createMemberTypesItem", { enumerable: !0, get: function() {
      return R.createMemberTypesItem;
    } });
    var D = jw();
    Object.defineProperty(e, "createDateRange", { enumerable: !0, get: function() {
      return D.createDateRange;
    } }), Object.defineProperty(e, "createAvailabilityRelations", { enumerable: !0, get: function() {
      return D.createAvailabilityRelations;
    } }), Object.defineProperty(e, "createDateRangeRelations", { enumerable: !0, get: function() {
      return D.createDateRangeRelations;
    } }), Object.defineProperty(e, "createEmptyTEObject", { enumerable: !0, get: function() {
      return D.createEmptyTEObject;
    } });
    var P = Uw();
    Object.defineProperty(e, "createEmptyPeriod", { enumerable: !0, get: function() {
      return P.createEmptyPeriod;
    } }), Object.defineProperty(e, "createPeriodInterval", { enumerable: !0, get: function() {
      return P.createPeriodInterval;
    } });
    var O = $w();
    Object.defineProperty(e, "createRelationTypesItem", { enumerable: !0, get: function() {
      return O.createRelationTypesItem;
    } }), Object.defineProperty(e, "createEmptyRelationType", { enumerable: !0, get: function() {
      return O.createEmptyRelationType;
    } });
    var F = Fw();
    Object.defineProperty(e, "createEmptyReservationMode", { enumerable: !0, get: function() {
      return F.createEmptyReservationMode;
    } }), Object.defineProperty(e, "createEmptyReservationTemplate", { enumerable: !0, get: function() {
      return F.createEmptyReservationTemplate;
    } }), Object.defineProperty(e, "createTemplateType", { enumerable: !0, get: function() {
      return F.createTemplateType;
    } });
    var U = Gw();
    Object.defineProperty(e, "createTimeZone", { enumerable: !0, get: function() {
      return U.createTimeZone;
    } });
    var z = zw();
    Object.defineProperty(e, "createReservationMapping", { enumerable: !0, get: function() {
      return z.createReservationMapping;
    } }), Object.defineProperty(e, "createReservationParamMapping", { enumerable: !0, get: function() {
      return z.createReservationParamMapping;
    } });
    var V = Bw();
    Object.defineProperty(e, "createObjectTypeMapping", { enumerable: !0, get: function() {
      return V.createObjectTypeMapping;
    } }), Object.defineProperty(e, "createFieldMapping", { enumerable: !0, get: function() {
      return V.createFieldMapping;
    } });
    var ae = Vw();
    Object.defineProperty(e, "getRedirectUri", { enumerable: !0, get: function() {
      return ae.getRedirectUri;
    } }), Object.defineProperty(e, "redirectURIs", { enumerable: !0, get: function() {
      return ae.redirectURIs;
    } });
    var q = Ww();
    Object.defineProperty(e, "convertPartialAttributesRowToAffiliation", { enumerable: !0, get: function() {
      return q.convertPartialAttributesRowToAffiliation;
    } }), Object.defineProperty(e, "convertPartialAttributesMatchingToAffiliations", { enumerable: !0, get: function() {
      return q.convertPartialAttributesMatchingToAffiliations;
    } });
  })(Ip)), Ip;
}
var ch;
function Hw() {
  return ch || (ch = 1, (function(e) {
    var t = ii && ii.__createBinding || (Object.create ? (function(n, i, o, s) {
      s === void 0 && (s = o);
      var a = Object.getOwnPropertyDescriptor(i, o);
      (!a || ("get" in a ? !i.__esModule : a.writable || a.configurable)) && (a = { enumerable: !0, get: function() {
        return i[o];
      } }), Object.defineProperty(n, s, a);
    }) : (function(n, i, o, s) {
      s === void 0 && (s = o), n[s] = i[o];
    })), r = ii && ii.__exportStar || function(n, i) {
      for (var o in n) o !== "default" && !Object.prototype.hasOwnProperty.call(i, o) && t(i, n, o);
    };
    Object.defineProperty(e, "__esModule", { value: !0 }), r(Py(), e), r(Rt(), e), r(dw(), e), r(qw(), e);
  })(ii)), ii;
}
var Yw = Hw();
const Zw = {
  HUB: {
    STUDENT: "TE_HUB::student"
  }
}, cr = {
  ALLOCATE: {
    USER: "TE_ALLOCATE::user",
    ADMIN: "TE_ALLOCATE::admin"
  },
  REGISTRATION: {
    USER: "TE_REGISTRATION::user"
  },
  ROOT: Yw.TE_ROOT_USER
}, Jw = ["ISSUE", "OK", "PENDING"], My = pe(Jw), Kw = [
  "ALLOCATED_TO_THIS",
  "ALLOCATED_TO_OTHER",
  "NOT_ALLOCATED",
  "MULTIPLE_ALLOCATIONS"
], Xw = pe(Kw), Qw = ["NONE", "REQUESTED", "CONFIRMED"];
pe(Qw);
const eN = ["OK", "ERROR", "WARNING"];
pe(eN);
const tN = [
  cr.REGISTRATION.USER,
  cr.ALLOCATE.USER,
  cr.ALLOCATE.ADMIN,
  cr.ROOT
];
pe(tN);
const fh = 3e3, dh = 1e3, Bt = N({
  local: A(),
  timezone: A().optional(),
  unix: v().int().nonnegative()
});
var Se = Rt(), Ly = nc(), xy = Dy();
function Zo(e, t) {
  return A().optional().nullable().transform(
    (r) => Object.values(e).includes(r ?? "") ? r : t
  ).pipe(pe(e));
}
function nn(e) {
  return A().optional().nullable().transform(
    (t) => t !== void 0 && Object.values(e).includes(t ?? "") ? t : void 0
  ).pipe(pe(e).optional());
}
const rN = Zo(
  Se.EApplicationObjectTypeGroup,
  Se.EApplicationObjectTypeGroup.NONE
), nN = Zo(
  Se.EAppProperties,
  Se.EAppProperties.NONE
), iN = nn(Se.EAppId), ky = pe(Se.EAppId), jy = nn(Ly.ERegion);
pe(Ly.ERegion);
nn(
  Se.EObjectTypeMappingStatuses
);
pe(
  Se.EObjectTypeMappingStatuses
);
nn(Se.EOrganizationType);
pe(Se.EOrganizationType);
pe(xy.EOrganizationVisibility);
const oN = nn(
  xy.EOrganizationVisibility
), sN = nn(Se.ETokenType);
pe(Se.ETokenType);
Zo(
  Se.EUserVisibility,
  Se.EUserVisibility.STANDARD
);
Zo(
  Se.EPersonalDataCheck,
  Se.EPersonalDataCheck.STANDARD
);
var Yu = ((e) => (e[e.YES = Se.EPersonalInformation.YES] = "YES", e[e.NO = Se.EPersonalInformation.NO] = "NO", e[e.STANDARD = Se.EPersonalInformation.STANDARD] = "STANDARD", e))(Yu || {});
Zo(
  Yu,
  Yu.STANDARD
);
nn(Se.EPreferencesFilter);
pe(Se.EPreferencesFilter);
nn(Se.EProperty);
pe(Se.EProperty);
var le = /* @__PURE__ */ ((e) => (e.Error = "Error", e.ValidationError = "ValidationError", e.BadRequestError = "BadRequestError", e.NotFoundError = "NotFoundError", e.AdminConfigurationError = "AdminConfigurationError", e.StudentSetGroupConfigurationError = "StudentSetGroupConfigurationError", e.PopulateCacheBusyError = "PopulateCacheBusyError", e.AutoAllocateBusyError = "AutoAllocateBusyError", e.CloudJobRunningError = "CloudJobRunningError", e.NoStudentObjectError = "NoStudentObjectError", e.SubscribeError = "SubscribeError", e.PacemakerFetchError = "PacemakerFetchError", e.PacemakerResponseError = "PacemakerResponseError", e.PermissionError = "PermissionError", e.ExternalServiceError = "ExternalServiceError", e.MultiError = "MultiError", e.RegistrationApiError = "RegistrationApiError", e.HeavyLoadError = "HeavyLoadError", e.NothingToAllocateError = "NothingToAllocateError", e.FrontendError = "FrontendError", e.RegistrationError = "RegistrationError", e.MyScheduleError = "MyScheduleError", e.MaximumMembershipReachedError = "MaximumMembershipReachedError", e.MaximumMembershipReachedByTypeError = "MaximumMembershipReachedByTypeError", e.TEServerFailedError = "TEServerFailedError", e.WorkerInlineFallbackError = "WorkerInlineFallbackError", e.WorkerTimeoutError = "WorkerTimeoutError", e.WorkerQueueSaturated = "WorkerQueueSaturated", e.InterruptAbortException = "InterruptAbortException", e.UnmountAbortException = "UnmountAbortException", e.AddWaitlistError = "AddWaitlistError", e.HistoryError = "HistoryError", e.IssueListCacheError = "IssueListCacheError", e.ReservationError = "ReservationError", e.EnvError = "EnvError", e))(le || {});
const aa = pe(le);
var Yt = /* @__PURE__ */ ((e) => (e.ASCID = "ASCID", e.DESCID = "DESCID", e.ASCMOD = "ASCMOD", e.DESCMOD = "DESCMOD", e.ASCFIELD = "ASCFIELD", e.DESCFIELD = "DESCFIELD", e))(Yt || {});
const Zu = pe(Yt);
var Uy = /* @__PURE__ */ ((e) => (e.ASCID = "ASCID", e.DESCID = "DESCID", e.ASCTIME = "ASCTIME", e.DESCTIME = "DESCTIME", e.ASCMOD = "ASCMOD", e.DESCMOD = "DESCMOD", e.ASCTAG = "ASCTAG", e.DESCTAG = "DESCTAG", e))(Uy || {});
const aN = pe(Uy), uN = [
  Se.EReservationStatuses.Complete,
  Se.EReservationStatuses.Incomplete,
  Se.EReservationStatuses.Confirmed,
  Se.EReservationStatuses.Requested,
  Se.EReservationStatuses.Rejected
];
Zl([k(A()), k(A())]).optional();
const ic = Zl([A(), A()]);
N({
  language: A(),
  name: A(),
  description: A()
});
const lN = [
  Se.EFieldType.TEXT,
  Se.EFieldType.SIGNATURE,
  Se.EFieldType.EMAIL,
  Se.EFieldType.URL,
  Se.EFieldType.TELEPHONE,
  Se.EFieldType.CATEGORY,
  Se.EFieldType.COMMENT,
  Se.EFieldType.INTEGER,
  Se.EFieldType.LENGTH,
  Se.EFieldType.CHECKBOX,
  Se.EFieldType.REFERENCE,
  Se.EFieldType.NON_SEARCHABLE_TEXT,
  Se.EFieldType.NON_SEARCHABLE_REFERENCE,
  ""
], cN = pe(lN), oc = N({
  id: v(),
  extId: A(),
  name: A(),
  // description: z.string(),
  // altDesignations: z.array(TAltDesignations),
  // documentation: z.string(),
  // history: z.array(THistory),
  fieldType: cN.default("").optional(),
  // personalData: ZPersonalDataCheck,
  // filter: z.union([ZPreferencesFilterRequired, z.string()]).optional(),
  // length: z.number().optional(),
  // min: z.number().optional(),
  // max: z.number().optional(),
  // sumType: z.number().optional(),
  // topLevelType: z.number().optional(),
  // titleType: z.number().optional(),
  refSeparator: A().optional(),
  memberMaxType: v().optional(),
  memberMaxCount: ie().optional(),
  // searchableInReservationList: z.boolean().optional(),
  // reservationTextField: z.boolean().optional(),
  mandatory: ie().optional(),
  // unique: z.boolean().optional(),
  // multiple: z.boolean().optional(),
  // editable: z.boolean().optional(),
  searchable: ie(),
  // listable: z.boolean(),
  // primary: z.boolean(),
  // sortable: z.boolean(),
  // virtualCategory: z.string().optional(),
  // abstractCategory: z.string().optional(),
  defaultValue: A().optional(),
  checkSum: v().optional(),
  categories: k(A()).optional(),
  referenceFields: k(v()),
  types: k(v())
  // reservationTemplates: z.array(z.number()),
  // organizations: z.array(z.string()),
});
mr(oc);
const fN = N({
  type: St([A(), v()]).optional(),
  memberLevel: v()
}), sc = N({
  id: v(),
  name: A(),
  memberTypes: k(fN).default([])
});
mr(sc);
const en = v(), Jo = N({
  fieldId: en,
  values: k(A())
}), ac = N({
  objectId: en,
  start: v(),
  end: v()
}), $y = N({
  start: v(),
  end: v(),
  objectIds: k(en)
});
N({
  availabilityTypeId: en,
  objectIds: k(en)
});
const dN = N({
  sort: A().optional(),
  objectStatus: A().optional(),
  // Type up the options
  page: v().optional(),
  limit: v().optional(),
  virtual: A().optional(),
  // Type up the options
  abstract: A().optional(),
  // Type up the options
  active: A().optional(),
  // Type up the options
  typeId: v().optional(),
  ids: k(v()).optional(),
  extIds: k(A()).optional(),
  excludeIds: k(v()).optional(),
  excludeExtIds: k(A()).optional(),
  modified: N({
    beginModified: v(),
    endModified: v()
  }).optional(),
  fields: N({
    exactSearchFieldIds: k(v()),
    generalSearchFieldIds: k(v()),
    searchText: A().optional()
  }).optional()
}).optional();
N({
  body: dN
});
const Vt = N({
  id: v(),
  extId: A(),
  created: v(),
  // createdBy: z.string(),
  // history: z.union([z.array(THistory), THistory]),
  // property: ZPropertyOptional,
  // personalInformation: ZPersonalInformation,
  fields: k(Jo),
  // organizations: z.array(z.union([z.string(), z.number()])),
  members: k(ac),
  types: k(en),
  relations: k($y),
  // availabilityRelations: z.array(TAvailabilityRelations),
  // optionalRelations: z.array(RelatedId),
  active: ie(),
  virtual: ie(),
  abstract: ie()
  // color: z.string(),
}), pN = rn({
  id: v(),
  extId: A(),
  created: v(),
  fields: k(Jo),
  members: k(ac),
  types: k(en),
  relations: k($y),
  active: ie(),
  virtual: ie(),
  abstract: ie()
});
mr(Vt);
hN(pN);
function mr(e) {
  return N({
    limit: v().optional(),
    page: v().optional(),
    results: k(e).optional(),
    totalPages: v().optional(),
    totalResults: v().optional()
  });
}
function hN(e) {
  return rn({
    limit: v().optional(),
    page: v().optional(),
    results: k(e).optional(),
    totalPages: v().optional(),
    totalResults: v().optional()
  });
}
const mN = rn({
  id: v(),
  extId: A().optional(),
  status: v(),
  errorCode: v().optional(),
  message: A().optional(),
  localizedMessage: A().optional()
});
function EN(e) {
  return mr(e).extend({
    failed: v().optional().default(0),
    success: v().optional().default(0)
  });
}
EN(mN);
const Fy = N({
  id: A(),
  name: A().optional().default(""),
  customerSignature: A().optional().default(""),
  customerLogo: A().optional().nullable().default(""),
  // teServerUrl: z.string().optional().default(""),
  public: ie().optional().default(!1),
  enabledProducts: k(iN).transform((e) => e.filter(Boolean)).optional().default([]),
  // Org type is not trustworthy.
  // type: ZOrganizationTypeRequired,
  rootUserPermissions: k(ic.or(A())).optional().default([]),
  rootUserStandardOrganizationNode: A().optional().default(""),
  region: jy,
  visibility: oN,
  // createdAt: z.number().optional().default(0),
  // updatedAt: z.number().optional().default(0),
  // inactiveSince: z.number().optional().nullable().default(null),
  inactive: ie().optional().default(!1)
});
mr(Fy);
Fy.pick({
  id: !0,
  name: !0,
  customerSignature: !0,
  customerLogo: !0,
  enabledProducts: !0,
  region: !0,
  visibility: !0
}).extend({
  customerColor: A().nullable().optional(),
  database: A().optional()
});
const gN = N({
  objectId: v(),
  typeId: v()
}), yN = N({
  sort: aN.optional(),
  page: v().optional(),
  limit: v().optional(),
  modified: N({
    beginModified: v().optional(),
    endModified: v().optional()
  }).optional(),
  date: N({
    startDate: v().optional(),
    endDate: v().optional()
  }).optional(),
  searchObjects: k(gN).optional(),
  types: k(v()).optional(),
  reservationMode: v().optional(),
  fields: N({
    exactSearchFieldIds: k(v()),
    generalSearchFieldIds: k(v()),
    searchText: A().optional()
  }).optional(),
  reservationStatus: k(A()).optional(),
  mineOnly: ie().optional(),
  includeReservationModes: ie().optional(),
  ids: k(v()).optional(),
  extIds: k(A()).optional(),
  typeId: v().optional()
});
N({
  body: yN
});
const Gy = N({
  id: v(),
  extId: A().optional(),
  // organizations: z.array(z.string()).optional(),
  history: N({
    modified: v().optional(),
    modifiedBy: A().optional()
  }),
  // .optional(),
  // created: z.number().optional(),
  // createdBy: z.string().optional(),
  begin: v().optional(),
  end: v().optional(),
  // originalReservation: z.number().optional(),
  // autoEngineId: z.string().optional(),
  // length: z.number().optional(),
  objects: k(
    N({
      objectId: v(),
      typeId: v()
    })
  ).optional(),
  fields: k(
    N({
      fieldId: v(),
      values: k(A())
    })
  ).optional(),
  status: k(pe(Se.EReservationStatuses)).optional(),
  // Only present when the find request sets `includeReservationModes`.
  reservationModes: k(v()).optional()
  // tags: z.array(z.string()).optional(),
});
mr(Gy);
ht(A(), A());
const TN = N({
  id: A(),
  legacyId: A().nullable().optional(),
  profileName: A().optional(),
  standardOrganization: A().nullable().optional(),
  organizationsAndRoles: k(ic),
  scopes: k(A()),
  appPermissions: k(A()),
  userObjects: k(A()),
  inactiveSince: v().nullable()
}), ph = N({
  id: A(),
  profileName: A().optional()
}), zy = N({
  region: jy,
  // Mandatory identifiers
  id: A(),
  // User id
  type: sN,
  customerSignature: A().nullable().optional(),
  organizationId: A().nullable().optional(),
  username: A().optional(),
  email: A().nullable().optional(),
  // Permissions
  appPermissions: k(A()).optional().default([]),
  scopes: k(A()),
  organizationsAndRoles: k(ic).optional(),
  // Profiles
  profile: ph.optional(),
  profiles: k(ph).optional(),
  // Token stuff
  iat: v().optional(),
  exp: v().optional(),
  fingerprintHashed: A().optional()
}), uc = N({
  id: v(),
  extId: A(),
  name: A(),
  // description: z.string(),
  // documentation: z.string(),
  // history: z.array(THistory),
  // altDesignations: z.array(TAltDesignations),
  active: ie(),
  // personalData: z.boolean(),
  // allowStandardObjects: z.boolean(),
  // allowAbstractObjects: z.boolean(),
  // allowVirtualObjects: z.boolean(),
  // personType: z.boolean(),
  // locationType: z.boolean(),
  // aliasType: RelatedId,
  // externalOwner: z.string(),
  subTypes: k(en).optional()
  // fields: z.array(RelatedId).optional(),
  // parentFields: z.array(RelatedId).optional(),
  // reservationTemplates: z.array(z.number()).optional(),
  // organizations: z.array(z.union([z.string(), z.number()])).optional(),
});
mr(uc);
N({
  login: v().optional(),
  appId: ky
});
const lc = N({
  id: A(),
  inactiveSince: v().nullable().optional(),
  // DESCRIPTIVES
  organizationId: A().nullable().optional(),
  username: A().optional(),
  email: A().nullable().optional(),
  firstName: A().nullable().optional(),
  lastName: A().nullable().optional(),
  // PROFILES
  profileName: A().optional(),
  profiles: k(TN).optional(),
  // LEGACY INFORMATION
  // legacyId: z.string().nullable().optional(),
  // CONFIG SETTINGS
  // language: z.string().nullable().optional(),
  // dateFormat: z.string().nullable().optional(),
  // displayTimezones: z.array(z.string()).optional(),
  timezone: A().nullable().optional(),
  // visibility: ZUserVisibility.optional(),
  // personalData: z.boolean().optional(),
  // description: z.string().nullable().optional(),
  // ORGANIZATIONS AND PERMISSIONS
  // standardOrganization: z.string().nullable().optional(), // Only leaves allowed
  // ** NOTE ** organizationAndRoles can fail validation how it looks below. It can have a tuple of value null
  // organizationsAndRoles: z.array(TAttributeValueArrayPair).optional(),
  scopes: k(A()),
  appPermissions: k(A()).optional(),
  // USER OBJECTS
  userObjects: k(A()).optional()
  // AUTH CONFIG
  // authConfigId: z.string().optional(),
  // USAGE STATISTICS
  // logins: z.array(TLogins).optional(),
  // createdBy: z.string().nullable().optional(),
  // history: z.array(THistory),
  // lockedForExternalAuthentication: z.boolean().optional(),
  // createdAt: z.number().optional(),
  // updatedAt: z.number().optional(),
});
mr(lc);
lc.pick({
  id: !0,
  email: !0,
  firstName: !0,
  lastName: !0,
  timezone: !0
});
lc.pick({
  email: !0,
  firstName: !0,
  lastName: !0,
  profiles: !0
});
N({
  id: A(),
  email: A().nullable().optional(),
  name: A()
});
const bN = N({
  isSearchable: ie().optional(),
  // appFieldName: z.string(),
  appProperty: nN,
  fieldExtId: A().optional().nullable(),
  fieldId: v().optional().nullable()
  // fieldLabel: z.string(),
  // allocationFieldFromObject: z.string().optional().nullable(),
}), AN = N({
  // applicationObjectTypeName: z.string(),
  applicationObjectTypeGroup: rN,
  // applicationObjectTypeLabel: z.string(),
  objectTypeExtId: A().optional().nullable(),
  objectTypeId: v().optional().nullable(),
  // labelField: z.string().optional().nullable(),
  // secondaryLabelField: z.string().optional().nullable(),
  fields: k(bN)
  // status: ZObjectTypeMappingStatusesRequired,
}), By = N({
  appId: ky,
  objectTypes: k(AN)
});
N({
  mappingData: By,
  fields: za(v(), oc),
  types: za(v(), uc),
  memberTypes: za(v(), sc)
});
N({
  mappingData: By,
  fields: k(oc),
  types: k(uc),
  memberTypes: k(sc)
});
const vN = N({
  id: v(),
  extId: A(),
  name: A(),
  identifiers: k(A()).optional(),
  // daylightSavingsTime: z.string(),
  isDefault: ie(),
  offset: A().optional(),
  timeZone: A()
}), hh = N({
  extId: A(),
  name: A(),
  identifier: A(),
  offset: A()
});
N({
  server: hh,
  user: hh
});
mr(vN);
const SN = N({
  id: A().optional(),
  viewLinkSubmitter: A().optional(),
  viewerEntry: A().optional(),
  viewerPath: A().optional(),
  viewerPage: A().optional(),
  commentField: A().optional(),
  currentPeriod: A().optional(),
  reservationMode: v().optional()
}), Vy = N({
  daily: ie().default(!1),
  hourly: ie().default(!1),
  everyMinute: ie().default(!1)
});
Object.keys(
  Vy.shape
);
const IN = N({
  deAllocationEnabled: ie().default(!1),
  allocationEnabled: ie().default(!1),
  frequency: Vy.default({
    daily: !1,
    hourly: !1,
    everyMinute: !1
  }),
  fromWaitlistEnabled: ie().default(!1)
}), _N = N({
  automaticAllocation: IN.optional(),
  blockStudentConflict: ie().default(!1),
  preferencesTimeOfDay: ie().optional(),
  preferencesTime: ie().optional(),
  preferencesGroup: ie().optional(),
  enableWaitlist: ie().default(!1),
  reservationStatuses: k(pe(Se.EReservationStatuses)).default(uN)
}), RN = N({
  startDate: v().optional(),
  endDate: v().optional()
}), ON = N({
  start: v(),
  end: v()
}), wN = ht(A(), k(A())), NN = N({
  range: ON.optional(),
  fields: wN.optional()
});
N({ id: v(), name: A() });
const CN = SN.extend({
  current: NN,
  dateRange: RN.optional(),
  currentFieldIds: k(v()),
  reservationMode: v().optional()
});
N({
  viewLink: CN,
  allocateSettings: _N
});
const et = (e) => N({
  label: A(),
  value: e
}), Rs = N({
  id: v(),
  begin: Bt,
  end: Bt,
  isInfo: ie().optional(),
  title: A(),
  subtitle: A().optional(),
  examType: et(A()).optional(),
  module: k(
    N({
      name: et(A()),
      code: et(A())
    })
  ).optional(),
  activity: N({ name: et(A()) }).optional(),
  location: k(
    N({
      name: et(A()),
      building: et(A()).optional()
    })
  ).optional()
});
function Wy(e) {
  return (t) => St([
    N({ value: t }),
    N({ availableAt: e }),
    N({ disabled: fe(!0) })
  ]);
}
const hs = Wy(Bt), qy = N({
  id: v(),
  lastModified: Bt.optional(),
  begin: Bt,
  end: Bt,
  title: A(),
  subtitle: A(),
  breadcrumb: A()
}), PN = qy.extend({
  kind: fe("general"),
  module: k(
    N({
      name: et(A()),
      code: et(A())
    })
  ),
  location: k(
    N({
      name: et(A()),
      building: et(A()),
      campus: et(A()),
      type: et(A()),
      map: et(A()),
      image: et(A()),
      equipment: et(k(A())),
      extraFields: k(et(A()))
    })
  ),
  extraFields: k(et(A())),
  digitalResource: N({
    onlineUrl: k(et(A())),
    recording: k(et(A())),
    links: k(et(A()))
  }),
  staff: k(
    N({
      name: et(A())
    })
  ),
  activity: N({
    name: et(A())
  }),
  message: N({
    comment: et(A())
  })
}), DN = qy.extend({
  kind: fe("exam"),
  location: hs(A()),
  seatNo: hs(A().nullable()),
  fields: k(
    hs(A()).and(
      N({
        label: A(),
        type: A().optional()
      })
    )
  ),
  information: k(
    hs(
      N({
        title: A().optional(),
        type: pe(["error", "warning", "info"]).optional(),
        value: A()
      })
    )
  )
});
hr("kind", [
  PN,
  DN
]);
var MN = typeof global == "object" && global && global.Object === Object && global, LN = typeof self == "object" && self && self.Object === Object && self, Hn = MN || LN || Function("return this")(), Ii = Hn.Symbol, Hy = Object.prototype, xN = Hy.hasOwnProperty, kN = Hy.toString, Eo = Ii ? Ii.toStringTag : void 0;
function jN(e) {
  var t = xN.call(e, Eo), r = e[Eo];
  try {
    e[Eo] = void 0;
    var n = !0;
  } catch {
  }
  var i = kN.call(e);
  return n && (t ? e[Eo] = r : delete e[Eo]), i;
}
var UN = Object.prototype, $N = UN.toString;
function FN(e) {
  return $N.call(e);
}
var GN = "[object Null]", zN = "[object Undefined]", mh = Ii ? Ii.toStringTag : void 0;
function ua(e) {
  return e == null ? e === void 0 ? zN : GN : mh && mh in Object(e) ? jN(e) : FN(e);
}
function BN(e) {
  return e != null && typeof e == "object";
}
var VN = Array.isArray, Eh = Ii ? Ii.prototype : void 0;
Eh && Eh.toString;
function Yy(e) {
  var t = typeof e;
  return e != null && (t == "object" || t == "function");
}
var WN = "[object AsyncFunction]", qN = "[object Function]", HN = "[object GeneratorFunction]", YN = "[object Proxy]";
function Zy(e) {
  if (!Yy(e))
    return !1;
  var t = ua(e);
  return t == qN || t == HN || t == WN || t == YN;
}
var Ba = Hn["__core-js_shared__"], gh = (function() {
  var e = /[^.]+$/.exec(Ba && Ba.keys && Ba.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
})();
function ZN(e) {
  return !!gh && gh in e;
}
var JN = Function.prototype, KN = JN.toString;
function Yn(e) {
  if (e != null) {
    try {
      return KN.call(e);
    } catch {
    }
    try {
      return e + "";
    } catch {
    }
  }
  return "";
}
var XN = /[\\^$.*+?()[\]{}|]/g, QN = /^\[object .+?Constructor\]$/, eC = Function.prototype, tC = Object.prototype, rC = eC.toString, nC = tC.hasOwnProperty, iC = RegExp(
  "^" + rC.call(nC).replace(XN, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function oC(e) {
  if (!Yy(e) || ZN(e))
    return !1;
  var t = Zy(e) ? iC : QN;
  return t.test(Yn(e));
}
function sC(e, t) {
  return e == null ? void 0 : e[t];
}
function Li(e, t) {
  var r = sC(e, t);
  return oC(r) ? r : void 0;
}
var Ju = Li(Hn, "WeakMap");
function aC(e, t) {
  return e === t || e !== e && t !== t;
}
var uC = 9007199254740991;
function lC(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= uC;
}
function cC(e) {
  return e != null && lC(e.length) && !Zy(e);
}
var fC = Object.prototype;
function dC(e) {
  var t = e && e.constructor, r = typeof t == "function" && t.prototype || fC;
  return e === r;
}
function pC(e, t) {
  return function(r) {
    return e(t(r));
  };
}
var hC = pC(Object.keys, Object), mC = Object.prototype, EC = mC.hasOwnProperty;
function gC(e) {
  if (!dC(e))
    return hC(e);
  var t = [];
  for (var r in Object(e))
    EC.call(e, r) && r != "constructor" && t.push(r);
  return t;
}
var Bo = Li(Object, "create");
function yC() {
  this.__data__ = Bo ? Bo(null) : {}, this.size = 0;
}
function TC(e) {
  var t = this.has(e) && delete this.__data__[e];
  return this.size -= t ? 1 : 0, t;
}
var bC = "__lodash_hash_undefined__", AC = Object.prototype, vC = AC.hasOwnProperty;
function SC(e) {
  var t = this.__data__;
  if (Bo) {
    var r = t[e];
    return r === bC ? void 0 : r;
  }
  return vC.call(t, e) ? t[e] : void 0;
}
var IC = Object.prototype, _C = IC.hasOwnProperty;
function RC(e) {
  var t = this.__data__;
  return Bo ? t[e] !== void 0 : _C.call(t, e);
}
var OC = "__lodash_hash_undefined__";
function wC(e, t) {
  var r = this.__data__;
  return this.size += this.has(e) ? 0 : 1, r[e] = Bo && t === void 0 ? OC : t, this;
}
function zn(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
zn.prototype.clear = yC;
zn.prototype.delete = TC;
zn.prototype.get = SC;
zn.prototype.has = RC;
zn.prototype.set = wC;
function NC() {
  this.__data__ = [], this.size = 0;
}
function la(e, t) {
  for (var r = e.length; r--; )
    if (aC(e[r][0], t))
      return r;
  return -1;
}
var CC = Array.prototype, PC = CC.splice;
function DC(e) {
  var t = this.__data__, r = la(t, e);
  if (r < 0)
    return !1;
  var n = t.length - 1;
  return r == n ? t.pop() : PC.call(t, r, 1), --this.size, !0;
}
function MC(e) {
  var t = this.__data__, r = la(t, e);
  return r < 0 ? void 0 : t[r][1];
}
function LC(e) {
  return la(this.__data__, e) > -1;
}
function xC(e, t) {
  var r = this.__data__, n = la(r, e);
  return n < 0 ? (++this.size, r.push([e, t])) : r[n][1] = t, this;
}
function xi(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
xi.prototype.clear = NC;
xi.prototype.delete = DC;
xi.prototype.get = MC;
xi.prototype.has = LC;
xi.prototype.set = xC;
var js = Li(Hn, "Map");
function kC() {
  this.size = 0, this.__data__ = {
    hash: new zn(),
    map: new (js || xi)(),
    string: new zn()
  };
}
function jC(e) {
  var t = typeof e;
  return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
}
function ca(e, t) {
  var r = e.__data__;
  return jC(t) ? r[typeof t == "string" ? "string" : "hash"] : r.map;
}
function UC(e) {
  var t = ca(this, e).delete(e);
  return this.size -= t ? 1 : 0, t;
}
function $C(e) {
  return ca(this, e).get(e);
}
function FC(e) {
  return ca(this, e).has(e);
}
function GC(e, t) {
  var r = ca(this, e), n = r.size;
  return r.set(e, t), this.size += r.size == n ? 0 : 1, this;
}
function Zn(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
Zn.prototype.clear = kC;
Zn.prototype.delete = UC;
Zn.prototype.get = $C;
Zn.prototype.has = FC;
Zn.prototype.set = GC;
var zC = "Expected a function";
function cc(e, t) {
  if (typeof e != "function" || t != null && typeof t != "function")
    throw new TypeError(zC);
  var r = function() {
    var n = arguments, i = t ? t.apply(this, n) : n[0], o = r.cache;
    if (o.has(i))
      return o.get(i);
    var s = e.apply(this, n);
    return r.cache = o.set(i, s) || o, s;
  };
  return r.cache = new (cc.Cache || Zn)(), r;
}
cc.Cache = Zn;
var BC = 500;
function VC(e) {
  var t = cc(e, function(n) {
    return r.size === BC && r.clear(), n;
  }), r = t.cache;
  return t;
}
var WC = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, qC = /\\(\\)?/g;
VC(function(e) {
  var t = [];
  return e.charCodeAt(0) === 46 && t.push(""), e.replace(WC, function(r, n, i, o) {
    t.push(i ? o.replace(qC, "$1") : n || r);
  }), t;
});
var HC = "\\ud800-\\udfff", YC = "\\u0300-\\u036f", ZC = "\\ufe20-\\ufe2f", JC = "\\u20d0-\\u20ff", KC = YC + ZC + JC, XC = "\\ufe0e\\ufe0f", QC = "\\u200d", e1 = RegExp("[" + QC + HC + KC + XC + "]");
function t1(e) {
  return e1.test(e);
}
var Ku = Li(Hn, "DataView"), Xu = Li(Hn, "Promise"), Qu = Li(Hn, "Set"), yh = "[object Map]", r1 = "[object Object]", Th = "[object Promise]", bh = "[object Set]", Ah = "[object WeakMap]", vh = "[object DataView]", n1 = Yn(Ku), i1 = Yn(js), o1 = Yn(Xu), s1 = Yn(Qu), a1 = Yn(Ju), Ln = ua;
(Ku && Ln(new Ku(new ArrayBuffer(1))) != vh || js && Ln(new js()) != yh || Xu && Ln(Xu.resolve()) != Th || Qu && Ln(new Qu()) != bh || Ju && Ln(new Ju()) != Ah) && (Ln = function(e) {
  var t = ua(e), r = t == r1 ? e.constructor : void 0, n = r ? Yn(r) : "";
  if (n)
    switch (n) {
      case n1:
        return vh;
      case i1:
        return yh;
      case o1:
        return Th;
      case s1:
        return bh;
      case a1:
        return Ah;
    }
  return t;
});
function u1(e) {
  return function(t) {
    return t == null ? void 0 : t[e];
  };
}
var l1 = "[object String]";
function c1(e) {
  return typeof e == "string" || !VN(e) && BN(e) && ua(e) == l1;
}
function f1(e) {
  return e === void 0;
}
var d1 = u1("length"), Jy = "\\ud800-\\udfff", p1 = "\\u0300-\\u036f", h1 = "\\ufe20-\\ufe2f", m1 = "\\u20d0-\\u20ff", E1 = p1 + h1 + m1, g1 = "\\ufe0e\\ufe0f", y1 = "[" + Jy + "]", el = "[" + E1 + "]", tl = "\\ud83c[\\udffb-\\udfff]", T1 = "(?:" + el + "|" + tl + ")", Ky = "[^" + Jy + "]", Xy = "(?:\\ud83c[\\udde6-\\uddff]){2}", Qy = "[\\ud800-\\udbff][\\udc00-\\udfff]", b1 = "\\u200d", eT = T1 + "?", tT = "[" + g1 + "]?", A1 = "(?:" + b1 + "(?:" + [Ky, Xy, Qy].join("|") + ")" + tT + eT + ")*", v1 = tT + eT + A1, S1 = "(?:" + [Ky + el + "?", el, Xy, Qy, y1].join("|") + ")", Sh = RegExp(tl + "(?=" + tl + ")|" + S1 + v1, "g");
function I1(e) {
  for (var t = Sh.lastIndex = 0; Sh.test(e); )
    ++t;
  return t;
}
function _1(e) {
  return t1(e) ? I1(e) : d1(e);
}
var R1 = "[object Map]", O1 = "[object Set]";
function w1(e) {
  if (e == null)
    return 0;
  if (cC(e))
    return c1(e) ? _1(e) : e.length;
  var t = Ln(e);
  return t == R1 || t == O1 ? e.size : gC(e).length;
}
var rl = { exports: {} }, N1 = rl.exports, Ih;
function C1() {
  return Ih || (Ih = 1, (function(e, t) {
    (function(r, n) {
      e.exports = n();
    })(N1, (function() {
      var r = 1e3, n = 6e4, i = 36e5, o = "millisecond", s = "second", a = "minute", l = "hour", f = "day", u = "week", h = "month", E = "quarter", d = "year", g = "date", y = "Invalid Date", b = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, _ = /\[([^\]]+)]|YYYY|YY|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, I = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: function(q) {
        var x = ["th", "st", "nd", "rd"], B = q % 100;
        return "[" + q + (x[(B - 20) % 10] || x[B] || x[0]) + "]";
      } }, w = function(q, x, B) {
        var Z = String(q);
        return !Z || Z.length >= x ? q : "" + Array(x + 1 - Z.length).join(B) + q;
      }, L = { s: w, z: function(q) {
        var x = -q.utcOffset(), B = Math.abs(x), Z = Math.floor(B / 60), G = B % 60;
        return (x <= 0 ? "+" : "-") + w(Z, 2, "0") + ":" + w(G, 2, "0");
      }, m: function q(x, B) {
        if (x.date() < B.date()) return -q(B, x);
        var Z = 12 * (B.year() - x.year()) + (B.month() - x.month()), G = x.clone().add(Z, h), Q = B - G < 0, K = x.clone().add(Z + (Q ? -1 : 1), h);
        return +(-(Z + (B - G) / (Q ? G - K : K - G)) || 0);
      }, a: function(q) {
        return q < 0 ? Math.ceil(q) || 0 : Math.floor(q);
      }, p: function(q) {
        return { M: h, y: d, w: u, d: f, D: g, h: l, m: a, s, ms: o, Q: E }[q] || String(q || "").toLowerCase().replace(/s$/, "");
      }, u: function(q) {
        return q === void 0;
      } }, R = "en", D = {};
      D[R] = I;
      var P = "$isDayjsObject", O = function(q) {
        return q instanceof V || !(!q || !q[P]);
      }, F = function q(x, B, Z) {
        var G;
        if (!x) return R;
        if (typeof x == "string") {
          var Q = x.toLowerCase();
          D[Q] && (G = Q), B && (D[Q] = B, G = Q);
          var K = x.split("-");
          if (!G && K.length > 1) return q(K[0]);
        } else {
          var ee = x.name;
          D[ee] = x, G = ee;
        }
        return !Z && G && (R = G), G || !Z && R;
      }, U = function(q, x) {
        if (O(q)) return q.clone();
        var B = typeof x == "object" ? x : {};
        return B.date = q, B.args = arguments, new V(B);
      }, z = L;
      z.l = F, z.i = O, z.w = function(q, x) {
        return U(q, { locale: x.$L, utc: x.$u, x: x.$x, $offset: x.$offset });
      };
      var V = (function() {
        function q(B) {
          this.$L = F(B.locale, null, !0), this.parse(B), this.$x = this.$x || B.x || {}, this[P] = !0;
        }
        var x = q.prototype;
        return x.parse = function(B) {
          this.$d = (function(Z) {
            var G = Z.date, Q = Z.utc;
            if (G === null) return /* @__PURE__ */ new Date(NaN);
            if (z.u(G)) return /* @__PURE__ */ new Date();
            if (G instanceof Date) return new Date(G);
            if (typeof G == "string" && !/Z$/i.test(G)) {
              var K = G.match(b);
              if (K) {
                var ee = K[2] - 1 || 0, ne = (K[7] || "0").substring(0, 3);
                return Q ? new Date(Date.UTC(K[1], ee, K[3] || 1, K[4] || 0, K[5] || 0, K[6] || 0, ne)) : new Date(K[1], ee, K[3] || 1, K[4] || 0, K[5] || 0, K[6] || 0, ne);
              }
            }
            return new Date(G);
          })(B), this.init();
        }, x.init = function() {
          var B = this.$d;
          this.$y = B.getFullYear(), this.$M = B.getMonth(), this.$D = B.getDate(), this.$W = B.getDay(), this.$H = B.getHours(), this.$m = B.getMinutes(), this.$s = B.getSeconds(), this.$ms = B.getMilliseconds();
        }, x.$utils = function() {
          return z;
        }, x.isValid = function() {
          return this.$d.toString() !== y;
        }, x.isSame = function(B, Z) {
          var G = U(B);
          return this.startOf(Z) <= G && G <= this.endOf(Z);
        }, x.isAfter = function(B, Z) {
          return U(B) < this.startOf(Z);
        }, x.isBefore = function(B, Z) {
          return this.endOf(Z) < U(B);
        }, x.$g = function(B, Z, G) {
          return z.u(B) ? this[Z] : this.set(G, B);
        }, x.unix = function() {
          return Math.floor(this.valueOf() / 1e3);
        }, x.valueOf = function() {
          return this.$d.getTime();
        }, x.startOf = function(B, Z) {
          var G = this, Q = !!z.u(Z) || Z, K = z.p(B), ee = function(Fe, _e) {
            var Le = z.w(G.$u ? Date.UTC(G.$y, _e, Fe) : new Date(G.$y, _e, Fe), G);
            return Q ? Le : Le.endOf(f);
          }, ne = function(Fe, _e) {
            return z.w(G.toDate()[Fe].apply(G.toDate("s"), (Q ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(_e)), G);
          }, re = this.$W, Ae = this.$M, ge = this.$D, Ne = "set" + (this.$u ? "UTC" : "");
          switch (K) {
            case d:
              return Q ? ee(1, 0) : ee(31, 11);
            case h:
              return Q ? ee(1, Ae) : ee(0, Ae + 1);
            case u:
              var We = this.$locale().weekStart || 0, Ue = (re < We ? re + 7 : re) - We;
              return ee(Q ? ge - Ue : ge + (6 - Ue), Ae);
            case f:
            case g:
              return ne(Ne + "Hours", 0);
            case l:
              return ne(Ne + "Minutes", 1);
            case a:
              return ne(Ne + "Seconds", 2);
            case s:
              return ne(Ne + "Milliseconds", 3);
            default:
              return this.clone();
          }
        }, x.endOf = function(B) {
          return this.startOf(B, !1);
        }, x.$set = function(B, Z) {
          var G, Q = z.p(B), K = "set" + (this.$u ? "UTC" : ""), ee = (G = {}, G[f] = K + "Date", G[g] = K + "Date", G[h] = K + "Month", G[d] = K + "FullYear", G[l] = K + "Hours", G[a] = K + "Minutes", G[s] = K + "Seconds", G[o] = K + "Milliseconds", G)[Q], ne = Q === f ? this.$D + (Z - this.$W) : Z;
          if (Q === h || Q === d) {
            var re = this.clone().set(g, 1);
            re.$d[ee](ne), re.init(), this.$d = re.set(g, Math.min(this.$D, re.daysInMonth())).$d;
          } else ee && this.$d[ee](ne);
          return this.init(), this;
        }, x.set = function(B, Z) {
          return this.clone().$set(B, Z);
        }, x.get = function(B) {
          return this[z.p(B)]();
        }, x.add = function(B, Z) {
          var G, Q = this;
          B = Number(B);
          var K = z.p(Z), ee = function(Ae) {
            var ge = U(Q);
            return z.w(ge.date(ge.date() + Math.round(Ae * B)), Q);
          };
          if (K === h) return this.set(h, this.$M + B);
          if (K === d) return this.set(d, this.$y + B);
          if (K === f) return ee(1);
          if (K === u) return ee(7);
          var ne = (G = {}, G[a] = n, G[l] = i, G[s] = r, G)[K] || 1, re = this.$d.getTime() + B * ne;
          return z.w(re, this);
        }, x.subtract = function(B, Z) {
          return this.add(-1 * B, Z);
        }, x.format = function(B) {
          var Z = this, G = this.$locale();
          if (!this.isValid()) return G.invalidDate || y;
          var Q = B || "YYYY-MM-DDTHH:mm:ssZ", K = z.z(this), ee = this.$H, ne = this.$m, re = this.$M, Ae = G.weekdays, ge = G.months, Ne = G.meridiem, We = function(_e, Le, De, Re) {
            return _e && (_e[Le] || _e(Z, Q)) || De[Le].slice(0, Re);
          }, Ue = function(_e) {
            return z.s(ee % 12 || 12, _e, "0");
          }, Fe = Ne || function(_e, Le, De) {
            var Re = _e < 12 ? "AM" : "PM";
            return De ? Re.toLowerCase() : Re;
          };
          return Q.replace(_, (function(_e, Le) {
            return Le || (function(De) {
              switch (De) {
                case "YY":
                  return String(Z.$y).slice(-2);
                case "YYYY":
                  return z.s(Z.$y, 4, "0");
                case "M":
                  return re + 1;
                case "MM":
                  return z.s(re + 1, 2, "0");
                case "MMM":
                  return We(G.monthsShort, re, ge, 3);
                case "MMMM":
                  return We(ge, re);
                case "D":
                  return Z.$D;
                case "DD":
                  return z.s(Z.$D, 2, "0");
                case "d":
                  return String(Z.$W);
                case "dd":
                  return We(G.weekdaysMin, Z.$W, Ae, 2);
                case "ddd":
                  return We(G.weekdaysShort, Z.$W, Ae, 3);
                case "dddd":
                  return Ae[Z.$W];
                case "H":
                  return String(ee);
                case "HH":
                  return z.s(ee, 2, "0");
                case "h":
                  return Ue(1);
                case "hh":
                  return Ue(2);
                case "a":
                  return Fe(ee, ne, !0);
                case "A":
                  return Fe(ee, ne, !1);
                case "m":
                  return String(ne);
                case "mm":
                  return z.s(ne, 2, "0");
                case "s":
                  return String(Z.$s);
                case "ss":
                  return z.s(Z.$s, 2, "0");
                case "SSS":
                  return z.s(Z.$ms, 3, "0");
                case "Z":
                  return K;
              }
              return null;
            })(_e) || K.replace(":", "");
          }));
        }, x.utcOffset = function() {
          return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
        }, x.diff = function(B, Z, G) {
          var Q, K = this, ee = z.p(Z), ne = U(B), re = (ne.utcOffset() - this.utcOffset()) * n, Ae = this - ne, ge = function() {
            return z.m(K, ne);
          };
          switch (ee) {
            case d:
              Q = ge() / 12;
              break;
            case h:
              Q = ge();
              break;
            case E:
              Q = ge() / 3;
              break;
            case u:
              Q = (Ae - re) / 6048e5;
              break;
            case f:
              Q = (Ae - re) / 864e5;
              break;
            case l:
              Q = Ae / i;
              break;
            case a:
              Q = Ae / n;
              break;
            case s:
              Q = Ae / r;
              break;
            default:
              Q = Ae;
          }
          return G ? Q : z.a(Q);
        }, x.daysInMonth = function() {
          return this.endOf(h).$D;
        }, x.$locale = function() {
          return D[this.$L];
        }, x.locale = function(B, Z) {
          if (!B) return this.$L;
          var G = this.clone(), Q = F(B, Z, !0);
          return Q && (G.$L = Q), G;
        }, x.clone = function() {
          return z.w(this.$d, this);
        }, x.toDate = function() {
          return new Date(this.valueOf());
        }, x.toJSON = function() {
          return this.isValid() ? this.toISOString() : null;
        }, x.toISOString = function() {
          return this.$d.toISOString();
        }, x.toString = function() {
          return this.$d.toUTCString();
        }, q;
      })(), ae = V.prototype;
      return U.prototype = ae, [["$ms", o], ["$s", s], ["$m", a], ["$H", l], ["$W", f], ["$M", h], ["$y", d], ["$D", g]].forEach((function(q) {
        ae[q[1]] = function(x) {
          return this.$g(x, q[0], q[1]);
        };
      })), U.extend = function(q, x) {
        return q.$i || (q(x, V, U), q.$i = !0), U;
      }, U.locale = F, U.isDayjs = O, U.unix = function(q) {
        return U(1e3 * q);
      }, U.en = D[R], U.Ls = D, U.p = {}, U;
    }));
  })(rl)), rl.exports;
}
var P1 = C1();
const Vo = /* @__PURE__ */ Ql(P1);
var nl = { exports: {} }, D1 = nl.exports, _h;
function M1() {
  return _h || (_h = 1, (function(e, t) {
    (function(r, n) {
      e.exports = n();
    })(D1, (function() {
      var r = { year: 0, month: 1, day: 2, hour: 3, minute: 4, second: 5 }, n = {};
      return function(i, o, s) {
        var a, l = function(E, d, g) {
          g === void 0 && (g = {});
          var y = new Date(E), b = (function(_, I) {
            I === void 0 && (I = {});
            var w = I.timeZoneName || "short", L = _ + "|" + w, R = n[L];
            return R || (R = new Intl.DateTimeFormat("en-US", { hour12: !1, timeZone: _, year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", second: "2-digit", timeZoneName: w }), n[L] = R), R;
          })(d, g);
          return b.formatToParts(y);
        }, f = function(E, d) {
          for (var g = l(E, d), y = [], b = 0; b < g.length; b += 1) {
            var _ = g[b], I = _.type, w = _.value, L = r[I];
            L >= 0 && (y[L] = parseInt(w, 10));
          }
          var R = y[3], D = R === 24 ? 0 : R, P = y[0] + "-" + y[1] + "-" + y[2] + " " + D + ":" + y[4] + ":" + y[5] + ":000", O = +E;
          return (s.utc(P).valueOf() - (O -= O % 1e3)) / 6e4;
        }, u = o.prototype;
        u.tz = function(E, d) {
          if (E === void 0 && (E = a), !this.isValid()) return this;
          var g, y = this.utcOffset(), b = this.toDate(), _ = b.toLocaleString("en-US", { timeZone: E }), I = f(+b, E);
          if (!Number(I)) g = this.utcOffset(0, d);
          else if (g = s(_, { locale: this.$L }).$set("millisecond", this.$ms).utcOffset(I, !0), d) {
            var w = g.utcOffset();
            g = g.add(y - w, "minute");
          }
          return g.$x.$timezone = E, g;
        }, u.offsetName = function(E) {
          var d = this.$x.$timezone || s.tz.guess(), g = l(this.valueOf(), d, { timeZoneName: E }).find((function(y) {
            return y.type.toLowerCase() === "timezonename";
          }));
          return g && g.value;
        };
        var h = u.startOf;
        u.startOf = function(E, d) {
          if (!this.$x || !this.$x.$timezone) return h.call(this, E, d);
          var g = s(this.format("YYYY-MM-DD HH:mm:ss:SSS"), { locale: this.$L });
          return h.call(g, E, d).tz(this.$x.$timezone, !0);
        }, s.tz = function(E, d, g) {
          var y = g && d, b = g || d || a, _ = f(+s(), b);
          if (typeof E != "string") return s(E).tz(b);
          var I = s.utc(E, y).valueOf();
          if (Number.isNaN(I)) {
            var w = s(NaN);
            return w.$x.$timezone = b, w;
          }
          var L = (function(O, F, U) {
            var z = O - 60 * F * 1e3, V = f(z, U);
            if (F === V) return [z, F];
            var ae = f(z -= 60 * (V - F) * 1e3, U);
            return V === ae ? [z, V] : [O - 60 * Math.min(V, ae) * 1e3, Math.max(V, ae)];
          })(I, _, b), R = L[0], D = L[1], P = s(R).utcOffset(D);
          return P.$x.$timezone = b, P;
        }, s.tz.guess = function() {
          return Intl.DateTimeFormat().resolvedOptions().timeZone;
        }, s.tz.setDefault = function(E) {
          a = E;
        };
      };
    }));
  })(nl)), nl.exports;
}
var L1 = M1();
const x1 = /* @__PURE__ */ Ql(L1);
var il = { exports: {} }, k1 = il.exports, Rh;
function j1() {
  return Rh || (Rh = 1, (function(e, t) {
    (function(r, n) {
      e.exports = n();
    })(k1, (function() {
      var r = "minute", n = /[+-]\d\d(?::?\d\d)?/g, i = /([+-]|\d\d)/g;
      return function(o, s, a) {
        var l = s.prototype;
        a.utc = function(y) {
          var b = { date: y, utc: !0, args: arguments };
          return new s(b);
        }, l.utc = function(y) {
          var b = a(this.toDate(), { locale: this.$L, utc: !0 });
          return y ? b.add(this.utcOffset(), r) : b;
        }, l.local = function() {
          return a(this.toDate(), { locale: this.$L, utc: !1 });
        };
        var f = l.parse;
        l.parse = function(y) {
          y.utc && (this.$u = !0), this.$utils().u(y.$offset) || (this.$offset = y.$offset), f.call(this, y);
        };
        var u = l.init;
        l.init = function() {
          if (this.$u) {
            var y = this.$d;
            this.$y = y.getUTCFullYear(), this.$M = y.getUTCMonth(), this.$D = y.getUTCDate(), this.$W = y.getUTCDay(), this.$H = y.getUTCHours(), this.$m = y.getUTCMinutes(), this.$s = y.getUTCSeconds(), this.$ms = y.getUTCMilliseconds();
          } else u.call(this);
        };
        var h = l.utcOffset;
        l.utcOffset = function(y, b) {
          var _ = this.$utils().u;
          if (_(y)) return this.$u ? 0 : _(this.$offset) ? h.call(this) : this.$offset;
          if (typeof y == "string" && (y = (function(R) {
            R === void 0 && (R = "");
            var D = R.match(n);
            if (!D) return null;
            var P = ("" + D[0]).match(i) || ["-", 0, 0], O = P[0], F = 60 * +P[1] + +P[2];
            return F === 0 ? 0 : O === "+" ? F : -F;
          })(y), y === null)) return this;
          var I = Math.abs(y) <= 16 ? 60 * y : y;
          if (I === 0) return this.utc(b);
          var w = this.clone();
          if (b) return w.$offset = I, w.$u = !1, w;
          var L = this.$u ? this.toDate().getTimezoneOffset() : -1 * this.utcOffset();
          return (w = this.local().add(I + L, r)).$offset = I, w.$x.$localOffset = L, w;
        };
        var E = l.format;
        l.format = function(y) {
          var b = y || (this.$u ? "YYYY-MM-DDTHH:mm:ss[Z]" : "");
          return E.call(this, b);
        }, l.valueOf = function() {
          var y = this.$utils().u(this.$offset) ? 0 : this.$offset + (this.$x.$localOffset || this.$d.getTimezoneOffset());
          return this.$d.valueOf() - 6e4 * y;
        }, l.isUTC = function() {
          return !!this.$u;
        }, l.toISOString = function() {
          return this.toDate().toISOString();
        }, l.toString = function() {
          return this.toDate().toUTCString();
        };
        var d = l.toDate;
        l.toDate = function(y) {
          return y === "s" && this.$offset ? a(this.format("YYYY-MM-DD HH:mm:ss:SSS")).toDate() : d.call(this);
        };
        var g = l.diff;
        l.diff = function(y, b, _) {
          if (y && this.$u === y.$u) return g.call(this, y, b, _);
          var I = this.local(), w = a(y).local();
          return g.call(I, w, b, _);
        };
      };
    }));
  })(il)), il.exports;
}
var U1 = j1();
const $1 = /* @__PURE__ */ Ql(U1);
function rT(e, t, r) {
  try {
    return t !== void 0 ? JSON.stringify(e, r, t) : JSON.stringify(e);
  } catch {
    return "";
  }
}
function Te(e) {
  return typeof e == "object" && e !== null && !$e(e);
}
function dz(e) {
  return Xe(e) ? e > 0 : !1;
}
function Xe(e) {
  return typeof e == "number" && !isNaN(e);
}
function fa(e) {
  return typeof e == "boolean";
}
function vt(e) {
  return typeof e == "string";
}
function $e(e) {
  return Array.isArray(e);
}
function Bn(e) {
  return M(e) && e.length > 0;
}
function pz(e, t = "Expected a non-empty array") {
  if (!Bn(e)) throw new Error(t);
}
function M(e) {
  return e != null;
}
function Er(e) {
  return typeof e == "number" && isNaN(e) || e === void 0 || e === null;
}
function hz(e) {
  return Object.entries(e);
}
const Us = [
  "data",
  "error",
  "cause",
  "response",
  "config",
  "signal",
  "reason"
];
function Ko({
  fallback: e,
  options: t
}) {
  return function r(n, i, o, s = ".") {
    if (M(t == null ? void 0 : t.limit) && w1(o) >= t.limit)
      return o;
    if ($e(n)) {
      let f = { ...o };
      for (let u = 0; u < n.length; u++) {
        const h = `${s}[${u}]`;
        f = r(n[u], i, f, h);
      }
      return f;
    }
    if (vt(n))
      try {
        const f = JSON.parse(n);
        return r(f, i, o, s);
      } catch {
      }
    const a = i(n);
    let l = { ...o };
    if (M(a)) {
      const f = l[a];
      M(f) ? l[a] = [...f, s] : l[a] = [s];
    }
    if (!Te(n))
      return Object.keys(l).length > 0 ? l : e();
    for (const f of Us)
      if (M(n[f])) {
        const u = s === "." ? `.${f}` : `${s}.${f}`;
        l = r(n[f], i, l, u);
      }
    return Object.keys(l).length > 0 ? l : e();
  };
}
function F1({
  fallback: e,
  options: t
}) {
  return function r(n, i, o, s = ".") {
    if (M(t == null ? void 0 : t.limit) && o.length >= t.limit)
      return o;
    if ($e(n)) {
      let f = [...o];
      for (let u = 0; u < n.length; u++) {
        const h = `${s}[${u}]`;
        f = r(n[u], i, f, h);
      }
      return f;
    }
    if (vt(n))
      try {
        const f = JSON.parse(n);
        return r(f, i, o, s);
      } catch {
      }
    const a = i(n);
    let l = [...o];
    for (const f of a)
      l.push({ value: f, path: s });
    if (!Te(n))
      return l.length > 0 ? l : e();
    for (const f of Us)
      if (M(n[f])) {
        const u = s === "." ? `.${f}` : `${s}.${f}`;
        l = r(n[f], i, l, u);
      }
    return l.length > 0 ? l : e();
  };
}
function Oh(e, t) {
  return Ko({
    fallback: () => ({ [rT(e)]: ["."] }),
    options: t
  })(e, (r) => {
    if (Er(r))
      return "";
    if (vt(r))
      return r;
    if (G1(r))
      return r.message;
  }, {});
}
function Dt(e) {
  if (Te(e) && "response" in e) {
    const r = Oh(e), n = Object.entries(r).find(
      ([i, o]) => o == null ? void 0 : o.some((s) => s === ".response.data")
    );
    if (n)
      return n[0];
  }
  const t = Oh(e, { limit: 1 });
  return Xo(t)[0] ?? "";
}
function G1(e) {
  return Te(e) && Object.prototype.hasOwnProperty.call(e, "message") && typeof e.message == "string";
}
function Xo(e) {
  return Object.entries(e).map(([t, r]) => ({
    value: t,
    path: r.map(z1).sort(wh)[0]
  })).sort((t, r) => M(t.path) ? M(r.path) ? wh(t.path, r.path) : -1 : M(r.path) ? 1 : 0).map(({ value: t }) => t);
}
function z1(e) {
  return [...e.matchAll(/\.([^.[]+)|\[(\d+)\]/g)].flatMap(
    ([, t, r]) => M(r) ? [Number(r)] : M(t) ? [t] : []
  );
}
function wh(e, t) {
  if (e.length !== t.length) return e.length - t.length;
  for (let r = 0; r < e.length; r++) {
    const n = e[r], i = t[r];
    if (n === void 0 || i === void 0) break;
    const o = B1(n, i);
    if (o !== 0) return o;
  }
  return 0;
}
function B1(e, t) {
  return typeof e == "number" && typeof t == "number" ? e - t : typeof e == "number" ? -1 : typeof t == "number" ? 1 : Nh(e) - Nh(t) || e.localeCompare(t);
}
function Nh(e) {
  const t = Us.indexOf(e);
  return t === -1 ? Us.length : t;
}
const Ch = new RegExp(
  "^(?:0[1-9]|[1-2]\\d|3[0-1])[/-](?:0[1-9]|1[0-2])[/-]\\d{4}(?: (?:[0-1]\\d|2[0-4]):[0-5]\\d:[0-5]\\d)?$"
);
function mz(e) {
  return Te(e) && "data" in e;
}
Vo.extend($1);
Vo.extend(x1);
const ol = Kl(
  (e) => e instanceof Date ? e.toISOString() : e,
  Xl()
), _i = Kl(
  (e) => e instanceof Date ? e.toISOString() : e,
  Xl().optional()
);
function V1(e) {
  return jt(A(), e).refine((t) => Object.keys(t).length <= fh, {
    message: `Record cannot exceed ${fh} entries`
  });
}
function W1(e) {
  return e.superRefine((t, r) => {
    if (Te(t))
      for (const [n, i] of Object.entries(t))
        f1(i) && i !== null && r.issues.push({
          input: [n, i],
          code: "custom",
          path: [n],
          message: `${n} can be omitted, but not undefined.`
        });
  });
}
function sr(e, t) {
  const r = t.reduce((n, i) => (i in e.shape && (n[i] = !0), n), {});
  return e.omit(r);
}
const Ph = /* @__PURE__ */ new Map();
function fc(e, t) {
  let r = Ph.get(t);
  return r || (r = new Intl.DateTimeFormat("sv-SE", {
    timeZone: t,
    hourCycle: "h23",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit"
  }), Ph.set(t, r)), r.format(new Date(e * 1e3));
}
function q1(e, t, r) {
  try {
    const [n = "", i = "00:00:00"] = e.split(" "), [o, s, a] = n.split(/[/-]/), l = `${a}-${s}-${o} ${i}`, f = new RegExp(/\b\d\b/, "g"), u = l.replace(
      f,
      "0$&"
    );
    if (Vo.utc(u).format("YYYY-MM-DD HH:mm:ss") !== u)
      return r ? (r.issues.push({
        input: e,
        code: "custom",
        message: `Invalid date value: ${e}`
      }), { local: "", timezone: "", unix: 0 }) : { local: "Invalid Date", timezone: t, unix: NaN };
    const h = Vo.tz(u, t).unix();
    return { local: fc(h, t), timezone: t, unix: h };
  } catch (n) {
    if (r)
      r.issues.push({
        input: e,
        code: "custom",
        message: Dt(n)
      });
    else
      throw n;
    return {
      local: "",
      timezone: "",
      unix: 0
    };
  }
}
function H1(e, t, r) {
  try {
    const n = Vo(e);
    if (!n.isValid())
      return { local: "Invalid Date", timezone: t, unix: NaN };
    const i = n.unix();
    return { local: fc(i, t), timezone: t, unix: i };
  } catch (n) {
    if (r)
      r.issues.push({
        input: e,
        code: "custom",
        message: Dt(n)
      });
    else
      throw n;
    return {
      local: "",
      timezone: "",
      unix: 0
    };
  }
}
function dc(e, t, r) {
  try {
    return { local: fc(e, t), timezone: t, unix: e };
  } catch (n) {
    if (r)
      r.issues.push({
        input: e,
        code: "custom",
        message: Dt(n)
      });
    else
      throw n;
    return {
      local: "",
      unix: 0,
      timezone: ""
    };
  }
}
const nT = (e) => e.transform((t) => Number(t)).pipe(v()), iT = (e) => e.transform((t) => isFinite(Number(t)) ? Math.round(Number(t)) : 0).pipe(v()), oT = (e) => e.transform((t) => {
  const r = Number(t);
  return isFinite(r) && r >= 0 ? Math.round(r) : 0;
}).pipe(v()), sT = nT(lt()), Y1 = nT(A()), pc = iT(lt());
iT(A());
const In = oT(
  lt()
);
oT(A());
lt().transform((e) => e == null ? "" : Te(e) || Xe(e) ? e.toString() : vt(e) ? e : "").pipe(A());
const Dh = lt().transform((e) => typeof e == "object" ? JSON.stringify(e) : M(e) ? `${e}` : "").pipe(A());
lt().transform((e) => !!e).pipe(ie());
lt().transform((e) => $e(e) ? !!e[0] : !!e).pipe(ie());
lt().transform((e) => $e(e) ? e.length === 0 ? 0 : Number(e[0]) : Number(e)).pipe(v());
lt().transform((e) => $e(e) ? e.join(", ") : e ?? "").pipe(A());
const Mh = St([N({ id: A() }), A()]).transform((e) => Te(e) ? e.id : e).pipe(A()), Z1 = lt().transform((e) => e === void 0 ? [] : $e(e) ? e.map((t) => Dh.parse(t)) : [Dh.parse(e)]).pipe(k(A())), J1 = Xl({ offset: !0 }), Lh = (e) => A().superRefine((t, r) => {
  !Ch.test(t) && !J1.validate(t) && r.issues.push({
    input: t,
    message: `Wrong date format: ${t}`,
    code: "invalid_format",
    format: "date"
  });
}).transform((t, r) => Ch.test(t) ? q1(t, e, r) : H1(t, e, r)).pipe(Bt).or(
  v().int().nonnegative().transform((t, r) => dc(t, e, r)).pipe(Bt)
).or(Bt), xh = N({
  label: A(),
  title: A(),
  id: v()
}), K1 = St([v(), xh]).transform((e) => Xe(e) ? {
  label: "",
  title: "",
  id: e
} : e).pipe(xh), da = ht(
  A(),
  k(v()).or(Xr())
), X1 = ["open", "closed", "not_set"], Mr = pe(X1), hc = N({
  invalidCourseIds: ie(),
  invalidActivityType: ie()
}).partial(), aT = N({
  multipleAllocations: ie()
}).partial(), $s = hc.extend({
  noAllocation: ie()
}).partial(), uT = $s.extend({
  overEnrollment: ie()
}).partial(), lT = uT.keyof(), Q1 = pe([
  ...lT.exclude(hc.keyof().options).options,
  "groupDataIssues",
  "studentDataIssues"
]), cT = N({
  id: v(),
  incompleteStudents: k(v()).optional(),
  enrolledStudents: k(v()),
  activities: k(v()),
  object: Vt,
  capacity: v().int().nonnegative().optional(),
  inWaitlist: v().int().nonnegative().optional(),
  issues: uT,
  openStatuses: k(Mr)
}), fT = N({
  key: A(),
  id: v(),
  incompleteStudents: k(v()).optional(),
  groups: k(v()),
  activityType: A(),
  courseId: v(),
  students: k(v()),
  capacity: v().int().nonnegative().optional(),
  inWaitlist: v().int().nonnegative().optional()
}), eP = N({
  id: v(),
  object: Vt,
  issues: aT
}), dT = N({
  id: v(),
  activityId: v(),
  courseId: v(),
  object: Vt,
  allocated: v().int().nonnegative(),
  capacity: v().int().nonnegative(),
  inWaitlist: k(v().int().nonnegative()).default([]),
  leaving: k(v().int().nonnegative()).default([]),
  issues: $s,
  open: Mr
}), tP = N({
  conflict: k(v()),
  size: k(v()),
  buffer: k(v()),
  doubleBooked: k(v()),
  dedicated: k(v()),
  hidden: k(v()),
  registrationPeriod: k(v())
}), rP = N({
  systemError: ht(
    A(),
    N({
      message: A(),
      code: v(),
      name: aa,
      presentableText: A().nullable().optional()
    }).or(Xr())
  )
}), pT = N({
  failsWithGroups: tP.partial().optional(),
  failsWithMessage: rP.partial().optional(),
  linkedGroupIds: k(v())
});
ht(A(), pT);
const mc = N({
  courseId: v(),
  activity: A(),
  activityId: v().optional()
});
ht(
  A(),
  k(mc)
);
const nP = mc.extend({
  reasons: pT.partial().optional()
}), Ec = N({
  buffer: ie().optional(),
  doubleBooked: ie().optional(),
  dedicated: ie().optional(),
  hidden: ie().optional(),
  registrationPeriod: ie().optional()
}), gc = ht(
  A(),
  k(nP)
), iP = mc.extend({
  group: v()
}), oP = ht(
  A(),
  k(iP)
), yc = N({
  logId: A().optional(),
  failedGroups: gc,
  successGroups: oP,
  swapStudentInfo: da.optional()
});
yc.omit({
  swapStudentInfo: !0
}).extend({
  swapStudentInfo: Xr().optional()
});
yc.omit({
  swapStudentInfo: !0
}).extend({
  swapStudentInfo: da
});
N({
  missingLinks: k(v()),
  missingGroupsForActivities: k(v())
});
N({
  addResult: yc,
  removeResult: A()
});
N({
  size: v(),
  isPercent: ie()
});
const sP = ["start", "end"];
pe(sP);
const aP = N({
  numberOfIssues: v()
}), uP = N({
  completed: ie()
});
N({
  list: jt(Q1, aP),
  issueCount: v(),
  courses: jt(A(), uP.optional())
});
const lP = N({
  courseId: v(),
  groupIds: k(v())
});
N({
  changeRequests: k(lP)
});
const cP = N({
  groupId: v(),
  groupLabel: A(),
  courseIds: k(v()),
  courseLabels: k(A()),
  activityTypes: k(A()),
  issueNames: k(hc.keyof().or(fe("unknownIssue")))
});
N({
  groups: k(cP),
  total: v().int().nonnegative()
});
const fP = N({
  issueId: v(),
  studentId: v(),
  studentLabel: A(),
  courseId: v(),
  courseLabel: A(),
  activityId: v(),
  activityType: A(),
  groupIds: k(v()),
  groupLabels: k(A()),
  issueName: aT.keyof().or(fe("unknownIssue"))
});
N({
  students: k(fP),
  total: v().int().nonnegative()
});
const dP = N({
  id: v(),
  value: A()
}), pP = N({
  id: v()
}), hT = St([
  N({
    kind: fe("category"),
    data: k(dP)
  }),
  N({
    kind: fe("relation"),
    data: k(pP)
  }),
  N({
    kind: fe("none"),
    data: Xr().optional()
  })
]);
var mT = /* @__PURE__ */ ((e) => (e[e.SPREAD = 1] = "SPREAD", e))(mT || {});
const Fs = pe(mT);
var tn = /* @__PURE__ */ ((e) => (e.TYPE = "t", e.FIELD = "f", e.NONE = "none", e))(tn || {});
const hP = (e) => e, Gs = v(), mP = hP({
  t: N({
    r: Fs,
    v: Gs,
    k: fe(
      "t"
      /* TYPE */
    )
  }),
  f: N({
    r: Fs,
    v: Gs,
    k: fe(
      "f"
      /* FIELD */
    )
  }),
  none: N({
    k: fe(
      "none"
      /* NONE */
    )
  })
}), ET = hr(
  "k",
  Object.values(mP)
), EP = N({
  dedi: hT,
  dist: ET
}), gP = N({
  k: pe(tn).optional(),
  r: Fs.optional(),
  v: St([Gs, k(Gs)]).optional()
});
N({
  groupIds: k(v()),
  distribution: gP,
  override: ie()
});
const yP = N({
  id: v(),
  name: A(),
  activityId: v()
}), TP = N({
  id: v(),
  name: A(),
  groups: k(v()),
  courseId: v()
}), bP = N({
  id: v(),
  activities: k(v()).optional()
}), AP = N({
  id: v(),
  fields: k(Jo),
  relations: k(v()),
  activities: k(v()),
  totalActivities: v(),
  groups: k(v())
}), gT = "ALLOCATED", yT = "NOT_ALLOCATED", sl = "GROUP:", vP = St([
  fe(gT),
  fe(yT),
  A().regex(/^GROUP:\d+$/)
]);
N({
  programs: k(Vt),
  students: k(AP),
  groupLookup: ht(A(), yP),
  courseLookup: ht(A(), bP),
  activitiesLookup: ht(A(), TP),
  totalStudents: v()
});
const TT = N({
  fieldId: pc,
  values: Z1
}), bT = N({
  sort: pe(Yt).extract(["ASCFIELD", "DESCFIELD"]).optional(),
  sortFieldId: v().nonnegative().int().optional()
}), SP = N({
  sort: pe(Yt).extract(["ASCFIELD", "DESCFIELD"]).optional(),
  key: A()
});
St([bT, SP]);
const IP = k(
  N({
    reservationId: v(),
    start: v(),
    end: v(),
    studentSetGroupId: v(),
    activityId: v(),
    courseId: v()
  })
), _P = N({
  reservations: IP,
  allocated: ie()
}), RP = jt(
  A(),
  _P
);
jt(
  A(),
  RP
);
ht(A(), v());
const OP = N({
  taken: In,
  available: In,
  total: In,
  raw: N({
    taken: In,
    available: In,
    total: In,
    buffer: In
  })
}), AT = Vt == null ? void 0 : Vt.partial().and(
  Vt.pick({
    id: !0,
    extId: !0,
    fields: !0,
    members: !0,
    types: !0,
    relations: !0
  })
), vT = Vt.pick({
  id: !0,
  fields: !0
}), wP = vT.extend(
  Vt.pick({ relations: !0 }).shape
);
Vt.pick({
  id: !0,
  extId: !0,
  fields: !0,
  types: !0,
  relations: !0
});
const Tc = N({
  id: sT,
  label: A()
}), ST = Tc.extend({
  extId: A(),
  typeIds: k(v()),
  children: k(v()).optional().default([]),
  teObject: AT
}), IT = Tc.extend({
  children: k(v()).optional().default([]),
  parentId: v().int().positive()
}), bc = Tc.extend({
  extId: A(),
  typeIds: k(v()),
  parentId: v().int().positive(),
  teObject: AT,
  links: k(v())
});
N({
  courses: ht(A(), ST),
  activities: ht(A(), IT),
  groups: ht(A(), bc)
});
const NP = ST.extend({
  open: ie().optional(),
  showInRegistration: ie().optional().transform((e) => !!e)
});
NP.pick({
  id: !0,
  label: !0,
  children: !0,
  open: !0
}).extend({ teObject: vT });
IT.extend({
  allocationSignal: My.optional().default("ISSUE"),
  open: ie().optional(),
  showInRegistration: ie().optional().transform((e) => !!e),
  hasWaitlist: ie().default(!1),
  hasConflicts: ie().default(!1)
});
const CP = bc.extend({
  seats: OP.optional().default({
    taken: 0,
    available: 0,
    total: 0,
    raw: { taken: 0, available: 0, total: 0, buffer: 0 }
  }),
  allocationStatus: Xw.optional().default("NOT_ALLOCATED"),
  open: ie().optional(),
  dedicated: hT.optional().default({
    kind: "none",
    data: void 0
  }),
  hidden: ie().optional().transform((e) => !!e),
  showInRegistration: ie().optional().transform((e) => !!e),
  matchDedication: ie().optional().transform((e) => !!e),
  waitlistPosition: v().optional().default(0),
  hasStudentsInWaitlist: ie().optional().default(!1)
});
CP.pick({
  id: !0,
  label: !0,
  parentId: !0,
  links: !0,
  seats: !0,
  allocationStatus: !0,
  open: !0,
  dedicated: !0,
  hidden: !0,
  matchDedication: !0,
  waitlistPosition: !0,
  hasStudentsInWaitlist: !0
}).extend({ teObject: wP });
const PP = ["teacher", "student"];
pe(PP);
N({
  studentId: Y1.pipe(Wu().nonnegative())
});
N({
  objectIds: k(v())
});
N({
  teachers: A().optional(),
  rooms: A().optional()
});
N({
  modified: v().optional(),
  modifiedBy: Mh == null ? void 0 : Mh.optional()
});
const al = N({
  typeId: v().int().positive(),
  objectIds: k(v().int().positive()).min(1)
}), DP = N({
  sort: Zu.optional(),
  sortFieldId: v().nonnegative().int().optional()
}), _T = DP.superRefine((e, t) => {
  const r = e.sort === Zu.enum.ASCFIELD || e.sort === Zu.enum.DESCFIELD;
  r && e.sortFieldId === void 0 && t.issues.push({
    input: e,
    code: "custom",
    message: "sortFieldId is required when sort is ASCFIELD or DESCFIELD"
  }), !r && e.sortFieldId !== void 0 && t.issues.push({
    input: e,
    code: "custom",
    path: ["sortFieldId"],
    message: "sortFieldId must be omitted unless sort is ASCFIELD or DESCFIELD"
  });
});
var kh = {}, go = {}, jh;
function MP() {
  if (jh) return go;
  jh = 1, go.byteLength = a, go.toByteArray = f, go.fromByteArray = E;
  for (var e = [], t = [], r = typeof Uint8Array < "u" ? Uint8Array : Array, n = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", i = 0, o = n.length; i < o; ++i)
    e[i] = n[i], t[n.charCodeAt(i)] = i;
  t[45] = 62, t[95] = 63;
  function s(d) {
    var g = d.length;
    if (g % 4 > 0)
      throw new Error("Invalid string. Length must be a multiple of 4");
    var y = d.indexOf("=");
    y === -1 && (y = g);
    var b = y === g ? 0 : 4 - y % 4;
    return [y, b];
  }
  function a(d) {
    var g = s(d), y = g[0], b = g[1];
    return (y + b) * 3 / 4 - b;
  }
  function l(d, g, y) {
    return (g + y) * 3 / 4 - y;
  }
  function f(d) {
    var g, y = s(d), b = y[0], _ = y[1], I = new r(l(d, b, _)), w = 0, L = _ > 0 ? b - 4 : b, R;
    for (R = 0; R < L; R += 4)
      g = t[d.charCodeAt(R)] << 18 | t[d.charCodeAt(R + 1)] << 12 | t[d.charCodeAt(R + 2)] << 6 | t[d.charCodeAt(R + 3)], I[w++] = g >> 16 & 255, I[w++] = g >> 8 & 255, I[w++] = g & 255;
    return _ === 2 && (g = t[d.charCodeAt(R)] << 2 | t[d.charCodeAt(R + 1)] >> 4, I[w++] = g & 255), _ === 1 && (g = t[d.charCodeAt(R)] << 10 | t[d.charCodeAt(R + 1)] << 4 | t[d.charCodeAt(R + 2)] >> 2, I[w++] = g >> 8 & 255, I[w++] = g & 255), I;
  }
  function u(d) {
    return e[d >> 18 & 63] + e[d >> 12 & 63] + e[d >> 6 & 63] + e[d & 63];
  }
  function h(d, g, y) {
    for (var b, _ = [], I = g; I < y; I += 3)
      b = (d[I] << 16 & 16711680) + (d[I + 1] << 8 & 65280) + (d[I + 2] & 255), _.push(u(b));
    return _.join("");
  }
  function E(d) {
    for (var g, y = d.length, b = y % 3, _ = [], I = 16383, w = 0, L = y - b; w < L; w += I)
      _.push(h(d, w, w + I > L ? L : w + I));
    return b === 1 ? (g = d[y - 1], _.push(
      e[g >> 2] + e[g << 4 & 63] + "=="
    )) : b === 2 && (g = (d[y - 2] << 8) + d[y - 1], _.push(
      e[g >> 10] + e[g >> 4 & 63] + e[g << 2 & 63] + "="
    )), _.join("");
  }
  return go;
}
var Va = {};
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
var Uh;
function LP() {
  return Uh || (Uh = 1, Va.read = function(e, t, r, n, i) {
    var o, s, a = i * 8 - n - 1, l = (1 << a) - 1, f = l >> 1, u = -7, h = r ? i - 1 : 0, E = r ? -1 : 1, d = e[t + h];
    for (h += E, o = d & (1 << -u) - 1, d >>= -u, u += a; u > 0; o = o * 256 + e[t + h], h += E, u -= 8)
      ;
    for (s = o & (1 << -u) - 1, o >>= -u, u += n; u > 0; s = s * 256 + e[t + h], h += E, u -= 8)
      ;
    if (o === 0)
      o = 1 - f;
    else {
      if (o === l)
        return s ? NaN : (d ? -1 : 1) * (1 / 0);
      s = s + Math.pow(2, n), o = o - f;
    }
    return (d ? -1 : 1) * s * Math.pow(2, o - n);
  }, Va.write = function(e, t, r, n, i, o) {
    var s, a, l, f = o * 8 - i - 1, u = (1 << f) - 1, h = u >> 1, E = i === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0, d = n ? 0 : o - 1, g = n ? 1 : -1, y = t < 0 || t === 0 && 1 / t < 0 ? 1 : 0;
    for (t = Math.abs(t), isNaN(t) || t === 1 / 0 ? (a = isNaN(t) ? 1 : 0, s = u) : (s = Math.floor(Math.log(t) / Math.LN2), t * (l = Math.pow(2, -s)) < 1 && (s--, l *= 2), s + h >= 1 ? t += E / l : t += E * Math.pow(2, 1 - h), t * l >= 2 && (s++, l /= 2), s + h >= u ? (a = 0, s = u) : s + h >= 1 ? (a = (t * l - 1) * Math.pow(2, i), s = s + h) : (a = t * Math.pow(2, h - 1) * Math.pow(2, i), s = 0)); i >= 8; e[r + d] = a & 255, d += g, a /= 256, i -= 8)
      ;
    for (s = s << i | a, f += i; f > 0; e[r + d] = s & 255, d += g, s /= 256, f -= 8)
      ;
    e[r + d - g] |= y * 128;
  }), Va;
}
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */
var $h;
function xP() {
  return $h || ($h = 1, (function(e) {
    var t = MP(), r = LP(), n = typeof Symbol == "function" && typeof Symbol.for == "function" ? Symbol.for("nodejs.util.inspect.custom") : null;
    e.Buffer = a, e.SlowBuffer = I, e.INSPECT_MAX_BYTES = 50;
    var i = 2147483647;
    e.kMaxLength = i, a.TYPED_ARRAY_SUPPORT = o(), !a.TYPED_ARRAY_SUPPORT && typeof console < "u" && typeof console.error == "function" && console.error(
      "This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support."
    );
    function o() {
      try {
        var p = new Uint8Array(1), c = { foo: function() {
          return 42;
        } };
        return Object.setPrototypeOf(c, Uint8Array.prototype), Object.setPrototypeOf(p, c), p.foo() === 42;
      } catch {
        return !1;
      }
    }
    Object.defineProperty(a.prototype, "parent", {
      enumerable: !0,
      get: function() {
        if (a.isBuffer(this))
          return this.buffer;
      }
    }), Object.defineProperty(a.prototype, "offset", {
      enumerable: !0,
      get: function() {
        if (a.isBuffer(this))
          return this.byteOffset;
      }
    });
    function s(p) {
      if (p > i)
        throw new RangeError('The value "' + p + '" is invalid for option "size"');
      var c = new Uint8Array(p);
      return Object.setPrototypeOf(c, a.prototype), c;
    }
    function a(p, c, m) {
      if (typeof p == "number") {
        if (typeof c == "string")
          throw new TypeError(
            'The "string" argument must be of type string. Received type number'
          );
        return h(p);
      }
      return l(p, c, m);
    }
    a.poolSize = 8192;
    function l(p, c, m) {
      if (typeof p == "string")
        return E(p, c);
      if (ArrayBuffer.isView(p))
        return g(p);
      if (p == null)
        throw new TypeError(
          "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof p
        );
      if (Re(p, ArrayBuffer) || p && Re(p.buffer, ArrayBuffer) || typeof SharedArrayBuffer < "u" && (Re(p, SharedArrayBuffer) || p && Re(p.buffer, SharedArrayBuffer)))
        return y(p, c, m);
      if (typeof p == "number")
        throw new TypeError(
          'The "value" argument must not be of type number. Received type number'
        );
      var T = p.valueOf && p.valueOf();
      if (T != null && T !== p)
        return a.from(T, c, m);
      var S = b(p);
      if (S) return S;
      if (typeof Symbol < "u" && Symbol.toPrimitive != null && typeof p[Symbol.toPrimitive] == "function")
        return a.from(
          p[Symbol.toPrimitive]("string"),
          c,
          m
        );
      throw new TypeError(
        "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof p
      );
    }
    a.from = function(p, c, m) {
      return l(p, c, m);
    }, Object.setPrototypeOf(a.prototype, Uint8Array.prototype), Object.setPrototypeOf(a, Uint8Array);
    function f(p) {
      if (typeof p != "number")
        throw new TypeError('"size" argument must be of type number');
      if (p < 0)
        throw new RangeError('The value "' + p + '" is invalid for option "size"');
    }
    function u(p, c, m) {
      return f(p), p <= 0 ? s(p) : c !== void 0 ? typeof m == "string" ? s(p).fill(c, m) : s(p).fill(c) : s(p);
    }
    a.alloc = function(p, c, m) {
      return u(p, c, m);
    };
    function h(p) {
      return f(p), s(p < 0 ? 0 : _(p) | 0);
    }
    a.allocUnsafe = function(p) {
      return h(p);
    }, a.allocUnsafeSlow = function(p) {
      return h(p);
    };
    function E(p, c) {
      if ((typeof c != "string" || c === "") && (c = "utf8"), !a.isEncoding(c))
        throw new TypeError("Unknown encoding: " + c);
      var m = w(p, c) | 0, T = s(m), S = T.write(p, c);
      return S !== m && (T = T.slice(0, S)), T;
    }
    function d(p) {
      for (var c = p.length < 0 ? 0 : _(p.length) | 0, m = s(c), T = 0; T < c; T += 1)
        m[T] = p[T] & 255;
      return m;
    }
    function g(p) {
      if (Re(p, Uint8Array)) {
        var c = new Uint8Array(p);
        return y(c.buffer, c.byteOffset, c.byteLength);
      }
      return d(p);
    }
    function y(p, c, m) {
      if (c < 0 || p.byteLength < c)
        throw new RangeError('"offset" is outside of buffer bounds');
      if (p.byteLength < c + (m || 0))
        throw new RangeError('"length" is outside of buffer bounds');
      var T;
      return c === void 0 && m === void 0 ? T = new Uint8Array(p) : m === void 0 ? T = new Uint8Array(p, c) : T = new Uint8Array(p, c, m), Object.setPrototypeOf(T, a.prototype), T;
    }
    function b(p) {
      if (a.isBuffer(p)) {
        var c = _(p.length) | 0, m = s(c);
        return m.length === 0 || p.copy(m, 0, 0, c), m;
      }
      if (p.length !== void 0)
        return typeof p.length != "number" || gt(p.length) ? s(0) : d(p);
      if (p.type === "Buffer" && Array.isArray(p.data))
        return d(p.data);
    }
    function _(p) {
      if (p >= i)
        throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + i.toString(16) + " bytes");
      return p | 0;
    }
    function I(p) {
      return +p != p && (p = 0), a.alloc(+p);
    }
    a.isBuffer = function(p) {
      return p != null && p._isBuffer === !0 && p !== a.prototype;
    }, a.compare = function(p, c) {
      if (Re(p, Uint8Array) && (p = a.from(p, p.offset, p.byteLength)), Re(c, Uint8Array) && (c = a.from(c, c.offset, c.byteLength)), !a.isBuffer(p) || !a.isBuffer(c))
        throw new TypeError(
          'The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array'
        );
      if (p === c) return 0;
      for (var m = p.length, T = c.length, S = 0, j = Math.min(m, T); S < j; ++S)
        if (p[S] !== c[S]) {
          m = p[S], T = c[S];
          break;
        }
      return m < T ? -1 : T < m ? 1 : 0;
    }, a.isEncoding = function(p) {
      switch (String(p).toLowerCase()) {
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return !0;
        default:
          return !1;
      }
    }, a.concat = function(p, c) {
      if (!Array.isArray(p))
        throw new TypeError('"list" argument must be an Array of Buffers');
      if (p.length === 0)
        return a.alloc(0);
      var m;
      if (c === void 0)
        for (c = 0, m = 0; m < p.length; ++m)
          c += p[m].length;
      var T = a.allocUnsafe(c), S = 0;
      for (m = 0; m < p.length; ++m) {
        var j = p[m];
        if (Re(j, Uint8Array))
          S + j.length > T.length ? a.from(j).copy(T, S) : Uint8Array.prototype.set.call(
            T,
            j,
            S
          );
        else if (a.isBuffer(j))
          j.copy(T, S);
        else
          throw new TypeError('"list" argument must be an Array of Buffers');
        S += j.length;
      }
      return T;
    };
    function w(p, c) {
      if (a.isBuffer(p))
        return p.length;
      if (ArrayBuffer.isView(p) || Re(p, ArrayBuffer))
        return p.byteLength;
      if (typeof p != "string")
        throw new TypeError(
          'The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof p
        );
      var m = p.length, T = arguments.length > 2 && arguments[2] === !0;
      if (!T && m === 0) return 0;
      for (var S = !1; ; )
        switch (c) {
          case "ascii":
          case "latin1":
          case "binary":
            return m;
          case "utf8":
          case "utf-8":
            return Ue(p).length;
          case "ucs2":
          case "ucs-2":
          case "utf16le":
          case "utf-16le":
            return m * 2;
          case "hex":
            return m >>> 1;
          case "base64":
            return Le(p).length;
          default:
            if (S)
              return T ? -1 : Ue(p).length;
            c = ("" + c).toLowerCase(), S = !0;
        }
    }
    a.byteLength = w;
    function L(p, c, m) {
      var T = !1;
      if ((c === void 0 || c < 0) && (c = 0), c > this.length || ((m === void 0 || m > this.length) && (m = this.length), m <= 0) || (m >>>= 0, c >>>= 0, m <= c))
        return "";
      for (p || (p = "utf8"); ; )
        switch (p) {
          case "hex":
            return Q(this, c, m);
          case "utf8":
          case "utf-8":
            return q(this, c, m);
          case "ascii":
            return Z(this, c, m);
          case "latin1":
          case "binary":
            return G(this, c, m);
          case "base64":
            return ae(this, c, m);
          case "ucs2":
          case "ucs-2":
          case "utf16le":
          case "utf-16le":
            return K(this, c, m);
          default:
            if (T) throw new TypeError("Unknown encoding: " + p);
            p = (p + "").toLowerCase(), T = !0;
        }
    }
    a.prototype._isBuffer = !0;
    function R(p, c, m) {
      var T = p[c];
      p[c] = p[m], p[m] = T;
    }
    a.prototype.swap16 = function() {
      var p = this.length;
      if (p % 2 !== 0)
        throw new RangeError("Buffer size must be a multiple of 16-bits");
      for (var c = 0; c < p; c += 2)
        R(this, c, c + 1);
      return this;
    }, a.prototype.swap32 = function() {
      var p = this.length;
      if (p % 4 !== 0)
        throw new RangeError("Buffer size must be a multiple of 32-bits");
      for (var c = 0; c < p; c += 4)
        R(this, c, c + 3), R(this, c + 1, c + 2);
      return this;
    }, a.prototype.swap64 = function() {
      var p = this.length;
      if (p % 8 !== 0)
        throw new RangeError("Buffer size must be a multiple of 64-bits");
      for (var c = 0; c < p; c += 8)
        R(this, c, c + 7), R(this, c + 1, c + 6), R(this, c + 2, c + 5), R(this, c + 3, c + 4);
      return this;
    }, a.prototype.toString = function() {
      var p = this.length;
      return p === 0 ? "" : arguments.length === 0 ? q(this, 0, p) : L.apply(this, arguments);
    }, a.prototype.toLocaleString = a.prototype.toString, a.prototype.equals = function(p) {
      if (!a.isBuffer(p)) throw new TypeError("Argument must be a Buffer");
      return this === p ? !0 : a.compare(this, p) === 0;
    }, a.prototype.inspect = function() {
      var p = "", c = e.INSPECT_MAX_BYTES;
      return p = this.toString("hex", 0, c).replace(/(.{2})/g, "$1 ").trim(), this.length > c && (p += " ... "), "<Buffer " + p + ">";
    }, n && (a.prototype[n] = a.prototype.inspect), a.prototype.compare = function(p, c, m, T, S) {
      if (Re(p, Uint8Array) && (p = a.from(p, p.offset, p.byteLength)), !a.isBuffer(p))
        throw new TypeError(
          'The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof p
        );
      if (c === void 0 && (c = 0), m === void 0 && (m = p ? p.length : 0), T === void 0 && (T = 0), S === void 0 && (S = this.length), c < 0 || m > p.length || T < 0 || S > this.length)
        throw new RangeError("out of range index");
      if (T >= S && c >= m)
        return 0;
      if (T >= S)
        return -1;
      if (c >= m)
        return 1;
      if (c >>>= 0, m >>>= 0, T >>>= 0, S >>>= 0, this === p) return 0;
      for (var j = S - T, W = m - c, ue = Math.min(j, W), be = this.slice(T, S), me = p.slice(c, m), we = 0; we < ue; ++we)
        if (be[we] !== me[we]) {
          j = be[we], W = me[we];
          break;
        }
      return j < W ? -1 : W < j ? 1 : 0;
    };
    function D(p, c, m, T, S) {
      if (p.length === 0) return -1;
      if (typeof m == "string" ? (T = m, m = 0) : m > 2147483647 ? m = 2147483647 : m < -2147483648 && (m = -2147483648), m = +m, gt(m) && (m = S ? 0 : p.length - 1), m < 0 && (m = p.length + m), m >= p.length) {
        if (S) return -1;
        m = p.length - 1;
      } else if (m < 0)
        if (S) m = 0;
        else return -1;
      if (typeof c == "string" && (c = a.from(c, T)), a.isBuffer(c))
        return c.length === 0 ? -1 : P(p, c, m, T, S);
      if (typeof c == "number")
        return c = c & 255, typeof Uint8Array.prototype.indexOf == "function" ? S ? Uint8Array.prototype.indexOf.call(p, c, m) : Uint8Array.prototype.lastIndexOf.call(p, c, m) : P(p, [c], m, T, S);
      throw new TypeError("val must be string, number or Buffer");
    }
    function P(p, c, m, T, S) {
      var j = 1, W = p.length, ue = c.length;
      if (T !== void 0 && (T = String(T).toLowerCase(), T === "ucs2" || T === "ucs-2" || T === "utf16le" || T === "utf-16le")) {
        if (p.length < 2 || c.length < 2)
          return -1;
        j = 2, W /= 2, ue /= 2, m /= 2;
      }
      function be(H, te) {
        return j === 1 ? H[te] : H.readUInt16BE(te * j);
      }
      var me;
      if (S) {
        var we = -1;
        for (me = m; me < W; me++)
          if (be(p, me) === be(c, we === -1 ? 0 : me - we)) {
            if (we === -1 && (we = me), me - we + 1 === ue) return we * j;
          } else
            we !== -1 && (me -= me - we), we = -1;
      } else
        for (m + ue > W && (m = W - ue), me = m; me >= 0; me--) {
          for (var Oe = !0, Ut = 0; Ut < ue; Ut++)
            if (be(p, me + Ut) !== be(c, Ut)) {
              Oe = !1;
              break;
            }
          if (Oe) return me;
        }
      return -1;
    }
    a.prototype.includes = function(p, c, m) {
      return this.indexOf(p, c, m) !== -1;
    }, a.prototype.indexOf = function(p, c, m) {
      return D(this, p, c, m, !0);
    }, a.prototype.lastIndexOf = function(p, c, m) {
      return D(this, p, c, m, !1);
    };
    function O(p, c, m, T) {
      m = Number(m) || 0;
      var S = p.length - m;
      T ? (T = Number(T), T > S && (T = S)) : T = S;
      var j = c.length;
      T > j / 2 && (T = j / 2);
      for (var W = 0; W < T; ++W) {
        var ue = parseInt(c.substr(W * 2, 2), 16);
        if (gt(ue)) return W;
        p[m + W] = ue;
      }
      return W;
    }
    function F(p, c, m, T) {
      return De(Ue(c, p.length - m), p, m, T);
    }
    function U(p, c, m, T) {
      return De(Fe(c), p, m, T);
    }
    function z(p, c, m, T) {
      return De(Le(c), p, m, T);
    }
    function V(p, c, m, T) {
      return De(_e(c, p.length - m), p, m, T);
    }
    a.prototype.write = function(p, c, m, T) {
      if (c === void 0)
        T = "utf8", m = this.length, c = 0;
      else if (m === void 0 && typeof c == "string")
        T = c, m = this.length, c = 0;
      else if (isFinite(c))
        c = c >>> 0, isFinite(m) ? (m = m >>> 0, T === void 0 && (T = "utf8")) : (T = m, m = void 0);
      else
        throw new Error(
          "Buffer.write(string, encoding, offset[, length]) is no longer supported"
        );
      var S = this.length - c;
      if ((m === void 0 || m > S) && (m = S), p.length > 0 && (m < 0 || c < 0) || c > this.length)
        throw new RangeError("Attempt to write outside buffer bounds");
      T || (T = "utf8");
      for (var j = !1; ; )
        switch (T) {
          case "hex":
            return O(this, p, c, m);
          case "utf8":
          case "utf-8":
            return F(this, p, c, m);
          case "ascii":
          case "latin1":
          case "binary":
            return U(this, p, c, m);
          case "base64":
            return z(this, p, c, m);
          case "ucs2":
          case "ucs-2":
          case "utf16le":
          case "utf-16le":
            return V(this, p, c, m);
          default:
            if (j) throw new TypeError("Unknown encoding: " + T);
            T = ("" + T).toLowerCase(), j = !0;
        }
    }, a.prototype.toJSON = function() {
      return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
      };
    };
    function ae(p, c, m) {
      return c === 0 && m === p.length ? t.fromByteArray(p) : t.fromByteArray(p.slice(c, m));
    }
    function q(p, c, m) {
      m = Math.min(p.length, m);
      for (var T = [], S = c; S < m; ) {
        var j = p[S], W = null, ue = j > 239 ? 4 : j > 223 ? 3 : j > 191 ? 2 : 1;
        if (S + ue <= m) {
          var be, me, we, Oe;
          switch (ue) {
            case 1:
              j < 128 && (W = j);
              break;
            case 2:
              be = p[S + 1], (be & 192) === 128 && (Oe = (j & 31) << 6 | be & 63, Oe > 127 && (W = Oe));
              break;
            case 3:
              be = p[S + 1], me = p[S + 2], (be & 192) === 128 && (me & 192) === 128 && (Oe = (j & 15) << 12 | (be & 63) << 6 | me & 63, Oe > 2047 && (Oe < 55296 || Oe > 57343) && (W = Oe));
              break;
            case 4:
              be = p[S + 1], me = p[S + 2], we = p[S + 3], (be & 192) === 128 && (me & 192) === 128 && (we & 192) === 128 && (Oe = (j & 15) << 18 | (be & 63) << 12 | (me & 63) << 6 | we & 63, Oe > 65535 && Oe < 1114112 && (W = Oe));
          }
        }
        W === null ? (W = 65533, ue = 1) : W > 65535 && (W -= 65536, T.push(W >>> 10 & 1023 | 55296), W = 56320 | W & 1023), T.push(W), S += ue;
      }
      return B(T);
    }
    var x = 4096;
    function B(p) {
      var c = p.length;
      if (c <= x)
        return String.fromCharCode.apply(String, p);
      for (var m = "", T = 0; T < c; )
        m += String.fromCharCode.apply(
          String,
          p.slice(T, T += x)
        );
      return m;
    }
    function Z(p, c, m) {
      var T = "";
      m = Math.min(p.length, m);
      for (var S = c; S < m; ++S)
        T += String.fromCharCode(p[S] & 127);
      return T;
    }
    function G(p, c, m) {
      var T = "";
      m = Math.min(p.length, m);
      for (var S = c; S < m; ++S)
        T += String.fromCharCode(p[S]);
      return T;
    }
    function Q(p, c, m) {
      var T = p.length;
      (!c || c < 0) && (c = 0), (!m || m < 0 || m > T) && (m = T);
      for (var S = "", j = c; j < m; ++j)
        S += ti[p[j]];
      return S;
    }
    function K(p, c, m) {
      for (var T = p.slice(c, m), S = "", j = 0; j < T.length - 1; j += 2)
        S += String.fromCharCode(T[j] + T[j + 1] * 256);
      return S;
    }
    a.prototype.slice = function(p, c) {
      var m = this.length;
      p = ~~p, c = c === void 0 ? m : ~~c, p < 0 ? (p += m, p < 0 && (p = 0)) : p > m && (p = m), c < 0 ? (c += m, c < 0 && (c = 0)) : c > m && (c = m), c < p && (c = p);
      var T = this.subarray(p, c);
      return Object.setPrototypeOf(T, a.prototype), T;
    };
    function ee(p, c, m) {
      if (p % 1 !== 0 || p < 0) throw new RangeError("offset is not uint");
      if (p + c > m) throw new RangeError("Trying to access beyond buffer length");
    }
    a.prototype.readUintLE = a.prototype.readUIntLE = function(p, c, m) {
      p = p >>> 0, c = c >>> 0, m || ee(p, c, this.length);
      for (var T = this[p], S = 1, j = 0; ++j < c && (S *= 256); )
        T += this[p + j] * S;
      return T;
    }, a.prototype.readUintBE = a.prototype.readUIntBE = function(p, c, m) {
      p = p >>> 0, c = c >>> 0, m || ee(p, c, this.length);
      for (var T = this[p + --c], S = 1; c > 0 && (S *= 256); )
        T += this[p + --c] * S;
      return T;
    }, a.prototype.readUint8 = a.prototype.readUInt8 = function(p, c) {
      return p = p >>> 0, c || ee(p, 1, this.length), this[p];
    }, a.prototype.readUint16LE = a.prototype.readUInt16LE = function(p, c) {
      return p = p >>> 0, c || ee(p, 2, this.length), this[p] | this[p + 1] << 8;
    }, a.prototype.readUint16BE = a.prototype.readUInt16BE = function(p, c) {
      return p = p >>> 0, c || ee(p, 2, this.length), this[p] << 8 | this[p + 1];
    }, a.prototype.readUint32LE = a.prototype.readUInt32LE = function(p, c) {
      return p = p >>> 0, c || ee(p, 4, this.length), (this[p] | this[p + 1] << 8 | this[p + 2] << 16) + this[p + 3] * 16777216;
    }, a.prototype.readUint32BE = a.prototype.readUInt32BE = function(p, c) {
      return p = p >>> 0, c || ee(p, 4, this.length), this[p] * 16777216 + (this[p + 1] << 16 | this[p + 2] << 8 | this[p + 3]);
    }, a.prototype.readIntLE = function(p, c, m) {
      p = p >>> 0, c = c >>> 0, m || ee(p, c, this.length);
      for (var T = this[p], S = 1, j = 0; ++j < c && (S *= 256); )
        T += this[p + j] * S;
      return S *= 128, T >= S && (T -= Math.pow(2, 8 * c)), T;
    }, a.prototype.readIntBE = function(p, c, m) {
      p = p >>> 0, c = c >>> 0, m || ee(p, c, this.length);
      for (var T = c, S = 1, j = this[p + --T]; T > 0 && (S *= 256); )
        j += this[p + --T] * S;
      return S *= 128, j >= S && (j -= Math.pow(2, 8 * c)), j;
    }, a.prototype.readInt8 = function(p, c) {
      return p = p >>> 0, c || ee(p, 1, this.length), this[p] & 128 ? (255 - this[p] + 1) * -1 : this[p];
    }, a.prototype.readInt16LE = function(p, c) {
      p = p >>> 0, c || ee(p, 2, this.length);
      var m = this[p] | this[p + 1] << 8;
      return m & 32768 ? m | 4294901760 : m;
    }, a.prototype.readInt16BE = function(p, c) {
      p = p >>> 0, c || ee(p, 2, this.length);
      var m = this[p + 1] | this[p] << 8;
      return m & 32768 ? m | 4294901760 : m;
    }, a.prototype.readInt32LE = function(p, c) {
      return p = p >>> 0, c || ee(p, 4, this.length), this[p] | this[p + 1] << 8 | this[p + 2] << 16 | this[p + 3] << 24;
    }, a.prototype.readInt32BE = function(p, c) {
      return p = p >>> 0, c || ee(p, 4, this.length), this[p] << 24 | this[p + 1] << 16 | this[p + 2] << 8 | this[p + 3];
    }, a.prototype.readFloatLE = function(p, c) {
      return p = p >>> 0, c || ee(p, 4, this.length), r.read(this, p, !0, 23, 4);
    }, a.prototype.readFloatBE = function(p, c) {
      return p = p >>> 0, c || ee(p, 4, this.length), r.read(this, p, !1, 23, 4);
    }, a.prototype.readDoubleLE = function(p, c) {
      return p = p >>> 0, c || ee(p, 8, this.length), r.read(this, p, !0, 52, 8);
    }, a.prototype.readDoubleBE = function(p, c) {
      return p = p >>> 0, c || ee(p, 8, this.length), r.read(this, p, !1, 52, 8);
    };
    function ne(p, c, m, T, S, j) {
      if (!a.isBuffer(p)) throw new TypeError('"buffer" argument must be a Buffer instance');
      if (c > S || c < j) throw new RangeError('"value" argument is out of bounds');
      if (m + T > p.length) throw new RangeError("Index out of range");
    }
    a.prototype.writeUintLE = a.prototype.writeUIntLE = function(p, c, m, T) {
      if (p = +p, c = c >>> 0, m = m >>> 0, !T) {
        var S = Math.pow(2, 8 * m) - 1;
        ne(this, p, c, m, S, 0);
      }
      var j = 1, W = 0;
      for (this[c] = p & 255; ++W < m && (j *= 256); )
        this[c + W] = p / j & 255;
      return c + m;
    }, a.prototype.writeUintBE = a.prototype.writeUIntBE = function(p, c, m, T) {
      if (p = +p, c = c >>> 0, m = m >>> 0, !T) {
        var S = Math.pow(2, 8 * m) - 1;
        ne(this, p, c, m, S, 0);
      }
      var j = m - 1, W = 1;
      for (this[c + j] = p & 255; --j >= 0 && (W *= 256); )
        this[c + j] = p / W & 255;
      return c + m;
    }, a.prototype.writeUint8 = a.prototype.writeUInt8 = function(p, c, m) {
      return p = +p, c = c >>> 0, m || ne(this, p, c, 1, 255, 0), this[c] = p & 255, c + 1;
    }, a.prototype.writeUint16LE = a.prototype.writeUInt16LE = function(p, c, m) {
      return p = +p, c = c >>> 0, m || ne(this, p, c, 2, 65535, 0), this[c] = p & 255, this[c + 1] = p >>> 8, c + 2;
    }, a.prototype.writeUint16BE = a.prototype.writeUInt16BE = function(p, c, m) {
      return p = +p, c = c >>> 0, m || ne(this, p, c, 2, 65535, 0), this[c] = p >>> 8, this[c + 1] = p & 255, c + 2;
    }, a.prototype.writeUint32LE = a.prototype.writeUInt32LE = function(p, c, m) {
      return p = +p, c = c >>> 0, m || ne(this, p, c, 4, 4294967295, 0), this[c + 3] = p >>> 24, this[c + 2] = p >>> 16, this[c + 1] = p >>> 8, this[c] = p & 255, c + 4;
    }, a.prototype.writeUint32BE = a.prototype.writeUInt32BE = function(p, c, m) {
      return p = +p, c = c >>> 0, m || ne(this, p, c, 4, 4294967295, 0), this[c] = p >>> 24, this[c + 1] = p >>> 16, this[c + 2] = p >>> 8, this[c + 3] = p & 255, c + 4;
    }, a.prototype.writeIntLE = function(p, c, m, T) {
      if (p = +p, c = c >>> 0, !T) {
        var S = Math.pow(2, 8 * m - 1);
        ne(this, p, c, m, S - 1, -S);
      }
      var j = 0, W = 1, ue = 0;
      for (this[c] = p & 255; ++j < m && (W *= 256); )
        p < 0 && ue === 0 && this[c + j - 1] !== 0 && (ue = 1), this[c + j] = (p / W >> 0) - ue & 255;
      return c + m;
    }, a.prototype.writeIntBE = function(p, c, m, T) {
      if (p = +p, c = c >>> 0, !T) {
        var S = Math.pow(2, 8 * m - 1);
        ne(this, p, c, m, S - 1, -S);
      }
      var j = m - 1, W = 1, ue = 0;
      for (this[c + j] = p & 255; --j >= 0 && (W *= 256); )
        p < 0 && ue === 0 && this[c + j + 1] !== 0 && (ue = 1), this[c + j] = (p / W >> 0) - ue & 255;
      return c + m;
    }, a.prototype.writeInt8 = function(p, c, m) {
      return p = +p, c = c >>> 0, m || ne(this, p, c, 1, 127, -128), p < 0 && (p = 255 + p + 1), this[c] = p & 255, c + 1;
    }, a.prototype.writeInt16LE = function(p, c, m) {
      return p = +p, c = c >>> 0, m || ne(this, p, c, 2, 32767, -32768), this[c] = p & 255, this[c + 1] = p >>> 8, c + 2;
    }, a.prototype.writeInt16BE = function(p, c, m) {
      return p = +p, c = c >>> 0, m || ne(this, p, c, 2, 32767, -32768), this[c] = p >>> 8, this[c + 1] = p & 255, c + 2;
    }, a.prototype.writeInt32LE = function(p, c, m) {
      return p = +p, c = c >>> 0, m || ne(this, p, c, 4, 2147483647, -2147483648), this[c] = p & 255, this[c + 1] = p >>> 8, this[c + 2] = p >>> 16, this[c + 3] = p >>> 24, c + 4;
    }, a.prototype.writeInt32BE = function(p, c, m) {
      return p = +p, c = c >>> 0, m || ne(this, p, c, 4, 2147483647, -2147483648), p < 0 && (p = 4294967295 + p + 1), this[c] = p >>> 24, this[c + 1] = p >>> 16, this[c + 2] = p >>> 8, this[c + 3] = p & 255, c + 4;
    };
    function re(p, c, m, T, S, j) {
      if (m + T > p.length) throw new RangeError("Index out of range");
      if (m < 0) throw new RangeError("Index out of range");
    }
    function Ae(p, c, m, T, S) {
      return c = +c, m = m >>> 0, S || re(p, c, m, 4), r.write(p, c, m, T, 23, 4), m + 4;
    }
    a.prototype.writeFloatLE = function(p, c, m) {
      return Ae(this, p, c, !0, m);
    }, a.prototype.writeFloatBE = function(p, c, m) {
      return Ae(this, p, c, !1, m);
    };
    function ge(p, c, m, T, S) {
      return c = +c, m = m >>> 0, S || re(p, c, m, 8), r.write(p, c, m, T, 52, 8), m + 8;
    }
    a.prototype.writeDoubleLE = function(p, c, m) {
      return ge(this, p, c, !0, m);
    }, a.prototype.writeDoubleBE = function(p, c, m) {
      return ge(this, p, c, !1, m);
    }, a.prototype.copy = function(p, c, m, T) {
      if (!a.isBuffer(p)) throw new TypeError("argument should be a Buffer");
      if (m || (m = 0), !T && T !== 0 && (T = this.length), c >= p.length && (c = p.length), c || (c = 0), T > 0 && T < m && (T = m), T === m || p.length === 0 || this.length === 0) return 0;
      if (c < 0)
        throw new RangeError("targetStart out of bounds");
      if (m < 0 || m >= this.length) throw new RangeError("Index out of range");
      if (T < 0) throw new RangeError("sourceEnd out of bounds");
      T > this.length && (T = this.length), p.length - c < T - m && (T = p.length - c + m);
      var S = T - m;
      return this === p && typeof Uint8Array.prototype.copyWithin == "function" ? this.copyWithin(c, m, T) : Uint8Array.prototype.set.call(
        p,
        this.subarray(m, T),
        c
      ), S;
    }, a.prototype.fill = function(p, c, m, T) {
      if (typeof p == "string") {
        if (typeof c == "string" ? (T = c, c = 0, m = this.length) : typeof m == "string" && (T = m, m = this.length), T !== void 0 && typeof T != "string")
          throw new TypeError("encoding must be a string");
        if (typeof T == "string" && !a.isEncoding(T))
          throw new TypeError("Unknown encoding: " + T);
        if (p.length === 1) {
          var S = p.charCodeAt(0);
          (T === "utf8" && S < 128 || T === "latin1") && (p = S);
        }
      } else typeof p == "number" ? p = p & 255 : typeof p == "boolean" && (p = Number(p));
      if (c < 0 || this.length < c || this.length < m)
        throw new RangeError("Out of range index");
      if (m <= c)
        return this;
      c = c >>> 0, m = m === void 0 ? this.length : m >>> 0, p || (p = 0);
      var j;
      if (typeof p == "number")
        for (j = c; j < m; ++j)
          this[j] = p;
      else {
        var W = a.isBuffer(p) ? p : a.from(p, T), ue = W.length;
        if (ue === 0)
          throw new TypeError('The value "' + p + '" is invalid for argument "value"');
        for (j = 0; j < m - c; ++j)
          this[j + c] = W[j % ue];
      }
      return this;
    };
    var Ne = /[^+/0-9A-Za-z-_]/g;
    function We(p) {
      if (p = p.split("=")[0], p = p.trim().replace(Ne, ""), p.length < 2) return "";
      for (; p.length % 4 !== 0; )
        p = p + "=";
      return p;
    }
    function Ue(p, c) {
      c = c || 1 / 0;
      for (var m, T = p.length, S = null, j = [], W = 0; W < T; ++W) {
        if (m = p.charCodeAt(W), m > 55295 && m < 57344) {
          if (!S) {
            if (m > 56319) {
              (c -= 3) > -1 && j.push(239, 191, 189);
              continue;
            } else if (W + 1 === T) {
              (c -= 3) > -1 && j.push(239, 191, 189);
              continue;
            }
            S = m;
            continue;
          }
          if (m < 56320) {
            (c -= 3) > -1 && j.push(239, 191, 189), S = m;
            continue;
          }
          m = (S - 55296 << 10 | m - 56320) + 65536;
        } else S && (c -= 3) > -1 && j.push(239, 191, 189);
        if (S = null, m < 128) {
          if ((c -= 1) < 0) break;
          j.push(m);
        } else if (m < 2048) {
          if ((c -= 2) < 0) break;
          j.push(
            m >> 6 | 192,
            m & 63 | 128
          );
        } else if (m < 65536) {
          if ((c -= 3) < 0) break;
          j.push(
            m >> 12 | 224,
            m >> 6 & 63 | 128,
            m & 63 | 128
          );
        } else if (m < 1114112) {
          if ((c -= 4) < 0) break;
          j.push(
            m >> 18 | 240,
            m >> 12 & 63 | 128,
            m >> 6 & 63 | 128,
            m & 63 | 128
          );
        } else
          throw new Error("Invalid code point");
      }
      return j;
    }
    function Fe(p) {
      for (var c = [], m = 0; m < p.length; ++m)
        c.push(p.charCodeAt(m) & 255);
      return c;
    }
    function _e(p, c) {
      for (var m, T, S, j = [], W = 0; W < p.length && !((c -= 2) < 0); ++W)
        m = p.charCodeAt(W), T = m >> 8, S = m % 256, j.push(S), j.push(T);
      return j;
    }
    function Le(p) {
      return t.toByteArray(We(p));
    }
    function De(p, c, m, T) {
      for (var S = 0; S < T && !(S + m >= c.length || S >= p.length); ++S)
        c[S + m] = p[S];
      return S;
    }
    function Re(p, c) {
      return p instanceof c || p != null && p.constructor != null && p.constructor.name != null && p.constructor.name === c.name;
    }
    function gt(p) {
      return p !== p;
    }
    var ti = (function() {
      for (var p = "0123456789abcdef", c = new Array(256), m = 0; m < 16; ++m)
        for (var T = m * 16, S = 0; S < 16; ++S)
          c[T + S] = p[m] + p[S];
      return c;
    })();
  })(kh)), kh;
}
var kP = xP();
N({
  id: v(),
  fields: k(Jo),
  members: k(ac)
});
N({
  id: v(),
  begin: v().optional(),
  end: v().optional(),
  objects: k(
    N({
      objectId: v(),
      typeId: v()
    })
  ),
  fields: k(
    N({
      fieldId: v(),
      values: k(A())
    })
  )
});
const Ri = N({
  id: A(),
  name: A(),
  value: v().optional(),
  cost: v().optional()
}), RT = N({
  impossible: v(),
  impossibleInCurrent: v(),
  notEnoughSpaceOnPossible: v()
}), jP = Object.keys(RT.shape), UP = pe(jP), $P = Ri.extend({
  id: fe("nofFailedDecisions"),
  kpis: k(
    Ri.extend({
      id: UP
    })
  )
}), OT = N({
  nofAssignedDecisions: v(),
  nofCompleteStudents: v(),
  nofIncompleteStudents: v(),
  nofFailedDecisions: v()
}), FP = Object.keys(OT.shape), GP = pe(FP), zP = Ri.extend({
  id: fe("solutionAnalysis"),
  kpis: k(
    St([
      $P,
      Ri.extend({
        id: GP
      })
    ])
  )
}), wT = N({
  nofStudents: v(),
  nofStudentSetGroups: v(),
  nofLockedDecisions: v(),
  nofNonLockedDecisions: v(),
  nofLockedStudents: v()
}), BP = Object.keys(wT.shape), VP = pe(BP), WP = Ri.extend({
  id: fe("problemAnalysis"),
  kpis: k(
    Ri.extend({
      id: VP
    })
  )
}), qP = hr("id", [
  zP,
  WP
]), HP = N({
  userId: A(),
  timestamp: v()
});
N({
  outputPath: A(),
  jobId: A(),
  internalJobId: A(),
  jobType: A(),
  status: A()
});
var Ei = /* @__PURE__ */ ((e) => (e[e.Success = 0] = "Success", e[e.Impossible = 1] = "Impossible", e[e.ImpossibleInCurrent = 2] = "ImpossibleInCurrent", e[e.NotEnoughSpaceOnPossible = 3] = "NotEnoughSpaceOnPossible", e))(Ei || {});
const YP = pe(Ei), ZP = rn({
  studentId: v(),
  statuses: k(YP)
}), JP = rn({
  students: k(v()),
  studentSetGroupId: v()
}), KP = N({
  kpis: k(qP),
  studentStatuses: k(ZP),
  solution: rn({
    assignments: k(JP)
  })
}), NT = rn({
  errorCode: v(),
  message: A()
});
hr("exit_status", [
  N({
    build: A(),
    dataVersion: v(),
    exit_status: fe("success"),
    id: A(),
    meta: HP,
    result: KP
  }),
  N({
    build: A(),
    dataVersion: v(),
    exit_status: fe("error"),
    id: A(),
    error: NT
  })
]);
const Wa = (e) => kP.Buffer.isBuffer(e) || globalThis.Buffer.isBuffer(e), CT = lt().superRefine((e, t) => {
  Wa(e) || e && typeof e == "object" && "buffer" in e && Wa(e.buffer) || t.issues.push({
    code: "custom",
    message: "Invalid Buffer type",
    input: e
  });
}).transform((e) => e && typeof e == "object" && "buffer" in e && Wa(e.buffer) ? e.buffer : e), XP = [
  "corrupted",
  "init_failed",
  "initializing",
  "unreceived",
  "failed",
  "pending",
  "completed",
  "allocating",
  "allocation_failed",
  "allocated"
], ce = pe(XP), QP = {
  [ce.enum.corrupted]: ["corrupted"],
  [ce.enum.init_failed]: [
    "init_failed",
    "initializing",
    "unreceived",
    "failed",
    "pending",
    "completed",
    "allocating",
    "allocation_failed",
    "allocated"
  ],
  [ce.enum.initializing]: [
    "initializing",
    "unreceived",
    "failed",
    "pending",
    "completed",
    "allocating",
    "allocation_failed",
    "allocated"
  ],
  [ce.enum.unreceived]: [
    "unreceived",
    "failed",
    "pending",
    "completed",
    "allocating",
    "allocation_failed",
    "allocated"
  ],
  [ce.enum.failed]: [
    "failed",
    "pending",
    "completed",
    "allocating",
    "allocation_failed",
    "allocated"
  ],
  [ce.enum.pending]: [
    "pending",
    "completed",
    "allocating",
    "allocation_failed",
    "allocated"
  ],
  [ce.enum.completed]: [
    "completed",
    "allocating",
    "allocation_failed",
    "allocated"
  ],
  [ce.enum.allocating]: [
    "allocating",
    "allocation_failed",
    "allocated"
  ],
  [ce.enum.allocation_failed]: [
    "allocation_failed",
    "allocated"
  ],
  [ce.enum.allocated]: ["allocated"]
}, eD = N({
  ...OT.shape,
  ...wT.shape,
  ...RT.shape
}), tD = N({
  time: A().optional(),
  allocationTime: _i,
  userId: A(),
  logId: A().optional()
}), rD = N({
  time: A().optional(),
  allocationTime: _i,
  userId: A(),
  logId: A().optional(),
  failedGroups: gc
}), Pt = {
  conflicts: "noConflicts",
  fill: "fillGroupsEvenly",
  distribution: "useAllocationSettings",
  optimizeForStudentPreferences: !0
}, qa = {
  conflicts: [Pt.conflicts],
  fill: [Pt.fill],
  distribution: [Pt.distribution]
}, zs = N({
  conflicts: pe(qa.conflicts).optional().default(Pt.conflicts),
  fill: pe(qa.fill).optional().default(Pt.fill),
  distribution: pe(qa.distribution).optional().default(Pt.distribution),
  optimizeForStudentPreferences: ie().optional().default(Pt.optimizeForStudentPreferences)
}), Ac = N({
  userId: A(),
  startTime: A().optional(),
  jobId: A(),
  createdAt: _i,
  updatedAt: _i
}), pa = N({
  userId: A(),
  startTime: A().optional(),
  jobId: A(),
  inputUrl: A(),
  issues: v(),
  settings: zs.optional().default(Pt),
  selection: N({
    studentSetGroups: v(),
    totalStudents: v(),
    incompleteStudents: v(),
    courses: k(K1)
  }),
  inputData: CT,
  createdAt: _i,
  updatedAt: _i
}), vc = Ac.extend({
  status: fe(ce.enum.initializing)
}), Sc = Ac.extend({
  status: fe(ce.enum.init_failed),
  error: lt().optional()
}), Ic = pa.extend({
  status: fe(ce.enum.pending)
}), ki = pa.extend({
  status: fe(ce.enum.completed),
  outputData: CT,
  proposalResult: eD,
  outputUrl: A()
}), _c = pa.extend({
  status: fe(ce.enum.unreceived),
  error: lt().optional()
}), Rc = pa.extend({
  status: fe(ce.enum.failed),
  error: NT
}), Oc = ki.extend({
  status: fe(ce.enum.allocating)
}), wc = ki.extend({
  status: fe(ce.enum.allocation_failed),
  error: lt().optional()
}), Nc = ki.extend({
  allocationResult: rD,
  status: fe(ce.enum.allocated)
}), Cc = Ac.extend({
  status: fe(ce.enum.corrupted),
  error: lt().optional()
}).loose(), Pc = (e) => e, ar = [
  "outputData",
  "inputData",
  "allocationResult"
], Rr = {
  username: N({
    creator: A()
  })
}, nD = Pc({
  [ce.enum.corrupted]: sr(
    Cc,
    ar
  ).extend(Rr).loose(),
  [ce.enum.allocated]: sr(
    Nc,
    ar
  ).extend({
    username: N({
      creator: A(),
      allocator: A()
    }),
    allocationResult: tD
  }),
  [ce.enum.allocation_failed]: sr(
    wc,
    ar
  ).extend(Rr),
  [ce.enum.allocating]: sr(
    Oc,
    ar
  ).extend(Rr),
  [ce.enum.completed]: sr(
    ki,
    ar
  ).extend(Rr),
  [ce.enum.pending]: sr(
    Ic,
    ar
  ).extend(Rr),
  [ce.enum.unreceived]: sr(
    _c,
    ar
  ).extend(Rr),
  [ce.enum.failed]: sr(
    Rc,
    ar
  ).extend(Rr),
  [ce.enum.init_failed]: sr(
    Sc,
    ar
  ).extend(Rr),
  [ce.enum.initializing]: sr(
    vc,
    ar
  ).extend(Rr)
}), iD = hr(
  "status",
  Object.values(nD)
), oD = Pc({
  [ce.enum.corrupted]: Cc,
  [ce.enum.allocated]: Nc,
  [ce.enum.allocation_failed]: wc,
  [ce.enum.allocating]: Oc,
  [ce.enum.completed]: ki,
  [ce.enum.pending]: Ic,
  [ce.enum.unreceived]: _c,
  [ce.enum.failed]: Rc,
  [ce.enum.init_failed]: Sc,
  [ce.enum.initializing]: vc
});
hr(
  "status",
  Object.values(oD)
);
const sD = Pc({
  [ce.enum.corrupted]: Cc.partial().extend({
    jobId: A(),
    status: fe(ce.enum.corrupted)
  }),
  [ce.enum.allocated]: Nc.omit({ settings: !0 }).partial().extend({
    jobId: A(),
    status: fe(ce.enum.allocated)
  }),
  [ce.enum.allocation_failed]: wc.omit({
    settings: !0
  }).partial().extend({
    jobId: A(),
    status: fe(ce.enum.allocation_failed)
  }),
  [ce.enum.allocating]: Oc.omit({ settings: !0 }).partial().extend({
    jobId: A(),
    status: fe(ce.enum.allocating)
  }),
  [ce.enum.completed]: ki.omit({ settings: !0 }).partial().extend({
    jobId: A(),
    status: fe(ce.enum.completed)
  }),
  [ce.enum.pending]: Ic.omit({ settings: !0 }).partial().extend({
    jobId: A(),
    status: fe(ce.enum.pending),
    settings: zs.optional()
  }),
  [ce.enum.unreceived]: _c.partial().extend({
    jobId: A(),
    status: fe(ce.enum.unreceived)
  }),
  [ce.enum.failed]: Rc.partial().extend({
    jobId: A(),
    status: fe(ce.enum.failed)
  }),
  [ce.enum.initializing]: vc.partial().extend({
    jobId: A(),
    status: fe(ce.enum.initializing)
  }),
  [ce.enum.init_failed]: Sc.partial().extend({
    jobId: A(),
    status: fe(ce.enum.init_failed)
  })
});
W1(
  hr(
    "status",
    Object.values(sD)
  )
);
N({
  jobId: A(),
  allocationResults: k(gc)
});
N({
  jobId: A(),
  date: Bt
});
N({
  jobs: k(iD),
  total: v()
});
const aD = N({
  id: v(),
  course: A(),
  courseTitle: A(),
  activity: A(),
  reason: A(),
  studentId: A(),
  activityId: A(),
  studentValues: k(A()),
  link: A()
}), uD = N({
  rows: k(aD),
  studentColumns: k(A())
});
N({
  content: uD,
  startTime: A()
});
const lD = N({
  key: A(),
  course: A(),
  activityType: A(),
  group: A(),
  student: A(),
  issueType: A(),
  manageStudentLink: A(),
  activityTypeId: v().optional(),
  logId: A().optional()
});
N({
  total: v(),
  data: k(lD)
});
const cD = (e) => N({
  data: e,
  status: v(),
  message: A()
});
cD(lt());
N({
  objectIds: k(v().nonnegative().int()),
  useCache: ie()
});
const PT = N({
  ids: k(v().nonnegative().int()).optional(),
  typeId: v().nonnegative().int().optional().or(k(v().nonnegative().int())),
  useCache: ie().optional(),
  limit: v().nonnegative().int().optional(),
  pageSize: v().nonnegative().int().optional(),
  page: v().nonnegative().int().optional(),
  fields: k(A().or(v().nonnegative().int())).optional(),
  relations: al.optional(),
  members: al.optional(),
  text: A().optional(),
  category: k(TT).optional()
}), fD = PT.and(_T).superRefine(
  (e, t) => {
    var r;
    !((r = e.ids) != null && r.length) && !e.limit && !e.pageSize && t.issues.push({
      input: e,
      code: "custom",
      path: ["limit"],
      message: "Limit or pageSize required when no ids are specified"
    }), e.limit && e.pageSize && t.issues.push({
      input: e,
      code: "custom",
      path: ["limit"],
      message: "Do not set both limit and pageSize"
    });
  }
), dD = hr("filterMode", [
  N({
    filterMode: fe(
      "related"
      /* related */
    ),
    courseIds: k(v().int().positive()).min(1)
  }),
  N({
    filterMode: fe(
      "all"
      /* all */
    )
  })
]);
fD.and(dD);
const pD = N({
  exactSearchFields: k(TT).optional(),
  generalSearchFieldIds: k(pc).optional(),
  searchText: A().optional()
}), hD = [
  "only_selected",
  "include_linked",
  "all"
], ul = pe(hD), DT = N({
  fields: pD.optional(),
  idsToFilter: k(pc).optional(),
  relations: al.optional(),
  filterCompleteStudents: ie().optional(),
  filterRegistrationPeriod: k(Mr).optional(),
  filterIssues: k(lT).optional(),
  filterSelectionMode: ul.optional(),
  limit: v().nonnegative().int().optional(),
  pageSize: v().nonnegative().int().optional(),
  page: v().nonnegative().int().optional()
}), mD = DT.pick({
  fields: !0,
  relations: !0,
  idsToFilter: !0,
  filterCompleteStudents: !0
}), ha = DT.and(_T);
ha.superRefine(
  (e, t) => {
    !e.limit && !e.pageSize && t.issues.push({
      input: e,
      code: "custom",
      path: ["limit"],
      message: "Limit or pageSize required"
    }), e.limit && e.pageSize && t.issues.push({
      input: e,
      code: "custom",
      path: ["limit"],
      message: "Do not set both limit and pageSize"
    });
  }
);
N({
  objects: k(Vt),
  totalFilteredObjects: v()
});
k(
  N({ id: v(), fields: k(Jo) })
);
const ED = ["partial", "none"], Dc = pe(ED);
N({
  studentInfo: da,
  conflictControl: Dc,
  overrides: Ec.optional(),
  updateWaitlist: ie().optional()
});
N({
  jobId: A(),
  conflictControl: Dc,
  overrides: Ec.optional()
});
N({
  studentInfo: da
});
N({ jobId: A() });
N({
  studentId: v(),
  newObjectId: v()
});
N({
  studentId: v(),
  newObjectId: v(),
  conflictControl: Dc,
  overrides: Ec.optional()
});
N({
  groups: ht(A(), bc)
});
N({
  summary: jt(My, v())
});
rn({
  results: k(
    N({
      status: v(),
      message: N({
        status: v(),
        message: A(),
        errorCode: v().optional()
      }).or(A()),
      memberObjectId: v().optional(),
      groupObjectId: v().optional(),
      operation: pe(["add", "remove"])
    })
  )
});
const gD = St([fe("asc"), fe("desc")]), yD = k(Zl([A(), gD]));
N({
  skip: A().optional(),
  limit: A().optional(),
  jobId: A().optional(),
  sort: yD.optional()
});
N({
  force: ie().optional()
});
St([
  N({
    loadCoursesProps: ha,
    settings: zs
  }).strict(),
  N({
    groupIds: k(v()),
    settings: zs
  }).strict()
]);
N({
  jobId: A(),
  csv: ie().optional()
});
N({
  jobId: A(),
  page: v(),
  pageSize: v()
}).required();
const TD = N({
  reloadReservations: ie().optional(),
  groupIds: k(v()).optional(),
  loadCoursesProps: mD
}), bD = N({
  reloadReservations: ie().optional(),
  groupIds: k(v()).optional(),
  ids: k(v())
}), AD = N({
  reloadReservations: ie().optional(),
  groupIds: k(v())
});
St([
  bD,
  TD,
  AD
]);
N({
  groups: jt(A(), dT.optional()),
  coursesToUpdate: V1(cT.optional()),
  reservations: k(Gy),
  activities: jt(A(), fT.optional()),
  studentIds: k(v())
});
St([
  N({ loadCoursesProps: ha }).strict(),
  N({
    groupIds: k(v()),
    filterSelectionMode: ul.optional()
  }).strict(),
  N({
    ids: k(v()),
    filterSelectionMode: ul.optional()
  }).strict()
]);
const vD = N({
  courses: jt(A(), cT.optional()),
  totalFilteredCourses: v().nonnegative().int(),
  studentsRelated: jt(A(), eP.optional()),
  groupsRelated: jt(A(), dT.optional()),
  selectedIncompleteStudents: v().nonnegative().int(),
  activities: jt(A(), fT.optional())
}), SD = vD.omit({
  studentsRelated: !0
}).extend({
  students: v()
});
SD.omit({
  selectedIncompleteStudents: !0
});
PT.omit({
  useCache: !0,
  typeId: !0
}).extend({
  ...bT.shape,
  groupIds: k(v()).optional(),
  numberOfStudents: v().int().nonnegative().optional(),
  filterCompleteStudents: ie().optional(),
  programIds: k(v()).optional(),
  allocationStatus: N({
    values: k(vP),
    selectedGroupId: v()
  }).optional()
});
var MT = /* @__PURE__ */ ((e) => (e.buttonClick = "button_click", e.pageView = "page_view", e))(MT || {});
N({
  event: pe(MT),
  properties: jt(A(), St([A(), v(), ie()])).optional()
});
const ID = N({
  groupId: v(),
  linkedIds: k(v())
});
N({
  linked: k(ID)
});
N({
  loadCoursesProps: ha
});
const ma = v(), Ea = v(), LT = A(), _D = A(), RD = N({
  sequence: v(),
  groupId: Ea
}), OD = RD.extend({
  studentId: ma,
  trigger: LT,
  userId: _D
});
OD.extend({
  position: v()
});
N({
  studentId: ma,
  groupId: Ea,
  trigger: LT
});
N({
  studentId: ma,
  groupId: Ea
});
N({
  studentId: ma,
  groupId: Ea
});
N({ studentId: A() });
const wD = N({
  evaluatedGroups: v(),
  allocations: v(),
  allocatedGroups: v(),
  allocatedStudents: v()
}), xT = {
  EVALUATE_WAITLIST: "eval-waitlist"
}, ND = pe(xT);
N({
  jobName: ND
});
const Lo = {
  POPULATE_CACHE: "Registration - Populate Cache",
  AUTO_ALLOCATE: "Auto Allocate",
  AUTO_ALLOCATE_DAILY: "Auto Allocate Daily",
  ...xT
}, Qo = pe(
  Object.values(Lo)
), CD = [
  "uninitialized",
  "pending",
  "completed",
  "failed"
], kT = pe(CD);
St([
  kT,
  fe("timeout"),
  Xr()
]);
const on = N({
  name: Qo,
  jobId: A(),
  lastRunAt: v(),
  lastFinishedAt: v().nullable().optional(),
  status: kT
}), jT = N({
  status: v(),
  name: A(),
  message: A()
});
Lo.EVALUATE_WAITLIST + "", N({
  stats: wD
}).optional().default({
  stats: {
    evaluatedGroups: 0,
    allocations: 0,
    allocatedGroups: 0,
    allocatedStudents: 0
  }
}), Lo.POPULATE_CACHE + "", Xr().optional(), Lo.AUTO_ALLOCATE + "", Xr().optional(), Lo.AUTO_ALLOCATE_DAILY + "", Xr().optional();
on.extend({
  status: fe("uninitialized")
});
on.extend({
  status: fe("pending")
});
on.extend({
  status: fe("completed")
});
on.extend({
  status: fe("failed"),
  error: jT
});
on.partial().extend({
  name: Qo,
  jobId: A(),
  status: fe("uninitialized")
});
on.partial().extend({
  name: Qo,
  jobId: A(),
  status: fe("pending")
});
on.partial().extend({
  name: Qo,
  jobId: A(),
  status: fe("completed")
});
on.partial().extend({
  name: Qo,
  jobId: A(),
  status: fe("failed"),
  error: jT
});
const PD = HR().brand(), DD = Kl(
  (e) => typeof e == "string" ? e.replace(/^\s*bearer\s+/i, "") : e,
  PD
);
N({
  serverUrl: A().optional(),
  token: DD,
  user: zy,
  organizationId: A(),
  listOptions: N({
    limit: v(),
    page: A(),
    sortBy: A().optional()
  }).optional()
});
const MD = N({
  limitToAdminsOnly: A().default("")
});
N({
  failedLinks: k(A())
});
ht(
  A(),
  k(v())
);
const LD = ["en", "sv"], xD = pe(LD), kD = N({
  message: A(),
  errorName: aa.catch(le.Error)
}), jD = [
  "Exams unexpected",
  "Student assessment not enabled",
  "Exams not found"
], UD = ["Missing preferred groups"], $D = ["User object cache write failed"], FD = [
  ...jD,
  ...UD,
  ...$D,
  // What a reason this client does not know reads as.
  "Unknown"
], GD = pe(FD), zD = N({
  /**
   * What went wrong. Typed on the server by the controller's union of
   * failures, so each reason identifies one kind of failure.
   * A reason this client does not know reads as `Unknown`.
   */
  reason: GD.catch("Unknown"),
  /**
   * Ids of the entities the failure affected. Empty `subjects` might mean
   * the entities could not be identified, and is not the same as none
   * affected.
   */
  subjects: k(v()).optional(),
  /** The status the underlying error maps to; absent when nothing was thrown. */
  status: v().int().optional(),
  /** The underlying error, reduced to the fields safe to send to a client. */
  error: kD.optional()
}), Mc = {
  failures: k(zD).optional(),
  logId: A().optional()
}, BD = ["morning", "afternoon", "no_preference"], ga = pe(BD), VD = [
  "Mon",
  "Tue",
  "Wed",
  "Thu",
  "Fri",
  "Sat",
  "Sun"
], WD = pe(VD), qD = ["prefer", "avoid"], HD = pe(qD), Fh = A().regex(/^([01]\d|2[0-3]):[0-5]\d$/, "time must be HH:mm"), ya = N({
  begin: Fh,
  end: Fh,
  day: WD,
  sentiment: HD
}).refine((e) => e.begin < e.end, {
  message: "begin must be before end",
  path: ["end"]
}), UT = N({
  studentId: v(),
  timeOfDay: ga,
  preferredGroupIds: k(v()).default([]),
  timePreferences: k(ya).default([]),
  modifiedBy: A(),
  createdAt: ol,
  updatedAt: ol
});
UT.pick({
  studentId: !0,
  timeOfDay: !0,
  preferredGroupIds: !0
});
N({
  timeOfDay: ga.optional(),
  preferredGroupIds: k(v()).optional(),
  timePreferences: k(ya).optional()
});
const $T = N({
  groupIds: k(v()),
  courseLabel: A(),
  groupName: A()
}), YD = N({
  group: ie(),
  time: ie(),
  timeOfDay: ie()
});
N({
  timeOfDay: ga,
  updatedAtUserTime: A().optional(),
  preferredGroups: k($T),
  timePreferences: k(ya),
  enabledSteps: YD,
  ...Mc
});
N({
  studentId: A().regex(/^\d+$/, "studentId must be numeric")
});
const ZD = ["create", "update", "delete"], JD = pe(ZD), KD = (e) => N({
  operation: JD,
  snapshot: e,
  modifiedBy: A(),
  timestamp: ol
});
function XD(e) {
  return KD(e);
}
XD(
  UT
).extend({
  studentId: v()
});
N({
  name: A(),
  timestamp: A(),
  timeOfDay: ga,
  preferredGroups: k($T).optional(),
  timePreferences: k(ya).default([])
});
const QD = N({
  time: A(),
  operationType: A(),
  itemType: A(),
  username: A(),
  objectIds: k(v()),
  courses: k(A()),
  activities: k(A()),
  groups: k(A())
}), eM = k(QD);
N({
  history: eM,
  total: v().int().nonnegative(),
  page: v().int().positive()
});
const tM = 50;
N({
  objectId: A().regex(/^\d+$/, "objectId must be numeric")
});
N({
  current: id().int().positive().optional(),
  pageSize: id().int().positive().max(tM).optional()
});
const rM = N({
  // action
  itemType: A(),
  operationType: A(),
  // user
  changed: v().optional().nullable(),
  changedBy: A().optional().nullable(),
  // objects
  objectId: v().optional().nullable(),
  objectIds: k(v()).optional().nullable(),
  // fields and types
  typeId: v().optional().nullable(),
  fieldId: v().optional().nullable(),
  // dates
  begin: v().optional().nullable(),
  end: v().optional().nullable(),
  // props
  name: A().optional().nullable(),
  value: A().optional().nullable(),
  // availability
  availabilityTypeId: v().optional().nullable()
});
N({
  objectId: v(),
  idFormat: fe("INTERNAL"),
  sort: pe(["ASC", "DESC"]),
  page: v(),
  limit: v(),
  skipNoChanged: ie().optional(),
  itemTypes: k(
    pe([
      "MEMBER",
      "RELATION",
      "OPTIONAL_RELATION",
      "AVAILABILITY_RELATION",
      "FIELD",
      "TYPE",
      "PROPERTY",
      "NONE"
    ])
  ).optional()
});
mr(rM);
const ms = {
  displayName: A().optional()
}, dt = hr("type", [
  N({
    ...ms,
    type: fe("reservation"),
    // Single numerical string
    value: A().regex(/^\d+$/)
  }),
  N({
    ...ms,
    type: fe("object-field"),
    // Two numerical strings joined by a dash
    value: A().regex(/^\d+-\d+$/)
  }),
  N({
    ...ms,
    type: fe("text"),
    value: A()
  }),
  N({
    ...ms,
    type: fe("unmapped")
  })
]), Gh = dt.and(N({ label: A() })), nM = N({
  absoluteStartTime: v().optional(),
  absoluteEndTime: v().optional(),
  relativeStartTime: v().optional(),
  relativeEndTime: v().optional()
}), iM = N({
  datelimit: nM.optional(),
  module: N({
    name: dt.optional(),
    code: dt.optional()
  }).optional(),
  location: N({
    room: dt.optional(),
    building: dt.optional(),
    campus: dt.optional(),
    type: dt.optional(),
    map: dt.optional(),
    image: dt.optional(),
    equipment: dt.optional(),
    onlineMeetingLink: dt.optional(),
    extraFields: k(Gh).optional()
  }).optional(),
  digitalResources: N({
    recording: dt.optional(),
    lmsLink: dt.optional()
  }).optional(),
  staff: N({
    name: dt.optional()
  }).optional(),
  activity: N({
    displayName: dt.optional(),
    alternativeTitle: dt.optional()
  }).optional(),
  messageToStudent: dt.optional(),
  extraFields: k(Gh).optional(),
  updatedBy: A().optional(),
  updatedAt: IO().optional(),
  reservationStatuses: k(pe(Se.EReservationStatuses)).optional(),
  reservationMode: v().optional()
}), oM = N({
  enabled: ie(),
  path: A().optional(),
  page: A().optional()
});
N({
  studentReservationDisplaySettings: iM.optional(),
  studentSubscribeSettings: oM.optional()
});
hr("direction", [
  N({
    direction: fe("initial")
  }),
  N({
    direction: fe("next"),
    from: v().int().positive()
  }),
  N({
    direction: fe("previous"),
    from: v().int().positive()
  }),
  N({
    direction: fe("full")
  })
]);
N({
  results: k(Rs.nullable()),
  /** Page number to pass as `from` on the next forward request, or null when the forward side is exhausted. */
  nextFrom: v().int().nullable(),
  /** Page number to pass as `from` on the next backward request, or null when the backward side is exhausted or the backward range is empty. */
  previousFrom: v().int().nullable(),
  userTodayLocal: A(),
  subscribeEnabled: ie(),
  datelimitText: N({
    before: Bt,
    after: Bt
  }).optional(),
  ...Mc
});
const sM = N({
  key: v(),
  title: A().optional(),
  subtitle: A(),
  allDay: ie().optional(),
  start: Rs.shape.begin,
  end: Rs.shape.end,
  location: Rs.shape.location
});
N({
  results: k(sM.nullable()),
  ...Mc
});
N({
  appleURL: A(),
  googleURL: A(),
  rawURL: A()
});
const aM = pe(["TE_HUB", "TE_EXAM_V3"]), uM = N({
  examReservationMode: v().optional()
});
N({
  reservationSettings: uM.optional()
});
N({
  date: N({
    startDate: v().int().optional(),
    // epoch seconds
    endDate: v().int().optional()
    // epoch seconds
  }).refine(
    (e) => e.startDate === void 0 || e.endDate === void 0 || e.endDate >= e.startDate,
    {
      message: "endDate must not be before startDate",
      path: ["endDate"]
    }
  ).optional(),
  ids: k(v().int().positive()).min(1).max(dh).optional(),
  settingsSource: aM,
  page: v().int().min(1).optional(),
  limit: v().int().min(1).max(dh).optional()
}).refine((e) => e.date !== void 0 != (e.ids !== void 0), {
  message: "Exactly one of date or ids must be given"
});
const Es = Wy(A()), lM = N({
  id: v(),
  start: A(),
  end: A(),
  lastModified: A(),
  examName: A(),
  examType: A(),
  location: Es(A()),
  seatNo: Es(A().nullable()),
  fields: k(
    Es(A()).and(
      N({
        label: A(),
        type: A().optional()
      })
    )
  ),
  information: k(
    Es(
      N({
        title: A().optional(),
        type: pe(["error", "warning", "info"]).optional(),
        value: A()
      })
    )
  )
});
N({
  results: k(lM),
  limit: v(),
  page: v(),
  totalPages: v(),
  totalResults: v(),
  examReservationMode: v().optional()
});
const Ez = {
  [le.MaximumMembershipReachedError]: -2306,
  [le.MaximumMembershipReachedByTypeError]: -2307,
  [le.PermissionError]: [-2005, -2006, -2300, -2310, -2401]
};
var cM = /* @__PURE__ */ ((e) => (e[e.Courses = 0] = "Courses", e[e.Activities = 1] = "Activities", e[e.StudentSetGroups = 2] = "StudentSetGroups", e))(cM || {}), FT = typeof global == "object" && global && global.Object === Object && global, fM = typeof self == "object" && self && self.Object === Object && self, zr = FT || fM || Function("return this")(), dr = zr.Symbol, GT = Object.prototype, dM = GT.hasOwnProperty, pM = GT.toString, yo = dr ? dr.toStringTag : void 0;
function hM(e) {
  var t = dM.call(e, yo), r = e[yo];
  try {
    e[yo] = void 0;
    var n = !0;
  } catch {
  }
  var i = pM.call(e);
  return n && (t ? e[yo] = r : delete e[yo]), i;
}
var mM = Object.prototype, EM = mM.toString;
function gM(e) {
  return EM.call(e);
}
var yM = "[object Null]", TM = "[object Undefined]", zh = dr ? dr.toStringTag : void 0;
function sn(e) {
  return e == null ? e === void 0 ? TM : yM : zh && zh in Object(e) ? hM(e) : gM(e);
}
function jr(e) {
  return e != null && typeof e == "object";
}
var bM = "[object Symbol]";
function Ta(e) {
  return typeof e == "symbol" || jr(e) && sn(e) == bM;
}
function zT(e, t) {
  for (var r = -1, n = e == null ? 0 : e.length, i = Array(n); ++r < n; )
    i[r] = t(e[r], r, e);
  return i;
}
var Zt = Array.isArray, Bh = dr ? dr.prototype : void 0, Vh = Bh ? Bh.toString : void 0;
function BT(e) {
  if (typeof e == "string")
    return e;
  if (Zt(e))
    return zT(e, BT) + "";
  if (Ta(e))
    return Vh ? Vh.call(e) : "";
  var t = e + "";
  return t == "0" && 1 / e == -1 / 0 ? "-0" : t;
}
var AM = /\s/;
function vM(e) {
  for (var t = e.length; t-- && AM.test(e.charAt(t)); )
    ;
  return t;
}
var SM = /^\s+/;
function IM(e) {
  return e && e.slice(0, vM(e) + 1).replace(SM, "");
}
function Oi(e) {
  var t = typeof e;
  return e != null && (t == "object" || t == "function");
}
var Wh = NaN, _M = /^[-+]0x[0-9a-f]+$/i, RM = /^0b[01]+$/i, OM = /^0o[0-7]+$/i, wM = parseInt;
function NM(e) {
  if (typeof e == "number")
    return e;
  if (Ta(e))
    return Wh;
  if (Oi(e)) {
    var t = typeof e.valueOf == "function" ? e.valueOf() : e;
    e = Oi(t) ? t + "" : t;
  }
  if (typeof e != "string")
    return e === 0 ? e : +e;
  e = IM(e);
  var r = RM.test(e);
  return r || OM.test(e) ? wM(e.slice(2), r ? 2 : 8) : _M.test(e) ? Wh : +e;
}
var qh = 1 / 0, CM = 17976931348623157e292;
function PM(e) {
  if (!e)
    return e === 0 ? e : 0;
  if (e = NM(e), e === qh || e === -qh) {
    var t = e < 0 ? -1 : 1;
    return t * CM;
  }
  return e === e ? e : 0;
}
function DM(e) {
  var t = PM(e), r = t % 1;
  return t === t ? r ? t - r : t : 0;
}
function Lc(e) {
  return e;
}
var MM = "[object AsyncFunction]", LM = "[object Function]", xM = "[object GeneratorFunction]", kM = "[object Proxy]";
function VT(e) {
  if (!Oi(e))
    return !1;
  var t = sn(e);
  return t == LM || t == xM || t == MM || t == kM;
}
var Ha = zr["__core-js_shared__"], Hh = (function() {
  var e = /[^.]+$/.exec(Ha && Ha.keys && Ha.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
})();
function jM(e) {
  return !!Hh && Hh in e;
}
var UM = Function.prototype, $M = UM.toString;
function Jn(e) {
  if (e != null) {
    try {
      return $M.call(e);
    } catch {
    }
    try {
      return e + "";
    } catch {
    }
  }
  return "";
}
var FM = /[\\^$.*+?()[\]{}|]/g, GM = /^\[object .+?Constructor\]$/, zM = Function.prototype, BM = Object.prototype, VM = zM.toString, WM = BM.hasOwnProperty, qM = RegExp(
  "^" + VM.call(WM).replace(FM, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function HM(e) {
  if (!Oi(e) || jM(e))
    return !1;
  var t = VT(e) ? qM : GM;
  return t.test(Jn(e));
}
function YM(e, t) {
  return e == null ? void 0 : e[t];
}
function Kn(e, t) {
  var r = YM(e, t);
  return HM(r) ? r : void 0;
}
var ll = Kn(zr, "WeakMap");
function ZM(e, t, r) {
  switch (r.length) {
    case 0:
      return e.call(t);
    case 1:
      return e.call(t, r[0]);
    case 2:
      return e.call(t, r[0], r[1]);
    case 3:
      return e.call(t, r[0], r[1], r[2]);
  }
  return e.apply(t, r);
}
function JM() {
}
var KM = 800, XM = 16, QM = Date.now;
function eL(e) {
  var t = 0, r = 0;
  return function() {
    var n = QM(), i = XM - (n - r);
    if (r = n, i > 0) {
      if (++t >= KM)
        return arguments[0];
    } else
      t = 0;
    return e.apply(void 0, arguments);
  };
}
function tL(e) {
  return function() {
    return e;
  };
}
var Bs = (function() {
  try {
    var e = Kn(Object, "defineProperty");
    return e({}, "", {}), e;
  } catch {
  }
})(), rL = Bs ? function(e, t) {
  return Bs(e, "toString", {
    configurable: !0,
    enumerable: !1,
    value: tL(t),
    writable: !0
  });
} : Lc, nL = eL(rL);
function iL(e, t, r, n) {
  for (var i = e.length, o = r + -1; ++o < i; )
    if (t(e[o], o, e))
      return o;
  return -1;
}
function oL(e) {
  return e !== e;
}
function sL(e, t, r) {
  for (var n = r - 1, i = e.length; ++n < i; )
    if (e[n] === t)
      return n;
  return -1;
}
function aL(e, t, r) {
  return t === t ? sL(e, t, r) : iL(e, oL, r);
}
function WT(e, t) {
  var r = e == null ? 0 : e.length;
  return !!r && aL(e, t, 0) > -1;
}
var uL = 9007199254740991, lL = /^(?:0|[1-9]\d*)$/;
function qT(e, t) {
  var r = typeof e;
  return t = t ?? uL, !!t && (r == "number" || r != "symbol" && lL.test(e)) && e > -1 && e % 1 == 0 && e < t;
}
function cL(e, t, r) {
  t == "__proto__" && Bs ? Bs(e, t, {
    configurable: !0,
    enumerable: !0,
    value: r,
    writable: !0
  }) : e[t] = r;
}
function HT(e, t) {
  return e === t || e !== e && t !== t;
}
var Yh = Math.max;
function fL(e, t, r) {
  return t = Yh(t === void 0 ? e.length - 1 : t, 0), function() {
    for (var n = arguments, i = -1, o = Yh(n.length - t, 0), s = Array(o); ++i < o; )
      s[i] = n[t + i];
    i = -1;
    for (var a = Array(t + 1); ++i < t; )
      a[i] = n[i];
    return a[t] = r(s), ZM(e, this, a);
  };
}
function xc(e, t) {
  return nL(fL(e, t, Lc), e + "");
}
var dL = 9007199254740991;
function kc(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= dL;
}
function ba(e) {
  return e != null && kc(e.length) && !VT(e);
}
var pL = Object.prototype;
function hL(e) {
  var t = e && e.constructor, r = typeof t == "function" && t.prototype || pL;
  return e === r;
}
function mL(e, t) {
  for (var r = -1, n = Array(e); ++r < e; )
    n[r] = t(r);
  return n;
}
var EL = "[object Arguments]";
function Zh(e) {
  return jr(e) && sn(e) == EL;
}
var YT = Object.prototype, gL = YT.hasOwnProperty, yL = YT.propertyIsEnumerable, jc = Zh(/* @__PURE__ */ (function() {
  return arguments;
})()) ? Zh : function(e) {
  return jr(e) && gL.call(e, "callee") && !yL.call(e, "callee");
};
function TL() {
  return !1;
}
var ZT = typeof exports == "object" && exports && !exports.nodeType && exports, Jh = ZT && typeof module == "object" && module && !module.nodeType && module, bL = Jh && Jh.exports === ZT, Kh = bL ? zr.Buffer : void 0, AL = Kh ? Kh.isBuffer : void 0, cl = AL || TL, vL = "[object Arguments]", SL = "[object Array]", IL = "[object Boolean]", _L = "[object Date]", RL = "[object Error]", OL = "[object Function]", wL = "[object Map]", NL = "[object Number]", CL = "[object Object]", PL = "[object RegExp]", DL = "[object Set]", ML = "[object String]", LL = "[object WeakMap]", xL = "[object ArrayBuffer]", kL = "[object DataView]", jL = "[object Float32Array]", UL = "[object Float64Array]", $L = "[object Int8Array]", FL = "[object Int16Array]", GL = "[object Int32Array]", zL = "[object Uint8Array]", BL = "[object Uint8ClampedArray]", VL = "[object Uint16Array]", WL = "[object Uint32Array]", Ye = {};
Ye[jL] = Ye[UL] = Ye[$L] = Ye[FL] = Ye[GL] = Ye[zL] = Ye[BL] = Ye[VL] = Ye[WL] = !0;
Ye[vL] = Ye[SL] = Ye[xL] = Ye[IL] = Ye[kL] = Ye[_L] = Ye[RL] = Ye[OL] = Ye[wL] = Ye[NL] = Ye[CL] = Ye[PL] = Ye[DL] = Ye[ML] = Ye[LL] = !1;
function qL(e) {
  return jr(e) && kc(e.length) && !!Ye[sn(e)];
}
function HL(e) {
  return function(t) {
    return e(t);
  };
}
var JT = typeof exports == "object" && exports && !exports.nodeType && exports, $o = JT && typeof module == "object" && module && !module.nodeType && module, YL = $o && $o.exports === JT, Ya = YL && FT.process, Xh = (function() {
  try {
    var e = $o && $o.require && $o.require("util").types;
    return e || Ya && Ya.binding && Ya.binding("util");
  } catch {
  }
})(), Qh = Xh && Xh.isTypedArray, KT = Qh ? HL(Qh) : qL, ZL = Object.prototype, JL = ZL.hasOwnProperty;
function KL(e, t) {
  var r = Zt(e), n = !r && jc(e), i = !r && !n && cl(e), o = !r && !n && !i && KT(e), s = r || n || i || o, a = s ? mL(e.length, String) : [], l = a.length;
  for (var f in e)
    JL.call(e, f) && !(s && // Safari 9 has enumerable `arguments.length` in strict mode.
    (f == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    i && (f == "offset" || f == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    o && (f == "buffer" || f == "byteLength" || f == "byteOffset") || // Skip index properties.
    qT(f, l))) && a.push(f);
  return a;
}
function XL(e, t) {
  return function(r) {
    return e(t(r));
  };
}
var QL = XL(Object.keys, Object), ex = Object.prototype, tx = ex.hasOwnProperty;
function XT(e) {
  if (!hL(e))
    return QL(e);
  var t = [];
  for (var r in Object(e))
    tx.call(e, r) && r != "constructor" && t.push(r);
  return t;
}
function Uc(e) {
  return ba(e) ? KL(e) : XT(e);
}
var rx = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, nx = /^\w*$/;
function $c(e, t) {
  if (Zt(e))
    return !1;
  var r = typeof e;
  return r == "number" || r == "symbol" || r == "boolean" || e == null || Ta(e) ? !0 : nx.test(e) || !rx.test(e) || t != null && e in Object(t);
}
var Wo = Kn(Object, "create");
function ix() {
  this.__data__ = Wo ? Wo(null) : {}, this.size = 0;
}
function ox(e) {
  var t = this.has(e) && delete this.__data__[e];
  return this.size -= t ? 1 : 0, t;
}
var sx = "__lodash_hash_undefined__", ax = Object.prototype, ux = ax.hasOwnProperty;
function lx(e) {
  var t = this.__data__;
  if (Wo) {
    var r = t[e];
    return r === sx ? void 0 : r;
  }
  return ux.call(t, e) ? t[e] : void 0;
}
var cx = Object.prototype, fx = cx.hasOwnProperty;
function dx(e) {
  var t = this.__data__;
  return Wo ? t[e] !== void 0 : fx.call(t, e);
}
var px = "__lodash_hash_undefined__";
function hx(e, t) {
  var r = this.__data__;
  return this.size += this.has(e) ? 0 : 1, r[e] = Wo && t === void 0 ? px : t, this;
}
function Vn(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
Vn.prototype.clear = ix;
Vn.prototype.delete = ox;
Vn.prototype.get = lx;
Vn.prototype.has = dx;
Vn.prototype.set = hx;
function mx() {
  this.__data__ = [], this.size = 0;
}
function Aa(e, t) {
  for (var r = e.length; r--; )
    if (HT(e[r][0], t))
      return r;
  return -1;
}
var Ex = Array.prototype, gx = Ex.splice;
function yx(e) {
  var t = this.__data__, r = Aa(t, e);
  if (r < 0)
    return !1;
  var n = t.length - 1;
  return r == n ? t.pop() : gx.call(t, r, 1), --this.size, !0;
}
function Tx(e) {
  var t = this.__data__, r = Aa(t, e);
  return r < 0 ? void 0 : t[r][1];
}
function bx(e) {
  return Aa(this.__data__, e) > -1;
}
function Ax(e, t) {
  var r = this.__data__, n = Aa(r, e);
  return n < 0 ? (++this.size, r.push([e, t])) : r[n][1] = t, this;
}
function Br(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
Br.prototype.clear = mx;
Br.prototype.delete = yx;
Br.prototype.get = Tx;
Br.prototype.has = bx;
Br.prototype.set = Ax;
var qo = Kn(zr, "Map");
function vx() {
  this.size = 0, this.__data__ = {
    hash: new Vn(),
    map: new (qo || Br)(),
    string: new Vn()
  };
}
function Sx(e) {
  var t = typeof e;
  return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
}
function va(e, t) {
  var r = e.__data__;
  return Sx(t) ? r[typeof t == "string" ? "string" : "hash"] : r.map;
}
function Ix(e) {
  var t = va(this, e).delete(e);
  return this.size -= t ? 1 : 0, t;
}
function _x(e) {
  return va(this, e).get(e);
}
function Rx(e) {
  return va(this, e).has(e);
}
function Ox(e, t) {
  var r = va(this, e), n = r.size;
  return r.set(e, t), this.size += r.size == n ? 0 : 1, this;
}
function Vr(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
Vr.prototype.clear = vx;
Vr.prototype.delete = Ix;
Vr.prototype.get = _x;
Vr.prototype.has = Rx;
Vr.prototype.set = Ox;
var wx = "Expected a function";
function Fc(e, t) {
  if (typeof e != "function" || t != null && typeof t != "function")
    throw new TypeError(wx);
  var r = function() {
    var n = arguments, i = t ? t.apply(this, n) : n[0], o = r.cache;
    if (o.has(i))
      return o.get(i);
    var s = e.apply(this, n);
    return r.cache = o.set(i, s) || o, s;
  };
  return r.cache = new (Fc.Cache || Vr)(), r;
}
Fc.Cache = Vr;
var Nx = 500;
function Cx(e) {
  var t = Fc(e, function(n) {
    return r.size === Nx && r.clear(), n;
  }), r = t.cache;
  return t;
}
var Px = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, Dx = /\\(\\)?/g, Mx = Cx(function(e) {
  var t = [];
  return e.charCodeAt(0) === 46 && t.push(""), e.replace(Px, function(r, n, i, o) {
    t.push(i ? o.replace(Dx, "$1") : n || r);
  }), t;
});
function Lx(e) {
  return e == null ? "" : BT(e);
}
function QT(e, t) {
  return Zt(e) ? e : $c(e, t) ? [e] : Mx(Lx(e));
}
function Sa(e) {
  if (typeof e == "string" || Ta(e))
    return e;
  var t = e + "";
  return t == "0" && 1 / e == -1 / 0 ? "-0" : t;
}
function eb(e, t) {
  t = QT(t, e);
  for (var r = 0, n = t.length; e != null && r < n; )
    e = e[Sa(t[r++])];
  return r && r == n ? e : void 0;
}
function xx(e, t, r) {
  var n = e == null ? void 0 : eb(e, t);
  return n === void 0 ? r : n;
}
function tb(e, t) {
  for (var r = -1, n = t.length, i = e.length; ++r < n; )
    e[i + r] = t[r];
  return e;
}
var em = dr ? dr.isConcatSpreadable : void 0;
function kx(e) {
  return Zt(e) || jc(e) || !!(em && e && e[em]);
}
function rb(e, t, r, n, i) {
  var o = -1, s = e.length;
  for (r || (r = kx), i || (i = []); ++o < s; ) {
    var a = e[o];
    r(a) && tb(i, a);
  }
  return i;
}
var jx = "\\ud800-\\udfff", Ux = "\\u0300-\\u036f", $x = "\\ufe20-\\ufe2f", Fx = "\\u20d0-\\u20ff", Gx = Ux + $x + Fx, zx = "\\ufe0e\\ufe0f", Bx = "\\u200d", Vx = RegExp("[" + Bx + jx + Gx + zx + "]");
function Wx(e) {
  return Vx.test(e);
}
function qx() {
  this.__data__ = new Br(), this.size = 0;
}
function Hx(e) {
  var t = this.__data__, r = t.delete(e);
  return this.size = t.size, r;
}
function Yx(e) {
  return this.__data__.get(e);
}
function Zx(e) {
  return this.__data__.has(e);
}
var Jx = 200;
function Kx(e, t) {
  var r = this.__data__;
  if (r instanceof Br) {
    var n = r.__data__;
    if (!qo || n.length < Jx - 1)
      return n.push([e, t]), this.size = ++r.size, this;
    r = this.__data__ = new Vr(n);
  }
  return r.set(e, t), this.size = r.size, this;
}
function xr(e) {
  var t = this.__data__ = new Br(e);
  this.size = t.size;
}
xr.prototype.clear = qx;
xr.prototype.delete = Hx;
xr.prototype.get = Yx;
xr.prototype.has = Zx;
xr.prototype.set = Kx;
function Xx(e, t) {
  for (var r = -1, n = e == null ? 0 : e.length, i = 0, o = []; ++r < n; ) {
    var s = e[r];
    t(s, r, e) && (o[i++] = s);
  }
  return o;
}
function Qx() {
  return [];
}
var ek = Object.prototype, tk = ek.propertyIsEnumerable, tm = Object.getOwnPropertySymbols, rk = tm ? function(e) {
  return e == null ? [] : (e = Object(e), Xx(tm(e), function(t) {
    return tk.call(e, t);
  }));
} : Qx;
function nk(e, t, r) {
  var n = t(e);
  return Zt(e) ? n : tb(n, r(e));
}
function rm(e) {
  return nk(e, Uc, rk);
}
var fl = Kn(zr, "DataView"), dl = Kn(zr, "Promise"), Ti = Kn(zr, "Set"), nm = "[object Map]", ik = "[object Object]", im = "[object Promise]", om = "[object Set]", sm = "[object WeakMap]", am = "[object DataView]", ok = Jn(fl), sk = Jn(qo), ak = Jn(dl), uk = Jn(Ti), lk = Jn(ll), Dr = sn;
(fl && Dr(new fl(new ArrayBuffer(1))) != am || qo && Dr(new qo()) != nm || dl && Dr(dl.resolve()) != im || Ti && Dr(new Ti()) != om || ll && Dr(new ll()) != sm) && (Dr = function(e) {
  var t = sn(e), r = t == ik ? e.constructor : void 0, n = r ? Jn(r) : "";
  if (n)
    switch (n) {
      case ok:
        return am;
      case sk:
        return nm;
      case ak:
        return im;
      case uk:
        return om;
      case lk:
        return sm;
    }
  return t;
});
var um = zr.Uint8Array, ck = "__lodash_hash_undefined__";
function fk(e) {
  return this.__data__.set(e, ck), this;
}
function dk(e) {
  return this.__data__.has(e);
}
function wi(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.__data__ = new Vr(); ++t < r; )
    this.add(e[t]);
}
wi.prototype.add = wi.prototype.push = fk;
wi.prototype.has = dk;
function pk(e, t) {
  for (var r = -1, n = e == null ? 0 : e.length; ++r < n; )
    if (t(e[r], r, e))
      return !0;
  return !1;
}
function Vs(e, t) {
  return e.has(t);
}
var hk = 1, mk = 2;
function nb(e, t, r, n, i, o) {
  var s = r & hk, a = e.length, l = t.length;
  if (a != l && !(s && l > a))
    return !1;
  var f = o.get(e), u = o.get(t);
  if (f && u)
    return f == t && u == e;
  var h = -1, E = !0, d = r & mk ? new wi() : void 0;
  for (o.set(e, t), o.set(t, e); ++h < a; ) {
    var g = e[h], y = t[h];
    if (n)
      var b = s ? n(y, g, h, t, e, o) : n(g, y, h, e, t, o);
    if (b !== void 0) {
      if (b)
        continue;
      E = !1;
      break;
    }
    if (d) {
      if (!pk(t, function(_, I) {
        if (!Vs(d, I) && (g === _ || i(g, _, r, n, o)))
          return d.push(I);
      })) {
        E = !1;
        break;
      }
    } else if (!(g === y || i(g, y, r, n, o))) {
      E = !1;
      break;
    }
  }
  return o.delete(e), o.delete(t), E;
}
function Ek(e) {
  var t = -1, r = Array(e.size);
  return e.forEach(function(n, i) {
    r[++t] = [i, n];
  }), r;
}
function Gc(e) {
  var t = -1, r = Array(e.size);
  return e.forEach(function(n) {
    r[++t] = n;
  }), r;
}
var gk = 1, yk = 2, Tk = "[object Boolean]", bk = "[object Date]", Ak = "[object Error]", vk = "[object Map]", Sk = "[object Number]", Ik = "[object RegExp]", _k = "[object Set]", Rk = "[object String]", Ok = "[object Symbol]", wk = "[object ArrayBuffer]", Nk = "[object DataView]", lm = dr ? dr.prototype : void 0, Za = lm ? lm.valueOf : void 0;
function Ck(e, t, r, n, i, o, s) {
  switch (r) {
    case Nk:
      if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset)
        return !1;
      e = e.buffer, t = t.buffer;
    case wk:
      return !(e.byteLength != t.byteLength || !o(new um(e), new um(t)));
    case Tk:
    case bk:
    case Sk:
      return HT(+e, +t);
    case Ak:
      return e.name == t.name && e.message == t.message;
    case Ik:
    case Rk:
      return e == t + "";
    case vk:
      var a = Ek;
    case _k:
      var l = n & gk;
      if (a || (a = Gc), e.size != t.size && !l)
        return !1;
      var f = s.get(e);
      if (f)
        return f == t;
      n |= yk, s.set(e, t);
      var u = nb(a(e), a(t), n, i, o, s);
      return s.delete(e), u;
    case Ok:
      if (Za)
        return Za.call(e) == Za.call(t);
  }
  return !1;
}
var Pk = 1, Dk = Object.prototype, Mk = Dk.hasOwnProperty;
function Lk(e, t, r, n, i, o) {
  var s = r & Pk, a = rm(e), l = a.length, f = rm(t), u = f.length;
  if (l != u && !s)
    return !1;
  for (var h = l; h--; ) {
    var E = a[h];
    if (!(s ? E in t : Mk.call(t, E)))
      return !1;
  }
  var d = o.get(e), g = o.get(t);
  if (d && g)
    return d == t && g == e;
  var y = !0;
  o.set(e, t), o.set(t, e);
  for (var b = s; ++h < l; ) {
    E = a[h];
    var _ = e[E], I = t[E];
    if (n)
      var w = s ? n(I, _, E, t, e, o) : n(_, I, E, e, t, o);
    if (!(w === void 0 ? _ === I || i(_, I, r, n, o) : w)) {
      y = !1;
      break;
    }
    b || (b = E == "constructor");
  }
  if (y && !b) {
    var L = e.constructor, R = t.constructor;
    L != R && "constructor" in e && "constructor" in t && !(typeof L == "function" && L instanceof L && typeof R == "function" && R instanceof R) && (y = !1);
  }
  return o.delete(e), o.delete(t), y;
}
var xk = 1, cm = "[object Arguments]", fm = "[object Array]", gs = "[object Object]", kk = Object.prototype, dm = kk.hasOwnProperty;
function jk(e, t, r, n, i, o) {
  var s = Zt(e), a = Zt(t), l = s ? fm : Dr(e), f = a ? fm : Dr(t);
  l = l == cm ? gs : l, f = f == cm ? gs : f;
  var u = l == gs, h = f == gs, E = l == f;
  if (E && cl(e)) {
    if (!cl(t))
      return !1;
    s = !0, u = !1;
  }
  if (E && !u)
    return o || (o = new xr()), s || KT(e) ? nb(e, t, r, n, i, o) : Ck(e, t, l, r, n, i, o);
  if (!(r & xk)) {
    var d = u && dm.call(e, "__wrapped__"), g = h && dm.call(t, "__wrapped__");
    if (d || g) {
      var y = d ? e.value() : e, b = g ? t.value() : t;
      return o || (o = new xr()), i(y, b, r, n, o);
    }
  }
  return E ? (o || (o = new xr()), Lk(e, t, r, n, i, o)) : !1;
}
function Ia(e, t, r, n, i) {
  return e === t ? !0 : e == null || t == null || !jr(e) && !jr(t) ? e !== e && t !== t : jk(e, t, r, n, Ia, i);
}
var Uk = 1, $k = 2;
function Fk(e, t, r, n) {
  var i = r.length, o = i;
  if (e == null)
    return !o;
  for (e = Object(e); i--; ) {
    var s = r[i];
    if (s[2] ? s[1] !== e[s[0]] : !(s[0] in e))
      return !1;
  }
  for (; ++i < o; ) {
    s = r[i];
    var a = s[0], l = e[a], f = s[1];
    if (s[2]) {
      if (l === void 0 && !(a in e))
        return !1;
    } else {
      var u = new xr(), h;
      if (!(h === void 0 ? Ia(f, l, Uk | $k, n, u) : h))
        return !1;
    }
  }
  return !0;
}
function ib(e) {
  return e === e && !Oi(e);
}
function Gk(e) {
  for (var t = Uc(e), r = t.length; r--; ) {
    var n = t[r], i = e[n];
    t[r] = [n, i, ib(i)];
  }
  return t;
}
function ob(e, t) {
  return function(r) {
    return r == null ? !1 : r[e] === t && (t !== void 0 || e in Object(r));
  };
}
function zk(e) {
  var t = Gk(e);
  return t.length == 1 && t[0][2] ? ob(t[0][0], t[0][1]) : function(r) {
    return r === e || Fk(r, e, t);
  };
}
function Bk(e, t) {
  return e != null && t in Object(e);
}
function Vk(e, t, r) {
  t = QT(t, e);
  for (var n = -1, i = t.length, o = !1; ++n < i; ) {
    var s = Sa(t[n]);
    if (!(o = e != null && r(e, s)))
      break;
    e = e[s];
  }
  return o || ++n != i ? o : (i = e == null ? 0 : e.length, !!i && kc(i) && qT(s, i) && (Zt(e) || jc(e)));
}
function Wk(e, t) {
  return e != null && Vk(e, t, Bk);
}
var qk = 1, Hk = 2;
function Yk(e, t) {
  return $c(e) && ib(t) ? ob(Sa(e), t) : function(r) {
    var n = xx(r, e);
    return n === void 0 && n === t ? Wk(r, e) : Ia(t, n, qk | Hk);
  };
}
function sb(e) {
  return function(t) {
    return t == null ? void 0 : t[e];
  };
}
function Zk(e) {
  return function(t) {
    return eb(t, e);
  };
}
function Jk(e) {
  return $c(e) ? sb(Sa(e)) : Zk(e);
}
function zc(e) {
  return typeof e == "function" ? e : e == null ? Lc : typeof e == "object" ? Zt(e) ? Yk(e[0], e[1]) : zk(e) : Jk(e);
}
function Kk(e, t, r, n) {
  for (var i = -1, o = e == null ? 0 : e.length; ++i < o; ) {
    var s = e[i];
    t(n, s, r(s), e);
  }
  return n;
}
function Xk(e) {
  return function(t, r, n) {
    for (var i = -1, o = Object(t), s = n(t), a = s.length; a--; ) {
      var l = s[++i];
      if (r(o[l], l, o) === !1)
        break;
    }
    return t;
  };
}
var Qk = Xk();
function ej(e, t) {
  return e && Qk(e, t, Uc);
}
function tj(e, t) {
  return function(r, n) {
    if (r == null)
      return r;
    if (!ba(r))
      return e(r, n);
    for (var i = r.length, o = -1, s = Object(r); ++o < i && n(s[o], o, s) !== !1; )
      ;
    return r;
  };
}
var rj = tj(ej);
function nj(e, t, r, n) {
  return rj(e, function(i, o, s) {
    t(n, i, r(i), s);
  }), n;
}
function ij(e, t) {
  return function(r, n) {
    var i = Zt(r) ? Kk : nj, o = {};
    return i(r, e, zc(n), o);
  };
}
function Ws(e) {
  return jr(e) && ba(e);
}
function oj(e) {
  var t = e == null ? 0 : e.length;
  return t ? e[t - 1] : void 0;
}
var sj = "[object String]";
function aj(e) {
  return typeof e == "string" || !Zt(e) && jr(e) && sn(e) == sj;
}
var uj = Math.min;
function lj(e, t, r) {
  for (var n = WT, i = e[0].length, o = e.length, s = o, a = Array(o), l = 1 / 0, f = []; s--; ) {
    var u = e[s];
    l = uj(u.length, l), a[s] = i >= 120 && u.length >= 120 ? new wi(s && u) : void 0;
  }
  u = e[0];
  var h = -1, E = a[0];
  e:
    for (; ++h < i && f.length < l; ) {
      var d = u[h], g = d;
      if (d = d !== 0 ? d : 0, !(E ? Vs(E, g) : n(f, g))) {
        for (s = o; --s; ) {
          var y = a[s];
          if (!(y ? Vs(y, g) : n(e[s], g)))
            continue e;
        }
        E && E.push(g), f.push(d);
      }
    }
  return f;
}
function cj(e) {
  return Ws(e) ? e : [];
}
var fj = xc(function(e) {
  var t = zT(e, cj);
  return t.length && t[0] === e[0] ? lj(t) : [];
});
function dj(e, t) {
  return Ia(e, t);
}
function pj(e) {
  return typeof e == "number" && e == DM(e);
}
var hj = "[object Number]";
function mj(e) {
  return typeof e == "number" || jr(e) && sn(e) == hj;
}
var Ej = ij(function(e, t, r) {
  cL(e, r, t);
}), gj = sb("length"), ab = "\\ud800-\\udfff", yj = "\\u0300-\\u036f", Tj = "\\ufe20-\\ufe2f", bj = "\\u20d0-\\u20ff", Aj = yj + Tj + bj, vj = "\\ufe0e\\ufe0f", Sj = "[" + ab + "]", pl = "[" + Aj + "]", hl = "\\ud83c[\\udffb-\\udfff]", Ij = "(?:" + pl + "|" + hl + ")", ub = "[^" + ab + "]", lb = "(?:\\ud83c[\\udde6-\\uddff]){2}", cb = "[\\ud800-\\udbff][\\udc00-\\udfff]", _j = "\\u200d", fb = Ij + "?", db = "[" + vj + "]?", Rj = "(?:" + _j + "(?:" + [ub, lb, cb].join("|") + ")" + db + fb + ")*", Oj = db + fb + Rj, wj = "(?:" + [ub + pl + "?", pl, lb, cb, Sj].join("|") + ")", pm = RegExp(hl + "(?=" + hl + ")|" + wj + Oj, "g");
function Nj(e) {
  for (var t = pm.lastIndex = 0; pm.test(e); )
    ++t;
  return t;
}
function Cj(e) {
  return Wx(e) ? Nj(e) : gj(e);
}
var Pj = "[object Map]", Dj = "[object Set]";
function Mj(e) {
  if (e == null)
    return 0;
  if (ba(e))
    return aj(e) ? Cj(e) : e.length;
  var t = Dr(e);
  return t == Pj || t == Dj ? e.size : XT(e).length;
}
var Lj = 1 / 0, xj = Ti && 1 / Gc(new Ti([, -0]))[1] == Lj ? function(e) {
  return new Ti(e);
} : JM, kj = 200;
function _a(e, t, r) {
  var n = -1, i = WT, o = e.length, s = !0, a = [], l = a;
  if (o >= kj) {
    var f = t ? null : xj(e);
    if (f)
      return Gc(f);
    s = !1, i = Vs, l = new wi();
  } else
    l = t ? [] : a;
  e:
    for (; ++n < o; ) {
      var u = e[n], h = t ? t(u) : u;
      if (u = u !== 0 ? u : 0, s && h === h) {
        for (var E = l.length; E--; )
          if (l[E] === h)
            continue e;
        t && l.push(h), a.push(u);
      } else i(l, h, r) || (l !== a && l.push(h), a.push(u));
    }
  return a;
}
var pb = xc(function(e) {
  return _a(rb(e, 1, Ws));
}), hb = xc(function(e) {
  var t = oj(e);
  return Ws(t) && (t = void 0), _a(rb(e, 1, Ws), zc(t));
});
function Wn(e) {
  return e && e.length ? _a(e) : [];
}
function jj(e, t) {
  return e && e.length ? _a(e, zc(t)) : [];
}
function qs(e) {
  return Te(e) && "fields" in e && $e(e.fields) && e.fields.some((t) => Te(t) && "fieldId" in t);
}
function Bc(e) {
  return Te(e) && "object" in e && Te(e.object);
}
function Uj(e) {
  return Te(e) && "teObject" in e && Te(e.teObject);
}
function hm(e) {
  return Te(e) && "types" in e && $e(e.types) && e.types.some((t) => Xe(t));
}
function $j(e) {
  return Te(e) && "members" in e && $e(e.members) && e.members.some((t) => Te(t) && "objectId" in t);
}
function mb(e) {
  return Te(e) && "relations" in e && $e(e.relations) && e.relations.some((t) => Te(t) && "objectIds" in t);
}
function Fj(e) {
  const t = e;
  return typeof e != "object" || !M(e) ? !1 : "id" in t && "value" in t && Xe(t.id) && vt(t.value);
}
function Gj(e) {
  const t = e;
  return typeof e != "object" || !M(e) ? !1 : "id" in t && !("value" in t) && Xe(t.id);
}
function zj(...e) {
  const t = e.join("");
  let r = 0;
  for (let n = 0; n < t.length; n++) {
    const i = t.charCodeAt(n);
    r = (r << 5) + r + i, r = r >>> 0;
  }
  return r;
}
function Bj(e) {
  return Eb(/* @__PURE__ */ new Set(), e);
}
function Eb(e, t) {
  var n;
  const r = (i) => {
    var o;
    (o = i.relations) == null || o.forEach((s) => {
      s.objectIds.forEach((a) => e.add(a));
    });
  };
  if ($e(t))
    t.forEach((i) => r(i));
  else if (Te(t) && mb(t))
    r(t);
  else
    for (const i in t) {
      const o = (n = t[Number(i)]) == null ? void 0 : n.object;
      M(o) && r(o);
    }
  return e;
}
function gz(e) {
  return Eb(gb(e), e);
}
function Vj(e) {
  return Array.from(Bj(e));
}
function gb(e) {
  var n;
  const t = /* @__PURE__ */ new Set(), r = (i) => {
    var o;
    (o = i.members) == null || o.forEach((s) => {
      t.add(s.objectId);
    });
  };
  if ($e(e))
    e.forEach((i) => r(i));
  else if (Te(e) && $j(e))
    r(e);
  else
    for (const i in e) {
      const o = (n = e[Number(i)]) == null ? void 0 : n.object;
      M(o) && r(o);
    }
  return t;
}
function yz(e) {
  return Array.from(gb(e));
}
function mm(e, t) {
  return hb(e, t, (r) => r == null ? void 0 : r.id).filter(M);
}
const Wj = (e, t) => hb(t, e, (r) => r.fieldId), Tz = (e, t) => ({
  ...e,
  fields: Wj(e.fields, t)
});
function bz(e) {
  return jj(e, "id");
}
function Az(e, t = (r) => r.id) {
  if ($e(e))
    return e.map(t);
  const r = [];
  for (const n in e) {
    const i = e[Number(n)];
    M(i) && r.push(t(i));
  }
  return r;
}
function vz(e, t) {
  var i;
  const r = new Set(t), n = (o) => o.relations.flatMap((s) => s.objectIds).some((s) => r.has(s));
  if ($e(e))
    return e.find(n);
  if (Te(e) && mb(e))
    return n(e) ? e : void 0;
  for (const o in e) {
    const s = (i = e[Number(o)]) == null ? void 0 : i.object;
    if (M(s) && n(s))
      return s;
  }
}
function Em(e) {
  return isFinite(e) ? Math.round(e) : 0;
}
function Sz(e) {
  return M(e) && pj(e) && e > 0;
}
function Iz(e, t) {
  const r = {};
  for (const n in e) {
    const i = e[n];
    t(i, n) && (r[n] = i);
  }
  return r;
}
function _z(e, t) {
  const r = [];
  for (const n in e) {
    const i = e[n];
    t(i, n) && r.push(i);
  }
  return r;
}
function Rz(e) {
  return Object.values(e).reduce(
    (t, r) => (M(r) && t.push(r.id), t),
    []
  );
}
function qj(e) {
  return e.reduce(
    (t, r) => (M(r) && (t[r.id] = r), t),
    {}
  );
}
function yb(e) {
  return Object.values(e);
}
function Hj(e) {
  let t = 0;
  for (const r in e)
    t++;
  return t;
}
function Oz(e) {
  return yb(e).map((t) => t.object);
}
function Et(e) {
  throw new Error("Should never get here");
}
function wz({
  registration: e
}) {
  var n, i;
  const { activities: t } = e, r = {
    OK: 0,
    ISSUE: 0,
    PENDING: 0
  };
  for (const o in t) {
    const s = (n = t[o]) == null ? void 0 : n.allocationSignal;
    if (s && (i = t[o]) != null && i.showInRegistration)
      switch (s) {
        case "ISSUE": {
          r.ISSUE++;
          break;
        }
        case "PENDING": {
          r.PENDING++;
          break;
        }
        case "OK": {
          r.OK++;
          break;
        }
        default:
          Et();
      }
  }
  return r;
}
function Nz(e, t = 500) {
  return rT(e).replace(/\\n|["\\{}]/g, " ").substring(0, t);
}
function Yj(e) {
  try {
    if (vt(e)) {
      const t = JSON.parse(e);
      return Te(t) ? t : {};
    }
    return {};
  } catch {
    return {};
  }
}
function Cz(e) {
  try {
    if (vt(e)) {
      const t = JSON.parse(e);
      return $e(t) ? t : [];
    }
    return [];
  } catch {
    return [];
  }
}
function Zj(e) {
  return Te(e) && "logId" in e && M(e.logId);
}
function Jj(e) {
  return Te(e) && "stack" in e;
}
function Tb(e) {
  return Te(e) && "cause" in e && M(e.cause);
}
function Kj(e) {
  return Te(e) && "errorName" in e && vt(e.errorName) && aa.validate(e.errorName);
}
function Xj(e) {
  return Te(e) && "name" in e && vt(e.name) && aa.validate(e.name);
}
function Qj(e, t) {
  return Ko({
    fallback: () => ({ "": ["."] }),
    options: t
  })(e, (i) => {
    if (Er(i))
      return "";
    if (Zj(i))
      return i.logId;
  }, {});
}
function eU(e) {
  const t = Qj(e), r = Xo(t);
  return Bn(r) && r.length === 1 ? r[0] : r;
}
function tU(e, t) {
  return Ko({
    fallback: () => ({ 500: ["."] }),
    options: t
  })(e, (i) => {
    if (Er(i))
      return 500;
    if (Xe(i))
      return i;
    for (const o of ["statusCode", "status"])
      if (Te(i) && o in i) {
        const s = i[o];
        if (Xe(s))
          return s;
        if (vt(s)) {
          const a = parseInt(s, 10);
          return isNaN(a) ? 500 : a;
        }
      }
  }, {});
}
function es(e) {
  const t = tU(e, { limit: 1 }), r = Xo(t);
  return r.length > 0 ? Number(r[0]) : 500;
}
function bb(e, t) {
  return Ko({
    fallback: () => ({ [le.Error]: ["."] }),
    options: t
  })(e, (i) => {
    if (Er(i))
      return le.Error;
    if (vt(i) && Object.values(le).includes(i))
      return i;
    if (Kj(i))
      return i.errorName;
    if (Xj(i))
      return i.name;
  }, {});
}
function qn(e) {
  const t = bb(e, { limit: 1 });
  return Xo(t)[0] || le.Error;
}
function rU(e, t) {
  return F1({
    fallback: () => [],
    options: t
  })(e, (i) => Er(i) ? [] : Tb(i) ? [i.cause] : [], []);
}
function gm(e) {
  const t = rU(e, { limit: 1 });
  return Bn(t) ? t[0].value : void 0;
}
function nU(e, t) {
  const r = Ko({
    fallback: () => ({}),
    options: t
  }), n = (i) => {
    if (!Er(i)) {
      if (vt(i) && (i = parseInt(i, 10)), Xe(i))
        return i;
      if (Te(i)) {
        if ("errorCode" in i)
          return n(i.errorCode);
        if ("message" in i) {
          const o = i.message;
          if (Te(o) && "errorCode" in o)
            return n(o.errorCode);
        }
      }
    }
  };
  return r(e, n, {});
}
function iU(e) {
  const t = nU(e, { limit: 1 }), r = Xo(t);
  return r.length > 0 ? Number(r[0]) : void 0;
}
function Pz(e) {
  return {
    status: es(e),
    message: Dt(e),
    errorName: qn(e),
    stack: Jj(e) ? e.stack : void 0
  };
}
function oU(e) {
  if (!Tb(e))
    return;
  const t = (r) => {
    const n = qn(r);
    return {
      errorName: n,
      name: n,
      message: Dt(r),
      code: es(r),
      cause: oU(r),
      errorCode: iU(r)
    };
  };
  return $e(e.cause) ? e.cause.map((r) => t(r)) : t(e.cause);
}
function Ab(e, t, r) {
  if (t === le.MultiError && Te(e) && $e(e.cause) && e.cause.length > 0) {
    const n = qn(e.cause[0]);
    if (e.cause.every(
      (o) => qn(o) === n
    ))
      return {
        errorName: n,
        statusCode: es(e.cause[0])
      };
  }
  return { errorName: t, statusCode: r };
}
function sU(e) {
  const t = Ab(
    e,
    qn(e),
    es(e)
  );
  return {
    code: t.statusCode,
    message: Dt(e),
    errorName: t.errorName
  };
}
function Vc(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function vb(e) {
  if (Object.prototype.hasOwnProperty.call(e, "__esModule")) return e;
  var t = e.default;
  if (typeof t == "function") {
    var r = function n() {
      return this instanceof n ? Reflect.construct(t, arguments, this.constructor) : t.apply(this, arguments);
    };
    r.prototype = t.prototype;
  } else r = {};
  return Object.defineProperty(r, "__esModule", { value: !0 }), Object.keys(e).forEach(function(n) {
    var i = Object.getOwnPropertyDescriptor(e, n);
    Object.defineProperty(r, n, i.get ? i : {
      enumerable: !0,
      get: function() {
        return e[n];
      }
    });
  }), r;
}
var _n = {}, ft = {}, ym;
function aU() {
  if (ym) return ft;
  ym = 1, Object.defineProperty(ft, "__esModule", { value: !0 }), ft.SAMLIdentifierFormat = ft.EUserObjectMatching = ft.EApplySSOPermissions = ft.EAuthSaml2SigantureAlgorithm = ft.EAuthSaml2Signing = ft.EAuthLogLevel = ft.EAuthStrategy = void 0;
  var e;
  (function(s) {
    s.TE_IDP = "TE_IDP", s.SAML2 = "SAML2", s.CAS = "CAS";
  })(e || (ft.EAuthStrategy = e = {}));
  var t;
  (function(s) {
    s.NONE = "NONE", s.LOW = "LOW", s.HIGH = "HIGH", s.DEBUG = "DEBUG";
  })(t || (ft.EAuthLogLevel = t = {}));
  var r;
  (function(s) {
    s.NONE = "NONE", s.SIGN = "SIGN", s.REQUIRED = "REQUIRED";
  })(r || (ft.EAuthSaml2Signing = r = {}));
  var n;
  (function(s) {
    s.SHA1 = "sha1", s.SHA256 = "sha256", s.SHA512 = "sha512";
  })(n || (ft.EAuthSaml2SigantureAlgorithm = n = {}));
  var i;
  (function(s) {
    s.ALWAYS = "ALWAYS", s.NEW_USERS = "NEW_USERS", s.NEVER = "NEVER";
  })(i || (ft.EApplySSOPermissions = i = {}));
  var o;
  return (function(s) {
    s.OBJECT_EXTID = "OBJECT_EXTID", s.OBJECT_FIELD = "OBJECT_FIELD";
  })(o || (ft.EUserObjectMatching = o = {})), ft.SAMLIdentifierFormat = {
    Unspecified: "urn:oasis:names:tc:SAML:1.1:nameid-format:unspecified",
    Email: "urn:oasis:names:tc:SAML:1.1:nameid-format:emailAddress",
    Persistent: "urn:oasis:names:tc:SAML:2.0:nameid-format:persistent",
    Transient: "urn:oasis:names:tc:SAML:2.0:nameid-format:transient"
  }, ft;
}
var Rn = {}, Tm;
function uU() {
  if (Tm) return Rn;
  Tm = 1, Object.defineProperty(Rn, "__esModule", { value: !0 }), Rn.APP_ID_TO_NAME_MAP = Rn.EAppId = void 0;
  var e;
  return (function(t) {
    t.TE_ACTIVITIES = "TE_ACTIVITIES", t.TE_ADMIN = "TE_ADMIN", t.TE_ALLOCATE = "TE_ALLOCATE", t.TE_ALLOCATE_PREFERENTIAL = "TE_ALLOCATE_PREFERENTIAL", t.TE_ATTENDANCE = "TE_ATTENDANCE", t.TE_AUTOPILOT = "TE_AUTOPILOT", t.TE_CALENDAR_INTEGRATION = "TE_CALENDAR_INTEGRATION", t.TE_CORE = "TE_CORE", t.TE_CURRICULUM = "TE_CURRICULUM", t.TE_DATA_MANAGER = "TE_DATA_MANAGER", t.TE_DEBIT = "TE_DEBIT", t.TE_EVALUATION = "TE_EVALUATION", t.TE_EVENT_BROKER = "TE_EVENT_BROKER", t.TE_EXAM = "TE_EXAM", t.TE_EXAM_V3 = "TE_EXAM_V3", t.TE_FLOW = "TE_FLOW", t.TE_HUB = "TE_HUB", t.TE_INSIGHT = "TE_INSIGHT", t.TE_PLAN = "TE_PLAN", t.TE_PREFERENCES = "TE_PREFERENCES", t.TE_REGISTRATION = "TE_REGISTRATION", t.TE_REPORTING = "TE_REPORTING", t.TE_RESERVE = "TE_RESERVE", t.TE_SEAT_MANAGEMENT = "TE_SEAT_MANAGEMENT", t.TE_STATISTICS = "TE_STATISTICS", t.TE_STUDY_GUIDE = "TE_STUDY_GUIDE", t.TE_STUDY_PLANNER = "TE_STUDY_PLANNER", t.TE_VIEWER = "TE_VIEWER", t.TE_WORKLOAD = "TE_WORKLOAD", t.JAVA_CLIENT = "JAVA_CLIENT", t.TE_AM = "TE_AM", t.TE_PORTAL = "TE_PORTAL", t.TE_MCP = "TE_MCP", t.TE_REST = "TE_REST", t.TE_SERVER_THREAD = "TE_SERVER_THREAD", t.TE_SOAP = "TE_SOAP";
  })(e || (Rn.EAppId = e = {})), Rn.APP_ID_TO_NAME_MAP = {
    // Products
    [e.TE_ACTIVITIES]: "Activities",
    [e.TE_ADMIN]: "Admin",
    [e.TE_ALLOCATE]: "Allocate",
    [e.TE_ALLOCATE_PREFERENTIAL]: "Allocate Preferential",
    [e.TE_ATTENDANCE]: "Attendance",
    [e.TE_AUTOPILOT]: "Autopilot",
    [e.TE_CALENDAR_INTEGRATION]: "Calendar Integration",
    [e.TE_CORE]: "Core",
    [e.TE_CURRICULUM]: "Curriculum",
    [e.TE_DATA_MANAGER]: "Data Manager",
    [e.TE_DEBIT]: "Debit",
    [e.TE_EVALUATION]: "Evaluation",
    [e.TE_EVENT_BROKER]: "Event Broker",
    [e.TE_EXAM]: "Exam",
    [e.TE_EXAM_V3]: "Assessment",
    [e.TE_FLOW]: "Flow",
    [e.TE_HUB]: "Hub",
    [e.TE_INSIGHT]: "Insight",
    [e.TE_PLAN]: "Plan",
    [e.TE_PREFERENCES]: "Preferences",
    [e.TE_REGISTRATION]: "Registration",
    [e.TE_REPORTING]: "Reporting",
    [e.TE_RESERVE]: "Reserve",
    [e.TE_SEAT_MANAGEMENT]: "Seat Management",
    [e.TE_STATISTICS]: "Statistics",
    [e.TE_STUDY_GUIDE]: "Study Guide",
    [e.TE_STUDY_PLANNER]: "Study Planner",
    [e.TE_VIEWER]: "Viewer",
    [e.TE_WORKLOAD]: "Workload",
    // Supporting apps
    [e.JAVA_CLIENT]: "Java Client",
    [e.TE_AM]: "Activity Manager",
    [e.TE_PORTAL]: "Portal",
    [e.TE_MCP]: "MCP",
    [e.TE_REST]: "REST",
    [e.TE_SERVER_THREAD]: "Server Thread",
    [e.TE_SOAP]: "SOAP"
  }, Rn;
}
var To = {}, bm;
function lU() {
  if (bm) return To;
  bm = 1, Object.defineProperty(To, "__esModule", { value: !0 }), To.ESuiteId = void 0;
  var e;
  return (function(t) {
    t.CURRICULUM = "CURRICULUM", t.WORKLOAD = "WORKLOAD", t.SCHEDULING = "SCHEDULING", t.ENGAGEMENT = "ENGAGEMENT";
  })(e || (To.ESuiteId = e = {})), To;
}
var bo = {}, Am;
function cU() {
  if (Am) return bo;
  Am = 1, Object.defineProperty(bo, "__esModule", { value: !0 }), bo.EAuth = void 0;
  var e;
  return (function(t) {
    t.NOT_AUTHENTICATED = "NOT_AUTHENTICATED", t.AUTHENTICATED = "AUTHENTICATED", t.PENDING = "PENDING";
  })(e || (bo.EAuth = e = {})), bo;
}
var On = {}, vm;
function fU() {
  if (vm) return On;
  vm = 1, Object.defineProperty(On, "__esModule", { value: !0 }), On.EExternalServiceMethods = On.EExternalServices = void 0;
  var e;
  (function(r) {
    r.AUTH_SERVICE = "AUTH_SERVICE", r.USER_SERVICE = "USER_SERVICE", r.ORGANIZATION_SERVICE = "ORGANIZATION_SERVICE", r.APP_SERVICE = "APP_SERVICE", r.BACKUP_SERVICE = "BACKUP_SERVICE", r.TE_SERVER = "TE_SERVER", r.INTEGRATION_SERVICE = "INTEGRATION_SERVICE", r.PATHWAY_SERVICE = "PATHWAY_SERVICE", r.TE_PREFERENCES = "TE_PREFERENCES", r.ACTIVITY_MANAGER = "ACTIVITY_MANAGER", r.ACTIVITY_IMPORTER = "ACTIVITY_IMPORTER", r.REPORTING = "REPORTING", r.NOTIFICATION = "NOTIFICATION_SERVICE", r.EXAM_V3 = "EXAM_V3", r.HUB_SERVICE = "HUB_SERVICE", r.OBJECTS_BATCH_SERVICE = "OBJECTS_BATCH_SERVICE";
  })(e || (On.EExternalServices = e = {}));
  var t;
  return (function(r) {
    r.GET = "get", r.POST = "post", r.PUT = "put", r.PATCH = "patch", r.DELETE = "delete";
  })(t || (On.EExternalServiceMethods = t = {})), On;
}
var Ao = {}, Sm;
function dU() {
  if (Sm) return Ao;
  Sm = 1, Object.defineProperty(Ao, "__esModule", { value: !0 }), Ao.EPaddingRuleType = void 0;
  var e;
  return (function(t) {
    t.DIRECT = "DIRECT", t.TRAVEL_TIME = "TRAVEL_TIME";
  })(e || (Ao.EPaddingRuleType = e = {})), Ao;
}
var wn = {}, Im;
function pU() {
  if (Im) return wn;
  Im = 1, Object.defineProperty(wn, "__esModule", { value: !0 }), wn.EScopeLevel = wn.EPermissionTypes = void 0;
  var e;
  (function(r) {
    r.SCOPE = "SCOPE", r.APP_PERMISSION = "APP_PERMISSION";
  })(e || (wn.EPermissionTypes = e = {}));
  var t;
  return (function(r) {
    r.ADMIN = "ADMIN", r.SUPER = "SUPER";
  })(t || (wn.EScopeLevel = t = {})), wn;
}
var vo = {}, _m;
function Sb() {
  if (_m) return vo;
  _m = 1, Object.defineProperty(vo, "__esModule", { value: !0 }), vo.ERegion = void 0;
  var e;
  return (function(t) {
    t.ANZ = "ANZ", t.EU_EES = "EU_EES", t.SGP = "SGP", t.UK = "UK";
  })(e || (vo.ERegion = e = {})), vo;
}
var tr = {}, Rm;
function hU() {
  if (Rm) return tr;
  Rm = 1, Object.defineProperty(tr, "__esModule", { value: !0 }), tr.ERelativeTimeTypes = tr.EReservationPeriodType = tr.EWeekdaySelection = tr.EWeekdays = void 0;
  var e;
  (function(i) {
    i.MON = "MON", i.TUE = "TUE", i.WED = "WED", i.THU = "THU", i.FRI = "FRI", i.SAT = "SAT", i.SUN = "SUN";
  })(e || (tr.EWeekdays = e = {}));
  var t;
  (function(i) {
    i.noWeekDaySelection = "no_weekday_selection";
  })(t || (tr.EWeekdaySelection = t = {}));
  var r;
  (function(i) {
    i.NONE = "NONE", i.RESERVATION_PERIOD = "RESERVATION_PERIOD", i.DAY = "DAY", i.WEEK = "WEEK", i.MONTH = "MONTH", i.YEAR = "YEAR";
  })(r || (tr.EReservationPeriodType = r = {}));
  var n;
  return (function(i) {
    i.DAYS = "DAYS", i.HOURS = "HOURS", i.MINUTES = "MINUTES";
  })(n || (tr.ERelativeTimeTypes = n = {})), tr;
}
var So = {}, Om;
function mU() {
  if (Om) return So;
  Om = 1, Object.defineProperty(So, "__esModule", { value: !0 }), So.ETokenType = void 0;
  var e;
  return (function(t) {
    t.M2M = "M2M", t.USER = "USER";
  })(e || (So.ETokenType = e = {})), So;
}
var Nn = {}, wm;
function EU() {
  if (wm) return Nn;
  wm = 1, Object.defineProperty(Nn, "__esModule", { value: !0 }), Nn.EUserAllowJavaClientAccess = Nn.EUserVisibility = void 0;
  var e;
  (function(r) {
    r.STANDARD = "STANDARD", r.READ_ONLY = "READ_ONLY", r.HIDDEN = "HIDDEN";
  })(e || (Nn.EUserVisibility = e = {}));
  var t;
  return (function(r) {
    r.STANDARD = "STANDARD", r.YES = "YES", r.NO = "NO";
  })(t || (Nn.EUserAllowJavaClientAccess = t = {})), Nn;
}
var Io = {}, Nm;
function gU() {
  if (Nm) return Io;
  Nm = 1, Object.defineProperty(Io, "__esModule", { value: !0 }), Io.EOrganizationType = void 0;
  var e;
  return (function(t) {
    t.CUSTOMER_PRODUCTION = "CUSTOMER_PRODUCTION", t.CUSTOMER_TESTING = "CUSTOMER_TESTING", t.INTERNAL_PRODUCTION = "INTERNAL_PRODUCTION", t.INTERNAL_OTHER = "INTERNAL_OTHER";
  })(e || (Io.EOrganizationType = e = {})), Io;
}
var Or = {}, Cm;
function yU() {
  if (Cm) return Or;
  Cm = 1, Object.defineProperty(Or, "__esModule", { value: !0 }), Or.EPreferencesFilter = Or.EPersonalDataCheck = Or.EFieldType = void 0;
  var e;
  (function(n) {
    n.TEXT = "TEXT", n.SIGNATURE = "SIGNATURE", n.EMAIL = "EMAIL", n.URL = "URL", n.TELEPHONE = "TELEPHONE", n.CATEGORY = "CATEGORY", n.COMMENT = "COMMENT", n.INTEGER = "INTEGER", n.LENGTH = "LENGTH", n.CHECKBOX = "CHECKBOX", n.REFERENCE = "REFERENCE", n.NON_SEARCHABLE_TEXT = "NON_SEARCHABLE_TEXT", n.NON_SEARCHABLE_REFERENCE = "NON_SEARCHABLE_REFERENCE";
  })(e || (Or.EFieldType = e = {}));
  var t;
  (function(n) {
    n.STANDARD = "STANDARD", n.YES = "YES", n.NO = "NO";
  })(t || (Or.EPersonalDataCheck = t = {}));
  var r;
  return (function(n) {
    n.CHOICE1 = "[0-9]", n.CHOICE2 = "[0-9\\- +]", n.CHOICE3 = "[0-9a-z]", n.CHOICE4 = "[0-9a-zA-ZåäöÅÄÖ_-]", n.CHOICE5 = "[@_\\-\\.0-9a-zA-Z]", n.CHOICE6 = "[@_\\-\\.0-9a-zA-ZåäöÅÄÖ]";
  })(r || (Or.EPreferencesFilter = r = {})), Or;
}
var Cn = {}, Pm;
function TU() {
  if (Pm) return Cn;
  Pm = 1, Object.defineProperty(Cn, "__esModule", { value: !0 }), Cn.EMatchMode = Cn.EOperator = void 0;
  var e;
  (function(r) {
    r.E = "=", r.GTE = ">=", r.GT = ">", r.LTE = "<=", r.LT = "<";
  })(e || (Cn.EOperator = e = {}));
  var t;
  return (function(r) {
    r.MATCH_ONE = "MATCH_ONE", r.MATCH_ALL = "MATCH_ALL";
  })(t || (Cn.EMatchMode = t = {})), Cn;
}
var wr = {}, Dm;
function bU() {
  if (Dm) return wr;
  Dm = 1, Object.defineProperty(wr, "__esModule", { value: !0 }), wr.ELoggedEventType = wr.ELoggedEventItemDataType = wr.ELoggedEventLevel = void 0;
  var e;
  (function(n) {
    n.LOW = "LOW", n.MEDIUM = "MEDIUM", n.HIGH = "HIGH", n.CRITICAL = "CRITICAL";
  })(e || (wr.ELoggedEventLevel = e = {}));
  var t;
  (function(n) {
    n.TEXT = "text/plain", n.JSON = "application/json";
  })(t || (wr.ELoggedEventItemDataType = t = {}));
  var r;
  return (function(n) {
    n.MIGRATION = "MIGRATION", n.IMPORT = "IMPORT", n.SSO = "SSO";
  })(r || (wr.ELoggedEventType = r = {})), wr;
}
var Pn = {}, Mm;
function AU() {
  if (Mm) return Pn;
  Mm = 1, Object.defineProperty(Pn, "__esModule", { value: !0 }), Pn.EPersonalInformation = Pn.EProperty = void 0;
  var e;
  (function(r) {
    r.STANDARD = "STANDARD", r.ABSTRACT = "ABSTRACT", r.VIRTUAL_STANDARD = "VIRTUAL_STANDARD", r.VIRTUAL_ABSTRACT = "VIRTUAL_ABSTRACT", r.TEMPLATE_OBJECT = "TEMPLATE_OBJECT";
  })(e || (Pn.EProperty = e = {}));
  var t;
  return (function(r) {
    r.YES = "YES", r.NO = "NO", r.STANDARD = "STANDARD";
  })(t || (Pn.EPersonalInformation = t = {})), Pn;
}
var Dn = {}, Lm;
function vU() {
  if (Lm) return Dn;
  Lm = 1, Object.defineProperty(Dn, "__esModule", { value: !0 }), Dn.EPeriodAccess = Dn.ETimeIntervals = void 0;
  var e;
  (function(r) {
    r.DATE = "DATE", r.YEAR = "YEAR", r.WEEK = "WEEK", r.WEEK_NUMBER = "WEEK_NUMBER", r.MONTH = "MONTH", r.DAY = "DAY", r.WEEKDAY = "WEEKDAY", r.TIME = "TIME", r.NONE = "-";
  })(e || (Dn.ETimeIntervals = e = {}));
  var t;
  return (function(r) {
    r.PUBLIC = "PUBLIC", r.LIMITED = "LIMITED", r.HIDDEN = "HIDDEN";
  })(t || (Dn.EPeriodAccess = t = {})), Dn;
}
var _o = {}, xm;
function SU() {
  if (xm) return _o;
  xm = 1, Object.defineProperty(_o, "__esModule", { value: !0 }), _o.ERelationType = void 0;
  var e;
  return (function(t) {
    t.USE_ONLY = "USE_ONLY", t.STRICT = "STRICT", t.DYNAMIC = "DYNAMIC";
  })(e || (_o.ERelationType = e = {})), _o;
}
var ut = {}, km;
function IU() {
  if (km) return ut;
  km = 1, Object.defineProperty(ut, "__esModule", { value: !0 }), ut.EReservationStatuses = ut.ETemplateType = ut.ETemplateTypesText = ut.EOptionalRelation = ut.EObjectProperty = ut.EMandatoryProperty = ut.EReservationKind = ut.EDefaultStatus = void 0;
  var e;
  (function(l) {
    l.CONFIRMED = "CONFIRMED", l.PLANNED = "PLANNED", l.PRELIMINARY = "PRELIMINARY";
  })(e || (ut.EDefaultStatus = e = {}));
  var t;
  (function(l) {
    l.PHYSICAL = "PHYSICAL", l.PHYSICAL_DOUBLE = "PHYSICAL_DOUBLE", l.ABSTRACT = "ABSTRACT", l.ABSTRACT_DISPLAY = "ABSTRACT_DISPLAY";
  })(t || (ut.EReservationKind = t = {}));
  var r;
  (function(l) {
    l.MANDATORY = "MANDATORY", l.COMBINATION = "COMBINATION", l.OPTIONAL = "OPTIONAL";
  })(r || (ut.EMandatoryProperty = r = {}));
  var n;
  (function(l) {
    l.OBJECT = "OBJECT", l.VIRTUAL = "VIRTUAL", l.INCOMPLETE = "INCOMPLETE";
  })(n || (ut.EObjectProperty = n = {}));
  var i;
  (function(l) {
    l.NONE = "NONE", l.OPTIONAL = "OPTIONAL", l.ABSTRACT = "ABSTRACT";
  })(i || (ut.EOptionalRelation = i = {}));
  var o;
  (function(l) {
    l.STANDARD = "STANDARD", l.NEVER = "NEVER", l.ALWAYS = "ALWAYS";
  })(o || (ut.ETemplateTypesText = o = {}));
  var s;
  (function(l) {
    l.RESERVATION = "RESERVATION", l.AVAILABILITY = "AVAILABILITY", l.INFO_RESERVATION = "INFO_RESERVATION";
  })(s || (ut.ETemplateType = s = {}));
  var a;
  return (function(l) {
    l.UNKNOWN = "UNKNOWN", l.Reservation = "A_RESERVATION", l.Availability = "A_AVAILABILITY", l.Info = "A_INFO", l.Complete = "B_COMPLETE", l.Incomplete = "B_INCOMPLETE", l.Confirmed = "C_CONFIRMED", l.Preliminary = "C_PRELIMINARY", l.Planned = "C_PLANNED", l.Requested = "C_REQUESTED", l.Rejected = "C_REJECTED", l.Time = "D_TIME", l.WaitingList = "D_WAITING_LIST";
  })(a || (ut.EReservationStatuses = a = {})), ut;
}
var Ro = {}, jm;
function _U() {
  if (jm) return Ro;
  jm = 1, Object.defineProperty(Ro, "__esModule", { value: !0 }), Ro.EAcceptJavaClient = void 0;
  var e;
  return (function(t) {
    t.YES = "YES", t.NO = "NO", t.DEFAULT = "DEFAULT";
  })(e || (Ro.EAcceptJavaClient = e = {})), Ro;
}
var Oo = {}, Um;
function RU() {
  if (Um) return Oo;
  Um = 1, Object.defineProperty(Oo, "__esModule", { value: !0 }), Oo.EFieldMappingModes = void 0;
  var e;
  return (function(t) {
    t.RAW = "RAW", t.FREE_MAPPING = "FREE_MAPPING", t.MAPPED = "MAPPED";
  })(e || (Oo.EFieldMappingModes = e = {})), Oo;
}
var wo = {}, $m;
function OU() {
  if ($m) return wo;
  $m = 1, Object.defineProperty(wo, "__esModule", { value: !0 }), wo.ETEReportingDataSource = void 0;
  var e;
  return (function(t) {
    t.SCHEDULE_GENERATOR = "SCHEDULE_GENERATOR", t.RESERVATIONS = "RESERVATIONS", t.ORDERS = "ORDERS", t.EXAMS = "EXAMS", t.FORMS = "FORMS", t.ACTIVITIES = "ACTIVITIES";
  })(e || (wo.ETEReportingDataSource = e = {})), wo;
}
var Nr = {}, Fm;
function wU() {
  if (Fm) return Nr;
  Fm = 1, Object.defineProperty(Nr, "__esModule", { value: !0 }), Nr.EAppProperties = Nr.EObjectTypeMappingStatuses = Nr.EApplicationObjectTypeGroup = void 0;
  var e;
  (function(n) {
    n.NONE = "NONE", n.ROOM = "ROOM", n.PROFESSOR = "PROFESSOR", n.COURSE = "COURSE", n.COURSE_INFORMATION = "COURSE_INFORMATION", n.INVOICING = "INVOICING", n.STUDENT_SET = "STUDENT_SET", n.STUDENT_SET_GROUP = "STUDENT_SET_GROUP", n.PROGRAM = "PROGRAM", n.ACTIVITY_TYPE = "ACTIVITY_TYPE", n.STUDENT = "STUDENT", n.STAFF = "STAFF", n.CHANGE_REQUEST = "CHANGE_REQUEST", n.INVIGILATOR = "INVIGILATOR";
  })(e || (Nr.EApplicationObjectTypeGroup = e = {}));
  var t;
  (function(n) {
    n.NOT_TESTED = "NOT_TESTED", n.NOT_MAPPED = "NOT_MAPPED", n.MAPPED = "MAPPED", n.TESTED = "TESTED", n.FAILED = "FAILED";
  })(t || (Nr.EObjectTypeMappingStatuses = t = {}));
  var r;
  return (function(n) {
    n.NONE = "NONE", n.NAME = "NAME", n.LABEL = "LABEL", n.EMAIL = "EMAIL", n.FIRST_NAME = "FIRST_NAME", n.LAST_NAME = "LAST_NAME", n.TITLE = "TITLE", n.ID = "ID", n.SEMESTER = "SEMESTER", n.MAX_STUDENTS = "MAX_STUDENTS", n.ACTIVITY_TYPE = "ACTIVITY_TYPE", n.START_DATE = "START_DATE", n.END_DATE = "END_DATE", n.BUFFER = "BUFFER", n.HIDETRACK = "HIDETRACK", n.DEDICATETRACK = "DEDICATETRACK", n.TRACK = "TRACK", n.SEATS = "SEATS", n.COURSE_OCCURENCE = "COURSE_OCCURENCE", n.PLANNED_SIZE = "PLANNED_SIZE", n.PROGRAM = "PROGRAM", n.ROOM_NAME = "ROOM_NAME", n.ROOM_TYPE = "ROOM_TYPE", n.BUILDING = "BUILDING", n.CAMPUS = "CAMPUS", n.REASONABLE_ADJUSTMENT = "REASONABLE_ADJUSTMENT";
  })(r || (Nr.EAppProperties = r = {})), Nr;
}
var xt = {}, Gm;
function NU() {
  if (Gm) return xt;
  Gm = 1, Object.defineProperty(xt, "__esModule", { value: !0 }), xt.CalculatedValueProps = xt.ECalculatedValueKey = xt.EReportTemplateType = xt.EReportingCapacitySource = xt.EReportingTimeType = void 0;
  var e;
  (function(i) {
    i.FIXED_HOUR = "FIXED_HOUR", i.TIME_RANGE = "TIME_RANGE", i.MAX_HOURS = "MAX_HOURS";
  })(e || (xt.EReportingTimeType = e = {}));
  var t;
  (function(i) {
    i.FROM_FIELD = "FROM_FIELD", i.FROM_MEMBERSHIP = "FROM_MEMBERSHIP";
  })(t || (xt.EReportingCapacitySource = t = {}));
  var r;
  (function(i) {
    i.UTILIZATION = "UTILIZATION", i.LOAD = "LOAD", i.DEMAND_ANALYTIC = "DEMAND_ANALYTIC", i.HEATMAP = "HEATMAP";
  })(r || (xt.EReportTemplateType = r = {}));
  var n;
  return (function(i) {
    i.FREQUENCY = "frequency", i.OCCUPANCY = "occupancy", i.UTILIZATION = "utilization", i.BOOKED_HOURS = "bookedHours", i.AVAILABLE_HOUR = "availableHour", i.LOAD_PERCENTAGE = "loadPercentage", i.WEEKS_ABOVE_TARGET = "weeksAboveTarget", i.DEMAND_PERCENTAGE = "demandPercentage";
  })(n || (xt.ECalculatedValueKey = n = {})), xt.CalculatedValueProps = {
    [n.FREQUENCY]: { label: "Frequency", templateType: r.UTILIZATION },
    [n.OCCUPANCY]: { label: "Occupancy", templateType: r.UTILIZATION },
    [n.UTILIZATION]: { label: "Utilization", templateType: r.UTILIZATION },
    [n.BOOKED_HOURS]: { label: "Booked Hours", templateType: r.LOAD },
    [n.AVAILABLE_HOUR]: { label: "Available Hours", templateType: r.LOAD },
    [n.LOAD_PERCENTAGE]: { label: "Load", templateType: r.LOAD },
    [n.WEEKS_ABOVE_TARGET]: {
      label: "Weeks Above Target",
      templateType: r.DEMAND_ANALYTIC
    },
    [n.DEMAND_PERCENTAGE]: {
      label: "Average Weekly Demand",
      templateType: r.DEMAND_ANALYTIC
    }
  }, xt;
}
var zm;
function CU() {
  return zm || (zm = 1, (function(e) {
    var t = _n && _n.__createBinding || (Object.create ? (function(U, z, V, ae) {
      ae === void 0 && (ae = V);
      var q = Object.getOwnPropertyDescriptor(z, V);
      (!q || ("get" in q ? !z.__esModule : q.writable || q.configurable)) && (q = { enumerable: !0, get: function() {
        return z[V];
      } }), Object.defineProperty(U, ae, q);
    }) : (function(U, z, V, ae) {
      ae === void 0 && (ae = V), U[ae] = z[V];
    })), r = _n && _n.__exportStar || function(U, z) {
      for (var V in U) V !== "default" && !Object.prototype.hasOwnProperty.call(z, V) && t(z, U, V);
    };
    Object.defineProperty(e, "__esModule", { value: !0 }), e.EReportTemplateType = e.EReportingCapacitySource = e.EReportingTimeType = e.EAppProperties = e.EObjectTypeMappingStatuses = e.EApplicationObjectTypeGroup = e.ETEReportingDataSource = e.EFieldMappingModes = e.EAcceptJavaClient = e.EReservationStatuses = e.ETemplateType = e.ETemplateTypesText = e.EOptionalRelation = e.EObjectProperty = e.EMandatoryProperty = e.EReservationKind = e.EDefaultStatus = e.ERelationType = e.EPeriodAccess = e.ETimeIntervals = e.EPersonalInformation = e.EProperty = e.EOperator = e.EMatchMode = e.EPreferencesFilter = e.EPersonalDataCheck = e.EFieldType = e.EOrganizationType = e.EUserVisibility = e.EUserAllowJavaClientAccess = e.ETokenType = e.EWeekdaySelection = e.EWeekdays = e.EReservationPeriodType = e.ERelativeTimeTypes = e.ERegion = e.EScopeLevel = e.EPermissionTypes = e.EPaddingRuleType = e.EExternalServices = e.EExternalServiceMethods = e.EAuth = e.ESuiteId = e.EAppId = e.EUserObjectMatching = e.EAuthStrategy = e.EAuthSaml2Signing = e.EAuthSaml2SigantureAlgorithm = e.EAuthLogLevel = e.EApplySSOPermissions = void 0, e.CalculatedValueProps = e.ECalculatedValueKey = void 0;
    var n = aU();
    Object.defineProperty(e, "EApplySSOPermissions", { enumerable: !0, get: function() {
      return n.EApplySSOPermissions;
    } }), Object.defineProperty(e, "EAuthLogLevel", { enumerable: !0, get: function() {
      return n.EAuthLogLevel;
    } }), Object.defineProperty(e, "EAuthSaml2SigantureAlgorithm", { enumerable: !0, get: function() {
      return n.EAuthSaml2SigantureAlgorithm;
    } }), Object.defineProperty(e, "EAuthSaml2Signing", { enumerable: !0, get: function() {
      return n.EAuthSaml2Signing;
    } }), Object.defineProperty(e, "EAuthStrategy", { enumerable: !0, get: function() {
      return n.EAuthStrategy;
    } }), Object.defineProperty(e, "EUserObjectMatching", { enumerable: !0, get: function() {
      return n.EUserObjectMatching;
    } });
    var i = uU();
    Object.defineProperty(e, "EAppId", { enumerable: !0, get: function() {
      return i.EAppId;
    } });
    var o = lU();
    Object.defineProperty(e, "ESuiteId", { enumerable: !0, get: function() {
      return o.ESuiteId;
    } });
    var s = cU();
    Object.defineProperty(e, "EAuth", { enumerable: !0, get: function() {
      return s.EAuth;
    } });
    var a = fU();
    Object.defineProperty(e, "EExternalServiceMethods", { enumerable: !0, get: function() {
      return a.EExternalServiceMethods;
    } }), Object.defineProperty(e, "EExternalServices", { enumerable: !0, get: function() {
      return a.EExternalServices;
    } });
    var l = dU();
    Object.defineProperty(e, "EPaddingRuleType", { enumerable: !0, get: function() {
      return l.EPaddingRuleType;
    } });
    var f = pU();
    Object.defineProperty(e, "EPermissionTypes", { enumerable: !0, get: function() {
      return f.EPermissionTypes;
    } }), Object.defineProperty(e, "EScopeLevel", { enumerable: !0, get: function() {
      return f.EScopeLevel;
    } });
    var u = Sb();
    Object.defineProperty(e, "ERegion", { enumerable: !0, get: function() {
      return u.ERegion;
    } });
    var h = hU();
    Object.defineProperty(e, "ERelativeTimeTypes", { enumerable: !0, get: function() {
      return h.ERelativeTimeTypes;
    } }), Object.defineProperty(e, "EReservationPeriodType", { enumerable: !0, get: function() {
      return h.EReservationPeriodType;
    } }), Object.defineProperty(e, "EWeekdays", { enumerable: !0, get: function() {
      return h.EWeekdays;
    } }), Object.defineProperty(e, "EWeekdaySelection", { enumerable: !0, get: function() {
      return h.EWeekdaySelection;
    } });
    var E = mU();
    Object.defineProperty(e, "ETokenType", { enumerable: !0, get: function() {
      return E.ETokenType;
    } });
    var d = EU();
    Object.defineProperty(e, "EUserAllowJavaClientAccess", { enumerable: !0, get: function() {
      return d.EUserAllowJavaClientAccess;
    } }), Object.defineProperty(e, "EUserVisibility", { enumerable: !0, get: function() {
      return d.EUserVisibility;
    } });
    var g = gU();
    Object.defineProperty(e, "EOrganizationType", { enumerable: !0, get: function() {
      return g.EOrganizationType;
    } });
    var y = yU();
    Object.defineProperty(e, "EFieldType", { enumerable: !0, get: function() {
      return y.EFieldType;
    } }), Object.defineProperty(e, "EPersonalDataCheck", { enumerable: !0, get: function() {
      return y.EPersonalDataCheck;
    } }), Object.defineProperty(e, "EPreferencesFilter", { enumerable: !0, get: function() {
      return y.EPreferencesFilter;
    } });
    var b = TU();
    Object.defineProperty(e, "EMatchMode", { enumerable: !0, get: function() {
      return b.EMatchMode;
    } }), Object.defineProperty(e, "EOperator", { enumerable: !0, get: function() {
      return b.EOperator;
    } }), r(bU(), e);
    var _ = AU();
    Object.defineProperty(e, "EProperty", { enumerable: !0, get: function() {
      return _.EProperty;
    } }), Object.defineProperty(e, "EPersonalInformation", { enumerable: !0, get: function() {
      return _.EPersonalInformation;
    } });
    var I = vU();
    Object.defineProperty(e, "ETimeIntervals", { enumerable: !0, get: function() {
      return I.ETimeIntervals;
    } }), Object.defineProperty(e, "EPeriodAccess", { enumerable: !0, get: function() {
      return I.EPeriodAccess;
    } });
    var w = SU();
    Object.defineProperty(e, "ERelationType", { enumerable: !0, get: function() {
      return w.ERelationType;
    } });
    var L = IU();
    Object.defineProperty(e, "EDefaultStatus", { enumerable: !0, get: function() {
      return L.EDefaultStatus;
    } }), Object.defineProperty(e, "EReservationKind", { enumerable: !0, get: function() {
      return L.EReservationKind;
    } }), Object.defineProperty(e, "EMandatoryProperty", { enumerable: !0, get: function() {
      return L.EMandatoryProperty;
    } }), Object.defineProperty(e, "EObjectProperty", { enumerable: !0, get: function() {
      return L.EObjectProperty;
    } }), Object.defineProperty(e, "EOptionalRelation", { enumerable: !0, get: function() {
      return L.EOptionalRelation;
    } }), Object.defineProperty(e, "ETemplateTypesText", { enumerable: !0, get: function() {
      return L.ETemplateTypesText;
    } }), Object.defineProperty(e, "ETemplateType", { enumerable: !0, get: function() {
      return L.ETemplateType;
    } }), Object.defineProperty(e, "EReservationStatuses", { enumerable: !0, get: function() {
      return L.EReservationStatuses;
    } });
    var R = _U();
    Object.defineProperty(e, "EAcceptJavaClient", { enumerable: !0, get: function() {
      return R.EAcceptJavaClient;
    } });
    var D = RU();
    Object.defineProperty(e, "EFieldMappingModes", { enumerable: !0, get: function() {
      return D.EFieldMappingModes;
    } });
    var P = OU();
    Object.defineProperty(e, "ETEReportingDataSource", { enumerable: !0, get: function() {
      return P.ETEReportingDataSource;
    } });
    var O = wU();
    Object.defineProperty(e, "EApplicationObjectTypeGroup", { enumerable: !0, get: function() {
      return O.EApplicationObjectTypeGroup;
    } }), Object.defineProperty(e, "EObjectTypeMappingStatuses", { enumerable: !0, get: function() {
      return O.EObjectTypeMappingStatuses;
    } }), Object.defineProperty(e, "EAppProperties", { enumerable: !0, get: function() {
      return O.EAppProperties;
    } });
    var F = NU();
    Object.defineProperty(e, "EReportingTimeType", { enumerable: !0, get: function() {
      return F.EReportingTimeType;
    } }), Object.defineProperty(e, "EReportingCapacitySource", { enumerable: !0, get: function() {
      return F.EReportingCapacitySource;
    } }), Object.defineProperty(e, "EReportTemplateType", { enumerable: !0, get: function() {
      return F.EReportTemplateType;
    } }), Object.defineProperty(e, "ECalculatedValueKey", { enumerable: !0, get: function() {
      return F.ECalculatedValueKey;
    } }), Object.defineProperty(e, "CalculatedValueProps", { enumerable: !0, get: function() {
      return F.CalculatedValueProps;
    } });
  })(_n)), _n;
}
var C = CU();
const PU = {
  [C.EApplicationObjectTypeGroup.NONE]: "None",
  [C.EApplicationObjectTypeGroup.ROOM]: "Room",
  [C.EApplicationObjectTypeGroup.PROFESSOR]: "Professor",
  [C.EApplicationObjectTypeGroup.COURSE]: "Course",
  [C.EApplicationObjectTypeGroup.COURSE_INFORMATION]: "Course Information",
  [C.EApplicationObjectTypeGroup.INVOICING]: "Invoicing",
  [C.EApplicationObjectTypeGroup.STUDENT_SET]: "Student Set",
  [C.EApplicationObjectTypeGroup.STUDENT_SET_GROUP]: "Student Set Group",
  [C.EApplicationObjectTypeGroup.PROGRAM]: "Program",
  [C.EApplicationObjectTypeGroup.ACTIVITY_TYPE]: "Activity Type",
  [C.EApplicationObjectTypeGroup.STUDENT]: "Student",
  [C.EApplicationObjectTypeGroup.INVIGILATOR]: "Invigilator",
  [C.EApplicationObjectTypeGroup.STAFF]: "Staff",
  [C.EApplicationObjectTypeGroup.CHANGE_REQUEST]: "Change Request"
}, DU = {
  [C.EAppProperties.NONE]: "None",
  [C.EAppProperties.NAME]: "Name",
  [C.EAppProperties.LABEL]: "Label",
  [C.EAppProperties.EMAIL]: "Email",
  [C.EAppProperties.FIRST_NAME]: "First Name",
  [C.EAppProperties.LAST_NAME]: "Last Name",
  [C.EAppProperties.ROOM_TYPE]: "Room Type",
  [C.EAppProperties.BUILDING]: "Building",
  [C.EAppProperties.CAMPUS]: "Campus",
  [C.EAppProperties.REASONABLE_ADJUSTMENT]: "Reasonable Adjustment",
  [C.EAppProperties.TITLE]: "Title",
  [C.EAppProperties.ID]: "Id",
  [C.EAppProperties.SEMESTER]: "Semester",
  [C.EAppProperties.MAX_STUDENTS]: "Max class size",
  [C.EAppProperties.ACTIVITY_TYPE]: "Activity Type",
  [C.EAppProperties.START_DATE]: "Start Date",
  [C.EAppProperties.END_DATE]: "End Date",
  [C.EAppProperties.BUFFER]: "Buffer",
  [C.EAppProperties.HIDETRACK]: "Hidden",
  [C.EAppProperties.DEDICATETRACK]: "Dedicated",
  [C.EAppProperties.TRACK]: "Group",
  [C.EAppProperties.SEATS]: "Capacity",
  [C.EAppProperties.ROOM_NAME]: "Room name",
  [C.EAppProperties.COURSE_OCCURENCE]: "Course Occurence",
  [C.EAppProperties.PLANNED_SIZE]: "Planned Size",
  [C.EAppProperties.PROGRAM]: "Program"
}, MU = {
  action: "Action",
  actionNeeded: "Action needed",
  activityWaitlistDescription: "Students in (at least one) waitlist",
  addRow: "Add Row",
  addToWaitlist: "Add to waitlist",
  addWaitlistErrorTitle: "Failed to join waitlist",
  admin: "Admin",
  afternoon: "Afternoon",
  agenda: "Agenda",
  allocated: "Allocated",
  allocating: "Allocating",
  allocation: "Allocation",
  availableAt: "Available {0}",
  chooseSettings: "Choose Settings",
  clash: "Schedule clash",
  clashMessage: "There is a conflict between the following registrations",
  classType: "Class Type",
  closed: "Closed",
  completed: "Completed",
  conflict: "Conflict",
  scheduleConflict: "Schedule conflict",
  conflictErrorText: "Please select a conflict free option",
  conflictErrorTitle: "There is a conflict",
  copy: "Copy",
  copyURL: "Copy URL",
  create: "Create",
  dataIssueText: "{0} data",
  date: "Date",
  dates: "Dates",
  day: "Day",
  days: "Days",
  deallocate: "Deregister",
  deallocateConfirm: "Are you sure you want to deregister?",
  dedicateTo: "Dedicate to",
  dedicatedErrorText: "This option is dedicated to another student group. Please select another one",
  dedicatedErrorTitle: "Dedicated option",
  defaultServerErrorMessage: "There appears to be a problem connecting to the server. Please try again.",
  delete: "Delete",
  deleteSelected: "Delete Selected",
  distribution: "Distribution",
  done: "Done",
  doubleBookedErrorText: "Please deregister from this activity before selecting a different option",
  doubleBookedErrorTitle: "Already registered on this activity",
  duration: "Duration",
  building: "Building",
  equipment: "Equipment",
  location: "Location",
  staff: "Staff",
  link: "Link",
  meetingLink: "Meeting link",
  recording: "Recording",
  roomDetails: "Room details",
  details: "{0} details",
  detailsFor: "{0} details for {1}",
  viewOnMap: "View on map",
  editSchedulePreferences: "Edit schedule preferences",
  editSettings: "Edit Settings",
  errorInAllocate: "Error in Allocate",
  errorInRegistration: "Error in registration",
  errorInSchedulePreferences: "Error in schedule preferences",
  errorInSchedule: "Error in my schedule",
  failed: "Failed",
  failedAllocationProposals: "Failed allocation proposals",
  generalPreferences: "General preferences",
  generating: "Generating",
  getLinkingGroupsFailed: "Could not get linked groups",
  graphicalview: "Calendar",
  groups: "Groups",
  hiddenErrorText: "Please select another one",
  hiddenErrorTitle: "Option is hidden",
  highDemandErrorTitle: "High demand for registration",
  home: "Home",
  impossibleInCurrentProposal: "Impossible in proposal",
  impossibleProposal: "Impossible",
  inWaitlist: "In waitlist",
  notInWaitlist: "Not in waitlist",
  inWaitlistTooltip: "In waitlist to this group",
  invalidActivityType: 'Invalid "{0}". Expected 1 "{0}", found {1}.',
  invalidCourseIds: 'Invalid "{0}" relations. Expected 1 "{0}" ID, found {1}.',
  issue: "Issue",
  issues: "Issues",
  lastRegistrationDate: "Last date for registration",
  lastUpdatedAt: "Last updated {0}",
  leaveWaitlist: "Leave waitlist",
  loadBookingsFailed: "Could not load bookings",
  loadEarlierBookings: "Load earlier bookings",
  leaveWaitlistConfirmText: "You will lose your place in the waitlist for {0}, {1}.",
  leaveWaitlistConfirmTitle: "Are you sure you want to leave waitlist?",
  leavingWaitlistDescription: "In waitlist to other groups",
  clickToLeaveWaitlist: "Click to leave waitlist.",
  clickToDeregister: "Click to deregister.",
  clickToPrefer: "Click to mark as preferred.",
  clickToUnprefer: "Click to remove preference.",
  registerTo: "Register to",
  swapTo: "Swap to",
  linkedIssuePresent: "Linked issue present",
  linkedRulesFailed: "Linked groups does not match.",
  loading: "Loading...",
  logout: "Logout",
  month: "Month",
  moreInformation: "More information",
  moreInformationAvailableAt: "More information available {0}",
  morning: "Morning",
  multipleAllocations: "Multiple allocations",
  multipleMessage: "The following activity has multiple allocated groups",
  mySchedule: "Schedule",
  subscribe: "Subscribe",
  goBackToSchedule: "Go back to your schedule",
  subscribeDescription: "Subscribe to your schedule and get automatic updates in your calendar application",
  subscribeSelectCal: "Select your calendar",
  subscribeApple: "Calendar on iPhone or Mac",
  subscribeGoogle: "Google Calendar",
  subscribeOther: "Other calendar",
  subscribeGoogleInfo: "The refresh frequency of your calendar is determined by Google Calendar, typically once every 12-24 hours.",
  subscribeAppleInfo: "The refresh frequency of your calendar is determined by the Calendar app on iPhone or Mac, typically once per hour.",
  subscribeOtherInfo: "The refresh frequency of your calendar is determined by your calendar provider, typically every few hours.",
  subscribeStepClickSubscribe: 'Click on "Subscribe" button',
  subscribeHowTo: "How to add the subscription:",
  subscribeAppleDescription: "Subscribe to your schedule in Calendar on iOS or macOS",
  subscribeAppleStepComplete: "Complete the dialog when Calendar opens",
  subscribeGoogleDescription: "Subscribe to your schedule in Google Calendar",
  subscribeGoogleStepAdd: 'Click "Add" when the dialog in Google Calendar opens',
  subscribeOtherIntro: "Complete the steps to add the subscription",
  subscribeOtherStepCopyUrl: "Copy the calendar URL",
  subscribeOtherStepOpenApp: "Open your calendar application",
  subscribeOtherStepFindOption: "Find the option to add a calendar. It's usually labelled Add calendar, Subscribe or shown as a + icon",
  subscribeOtherStepChooseUrl: "Choose from the URL / Subscribe from web option",
  subscribeOtherStepPaste: "Paste the URL and confirm",
  subscribeOtherPasteLabel: "Copy and paste the URL into your calendar:",
  specificGroups: "Specific groups",
  specificGroupsPreferencesDescription: "Continue with your general preferences or mark one or more specific group(s) as preferred",
  specificGroupsPreferencesHappy: "I am happy with my general preferences",
  specificGroupsPreferencesSpecific: "I want to submit preferences for specific groups",
  navigate: "Navigate to",
  newChanges: "new changes",
  next: "Next",
  noActivities: "No Activities",
  noBookings: "You have no bookings",
  noData: "No data",
  noEnrolledCourses: "No Enrolled Courses",
  bookingsBefore: "Bookings before {0} are not available.",
  bookingsAfter: "Bookings after {0} are not available.",
  noNotifications: "No notifications",
  noPermission: "You don't have permission to perform this action",
  noPreference: "No preference",
  noSchedule: "No schedule",
  noSchedulePreferencesSaved: "No preferences submitted",
  noStudentObject: "There is no student object connected to your user.",
  noSeatsLeft: "No seats left",
  notAllocated: "Not Allocated",
  notEnoughSpaceOnPossibleProposal: "No seats in proposal",
  notRegistered: "Not Registered",
  youAreRegisteredTo: "You are registered to",
  noticeText: "Notices",
  optionsAvailable: "options available",
  optionsAvailableNone: "No options available",
  optionsAvailableOne: "1 option available",
  pleaseTryAgain: "Please try again",
  populateCache: "Populate Cache",
  preferencesSaved: "Preferences saved",
  preferredGroup: "Preferred",
  notPreferred: "Not preferred",
  preferredGroupsCount: "{0} preferred",
  preferredGroups: "Preferred groups",
  addTime: "Add time",
  addTimeToAvoid: "Add a time to avoid",
  editTime: "Edit time",
  deleteTime: "Delete time",
  timePreferenceDisclaimer: "You may still be scheduled at this time, as preferences can't always be met.",
  from: "From",
  to: "To",
  avoidThisTime: "Avoid this time",
  noTimeAdded: "No time added",
  cancel: "Cancel",
  close: "Close",
  preferThisGroup: "I prefer this",
  previous: "Previous",
  register: "Register",
  registerToClasses: "Register to the classes that fit your preferences",
  registered: "Registered",
  registration: "Registration",
  registrationClosed: "Registration closed",
  registrationInfo: "Registration",
  registrationOpen: "Registration is open for",
  registrationOpenUntil: "Registration open until",
  registrationOpens: "Registration opens",
  registrationPeriodErrorText: "The registration period for this group is closed",
  registrationPeriodErrorTitle: "Registration period closed",
  relation: "Relation",
  rename: "Rename",
  restoreNotifications: "Restore closed notifications",
  retry: "Retry",
  save: "Save",
  savePreferencesSummaryDescription: "You are about to save the following schedule preferences.",
  schedule: "Schedule",
  schedulePreferences: "Schedule preferences",
  schedulePreferencesDisclaimer: "While we cannot guarantee that your schedule will meet all of your preferences, we will make every effort to accommodate your requests.",
  seatNumber: "Seat number",
  seat: "Seat",
  select: "Select",
  selectPreferencesDescription: "Select from available options to let us know what you prefer.",
  setDefault: "Set as Default",
  setTypeWarning: "You have fields mapped on this type. Remove them before switching.",
  settings: "Settings",
  showMore: "+{0} more",
  sizeErrorText: "Please select another one",
  sizeErrorTitle: "Option is full",
  sortBy: "Sort by",
  submit: "Submit",
  summary: "Summary",
  swap: "Swap",
  teServerDown: "There appears to be a problem connecting to the server. Try again in a moment",
  textview: "List",
  time: "Time",
  timePreferences: "Time preferences",
  timePreferencesDescription: "Add the times you would like to avoid to be scheduled",
  timeOfDay: "Time of day",
  timeOfDayTooltip: "The time of day you prefer to be scheduled",
  preferredTimes: "Preferred times",
  avoidTimes: "Times to avoid",
  today: "Today",
  typeList: "{0} list",
  unknownIssue: "Something went wrong when fetching details about this issue.",
  waitlist: "Waitlist",
  week: "Week",
  welcome: "Welcome",
  welcomeTo: "Welcome to",
  youHave: "You have",
  digitalResources: "Digital resources",
  generalInfo: "General information",
  ...PU,
  ...DU,
  examsUnavailableText: "Your assessments could not be loaded right now. The rest of your schedule is shown below.",
  examsUnavailableTitle: "Assessment information unavailable",
  preferredGroupsUnavailableText: "Some of your preferred groups could not be found. They may have been removed or changed. The rest of your preferences are shown.",
  preferredGroupsUnavailableTitle: "Preferred groups unavailable",
  configurationErrorText: "Your schedule is not fully set up. Please contact your administrator.",
  configurationErrorTitle: "Configuration problem",
  noStudentObjectTitle: "No schedule connected",
  somethingWentWrong: "Something went wrong"
}, LU = {
  [C.EApplicationObjectTypeGroup.NONE]: "Ingen",
  [C.EApplicationObjectTypeGroup.ROOM]: "Rum",
  [C.EApplicationObjectTypeGroup.PROFESSOR]: "Professor",
  [C.EApplicationObjectTypeGroup.COURSE]: "Kurs",
  [C.EApplicationObjectTypeGroup.COURSE_INFORMATION]: "Kursinformation",
  [C.EApplicationObjectTypeGroup.INVOICING]: "Fakturering",
  [C.EApplicationObjectTypeGroup.STUDENT_SET]: "Studentset",
  [C.EApplicationObjectTypeGroup.STUDENT_SET_GROUP]: "Studentsetgrupp",
  [C.EApplicationObjectTypeGroup.PROGRAM]: "Program",
  [C.EApplicationObjectTypeGroup.ACTIVITY_TYPE]: "Activitetsgrupp",
  [C.EApplicationObjectTypeGroup.STUDENT]: "Student",
  [C.EApplicationObjectTypeGroup.INVIGILATOR]: "Tentamensvakt",
  [C.EApplicationObjectTypeGroup.STAFF]: "Personal",
  [C.EApplicationObjectTypeGroup.CHANGE_REQUEST]: "Förändringsförfrågning"
}, xU = {
  [C.EAppProperties.NONE]: "Inget",
  [C.EAppProperties.NAME]: "Namn",
  [C.EAppProperties.LABEL]: "Etikett",
  [C.EAppProperties.EMAIL]: "Epost",
  [C.EAppProperties.FIRST_NAME]: "Förnamn",
  [C.EAppProperties.LAST_NAME]: "Efternamn",
  [C.EAppProperties.ROOM_TYPE]: "Rumstyp",
  [C.EAppProperties.BUILDING]: "Byggnad",
  [C.EAppProperties.CAMPUS]: "Campus",
  [C.EAppProperties.REASONABLE_ADJUSTMENT]: "Rimlig justering",
  [C.EAppProperties.TITLE]: "Titel",
  [C.EAppProperties.ID]: "Id",
  [C.EAppProperties.SEMESTER]: "Termin",
  [C.EAppProperties.MAX_STUDENTS]: "Max antal studenter",
  [C.EAppProperties.ACTIVITY_TYPE]: "Aktivitetstyp",
  [C.EAppProperties.START_DATE]: "Startdatum",
  [C.EAppProperties.END_DATE]: "Slutdatum",
  [C.EAppProperties.BUFFER]: "Buffer",
  [C.EAppProperties.HIDETRACK]: "Gömt",
  [C.EAppProperties.DEDICATETRACK]: "Tilldelat",
  [C.EAppProperties.TRACK]: "Grupp",
  [C.EAppProperties.ROOM_NAME]: "Rumsnamn",
  [C.EAppProperties.SEATS]: "Kapacitet",
  [C.EAppProperties.COURSE_OCCURENCE]: "Kurstillfälle",
  [C.EAppProperties.PLANNED_SIZE]: "Planerad storlek",
  [C.EAppProperties.PROGRAM]: "Program"
}, kU = {
  action: "Handling",
  actionNeeded: "Handling erfordras",
  activityWaitlistDescription: "Studenter i (minst en) väntelista",
  addRow: "Lägg till rad",
  addToWaitlist: "Lägg till på väntelista",
  addWaitlistErrorTitle: "Kunde inte gå med i väntelistan",
  admin: "Admin",
  afternoon: "Eftermiddag",
  agenda: "Agenda",
  allocated: "Allokerad",
  allocating: "Allokerar",
  allocation: "Allokering",
  availableAt: "Tillgänglig {0}",
  chooseSettings: "Välj inställningar",
  clash: "Schemakonflikt",
  clashMessage: "Det finns en konflikt mellan följande registrationer",
  classType: "Kurstillfälle",
  closed: "Stängd",
  completed: "Completed",
  conflict: "Konflikt",
  scheduleConflict: "Schemakonflikt",
  conflictErrorText: "Vänligen välj ett annat alternativ",
  conflictErrorTitle: "Konflikt",
  copy: "Kopiera",
  copyURL: "Kopiera URL",
  create: "Skapa",
  dataIssueText: "{0} data",
  date: "Datum",
  dates: "Datum",
  day: "Dag",
  days: "Dagar",
  deallocate: "Avregistrera",
  deallocateConfirm: "Är du säker på att du vill avregistrera?",
  dedicateTo: "Dedikera till",
  dedicatedErrorText: "Detta alternativ är tilldelat för andra student grupper",
  dedicatedErrorTitle: "Tilldelat alternativ",
  defaultServerErrorMessage: "Det verkar vara ett problem med att ansluta till servern. Vänligen försök igen.",
  delete: "Radera",
  deleteSelected: "Rader markerade",
  distribution: "Fördelning",
  done: "Klar",
  doubleBookedErrorText: "Vänligen avregistrera från denna aktivitet innan du väljer ett annat alternativ",
  doubleBookedErrorTitle: "Redan registrerad på denna aktivitet",
  duration: "Varaktighet",
  building: "Byggnad",
  equipment: "Utrustning",
  location: "Plats",
  staff: "Personal",
  link: "Länk",
  meetingLink: "Möteslänk",
  recording: "Inspelning",
  roomDetails: "Rumsdetaljer",
  details: "Detaljer för {0}",
  detailsFor: "Detaljer för {0} {1}",
  viewOnMap: "Visa på karta",
  editSchedulePreferences: "Redigera schemapreferenser",
  editSettings: "Ändra inställningar",
  errorInAllocate: "Fel i Allocate",
  errorInRegistration: "Fel vid registrering",
  errorInSchedulePreferences: "Fel vid schemapreferenser",
  errorInSchedule: "Fel vid mitt schema",
  failed: "Misslyckad",
  failedAllocationProposals: "Misslyckade allokeringsförslag",
  generalPreferences: "Allmänna preferenser",
  generating: "Genererar",
  getLinkingGroupsFailed: "Hittade inga länkade grupper",
  graphicalview: "Kalender",
  groups: "Grupper",
  hiddenErrorText: "Vänligen välj ett annat alternativ",
  hiddenErrorTitle: "Dolt alternativ",
  highDemandErrorTitle: "Hög efterfrågan",
  home: "Hem",
  impossibleInCurrentProposal: "Omöjligt i förslaget",
  impossibleProposal: "Omöjligt",
  inWaitlist: "På väntelista",
  notInWaitlist: "Inte på väntelista",
  inWaitlistTooltip: "På väntelista för denna gruppen",
  invalidActivityType: "Ogiltig '{0}'. 1 förväntad '{0}', hittade {1}.",
  invalidCourseIds: "Ogiltiga '{0}'-relationer. 1 förväntat '{0}'-relationer, hittade {1}.",
  issue: "Problem",
  issues: "Problem",
  lastRegistrationDate: "Sista datum för registrering",
  lastUpdatedAt: "Senaste ändringen {0}",
  leaveWaitlist: "Lämna väntelista",
  loadBookingsFailed: "Kunde inte ladda bokningar",
  loadEarlierBookings: "Ladda tidigare bokningar",
  leaveWaitlistConfirmText: "Du kommer att förlora din plats i kön för {0}, {1}.",
  leaveWaitlistConfirmTitle: "Är du säker på att du vill lämna väntelistan?",
  leavingWaitlistDescription: "På väntelista till andra grupper",
  clickToLeaveWaitlist: "Klicka för att lämna lämna väntelistan.",
  clickToDeregister: "Klicka för att avregistrera.",
  clickToPrefer: "Klicka för att markera som föredragen.",
  clickToUnprefer: "Klicka för att ta bort önskemålet.",
  registerTo: "Registrera till",
  swapTo: "Byt till",
  linkedIssuePresent: "Problem i en länkad grupp",
  linkedRulesFailed: "Studenter kommer inte att allokeras till dessa grupper. Länkade grupper matchar inte.",
  loading: "Laddar...",
  logout: "Logga ut",
  month: "Månad",
  moreInformation: "Mer information",
  moreInformationAvailableAt: "Mer information tillgänglig {0}",
  morning: "Förmiddag",
  multipleAllocations: "Flertal registreringar",
  multipleMessage: "Följande aktiviteter har flera registrerade spår",
  mySchedule: "Schema",
  subscribe: "Prenumerera",
  goBackToSchedule: "Gå tillbaka till ditt schema",
  subscribeDescription: "Prenumerera på ditt schema och få automatiska uppdateringar i din kalenderapplikation",
  subscribeSelectCal: "Välj din kalender",
  subscribeApple: "Kalender på iPhone eller Mac",
  subscribeGoogle: "Google Calendar",
  subscribeOther: "Annan kalender",
  subscribeGoogleInfo: "Hur ofta din kalender uppdateras bestäms av Google Kalender, vanligtvis var 12–24:e timme.",
  subscribeAppleInfo: "Hur ofta din kalender uppdateras bestäms av appen Kalender på iPhone eller Mac, vanligtvis en gång i timmen.",
  subscribeOtherInfo: "Hur ofta din kalender uppdateras bestäms av din kalenderleverantör, vanligtvis med några timmars mellanrum.",
  subscribeStepClickSubscribe: 'Klicka på "Prenumerera"-knappen',
  subscribeHowTo: "Så här lägger du till prenumerationen:",
  subscribeAppleDescription: "Prenumerera på ditt schema i Kalender på iOS eller macOS",
  subscribeAppleStepComplete: "Slutför dialogen när Kalender öppnas",
  subscribeGoogleDescription: "Prenumerera på ditt schema i Google Calendar",
  subscribeGoogleStepAdd: 'Klicka på "Lägg till" när dialogen i Google Calendar öppnas',
  subscribeOtherIntro: "Slutför stegen för att lägga till prenumerationen",
  subscribeOtherStepCopyUrl: "Kopiera kalender-URL:en",
  subscribeOtherStepOpenApp: "Öppna din kalenderapplikation",
  subscribeOtherStepFindOption: "Hitta alternativet för att lägga till en kalender. Det är oftast märkt Lägg till kalender, Prenumerera eller visas som en +-ikon",
  subscribeOtherStepChooseUrl: "Välj alternativet URL / Prenumerera från webben",
  subscribeOtherStepPaste: "Klistra in URL:en och bekräfta",
  subscribeOtherPasteLabel: "Kopiera och klistra in URL:en i din kalender:",
  specificGroups: "Specifika grupper",
  specificGroupsPreferencesDescription: "Fortsätt med dina allmänna önskemål eller markera en eller flera specifika grupper som föredragna",
  specificGroupsPreferencesHappy: "Jag är nöjd med mina allmänna önskemål",
  specificGroupsPreferencesSpecific: "Jag vill lämna önskemål för specifika grupper",
  navigate: "Navigera till",
  newChanges: "new changes",
  next: "Nästa",
  noActivities: "Inga aktiviteter",
  noBookings: "Du har inga bokningar",
  noData: "Ingen data",
  noEnrolledCourses: "Inga registrerade kurser",
  bookingsBefore: "Bokningar före {0} är inte tillgängliga.",
  bookingsAfter: "Bokningar efter {0} är inte tillgängliga.",
  noNotifications: "Inga notiser",
  noPermission: "Du har inte behörighet att utföra denna åtgärd",
  noPreference: "Ingen preferens",
  noSchedule: "Inget schema",
  noSchedulePreferencesSaved: "Inga preferenser inlämnade",
  noStudentObject: "Inget studentobjekt är kopplat till din användare.",
  noSeatsLeft: "Inga platser kvar",
  notAllocated: "Inte allokerad",
  notEnoughSpaceOnPossibleProposal: "Inga platser i förslaget",
  notRegistered: "Inte Registrerad",
  youAreRegisteredTo: "Du är registrerad till",
  noticeText: "Notiser",
  optionsAvailable: "Tillgängliga alternativ",
  optionsAvailableNone: "Inga alternativ",
  optionsAvailableOne: "1 tillgängligt alternativ",
  pleaseTryAgain: "Var god och försök igen",
  populateCache: "Populera cachen",
  preferencesSaved: "Preferenser sparade",
  preferredGroup: "Föredragen",
  notPreferred: "Inte föredragen",
  preferredGroupsCount: "{0} föredragna",
  preferredGroups: "Föredragna grupper",
  addTime: "Lägg till tid",
  addTimeToAvoid: "Lägg till en tid att undvika",
  editTime: "Redigera tid",
  deleteTime: "Ta bort tid",
  timePreferenceDisclaimer: "Du kan fortfarande bli schemalagd på denna tid, eftersom preferenser inte alltid kan uppfyllas.",
  from: "Från",
  to: "Till",
  avoidThisTime: "Undvik denna tid",
  noTimeAdded: "Ingen tid tillagd",
  cancel: "Avbryt",
  close: "Stäng",
  preferThisGroup: "Jag föredrar denna",
  previous: "Föregående",
  register: "Registrera",
  registerToClasses: "Registrera till de kurser som passar dina preferenser",
  registered: "Registrerad",
  registration: "Registrering",
  registrationClosed: "Registrering stängd",
  registrationInfo: "Registreringsinfo",
  registrationOpen: "Registrering öppen för",
  registrationOpenUntil: "Registrering öppen till",
  registrationOpens: "Registrering öppnar",
  registrationPeriodErrorText: "Registreringsperioden för denna grupp är stängd",
  registrationPeriodErrorTitle: "Registreringsperioden är stängd",
  relation: "Relation",
  rename: "Döp om",
  restoreNotifications: "Återställ stängda notiser",
  retry: "Försök igen",
  save: "Spara",
  savePreferencesSummaryDescription: "Du är på väg att spara följande schemapreferenser.",
  schedule: "Schema",
  schedulePreferences: "Schemapreferenser",
  schedulePreferencesDisclaimer: "Vi kan inte garantera att ditt schema kommer att uppfylla alla dina preferenser, men vi kommer att göra vårt bästa för att tillgodose dina önskemål.",
  seatNumber: "Platsnummer",
  seat: "Plats",
  select: "Välj",
  selectPreferencesDescription: "Välj bland tillgängliga alternativ för att meddela oss vad du föredrar.",
  setDefault: "Sätt som förval",
  setTypeWarning: "Du har fält mappade för den här typen. Ta bort dem innan du byter typ.",
  settings: "Inställningar",
  showMore: "+{0} till",
  sizeErrorText: "Vänligen välj ett annat alternativ",
  sizeErrorTitle: "Alternativet är fullt",
  sortBy: "Sortera efter",
  submit: "Skicka",
  summary: "Sammanfattning",
  swap: "Byt",
  teServerDown: "Det verkar vara ett problem att ansluta till servern. Försök igen om en stund",
  textview: "Lista",
  time: "Tid",
  timePreferences: "Tidspreferenser",
  timePreferencesDescription: "Lägg till tider då du inte vill bli schemalagd",
  timeOfDay: "Tid på dagen",
  timeOfDayTooltip: "Vilken tid du föredrar att bli schemalagd",
  preferredTimes: "Föredragna tider",
  avoidTimes: "Tider att undvika",
  today: "Idag",
  typeList: "{0}-lista",
  unknownIssue: "Något gick fel med att hämta detaljer om problemet.",
  waitlist: "Väntelista",
  week: "Vecka",
  welcome: "Välkommen",
  welcomeTo: "Välkommen till",
  youHave: "Du har",
  digitalResources: "Digitala resurser",
  generalInfo: "Generell information",
  ...LU,
  ...xU,
  examsUnavailableText: "Dina tentamensbokningar kunde inte hämtas just nu. Resten av ditt schema visas nedan.",
  examsUnavailableTitle: "Tentamensinformation ej tillgänglig",
  preferredGroupsUnavailableText: "Några av dina föredragna grupper kunde inte hittas. De kan ha tagits bort eller ändrats. Resten av dina preferenser visas.",
  preferredGroupsUnavailableTitle: "Föredragna grupper ej tillgängliga",
  configurationErrorText: "Ditt schema är inte färdigkonfigurerat. Kontakta din administratör.",
  configurationErrorTitle: "Konfigurationsproblem",
  noStudentObjectTitle: "Inget schema kopplat",
  somethingWentWrong: "Något gick fel"
}, ml = {
  en: MU,
  sv: kU
}, El = "en";
let ve = ml[El];
function Dz() {
  return {
    no_preference: ve.noPreference,
    morning: ve.morning,
    afternoon: ve.afternoon
  };
}
function Mz(e) {
  return xD.validate(e) ? (ve = ml[e], { translations: ve, currentLanguage: e }) : (ve = ml[El], { translations: ve, currentLanguage: El });
}
function jU(e, t) {
  return e instanceof t || e instanceof Error && e.name === t.errorName;
}
function qr(e, t) {
  return !!bb(e)[t];
}
function Lz(e) {
  switch (qn(e)) {
    case le.NoStudentObjectError:
    case le.PacemakerFetchError:
      return "warn";
    default:
      return "error";
  }
}
function xz(e) {
  switch (e.kind) {
    case "failedGroups": {
      const { failedGroups: t } = e;
      let r = le.Error, n;
      return Object.keys(t).forEach((i) => {
        var l, f, u, h;
        const o = (l = t[i]) == null ? void 0 : l.find(
          (E) => M(E.reasons) && (M(E.reasons.failsWithMessage) || M(E.reasons.failsWithGroups))
        ), s = (u = (f = o == null ? void 0 : o.reasons) == null ? void 0 : f.failsWithMessage) == null ? void 0 : u.systemError;
        if (M(s)) {
          const E = Object.values(s)[0];
          M(E) && (n = E.message, r = E.name);
          return;
        }
        const a = (h = o == null ? void 0 : o.reasons) == null ? void 0 : h.failsWithGroups;
        M(a) && (n = Object.keys(a)[0]);
      }), Bm(r, n, e.logId);
    }
    case "error": {
      const t = qn(e.error), r = es(e.error), n = Ab(e.error, t, r), i = eU(e.error);
      return Bm(
        // A MultiError only counts as a known error when all its causes agree
        t === le.MultiError ? n.errorName : e.error,
        Dt(e.error),
        $e(i) ? i[0] : i
      );
    }
    case "partialFailure":
      return FU(e.failure, e.logId);
    default:
      return Et();
  }
}
function Bm(e, t, r) {
  return UU(e, r) ?? $U(t) ?? Ib(t, r);
}
function UU(e, t) {
  if (qr(e, le.HeavyLoadError))
    return {
      title: ve.highDemandErrorTitle,
      text: ve.pleaseTryAgain,
      knownError: !0,
      logId: void 0
    };
  if (qr(e, le.PermissionError))
    return {
      title: "Permission Error",
      text: ve.noPermission,
      knownError: !0,
      logId: t
    };
  if (qr(e, le.AddWaitlistError))
    return {
      title: ve.addWaitlistErrorTitle,
      text: ve.pleaseTryAgain,
      knownError: !0,
      logId: t
    };
  if (qr(e, le.NoStudentObjectError))
    return {
      title: ve.noStudentObjectTitle,
      text: ve.noStudentObject,
      knownError: !0,
      logId: void 0
    };
  if (qr(e, le.AdminConfigurationError) || qr(e, le.StudentSetGroupConfigurationError))
    return {
      title: ve.configurationErrorTitle,
      text: ve.configurationErrorText,
      knownError: !0,
      logId: t
    };
  if (qr(e, le.MaximumMembershipReachedError) || qr(e, le.MaximumMembershipReachedByTypeError))
    return {
      title: ve.sizeErrorTitle,
      text: ve.sizeErrorText,
      knownError: !0,
      logId: void 0
    };
}
function $U(e) {
  return M(e) && GU(e) ? zU(e) : void 0;
}
function Ib(e, t) {
  return {
    title: ve.somethingWentWrong,
    // Nothing was said about why, so there is no server problem to point at.
    text: M(e) ? ve.defaultServerErrorMessage : ve.pleaseTryAgain,
    knownError: !1,
    logId: t
  };
}
function FU(e, t) {
  switch (e.reason) {
    case "Exams unexpected":
    case "Student assessment not enabled":
    case "Exams not found":
      return {
        title: ve.examsUnavailableTitle,
        text: ve.examsUnavailableText,
        knownError: !0,
        logId: t
      };
    case "Missing preferred groups":
      return {
        title: ve.preferredGroupsUnavailableTitle,
        text: ve.preferredGroupsUnavailableText,
        knownError: !0,
        logId: t
      };
    case "User object cache write failed":
    case "Unknown":
      return Ib(void 0, t);
    default:
      Et();
  }
}
function GU(e) {
  return e === "buffer" || e === "conflict" || e === "dedicated" || e === "dedicatedSize" || e === "doubleBooked" || e === "size" || e === "hidden" || e === "registrationPeriod";
}
function zU(e) {
  switch (e) {
    case "buffer":
    case "size":
      return {
        title: ve.sizeErrorTitle,
        text: ve.sizeErrorText,
        knownError: !0,
        logId: void 0
      };
    case "dedicated":
      return {
        title: ve.dedicatedErrorTitle,
        text: ve.dedicatedErrorText,
        knownError: !0,
        logId: void 0
      };
    // Double booked should never be an issue, but should cover the case if it does.
    case "doubleBooked":
      return {
        title: ve.doubleBookedErrorTitle,
        text: ve.doubleBookedErrorText,
        knownError: !0,
        logId: void 0
      };
    // Conflict should never be an issue, but should cover the case if it does.
    case "conflict":
      return {
        title: ve.conflictErrorTitle,
        text: ve.conflictErrorText,
        knownError: !0,
        logId: void 0
      };
    // Hidden should never be an issue, but should cover the case if it does.
    case "hidden":
      return {
        title: ve.hiddenErrorTitle,
        text: ve.hiddenErrorText,
        knownError: !0,
        logId: void 0
      };
    case "registrationPeriod":
      return {
        title: ve.registrationPeriodErrorTitle,
        text: ve.registrationPeriodErrorText,
        knownError: !0,
        logId: void 0
      };
    default:
      return Et();
  }
}
function kz() {
  const e = /* @__PURE__ */ new Map();
  return {
    add({ reason: t, error: r, subject: n }) {
      let i = e.get(t);
      if (!M(i)) {
        const o = M(r) ? sU(r) : void 0;
        i = {
          failure: {
            reason: t,
            status: o == null ? void 0 : o.code,
            error: M(o) ? { message: o.message, errorName: o.errorName } : void 0
          },
          subjects: /* @__PURE__ */ new Set()
        }, e.set(t, i);
      }
      M(n) && i.subjects.add(n);
    },
    get store() {
      const t = [...e.values()].map(
        ({ failure: n, subjects: i }) => i.size > 0 ? { ...n, subjects: [...i] } : n
      ), r = BU(t);
      return {
        hasFailures: t.length > 0,
        failures: t,
        // Left out rather than reported as empty. Claiming nothing was
        // affected is not the same as not knowing what was.
        subjects: r.length > 0 ? r : void 0,
        totalAffectedSubjects: r.length > 0 ? r.length : void 0
      };
    }
  };
}
function BU(e) {
  const t = /* @__PURE__ */ new Set();
  for (const r of e)
    for (const n of r.subjects ?? [])
      t.add(n);
  return [...t];
}
var Os = { exports: {} }, VU = Os.exports, Vm;
function _b() {
  return Vm || (Vm = 1, (function(e, t) {
    (function(r, n) {
      e.exports = n();
    })(VU, (function() {
      var r = 1e3, n = 6e4, i = 36e5, o = "millisecond", s = "second", a = "minute", l = "hour", f = "day", u = "week", h = "month", E = "quarter", d = "year", g = "date", y = "Invalid Date", b = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, _ = /\[([^\]]+)]|YYYY|YY|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, I = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: function(q) {
        var x = ["th", "st", "nd", "rd"], B = q % 100;
        return "[" + q + (x[(B - 20) % 10] || x[B] || x[0]) + "]";
      } }, w = function(q, x, B) {
        var Z = String(q);
        return !Z || Z.length >= x ? q : "" + Array(x + 1 - Z.length).join(B) + q;
      }, L = { s: w, z: function(q) {
        var x = -q.utcOffset(), B = Math.abs(x), Z = Math.floor(B / 60), G = B % 60;
        return (x <= 0 ? "+" : "-") + w(Z, 2, "0") + ":" + w(G, 2, "0");
      }, m: function q(x, B) {
        if (x.date() < B.date()) return -q(B, x);
        var Z = 12 * (B.year() - x.year()) + (B.month() - x.month()), G = x.clone().add(Z, h), Q = B - G < 0, K = x.clone().add(Z + (Q ? -1 : 1), h);
        return +(-(Z + (B - G) / (Q ? G - K : K - G)) || 0);
      }, a: function(q) {
        return q < 0 ? Math.ceil(q) || 0 : Math.floor(q);
      }, p: function(q) {
        return { M: h, y: d, w: u, d: f, D: g, h: l, m: a, s, ms: o, Q: E }[q] || String(q || "").toLowerCase().replace(/s$/, "");
      }, u: function(q) {
        return q === void 0;
      } }, R = "en", D = {};
      D[R] = I;
      var P = "$isDayjsObject", O = function(q) {
        return q instanceof V || !(!q || !q[P]);
      }, F = function q(x, B, Z) {
        var G;
        if (!x) return R;
        if (typeof x == "string") {
          var Q = x.toLowerCase();
          D[Q] && (G = Q), B && (D[Q] = B, G = Q);
          var K = x.split("-");
          if (!G && K.length > 1) return q(K[0]);
        } else {
          var ee = x.name;
          D[ee] = x, G = ee;
        }
        return !Z && G && (R = G), G || !Z && R;
      }, U = function(q, x) {
        if (O(q)) return q.clone();
        var B = typeof x == "object" ? x : {};
        return B.date = q, B.args = arguments, new V(B);
      }, z = L;
      z.l = F, z.i = O, z.w = function(q, x) {
        return U(q, { locale: x.$L, utc: x.$u, x: x.$x, $offset: x.$offset });
      };
      var V = (function() {
        function q(B) {
          this.$L = F(B.locale, null, !0), this.parse(B), this.$x = this.$x || B.x || {}, this[P] = !0;
        }
        var x = q.prototype;
        return x.parse = function(B) {
          this.$d = (function(Z) {
            var G = Z.date, Q = Z.utc;
            if (G === null) return /* @__PURE__ */ new Date(NaN);
            if (z.u(G)) return /* @__PURE__ */ new Date();
            if (G instanceof Date) return new Date(G);
            if (typeof G == "string" && !/Z$/i.test(G)) {
              var K = G.match(b);
              if (K) {
                var ee = K[2] - 1 || 0, ne = (K[7] || "0").substring(0, 3);
                return Q ? new Date(Date.UTC(K[1], ee, K[3] || 1, K[4] || 0, K[5] || 0, K[6] || 0, ne)) : new Date(K[1], ee, K[3] || 1, K[4] || 0, K[5] || 0, K[6] || 0, ne);
              }
            }
            return new Date(G);
          })(B), this.init();
        }, x.init = function() {
          var B = this.$d;
          this.$y = B.getFullYear(), this.$M = B.getMonth(), this.$D = B.getDate(), this.$W = B.getDay(), this.$H = B.getHours(), this.$m = B.getMinutes(), this.$s = B.getSeconds(), this.$ms = B.getMilliseconds();
        }, x.$utils = function() {
          return z;
        }, x.isValid = function() {
          return this.$d.toString() !== y;
        }, x.isSame = function(B, Z) {
          var G = U(B);
          return this.startOf(Z) <= G && G <= this.endOf(Z);
        }, x.isAfter = function(B, Z) {
          return U(B) < this.startOf(Z);
        }, x.isBefore = function(B, Z) {
          return this.endOf(Z) < U(B);
        }, x.$g = function(B, Z, G) {
          return z.u(B) ? this[Z] : this.set(G, B);
        }, x.unix = function() {
          return Math.floor(this.valueOf() / 1e3);
        }, x.valueOf = function() {
          return this.$d.getTime();
        }, x.startOf = function(B, Z) {
          var G = this, Q = !!z.u(Z) || Z, K = z.p(B), ee = function(Fe, _e) {
            var Le = z.w(G.$u ? Date.UTC(G.$y, _e, Fe) : new Date(G.$y, _e, Fe), G);
            return Q ? Le : Le.endOf(f);
          }, ne = function(Fe, _e) {
            return z.w(G.toDate()[Fe].apply(G.toDate("s"), (Q ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(_e)), G);
          }, re = this.$W, Ae = this.$M, ge = this.$D, Ne = "set" + (this.$u ? "UTC" : "");
          switch (K) {
            case d:
              return Q ? ee(1, 0) : ee(31, 11);
            case h:
              return Q ? ee(1, Ae) : ee(0, Ae + 1);
            case u:
              var We = this.$locale().weekStart || 0, Ue = (re < We ? re + 7 : re) - We;
              return ee(Q ? ge - Ue : ge + (6 - Ue), Ae);
            case f:
            case g:
              return ne(Ne + "Hours", 0);
            case l:
              return ne(Ne + "Minutes", 1);
            case a:
              return ne(Ne + "Seconds", 2);
            case s:
              return ne(Ne + "Milliseconds", 3);
            default:
              return this.clone();
          }
        }, x.endOf = function(B) {
          return this.startOf(B, !1);
        }, x.$set = function(B, Z) {
          var G, Q = z.p(B), K = "set" + (this.$u ? "UTC" : ""), ee = (G = {}, G[f] = K + "Date", G[g] = K + "Date", G[h] = K + "Month", G[d] = K + "FullYear", G[l] = K + "Hours", G[a] = K + "Minutes", G[s] = K + "Seconds", G[o] = K + "Milliseconds", G)[Q], ne = Q === f ? this.$D + (Z - this.$W) : Z;
          if (Q === h || Q === d) {
            var re = this.clone().set(g, 1);
            re.$d[ee](ne), re.init(), this.$d = re.set(g, Math.min(this.$D, re.daysInMonth())).$d;
          } else ee && this.$d[ee](ne);
          return this.init(), this;
        }, x.set = function(B, Z) {
          return this.clone().$set(B, Z);
        }, x.get = function(B) {
          return this[z.p(B)]();
        }, x.add = function(B, Z) {
          var G, Q = this;
          B = Number(B);
          var K = z.p(Z), ee = function(Ae) {
            var ge = U(Q);
            return z.w(ge.date(ge.date() + Math.round(Ae * B)), Q);
          };
          if (K === h) return this.set(h, this.$M + B);
          if (K === d) return this.set(d, this.$y + B);
          if (K === f) return ee(1);
          if (K === u) return ee(7);
          var ne = (G = {}, G[a] = n, G[l] = i, G[s] = r, G)[K] || 1, re = this.$d.getTime() + B * ne;
          return z.w(re, this);
        }, x.subtract = function(B, Z) {
          return this.add(-1 * B, Z);
        }, x.format = function(B) {
          var Z = this, G = this.$locale();
          if (!this.isValid()) return G.invalidDate || y;
          var Q = B || "YYYY-MM-DDTHH:mm:ssZ", K = z.z(this), ee = this.$H, ne = this.$m, re = this.$M, Ae = G.weekdays, ge = G.months, Ne = G.meridiem, We = function(_e, Le, De, Re) {
            return _e && (_e[Le] || _e(Z, Q)) || De[Le].slice(0, Re);
          }, Ue = function(_e) {
            return z.s(ee % 12 || 12, _e, "0");
          }, Fe = Ne || function(_e, Le, De) {
            var Re = _e < 12 ? "AM" : "PM";
            return De ? Re.toLowerCase() : Re;
          };
          return Q.replace(_, (function(_e, Le) {
            return Le || (function(De) {
              switch (De) {
                case "YY":
                  return String(Z.$y).slice(-2);
                case "YYYY":
                  return z.s(Z.$y, 4, "0");
                case "M":
                  return re + 1;
                case "MM":
                  return z.s(re + 1, 2, "0");
                case "MMM":
                  return We(G.monthsShort, re, ge, 3);
                case "MMMM":
                  return We(ge, re);
                case "D":
                  return Z.$D;
                case "DD":
                  return z.s(Z.$D, 2, "0");
                case "d":
                  return String(Z.$W);
                case "dd":
                  return We(G.weekdaysMin, Z.$W, Ae, 2);
                case "ddd":
                  return We(G.weekdaysShort, Z.$W, Ae, 3);
                case "dddd":
                  return Ae[Z.$W];
                case "H":
                  return String(ee);
                case "HH":
                  return z.s(ee, 2, "0");
                case "h":
                  return Ue(1);
                case "hh":
                  return Ue(2);
                case "a":
                  return Fe(ee, ne, !0);
                case "A":
                  return Fe(ee, ne, !1);
                case "m":
                  return String(ne);
                case "mm":
                  return z.s(ne, 2, "0");
                case "s":
                  return String(Z.$s);
                case "ss":
                  return z.s(Z.$s, 2, "0");
                case "SSS":
                  return z.s(Z.$ms, 3, "0");
                case "Z":
                  return K;
              }
              return null;
            })(_e) || K.replace(":", "");
          }));
        }, x.utcOffset = function() {
          return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
        }, x.diff = function(B, Z, G) {
          var Q, K = this, ee = z.p(Z), ne = U(B), re = (ne.utcOffset() - this.utcOffset()) * n, Ae = this - ne, ge = function() {
            return z.m(K, ne);
          };
          switch (ee) {
            case d:
              Q = ge() / 12;
              break;
            case h:
              Q = ge();
              break;
            case E:
              Q = ge() / 3;
              break;
            case u:
              Q = (Ae - re) / 6048e5;
              break;
            case f:
              Q = (Ae - re) / 864e5;
              break;
            case l:
              Q = Ae / i;
              break;
            case a:
              Q = Ae / n;
              break;
            case s:
              Q = Ae / r;
              break;
            default:
              Q = Ae;
          }
          return G ? Q : z.a(Q);
        }, x.daysInMonth = function() {
          return this.endOf(h).$D;
        }, x.$locale = function() {
          return D[this.$L];
        }, x.locale = function(B, Z) {
          if (!B) return this.$L;
          var G = this.clone(), Q = F(B, Z, !0);
          return Q && (G.$L = Q), G;
        }, x.clone = function() {
          return z.w(this.$d, this);
        }, x.toDate = function() {
          return new Date(this.valueOf());
        }, x.toJSON = function() {
          return this.isValid() ? this.toISOString() : null;
        }, x.toISOString = function() {
          return this.$d.toISOString();
        }, x.toString = function() {
          return this.$d.toUTCString();
        }, q;
      })(), ae = V.prototype;
      return U.prototype = ae, [["$ms", o], ["$s", s], ["$m", a], ["$H", l], ["$W", f], ["$M", h], ["$y", d], ["$D", g]].forEach((function(q) {
        ae[q[1]] = function(x) {
          return this.$g(x, q[0], q[1]);
        };
      })), U.extend = function(q, x) {
        return q.$i || (q(x, V, U), q.$i = !0), U;
      }, U.locale = F, U.isDayjs = O, U.unix = function(q) {
        return U(1e3 * q);
      }, U.en = D[R], U.Ls = D, U.p = {}, U;
    }));
  })(Os)), Os.exports;
}
var WU = _b();
const Ur = /* @__PURE__ */ Vc(WU);
function Rb(e) {
  return M(e) ? `${e}` : "";
}
function jz(e) {
  return M(e) ? e.length : 0;
}
function $r(e) {
  return M(e) ? !Xn(e) : !1;
}
function Xn(e) {
  return M(e) ? e.length === 0 : !1;
}
function Uz(e) {
  return `${e.charAt(0).toUpperCase()}${e.substring(1).toLowerCase()}`;
}
function Ra(e, t) {
  return e.filter($r).join(t);
}
function $z(e, t) {
  const r = M(t) ? t : 40;
  return e.length > r ? `${e.substring(0, r)}...` : e;
}
function Fz(e) {
  return e.replace(/[\r\n]+/gm, " ");
}
const Wm = (e) => Xn(e) ? 1 : 0;
function Gz(e, t) {
  return Wm(e) - Wm(t);
}
function zz(e, ...t) {
  if (!M(e)) return "";
  if (Bn(t))
    for (let r = 0, n = t.length; r < n; r++) {
      const i = t[r];
      M(i) && (e = e.replaceAll(`{${r}}`, i.toString()));
    }
  return e;
}
const qU = 1e4, Bz = 1440 * 60;
function Vz(e = 0) {
  return Math.round(e / 1e3);
}
function Wz(e) {
  return e.getHours() === 0 && e.getMinutes() === 0 || e.getHours() === 23 && e.getMinutes() === 59;
}
function qm(e, t) {
  return e.getFullYear() === t.getFullYear() && e.getMonth() === t.getMonth() && e.getDate() === t.getDate();
}
function qz(e, t) {
  return Math.abs(e.startOf("day").diff(t.startOf("day"), "day"));
}
function Hz(e, t) {
  return Ym(e) !== Ym(t);
}
function Yz(e, t) {
  return qm(e, t.start) || qm(e, t.end) ? !0 : HU(e, t);
}
function HU(e, t) {
  return t.start.getTime() <= e.getTime() && e.getTime() <= t.end.getTime();
}
function Zz(e) {
  return M(e) ? e.local.replace("00:00:00", "").trim() : "";
}
function Hm(e, t) {
  return Ur(dc(e, t).local).format("HH:mm");
}
function Jz(e, t) {
  return Ur(dc(e, t).local).format("ddd MMM D");
}
function Ym(e) {
  return Ur(e.local).format("YYYY-MM-DD");
}
function Kz(e, t, r) {
  return `${Hm(e, r)} - ${Hm(t, r)}`;
}
function Xz(e, t) {
  return `${Zm(e)} - ${Zm(t)}`;
}
function Zm(e) {
  return Ur(e.local).format("MMM D, HH:mm");
}
function YU(e) {
  return Ur(e.local).format("D MMM YYYY");
}
function gl(e) {
  return Ur(e.local).format("HH:mm");
}
function Qz(e, t) {
  return `${gl(e)} - ${gl(t)}`;
}
function e4(e) {
  return `${YU(e)}, ${gl(e)}`;
}
function t4(e) {
  return !M(e) || Xn(e) ? "" : ZU(KU(e)) + " " + JU(e);
}
function ZU(e) {
  if (!M(e) || Xn(e)) return "";
  const [t, r, n] = e.split(/[/-]/);
  return `${n}-${r}-${t}`;
}
function JU(e) {
  if (!M(e) || Xn(e)) return "";
  const t = e.split(" ")[1];
  return M(t) ? t.substring(0, 5) : "";
}
function KU(e) {
  return !M(e) || Xn(e) ? "" : e.split(" ")[0] ?? "";
}
const XU = (e, t, r, n) => {
  if (!e || !t) return Mr.enum.not_set;
  const i = Hs(e, r);
  if (!i.success)
    return Mr.enum.not_set;
  const o = Hs(t, r);
  return o.success ? !!i.data.unix && !!o.data.unix && i.data.unix < n && n < o.data.unix ? Mr.enum.open : Mr.enum.closed : Mr.enum.not_set;
}, Ni = {
  local: "1970-01-01 00:00:00",
  timezone: "Europe/Berlin",
  unix: 1
};
function Jm(e) {
  return Ni.unix !== e;
}
function Km(e, t) {
  const r = Hs(e, t);
  return r.success ? r.data : Ni;
}
const jn = /* @__PURE__ */ new Map();
function QU(e) {
  return typeof e == "string" || typeof e == "number" || typeof e == "object" && e !== null;
}
const Xm = /* @__PURE__ */ new WeakMap();
let e2 = 0;
function t2(e) {
  let t = Xm.get(e);
  return M(t) || (t = e2++, Xm.set(e, t)), t;
}
function r2(e, t) {
  const r = typeof e == "object" ? t2(e) : e;
  return `${t}\0${typeof e}\0${r}`;
}
function Hs(e, t) {
  if (!QU(e))
    return Lh(t).safeParse(e);
  const r = r2(e, t), n = jn.get(r);
  if (M(n))
    return n;
  const i = Lh(t).safeParse(e);
  if (jn.size >= qU) {
    const o = jn.keys().next().value;
    M(o) && jn.delete(o);
  }
  return jn.set(r, i), i;
}
function r4() {
  return jn.size;
}
function n4() {
  jn.clear();
}
function n2({
  event: e,
  currentStart: t,
  currentEnd: r
}) {
  let n = t, i = r;
  return e.start.unix < n.unix && (n = e.start), e.end.unix > i.unix && (i = e.end), {
    start: n,
    end: i
  };
}
function i4({
  date: e,
  timezone: t,
  timezoneLabel: r,
  legacyTimestamp: n = ""
}) {
  if (e) {
    const i = e instanceof Date ? e : new Date(e), o = Math.floor(i.getTime() / 1e3), s = Hs(o, t);
    if (s.success) {
      const a = s.data.local;
      return r ? `${a} (${r})` : a;
    }
    return n;
  }
  return n;
}
function o4(e, t) {
  return e && t ? `${Ur(e).format("HH:mm")} – ${Ur(t).format("HH:mm")}` : "";
}
const s4 = "2024-08-05";
function Qm({
  events: e
}) {
  let t = { unix: 1 / 0, local: "" }, r = { unix: -1 / 0, local: "" };
  for (const n in e) {
    const i = e[n];
    if (!M(i) || !Jm(i.start.unix) || !Jm(i.end.unix)) continue;
    const o = n2({
      event: i,
      currentStart: t,
      currentEnd: r
    });
    t = o.start, r = o.end;
  }
  return { start: t, end: r };
}
function i2({
  events: e,
  studentSetGroupSet: t
}) {
  return t.size === 0 ? e : e.filter((r) => t.has(r.groupId));
}
function a4({
  registration: e,
  studentSetGroupIds: t
}) {
  const r = new Set(t), n = i2({
    events: e.events,
    studentSetGroupSet: r
  });
  if (n.length === 0) {
    const o = Qm({
      events: e.events
    });
    if (eE(o))
      return {
        min: o.start,
        max: o.end
      };
  }
  const i = Qm({
    events: n
  });
  return eE(i) ? {
    min: i.start,
    max: i.end
  } : {
    min: Ni,
    max: Ni
  };
}
function eE(e) {
  return e.start.unix !== 1 / 0 && e.end.unix !== -1 / 0;
}
var No = {}, tE;
function o2() {
  if (tE) return No;
  tE = 1, Object.defineProperty(No, "__esModule", { value: !0 }), No.EAppEnv = void 0;
  var e;
  return (function(t) {
    t.BETA = "beta", t.STAGING = "staging", t.TEST = "test", t.PRODUCTION = "production", t.DEVELOPMENT = "development";
  })(e || (No.EAppEnv = e = {})), No;
}
var Ze = o2();
class xo extends Error {
}
xo.prototype.name = "InvalidTokenError";
function s2(e) {
  return decodeURIComponent(atob(e).replace(/(.)/g, (t, r) => {
    let n = r.charCodeAt(0).toString(16).toUpperCase();
    return n.length < 2 && (n = "0" + n), "%" + n;
  }));
}
function a2(e) {
  let t = e.replace(/-/g, "+").replace(/_/g, "/");
  switch (t.length % 4) {
    case 0:
      break;
    case 2:
      t += "==";
      break;
    case 3:
      t += "=";
      break;
    default:
      throw new Error("base64 string is not of the correct length");
  }
  try {
    return s2(t);
  } catch {
    return atob(t);
  }
}
function u2(e, t) {
  if (typeof e != "string")
    throw new xo("Invalid token specified: must be a string");
  t || (t = {});
  const r = t.header === !0 ? 0 : 1, n = e.split(".")[r];
  if (typeof n != "string")
    throw new xo(`Invalid token specified: missing part #${r + 1}`);
  let i;
  try {
    i = a2(n);
  } catch (o) {
    throw new xo(`Invalid token specified: invalid base64 for part #${r + 1} (${o.message})`);
  }
  try {
    return JSON.parse(i);
  } catch (o) {
    throw new xo(`Invalid token specified: invalid json for part #${r + 1} (${o.message})`);
  }
}
var gi = Sb();
const l2 = {
  [gi.ERegion.EU_EES]: "eu",
  [gi.ERegion.ANZ]: "anz",
  [gi.ERegion.SGP]: "sgp",
  [gi.ERegion.UK]: "uk"
}, yi = "|_REGION_|", c2 = (e, t) => {
  let r = e;
  if (M(t) && (r = e.replace(yi, l2[t])), r.includes(yi))
    throw new Error(
      `The URL '${r}' still contains the region placeholder: review the inputs to 'replaceRegionPlaceholder'.`
    );
  return r;
}, u4 = (e, t = console) => {
  if (e)
    try {
      const r = u2(e), { region: n } = zy.parse(r);
      return n;
    } catch (r) {
      t.error(r);
      return;
    }
}, f2 = (e, t, r) => {
  switch (t) {
    case Ze.EAppEnv.BETA:
      return `${r ? "wss" : "https"}://${e}.${yi}.timeedit.dev`;
    case Ze.EAppEnv.STAGING:
      return `${r ? "wss" : "https"}://${e}.${yi}.timeedit.io`;
    case Ze.EAppEnv.TEST:
      return `${r ? "wss" : "https"}://${e}.${yi}.test.timeedit.net`;
    case Ze.EAppEnv.PRODUCTION:
      return `${r ? "wss" : "https"}://${e}.${yi}.timeedit.net`;
    default:
      throw new Error(
        `Can't get regional Url. Not a valid environment: ${t}`
      );
  }
}, l4 = ({
  environment: e,
  region: t,
  subdomain: r,
  localPort: n = 5173,
  websocket: i
}) => {
  if (t && e !== Ze.EAppEnv.DEVELOPMENT) {
    const s = f2(
      r,
      e,
      i
    );
    return c2(s, t);
  }
  if (typeof window > "u")
    throw new Error(
      "window is undefined. getRegionalUrlForEnv is not usable in a non-browser environment"
    );
  const o = `http://${window.location.hostname || "localhost"}:${n}`;
  return i ? o.replace("http", "ws") : o;
};
function Lr(e) {
  return e.replace(/^cloud_/, "");
}
function d2(e) {
  return e.replace(/^\//, "");
}
function c4(e, t) {
  const r = d2(t);
  return M(e) && !r.startsWith(
    `${Lr(e)}`
  ) ? `/${Lr(
    e
  )}/${r}` : t;
}
function f4(e) {
  return e.replace(/^\/?\w+[^/]*\//, "/");
}
function d4(e) {
  if (e === Ze.EAppEnv.BETA) return "https://allocate.timeedit.dev/";
  if (e === Ze.EAppEnv.STAGING) return "https://allocate.timeedit.io/";
  if (e === Ze.EAppEnv.TEST) return "https://allocate.test.timeedit.net/";
  if (e === Ze.EAppEnv.PRODUCTION) return "https://allocate.timeedit.net/";
  if (e === Ze.EAppEnv.DEVELOPMENT) return "http://localhost:5174/";
  throw new Error(`Invalid environment: ${e}`);
}
function p4(e, t) {
  switch (e) {
    case Ze.EAppEnv.BETA:
      return `https://cloud.timeedit.dev/${Lr(
        t
      )}/web`;
    case Ze.EAppEnv.STAGING:
      return `https://cloud.timeedit.io/${Lr(
        t
      )}/web`;
    case Ze.EAppEnv.TEST:
      return `https://cloud.test.timeedit.net/${Lr(
        t
      )}/web`;
    case Ze.EAppEnv.PRODUCTION:
      return `https://cloud.timeedit.net/${Lr(
        t
      )}/web`;
    case Ze.EAppEnv.DEVELOPMENT:
      return `https://cloud.timeedit.dev/${Lr(
        t
      )}/web`;
    default:
      Et();
  }
}
function p2(e) {
  switch (e) {
    case Ze.EAppEnv.BETA:
      return "timeedit.dev";
    case Ze.EAppEnv.STAGING:
      return "timeedit.io";
    case Ze.EAppEnv.TEST:
      return "test.timeedit.net";
    case Ze.EAppEnv.PRODUCTION:
      return "timeedit.net";
    case Ze.EAppEnv.DEVELOPMENT:
      return "localhost";
    default:
      Et();
  }
}
function h4(e, t) {
  return t ? e === Ze.EAppEnv.DEVELOPMENT ? `http://localhost:3004/${Lr(
    t
  )}` : `https://admin.${p2(e)}/${Lr(
    t
  )}` : "";
}
const m4 = (e) => {
  if (!e || Xn(e)) return !1;
  try {
    const t = new URL(e);
    return t.protocol === "http:" || t.protocol === "https:";
  } catch {
    return !1;
  }
}, h2 = [
  8364,
  0,
  8218,
  402,
  8222,
  8230,
  8224,
  8225,
  710,
  8240,
  352,
  8249,
  338,
  0,
  381,
  0,
  0,
  8216,
  8217,
  8220,
  8221,
  8226,
  8211,
  8212,
  732,
  8482,
  353,
  8250,
  339,
  0,
  382,
  376
];
function Ob(e) {
  return e === 0 || e >= 55296 && e <= 57343 || e > 1114111;
}
function m2(e) {
  return Ob(e) ? 65533 : e >= 128 && e <= 159 && h2[e - 128] || e;
}
function E2(e) {
  return Ob(e) ? 65533 : e;
}
const rr = /* @__PURE__ */ (() => {
  const e = new Uint8Array(127);
  let t = 0;
  for (let r = 33; r <= 126; r++)
    r !== 34 && r !== 36 && r !== 92 && (e[r] = t++);
  return e;
})();
function g2(e, t, r, n, i, o) {
  const a = e.length, l = o * 90;
  let f = 0;
  const u = () => {
    const F = rr[e.charCodeAt(f++)];
    return F < o ? F : F * 91 - l + rr[e.charCodeAt(f++)];
  }, h = r - n, E = r + i, d = new Int32Array(E);
  d.fill(-1, n, o), d.fill(-1, o + h, E);
  const g = new Int32Array(E), y = new Int32Array(E);
  function b(F, U) {
    let z = 0, V = U;
    const ae = U + F;
    for (; V < ae; ) {
      const q = rr[e.charCodeAt(f++)];
      if (q < 89)
        z += q, d[V++] = z;
      else if (q === 89) {
        let x = rr[e.charCodeAt(f++)] + 2;
        for (; x--; )
          d[V++] = ++z;
      } else {
        const x = rr[e.charCodeAt(f++)];
        z += 89 + // eslint-disable-next-line unicorn/prefer-minimal-ternary -- branches read a different number of side-effecting input bytes
        (x < 90 ? x * 91 + rr[e.charCodeAt(f++)] : rr[e.charCodeAt(f++)] * 8281 + rr[e.charCodeAt(f++)] * 91 + rr[e.charCodeAt(f++)]), d[V++] = z;
      }
    }
  }
  b(n, 0), b(h, o);
  const _ = new Int32Array(i * 2);
  let I = 0, w = 0;
  function L(F, U) {
    for (let z = 0; z < F; z++) {
      const V = U + z, ae = u(), q = u();
      _[w * 2] = ae, _[w * 2 + 1] = q, w += 1, g[V] = I;
      const x = (d[ae] < 0 ? y[ae] : 1) + (d[q] < 0 ? y[q] : 1);
      y[V] = x, I += x;
    }
  }
  L(i - o + n, o + h), L(o - n, n);
  const R = new Uint16Array(I);
  let D = 0;
  for (let F = 0; F < w; F++)
    for (let U = 0; U < 2; U++) {
      const z = _[F * 2 + U], V = d[z];
      if (V < 0) {
        let ae = g[z];
        const q = ae + y[z];
        for (; ae < q; )
          R[D++] = R[ae++];
      } else
        R[D++] = V;
    }
  const P = new Uint16Array(t);
  let O = 0;
  for (; f < a; ) {
    let F = rr[e.charCodeAt(f++)];
    F >= o && (F = F * 91 - l + rr[e.charCodeAt(f++)]);
    const U = d[F];
    if (U < 0) {
      let z = g[F];
      const V = z + y[F];
      for (; z < V; )
        P[O++] = R[z++];
    } else
      P[O++] = U;
  }
  return P;
}
const y2 = /* @__PURE__ */ g2("!}.&u%}'&}*'~!6*)%&,~!J~!J~%L~y<~!R,~~%Lu~~#GD~~#|)1#%}^%}2%+#.##%##%}&%##%'#%##&%#%#'%#&#%#&#'#%%#&#%##%#)%''%&%#%#'%#%%#%%}%%%#%#&(23#%%#&-%0%('1#(##%#'##+%'*.:1}#%#6-+(%'%%#%%%}#L'2351&('%}&/N'(0(/*-%(%%}#'+&T%7.2}#&%&#%#36/5##%&%%#&#%%#))2%%##%&&'0~!#*+&'%1~!%).'3q?&%'1~!.##%6(~!+%%%(Gw'rT~!E#<nA%#jZ~!H%(~!42##~!*31&~!G%U~#)5~#`3~!J~!Z~%]~%Y~%C~!q~!u~#kz~%#~!6'~!D~!U~!?~#T~!c%~!G#'~%7|~!G~!J~!G&~#pb~(Df}#%}*&}#%##%##%##&#-}&'#'&%#.++}%mI,#,@&(}*%}*'%&##&#%##%}&0}#.},U},%}+%}&%}#%##&}B%(}(%}+%)})%##%#&}&%##%&}<%}>%#%&}*%}(%}9%}/%})%}*%}*%}?&}&%}3%}&*#%})%#%#)}#&#-#+*%E%%'%'#%}#*V##&##I}#&&##%&%#&&Qf%%))w/0+&%#(#.%-''''++++7}>%4'',##1,#%#&%##&#'##&#*#9)%&%}#*}%,#+P(%A&%#'&##wSD',9E00#y#@}(+}&%&>~!#~!X}#*}(&&}(&}(,%}%&#+&}#&}I%#%}%)#(},'%#*}4%%#%}(''}#/##(##),%-##%%)#&}(.}&%#&}%%}*&#%},&&}&%}#%*'#%})%}D&}&%}-&}6&#&}-,%}#%})-(~+`~,=?~I9'9%~!,#%})%})%}@%}?%}(~!?~#<~#pP~#BG~#=1#%K+~#?#~%;)~#A~#mF1~#A'~'X%'~#lR~#N~'N~#r~#m#-~#i'?%#'%~#B%##%,%#~#_%#0%~#]732~,w~2+#:&#%&'0%&>%}#>##F+)#%&&#(+_}4&}-%}(&}@&}O7Fdf0@+/v4}&WU##&/0#&'('B#%}.%}'+#%}#%%&#&%#%##+#&#)#6#'#.},%}c%},%#%##%&#&%#&~#>'*-.%##%##%}#%%}%'~#)D1}#%*&~#_%%'(~#S2%'.}#~#=##*'*-%}&'%'##&&~'E%.#&~#M4}%%##&'%#~#O1##%&#'+~#<B%##%%'%+~#;#@%}#&%#&&%#(~#H1}'%'##&&~#?A}&'~#D#%32}'&&&&~#[}'(#%}'~#;C})&}%%#%~#=&%,3}%'(#%%~#^'#&&)#%'~#Y%-~#d-%'~#^%%&#&&&}#~#b~2t*&'~&(~&@~0%~e~3}%*''0})&}+~!9##-}#%-hD*)1fC#%/&/fB#40~!+#)*4~!+~!K'&:~!/*7~!.#~!H~!L':~%x&~!H#~!*~%1~!I#~!+A~#p'~!F~~#-#~,,(~.Z~!V~%;'B'mq-W~!N~%I%#&&#&}#%},%%}'%}+X#%}#&}(%}'%}<%}#%}%%'}'%}:~![)9@~%>~#UA%-%##&~!C%~!-.9:~!1~!-^2/:a~!y,D*J#-5)/4~%23,~#G~!L1~!0X3`~!2+~!!0-~&E~!W~!o,>Y&]~%cZx_&~#O*9#A#'#+I'%#)~!0B*-5A+-((F&*M#)(-7-5+'-3a5Vi~!Y~!?+[)%3),ERHm~!+:D,VG.+)?fB%%*(%)'(#&80%1'8`K8?`+'Z#&O&'H5#*9)A%%5&3))0%39+.*7#()&&*=4@**L)<'_&*+..;(#*+)./&0#3)%')-8(4ixD(&.}%,('aI:,)%,k2231T)I'#/-W7,/'Q#.'Y24+h')37</31&83##&0#),H(?'&?/1##%#&&#%''-%&&&#(&''&#.-'%#%%(,')*'&#&#'##%(%(#%('#&##%%%%('%#%#%%#%#&%##h>w+v<ayvyvcg.uuhKr}g/v|g>u9i[~>g5uI~=RvdwEg;v/g;uk!!TTSx]@RT!U!#!@VBRUU!'UTe-d0c`e&gSdicedFcrdTaqb.kYcAohdYd@a3e+d}dMdtd.aJ#bqcK`dle/e.e'dwdPdodddjbEb}ogd^ofdpduc6j?l%d{drdqc)d7bacOdQ%T#Y)X.sR[yH>6Vyv3[xwLu>vo'!*.[yBacahoj>6Rew3[xqdZa#!a&#^(X-[yG>6Vyu3[xvg3sEr|g.u/Ri9db0T#^(Xa)!-[y;>6Vylg4wKs{JwNZt3@3r=c4Z([xlg;wKt!cpq's@v7A'*a(a+!-a#[y<3Dt?3Dt'>6Vym3[xmg9rxsNJwLZt4~?r?db1T#`-!(Xa,!0[yS>6Vz%NuQs.g4wKtnJwNZtS@3r>c4Z([y%g;wKtrdga8!a(!#&T*Y-Xa#!a0<or[yc3Dtq>6Vz43[y3JwNZtf@3s!Ju}!%Dti:pm3c_%X#tjB5pkd6q!r]u?voC'*-a.a2!0a&a+[yI3DtI3Ds~3DtH>6Vyw3[xx;:s#~<5pKJwNZtE@3r~d`a)!a2T#a.(!+U.X1[yT3Dt`3Dtv>6Vz&3[y&g9rxwzcxstPu.<rAJwLZtT~?r@dZa%!a.&^*Za(/Reu[ya>6Vz23[y1g3sEr}wkg{NuQRg{ci(U#5@b`~,cg#U(2WnH5wugcRh7dX#T(Y,a'Ta!!a,[yZ<]mj>6Vz,3[y+Pv#5ReZKu+=,%!H}7ABwkaS?Rh:BcW(X#<]mrj:ubv/ARekdg%!(!a.*Ta(Y.X1!#sP>Rl*Dt6[y>>6Vyo3Wf*jOvuumvuRgRJuq*!:9<B@bX~3jVv&v@s@5Re[d/rQt{uAvo&a&a*)a2!,0Wf!3Dt0=Bs'>6Re}3[xy~<5s%JwJZt1~Gs)c;&!#2sJkNuXvzq7rxu,Re8dka4!a8(aEZ+a@Y.X1Xa)[yd=Bs(3DtP>6Vz53[y4cX#X&Re:avRe9~<5s&JwJZtQ~Gs*i^rzvdRg+Jv{%!2sbB@bX}kdga,!Za?&^*T1/!a'Dt+[y6>6Vyf3Wf%g/u;s4hGu6?Rh-JvZ,!c%#&RoX54Rivj7uyvf8RgTKvZB%*!2sGh<vu5Rgq<=C::9bb~#dZ#T&Ta6Y.X*Dt>[y93Wf)coZ(T,6VyifluvRgC@95@B@bX~/hFu34cC#T,k/unq8w8Q5RkUklwQuzunq8w8Q5Rk8d/rJu?v8w9)-&!a0a;a&aIWejg3sEr/h1s<DtDJvyZqY5aws3Jvy!&Wei~Hr1:au5@Bag>23E~5c:Z&bX};kKv?w&unuVu5Rjc;>bs)#~@:Rh.=ay<a]C;b`}Vd6s/t{uAvoaxa()!a,a7%-a#a2Dt,[yF2Wo[>6Vyt3[xuNuPRi&NuPwpi#RoWh?vf8Ri%Jv]!%Ri:KvxD!.'2WeAjZu`q9rxu,Re7woeAg-unLq(qA_/*2Wg_g3u5q^9:4E}/jTrxrzv=Wkkd~0UX#^^Xa-a1a5T&a=U1a'*aEa]!a*aPaA-adok[y54Rn>;:p3~Dp5g9rpsFNvZqjg3uJp4~<5p0Pw;5qlJwNZt*@3p1Pw:5p/Ou!5p2JvG'!6Vye=<qnJvh_[xhg3v,Rh3kOwOw-sDuev/Re^dha[a%!%!a+#Ta7)-5TaCaO!aka!a)sf[yb2>Rl!9ARiq5E}Qg=ucRkBE|oJrJ_@Wk~@Wk{JrJ_@Wk|@WkyJrJ_@Wk}@WkzJvO_[y2g-vMRmiKuYC!)&>Ri;>Ri<@3RkNc](X#@9Rk=g5vuRmhKvDB!+'=]meg3u4Rmgd)#Y'Vz3CARmfd`a+!%T'!+#Ta1Ta6TaM-sTDt9[yA9sYd'%Y#s[[xpj:ueunaXRgEjRq,v-vuqdd2'`#6Rev<32@5>:2<E}5xIo9a*X#Y(;5RePJvD_g>vyRgNj8w)v8<wggs:RgXiZt|vjx,hSq3ah!-(~@:Ro/Ou!5RhWj^v(pyw8unRhUdx-UY#^Ua.a3a70!)%UX1TaDa)'omRiRRhE[y:3Dsz=Br,>6Vyj3[xkg6ruwjcqsrPw;5r*Ku]D'Zt-@3r(~?r.i[vwv]dU1a--U#`a4(g/vsRhPOu!5RhLj:rmu9Wo!~@:wdh@g/vsRiTjXuvvNr}:RhBj^v(pyw8unRn]dz1UYa'a+^Y(!aETZalaRY.Ta?a4[yDJw1!#qLsW>6Vyrfzq-pLflpwRe|Js>%!Dt@3Dt&Jvy_[xs~HrnjMuwpsw'RecKu+D#'!t<~Grl~?rjg5u-x,gwp{ah!-(~@:Rg~Ou!5Rh'jXuvvNr}:Rh#cW#X/c;&!#2sLi[v7u7RgpJv)(!iLrxu,Re6j7v@s@5Se[e7d`aW!Za(a`T.a#!a3!&aDa-!9)Dt_=6s+3[x~~DR|h~DS6avhGun5RkZj3w)v-]mkKunB!&*]kb97R|i<ARk<c:Z(6Vy}Juh'!wziMRoS:F|vkLuauJv5vtvQRh1d='T+Y#VyO~DR|jcF#T'7R|g97R|kJv3'!ay<Rj,Jvh&!:ReXcsa6*a+#a#_aIRf9aLRf?c,Z&Rf5Rf7c.Z&Rf;Rf>cQ#%T'p-Rf8Rf=ct#%'(*!,p,Rf4p+Rf6Rf:Rf<d~'Ua%U*^UYa(!a,-!#a4YaTalaEX0a8a<Weo3Dt/3Dsx=Br93Wen~Dr;~<5p<JwNZt2@3p=Pw:5p;Ou!5r3c7&!#:p>3Ds}KvGB)_6Vyk2sM=<r7x'eovA(!hFu1ARf}cV#X&@r5j6rvwQa^Rf3c=Za'wkghJv__g;unRggA53B9=b^}%j6uduo5Jq;!(hIv%2Re`Ou4ARe_e%a#^^^Xa&!a*a2!&a6YaP!*ad!#a:aE/5Rn?[y@>6Vyp;:pE~DrY~<5pBJwNZt8@3pCh=rt3rWPw:5pAJup_[xoNuPpF9c!#'45pD5ARn)d8#X'X*3@rU72s]h>v<<sSjJpqvewOJq/(!hNw'5ReBk0s2u3w/w'5ReE5@Jq.!a+JQ!&WeU23d(#Y&RjG5]jBk!u7w&u0udARjEe#+^^^Ub#!a2/a`Z(agT1!a-a;|@TaG!aS[yV=Re~fow'RguNuPRe?bz#'>RoUWeL>:Cbb|?JwPZtVg6ruRmzJvD'!6Vz(g/vmRh~Jvy_[y(g9voRgyx*cy(#2>Ri2B9b]~9kIw9u7rluJu3Rg]dI#a%UY'@=p%CAx.gQZ&RhwwygtRm{x5g_Z'+ABqR9Woa=Bp&dV#^*Xa'!&@o{g4v]Rk;Jv{!%Rk[wkkiA5RkiwwfUB=x,fUuqC&*!>RfTg8v0RfV~ARfSd;rJsAuAv9wR'ae+/aO!a@aza/a#[yQ@Wg!2Wemg3sEr0JvB_g>uvReWg2v+Re=KupB_+[y!2AbY~-~Hr2AJwD!(h<~El>h<~El?Kun@+_:9b`}Kg-v/Ri3g;vtwyk_9]k_d=&T#*U.6qh@Ab`|K9:H|CJv[!&3Dtex'fDwC%!Rf[9WlMd[(^X,!a%Z06Vz!@WgBg=v~Rgvg,QRe@awd,#Y+jTv|Q~EfWj]uNr|~FRfXdy#Y&^Ua%!aO.!(a)Ua;=!a@aKap!a-,a!Ta]a[rSa]p?[y82sK=Bq~;:p:~<5p8Pw:5p7d'#Y'Wf(;RnRi[u4w&RgJJvG'!6Vyh=<r#ijuuv/sIKuYD'ZtG@3p9~Gr&d2#`(g<vtRgFj`u5w&rqpxRf2CJuY!+:wfnTOu!5Rg}jNs1ucv&RfwJvA!&3@q|BDcC#T,k/unq8w8Q5RkTklwQuzunq8w8Q5Rk9dga#!a'!a=#a0!:+Tb*b@aO.a4!aba8aFJv^}?!VyR~Dr<g;u%Rn.~<5p[x'e`wNZtR@3p]Pw:5pZhNvjBp.woe_g5u-r4JwF!%DtO3:ooc7&!#:p^3DtpLuGw(!+%)Dtk6Vz#2sd=<r8d'#Y([y#<x3gJt`w@!)%}MRiowzikRij=]ilxAf3,U(#B2Rf#g0v-Rm[ck{`U#]giKv3>)!&6Ri154s,KuGB_%@r68r:dJ|t`#X(9<E|u2@H|rx3gJu?w'!+'1Nu7Reg4=H~+9<wxgY95Rm]xLggZ-`(X}U2:Ri4h<uOawRmsJv__5@bb{jbV~3dka#a'a]!,#a+U=a>b6a3b%!/aKa/)!arwve^VyJ;:pR~DpTg3uJpS~<5pOPw;5qmPw:5pNOu!5pQJvG'!6Vyx=<qoJvA!{~Jup!%@qk7Rn/KvyD!}''[xz;>wkh'?Rh,x8gyt`w5D!&),(SgyccRgztJ@3pPB5p#d'(Y#<]mmifubw&RgoJvE&!82s^JvF&!8Rf,ADb]~;x=h'rNu]vK!,%'*0RnORh)4Rh*AqQg-vaRnNg;wHwkh'ba~4cE#Ta*x3gctyw@'!+%RnFRnD<4Rn@hFvK5RnCxWg[#`&a0Ua()`1Rm75Rg[c]%X#qi8Rg^NvdRj>BwzgZauwji7Rm6A4wgg]d1#&(*,.0a#Rm;Rm<Rm=Rm>Rm?Rm@RmARmBe%#^^^Xaea?aC/b+(,!a+a#!a/!>a&Ta<aKbD!2wphBRnk[yPw}hE|.=Br-3Dtm>6Vy~g6urRf.x,hPrNav!%'RnqRo%Ro#Nu;q[Pw;5r+JwNZtM@3r)d'#Y'Weh;xChL#`&RnmRnoKu}>%(!Rne~Bs-;2wjcussJv+'!aYSO}6@B<5?ba~8LrNvj!.%*ROwungw~ng~:9;Ri^>wtnig;wHRnixDh@|(UZ.x1h@|)!#:2<H|*xHn]#-UX'3Ro)z=iT}6ARns=Bwsn_wpnaRncw]aR(#UXa&Ua*a/=]iPd'#Y&Ro'WnXf{QRm2hNvj]nZd`'T~&1`{|`#9b]{}c:'!#Wl{>@=be}]?cl{{U#:5Abb}Jds#^YaF!a*b4a#a3aPa>&Tb!bH!*a_!Eau?/a&RjY<]gj>6Vz*;:pe~DrZg,QRj1JwNZtX@wihspcJvZ&!VyX9WmOJu|!|N2WmHJvh&!]ht~Bpbcn&T(!#RmQ<s7Nu;padH#X'`+WmJ@>RmKCARhnKup=!)&Wf+:RhqNuPpf9c!#'45pd5AwghpARn(Ls@w!%,)!RmP@Wfe<E|IJva!&WmNg8vsRmLd`*.`#Y'Xa!axRn*]hrA8Rhug5s@rXg8u!RmMd8#X'X*3@rV72smdI*#UY&RmICARho~GsgxVgd)Ta'U-Y&Xa!T#RnEWnA@Wffg1uDRi0hFvK5RnBxGnG&#`%owp)@wsf+bX}Ze-*1!a*^^^Ua|!#a.aq&Ya2!a>.a6!a:aO`aJDtL[y`@Wg#>6Vz12@wzoYRoZNuPRi!NuPRhzg=ucRi,@=b`{Yg=ucRi-ACJvB!&Sh[ebSh]ebi`wUuFRm4Jw2_[y0JvB!.<Ju(!&SoG}6Shd}6<Ju(!&SoH}6She}6Kur@._g5vHRieJvx!{L2G{Kx6gd'T#?Rh82Wi5cZ#X(g1w)Rm5dW-Y(Ta#!a)!#aYa=wnfE=su2>>bU{0j9udv:<svj8uQv-7RgHdE%#^'sq9sp=>Bb_{TJv`!&g/r|snj6v(us5d,#Y(56H}[978H}]Jw5!&g1rushJvB!+j;v{u5?zDhd}6}bj;v{u5?zDhe}6}ce*#`(^^^a[aea!=!a6a*aoXb1a.!aAbL!b>,b'aL!aV@Wf|2Wlg3[y/JwNZt^@3piPw:5pgJunZou3@rsJva&!Vy_g<v~Rm#JvG'!6Vz0=<r{Ju{%!:pj@WfsiXuJu3Rm:JvZ&!WfA~Bph@c4Z&Dtwax5rubx(#:awRk1@d,#Y&RfjRfid1#,Y(@Wfp2Wlrg5s@ryKu[@!,'=]ig9wlk?Rk>g5u-rqJvy'!@9RkQcH(T#=>Ri~@<wkj(Wj(KuZB*!&<7rw@9RkRcH(T#=>Ri}@<wkj)Wj)dg(Ta2Xa9X#`-!a*CARhg@@=I}d9x;c~#X%so=<sj>2@@=aybb}XjWv0Q~EfEj3vLv;<d,#Y(56H}`978H}_dgaPaFa'a/!#a3Y0a_a;a|!1(a7-[yE3[xt;:pJNvZrrg3uJrvJwNZt=@3pIh=rt3rxPw:5pGOu!5rpJvG'!6Vys=<rz@c4Z&Dt(ax5rtJvZ!&~BpH@wsfNg-vaRlNci*U#=<wei<F}a5@Jq.!a*JQ!%@qZ23d(#Y&RjH5]jCk!u7w&u0udARjFd/prq=tyvpaEa(a:.!a1aZ(@@=I}:9wpd%=<sX55w_h}@@=I{t=ay<aU@@=I}T=ay<2@@=I})?C9:9au@9Cb]}DP~=x-fAZ(2Wl1=ay<aU@@=I}>5@d##Y+jTv|vV~EfFj]uNpn~FRfGdgaK!Z2&!a8a-Tb({E!acTbM*!a(DtY[yYd'%Y#sl[y*hHvh>Re5x2c{Z}.j4uCvcawRiMd+#X+_x&d!},<5RkX;2Hzw@x,gavfB-!{CcF&T#Roe;RodwWbBg5urRgaKvHC*_6Vz+<4opieuew&Rmq@d]&Y)X,T#X0Rh}<BqP=4qS9:ReMg/ujReNJw0!/<Jui%!bd{kawwnemRelAxUa?a3#*.&UX(Ya+a/RhvRnQ<o}9Wmtd-#Y&RgSRmw9;Rmxay=Rmyg-vaRmuxEhSrNu,v-voC!%(aR.a(a7+1Ro1>Ro5CE{A9b]{@;5x#eO{:g;urRi+KrNA!%(Ro3>Ro79;Ri_Ku@>{;&!x%gX|{KunA_+g5QRj/g3u5Rj#g>uERj%wio/xRhS&!,!#^1U}wba{8>>@=be}qC@:D5ba{7Ku+A&!}x?ba}t>>@=be}se(aA^^^Uat!b0#{pa+awUazbGa#aLb9bgaWac'a5TbS=Br!d1#`%scp_Jvl!#rT>Re0JvX&!VyN=H{Fcm#U&:pY=ReaJv2&!]h0=]nUJvG'!6Vy|=<r%JrM_=]h2@Wlud'#)U'Wf'b]{i=]h/Jvh!&~BpWg=v]RnMx+ny#'Nu;pVwjnu=]nwxJnx,T#`&Reqwjnt=]nvieu9vrRjLLuYwP(#+!th@wih5pX~Gr'g5v/Rh4KunA'!-CARnP@wwiN:Rm_9x'cvw>!|l=<saKvAA!0&3@q}>w^e1bp#&Re2Re3BDx7gH#T|f5H|eKuZ>!%(:qNAH{]Jv6!+3B2B9=b^{X<5<B92:E{ZLvhwA(a;a%!igQuyRmad+#Y}m@3Rh5d8#X'X*:AqUAHzmaxwbh<aXRnVcF}RT#Nw&cj#U(BWnug/vsRntdka)(a3+.Zb7aYYan1!bVa@Xa}[y^@b[{G=H{+hFu73Rj&Pv#5ReQcK%T#sig1v{Rj'Ku+D#'!t]~Grm~?rkKuMB!01d5#`'Vy.ta3Dtu~Hroc8#'{^45s85AwZbP&!#Rn!wghxWn#KvEA!)&2RlA2RlBx:h|#(T,=]j09Wobz>x]z/@awRoTd+#Y(az]hFhCrm4d,#Y+jTv|Q~EfMj]uNr|~FRfOdCa!Xa9_X#@<plJvf!%b`{(9;Rgwc;.!#2x7cw#T|UDb]|T5Ju={(!=@E{&Jv)&!Ab`{'awJvf!~*>>@=be{#KuY>!+&4Ezyi[ugv&RjIdea+T)#UXa&T-T&a!Rh9auRmW=]kLg5vuRn+g3u4Rn-Ow6ARn,hHus5xNk?#UX(U~)/g8v0RkD~AwkkF?Ri.OuNBwkkA?Ri/d|a2`a*^UYa.!aBTZaTa'Xa;!(!2!-a#b2[yC>6Vyq3[xr2Wi?g1rusVh%s?DtF~<5rbJs;%!DtBfswKtCj[uvuSsEu3RgVx3o:u+wN'*Zt;@3rd~Grh~?rfg8w)Lq)qE&-a%!>bI|`jWv0vV~EfCjTv|vV~Ef@j]uNpn~FRfBcK#T']gWNu7x,k7q4ai(0!hHv8<RhmkMu9vrsBuev/RhlCJvB!,g<v{wchh~@:Rhji[vrv{wchi~@:RhkdS&a5UY#Ta!RgPwwiI5BwciI~@:Rh`x'iJvj'!5]iJPu8Bwch]~@:Rhach)U#h3rp]gLh@t|Ax,hTq3ah!-(~@:Ro0Ou!5RhXj^v(pyw8unRhVd|)`,^UYas!a?/a2Z'a^Ta{Tb7Ta(a#!a,Wf&9sZ3DtAadamov=Bqt3[xig8vsRm~>waiL2b`{QJv*_Ouv2qgj<v]v2BqfdR'X*X#Y-@3qr~Gqv~?p6hHv-]glPup5Lq+q?_%*b_{qF{n9b^{rOu4ARhpKvCD!+&~Bqp:5Dbb}nwoiKl&unuTuBv]v+ueunaXRf0=Jvh!0nKufu8v1w&w7q%w&uHrz:Rgnj5w,uxDJq/(!hNw'5ReCk0s2u3w/w'5ReFd>Za&!*UaA=<wkgsRnSJv^!%Refifw3vyRgOKu_B'!,<]gkiiu:w&Rh<=C@a^<B57@2F{[<B5@aW:=3away9A5aW=<B=C@a^<B57@2F{Ie-#`(^^^bCara.b8aza6!/bZ,!adTbnTbOb+aFaS!aAT9@Wf~2Wli3Dtl2@d,#Y&RfnRfmJwJZtN~GqyJva&!VyMg<v~Rm%iXuJu3Rm9Jv[_=]ih9wlkDRkCd1#`(@Wg>2Wls3cH#T(@<Rj*=>Ri|b~'#23s9h<~El.d'#Y&Dtxi^rzvdRl#d*#U%(o|B2s`hJwSaxRmDKv4B&!1:Rmdd5#`'Vx}to~Hq{x'f1v3(!BA5ba|bJv_&!Wfug1v]ReIdO+U/Y#&G}-8wze=Rh{g1v]ReHg/uQRf/by#)ibQwERl/cH#T(@<Rj+=>Ri{cNu+vlax-!(#a0qa9<Rii2;;bU{H;x<i=&X#Rk`<4wwi=C9H~8xAI(Y#<azRi@45wXI<B9;5bb~7dL(X#Xa(+!aL6Vy{g5QqOau:5au2@ay547EzbxOcU(UX-T#Ta#:Cbb|A?wjh/b_|SOw6ARgtihr}u7Rhy<d1#T)X1@@=I|~=ay<2@@=aybb}Sj3vLv;<d,#Y(56H}A978H}@dGpvs@uAu`vcw9*!aFa+ai%(b!aXa8.a?a[ozWey=sU2@G}Nch&U#Rf_WexKu+D#'!t:~Gr`~?r^j]uNr|~FRg*j^psurwJt|RmcKv)@&!)7Rkv~Br[@wxfO:Rl3co#U'6Rezj_q#vIuavjRltwzeyh@vr5JqD0!>aY?C9:9au@9Cb]}9cl#U*5;5<H||jbuus1ucv&Rfvg1v~d/pppzqFr^a--a~!aMat1(hFv;Wiz@@=Izoj5uuv-7Rix~Cw`fk2WlVcZ#X,k)u3vWs@u2]ktg;wEx'fBq(_2Wg/jTv|vV~EfoJv]!15x'hzqG!(P~EfU~CRl_j6v(us5x4i-#T(2WmZ?C2F|d>Kq<aj1!*jTqIsBv=Wl`~Cw`fi2WlWj`v0u*~>RlR=c>Z,k#u3vWs@u2]kr<c1Z+jTqIsBv=Wla~Cw`fm2WlXdmb3!a{(arZa`bkTa%TbQTa-a9+c'!aM!/[yL=Bqug.w'RifhFvyDRj.g>vgwyk^9]k^Jv3_@WfbAARkhJw2_[x|JvB_wkoIRoKwkoJRoLd'(Y#<]gm=<9<H|yd'%_X#skDtb3awwqkgNulRkgdB#^',9:p'hJwSaxRmEBwVb8@4=H|qLu+w50&!)@3qs~?pU>Awwn;;Rn=c:Z'ARn<=<qwKvC@!/&~BqqJv6!&]eVb^z^xRge'/a%+^`#Sge}6<4Rn3=]n0Pw2>Rn8Jw0!&>Rn:>Rn6cY#a7+!a&=<wkaNw~h3z_c5Z{=wjh#=]nLKv^D!&)Vyz=bW|swYb<WetcG#T(2wxa@qVx@gD#Y&b^|V5JwG&!5bb|pg/w&RgD@x=kHs=uAvn!a%%/'+RmSRh694Ro`g-vaRmRhHv-]mlxCcS#`&ba~.5cD#Ta)P~=d,#Y(56H{>978H{Dd_#{2^Y%_+qbbb{6g3sERhsbU{?dfa.,`a(Xa<!aiX#(55RiG54RiHcI#T'WiU3RiVNvdwtfcRlKNvdd,#Y&RlHRlExQgf.1*^T'X#Sgf}6Wn4=]hfPrk>Rn7Jw0!&>Rn5>Rn9Lunw?&a2!,5<oq@@wqfdRlJj5Q~=d,#Y(~ARfcOuN]fdDKw;ay(}i!547E}j?cI#T(@5bV}iCbV}hdv(^^Tb?a40,b##Tbo!a*bR!a<b|a/!aKai!aU[yK=]o^g:v>ReGJwPZtK<7Rh+h<~El,Pv#5ReR@awwxjCg,ulRjDJv6&!]j!z?aQeeg>w=Sh<eeJw;!&axEzOg,Qosc!#*:wkeJ]eJ>x'h-u(!%Ro.w~h.zPdNZ(X,Ya![x{;9ReY;wkgxRiF:x?ap#Y&RmUg<s2Rkod]+UY0TZ'!a&A9sw<=bczLNvuw{gqzNhJwSaxRmCKuLay!#&s_Rf-55b^{uJvZa!!c%#(55Ri654wmiu5RiuawLu,vp!+}^%b_}Y9;wkgxba}o>A9:=b^}zKuh=a''!3awRk3c*'!#aHRk6c+Z&Rk5Rk4Jv)&!awRjSawd9*`#0?C2@EzMj8u<uJ5RmbjQrquJu3x,k>uq@_+=ayb^|W~ARkEOuN]k@7dhzV^X/X&a-#zRzSb`zXcJzTT#2WkVKvDBzW!%FzY9;5bbzWjQrquJu3Jw3%!b`zU=ayb^zQd:#X(T-a!6Vyywxh}=b]{Jg=u1RiAdGp~qHtzv!w(wA+a+a;<!aJaYai'anasb(=azRmV:Cbb{MLq2vb!%')RjuRjrRjtRjqx3jnqCw3!%')Rk(Rk+Rk&Rk)Lq2vb!%')Rj{RjxRjzRjwLq2vb!%')RjsRjpRjfRjex3jcqCw3!%')Rk'Rk*RjkRjl9<CbbzfOu4ARhxLq2vb!%')RjyRjvRjhRjgx=joq*uKvb!%')+-Rk.Rk%Rj~Rk-Rk#Rj}x=jdq*uKvb!%')+-Rk,Rk!Rj|RjmRjjRjidAq&qKs@uAv8Aa.'*-a@a&0!aM@a5[y73Dsy3Ds|3Dt):wxgI2sHJwJZt.~Gqxwsf0ikrzt}Rl0Jvy_[xj~HqzKv_A|D!&WfP8axRoVcf,U#k(v]v+ueunaXRf1Ju}'!g8u#Ri=jQw!sCunLprq>!,')~<5qeGzq9F{W=c##%s5au:5aU3CBE|;d4#X(D!a&6Vygx(b;#(=]ed?C2F{N<capoq2r[a&!aPa9,'Pw;5s:@@=I|,55w_h|@@=IzcP~=x'fCqB_2Wl2>aU@@=I|1OuNBc1Z+jTqIsBv=Wlc~Cw`fl2WlZ~AcTa%!Z+jTqIsBv=Wlb~Cw`fh2WlYk+uNqJsBv=WlSg,u3dca3#UXaMYa)TaB-=cM|7T#<bI}l5@B932:aV2G{BOuNBJq:|M!5Ezt=<B=C@a^<B57@2F{v>cB{/T#=ay<bI{3Jv6!a.6BKq0ah&+!5E}HP~Ef{978BaU@@=Iza<7d#.Y#978BaU@@=IzH~AJq0!(@@=IzG978BaU@@=IzFe,aU*Y&^^^bvJb,b:bFad!a,c2Ta>aL.bo6!a#CbTa'T#Re{2Wlh2@G{yg6t~Ro_NvdRfticuRQRllJv3&!x&c|zs@Jw3!%RflwpfkRlpKuL;%(!Re<@G|C2GzdhIvuBwgjAg-u0RjAKQB%!(GzZ@G|5NuuRl7d='T+Y#Vy[g<v~Rm!==G|>JvA!)@wma=]m1ifuaw&RmnLs@vT'!|/+[y,g:v>ReTJw1!#qX=x!eC{bLu+wT&)ZtZauq_~Graci&U#F|89:r_Lupvq!.)&2RlG8RfaC=x!eF{_h?rpWlmd&'!#X|&]k::xJey#`'T|+<E|&2@H|%dE#(^,g;u.RiEg6vjRiC9xCkA{O|zY#g=ucRmXKs0@!&*@G|m@awRknJuh!,3d(}gY}eJvj!%Rm):Jw3!%Rm+Rm-Ls0w(&!a(a#@b[|6cZ#X'7RkxWgAOu4ARn'dH'U#Y*Vz-Wm'CARm}d]*#a%^a*T'aK!a<9bV{PC=p*Jw4!&SgxcbB5r]idw(wBRmF7xFkt#&`(Rm/Rm8E|!JuY_9:Rl5=wrgr2:bbxd@xXfB(a*#T+!.X0X1Ta/a'T&RlDRfL>RlyARl9b[z[>RfZ:RlL:RfRwlg/ARl;9;RlxKv,A/!%7s69<74=BA5ba{-8Bde#`a<XaKYa1,a'P~=wxfB2bZ}}?C972@@=I}r8@55B9;5bb}G978B2@@=aybb}3j3vLv;<Jw3&!>Rfk=ayb^}4~Ad1#`*@@=aybb{w2@>==<bbz]dx+UY#^UaF!a9!bB'Ya1.!ajXa#%olRhD[y=3Dt#Ov5BrHKuMB%!(Rf^Wep~HrJwkiQjKr|~FRg)Ku+D#'!t5~GrF~?rDdV)UY,Z/_7RkuG{<~BrBg,rlsO:235B@bX}|d?a1!#`(6Vyn5@d##Y+jTv|vV~EfIj]uNpn~FRfH7Lq2vb1!a9-978BaU@@=Iz9978BbU}#~AJq0!(@@=Iz8978BaU@@=Iz7~AJQ|}!978BbU}!JvkaK!AdUa21-U#`a+(g/vsRn~Ou!5RPj:rmu9WhOjXuvvNr}:RhAj^v(pyw8unRn[kPr}p|u7vwv]RiSBd;pppzq@qHQa?(b.!a.a`@.|xa(hFv;Wiyj5uuv-7Riw~Cw`fg2WlU978BbU|wOuNBJqG!(P~EfD~CRlQcZ#X,k)u3vWs@u2]ksg;wEx'f@q1_2Wg.j]uNpn~FRfqJv]!15x'h{qG!(@@=IzK~CRl^j6v(us5x4i,#T(2WmY?C2F{1>Kq<aj1!*jTqIsBv=Wld~Cw`fj2Wl[j`v0u*~>RlT=c>Z,k#u3vWs@u2]kq<c1Z+jTqIsBv=Wle~Cw`fn2Wl]dn1#c(a(b^a2!b/bAT(bj!aDa7bu,a_a{c0!2T0g:v>ReD2@G{42@G{5~DpM~<5rc=Bx6i>{RT#RnI@zCx]y]z:2Jv[!zr5Awyk]9]k]dD(Y+X#6Vz.g=wKtgwhaCwgmTWj2Lu,w%_+/[y-B;b^xeg3u3Rj-2@bX{*KrJ<!+'@Wg(g?QRlC@Jv`!%b[zIwsfII}8JQ_@w|kW|=Jv(%!AqcOuNBJvEzh!bYzjLs@wP#(0!oy@>RkdJwMZtc3Dtd@BcG#T'9bWxg2@2Fznd*#Y+;2x'c}w<zizixNgwa#Z'U+!/!a'!a+w~g~z6wcn{Rn}wcnzRn|5Rh%=]nJg5vuRmvNvdRlvcprJu}w*az*a#!%.a.'Bot9qT]kj@Wg'ay2Gzv@Jv`!%b[zEwsfHI}1;ck#Ux`<Cbbx_Lu+w!a&0*!wko*wwo,So,}6Juqxf!E}PigQuyRm`d3(`#8>Rn%:A5B;bZ~%KvhCa!a2!x>k7#Uxb@b{#xaRk7Jw0!)>wwhlShl}6>wwhmShm}6CJvB!.x'hhvj{!!5Bwkhhbaz}x'hivjz~!5Bwkhibaz|xEhTrNu,v-vpD!a%&/)a3a.,%Ro2t[CE{)@3re9b]{%wjo09:rgc:Z&Ro6=<riifuaw&RmoKrNA!%(Ro4>Ro89;Ri`dSaL'UYzxZb)7Rka3xRhT&!,!#^1U}vbaz{>>@=be}yC@:D5bazzKu+A&!}{?ba}y>>@=be}wxBh[t`u~vJvr!%a!a()a,a0a4RoC=]o;Ju(!%RoGRhdwjh`=]oAg>w#Ro?g5vuRo=NvdRl|Ku]C.!&;RoEJvB!%RoORoMBx'h[v+_?w~h`}~5?w~hd~!xKh]oiptu-utv.vp!#%&a30a@a'a+(a/aOp(o~p!RoDJu(!%RoHRhewjha=]oBNvdRl}g>w#Ro@g5vuRo>c[#X']o<CauRoRAd-#Y':RkpauRoQKu]C.!&;RoFJvB!%RoNRoPBx'h]v+_?w~ha}t5?w~he}ue!/UbhYacXaW^Tc&a;b:a-c/#b&aja1(!cL+!bKbt!bmcRc9aIc?8[yW3Dtt94Rg`Jv}!&SiRMzBhEebShEMNuPRe>x7gL#TzuwjirRipc<Z&>on;>z=h-MSh.Mwqczx'a7vj&!>Re4@=ResJt__NuPRi*NuPRi)j]uNr|~FRfzKrJ>_+@Wfy@Wf]2WocKrJ<!+'@Wg%g/QRl@@Jv`!&awRl<wsfFIzgLu(w*!.*&ShBMwvhIRhI9;RhNx1hK'!#Sn]Mx1hK~0!#:2<H~7cNu+w7D*'1ZtW>Rn1~?rOc:Z&Rn2=<rQ<7wjh&=BSnLMc]#X(6Vz)w[b=a!U#9wzgMc3#&(RgMRitRis<x,gKt`ax!&+SioM=BSilMc3#&(RgKRinRimKurB,!&SiQMzBhDebShDM6BJQ!(P~Efx978B2@@=I}WLrJw!!,a*&@G}O@9wkibRid@@x'fKwC!&SlDMSfLMjUv~Q~EfKKv3@a+!(hFv-]mpx/hYZ(C5RiWz<o/MwkhY?So/M@x,gbvfB*&!SgEM:SoeeehFu3:Rgbda(,^TZa)X/7Sg[eb:2RgI~BrMC@wgkc:wwkcRerx3h(uUvK!&*,SnOM4Sh*MArRg;wHRh(x=h;rJvPwI!a4',a'0@Wg&=BSh/Mg>w=Rh=g3w*wwgGRgGcW(X#;Sg}M2Gzk@Jv`!&awRl=wsfGIz`dKZ*T'Y-:RhR7RhQg5u-p`j6v(us5d,#Y+~Awkia?RicOuNBwkibba}Ld6p~tyu_vbAa'a+!a/'a3aEa8a!>Sh,ebJv{!&Sh@ebSaReb9;SgwebNuPRi(NvdRl)NuPRi'hHu^<Rm^Jvv_@Wl(g;u1Si/ebKu'B&!*Sh?eb@Wl'z@aPeb95Si.ebcpputyvjB)!,&a+0a%ShAMWeK@G}C@WfJ9;RhMwvhH9w{ia}ix,hJvRA1(!zAn[MRhHx1hJ~*!#hFv(BSn[MBJQ!(@@=I~'978B2@@=I}2db.Ua<'X}+T#a0XaG2G}E;wkg|wuh!Rh!x,hZu,@)!&So0MVy)C5RiXACJvB!&5RiY5RiZg8w)cG}*T#2@bU}=KsA>(!a.3wkhZba~(x,h^u(A!&(SoCMRhb5Bz=h[eb?w~hb~6x,h_u(A!&(SoDMRhc5Bz=h]eb?w~hc~6e)aA1T#T,^^^c-bMb&blcPaP(a/!0!bA=b5c@a(!bfbrc#2afwmhARnjwchORnp2Wlf3DtsNvdRl-2@wpa<]m0bx(#:awRk2@Jw3!%RfhwpfgRlnKQB%!(G{V@G|'NuuRl6d='T+Y#VyUg<v~Rl~==G|<Jv+'!aYShC}6@B<5?ba~8@Jw3'!g2QRljhLrpWlOd+#Y'g.w'rIg>w*wgj@g-u0Rj@Lu+wT&)ZtUauq]~GrGci&U#F|39:rELrNvj!.%*RhCwunfw~nf~:9;Ri]>wtnhg;wHRnhx3hDs@v~!/+'@Wfr@9RkSNu&Rlo=@<5GzoKs0@_+@Wl+@awRkmJuh!-3d(}pY#qWJvj!%Rm(:Jw3!%Rm,Rm*de&!1U-U#`)Re;@G|.@9Ri82@wjfvRlq=@<5GzpLvOvr!).&2RlF8Rf`C=x!eE{.Jw3_g2QRlkhLrpWlPde(!#U{s,UXa*Ta'[y'g:v>ReS;x0PZ&RnlRnn~HrKJw1}f!=x!eB|2w]aP(#Xa&a*Ta.Ua2a7=]iOd'#Y&Ro&WnWg;u.RiDg6vjRiBNvdRlzhNvj]nYJuW_2Wm3x)kFze{9d])!a.!,Y01!#&aC!a3RndC=ox~BrC@2b^{pg,rlse7x'ksuq!%Rm.E{xidw(wBRmGx9o+)X#wwo-So-}69:Rl4@xSf@a#XZ'X)X,Ta(/ARl8b[xc>RfY:RlI:RfQwlg.ARl:9;Rlwdn'#^XafaQa1X1TaHTa)@b[{zcZ#X'7RkwWg@Ou4ARn&x)kG#{,g7u/RkGdH'U#Y*Vz'Wm&CARm|bx#(A]gUbUzJj9Q~=d,#Y(56H}l978H{U7d,0#U*2>ABb_xZ978BbU{e~AJQ{g!978BbU{hxMh?ad{oUYZ.x1h?{l!#:2<H{mx3n[t{vl!,&a%3Ro(z=iS}6ARnr=Bwsn^wvn`Rnbd`*T}B0!#^X'BG{c9b]{a>>@=be}F?JvS!&BG{d7BG}(Bde#`a1X,Ya@!a'P~=wxf@2bZ}I56B2@@=aybb}08@55B9;5bb}<j3vLv;<Jw3&!>Rfg=ayb^}&OuNBKuLA!)a!P~=x#fD{f2@>==<bbzl?C972@@=Ix^d6rSu,v7w*C(0a)a6#B+a%!sQ[y?3Dt%3[xn~<5rLOu!5p@Ku+D#'!t7~GrP~?rNKvlaya7'!h+v-5qMg=t|cd,U#5AAaa5Abb{S@52B5@a[@52B5Gx[iXueu;d<#`a(!/549C;ag>23ExY5@Dah89b^~689Jv)!~2b[~1Lv'w(%*!a#bX|aPrmawRe]keu7uhv-q6rxu,q`xTo]/a5aU!bNaDXbi!b-!ao!b<bwA!#5@B932:aV2G|:d-)Y#hJrL>RhG<7@C5<H|_=Cau:5aj5@B932:bJ|ng>vIbs)#?C2F|9jPv0w.vISh-MKvUaz(.!9ABbb|[5;5<H|Eg>unwfh;9:4E|YjQsBt|vjx'hYq3!(?C2F|J:2<BaY?C2F|GOu!5x,g|p{ah!-(?C2F|c9:4E|OjXuvvNr}:Rh&i[w*t|cd+U#jJvsu)vsSn~Mkfrmu9p}u7vwv]So!McW#Xa!ax5@A5aY:5;5<H|>kJv~vYrquJu3x4ib#T)2@SmZM?C2F|Bj:rmu9@xPhI(a*a#U#`a3-5Abb|L~@:RhK9:4E|0@52B5G|#C::aY?C2F|-:2<BaY?C2F|.5Jvk!a)javYrquJu3x4ia#T)2@SmYM?C2F|HAxPhH(!a#U#`a*-5Abb|4~@:RhJ9:4E|R@52B5G|F:2<BaY?C2F|Sc^#Xa2j=Qq5CJvB!-g<v{z;hhM?C2F|Zi[vrv{z;hiM?C2F|XKsA>!a)-g<v{z;h[eb?C2F|]i[vrv{z;h]eb?C2F|^iZu.vix,hZq3ah!.(?C2F|QOu!5ShXM:2<BaY?C2F|P", 13494, 2713, 49, 25, 61), wb = /* @__PURE__ */ new Uint16Array([
  512,
  26465,
  29036,
  7,
  0,
  2,
  4,
  116,
  24638,
  116,
  24636,
  8693,
  29807,
  24610,
  621,
  1,
  0,
  0,
  3,
  112,
  24614,
  111,
  115,
  24615
]);
var pt;
(function(e) {
  e[e.VALUE_LENGTH = 49152] = "VALUE_LENGTH", e[e.FLAG13 = 8192] = "FLAG13", e[e.BRANCH_LENGTH = 8064] = "BRANCH_LENGTH", e[e.JUMP_TABLE = 127] = "JUMP_TABLE", e[e.VALUE_MASK = 8191] = "VALUE_MASK";
})(pt || (pt = {}));
var bt;
(function(e) {
  e[e.AMP = 38] = "AMP", e[e.NUM = 35] = "NUM", e[e.SEMI = 59] = "SEMI", e[e.EQUALS = 61] = "EQUALS", e[e.ZERO = 48] = "ZERO", e[e.NINE = 57] = "NINE", e[e.LOWER_A = 97] = "LOWER_A", e[e.LOWER_X = 120] = "LOWER_X";
})(bt || (bt = {}));
const Ys = 32;
function Nb(e) {
  return e - bt.ZERO >>> 0 <= 9;
}
function T2(e) {
  return (e | Ys) - bt.LOWER_A >>> 0 <= 5;
}
function b2(e) {
  return (e | Ys) - bt.LOWER_A >>> 0 <= 25;
}
function A2(e) {
  return e === bt.EQUALS || b2(e) || Nb(e);
}
var Tt;
(function(e) {
  e[e.EntityStart = 0] = "EntityStart", e[e.NumericStart = 1] = "NumericStart", e[e.NumericDecimal = 2] = "NumericDecimal", e[e.NumericHex = 3] = "NumericHex", e[e.NamedEntity = 4] = "NamedEntity";
})(Tt || (Tt = {}));
var ur;
(function(e) {
  e[e.Legacy = 0] = "Legacy", e[e.Strict = 1] = "Strict", e[e.Attribute = 2] = "Attribute";
})(ur || (ur = {}));
class v2 {
  constructor(t, r, n) {
    $(this, "decodeTree");
    $(this, "emitCodePoint");
    $(this, "errors");
    /** The current state of the decoder. */
    $(this, "state", Tt.EntityStart);
    /** Characters that were consumed while parsing an entity. */
    $(this, "consumed", 1);
    /**
     * The result of the entity.
     *
     * For named entities: the trie index of the best legacy match so far
     * (0 = none). For numeric entities: the accumulated code point.
     */
    $(this, "result", 0);
    /** The current index in the decode tree. */
    $(this, "treeIndex", 0);
    /**
     * Characters consumed since the last recorded legacy match, plus one.
     * Invariant at the top of the `stateNamedEntity` loop: `excess` equals
     * the number of unrecorded consumed characters + 1.
     */
    // biome-ignore lint/correctness/noUnusedPrivateClassMembers: False positive (read via destructuring)
    $(this, "excess", 1);
    /** The mode in which the decoder is operating. */
    $(this, "decodeMode", ur.Strict);
    /** The number of characters that have been consumed in the current run. */
    // biome-ignore lint/correctness/noUnusedPrivateClassMembers: False positive
    $(this, "runConsumed", 0);
    this.decodeTree = t, this.emitCodePoint = r, this.errors = n;
  }
  /**
   * Resets the instance to make it reusable.
   * @param decodeMode Entity decoding mode to use.
   */
  startEntity(t) {
    this.decodeMode = t, this.state = Tt.EntityStart, this.result = 0, this.treeIndex = 0, this.excess = 1, this.consumed = 1, this.runConsumed = 0;
  }
  /**
   * Write an entity to the decoder. This can be called multiple times with partial entities.
   * If the entity is incomplete, the decoder will return -1.
   *
   * Mirrors the non-streaming `decodeWithTrie`, but with the ability to stop decoding if the
   * entity is incomplete, and resume when the next string is written.
   * @param input The string containing the entity (or a continuation of the entity).
   * @param offset The offset at which the entity begins. Should be 0 if this is not the first call.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  write(t, r) {
    switch (this.state) {
      case Tt.EntityStart:
        return t.charCodeAt(r) === bt.NUM ? (this.state = Tt.NumericStart, this.consumed += 1, this.stateNumericStart(t, r + 1)) : (this.state = Tt.NamedEntity, this.stateNamedEntity(t, r));
      case Tt.NumericStart:
        return this.stateNumericStart(t, r);
      case Tt.NumericDecimal:
        return this.stateNumericDecimal(t, r);
      case Tt.NumericHex:
        return this.stateNumericHex(t, r);
      default:
        return this.stateNamedEntity(t, r);
    }
  }
  /**
   * Switches between the numeric decimal and hexadecimal states.
   *
   * Equivalent to the `Numeric character reference state` in the HTML spec.
   * @param input The string containing the entity (or a continuation of the entity).
   * @param offset The current offset.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  // eslint-disable-next-line unicorn/consistent-class-member-order
  stateNumericStart(t, r) {
    return r >= t.length ? -1 : (t.charCodeAt(r) | Ys) === bt.LOWER_X ? (this.state = Tt.NumericHex, this.consumed += 1, this.stateNumericHex(t, r + 1)) : (this.state = Tt.NumericDecimal, this.stateNumericDecimal(t, r));
  }
  /**
   * Parses a hexadecimal numeric entity.
   *
   * Equivalent to the `Hexademical character reference state` in the HTML
   * spec. Digit parsing matches the hex loop in `parseNumericEntity`.
   * The accumulated value is preserved for numeric validation callbacks.
   * @param input The string containing the entity (or a continuation of the entity).
   * @param offset The current offset.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  stateNumericHex(t, r) {
    const n = t.length;
    let { result: i } = this, { consumed: o } = this;
    for (; r < n; ) {
      const s = t.charCodeAt(r);
      if (Nb(s) || T2(s)) {
        const a = s <= bt.NINE ? s - bt.ZERO : (s | Ys) - bt.LOWER_A + 10;
        i = i * 16 + a, o += 1, r += 1;
      } else
        return this.result = i, this.consumed = o, this.emitNumericEntity(s, 3);
    }
    return this.result = i, this.consumed = o, -1;
  }
  /**
   * Parses a decimal numeric entity.
   *
   * Equivalent to the `Decimal character reference state` in the HTML
   * spec. Digit parsing matches the decimal loop in `parseNumericEntity`.
   * The accumulated value is preserved for numeric validation callbacks.
   * @param input The string containing the entity (or a continuation of the entity).
   * @param offset The current offset.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  stateNumericDecimal(t, r) {
    const n = t.length;
    let { result: i } = this, { consumed: o } = this;
    for (; r < n; ) {
      const s = t.charCodeAt(r) - bt.ZERO;
      if (s >>> 0 > 9)
        return this.result = i, this.consumed = o, this.emitNumericEntity(s + bt.ZERO, 2);
      i = i * 10 + s, o += 1, r += 1;
    }
    return this.result = i, this.consumed = o, -1;
  }
  /**
   * Validate and emit a numeric entity.
   *
   * Implements the logic from the `Hexademical character reference start
   * state` and `Numeric character reference end state` in the HTML spec.
   * @param lastCp The last code point of the entity. Used to see if the
   *               entity was terminated with a semicolon.
   * @param expectedLength The minimum number of characters that should be
   *                       consumed. Used to validate that at least one digit
   *                       was consumed.
   * @returns The number of characters that were consumed.
   */
  emitNumericEntity(t, r) {
    var n;
    if (this.consumed <= r)
      return (n = this.errors) == null || n.absenceOfDigitsInNumericCharacterReference(this.consumed), 0;
    if (t === bt.SEMI)
      this.consumed += 1;
    else if (this.decodeMode === ur.Strict)
      return 0;
    return this.emitCodePoint((this.decodeTree === wb ? E2 : m2)(this.result), this.consumed), this.errors && (t !== bt.SEMI && this.errors.missingSemicolonAfterCharacterReference(), this.errors.validateNumericCharacterReference(this.result)), this.consumed;
  }
  /**
   * Flush locally-tracked walk state back to the fields, then emit the
   * recorded legacy match or reject (cold path — at most once per
   * entity). Called after failed navigation (leaf node, branch miss, or
   * compact-run mismatch). In attribute mode, reject if no legacy was
   * recorded at the current node, if we descended past it, or if the
   * pending input character is an invalid attribute terminator.
   * @param consumed Locally-tracked consumed count.
   * @param excess Locally-tracked excess count.
   * @param char Pending input character (may be the mismatching char).
   * @param valueLength Value length at the current trie node.
   */
  flushAndEmitLegacyOrReject(t, r, n, i) {
    return this.consumed = t, this.excess = r, this.result === 0 || this.decodeMode === ur.Attribute && (i === 0 || r > 1 || A2(n)) ? 0 : this.emitNotTerminatedNamedEntity();
  }
  /**
   * Parses a named entity.
   *
   * Equivalent to the `Named character reference state` in the HTML spec.
   * @param input The string containing the entity (or a continuation of the entity).
   * @param offset The current offset.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  stateNamedEntity(t, r) {
    const { decodeTree: n } = this, i = t.length, o = this.decodeMode === ur.Strict;
    let { treeIndex: s } = this, { excess: a } = this, { consumed: l } = this, f = n[s];
    for (; r < i; ) {
      for (; (f & (pt.VALUE_LENGTH | pt.FLAG13)) === 0 && (f & pt.JUMP_TABLE) !== 0; ) {
        const d = t.charCodeAt(r), g = f & pt.JUMP_TABLE, y = (f & pt.BRANCH_LENGTH) >> 7;
        if (y === 0) {
          if (d !== g)
            return this.flushAndEmitLegacyOrReject(l, a, d, 0);
          s += 1;
        } else {
          const b = d - g;
          if (b >>> 0 >= y)
            return this.flushAndEmitLegacyOrReject(l, a, d, 0);
          const _ = n[s + 1 + b];
          if (_ === 0)
            return this.flushAndEmitLegacyOrReject(l, a, d, 0);
          s = s + y + _ & 65535;
        }
        if (f = n[s], r += 1, a += 1, r >= i)
          break;
      }
      if (r >= i)
        break;
      if ((f & (pt.VALUE_LENGTH | pt.FLAG13)) === pt.FLAG13) {
        const d = (f & pt.BRANCH_LENGTH) >> 7;
        let { runConsumed: g } = this;
        if (g === 0) {
          const y = t.charCodeAt(r);
          if (y !== (f & pt.JUMP_TABLE))
            return this.flushAndEmitLegacyOrReject(l, a, y, 0);
          r += 1, a += 1, g = 1;
        }
        for (; g < d; ) {
          if (r >= i)
            return this.treeIndex = s, this.excess = a, this.consumed = l, this.runConsumed = g, -1;
          const y = g - 1, _ = n[s + 1 + (y >> 1)] >> ((y & 1) << 3) & 255, I = t.charCodeAt(r);
          if (I !== _)
            return this.runConsumed = 0, this.flushAndEmitLegacyOrReject(l, a, I, 0);
          r += 1, a += 1, g += 1;
        }
        this.runConsumed = 0, s += 1 + (d >> 1), f = n[s];
        continue;
      }
      const u = f >>> 14, h = t.charCodeAt(r);
      if (u !== 0) {
        if (!o && (f & pt.FLAG13) === 0 && (this.result = s, l += a - 1, a = 1), h === bt.SEMI)
          return this.emitNamedEntityData(s, u, l + a);
        if (u === 1)
          return this.flushAndEmitLegacyOrReject(l, a, h, u);
      }
      const E = S2(n, f, s + (u || 1), h);
      if (E < 0)
        return this.flushAndEmitLegacyOrReject(l, a, h, u);
      s = E, f = n[s], r += 1, a += 1;
    }
    return !o && f >>> 14 && (f & pt.FLAG13) === 0 && (this.result = s, l += a - 1, a = 1), this.treeIndex = s, this.excess = a, this.consumed = l, -1;
  }
  /**
   * Emit a named entity that was not terminated with a semicolon.
   * @returns The number of characters consumed.
   */
  emitNotTerminatedNamedEntity() {
    var i;
    const { result: t, decodeTree: r } = this, n = r[t] >>> 14;
    return this.emitNamedEntityData(t, n, this.consumed), (i = this.errors) == null || i.missingSemicolonAfterCharacterReference(), this.consumed;
  }
  /**
   * Emit a named entity.
   * @param result The index of the entity in the decode tree.
   * @param valueLength Encoded value length (header plus any value words).
   * @param consumed The number of characters consumed.
   * @returns The number of characters consumed.
   */
  emitNamedEntityData(t, r, n) {
    const { decodeTree: i } = this;
    return this.emitCodePoint(r === 1 ? i[t] & pt.VALUE_MASK : i[t + 1], n), r === 3 && this.emitCodePoint(i[t + 2], n), n;
  }
  /**
   * Signal to the parser that the end of the input was reached.
   *
   * Remaining data will be emitted and relevant errors will be produced.
   * @returns The number of characters consumed.
   */
  end() {
    var t;
    switch (this.state) {
      case Tt.NamedEntity:
        return this.result !== 0 && (this.decodeMode !== ur.Attribute || this.result === this.treeIndex) ? this.emitNotTerminatedNamedEntity() : 0;
      // Otherwise, emit a numeric entity if we have one.
      case Tt.NumericDecimal:
        return this.emitNumericEntity(0, 2);
      case Tt.NumericHex:
        return this.emitNumericEntity(0, 3);
      case Tt.NumericStart:
        return (t = this.errors) == null || t.absenceOfDigitsInNumericCharacterReference(this.consumed), 0;
      default:
        return 0;
    }
  }
}
function S2(e, t, r, n) {
  const i = (t & pt.BRANCH_LENGTH) >> 7, o = t & pt.JUMP_TABLE;
  if (o) {
    if (i === 0)
      return n === o ? r : -1;
    const l = n - o;
    if (l >>> 0 >= i)
      return -1;
    const f = e[r + l];
    return f === 0 ? -1 : r + i + f - 1 & 65535;
  }
  if (i === 0)
    return -1;
  const s = i + 1 >> 1, a = r + s + i;
  for (let l = 0; l < i; l++) {
    const u = e[r + (l >> 1)] >> ((l & 1) << 3) & 255;
    if (u === n) {
      const h = r + s + l;
      return a + e[h] & 65535;
    }
    if (u > n)
      return -1;
  }
  return -1;
}
var de;
(function(e) {
  e[e.Tab = 9] = "Tab", e[e.NewLine = 10] = "NewLine", e[e.FormFeed = 12] = "FormFeed", e[e.CarriageReturn = 13] = "CarriageReturn", e[e.Space = 32] = "Space", e[e.ExclamationMark = 33] = "ExclamationMark", e[e.Number = 35] = "Number", e[e.Amp = 38] = "Amp", e[e.SingleQuote = 39] = "SingleQuote", e[e.DoubleQuote = 34] = "DoubleQuote", e[e.Dash = 45] = "Dash", e[e.Slash = 47] = "Slash", e[e.Zero = 48] = "Zero", e[e.Nine = 57] = "Nine", e[e.Semi = 59] = "Semi", e[e.Lt = 60] = "Lt", e[e.Eq = 61] = "Eq", e[e.Gt = 62] = "Gt", e[e.Questionmark = 63] = "Questionmark", e[e.UpperA = 65] = "UpperA", e[e.LowerA = 97] = "LowerA", e[e.UpperF = 70] = "UpperF", e[e.LowerF = 102] = "LowerF", e[e.UpperZ = 90] = "UpperZ", e[e.LowerZ = 122] = "LowerZ", e[e.LowerX = 120] = "LowerX", e[e.OpeningSquareBracket = 91] = "OpeningSquareBracket";
})(de || (de = {}));
var J;
(function(e) {
  e[e.Text = 1] = "Text", e[e.BeforeTagName = 2] = "BeforeTagName", e[e.InTagName = 3] = "InTagName", e[e.InSelfClosingTag = 4] = "InSelfClosingTag", e[e.BeforeClosingTagName = 5] = "BeforeClosingTagName", e[e.InClosingTagName = 6] = "InClosingTagName", e[e.AfterClosingTagName = 7] = "AfterClosingTagName", e[e.BeforeAttributeName = 8] = "BeforeAttributeName", e[e.InAttributeName = 9] = "InAttributeName", e[e.AfterAttributeName = 10] = "AfterAttributeName", e[e.BeforeAttributeValue = 11] = "BeforeAttributeValue", e[e.InAttributeValueDq = 12] = "InAttributeValueDq", e[e.InAttributeValueSq = 13] = "InAttributeValueSq", e[e.InAttributeValueNq = 14] = "InAttributeValueNq", e[e.BeforeDeclaration = 15] = "BeforeDeclaration", e[e.InDeclaration = 16] = "InDeclaration", e[e.InProcessingInstruction = 17] = "InProcessingInstruction", e[e.BeforeComment = 18] = "BeforeComment", e[e.CDATASequence = 19] = "CDATASequence", e[e.DeclarationSequence = 20] = "DeclarationSequence", e[e.InSpecialComment = 21] = "InSpecialComment", e[e.InCommentLike = 22] = "InCommentLike", e[e.SpecialStartSequence = 23] = "SpecialStartSequence", e[e.InSpecialTag = 24] = "InSpecialTag", e[e.InPlainText = 25] = "InPlainText", e[e.InEntity = 26] = "InEntity";
})(J || (J = {}));
function xn(e) {
  return e === de.Space || e === de.NewLine || e === de.Tab || e === de.FormFeed || e === de.CarriageReturn;
}
function ci(e) {
  return e === de.Slash || e === de.Gt || xn(e);
}
function I2(e) {
  return e >= de.LowerA && e <= de.LowerZ || e >= de.UpperA && e <= de.UpperZ;
}
var nr;
(function(e) {
  e[e.NoValue = 0] = "NoValue", e[e.Unquoted = 1] = "Unquoted", e[e.Single = 2] = "Single", e[e.Double = 3] = "Double";
})(nr || (nr = {}));
const Ie = {
  Empty: new Uint8Array(0),
  Cdata: new Uint8Array([67, 68, 65, 84, 65, 91]),
  // CDATA[
  CdataEnd: new Uint8Array([93, 93, 62]),
  // ]]>
  CommentEnd: new Uint8Array([45, 45, 33, 62]),
  // `--!>`
  Doctype: new Uint8Array([100, 111, 99, 116, 121, 112, 101]),
  // `doctype`
  IframeEnd: new Uint8Array([60, 47, 105, 102, 114, 97, 109, 101]),
  // `</iframe`
  NoembedEnd: new Uint8Array([
    60,
    47,
    110,
    111,
    101,
    109,
    98,
    101,
    100
  ]),
  // `</noembed`
  NoframesEnd: new Uint8Array([
    60,
    47,
    110,
    111,
    102,
    114,
    97,
    109,
    101,
    115
  ]),
  // `</noframes`
  Plaintext: new Uint8Array([
    60,
    47,
    112,
    108,
    97,
    105,
    110,
    116,
    101,
    120,
    116
  ]),
  // `</plaintext`
  ScriptEnd: new Uint8Array([60, 47, 115, 99, 114, 105, 112, 116]),
  // `<\/script`
  StyleEnd: new Uint8Array([60, 47, 115, 116, 121, 108, 101]),
  // `</style`
  TitleEnd: new Uint8Array([60, 47, 116, 105, 116, 108, 101]),
  // `</title`
  TextareaEnd: new Uint8Array([
    60,
    47,
    116,
    101,
    120,
    116,
    97,
    114,
    101,
    97
  ]),
  // `</textarea`
  XmpEnd: new Uint8Array([60, 47, 120, 109, 112])
  // `</xmp`
}, _2 = /* @__PURE__ */ new Map([
  [Ie.IframeEnd[2], Ie.IframeEnd],
  [Ie.NoembedEnd[2], Ie.NoembedEnd],
  [Ie.Plaintext[2], Ie.Plaintext],
  [Ie.ScriptEnd[2], Ie.ScriptEnd],
  [Ie.TitleEnd[2], Ie.TitleEnd],
  [Ie.XmpEnd[2], Ie.XmpEnd]
]);
class Cb {
  constructor({ xmlMode: t = !1, decodeEntities: r = !0, recognizeSelfClosing: n = t }, i) {
    $(this, "cbs");
    /** The current state the tokenizer is in. */
    $(this, "state", J.Text);
    /** The read buffer. */
    $(this, "buffer", "");
    /** The beginning of the section that is currently being read. */
    $(this, "sectionStart", 0);
    /** The index within the buffer that we are currently looking at. */
    $(this, "index", 0);
    /** The start of the last entity. */
    $(this, "entityStart", 0);
    /** Some behavior, eg. when decoding entities, is done while we are in another state. This keeps track of the other state type. */
    $(this, "baseState", J.Text);
    /** For special parsing behavior inside of script and style tags. */
    $(this, "isSpecial", !1);
    /** Indicates whether the tokenizer has been paused. */
    $(this, "running", !0);
    /** The offset of the current buffer. */
    $(this, "offset", 0);
    $(this, "xmlMode");
    $(this, "decodeEntities");
    $(this, "recognizeSelfClosing");
    $(this, "entityDecoder");
    $(this, "currentSequence", Ie.Empty);
    $(this, "sequenceIndex", 0);
    this.cbs = i, this.xmlMode = t, this.decodeEntities = r, this.recognizeSelfClosing = n, this.entityDecoder = new v2(t ? wb : y2, (o, s) => this.emitCodePoint(o, s));
  }
  reset() {
    this.state = J.Text, this.buffer = "", this.sectionStart = 0, this.index = 0, this.baseState = J.Text, this.isSpecial = !1, this.currentSequence = Ie.Empty, this.sequenceIndex = 0, this.running = !0, this.offset = 0;
  }
  write(t) {
    this.offset += this.buffer.length, this.buffer = t, this.parse();
  }
  end() {
    this.running && this.finish();
  }
  pause() {
    this.running = !1;
  }
  resume() {
    this.running = !0, this.index < this.buffer.length + this.offset && this.parse();
  }
  stateText(t) {
    t === de.Lt || !this.decodeEntities && this.fastForwardTo(de.Lt) ? (this.index > this.sectionStart && this.cbs.ontext(this.sectionStart, this.index), this.state = J.BeforeTagName, this.sectionStart = this.index) : this.decodeEntities && t === de.Amp && this.startEntity();
  }
  enterTagBody() {
    this.currentSequence === Ie.Plaintext ? (this.currentSequence = Ie.Empty, this.state = J.InPlainText) : this.isSpecial ? (this.state = J.InSpecialTag, this.sequenceIndex = 0) : this.state = J.Text;
  }
  /**
   * Match the opening tag name against an HTML text-only tag sequence.
   *
   * Some tags share an initial prefix (`script`/`style`, `title`/`textarea`,
   * `noembed`/`noframes`), so we may switch to an alternate sequence at the
   * first distinguishing byte.  On a successful full match we fall back to
   * the normal tag-name state; a later `>` will enter raw-text, RCDATA, or
   * plaintext mode based on `currentSequence` / `isSpecial`.
   * @param c Current character code point.
   */
  stateSpecialStartSequence(t) {
    const r = t | 32;
    if (this.sequenceIndex < this.currentSequence.length) {
      if (r === this.currentSequence[this.sequenceIndex]) {
        this.sequenceIndex++;
        return;
      }
      if (this.sequenceIndex === 3) {
        if (this.currentSequence === Ie.ScriptEnd && r === Ie.StyleEnd[3]) {
          this.currentSequence = Ie.StyleEnd, this.sequenceIndex = 4;
          return;
        }
        if (this.currentSequence === Ie.TitleEnd && r === Ie.TextareaEnd[3]) {
          this.currentSequence = Ie.TextareaEnd, this.sequenceIndex = 4;
          return;
        }
      } else if (this.sequenceIndex === 4 && this.currentSequence === Ie.NoembedEnd && r === Ie.NoframesEnd[4]) {
        this.currentSequence = Ie.NoframesEnd, this.sequenceIndex = 5;
        return;
      }
    } else if (ci(t)) {
      this.sequenceIndex = 0, this.state = J.InTagName, this.stateInTagName(t);
      return;
    }
    this.isSpecial = !1, this.currentSequence = Ie.Empty, this.sequenceIndex = 0, this.state = J.InTagName, this.stateInTagName(t);
  }
  stateCDATASequence(t) {
    t === Ie.Cdata[this.sequenceIndex] ? ++this.sequenceIndex === Ie.Cdata.length && (this.state = J.InCommentLike, this.currentSequence = Ie.CdataEnd, this.sequenceIndex = 0, this.sectionStart = this.index + 1) : (this.sequenceIndex = 0, this.xmlMode ? (this.state = J.InDeclaration, this.stateInDeclaration(t)) : (this.state = J.InSpecialComment, this.stateInSpecialComment(t)));
  }
  /**
   * When we wait for one specific character, we can speed things up
   * by skipping through the buffer until we find it.
   * @param c Current character code point.
   * @returns Whether the character was found.
   */
  fastForwardTo(t) {
    for (; ++this.index < this.buffer.length + this.offset; )
      if (this.buffer.charCodeAt(this.index - this.offset) === t)
        return !0;
    return this.index = this.buffer.length + this.offset - 1, !1;
  }
  /**
   * Emit a comment token and return to the text state.
   * @param offset Number of characters in the end sequence that have already been matched.
   */
  emitComment(t) {
    this.cbs.oncomment(this.sectionStart, this.index, t), this.sequenceIndex = 0, this.sectionStart = this.index + 1, this.state = J.Text;
  }
  /**
   * Comments and CDATA end with `-->` and `]]>`.
   *
   * Their common qualities are:
   * - Their end sequences have a distinct character they start with.
   * - That character is then repeated, so we have to check multiple repeats.
   * - All characters but the start character of the sequence can be skipped.
   * @param c Current character code point.
   */
  stateInCommentLike(t) {
    !this.xmlMode && this.currentSequence === Ie.CommentEnd && this.sequenceIndex <= 1 && /*
     * We're still at the very start of the comment: the only
     * characters consumed since `<!--` are the dashes that
     * advanced sequenceIndex (0 for `<!-->`, 1 for `<!--->`).
     */
    this.index === this.sectionStart + this.sequenceIndex && t === de.Gt ? this.emitComment(this.sequenceIndex) : this.currentSequence === Ie.CommentEnd && this.sequenceIndex === 2 && t === de.Gt ? this.emitComment(2) : this.currentSequence === Ie.CommentEnd && this.sequenceIndex === this.currentSequence.length - 1 && t !== de.Gt ? this.sequenceIndex = +(t === de.Dash) : t === this.currentSequence[this.sequenceIndex] ? ++this.sequenceIndex === this.currentSequence.length && (this.currentSequence === Ie.CdataEnd ? this.cbs.oncdata(this.sectionStart, this.index, 2) : this.cbs.oncomment(this.sectionStart, this.index, 3), this.sequenceIndex = 0, this.sectionStart = this.index + 1, this.state = J.Text) : this.sequenceIndex === 0 ? this.fastForwardTo(this.currentSequence[0]) && (this.sequenceIndex = 1) : t !== this.currentSequence[this.sequenceIndex - 1] && (this.sequenceIndex = 0);
  }
  /**
   * HTML only allows ASCII alpha characters (a-z and A-Z) at the beginning of a tag name.
   *
   * XML allows a lot more characters here (@see https://www.w3.org/TR/REC-xml/#NT-NameStartChar).
   * We allow anything that wouldn't end the tag.
   * @param c Current character code point.
   */
  isTagStartChar(t) {
    return this.xmlMode ? !ci(t) : I2(t);
  }
  /**
   * Scan raw-text / RCDATA content for the matching end tag.
   *
   * For RCDATA tags (`<title>`, `<textarea>`) entities are decoded inline.
   * For raw-text tags (`<script>`, `<style>`, etc.) we fast-forward to `<`.
   * @param c Current character code point.
   */
  stateInSpecialTag(t) {
    if (this.sequenceIndex === this.currentSequence.length) {
      if (ci(t)) {
        const r = this.index - this.currentSequence.length;
        if (this.sectionStart < r) {
          const n = this.index;
          this.index = r, this.cbs.ontext(this.sectionStart, r), this.index = n;
        }
        this.isSpecial = !1, this.sectionStart = r + 2, this.stateInClosingTagName(t);
        return;
      }
      this.sequenceIndex = 0;
    }
    (t | 32) === this.currentSequence[this.sequenceIndex] ? this.sequenceIndex += 1 : this.sequenceIndex === 0 ? this.currentSequence === Ie.TitleEnd || this.currentSequence === Ie.TextareaEnd ? this.decodeEntities && t === de.Amp && this.startEntity() : this.fastForwardTo(de.Lt) && (this.sequenceIndex = 1) : this.sequenceIndex = +(t === de.Lt);
  }
  stateBeforeTagName(t) {
    var r, n;
    if (t === de.ExclamationMark)
      this.state = J.BeforeDeclaration, this.sectionStart = this.index + 1;
    else if (t === de.Questionmark)
      this.xmlMode ? (this.state = J.InProcessingInstruction, this.sequenceIndex = 0, this.sectionStart = this.index + 1) : (this.state = J.InSpecialComment, this.sectionStart = this.index);
    else if (this.isTagStartChar(t)) {
      this.sectionStart = this.index;
      const i = this.xmlMode || (n = (r = this.cbs).isInForeignContext) != null && n.call(r) ? void 0 : _2.get(t | 32);
      i === void 0 ? this.state = J.InTagName : (this.isSpecial = !0, this.currentSequence = i, this.sequenceIndex = 3, this.state = J.SpecialStartSequence);
    } else t === de.Slash ? this.state = J.BeforeClosingTagName : (this.state = J.Text, this.stateText(t));
  }
  stateInTagName(t) {
    ci(t) && (this.cbs.onopentagname(this.sectionStart, this.index), this.sectionStart = -1, this.state = J.BeforeAttributeName, this.stateBeforeAttributeName(t));
  }
  stateBeforeClosingTagName(t) {
    xn(t) ? this.xmlMode || (this.state = J.InSpecialComment, this.sectionStart = this.index) : t === de.Gt ? (this.state = J.Text, this.xmlMode || (this.sectionStart = this.index + 1)) : (this.state = this.isTagStartChar(t) ? J.InClosingTagName : J.InSpecialComment, this.sectionStart = this.index);
  }
  stateInClosingTagName(t) {
    ci(t) && (this.cbs.onclosetag(this.sectionStart, this.index), this.sectionStart = -1, this.state = J.AfterClosingTagName, this.stateAfterClosingTagName(t));
  }
  stateAfterClosingTagName(t) {
    (t === de.Gt || this.fastForwardTo(de.Gt)) && (this.state = J.Text, this.sectionStart = this.index + 1);
  }
  stateBeforeAttributeName(t) {
    t === de.Gt ? (this.cbs.onopentagend(this.index), this.enterTagBody(), this.sectionStart = this.index + 1) : t === de.Slash ? this.state = J.InSelfClosingTag : xn(t) || (this.state = J.InAttributeName, this.sectionStart = this.index);
  }
  /**
   * Handle `/` before `>` in an opening tag.
   *
   * In HTML mode, text-only tags ignore the self-closing flag and still enter
   * their raw-text/RCDATA/plaintext state unless self-closing tags are being
   * recognized. In XML mode, or for ordinary tags, the tokenizer returns to
   * regular text parsing after emitting the self-closing callback.
   * @param c Current character code point.
   */
  stateInSelfClosingTag(t) {
    if (t === de.Gt) {
      if (this.cbs.onselfclosingtag(this.index), this.sectionStart = this.index + 1, !this.recognizeSelfClosing) {
        this.enterTagBody();
        return;
      }
      this.state = J.Text, this.isSpecial = !1, this.currentSequence = Ie.Empty;
    } else xn(t) || (this.state = J.BeforeAttributeName, this.stateBeforeAttributeName(t));
  }
  stateInAttributeName(t) {
    (t === de.Eq || ci(t)) && (this.cbs.onattribname(this.sectionStart, this.index), this.sectionStart = this.index, this.state = J.AfterAttributeName, this.stateAfterAttributeName(t));
  }
  stateAfterAttributeName(t) {
    t === de.Eq ? this.state = J.BeforeAttributeValue : t === de.Slash || t === de.Gt ? (this.cbs.onattribend(nr.NoValue, this.sectionStart), this.sectionStart = -1, this.state = J.BeforeAttributeName, this.stateBeforeAttributeName(t)) : xn(t) || (this.cbs.onattribend(nr.NoValue, this.sectionStart), this.state = J.InAttributeName, this.sectionStart = this.index);
  }
  stateBeforeAttributeValue(t) {
    t === de.DoubleQuote ? (this.state = J.InAttributeValueDq, this.sectionStart = this.index + 1) : t === de.SingleQuote ? (this.state = J.InAttributeValueSq, this.sectionStart = this.index + 1) : xn(t) || (this.sectionStart = this.index, this.state = J.InAttributeValueNq, this.stateInAttributeValueNoQuotes(t));
  }
  handleInAttributeValue(t, r) {
    t === r || !this.decodeEntities && this.fastForwardTo(r) ? (this.cbs.onattribdata(this.sectionStart, this.index), this.sectionStart = -1, this.cbs.onattribend(r === de.DoubleQuote ? nr.Double : nr.Single, this.index + 1), this.state = J.BeforeAttributeName) : this.decodeEntities && t === de.Amp && this.startEntity();
  }
  stateInAttributeValueDoubleQuotes(t) {
    this.handleInAttributeValue(t, de.DoubleQuote);
  }
  stateInAttributeValueSingleQuotes(t) {
    this.handleInAttributeValue(t, de.SingleQuote);
  }
  stateInAttributeValueNoQuotes(t) {
    xn(t) || t === de.Gt ? (this.cbs.onattribdata(this.sectionStart, this.index), this.sectionStart = -1, this.cbs.onattribend(nr.Unquoted, this.index), this.state = J.BeforeAttributeName, this.stateBeforeAttributeName(t)) : this.decodeEntities && t === de.Amp && this.startEntity();
  }
  /**
   * Distinguish between CDATA, declarations, HTML comments, and HTML bogus
   * comments after `<!`.
   *
   * In HTML mode, only real comments and doctypes stay on declaration paths;
   * everything else becomes a bogus comment terminated by the next `>`.
   * @param c Current character code point.
   */
  stateBeforeDeclaration(t) {
    t === de.OpeningSquareBracket ? (this.state = J.CDATASequence, this.sequenceIndex = 0) : this.xmlMode ? this.state = t === de.Dash ? J.BeforeComment : J.InDeclaration : (t | 32) === Ie.Doctype[0] ? (this.state = J.DeclarationSequence, this.currentSequence = Ie.Doctype, this.sequenceIndex = 1) : t === de.Gt ? (this.cbs.oncomment(this.sectionStart, this.index, 0), this.state = J.Text, this.sectionStart = this.index + 1) : t === de.Dash ? this.state = J.BeforeComment : this.state = J.InSpecialComment;
  }
  /**
   * Continue matching `doctype` after `<!d`.
   *
   * A full `doctype` match stays on the declaration path; any other name falls
   * back to an HTML bogus comment, which matches browser behavior for
   * non-doctype `<!...>` constructs.
   * @param c Current character code point.
   */
  stateDeclarationSequence(t) {
    this.sequenceIndex === this.currentSequence.length ? (this.state = J.InDeclaration, this.stateInDeclaration(t)) : (t | 32) === this.currentSequence[this.sequenceIndex] ? this.sequenceIndex += 1 : t === de.Gt ? (this.cbs.oncomment(this.sectionStart, this.index, 0), this.state = J.Text, this.sectionStart = this.index + 1) : this.state = J.InSpecialComment;
  }
  stateInDeclaration(t) {
    (t === de.Gt || this.fastForwardTo(de.Gt)) && (this.cbs.ondeclaration(this.sectionStart, this.index), this.state = J.Text, this.sectionStart = this.index + 1);
  }
  /**
   * XML processing instructions (`<?...?>`).
   *
   * In HTML mode `<?` is routed to `InSpecialComment` instead, so this
   * state is only reachable in XML mode.
   * @param c Current character code point.
   */
  stateInProcessingInstruction(t) {
    t === de.Questionmark ? this.sequenceIndex = 1 : t === de.Gt && this.sequenceIndex === 1 ? (this.cbs.onprocessinginstruction(this.sectionStart, this.index - 1), this.sequenceIndex = 0, this.state = J.Text, this.sectionStart = this.index + 1) : this.sequenceIndex = Number(this.fastForwardTo(de.Questionmark));
  }
  stateBeforeComment(t) {
    t === de.Dash ? (this.state = J.InCommentLike, this.currentSequence = Ie.CommentEnd, this.sequenceIndex = 0, this.sectionStart = this.index + 1) : this.xmlMode ? this.state = J.InDeclaration : t === de.Gt ? (this.cbs.oncomment(this.sectionStart, this.index, 0), this.state = J.Text, this.sectionStart = this.index + 1) : this.state = J.InSpecialComment;
  }
  stateInSpecialComment(t) {
    (t === de.Gt || this.fastForwardTo(de.Gt)) && (this.cbs.oncomment(this.sectionStart, this.index, 0), this.state = J.Text, this.sectionStart = this.index + 1);
  }
  startEntity() {
    this.baseState = this.state, this.state = J.InEntity, this.entityStart = this.index, this.entityDecoder.startEntity(this.xmlMode ? ur.Strict : this.baseState === J.Text || this.baseState === J.InSpecialTag ? ur.Legacy : ur.Attribute);
  }
  stateInEntity() {
    const t = this.index - this.offset, r = this.entityDecoder.write(this.buffer, t);
    if (r >= 0)
      this.state = this.baseState, r === 0 && (this.index -= 1);
    else {
      if (t < this.buffer.length && this.buffer.charCodeAt(t) === de.Amp) {
        this.state = this.baseState, this.index -= 1;
        return;
      }
      this.index = this.offset + this.buffer.length - 1;
    }
  }
  /**
   * Remove data that has already been consumed from the buffer.
   */
  cleanup() {
    this.running && this.sectionStart !== this.index && (this.state === J.Text || this.state === J.InPlainText || this.state === J.InSpecialTag && this.sequenceIndex === 0 ? (this.cbs.ontext(this.sectionStart, this.index), this.sectionStart = this.index) : (this.state === J.InAttributeValueDq || this.state === J.InAttributeValueSq || this.state === J.InAttributeValueNq) && (this.cbs.onattribdata(this.sectionStart, this.index), this.sectionStart = this.index));
  }
  shouldContinue() {
    return this.index < this.buffer.length + this.offset && this.running;
  }
  /**
   * Iterates through the buffer, calling the function corresponding to the current state.
   *
   * States that are more likely to be hit are higher up, as a performance improvement.
   */
  parse() {
    for (; this.shouldContinue(); ) {
      const t = this.buffer.charCodeAt(this.index - this.offset);
      switch (this.state) {
        case J.Text: {
          this.stateText(t);
          break;
        }
        case J.InPlainText: {
          this.index = this.buffer.length + this.offset - 1;
          break;
        }
        case J.SpecialStartSequence: {
          this.stateSpecialStartSequence(t);
          break;
        }
        case J.InSpecialTag: {
          this.stateInSpecialTag(t);
          break;
        }
        case J.CDATASequence: {
          this.stateCDATASequence(t);
          break;
        }
        case J.DeclarationSequence: {
          this.stateDeclarationSequence(t);
          break;
        }
        case J.InAttributeValueDq: {
          this.stateInAttributeValueDoubleQuotes(t);
          break;
        }
        case J.InAttributeName: {
          this.stateInAttributeName(t);
          break;
        }
        case J.InCommentLike: {
          this.stateInCommentLike(t);
          break;
        }
        case J.InSpecialComment: {
          this.stateInSpecialComment(t);
          break;
        }
        case J.BeforeAttributeName: {
          this.stateBeforeAttributeName(t);
          break;
        }
        case J.InTagName: {
          this.stateInTagName(t);
          break;
        }
        case J.InClosingTagName: {
          this.stateInClosingTagName(t);
          break;
        }
        case J.BeforeTagName: {
          this.stateBeforeTagName(t);
          break;
        }
        case J.AfterAttributeName: {
          this.stateAfterAttributeName(t);
          break;
        }
        case J.InAttributeValueSq: {
          this.stateInAttributeValueSingleQuotes(t);
          break;
        }
        case J.BeforeAttributeValue: {
          this.stateBeforeAttributeValue(t);
          break;
        }
        case J.BeforeClosingTagName: {
          this.stateBeforeClosingTagName(t);
          break;
        }
        case J.AfterClosingTagName: {
          this.stateAfterClosingTagName(t);
          break;
        }
        case J.InAttributeValueNq: {
          this.stateInAttributeValueNoQuotes(t);
          break;
        }
        case J.InSelfClosingTag: {
          this.stateInSelfClosingTag(t);
          break;
        }
        case J.InDeclaration: {
          this.stateInDeclaration(t);
          break;
        }
        case J.BeforeDeclaration: {
          this.stateBeforeDeclaration(t);
          break;
        }
        case J.BeforeComment: {
          this.stateBeforeComment(t);
          break;
        }
        case J.InProcessingInstruction: {
          this.stateInProcessingInstruction(t);
          break;
        }
        case J.InEntity: {
          this.stateInEntity();
          break;
        }
      }
      this.index++;
    }
    this.cleanup();
  }
  finish() {
    this.state === J.InEntity && (this.entityDecoder.end(), this.state = this.baseState), this.handleTrailingData(), this.cbs.onend();
  }
  handleTrailingCommentLikeData(t) {
    if (this.state !== J.InCommentLike)
      return !1;
    if (this.currentSequence === Ie.CdataEnd)
      if (this.xmlMode)
        this.sectionStart < t && this.cbs.oncdata(this.sectionStart, t, 0);
      else {
        const r = this.sectionStart - Ie.Cdata.length - 1;
        this.cbs.oncomment(r, t, 0);
      }
    else {
      const r = this.xmlMode ? 0 : Math.min(this.sequenceIndex, Ie.CommentEnd.length - 1);
      this.cbs.oncomment(this.sectionStart, t, r);
    }
    return !0;
  }
  handleTrailingMarkupDeclaration(t) {
    if (this.xmlMode)
      switch (this.state) {
        case J.InSpecialComment:
        case J.BeforeComment:
        case J.CDATASequence:
        case J.DeclarationSequence:
        case J.InDeclaration:
          return this.cbs.ontext(this.sectionStart, t), !0;
        default:
          return !1;
      }
    switch (this.state) {
      case J.BeforeDeclaration:
      case J.InSpecialComment:
      case J.BeforeComment:
      case J.CDATASequence:
        return this.cbs.oncomment(this.sectionStart, t, 0), !0;
      case J.DeclarationSequence:
        return this.sequenceIndex !== Ie.Doctype.length && this.cbs.oncomment(this.sectionStart, t, 0), !0;
      case J.InDeclaration:
        return !0;
      default:
        return !1;
    }
  }
  /** Handle any trailing data. */
  handleTrailingData() {
    const t = this.buffer.length + this.offset;
    if (!(this.handleTrailingCommentLikeData(t) || this.handleTrailingMarkupDeclaration(t)) && !(this.sectionStart >= t))
      switch (this.state) {
        case J.InTagName:
        case J.BeforeAttributeName:
        case J.BeforeAttributeValue:
        case J.AfterAttributeName:
        case J.InAttributeName:
        case J.InAttributeValueSq:
        case J.InAttributeValueDq:
        case J.InAttributeValueNq:
        case J.InClosingTagName:
          break;
        default:
          this.cbs.ontext(this.sectionStart, t);
      }
  }
  emitCodePoint(t, r) {
    this.baseState !== J.Text && this.baseState !== J.InSpecialTag ? (this.sectionStart < this.entityStart && this.cbs.onattribdata(this.sectionStart, this.entityStart), this.sectionStart = this.entityStart + r, this.index = this.sectionStart - 1, this.cbs.onattribentity(t)) : (this.sectionStart < this.entityStart && this.cbs.ontext(this.sectionStart, this.entityStart), this.sectionStart = this.entityStart + r, this.index = this.sectionStart - 1, this.cbs.ontextentity(t, this.sectionStart));
  }
}
const { fromCodePoint: rE } = String, fi = /* @__PURE__ */ new Set([
  "input",
  "option",
  "optgroup",
  "select",
  "button",
  "datalist",
  "textarea"
]), rt = /* @__PURE__ */ new Set(["p"]), di = /* @__PURE__ */ new Set(["h1", "h2", "h3", "h4", "h5", "h6", "p"]), nE = /* @__PURE__ */ new Set(["thead", "tbody"]), iE = /* @__PURE__ */ new Set(["dd", "dt"]), oE = /* @__PURE__ */ new Set(["rt", "rp"]), R2 = /* @__PURE__ */ new Map([
  ["tr", /* @__PURE__ */ new Set(["tr", "th", "td"])],
  ["th", /* @__PURE__ */ new Set(["th"])],
  ["td", /* @__PURE__ */ new Set(["thead", "th", "td"])],
  ["body", /* @__PURE__ */ new Set(["head", "link", "script"])],
  ["a", /* @__PURE__ */ new Set(["a"])],
  ["li", /* @__PURE__ */ new Set(["li"])],
  ["p", rt],
  ["h1", di],
  ["h2", di],
  ["h3", di],
  ["h4", di],
  ["h5", di],
  ["h6", di],
  ["select", fi],
  ["input", fi],
  ["output", fi],
  ["button", fi],
  ["datalist", fi],
  ["textarea", fi],
  ["option", /* @__PURE__ */ new Set(["option"])],
  ["optgroup", /* @__PURE__ */ new Set(["optgroup", "option"])],
  ["dd", iE],
  ["dt", iE],
  ["address", rt],
  ["article", rt],
  ["aside", rt],
  ["blockquote", rt],
  ["details", rt],
  ["div", rt],
  ["dl", rt],
  ["fieldset", rt],
  ["figcaption", rt],
  ["figure", rt],
  ["footer", rt],
  ["form", rt],
  ["header", rt],
  ["hr", rt],
  ["main", rt],
  ["nav", rt],
  ["ol", rt],
  ["pre", rt],
  ["section", rt],
  ["table", rt],
  ["ul", rt],
  ["rt", oE],
  ["rp", oE],
  ["tbody", nE],
  ["tfoot", nE]
]), sE = "doctype", O2 = /* @__PURE__ */ new Set([
  "area",
  "base",
  "basefont",
  "br",
  "col",
  "command",
  "embed",
  "frame",
  "hr",
  "img",
  "input",
  "isindex",
  "keygen",
  "link",
  "meta",
  "param",
  "source",
  "track",
  "wbr"
]), w2 = /* @__PURE__ */ new Set(["math", "svg"]), aE = /* @__PURE__ */ new Set([
  "mi",
  "mo",
  "mn",
  "ms",
  "mtext",
  "annotation-xml",
  "foreignObject",
  "desc",
  "title"
]), uE = /* @__PURE__ */ new Map([
  ["altglyph", "altGlyph"],
  ["altglyphdef", "altGlyphDef"],
  ["altglyphitem", "altGlyphItem"],
  ["animatecolor", "animateColor"],
  ["animatemotion", "animateMotion"],
  ["animatetransform", "animateTransform"],
  ["clippath", "clipPath"],
  ["feblend", "feBlend"],
  ["fecolormatrix", "feColorMatrix"],
  ["fecomponenttransfer", "feComponentTransfer"],
  ["fecomposite", "feComposite"],
  ["feconvolvematrix", "feConvolveMatrix"],
  ["fediffuselighting", "feDiffuseLighting"],
  ["fedisplacementmap", "feDisplacementMap"],
  ["fedistantlight", "feDistantLight"],
  ["fedropshadow", "feDropShadow"],
  ["feflood", "feFlood"],
  ["fefunca", "feFuncA"],
  ["fefuncb", "feFuncB"],
  ["fefuncg", "feFuncG"],
  ["fefuncr", "feFuncR"],
  ["fegaussianblur", "feGaussianBlur"],
  ["feimage", "feImage"],
  ["femerge", "feMerge"],
  ["femergenode", "feMergeNode"],
  ["femorphology", "feMorphology"],
  ["feoffset", "feOffset"],
  ["fepointlight", "fePointLight"],
  ["fespecularlighting", "feSpecularLighting"],
  ["fespotlight", "feSpotLight"],
  ["fetile", "feTile"],
  ["feturbulence", "feTurbulence"],
  ["foreignobject", "foreignObject"],
  ["glyphref", "glyphRef"],
  ["lineargradient", "linearGradient"],
  ["radialgradient", "radialGradient"],
  ["textpath", "textPath"]
]);
var Pr;
(function(e) {
  e[e.None = 0] = "None", e[e.Svg = 1] = "Svg", e[e.MathML = 2] = "MathML";
})(Pr || (Pr = {}));
const N2 = /\s|\//;
class Wc {
  constructor(t, r = {}) {
    $(this, "options");
    /** The start index of the last event. */
    $(this, "startIndex", 0);
    /** The end index of the last event. */
    $(this, "endIndex", 0);
    /**
     * Store the start index of the current open tag,
     * so we can update the start index for attributes.
     */
    $(this, "openTagStart", 0);
    $(this, "tagname", "");
    $(this, "attribname", "");
    $(this, "attribvalue", "");
    $(this, "attribs", null);
    $(this, "stack", []);
    $(this, "foreignContext");
    $(this, "cbs");
    $(this, "lowerCaseTagNames");
    $(this, "lowerCaseAttributeNames");
    $(this, "recognizeSelfClosing");
    /** We are parsing HTML. Inverse of the `xmlMode` option. */
    $(this, "htmlMode");
    $(this, "tokenizer");
    $(this, "buffers", []);
    $(this, "bufferOffset", 0);
    /** The index of the last written buffer. Used when resuming after a `pause()`. */
    $(this, "writeIndex", 0);
    /** Indicates whether the parser has finished running / `.end` has been called. */
    $(this, "ended", !1);
    var n, i;
    this.options = r, this.cbs = t ?? {}, this.htmlMode = !this.options.xmlMode, this.lowerCaseTagNames = r.lowerCaseTags ?? this.htmlMode, this.lowerCaseAttributeNames = r.lowerCaseAttributeNames ?? this.htmlMode, this.recognizeSelfClosing = r.recognizeSelfClosing ?? !this.htmlMode, this.tokenizer = new (r.Tokenizer ?? Cb)(this.options, this), this.foreignContext = [Pr.None], (i = (n = this.cbs).onparserinit) == null || i.call(n, this);
  }
  // Tokenizer event handlers
  /**
   * @param start Start index for the current parser event.
   * @param endIndex End index for the current parser event.
   * @internal
   */
  ontext(t, r) {
    var i, o;
    const n = this.getSlice(t, r);
    this.endIndex = r - 1, (o = (i = this.cbs).ontext) == null || o.call(i, n), this.startIndex = r;
  }
  /**
   * @param cp Current Unicode code point.
   * @param endIndex End index for the current parser event.
   * @internal
   */
  ontextentity(t, r) {
    var n, i;
    this.endIndex = r - 1, (i = (n = this.cbs).ontext) == null || i.call(n, rE(t)), this.startIndex = r;
  }
  /** @internal */
  isInForeignContext() {
    return this.foreignContext[0] !== Pr.None;
  }
  /**
   * Checks if the current tag is a void element. Override this if you want
   * to specify your own additional void elements.
   * @param name Name of the pseudo selector.
   */
  isVoidElement(t) {
    return this.htmlMode && O2.has(t);
  }
  /**
   * Read a tag name from the buffer.
   *
   * When `lowerCaseTagNames` is enabled (the default in HTML mode), the name
   * is lowercased and may be adjusted for SVG casing or the `image` → `img`
   * alias.
   * @param start Start index of the tag name in the buffer.
   * @param endIndex End index of the tag name in the buffer.
   */
  readTagName(t, r) {
    const n = this.lowerCaseTagNames ? this.getSlice(t, r).toLowerCase() : this.getSlice(t, r);
    if (!(this.lowerCaseTagNames && this.htmlMode))
      return n;
    if (this.foreignContext[0] === Pr.Svg)
      return uE.get(n) ?? n;
    if (this.foreignContext.length > 1) {
      const i = uE.get(n);
      if (i !== void 0 && this.stack.includes(i))
        return i;
    }
    return this.isInForeignContext() ? n : n === "image" ? "img" : n;
  }
  /**
   * @param start Start index for the current parser event.
   * @param endIndex End index for the current parser event.
   * @internal
   */
  onopentagname(t, r) {
    this.endIndex = r, this.emitOpenTag(this.readTagName(t, r));
  }
  emitOpenTag(t) {
    var n, i;
    if (this.openTagStart = this.startIndex, this.tagname = t, this.htmlMode && t === "form" && this.stack.includes("form")) {
      this.tagname = "";
      return;
    }
    const r = this.htmlMode && R2.get(t);
    if (r)
      for (; this.stack.length > 0 && r.has(this.stack[0]); )
        this.popElement(!0);
    this.isVoidElement(t) || (this.stack.unshift(t), this.htmlMode && (t === "svg" ? this.foreignContext.unshift(Pr.Svg) : t === "math" ? this.foreignContext.unshift(Pr.MathML) : aE.has(t) && this.foreignContext.unshift(Pr.None))), (i = (n = this.cbs).onopentagname) == null || i.call(n, t), this.cbs.onopentag && (this.attribs = {});
  }
  endOpenTag(t) {
    var r, n;
    this.startIndex = this.openTagStart, this.attribs && ((n = (r = this.cbs).onopentag) == null || n.call(r, this.tagname, this.attribs, t), this.attribs = null), this.cbs.onclosetag && this.isVoidElement(this.tagname) && this.cbs.onclosetag(this.tagname, !0), this.tagname = "";
  }
  /**
   * @param endIndex End index for the current parser event.
   * @internal
   */
  onopentagend(t) {
    this.endIndex = t, this.endOpenTag(!1), this.startIndex = t + 1;
  }
  /**
   * @param start Start index for the current parser event.
   * @param endIndex End index for the current parser event.
   * @internal
   */
  onclosetag(t, r) {
    var i, o, s, a, l, f;
    this.endIndex = r;
    const n = this.readTagName(t, r);
    if (this.isVoidElement(n))
      this.htmlMode && n === "br" && ((o = (i = this.cbs).onopentagname) == null || o.call(i, "br"), (a = (s = this.cbs).onopentag) == null || a.call(s, "br", {}, !0), (f = (l = this.cbs).onclosetag) == null || f.call(l, "br", !1));
    else {
      const u = this.stack.indexOf(n);
      if (u !== -1) {
        for (let h = 0; h < u; h++)
          this.popElement(!0);
        this.popElement(!1);
      } else this.htmlMode && n === "p" && (this.emitOpenTag("p"), this.closeCurrentTag(!0));
    }
    this.startIndex = r + 1;
  }
  /**
   * @param endIndex End index for the current parser event.
   * @internal
   */
  onselfclosingtag(t) {
    this.endIndex = t, this.recognizeSelfClosing || this.isInForeignContext() ? (this.closeCurrentTag(!1), this.startIndex = t + 1) : this.onopentagend(t);
  }
  /**
   * Pop the top element off the stack, emit a close event, and maintain
   * the foreign context stack.
   * @param implied Whether this close is implied (not from an explicit end tag).
   */
  popElement(t) {
    var n, i;
    const r = this.stack.shift();
    this.htmlMode && (w2.has(r) || aE.has(r)) && this.foreignContext.shift(), (i = (n = this.cbs).onclosetag) == null || i.call(n, r, t);
  }
  closeCurrentTag(t) {
    const r = this.tagname;
    this.endOpenTag(t), this.stack[0] === r && this.popElement(!t);
  }
  /**
   * @param start Start index for the current parser event.
   * @param endIndex End index for the current parser event.
   * @internal
   */
  onattribname(t, r) {
    this.startIndex = t;
    const n = this.getSlice(t, r);
    this.attribname = this.lowerCaseAttributeNames ? n.toLowerCase() : n;
  }
  /**
   * @param start Start index for the current parser event.
   * @param endIndex End index for the current parser event.
   * @internal
   */
  onattribdata(t, r) {
    this.attribvalue += this.getSlice(t, r);
  }
  /**
   * @param cp Current Unicode code point.
   * @internal
   */
  onattribentity(t) {
    this.attribvalue += rE(t);
  }
  /**
   * @param quote Quote type used for the current attribute.
   * @param endIndex End index for the current parser event.
   * @internal
   */
  onattribend(t, r) {
    var n, i;
    this.endIndex = r, (i = (n = this.cbs).onattribute) == null || i.call(n, this.attribname, this.attribvalue, t === nr.Double ? '"' : t === nr.Single ? "'" : t === nr.NoValue ? void 0 : null), this.attribs && !Object.hasOwn(this.attribs, this.attribname) && (this.attribs[this.attribname] = this.attribvalue), this.attribvalue = "";
  }
  getInstructionName(t) {
    const r = t.search(N2);
    let n = r < 0 ? t : t.substr(0, r);
    return this.lowerCaseTagNames && (n = n.toLowerCase()), n;
  }
  /**
   * @param start Start index for the current parser event.
   * @param endIndex End index for the current parser event.
   * @internal
   */
  ondeclaration(t, r) {
    this.endIndex = r;
    const n = this.getSlice(t, r);
    if (this.cbs.onprocessinginstruction) {
      const i = this.htmlMode ? this.lowerCaseTagNames ? sE : n.slice(0, sE.length) : this.getInstructionName(n);
      this.cbs.onprocessinginstruction(`!${i}`, `!${n}`);
    }
    this.startIndex = r + 1;
  }
  /**
   * @param start Start index for the current parser event.
   * @param endIndex End index for the current parser event.
   * @internal
   */
  onprocessinginstruction(t, r) {
    this.endIndex = r;
    const n = this.getSlice(t, r);
    if (this.cbs.onprocessinginstruction) {
      const i = this.getInstructionName(n);
      this.cbs.onprocessinginstruction(`?${i}`, `?${n}`);
    }
    this.startIndex = r + 1;
  }
  /**
   * @param start Start index for the current parser event.
   * @param endIndex End index for the current parser event.
   * @param offset Offset applied when computing parser indices.
   * @internal
   */
  oncomment(t, r, n) {
    var i, o, s, a;
    this.endIndex = r, (o = (i = this.cbs).oncomment) == null || o.call(i, this.getSlice(t, r - n)), (a = (s = this.cbs).oncommentend) == null || a.call(s), this.startIndex = r + 1;
  }
  /**
   * @param start Start index for the current parser event.
   * @param endIndex End index for the current parser event.
   * @param offset Offset applied when computing parser indices.
   * @internal
   */
  oncdata(t, r, n) {
    var o, s, a, l, f, u, h, E, d, g, y, b;
    this.endIndex = r;
    const i = this.getSlice(t, r - n);
    !this.htmlMode || this.options.recognizeCDATA ? ((s = (o = this.cbs).oncdatastart) == null || s.call(o), (l = (a = this.cbs).ontext) == null || l.call(a, i), (u = (f = this.cbs).oncdataend) == null || u.call(f)) : this.isInForeignContext() ? (E = (h = this.cbs).ontext) == null || E.call(h, i) : ((g = (d = this.cbs).oncomment) == null || g.call(d, `[CDATA[${i}]]`), (b = (y = this.cbs).oncommentend) == null || b.call(y)), this.startIndex = r + 1;
  }
  /** @internal */
  onend() {
    var t, r;
    if (this.cbs.onclosetag) {
      this.endIndex = this.startIndex;
      for (let n = 0; n < this.stack.length; n++)
        this.cbs.onclosetag(this.stack[n], !0);
    }
    (r = (t = this.cbs).onend) == null || r.call(t);
  }
  /**
   * Resets the parser to a blank state, ready to parse a new HTML document
   */
  reset() {
    var t, r, n, i;
    (r = (t = this.cbs).onreset) == null || r.call(t), this.tokenizer.reset(), this.tagname = "", this.attribname = "", this.attribvalue = "", this.attribs = null, this.stack.length = 0, this.startIndex = 0, this.endIndex = 0, (i = (n = this.cbs).onparserinit) == null || i.call(n, this), this.buffers.length = 0, this.foreignContext.length = 0, this.foreignContext.unshift(Pr.None), this.bufferOffset = 0, this.writeIndex = 0, this.ended = !1;
  }
  /**
   * Resets the parser, then parses a complete document and
   * pushes it to the handler.
   * @param data Document to parse.
   */
  parseComplete(t) {
    this.reset(), this.end(t);
  }
  getSlice(t, r) {
    if (t === r)
      return "";
    for (; t - this.bufferOffset >= this.buffers[0].length; )
      this.shiftBuffer();
    let n = this.buffers[0].slice(t - this.bufferOffset, r - this.bufferOffset);
    for (; r - this.bufferOffset > this.buffers[0].length; )
      this.shiftBuffer(), n += this.buffers[0].slice(0, r - this.bufferOffset);
    return n;
  }
  shiftBuffer() {
    this.bufferOffset += this.buffers[0].length, this.writeIndex--, this.buffers.shift();
  }
  /**
   * Parses a chunk of data and calls the corresponding callbacks.
   * @param chunk Chunk to parse.
   */
  write(t) {
    var r, n;
    if (this.ended) {
      (n = (r = this.cbs).onerror) == null || n.call(r, new Error(".write() after done!"));
      return;
    }
    this.buffers.push(t), this.tokenizer.running && (this.tokenizer.write(t), this.writeIndex++);
  }
  /**
   * Parses the end of the buffer and clears the stack, calls onend.
   * @param chunk Optional final chunk to parse.
   */
  end(t) {
    var r, n;
    if (this.ended) {
      (n = (r = this.cbs).onerror) == null || n.call(r, new Error(".end() after done!"));
      return;
    }
    t && this.write(t), this.ended = !0, this.tokenizer.end();
  }
  /**
   * Pauses parsing. The parser won't emit events until `resume` is called.
   */
  pause() {
    this.tokenizer.pause();
  }
  /**
   * Resumes parsing after `pause` was called.
   */
  resume() {
    for (this.tokenizer.resume(); this.tokenizer.running && this.writeIndex < this.buffers.length; )
      this.tokenizer.write(this.buffers[this.writeIndex++]);
    this.ended && this.tokenizer.end();
  }
}
var xe;
(function(e) {
  e.Root = "root", e.Text = "text", e.Directive = "directive", e.Comment = "comment", e.Script = "script", e.Style = "style", e.Tag = "tag", e.CDATA = "cdata", e.Doctype = "doctype";
})(xe || (xe = {}));
function Pb(e) {
  return e.type === xe.Tag || e.type === xe.Script || e.type === xe.Style;
}
const Db = xe.Root, Mb = xe.Text, Lb = xe.Directive, xb = xe.Comment, kb = xe.Script, jb = xe.Style, Ub = xe.Tag, $b = xe.CDATA, C2 = xe.Doctype, P2 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  CDATA: $b,
  Comment: xb,
  Directive: Lb,
  Doctype: C2,
  get ElementType() {
    return xe;
  },
  Root: Db,
  Script: kb,
  Style: jb,
  Tag: Ub,
  Text: Mb,
  isTag: Pb
}, Symbol.toStringTag, { value: "Module" }));
class Fb {
  constructor() {
    /** Parent of the node */
    $(this, "parent", null);
    /** Previous sibling */
    $(this, "prev", null);
    /** Next sibling */
    $(this, "next", null);
    /** The start index of the node. Requires `withStartIndices` on the handler to be `true. */
    $(this, "startIndex", null);
    /** The end index of the node. Requires `withEndIndices` on the handler to be `true. */
    $(this, "endIndex", null);
  }
  // Read-write aliases for properties
  /**
   * Same as {@link parent}.
   * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
   */
  get parentNode() {
    return this.parent;
  }
  set parentNode(t) {
    this.parent = t;
  }
  /**
   * Same as {@link prev}.
   * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
   */
  get previousSibling() {
    return this.prev;
  }
  set previousSibling(t) {
    this.prev = t;
  }
  /**
   * Same as {@link next}.
   * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
   */
  get nextSibling() {
    return this.next;
  }
  set nextSibling(t) {
    this.next = t;
  }
  /**
   * Clone this node, and optionally its children.
   * @param recursive Clone child nodes as well.
   * @returns A clone of the node.
   */
  cloneNode(t = !1) {
    return qb(this, t);
  }
}
class qc extends Fb {
  /**
   * @param data The content of the data node
   */
  constructor(r) {
    super();
    $(this, "data");
    this.data = r;
  }
  /**
   * Same as {@link data}.
   * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
   */
  get nodeValue() {
    return this.data;
  }
  set nodeValue(r) {
    this.data = r;
  }
}
class yl extends qc {
  constructor() {
    super(...arguments);
    $(this, "type", xe.Text);
  }
  get nodeType() {
    return 3;
  }
}
class Gb extends qc {
  constructor() {
    super(...arguments);
    $(this, "type", xe.Comment);
  }
  get nodeType() {
    return 8;
  }
}
class zb extends qc {
  constructor(r, n) {
    super(n);
    $(this, "type", xe.Directive);
    $(this, "name");
    /** If this is a doctype, the document type name (parse5 only). */
    $(this, "x-name");
    /** If this is a doctype, the document type public identifier (parse5 only). */
    $(this, "x-publicId");
    /** If this is a doctype, the document type system identifier (parse5 only). */
    $(this, "x-systemId");
    this.name = r;
  }
  get nodeType() {
    return 1;
  }
}
class Hc extends Fb {
  /**
   * @param children Children of the node. Only certain node types can have children.
   */
  constructor(r) {
    super();
    $(this, "children");
    this.children = r;
  }
  // Aliases
  /** First child of the node. */
  get firstChild() {
    return this.children[0] ?? null;
  }
  /** Last child of the node. */
  get lastChild() {
    return this.children.length > 0 ? this.children[this.children.length - 1] : null;
  }
  /**
   * Same as {@link children}.
   * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
   */
  get childNodes() {
    return this.children;
  }
  set childNodes(r) {
    this.children = r;
  }
}
class Bb extends Hc {
  constructor() {
    super(...arguments);
    $(this, "type", xe.CDATA);
  }
  get nodeType() {
    return 4;
  }
}
class Tl extends Hc {
  constructor() {
    super(...arguments);
    $(this, "type", xe.Root);
  }
  get nodeType() {
    return 9;
  }
}
class Vb extends Hc {
  /**
   * @param name Name of the tag, eg. `div`, `span`.
   * @param attribs Object mapping attribute names to attribute values.
   * @param children Children of the node.
   * @param type Node type used for the new node instance.
   */
  constructor(r, n, i = [], o = r === "script" ? xe.Script : r === "style" ? xe.Style : xe.Tag) {
    super(i);
    $(this, "name");
    $(this, "attribs");
    $(this, "type");
    /** Element namespace (parse5 only). */
    $(this, "namespace");
    /** Element attribute namespaces (parse5 only). */
    $(this, "x-attribsNamespace");
    /** Element attribute namespace-related prefixes (parse5 only). */
    $(this, "x-attribsPrefix");
    this.name = r, this.attribs = n, this.type = o;
  }
  get nodeType() {
    return 1;
  }
  // DOM Level 1 aliases
  /**
   * Same as {@link name}.
   * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
   */
  get tagName() {
    return this.name;
  }
  set tagName(r) {
    this.name = r;
  }
  get attributes() {
    return Object.keys(this.attribs).map((r) => {
      var n, i;
      return {
        name: r,
        value: this.attribs[r],
        namespace: (n = this["x-attribsNamespace"]) == null ? void 0 : n[r],
        prefix: (i = this["x-attribsPrefix"]) == null ? void 0 : i[r]
      };
    });
  }
}
function Wt(e) {
  return Pb(e);
}
function Yc(e) {
  return e.type === xe.CDATA;
}
function Ci(e) {
  return e.type === xe.Text;
}
function Wb(e) {
  return e.type === xe.Comment;
}
function D2(e) {
  return e.type === xe.Directive;
}
function M2(e) {
  return e.type === xe.Root;
}
function pr(e) {
  return Object.hasOwn(e, "children");
}
function qb(e, t = !1) {
  let r;
  if (Ci(e))
    r = new yl(e.data);
  else if (Wb(e))
    r = new Gb(e.data);
  else if (Wt(e)) {
    const n = t ? Ja(e.children) : [], i = new Vb(e.name, { ...e.attribs }, n);
    for (const o of n)
      o.parent = i;
    e.namespace != null && (i.namespace = e.namespace), e["x-attribsNamespace"] && (i["x-attribsNamespace"] = { ...e["x-attribsNamespace"] }), e["x-attribsPrefix"] && (i["x-attribsPrefix"] = { ...e["x-attribsPrefix"] }), r = i;
  } else if (Yc(e)) {
    const n = t ? Ja(e.children) : [], i = new Bb(n);
    for (const o of n)
      o.parent = i;
    r = i;
  } else if (M2(e)) {
    const n = t ? Ja(e.children) : [], i = new Tl(n);
    for (const o of n)
      o.parent = i;
    e["x-mode"] && (i["x-mode"] = e["x-mode"]), r = i;
  } else if (D2(e)) {
    const n = new zb(e.name, e.data);
    e["x-name"] != null && (n["x-name"] = e["x-name"], n["x-publicId"] = e["x-publicId"], n["x-systemId"] = e["x-systemId"]), r = n;
  } else
    throw new Error(`Not implemented yet: ${e.type}`);
  return r.startIndex = e.startIndex, r.endIndex = e.endIndex, e.sourceCodeLocation != null && (r.sourceCodeLocation = e.sourceCodeLocation), r;
}
function Ja(e) {
  const t = e.map((r) => qb(r, !0));
  for (let r = 1; r < t.length; r++)
    t[r].prev = t[r - 1], t[r - 1].next = t[r];
  return t;
}
const lE = {
  withStartIndices: !1,
  withEndIndices: !1,
  xmlMode: !1
};
class Zs {
  /**
   * @param callback Called once parsing has completed.
   * @param options Settings for the handler.
   * @param elementCB Callback whenever a tag is closed.
   */
  constructor(t, r, n) {
    /** The elements of the DOM */
    $(this, "dom", []);
    /** The root element for the DOM */
    $(this, "root", new Tl(this.dom));
    /** Called once parsing has completed. */
    $(this, "callback");
    /** Settings for the handler. */
    $(this, "options");
    /** Callback whenever a tag is closed. */
    $(this, "elementCB");
    /** Indicated whether parsing has been completed. */
    $(this, "done", !1);
    /** Stack of open tags. */
    $(this, "tagStack", [this.root]);
    /** A data node that is still being written to. */
    $(this, "lastNode", null);
    /** Reference to the parser instance. Used for location information. */
    $(this, "parser", null);
    typeof r == "function" && (n = r, r = lE), typeof t == "object" && (r = t, t = void 0), this.callback = t ?? null, this.options = r ?? lE, this.elementCB = n ?? null;
  }
  onparserinit(t) {
    this.parser = t;
  }
  // Resets the handler back to starting state
  onreset() {
    this.dom = [], this.root = new Tl(this.dom), this.done = !1, this.tagStack = [this.root], this.lastNode = null, this.parser = null;
  }
  // Signals the handler that parsing is done
  onend() {
    this.done || (this.done = !0, this.parser = null, this.handleCallback(null));
  }
  onerror(t) {
    this.handleCallback(t);
  }
  onclosetag() {
    this.lastNode = null;
    const t = this.tagStack.pop();
    this.options.withEndIndices && this.parser && (t.endIndex = this.parser.endIndex), this.elementCB && this.elementCB(t);
  }
  onopentag(t, r) {
    const n = this.options.xmlMode ? xe.Tag : void 0, i = new Vb(t, r, void 0, n);
    this.addNode(i), this.tagStack.push(i);
  }
  ontext(t) {
    const { lastNode: r } = this;
    if (r && r.type === xe.Text)
      r.data += t, this.options.withEndIndices && this.parser && (r.endIndex = this.parser.endIndex);
    else {
      const n = new yl(t);
      this.addNode(n), this.lastNode = n;
    }
  }
  oncomment(t) {
    if (this.lastNode && this.lastNode.type === xe.Comment) {
      this.lastNode.data += t;
      return;
    }
    const r = new Gb(t);
    this.addNode(r), this.lastNode = r;
  }
  oncommentend() {
    this.lastNode = null;
  }
  oncdatastart() {
    const t = new yl(""), r = new Bb([t]);
    this.addNode(r), t.parent = r, this.lastNode = t;
  }
  oncdataend() {
    this.lastNode = null;
  }
  onprocessinginstruction(t, r) {
    const n = new zb(t, r);
    this.addNode(n);
  }
  handleCallback(t) {
    if (typeof this.callback == "function")
      this.callback(t, this.dom);
    else if (t)
      throw t;
  }
  addNode(t) {
    const r = this.tagStack[this.tagStack.length - 1], n = r.children[r.children.length - 1];
    this.options.withStartIndices && this.parser && (t.startIndex = this.parser.startIndex), this.options.withEndIndices && this.parser && (t.endIndex = this.parser.endIndex), r.children.push(t), n && (t.prev = n, n.next = t), t.parent = r, this.lastNode = null;
  }
}
function ts(e, t, r = !0, n = Number.POSITIVE_INFINITY) {
  return Hb(e, Array.isArray(t) ? t : [t], r, n);
}
function Hb(e, t, r, n) {
  const i = [], o = [Array.isArray(t) ? t : [t]], s = [0];
  for (; ; ) {
    if (s[0] >= o[0].length) {
      if (s.length === 1)
        return i;
      o.shift(), s.shift();
      continue;
    }
    const a = o[0][s[0]++];
    if (e(a) && (i.push(a), --n <= 0))
      return i;
    r && pr(a) && a.children.length > 0 && (s.unshift(0), o.unshift(a.children));
  }
}
function Zc(e, t, r = !0) {
  const n = Array.isArray(t) ? t : [t];
  for (const i of n) {
    if (Wt(i) && e(i))
      return i;
    if (r && pr(i) && i.children.length > 0) {
      const o = Zc(e, i.children, !0);
      if (o)
        return o;
    }
  }
  return null;
}
function Yb(e, t) {
  return (Array.isArray(t) ? t : [t]).some((r) => Wt(r) && e(r) || pr(r) && Yb(e, r.children));
}
function L2(e, t) {
  const r = [], n = [Array.isArray(t) ? t : [t]], i = [0];
  for (; ; ) {
    if (i[0] >= n[0].length) {
      if (n.length === 1)
        return r;
      n.shift(), i.shift();
      continue;
    }
    const o = n[0][i[0]++];
    Wt(o) && e(o) && r.push(o), pr(o) && o.children.length > 0 && (i.unshift(0), n.unshift(o.children));
  }
}
const Js = {
  tag_name(e) {
    return typeof e == "function" ? (t) => Wt(t) && e(t.name) : e === "*" ? Wt : (t) => Wt(t) && t.name === e;
  },
  tag_type(e) {
    return typeof e == "function" ? (t) => e(t.type) : (t) => t.type === e;
  },
  tag_contains(e) {
    return typeof e == "function" ? (t) => Ci(t) && e(t.data) : (t) => Ci(t) && t.data === e;
  }
};
function Jc(e, t) {
  return typeof t == "function" ? (r) => Wt(r) && t(r.attribs[e]) : (r) => Wt(r) && r.attribs[e] === t;
}
function x2(e, t) {
  return (r) => e(r) || t(r);
}
function Zb(e) {
  const t = Object.keys(e).map((r) => {
    const n = e[r];
    return Object.hasOwn(Js, r) ? Js[r](n) : Jc(r, n);
  });
  return t.length === 0 ? null : t.reduce(x2);
}
function k2(e, t) {
  const r = Zb(e);
  return r ? r(t) : !0;
}
function j2(e, t, r, n = Number.POSITIVE_INFINITY) {
  const i = Zb(e);
  return i ? ts(i, t, r, n) : [];
}
function U2(e, t, r = !0) {
  return Array.isArray(t) || (t = [t]), Zc(Jc("id", e), t, r);
}
function ji(e, t, r = !0, n = Number.POSITIVE_INFINITY) {
  return ts(Js.tag_name(e), t, r, n);
}
function $2(e, t, r = !0, n = Number.POSITIVE_INFINITY) {
  return ts(Jc("class", e), t, r, n);
}
function F2(e, t, r = !0, n = Number.POSITIVE_INFINITY) {
  return ts(Js.tag_type(e), t, r, n);
}
function Jb(e) {
  return e === 34 ? "&quot;" : e === 38 ? "&amp;" : e === 39 ? "&apos;" : e === 60 ? "&lt;" : e === 62 ? "&gt;" : "&nbsp;";
}
const G2 = 1342177476, Ka = /["&'<>\u0080-\uFFFF]/g;
function cE(e) {
  return e >= 128 || e >= 32 && e < 64 && (G2 >>> e & 1) === 1;
}
function Kb(e) {
  const { length: t } = e;
  let r, n = 0, i = 0;
  for (; i < t; ) {
    const o = e.charCodeAt(i);
    if (!cE(o)) {
      const a = Math.min(i + 32, t);
      let l = i + 1;
      for (; l < a && !cE(e.charCodeAt(l)); )
        l++;
      if (l < a) {
        i = l;
        continue;
      }
      if (l >= t || (Ka.lastIndex = l, !Ka.test(e)))
        break;
      i = Ka.lastIndex - 1;
      continue;
    }
    if (r === void 0 ? r = e.substring(0, i) : n !== i && (r += e.substring(n, i)), o < 64) {
      r += Jb(o), n = i += 1;
      continue;
    }
    const s = e.codePointAt(i);
    r += `&#x${s.toString(16)};`, s !== o && i++, n = i += 1;
  }
  return r === void 0 ? e : (n < t && (r += e.substr(n)), r);
}
function Xb(e, t) {
  if (e.lastIndex = 0, !e.test(t))
    return t;
  let r = "", n = 0;
  do {
    const i = e.lastIndex - 1;
    n !== i && (r += t.substring(n, i));
    const o = t.charCodeAt(i);
    r += Jb(o), n = i + 1;
  } while (e.test(t));
  return r + t.substring(n);
}
const z2 = /["&\u{A0}]/gu;
function B2(e) {
  return Xb(z2, e);
}
const V2 = /[&<>\u{A0}]/gu;
function W2(e) {
  return Xb(V2, e);
}
const q2 = new Map("altGlyph altGlyphDef altGlyphItem animateColor animateMotion animateTransform clipPath feBlend feColorMatrix feComponentTransfer feComposite feConvolveMatrix feDiffuseLighting feDisplacementMap feDistantLight feDropShadow feFlood feFuncA feFuncB feFuncG feFuncR feGaussianBlur feImage feMerge feMergeNode feMorphology feOffset fePointLight feSpecularLighting feSpotLight feTile feTurbulence foreignObject glyphRef linearGradient radialGradient textPath".split(" ").map((e) => [e.toLowerCase(), e])), H2 = new Map("definitionURL attributeName attributeType baseFrequency baseProfile calcMode clipPathUnits diffuseConstant edgeMode filterUnits glyphRef gradientTransform gradientUnits kernelMatrix kernelUnitLength keyPoints keySplines keyTimes lengthAdjust limitingConeAngle markerHeight markerUnits markerWidth maskContentUnits maskUnits numOctaves pathLength patternContentUnits patternTransform patternUnits pointsAtX pointsAtY pointsAtZ preserveAlpha preserveAspectRatio primitiveUnits refX refY repeatCount repeatDur requiredExtensions requiredFeatures specularConstant specularExponent spreadMethod startOffset stdDeviation stitchTiles surfaceScale systemLanguage tableValues targetX targetY textLength viewBox viewTarget xChannelSelector yChannelSelector zoomAndPan".split(" ").map((e) => [e.toLowerCase(), e])), Y2 = new Set("style script xmp iframe noembed noframes plaintext noscript".split(" ")), Z2 = new Set("area base basefont br col command embed frame hr img input isindex keygen link meta param source track wbr".split(" ")), J2 = /* @__PURE__ */ new Set(["svg", "math"]), K2 = new Set("mi mo mn ms mtext annotation-xml foreignObject desc title".split(" "));
function X2(e, t = {}) {
  const r = "length" in e ? e : [e], n = t.xmlMode ?? !1;
  let i = "";
  for (let o = 0; o < r.length; o++)
    i += eA(r[o], t, n);
  return i;
}
function Qb(e, t, r) {
  let n = "";
  for (let i = 0; i < e.length; i++)
    n += eA(e[i], t, r);
  return n;
}
function eA(e, t, r) {
  switch (e.type) {
    case Db:
      return Qb(e.children, t, r);
    case Lb:
      return `<${e.data}>`;
    case xb:
      return `<!--${e.data}-->`;
    case $b:
      return `<![CDATA[${e.children[0].data}]]>`;
    case kb:
    case jb:
    case Ub:
      return Q2(e, t, r);
    case Mb: {
      const n = e, i = n.data || "";
      return (t.encodeEntities ?? t.decodeEntities) !== !1 && !(!r && n.parent && Y2.has(n.parent.name)) ? r || t.encodeEntities !== "utf8" ? Kb(i) : W2(i) : i;
    }
  }
}
function Q2(e, t, r) {
  r === "foreign" && (e.name = q2.get(e.name) ?? e.name, e.parent && K2.has(e.parent.name) && (r = !1)), !r && J2.has(e.name) && (r = "foreign");
  const { name: n, children: i } = e, o = !r && Z2.has(n);
  let s = `<${n}${t$(e.attribs, t, r)}`;
  return i.length === 0 && (r ? t.selfClosingTags !== !1 : t.selfClosingTags && o) ? s += r ? "/>" : " />" : (s += ">", i.length > 0 && (s += Qb(i, t, r)), o || (s += `</${n}>`)), s;
}
function e$(e) {
  return e.replaceAll('"', "&quot;");
}
function t$(e, t, r) {
  if (!e)
    return "";
  const n = (t.encodeEntities ?? t.decodeEntities) === !1 ? e$ : r || t.encodeEntities !== "utf8" ? Kb : B2, i = r === "foreign", o = !!(t.emptyAttrs ?? r);
  let s = "";
  for (const a in e) {
    if (!Object.hasOwn(e, a))
      continue;
    const l = e[a], f = i ? H2.get(a) ?? a : a;
    s += !o && (l == null || l === "") ? ` ${f}` : ` ${f}="${n(l == null ? "" : String(l))}"`;
  }
  return s;
}
function tA(e, t) {
  return X2(e, t);
}
function r$(e, t) {
  return pr(e) ? e.children.map((r) => tA(r, t)).join("") : "";
}
function ws(e) {
  return Array.isArray(e) ? e.map(ws).join("") : Wt(e) ? e.name === "br" ? `
` : ws(e.children) : Yc(e) ? ws(e.children) : Ci(e) ? e.data : "";
}
function Ks(e) {
  return Array.isArray(e) ? e.map(Ks).join("") : pr(e) && !Wb(e) ? Ks(e.children) : Ci(e) ? e.data : "";
}
function bl(e) {
  return Array.isArray(e) ? e.map(bl).join("") : pr(e) && (e.type === xe.Tag || Yc(e)) ? bl(e.children) : Ci(e) ? e.data : "";
}
function Kc(e) {
  const t = Xs(a$, e);
  return t ? t.name === "feed" ? n$(t) : i$(t) : null;
}
function n$(e) {
  var o;
  const t = e.children, r = {
    type: "atom",
    items: ji("entry", t).map((s) => {
      var E;
      const { children: a } = s, l = { media: rA(a) };
      wt(l, "id", "id", a), wt(l, "title", "title", a);
      const f = (E = Xs("link", a)) == null ? void 0 : E.attribs.href;
      f && (l.link = f);
      const u = Jr("summary", a) || Jr("content", a);
      u && (l.description = u);
      const h = Jr("updated", a);
      return h && (l.pubDate = new Date(h)), l;
    })
  };
  wt(r, "id", "id", t), wt(r, "title", "title", t);
  const n = (o = Xs("link", t)) == null ? void 0 : o.attribs.href;
  n && (r.link = n), wt(r, "description", "subtitle", t);
  const i = Jr("updated", t);
  return i && (r.updated = new Date(i)), wt(r, "author", "email", t, !0), r;
}
function i$(e) {
  var i;
  const t = ((i = Xs("channel", e.children)) == null ? void 0 : i.children) ?? [], r = {
    type: e.name.substr(0, 3),
    id: "",
    items: ji("item", e.children).map((o) => {
      const { children: s } = o, a = { media: rA(s) };
      wt(a, "id", "guid", s), wt(a, "title", "title", s), wt(a, "link", "link", s), wt(a, "description", "description", s);
      const l = Jr("pubDate", s) || Jr("dc:date", s);
      return l && (a.pubDate = new Date(l)), a;
    })
  };
  wt(r, "title", "title", t), wt(r, "link", "link", t), wt(r, "description", "description", t);
  const n = Jr("lastBuildDate", t);
  return n && (r.updated = new Date(n)), wt(r, "author", "managingEditor", t, !0), r;
}
const o$ = ["url", "type", "lang"], s$ = [
  "fileSize",
  "bitrate",
  "framerate",
  "samplingrate",
  "channels",
  "duration",
  "height",
  "width"
];
function rA(e) {
  return ji("media:content", e).map((t) => {
    const { attribs: r } = t, n = {
      medium: r.medium,
      isDefault: !!r.isDefault
    };
    for (const i of o$)
      r[i] && (n[i] = r[i]);
    for (const i of s$)
      r[i] && (n[i] = Number.parseInt(r[i], 10));
    return r.expression && (n.expression = r.expression), n;
  });
}
function Xs(e, t) {
  return ji(e, t, !0, 1)[0];
}
function Jr(e, t, r = !1) {
  return Ks(ji(e, t, r, 1)).trim();
}
function wt(e, t, r, n, i = !1) {
  const o = Jr(r, n, i);
  o && (e[t] = o);
}
function a$(e) {
  return e === "rss" || e === "feed" || e === "rdf:RDF";
}
function u$(e) {
  let t = e.length;
  for (; --t >= 0; ) {
    const r = e[t];
    if (t > 0 && e.lastIndexOf(r, t - 1) >= 0) {
      e.splice(t, 1);
      continue;
    }
    for (let n = r.parent; n; n = n.parent)
      if (e.includes(n)) {
        e.splice(t, 1);
        break;
      }
  }
  return e;
}
var Ft;
(function(e) {
  e[e.DISCONNECTED = 1] = "DISCONNECTED", e[e.PRECEDING = 2] = "PRECEDING", e[e.FOLLOWING = 4] = "FOLLOWING", e[e.CONTAINS = 8] = "CONTAINS", e[e.CONTAINED_BY = 16] = "CONTAINED_BY";
})(Ft || (Ft = {}));
function nA(e, t) {
  const r = [], n = [];
  if (e === t)
    return 0;
  let i = pr(e) ? e : e.parent;
  for (; i; )
    r.unshift(i), i = i.parent;
  for (i = pr(t) ? t : t.parent; i; )
    n.unshift(i), i = i.parent;
  const o = Math.min(r.length, n.length);
  let s = 0;
  for (; s < o && r[s] === n[s]; )
    s++;
  if (s === 0)
    return Ft.DISCONNECTED;
  const a = r[s - 1], l = a.children, f = r[s], u = n[s];
  return l.indexOf(f) > l.indexOf(u) ? a === t ? Ft.FOLLOWING | Ft.CONTAINED_BY : Ft.FOLLOWING : a === e ? Ft.PRECEDING | Ft.CONTAINS : Ft.PRECEDING;
}
function l$(e) {
  return e = e.filter((t, r, n) => !n.includes(t, r + 1)), e.sort((t, r) => {
    const n = nA(t, r);
    return n & Ft.PRECEDING ? -1 : n & Ft.FOLLOWING ? 1 : 0;
  }), e;
}
function rs(e) {
  if (e.prev && (e.prev.next = e.next), e.next && (e.next.prev = e.prev), e.parent) {
    const t = e.parent.children, r = t.lastIndexOf(e);
    r !== -1 && t.splice(r, 1);
  }
  e.next = null, e.prev = null, e.parent = null;
}
function c$(e, t) {
  if (t.prev = e.prev, t.prev && (t.prev.next = t), t.next = e.next, t.next && (t.next.prev = t), t.parent = e.parent, t.parent) {
    const { children: r } = t.parent, n = r.lastIndexOf(e);
    if (n === -1)
      return;
    r[n] = t, e.parent = null;
  }
}
function f$(e, t) {
  if (rs(t), t.next = null, t.parent = e, e.children.push(t) > 1) {
    const r = e.children[e.children.length - 2];
    r.next = t, t.prev = r;
  } else
    t.prev = null;
}
function d$(e, t) {
  rs(t);
  const { parent: r } = e, n = e.next;
  if (t.next = n, t.prev = e, e.next = t, t.parent = r, n) {
    if (n.prev = t, r) {
      const i = r.children;
      i.splice(i.lastIndexOf(n), 0, t);
    }
  } else r && r.children.push(t);
}
function p$(e, t) {
  if (rs(t), t.parent = e, t.prev = null, e.children.unshift(t) === 1)
    t.next = null;
  else {
    const r = e.children[1];
    r.prev = t, t.next = r;
  }
}
function h$(e, t) {
  rs(t);
  const { parent: r } = e;
  if (r) {
    const n = r.children;
    n.splice(n.indexOf(e), 0, t);
  }
  e.prev && (e.prev.next = t), t.parent = r, t.prev = e.prev, t.next = e, e.prev = t;
}
function iA(e) {
  return pr(e) ? e.children : [];
}
function oA(e) {
  return e.parent || null;
}
function m$(e) {
  const t = oA(e);
  if (t != null)
    return iA(t);
  const r = [e];
  let { prev: n, next: i } = e;
  for (; n != null; )
    r.unshift(n), { prev: n } = n;
  for (; i != null; )
    r.push(i), { next: i } = i;
  return r;
}
function E$(e, t) {
  const { attribs: r } = e;
  return r == null ? void 0 : r[t];
}
function g$(e, t) {
  const { attribs: r } = e;
  return r != null && Object.hasOwn(r, t) && r[t] != null;
}
function y$(e) {
  return e.name;
}
function T$(e) {
  let { next: t } = e;
  for (; t !== null && !Wt(t); )
    ({ next: t } = t);
  return t;
}
function b$(e) {
  let { prev: t } = e;
  for (; t !== null && !Wt(t); )
    ({ prev: t } = t);
  return t;
}
const A$ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  get DocumentPosition() {
    return Ft;
  },
  append: d$,
  appendChild: f$,
  compareDocumentPosition: nA,
  existsOne: Yb,
  filter: ts,
  find: Hb,
  findAll: L2,
  findOne: Zc,
  getAttributeValue: E$,
  getChildren: iA,
  getElementById: U2,
  getElements: j2,
  getElementsByClassName: $2,
  getElementsByTagName: ji,
  getElementsByTagType: F2,
  getFeed: Kc,
  getInnerHTML: r$,
  getName: y$,
  getOuterHTML: tA,
  getParent: oA,
  getSiblings: m$,
  getText: ws,
  hasAttrib: g$,
  innerText: bl,
  nextElementSibling: T$,
  prepend: h$,
  prependChild: p$,
  prevElementSibling: b$,
  removeElement: rs,
  removeSubsets: u$,
  replaceElement: c$,
  testElement: k2,
  textContent: Ks,
  uniqueSort: l$
}, Symbol.toStringTag, { value: "Module" }));
function sA(e, t) {
  const r = new Zs(void 0, t);
  return new Wc(r, t).end(e), r.root;
}
function v$(e, t, r) {
  const n = new Zs((i) => e(i, n.root), t, r);
  return new Wc(n, t);
}
const S$ = { xmlMode: !0 };
function I$(e, t = S$) {
  return Kc(sA(e, t).children);
}
const _$ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  DefaultHandler: Zs,
  DomHandler: Zs,
  DomUtils: A$,
  ElementType: P2,
  Parser: Wc,
  get QuoteType() {
    return nr;
  },
  Tokenizer: Cb,
  createDocumentStream: v$,
  getFeed: Kc,
  parseDocument: sA,
  parseFeed: I$
}, Symbol.toStringTag, { value: "Module" })), R$ = /* @__PURE__ */ vb(_$);
var Xa, fE;
function O$() {
  return fE || (fE = 1, Xa = (e) => {
    if (typeof e != "string")
      throw new TypeError("Expected a string");
    return e.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&").replace(/-/g, "\\x2d");
  }), Xa;
}
var Qa = {}, dE;
function w$() {
  if (dE) return Qa;
  dE = 1;
  /*!
   * is-plain-object <https://github.com/jonschlinkert/is-plain-object>
   *
   * Copyright (c) 2014-2017, Jon Schlinkert.
   * Released under the MIT License.
   */
  function e(r) {
    return Object.prototype.toString.call(r) === "[object Object]";
  }
  function t(r) {
    var n, i;
    return e(r) === !1 ? !1 : (n = r.constructor, n === void 0 ? !0 : (i = n.prototype, !(e(i) === !1 || i.hasOwnProperty("isPrototypeOf") === !1)));
  }
  return Qa.isPlainObject = t, Qa;
}
var Ns = { exports: {} }, N$ = Ns.exports, pE;
function C$() {
  return pE || (pE = 1, (function(e) {
    (function(t, r) {
      e.exports ? e.exports = r() : t.parseSrcset = r();
    })(N$, function() {
      return function(t) {
        function r(L) {
          return L === " " || // space
          L === "	" || // horizontal tab
          L === `
` || // new line
          L === "\f" || // form feed
          L === "\r";
        }
        function n(L) {
          var R, D = L.exec(t.substring(b));
          if (D)
            return R = D[0], b += R.length, R;
        }
        for (var i = t.length, o = /^[ \t\n\r\u000c]+/, s = /^[, \t\n\r\u000c]+/, a = /^[^ \t\n\r\u000c]+/, l = /[,]+$/, f = /^\d+$/, u = /^-?(?:[0-9]+|[0-9]*\.[0-9]+)(?:[eE][+-]?[0-9]+)?$/, h, E, d, g, y, b = 0, _ = []; ; ) {
          if (n(s), b >= i)
            return _;
          h = n(a), E = [], h.slice(-1) === "," ? (h = h.replace(l, ""), w()) : I();
        }
        function I() {
          for (n(o), d = "", g = "in descriptor"; ; ) {
            if (y = t.charAt(b), g === "in descriptor")
              if (r(y))
                d && (E.push(d), d = "", g = "after descriptor");
              else if (y === ",") {
                b += 1, d && E.push(d), w();
                return;
              } else if (y === "(")
                d = d + y, g = "in parens";
              else if (y === "") {
                d && E.push(d), w();
                return;
              } else
                d = d + y;
            else if (g === "in parens")
              if (y === ")")
                d = d + y, g = "in descriptor";
              else if (y === "") {
                E.push(d), w();
                return;
              } else
                d = d + y;
            else if (g === "after descriptor" && !r(y))
              if (y === "") {
                w();
                return;
              } else
                g = "in descriptor", b -= 1;
            b += 1;
          }
        }
        function w() {
          var L = !1, R, D, P, O, F = {}, U, z, V, ae, q;
          for (O = 0; O < E.length; O++)
            U = E[O], z = U[U.length - 1], V = U.substring(0, U.length - 1), ae = parseInt(V, 10), q = parseFloat(V), f.test(V) && z === "w" ? ((R || D) && (L = !0), ae === 0 ? L = !0 : R = ae) : u.test(V) && z === "x" ? ((R || D || P) && (L = !0), q < 0 ? L = !0 : D = q) : f.test(V) && z === "h" ? ((P || D) && (L = !0), ae === 0 ? L = !0 : P = ae) : L = !0;
          L ? console && console.log && console.log("Invalid srcset descriptor found in '" + t + "' at '" + U + "'.") : (F.url = h, R && (F.w = R), D && (F.d = D), P && (F.h = P), _.push(F));
        }
      };
    });
  })(Ns)), Ns.exports;
}
var ys = { exports: {} }, hE;
function P$() {
  if (hE) return ys.exports;
  hE = 1;
  var e = String, t = function() {
    return { isColorSupported: !1, reset: e, bold: e, dim: e, italic: e, underline: e, inverse: e, hidden: e, strikethrough: e, black: e, red: e, green: e, yellow: e, blue: e, magenta: e, cyan: e, white: e, gray: e, bgBlack: e, bgRed: e, bgGreen: e, bgYellow: e, bgBlue: e, bgMagenta: e, bgCyan: e, bgWhite: e, blackBright: e, redBright: e, greenBright: e, yellowBright: e, blueBright: e, magentaBright: e, cyanBright: e, whiteBright: e, bgBlackBright: e, bgRedBright: e, bgGreenBright: e, bgYellowBright: e, bgBlueBright: e, bgMagentaBright: e, bgCyanBright: e, bgWhiteBright: e };
  };
  return ys.exports = t(), ys.exports.createColors = t, ys.exports;
}
const D$ = {}, M$ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: D$
}, Symbol.toStringTag, { value: "Module" })), ir = /* @__PURE__ */ vb(M$);
var eu, mE;
function Xc() {
  if (mE) return eu;
  mE = 1;
  let e = /* @__PURE__ */ P$(), t = ir;
  class r extends Error {
    constructor(i, o, s, a, l, f) {
      super(i), this.name = "CssSyntaxError", this.reason = i, l && (this.file = l), a && (this.source = a), f && (this.plugin = f), typeof o < "u" && typeof s < "u" && (typeof o == "number" ? (this.line = o, this.column = s) : (this.line = o.line, this.column = o.column, this.endLine = s.line, this.endColumn = s.column)), this.setMessage(), Error.captureStackTrace && Error.captureStackTrace(this, r);
    }
    setMessage() {
      this.message = this.plugin ? this.plugin + ": " : "", this.message += this.file ? this.file : "<css input>", typeof this.line < "u" && (this.message += ":" + this.line + ":" + this.column), this.message += ": " + this.reason;
    }
    showSourceCode(i) {
      if (!this.source) return "";
      let o = this.source;
      i == null && (i = e.isColorSupported);
      let s = (d) => d, a = (d) => d, l = (d) => d;
      if (i) {
        let { bold: d, gray: g, red: y } = e.createColors(!0);
        a = (b) => d(y(b)), s = (b) => g(b), t && (l = (b) => t(b));
      }
      let f = o.split(/\r?\n/), u = Math.max(this.line - 3, 0), h = Math.min(this.line + 2, f.length), E = String(h).length;
      return f.slice(u, h).map((d, g) => {
        let y = u + 1 + g, b = " " + (" " + y).slice(-E) + " | ";
        if (y === this.line) {
          if (d.length > 160) {
            let I = 20, w = Math.max(0, this.column - I), L = Math.max(
              this.column + I,
              this.endColumn + I
            ), R = d.slice(w, L), D = s(b.replace(/\d/g, " ")) + d.slice(0, Math.min(this.column - 1, I - 1)).replace(/[^\t]/g, " ");
            return a(">") + s(b) + l(R) + `
 ` + D + a("^");
          }
          let _ = s(b.replace(/\d/g, " ")) + d.slice(0, this.column - 1).replace(/[^\t]/g, " ");
          return a(">") + s(b) + l(d) + `
 ` + _ + a("^");
        }
        return " " + s(b) + l(d);
      }).join(`
`);
    }
    toString() {
      let i = this.showSourceCode();
      return i && (i = `

` + i + `
`), this.name + ": " + this.message + i;
    }
  }
  return eu = r, r.default = r, eu;
}
var tu, EE;
function aA() {
  if (EE) return tu;
  EE = 1;
  const e = /[\t\n\f\r "#'()/;[\\\]{}]/, t = {
    after: `
`,
    beforeClose: `
`,
    beforeComment: `
`,
    beforeDecl: `
`,
    beforeOpen: " ",
    beforeRule: `
`,
    colon: ": ",
    commentLeft: " ",
    commentRight: " ",
    emptyBody: "",
    indent: "    ",
    semicolon: !1
  };
  function r(l) {
    return l[0].toUpperCase() + l.slice(1);
  }
  function n(l, f) {
    let u = "@" + f.name, h = f.params ? l.rawValue(f, "params") : "", E = f.raws.afterName;
    return typeof E > "u" ? E = h ? " " : "" : E === "" && h && !e.test(h[0]) && (E = " "), u + E + h;
  }
  function i(l) {
    if (!l.prop.startsWith("--")) return !1;
    let f = l.raws.before;
    return typeof f > "u" || !/[^\s;]$/.test(f);
  }
  function o(l, f, u) {
    let h = u.nodes, E = h.length - 1;
    for (; E > 0 && h[E].type === "comment"; )
      E -= 1;
    let d = l.raw(u, "semicolon"), g = u.type === "document";
    for (let y = h.length - 1; y >= 0; y--) {
      let b = h[y], _ = E !== y || d;
      !_ && y < h.length - 1 && (b.type === "atrule" && !b.nodes || b.type === "decl" && i(b)) && (_ = !0), f.push({
        document: g,
        node: b,
        semicolon: _
      });
    }
  }
  function s(l, f, u, h) {
    let E = l.raw(u, "between", "beforeOpen");
    l.builder(h + E + "{", u, "start");
    let d = u.nodes && u.nodes.length, g = () => {
      let y = d ? l.raw(u, "after") : l.raw(u, "after", "emptyBody");
      y && l.builder(y), l.builder("}", u, "end"), u.type === "rule" && u.raws.ownSemicolon && l.builder(u.raws.ownSemicolon, u, "end");
    };
    d ? (f.push(g), o(l, f, u)) : g();
  }
  class a {
    constructor(f) {
      this.builder = f;
    }
    atrule(f, u) {
      let h = n(this, f);
      if (f.nodes)
        this.block(f, h);
      else {
        let E = (f.raws.between || "") + (u ? ";" : "");
        this.builder(h + E, f);
      }
    }
    beforeAfter(f, u) {
      let h;
      f.type === "decl" ? h = this.raw(f, null, "beforeDecl") : f.type === "comment" ? h = this.raw(f, null, "beforeComment") : u === "before" ? h = this.raw(f, null, "beforeRule") : h = this.raw(f, null, "beforeClose");
      let E = f.parent, d = 0;
      for (; E && E.type !== "root"; )
        d += 1, E = E.parent;
      if (h.includes(`
`)) {
        let g = this.raw(f, null, "indent");
        if (g.length)
          for (let y = 0; y < d; y++) h += g;
      }
      return h;
    }
    block(f, u) {
      let h = this.raw(f, "between", "beforeOpen");
      this.builder(u + h + "{", f, "start");
      let E;
      f.nodes && f.nodes.length ? (this.body(f), E = this.raw(f, "after")) : E = this.raw(f, "after", "emptyBody"), E && this.builder(E), this.builder("}", f, "end");
    }
    body(f) {
      let u = a.prototype, h = ["atrule", "block", "body", "rule", "stringify"].every(
        (d) => this[d] === u[d]
      ), E = [];
      for (o(this, E, f); E.length > 0; ) {
        let d = E.pop();
        if (typeof d == "function") {
          d();
          continue;
        }
        let g = d.node, y = this.raw(g, "before");
        y && this.builder(y), h && g.type === "rule" ? s(this, E, g, this.rawValue(g, "selector")) : h && g.type === "atrule" && g.nodes ? s(this, E, g, n(this, g)) : this.stringify(g, d.semicolon);
      }
    }
    comment(f) {
      let u = this.raw(f, "left", "commentLeft"), h = this.raw(f, "right", "commentRight");
      this.builder("/*" + u + f.text + h + "*/", f);
    }
    decl(f, u) {
      let h = f.raws, E = this.raw(f, "between", "colon"), d = f.prop + E + this.rawValue(f, "value");
      f.important && (d += h.important || " !important"), u && (d += ";"), this.builder(d, f);
    }
    document(f) {
      this.body(f);
    }
    raw(f, u, h) {
      let E;
      if (h || (h = u), u && (E = f.raws[u], typeof E < "u"))
        return E;
      let d = f.parent;
      if (h === "before" && (!d || d.type === "root" && d.first === f || d && d.type === "document"))
        return "";
      if (!d) return t[h];
      let g = f.root(), y = g.rawCache || (g.rawCache = {});
      if (typeof y[h] < "u")
        return y[h];
      if (h === "before" || h === "after")
        return this.beforeAfter(f, h);
      {
        let b = "raw" + r(h);
        this[b] ? E = this[b](g, f) : g.walk((_) => {
          if (E = _.raws[u], typeof E < "u") return !1;
        });
      }
      return typeof E > "u" && (E = t[h]), y[h] = E, E;
    }
    rawBeforeClose(f) {
      let u;
      return f.walk((h) => {
        if (h.nodes && h.nodes.length > 0 && typeof h.raws.after < "u")
          return u = h.raws.after, u.includes(`
`) && (u = u.replace(/[^\n]+$/, "")), !1;
      }), u && (u = u.replace(/\S/g, "")), u;
    }
    rawBeforeComment(f, u) {
      let h;
      return f.walkComments((E) => {
        if (typeof E.raws.before < "u")
          return h = E.raws.before, h.includes(`
`) && (h = h.replace(/[^\n]+$/, "")), !1;
      }), typeof h > "u" ? h = this.raw(u, null, "beforeDecl") : h && (h = h.replace(/\S/g, "")), h;
    }
    rawBeforeDecl(f, u) {
      let h;
      return f.walkDecls((E) => {
        if (typeof E.raws.before < "u")
          return h = E.raws.before, h.includes(`
`) && (h = h.replace(/[^\n]+$/, "")), !1;
      }), typeof h > "u" ? h = this.raw(u, null, "beforeRule") : h && (h = h.replace(/\S/g, "")), h;
    }
    rawBeforeOpen(f) {
      let u;
      return f.walk((h) => {
        if (h.type !== "decl" && (u = h.raws.between, typeof u < "u"))
          return !1;
      }), u;
    }
    rawBeforeRule(f) {
      let u;
      return f.walk((h) => {
        if (h.nodes && (h.parent !== f || f.first !== h) && typeof h.raws.before < "u")
          return u = h.raws.before, u.includes(`
`) && (u = u.replace(/[^\n]+$/, "")), !1;
      }), u && (u = u.replace(/\S/g, "")), u;
    }
    rawColon(f) {
      let u;
      return f.walkDecls((h) => {
        if (typeof h.raws.between < "u")
          return u = h.raws.between.replace(/[^\s:]/g, ""), !1;
      }), u;
    }
    rawEmptyBody(f) {
      let u;
      return f.walk((h) => {
        if (h.nodes && h.nodes.length === 0 && (u = h.raws.after, typeof u < "u"))
          return !1;
      }), u;
    }
    rawIndent(f) {
      if (f.raws.indent) return f.raws.indent;
      let u;
      return f.walk((h) => {
        let E = h.parent;
        if (E && E !== f && E.parent && E.parent === f && typeof h.raws.before < "u") {
          let d = h.raws.before.split(`
`);
          return u = d[d.length - 1], u = u.replace(/\S/g, ""), !1;
        }
      }), u;
    }
    rawSemicolon(f) {
      let u;
      return f.walk((h) => {
        if (h.nodes && h.nodes.length && h.last.type === "decl" && (u = h.raws.semicolon, typeof u < "u"))
          return !1;
      }), u;
    }
    rawValue(f, u) {
      let h = f[u], E = f.raws[u];
      return E && E.value === h ? E.raw : h;
    }
    root(f) {
      !(f.parent && f.parent.type === "document") && f.source && f.source.input.hasBOM && this.builder("\uFEFF", f, "start"), this.body(f), f.raws.after && this.builder(f.raws.after);
    }
    rule(f) {
      this.block(f, this.rawValue(f, "selector")), f.raws.ownSemicolon && this.builder(f.raws.ownSemicolon, f, "end");
    }
    stringify(f, u) {
      if (!this[f.type])
        throw new Error(
          "Unknown AST node type " + f.type + ". Maybe you need to change PostCSS stringifier."
        );
      this[f.type](f, u);
    }
  }
  return tu = a, a.default = a, tu;
}
var ru, gE;
function Oa() {
  if (gE) return ru;
  gE = 1;
  let e = aA();
  const t = /(<)(\/?style\b)/gi, r = /(<)(!--)/g;
  function n(a) {
    return a.includes("<") ? a.replace(t, "\\3c $2").replace(r, "\\3c $2") : a;
  }
  function i(a, l, f) {
    let u = [], h = 0, E = 0;
    for (let d = 0; d < a.length; d += 3) {
      let g = E, y = h + a[d].length;
      for (; h < y; )
        l[h] === f[E] ? (h += 1, E += 1) : (h += 1, E += 4);
      u.push(f.slice(g, E));
    }
    return u;
  }
  class o extends e {
    escapeHTML(l) {
      let f = this.builder, u, h;
      if (this.builder = (d, g, y) => {
        u ? (h += d, u.push(d, g, y)) : d.includes("<") ? (h = d, u = [d, g, y]) : f(d, g, y);
      }, l(), this.builder = f, !u) return;
      let E = n(h);
      if (E === h)
        for (let d = 0; d < u.length; d += 3)
          f(u[d], u[d + 1], u[d + 2]);
      else {
        let d = i(u, h, E);
        for (let g = 0; g < u.length; g += 3)
          f(d[g / 3], u[g + 1], u[g + 2]);
      }
    }
    root(l) {
      l.parent && l.parent.type === "document" ? (this.escapeHTML(() => this.body(l)), l.raws.after && this.builder(l.raws.after)) : this.escapeHTML(() => super.root(l));
    }
  }
  function s(a, l) {
    let f = new o(l);
    a.type === "root" || a.type === "document" ? f.stringify(a) : f.escapeHTML(() => f.stringify(a));
  }
  return ru = s, s.default = s, ru;
}
var Ts = {}, yE;
function wa() {
  return yE || (yE = 1, Ts.isClean = Symbol("isClean"), Ts.my = Symbol("my")), Ts;
}
var nu, TE;
function Na() {
  if (TE) return nu;
  TE = 1;
  let e = Xc(), t = aA(), r = Oa(), { isClean: n, my: i } = wa();
  function o(l, f) {
    let u = new l.constructor(), h = [[l, u, f]];
    for (; h.length > 0; ) {
      let [E, d, g] = h.pop();
      for (let y in E) {
        if (!Object.prototype.hasOwnProperty.call(E, y) || y === "proxyCache") continue;
        let b = E[y], _ = typeof b;
        if (y === "parent" && _ === "object")
          g && (d[y] = g);
        else if (y === "source")
          d[y] = b;
        else if (Array.isArray(b)) {
          let I = [];
          d[y] = I;
          for (let w of b) {
            let L = new w.constructor();
            I.push(L), h.push([w, L, d]);
          }
        } else {
          if (_ === "object" && b !== null) {
            let I = new b.constructor();
            h.push([b, I, void 0]), b = I;
          }
          d[y] = b;
        }
      }
    }
    return u;
  }
  function s(l, f) {
    if (f && typeof f.offset < "u")
      return f.offset;
    let u = 1, h = 1, E = 0;
    for (let d = 0; d < l.length; d++) {
      if (h === f.line && u === f.column) {
        E = d;
        break;
      }
      l[d] === `
` ? (u = 1, h += 1) : u += 1;
    }
    return E;
  }
  class a {
    get proxyOf() {
      return this;
    }
    constructor(f = {}) {
      this.raws = {}, this[n] = !1, this[i] = !0;
      for (let u of Object.keys(f))
        if (u !== "__proto__")
          if (u === "nodes") {
            this.nodes = [];
            for (let h of f[u])
              typeof h.clone == "function" && h.parent ? this.append(h.clone()) : this.append(h);
          } else
            this[u] = f[u];
    }
    addToError(f) {
      if (f.postcssNode = this, f.stack && this.source && /\n\s{4}at /.test(f.stack)) {
        let u = this.source;
        f.stack = f.stack.replace(
          /\n\s{4}at /,
          `$&${u.input.from}:${u.start.line}:${u.start.column}$&`
        );
      }
      return f;
    }
    after(f) {
      return this.parent.insertAfter(this, f), this;
    }
    assign(f = {}) {
      for (let u in f)
        this[u] = f[u];
      return this;
    }
    before(f) {
      return this.parent.insertBefore(this, f), this;
    }
    cleanRaws(f) {
      delete this.raws.before, delete this.raws.after, f || delete this.raws.between;
    }
    clone(f = {}) {
      let u = o(this);
      for (let h in f)
        u[h] = f[h];
      return u;
    }
    cloneAfter(f = {}) {
      let u = this.clone(f);
      return this.parent.insertAfter(this, u), u;
    }
    cloneBefore(f = {}) {
      let u = this.clone(f);
      return this.parent.insertBefore(this, u), u;
    }
    error(f, u = {}) {
      if (this.source) {
        let { end: h, start: E } = this.rangeBy(u);
        return this.source.input.error(
          f,
          { column: E.column, line: E.line },
          { column: h.column, line: h.line },
          u
        );
      }
      return new e(f);
    }
    getProxyProcessor() {
      return {
        get(f, u) {
          return u === "proxyOf" ? f : u === "root" ? () => f.root().toProxy() : f[u];
        },
        set(f, u, h) {
          return f[u] === h || (f[u] = h, (u === "prop" || u === "value" || u === "name" || u === "params" || u === "important" || /* c8 ignore next */
          u === "text") && f.markDirty()), !0;
        }
      };
    }
    /* c8 ignore next 3 */
    markClean() {
      this[n] = !0;
    }
    markDirty() {
      if (this[n]) {
        this[n] = !1;
        let f = this;
        for (; f = f.parent; )
          f[n] = !1;
      }
    }
    next() {
      if (!this.parent) return;
      let f = this.parent.index(this);
      return this.parent.nodes[f + 1];
    }
    positionBy(f = {}) {
      let u = "document" in this.source.input ? this.source.input.document : this.source.input.css, h = {
        column: this.source.start.column,
        line: this.source.start.line,
        offset: s(u, this.source.start)
      };
      if (f.index)
        h = this.positionInside(f.index);
      else if (f.word) {
        let d = u.slice(
          s(u, this.source.start),
          this.rangeBy().end.offset
        ).indexOf(f.word);
        d !== -1 && (h = this.positionInside(d));
      }
      return h;
    }
    positionInside(f) {
      let u = this.source.start.column, h = this.source.start.line, E = "document" in this.source.input ? this.source.input.document : this.source.input.css, d = s(E, this.source.start), g = d + f;
      for (let y = d; y < g; y++)
        E[y] === `
` ? (u = 1, h += 1) : u += 1;
      return { column: u, line: h, offset: g };
    }
    prev() {
      if (!this.parent) return;
      let f = this.parent.index(this);
      return this.parent.nodes[f - 1];
    }
    rangeBy(f = {}) {
      let u = "document" in this.source.input ? this.source.input.document : this.source.input.css, h = {
        column: this.source.start.column,
        line: this.source.start.line,
        offset: s(u, this.source.start)
      }, E = this.source.end ? {
        column: this.source.end.column + 1,
        line: this.source.end.line,
        offset: typeof this.source.end.offset == "number" ? (
          // `source.end.offset` is exclusive, so we don't need to add 1
          this.source.end.offset
        ) : (
          // Since line/column in this.source.end is inclusive,
          // the `sourceOffset(... , this.source.end)` returns an inclusive offset.
          // So, we add 1 to convert it to exclusive.
          s(u, this.source.end) + 1
        )
      } : {
        column: h.column + 1,
        line: h.line,
        offset: h.offset + 1
      };
      if (f.word) {
        let g = u.slice(
          s(u, this.source.start),
          E.offset
        ).indexOf(f.word);
        g !== -1 && (h = this.positionInside(g), E = this.positionInside(g + f.word.length));
      } else
        f.start ? h = {
          column: f.start.column,
          line: f.start.line,
          offset: s(u, f.start)
        } : typeof f.index == "number" && (h = this.positionInside(f.index)), f.end ? E = {
          column: f.end.column,
          line: f.end.line,
          offset: s(u, f.end)
        } : typeof f.endIndex == "number" ? E = this.positionInside(f.endIndex) : typeof f.index == "number" && (E = this.positionInside(f.index + 1));
      return (E.line < h.line || E.line === h.line && E.column <= h.column) && (E = {
        column: h.column + 1,
        line: h.line,
        offset: h.offset + 1
      }), { end: E, start: h };
    }
    raw(f, u) {
      return new t().raw(this, f, u);
    }
    remove() {
      return this.parent && this.parent.removeChild(this), this.parent = void 0, this;
    }
    replaceWith(...f) {
      if (this.parent) {
        let u = this, h = !1;
        for (let E of f)
          E === this ? h = !0 : h ? (this.parent.insertAfter(u, E), u = E) : this.parent.insertBefore(u, E);
        h || this.remove();
      }
      return this;
    }
    root() {
      let f = this;
      for (; f.parent && f.parent.type !== "document"; )
        f = f.parent;
      return f;
    }
    toJSON(f, u) {
      let h = u == null;
      u = u || /* @__PURE__ */ new Map();
      let E = [], d = [[this, E, 0]];
      for (let y = 0; y < d.length; y++) {
        let [b, _, I] = d[y], w = {};
        _[I] = w;
        for (let L in b) {
          if (!Object.prototype.hasOwnProperty.call(b, L) || L === "parent" || L === "proxyCache") continue;
          let R = b[L];
          if (Array.isArray(R)) {
            let D = [];
            w[L] = D;
            for (let P = 0; P < R.length; P++) {
              let O = R[P];
              typeof O == "object" && O.toJSON ? O.toJSON === a.prototype.toJSON ? d.push([O, D, P]) : D[P] = O.toJSON(null, u) : D[P] = O;
            }
          } else if (typeof R == "object" && R.toJSON)
            R.toJSON === a.prototype.toJSON ? d.push([R, w, L]) : w[L] = R.toJSON(null, u);
          else if (L === "source") {
            if (R == null) continue;
            let D = u.get(R.input);
            D == null && (D = u.size, u.set(R.input, D)), w[L] = {
              end: R.end,
              inputId: D,
              start: R.start
            };
          } else
            w[L] = R;
        }
      }
      let g = E[0];
      return h && (g.inputs = [...u.keys()].map((y) => y.toJSON())), g;
    }
    toProxy() {
      return this.proxyCache || (this.proxyCache = new Proxy(this, this.getProxyProcessor())), this.proxyCache;
    }
    toString(f = r) {
      f.stringify && (f = f.stringify);
      let u = "";
      return f(this, (h) => {
        u += h;
      }), u;
    }
    warn(f, u, h = {}) {
      let E = { node: this };
      for (let d in h) E[d] = h[d];
      return f.warn(u, E);
    }
  }
  return nu = a, a.default = a, nu;
}
var iu, bE;
function Ca() {
  if (bE) return iu;
  bE = 1;
  let e = Na();
  class t extends e {
    constructor(n) {
      super(n), this.type = "comment";
    }
  }
  return iu = t, t.default = t, iu;
}
var ou, AE;
function Pa() {
  if (AE) return ou;
  AE = 1;
  let e = Na();
  class t extends e {
    get variable() {
      return this.prop.startsWith("--") || this.prop[0] === "$";
    }
    constructor(n) {
      n && typeof n.value < "u" && typeof n.value != "string" && (n = { ...n, value: String(n.value) }), super(n), this.type = "decl";
    }
  }
  return ou = t, t.default = t, ou;
}
var su, vE;
function an() {
  if (vE) return su;
  vE = 1;
  let e = Ca(), t = Pa(), r = Na(), { isClean: n, my: i } = wa(), o, s, a, l;
  function f(E) {
    let d = E.slice();
    for (; d.length > 0; ) {
      let g = d.pop();
      if (delete g.source, g.nodes) {
        g.nodes = g.nodes.slice();
        for (let y of g.nodes) d.push(y);
      }
    }
    return E.slice();
  }
  function u(E) {
    let d = [E];
    for (; d.length > 0; ) {
      let g = d.pop();
      if (g[n] = !1, g.proxyOf.nodes)
        for (let y of g.proxyOf.nodes) d.push(y);
    }
  }
  class h extends r {
    get first() {
      if (this.proxyOf.nodes)
        return this.proxyOf.nodes[0];
    }
    get last() {
      if (this.proxyOf.nodes)
        return this.proxyOf.nodes[this.proxyOf.nodes.length - 1];
    }
    append(...d) {
      for (let g of d) {
        let y = this.normalize(g, this.last);
        for (let b of y) this.proxyOf.nodes.push(b);
      }
      return this.markDirty(), this;
    }
    cleanRaws(d) {
      let g = [this];
      for (; g.length > 0; ) {
        let y = g.pop();
        if (y !== this && y.cleanRaws !== h.prototype.cleanRaws) {
          y.cleanRaws(d);
          continue;
        }
        if (r.prototype.cleanRaws.call(y, d), y.nodes)
          for (let b of y.nodes) g.push(b);
      }
    }
    each(d) {
      if (!this.proxyOf.nodes) return;
      let g = this.getIterator(), y, b;
      for (; this.indexes[g] < this.proxyOf.nodes.length && (y = this.indexes[g], b = d(this.proxyOf.nodes[y], y), b !== !1); )
        this.indexes[g] += 1;
      return delete this.indexes[g], b;
    }
    every(d) {
      return this.nodes.every(d);
    }
    getIterator() {
      this.lastEach || (this.lastEach = 0), this.indexes || (this.indexes = {}), this.lastEach += 1;
      let d = this.lastEach;
      return this.indexes[d] = 0, d;
    }
    getProxyProcessor() {
      return {
        get(d, g) {
          return g === "proxyOf" ? d : d[g] ? g === "each" || typeof g == "string" && g.startsWith("walk") ? (...y) => d[g](
            ...y.map((b) => typeof b == "function" ? (_, I) => b(_.toProxy(), I) : b)
          ) : g === "every" || g === "some" ? (y) => d[g](
            (b, ..._) => y(b.toProxy(), ..._)
          ) : g === "root" ? () => d.root().toProxy() : g === "nodes" ? d.nodes.map((y) => y.toProxy()) : g === "first" || g === "last" ? d[g].toProxy() : d[g] : d[g];
        },
        set(d, g, y) {
          return d[g] === y || (d[g] = y, (g === "name" || g === "params" || g === "selector") && d.markDirty()), !0;
        }
      };
    }
    index(d) {
      return typeof d == "number" ? d : (d.proxyOf && (d = d.proxyOf), this.proxyOf.nodes.indexOf(d));
    }
    insertAfter(d, g) {
      let y = this.index(d), b = this.normalize(g, this.proxyOf.nodes[y]).reverse();
      y = this.index(d);
      for (let I of b) this.proxyOf.nodes.splice(y + 1, 0, I);
      let _;
      for (let I in this.indexes)
        _ = this.indexes[I], y < _ && (this.indexes[I] = _ + b.length);
      return this.markDirty(), this;
    }
    insertBefore(d, g) {
      let y = this.index(d), b = y === 0 ? "prepend" : !1, _ = this.normalize(
        g,
        this.proxyOf.nodes[y],
        b
      ).reverse();
      y = this.index(d);
      for (let w of _) this.proxyOf.nodes.splice(y, 0, w);
      let I;
      for (let w in this.indexes)
        I = this.indexes[w], y <= I && (this.indexes[w] = I + _.length);
      return this.markDirty(), this;
    }
    normalize(d, g) {
      if (typeof d == "string")
        d = f(s(d).nodes);
      else if (typeof d > "u")
        d = [];
      else if (Array.isArray(d)) {
        d = d.slice(0);
        for (let b of d)
          b.parent && b.parent.removeChild(b, "ignore");
      } else if (d.type === "root" && this.type !== "document") {
        d = d.nodes.slice(0);
        for (let b of d)
          b.parent && b.parent.removeChild(b, "ignore");
      } else if (d.type)
        d = [d];
      else if (d.prop) {
        if (typeof d.value > "u")
          throw new Error("Value field is missed in node creation");
        typeof d.value != "string" && (d.value = String(d.value)), d = [new t(d)];
      } else if (d.selector || d.selectors)
        d = [new l(d)];
      else if (d.name)
        d = [new o(d)];
      else if (d.text)
        d = [new e(d)];
      else
        throw new Error("Unknown node type in node creation");
      return d.map((b) => (b[i] || h.rebuild(b), b = b.proxyOf, b.parent && b.parent.removeChild(b), b[n] && u(b), b.raws || (b.raws = {}), typeof b.raws.before > "u" && g && typeof g.raws.before < "u" && (b.raws.before = g.raws.before.replace(/\S/g, "")), b.parent = this.proxyOf, b));
    }
    prepend(...d) {
      d = d.reverse();
      for (let g of d) {
        let y = this.normalize(g, this.first, "prepend").reverse();
        for (let b of y) this.proxyOf.nodes.unshift(b);
        for (let b in this.indexes)
          this.indexes[b] = this.indexes[b] + y.length;
      }
      return this.markDirty(), this;
    }
    push(d) {
      return d.parent = this, this.proxyOf.nodes.push(d), this;
    }
    removeAll() {
      for (let d of this.proxyOf.nodes) d.parent = void 0;
      return this.proxyOf.nodes = [], this.markDirty(), this;
    }
    removeChild(d) {
      d = this.index(d), this.proxyOf.nodes[d].parent = void 0, this.proxyOf.nodes.splice(d, 1);
      let g;
      for (let y in this.indexes)
        g = this.indexes[y], g >= d && (this.indexes[y] = g - 1);
      return this.markDirty(), this;
    }
    replaceValues(d, g, y) {
      return y || (y = g, g = {}), this.walkDecls((b) => {
        g.props && !g.props.includes(b.prop) || g.fast && !b.value.includes(g.fast) || (b.value = b.value.replace(d, y));
      }), this.markDirty(), this;
    }
    some(d) {
      return this.nodes.some(d);
    }
    walk(d) {
      if (!this.proxyOf.nodes) return;
      let g = [{ iterator: this.getIterator(), node: this.proxyOf }];
      for (; g.length > 0; ) {
        let { iterator: y, node: b } = g[g.length - 1], _ = b.indexes[y];
        if (_ >= b.proxyOf.nodes.length) {
          delete b.indexes[y], g.pop();
          let L = g[g.length - 1];
          L && (L.node.indexes[L.iterator] += 1);
          continue;
        }
        let I = b.proxyOf.nodes[_], w;
        try {
          w = d(I, _);
        } catch (L) {
          throw I.addToError(L);
        }
        if (w === !1) {
          for (let L of g)
            delete L.node.indexes[L.iterator];
          return !1;
        }
        I.walk && I.proxyOf.nodes ? g.push({ iterator: I.getIterator(), node: I }) : b.indexes[y] += 1;
      }
    }
    walkAtRules(d, g) {
      return g ? d instanceof RegExp ? this.walk((y, b) => {
        if (y.type === "atrule" && d.test(y.name))
          return g(y, b);
      }) : this.walk((y, b) => {
        if (y.type === "atrule" && y.name === d)
          return g(y, b);
      }) : (g = d, this.walk((y, b) => {
        if (y.type === "atrule")
          return g(y, b);
      }));
    }
    walkComments(d) {
      return this.walk((g, y) => {
        if (g.type === "comment")
          return d(g, y);
      });
    }
    walkDecls(d, g) {
      return g ? d instanceof RegExp ? this.walk((y, b) => {
        if (y.type === "decl" && d.test(y.prop))
          return g(y, b);
      }) : this.walk((y, b) => {
        if (y.type === "decl" && y.prop === d)
          return g(y, b);
      }) : (g = d, this.walk((y, b) => {
        if (y.type === "decl")
          return g(y, b);
      }));
    }
    walkRules(d, g) {
      return g ? d instanceof RegExp ? this.walk((y, b) => {
        if (y.type === "rule" && d.test(y.selector))
          return g(y, b);
      }) : this.walk((y, b) => {
        if (y.type === "rule" && y.selector === d)
          return g(y, b);
      }) : (g = d, this.walk((y, b) => {
        if (y.type === "rule")
          return g(y, b);
      }));
    }
  }
  return h.registerParse = (E) => {
    s = E;
  }, h.registerRule = (E) => {
    l = E;
  }, h.registerAtRule = (E) => {
    o = E;
  }, h.registerRoot = (E) => {
    a = E;
  }, su = h, h.default = h, h.rebuild = (E) => {
    let d = [E];
    for (; d.length > 0; ) {
      let g = d.pop();
      if (g.type === "atrule" ? Object.setPrototypeOf(g, o.prototype) : g.type === "rule" ? Object.setPrototypeOf(g, l.prototype) : g.type === "decl" ? Object.setPrototypeOf(g, t.prototype) : g.type === "comment" ? Object.setPrototypeOf(g, e.prototype) : g.type === "root" && Object.setPrototypeOf(g, a.prototype), g[i] = !0, g.nodes)
        for (let y of g.nodes) d.push(y);
    }
  }, su;
}
var au, SE;
function Qc() {
  if (SE) return au;
  SE = 1;
  let e = an();
  class t extends e {
    constructor(n) {
      super(n), this.type = "atrule";
    }
    append(...n) {
      return this.proxyOf.nodes || (this.nodes = []), super.append(...n);
    }
    prepend(...n) {
      return this.proxyOf.nodes || (this.nodes = []), super.prepend(...n);
    }
  }
  return au = t, t.default = t, e.registerAtRule(t), au;
}
var uu, IE;
function ef() {
  if (IE) return uu;
  IE = 1;
  let e = an(), t, r;
  class n extends e {
    constructor(o) {
      super({ type: "document", ...o }), this.nodes || (this.nodes = []);
    }
    toResult(o = {}) {
      return new t(new r(), this, o).stringify();
    }
  }
  return n.registerLazyResult = (i) => {
    t = i;
  }, n.registerProcessor = (i) => {
    r = i;
  }, uu = n, n.default = n, uu;
}
var lu, _E;
function L$() {
  if (_E) return lu;
  _E = 1;
  let e = "useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict";
  return lu = { nanoid: (n = 21) => {
    let i = "", o = n | 0;
    for (; o-- > 0; )
      i += e[Math.random() * 64 | 0];
    return i;
  }, customAlphabet: (n, i = 21) => (o = i) => {
    let s = "", a = o | 0;
    for (; a-- > 0; )
      s += n[Math.random() * n.length | 0];
    return s;
  } }, lu;
}
var cu, RE;
function uA() {
  if (RE) return cu;
  RE = 1;
  let { existsSync: e, readFileSync: t, realpathSync: r } = ir, { dirname: n, isAbsolute: i, join: o, relative: s, sep: a } = ir, { SourceMapConsumer: l, SourceMapGenerator: f } = ir;
  function u(d) {
    try {
      return r(d);
    } catch {
      return d;
    }
  }
  function h(d) {
    return Buffer ? Buffer.from(d, "base64").toString() : window.atob(d);
  }
  class E {
    constructor(g, y) {
      if (y.map === !1) return;
      y.unsafeMap && (this.unsafeMap = !0), this.loadAnnotation(g), this.inline = this.startWith(this.annotation, "data:");
      let b = y.map ? y.map.prev : void 0, _ = this.loadMap(y.from, b);
      !this.mapFile && y.from && (this.mapFile = y.from), this.mapFile && (this.root = n(this.mapFile)), _ && (this.text = _);
    }
    consumer() {
      return this.consumerCache || (this.consumerCache = new l(this.json || this.text)), this.consumerCache;
    }
    decodeInline(g) {
      let y = /^data:application\/json;charset=utf-?8;base64,/, b = /^data:application\/json;base64,/, _ = /^data:application\/json;charset=utf-?8,/, I = /^data:application\/json,/, w = g.match(_) || g.match(I);
      if (w)
        return decodeURIComponent(g.substr(w[0].length));
      let L = g.match(y) || g.match(b);
      if (L)
        return h(g.substr(L[0].length));
      let R = g.slice(22);
      throw R = R.slice(0, R.indexOf(",")), new Error("Unsupported source map encoding " + R);
    }
    getAnnotationURL(g) {
      return g.replace(/^\/\*\s*# sourceMappingURL=/, "").trim();
    }
    isMap(g) {
      return typeof g != "object" ? !1 : typeof g.mappings == "string" || typeof g._mappings == "string" || Array.isArray(g.sections);
    }
    loadAnnotation(g) {
      let y = g.match(/\/\*\s*# sourceMappingURL=/g);
      if (!y) return;
      let b = g.lastIndexOf(y.pop()), _ = g.indexOf("*/", b);
      b > -1 && _ > -1 && (this.annotation = this.getAnnotationURL(g.substring(b, _)));
    }
    loadFile(g, y, b) {
      if (!b && !this.unsafeMap) {
        if (!/\.map$/i.test(g) || !y) return;
        let _ = s(u(n(y)), u(g));
        if (_ === ".." || _.startsWith(".." + a) || i(_))
          return;
      }
      if (this.root = n(g), e(g))
        return this.mapFile = g, t(g, "utf-8").toString().trim();
    }
    loadMap(g, y) {
      if (y === !1) return !1;
      if (y) {
        if (typeof y == "string")
          return y;
        if (typeof y == "function") {
          let b = y(g);
          if (b) {
            let _ = this.loadFile(b, g, !0);
            if (!_)
              throw new Error(
                "Unable to load previous source map: " + b.toString()
              );
            return _;
          }
        } else {
          if (y instanceof l)
            return f.fromSourceMap(y).toString();
          if (y instanceof f)
            return y.toString();
          if (this.isMap(y))
            return JSON.stringify(y);
          throw new Error(
            "Unsupported previous source map format: " + y.toString()
          );
        }
      } else {
        if (this.inline)
          return this.decodeInline(this.annotation);
        if (this.annotation) {
          let b = this.annotation;
          g && (b = o(n(g), b));
          let _ = this.loadFile(b, g, !1);
          if (_)
            try {
              this.json = JSON.parse(_.replace(/^\)]}'[^\n]*\n/, ""));
            } catch {
              return;
            }
          return _;
        }
      }
    }
    startWith(g, y) {
      return g ? g.substr(0, y.length) === y : !1;
    }
    withContent() {
      return !!(this.consumer().sourcesContent && this.consumer().sourcesContent.length > 0);
    }
  }
  return cu = E, E.default = E, cu;
}
var fu, OE;
function Da() {
  if (OE) return fu;
  OE = 1;
  let { nanoid: e } = /* @__PURE__ */ L$(), { isAbsolute: t, resolve: r } = ir, { SourceMapConsumer: n, SourceMapGenerator: i } = ir, { fileURLToPath: o, pathToFileURL: s } = ir, a = Xc(), l = uA(), f = ir, u = Symbol("lineToIndexCache"), h = !!(n && i), E = !!(r && t);
  function d(y) {
    if (y[u]) return y[u];
    let b = y.css.split(`
`), _ = new Array(b.length), I = 0;
    for (let w = 0, L = b.length; w < L; w++)
      _[w] = I, I += b[w].length + 1;
    return y[u] = _, _;
  }
  class g {
    get from() {
      return this.file || this.id;
    }
    constructor(b, _ = {}) {
      if (b === null || typeof b > "u" || typeof b == "object" && !b.toString)
        throw new Error(`PostCSS received ${b} instead of CSS string`);
      if (this.css = b.toString(), this.css[0] === "\uFEFF" || this.css[0] === "￾" ? (this.hasBOM = !0, this.css = this.css.slice(1)) : this.hasBOM = !1, this.document = this.css, _.document && (this.document = _.document.toString()), _.from && (!E || /^\w+:\/\//.test(_.from) || t(_.from) ? this.file = _.from : this.file = r(_.from)), E && h) {
        let I = new l(this.css, _);
        if (I.text) {
          this.map = I;
          let w = I.consumer().file;
          !this.file && w && (this.file = this.mapResolve(w));
        }
      }
      this.file || (this.id = "<input css " + e(6) + ">"), this.map && (this.map.file = this.from);
    }
    error(b, _, I, w = {}) {
      let L, R, D, P, O;
      if (_ && typeof _ == "object") {
        let U = _, z = I;
        if (typeof U.offset == "number") {
          P = U.offset;
          let V = this.fromOffset(P);
          _ = V.line, I = V.col;
        } else
          _ = U.line, I = U.column, P = this.fromLineAndColumn(_, I);
        if (typeof z.offset == "number") {
          D = z.offset;
          let V = this.fromOffset(D);
          R = V.line, L = V.col;
        } else
          R = z.line, L = z.column, D = this.fromLineAndColumn(z.line, z.column);
      } else if (I)
        P = this.fromLineAndColumn(_, I);
      else {
        P = _;
        let U = this.fromOffset(P);
        _ = U.line, I = U.col;
      }
      let F = this.origin(_, I, R, L);
      return F ? O = new a(
        b,
        F.endLine === void 0 ? F.line : { column: F.column, line: F.line },
        F.endLine === void 0 ? F.column : { column: F.endColumn, line: F.endLine },
        F.source,
        F.file,
        w.plugin
      ) : O = new a(
        b,
        R === void 0 ? _ : { column: I, line: _ },
        R === void 0 ? I : { column: L, line: R },
        this.css,
        this.file,
        w.plugin
      ), O.input = {
        column: I,
        endColumn: L,
        endLine: R,
        endOffset: D,
        line: _,
        offset: P,
        source: this.css
      }, this.file && (s && (O.input.url = s(this.file).toString()), O.input.file = this.file), O;
    }
    fromLineAndColumn(b, _) {
      return d(this)[b - 1] + _ - 1;
    }
    fromOffset(b) {
      let _ = d(this), I = _[_.length - 1], w = 0;
      if (b >= I)
        w = _.length - 1;
      else {
        let L = _.length - 2, R;
        for (; w < L; )
          if (R = w + (L - w >> 1), b < _[R])
            L = R - 1;
          else if (b >= _[R + 1])
            w = R + 1;
          else {
            w = R;
            break;
          }
      }
      return {
        col: b - _[w] + 1,
        line: w + 1
      };
    }
    mapResolve(b) {
      return /^\w+:\/\//.test(b) ? b : r(this.map.consumer().sourceRoot || this.map.root || ".", b);
    }
    origin(b, _, I, w) {
      if (!this.map) return !1;
      let L = this.map.consumer(), R = L.originalPositionFor({ column: _ - 1, line: b });
      if (!R.source) return !1;
      let D;
      if (typeof I == "number") {
        let U = L.originalPositionFor({
          column: w - 1,
          line: I
        });
        U.source && (D = U);
      }
      let P;
      t(R.source) ? P = s(R.source) : P = new URL(
        R.source,
        s(this.map.mapFile || r(".") + "/")
      );
      let O = {
        column: R.column + 1,
        endColumn: D && D.column + 1,
        endLine: D && D.line,
        line: R.line,
        url: P.toString()
      };
      if (P.protocol === "file:")
        if (o)
          O.file = o(P);
        else
          throw new Error("file: protocol is not available in this PostCSS build");
      let F = L.sourceContentFor(R.source);
      return F && (O.source = F), O;
    }
    toJSON() {
      let b = {};
      for (let _ of ["hasBOM", "css", "file", "id"])
        this[_] != null && (b[_] = this[_]);
      return this.map && (b.map = { ...this.map }, b.map.consumerCache && (b.map.consumerCache = void 0)), b;
    }
  }
  return fu = g, g.default = g, f && f.registerInput && f.registerInput(g), fu;
}
var du, wE;
function ns() {
  if (wE) return du;
  wE = 1;
  let e = an(), t, r;
  class n extends e {
    constructor(o) {
      super(o), this.type = "root", this.nodes || (this.nodes = []);
    }
    normalize(o, s, a) {
      let l = /* @__PURE__ */ new Set();
      for (let u of Array.isArray(o) ? o : [o])
        u && typeof u == "object" && !u.parent && u.raws && typeof u.raws.before < "u" && l.add(u.raws);
      let f = super.normalize(o);
      if (s) {
        if (a === "prepend")
          this.nodes.length > 1 ? s.raws.before = this.nodes[1].raws.before : delete s.raws.before;
        else if (this.first !== s)
          for (let u of f)
            l.has(u.raws) || (u.raws.before = s.raws.before);
      }
      return f;
    }
    removeChild(o, s) {
      let a = this.index(o);
      return !s && a === 0 && this.nodes.length > 1 && (this.nodes[1].raws.before = this.nodes[a].raws.before), super.removeChild(o);
    }
    toResult(o = {}) {
      return new t(new r(), this, o).stringify();
    }
  }
  return n.registerLazyResult = (i) => {
    t = i;
  }, n.registerProcessor = (i) => {
    r = i;
  }, du = n, n.default = n, e.registerRoot(n), du;
}
var pu, NE;
function lA() {
  if (NE) return pu;
  NE = 1;
  let e = {
    comma(t) {
      return e.split(t, [","], !0);
    },
    space(t) {
      let r = [" ", `
`, "	"];
      return e.split(t, r);
    },
    split(t, r, n) {
      if (typeof t != "string") return [];
      let i = [], o = "", s = !1, a = 0, l = !1, f = "", u = !1, h = !1;
      for (let d = 0; d < t.length; d++) {
        let g = t[d];
        if (h) {
          o += g, g === "*" && t[d + 1] === "/" && (o += "/", d += 1, h = !1);
          continue;
        }
        if (u)
          u = !1;
        else if (g === "\\")
          u = !0;
        else if (l)
          g === f && (l = !1);
        else if (g === '"' || g === "'")
          l = !0, f = g;
        else if (g === "/" && t[d + 1] === "*") {
          o += "/*", d += 1, h = !0;
          continue;
        } else g === "(" ? a += 1 : g === ")" ? a > 0 && (a -= 1) : a === 0 && r.includes(g) && (s = !0);
        if (s) {
          let y = o.trim();
          (n || y !== "") && i.push(y), o = "", s = !1;
        } else
          o += g;
      }
      let E = o.trim();
      return (n || E !== "") && i.push(E), i;
    }
  };
  return pu = e, e.default = e, pu;
}
var hu, CE;
function tf() {
  if (CE) return hu;
  CE = 1;
  let e = an(), t = lA();
  class r extends e {
    get selectors() {
      return t.comma(this.selector);
    }
    set selectors(i) {
      let o = this.selector ? this.selector.match(/,\s*/) : null, s = o ? o[0] : "," + this.raw("between", "beforeOpen");
      this.selector = i.join(s);
    }
    constructor(i) {
      super(i), this.type = "rule", this.nodes || (this.nodes = []);
    }
  }
  return hu = r, r.default = r, e.registerRule(r), hu;
}
var mu, PE;
function x$() {
  if (PE) return mu;
  PE = 1;
  let e = Qc(), t = Ca(), r = Pa(), n = Da(), i = uA(), o = ns(), s = tf();
  function a(u, h) {
    return u.inputs ? u.inputs.map((E) => {
      let d = { ...E, __proto__: n.prototype };
      return d.map && (d.map = {
        ...d.map,
        __proto__: i.prototype
      }), d;
    }) : h;
  }
  function l(u, h, E) {
    let d = { ...u };
    if (delete d.inputs, delete d.nodes, d.source) {
      let { inputId: y, ...b } = d.source;
      d.source = b, y != null && (d.source.input = h[y]);
    }
    let g;
    if (d.type === "root")
      g = new o(d);
    else if (d.type === "decl")
      g = new r(d);
    else if (d.type === "rule")
      g = new s(d);
    else if (d.type === "comment")
      g = new t(d);
    else if (d.type === "atrule")
      g = new e(d);
    else
      throw new Error("Unknown node type: " + u.type);
    if (E) {
      g.nodes = E;
      for (let y of E) y.parent = g;
    }
    return g;
  }
  function f(u, h) {
    if (Array.isArray(u)) return u.map((g) => f(g));
    let E, d = [
      { childIndex: 0, children: [], inputs: a(u, h), json: u }
    ];
    for (; d.length > 0; ) {
      let g = d[d.length - 1], y = g.json.nodes;
      if (y && g.childIndex < y.length) {
        let _ = y[g.childIndex];
        g.childIndex += 1, d.push({
          childIndex: 0,
          children: [],
          inputs: a(_, g.inputs),
          json: _
        });
        continue;
      }
      d.pop();
      let b = l(
        g.json,
        g.inputs,
        y ? g.children : void 0
      );
      d.length > 0 ? d[d.length - 1].children.push(b) : E = b;
    }
    return E;
  }
  return mu = f, f.default = f, mu;
}
var Eu, DE;
function cA() {
  if (DE) return Eu;
  DE = 1;
  let { dirname: e, relative: t, resolve: r, sep: n } = ir, { SourceMapConsumer: i, SourceMapGenerator: o } = ir, { pathToFileURL: s } = ir, a = Da(), l = !!(i && o), f = !!(e && r && t && n);
  class u {
    constructor(E, d, g, y) {
      this.stringify = E, this.mapOpts = g.map || {}, this.root = d, this.opts = g, this.css = y, this.originalCSS = y, this.usesFileUrls = !this.mapOpts.from && this.mapOpts.absolute, this.memoizedFileURLs = /* @__PURE__ */ new Map(), this.memoizedPaths = /* @__PURE__ */ new Map(), this.memoizedURLs = /* @__PURE__ */ new Map();
    }
    addAnnotation() {
      let E;
      this.isInline() ? E = "data:application/json;base64," + this.toBase64(this.map.toString()) : typeof this.mapOpts.annotation == "string" ? E = this.mapOpts.annotation : typeof this.mapOpts.annotation == "function" ? E = this.mapOpts.annotation(this.opts.to, this.root) : E = this.outputFile() + ".map";
      let d = `
`;
      this.css.includes(`\r
`) && (d = `\r
`), this.css += d + "/*# sourceMappingURL=" + E + " */";
    }
    applyPrevMaps() {
      for (let E of this.previous()) {
        let d = this.toUrl(this.path(E.file)), g = E.root || e(E.file), y;
        this.mapOpts.sourcesContent === !1 ? (y = new i(E.text), y.sourcesContent && (y.sourcesContent = null)) : y = E.consumer(), this.map.applySourceMap(y, d, this.toUrl(this.path(g)));
      }
    }
    clearAnnotation() {
      if (this.mapOpts.annotation !== !1) {
        if (this.root) {
          let E;
          for (let d = this.root.nodes.length - 1; d >= 0; d--)
            E = this.root.nodes[d], E.type === "comment" && E.text.startsWith("# sourceMappingURL=") && this.root.removeChild(d);
        } else if (this.css) {
          let E = "/*# sourceMappingURL=", d = "", g = 0, y;
          for (; (y = this.css.indexOf(E, g)) !== -1; ) {
            let b = this.css.indexOf("*/", y + E.length);
            if (b === -1) break;
            for (; y > g && this.css[y - 1] === `
`; )
              y--;
            d += this.css.slice(g, y), g = b + 2;
          }
          g > 0 && (this.css = d + this.css.slice(g));
        }
      }
    }
    generate() {
      if (this.clearAnnotation(), f && l && this.isMap())
        return this.generateMap();
      {
        let E = "";
        return this.stringify(this.root, (d) => {
          E += d;
        }), [E];
      }
    }
    generateMap() {
      if (this.root)
        this.generateString();
      else if (this.previous().length === 1) {
        let E = this.previous()[0].consumer();
        E.file = this.outputFile(), this.map = o.fromSourceMap(E, {
          ignoreInvalidMapping: !0
        });
      } else
        this.map = new o({
          file: this.outputFile(),
          ignoreInvalidMapping: !0
        }), this.map.addMapping({
          generated: { column: 0, line: 1 },
          original: { column: 0, line: 1 },
          source: this.opts.from ? this.toUrl(this.path(this.opts.from)) : "<no source>"
        });
      return this.isSourcesContent() && this.setSourcesContent(), this.root && this.previous().length > 0 && this.applyPrevMaps(), this.isAnnotation() && this.addAnnotation(), this.isInline() ? [this.css] : [this.css, this.map];
    }
    generateString() {
      this.css = "", this.map = new o({
        file: this.outputFile(),
        ignoreInvalidMapping: !0
      });
      let E = 1, d = 1, g = "<no source>", y = {
        generated: { column: 0, line: 0 },
        original: { column: 0, line: 0 },
        source: ""
      }, b, _;
      this.stringify(this.root, (I, w, L) => {
        if (this.css += I, w && L !== "end" && (y.generated.line = E, y.generated.column = d - 1, w.source && w.source.start ? (y.source = this.sourcePath(w), y.original.line = w.source.start.line, y.original.column = w.source.start.column - 1, this.map.addMapping(y)) : (y.source = g, y.original.line = 1, y.original.column = 0, this.map.addMapping(y))), _ = I.match(/\n/g), _ ? (E += _.length, b = I.lastIndexOf(`
`), d = I.length - b) : d += I.length, w && L !== "start") {
          let R = w.parent || { raws: {} };
          (!(w.type === "decl" || w.type === "atrule" && !w.nodes) || w !== R.last || R.raws.semicolon) && (w.source && w.source.end ? (y.source = this.sourcePath(w), y.original.line = w.source.end.line, y.original.column = w.source.end.column - 1, y.generated.line = E, y.generated.column = d - 2, this.map.addMapping(y)) : (y.source = g, y.original.line = 1, y.original.column = 0, y.generated.line = E, y.generated.column = d - 1, this.map.addMapping(y)));
        }
      });
    }
    isAnnotation() {
      return this.isInline() ? !0 : typeof this.mapOpts.annotation < "u" ? this.mapOpts.annotation : this.previous().length ? this.previous().some((E) => E.annotation) : !0;
    }
    isInline() {
      if (typeof this.mapOpts.inline < "u")
        return this.mapOpts.inline;
      let E = this.mapOpts.annotation;
      return typeof E < "u" && E !== !0 ? !1 : this.previous().length ? this.previous().some((d) => d.inline) : !0;
    }
    isMap() {
      return typeof this.opts.map < "u" ? !!this.opts.map : this.previous().length > 0;
    }
    isSourcesContent() {
      return typeof this.mapOpts.sourcesContent < "u" ? this.mapOpts.sourcesContent : this.previous().length ? this.previous().some((E) => E.withContent()) : !0;
    }
    outputFile() {
      return this.opts.to ? this.path(this.opts.to) : this.opts.from ? this.path(this.opts.from) : "to.css";
    }
    path(E) {
      if (this.mapOpts.absolute || E.charCodeAt(0) === 60 || /^\w+:\/\//.test(E)) return E;
      let d = this.memoizedPaths.get(E);
      if (d) return d;
      let g = this.opts.to ? e(this.opts.to) : ".";
      typeof this.mapOpts.annotation == "string" && (g = e(r(g, this.mapOpts.annotation)));
      let y = t(g, E);
      return this.memoizedPaths.set(E, y), y;
    }
    previous() {
      if (!this.previousMaps)
        if (this.previousMaps = [], this.root)
          this.root.walk((E) => {
            if (E.source && E.source.input.map) {
              let d = E.source.input.map;
              this.previousMaps.includes(d) || this.previousMaps.push(d);
            }
          });
        else {
          let E = new a(this.originalCSS, this.opts);
          E.map && this.previousMaps.push(E.map);
        }
      return this.previousMaps;
    }
    setSourcesContent() {
      let E = {};
      if (this.root)
        this.root.walk((d) => {
          if (d.source) {
            let g = d.source.input.from;
            if (g && !E[g]) {
              E[g] = !0;
              let y = this.usesFileUrls ? this.toFileUrl(g) : this.toUrl(this.path(g));
              this.map.setSourceContent(y, d.source.input.css);
            }
          }
        });
      else if (this.css) {
        let d = this.opts.from ? this.toUrl(this.path(this.opts.from)) : "<no source>";
        this.map.setSourceContent(d, this.css);
      }
    }
    sourcePath(E) {
      return this.mapOpts.from ? this.toUrl(this.mapOpts.from) : this.usesFileUrls ? this.toFileUrl(E.source.input.from) : this.toUrl(this.path(E.source.input.from));
    }
    toBase64(E) {
      return Buffer ? Buffer.from(E).toString("base64") : window.btoa(unescape(encodeURIComponent(E)));
    }
    toFileUrl(E) {
      let d = this.memoizedFileURLs.get(E);
      if (d) return d;
      if (s) {
        let g = s(E).toString();
        return this.memoizedFileURLs.set(E, g), g;
      } else
        throw new Error(
          "`map.absolute` option is not available in this PostCSS build"
        );
    }
    toUrl(E) {
      let d = this.memoizedURLs.get(E);
      if (d) return d;
      n === "\\" && (E = E.replace(/\\/g, "/"));
      let g = encodeURI(E).replace(/[#?]/g, encodeURIComponent);
      return this.memoizedURLs.set(E, g), g;
    }
  }
  return Eu = u, Eu;
}
var gu, ME;
function k$() {
  if (ME) return gu;
  ME = 1;
  const e = 39, t = 34, r = 92, n = 47, i = 10, o = 32, s = 12, a = 9, l = 13, f = 91, u = 93, h = 40, E = 41, d = 123, g = 125, y = 59, b = 42, _ = 58, I = 64, w = /[\t\n\f\r "#'()/;[\\\]{}]/g, L = /[\t\n\f\r !"#'():;@[\\\]{}]|\/(?=\*)/g, R = /.[\r\n"'(/\\]/, D = /[\da-f]/i;
  return gu = function(O, F = {}) {
    let U = O.css.valueOf(), z = F.ignoreErrors, V, ae, q, x, B, Z, G, Q, K, ee, ne = U.length, re = 0, Ae = [], ge = [], Ne = -1;
    function We() {
      return re;
    }
    function Ue(De) {
      throw O.error("Unclosed " + De, re);
    }
    function Fe() {
      return ge.length === 0 && re >= ne;
    }
    function _e(De) {
      if (ge.length) return ge.pop();
      if (re >= ne) return;
      let Re = De ? De.ignoreUnclosed : !1;
      switch (V = U.charCodeAt(re), V) {
        case i:
        case o:
        case a:
        case l:
        case s: {
          x = re;
          do
            x += 1, V = U.charCodeAt(x);
          while (V === o || V === i || V === a || V === l || V === s);
          Z = ["space", U.slice(re, x)], re = x - 1;
          break;
        }
        case f:
        case u:
        case d:
        case g:
        case _:
        case y:
        case E: {
          let gt = String.fromCharCode(V);
          Z = [gt, gt, re];
          break;
        }
        case h: {
          if (ee = Ae.length ? Ae.pop()[1] : "", K = U.charCodeAt(re + 1), ee === "url" && K !== e && K !== t && K !== o && K !== i && K !== a && K !== s && K !== l) {
            x = re;
            do {
              if (G = !1, x = U.indexOf(")", x + 1), x === -1)
                if (z || Re) {
                  x = re;
                  break;
                } else
                  Ue("bracket");
              for (Q = x; U.charCodeAt(Q - 1) === r; )
                Q -= 1, G = !G;
            } while (G);
            Z = ["brackets", U.slice(re, x + 1), re, x], re = x;
          } else re <= Ne ? Z = ["(", "(", re] : (x = U.indexOf(")", re + 1), ae = U.slice(re, x + 1), x === -1 || R.test(ae) ? (Ne = x === -1 ? ne : x, Z = ["(", "(", re]) : (Z = ["brackets", ae, re, x], re = x));
          break;
        }
        case e:
        case t: {
          B = V === e ? "'" : '"', x = re;
          do {
            if (G = !1, x = U.indexOf(B, x + 1), x === -1)
              if (z || Re) {
                x = re + 1;
                break;
              } else
                Ue("string");
            for (Q = x; U.charCodeAt(Q - 1) === r; )
              Q -= 1, G = !G;
          } while (G);
          Z = ["string", U.slice(re, x + 1), re, x], re = x;
          break;
        }
        case I: {
          w.lastIndex = re + 1, w.test(U), w.lastIndex === 0 ? x = U.length - 1 : x = w.lastIndex - 2, Z = ["at-word", U.slice(re, x + 1), re, x], re = x;
          break;
        }
        case r: {
          for (x = re, q = !0; U.charCodeAt(x + 1) === r; )
            x += 1, q = !q;
          if (V = U.charCodeAt(x + 1), q && V !== n && V !== o && V !== i && V !== a && V !== l && V !== s && (x += 1, D.test(U.charAt(x)))) {
            for (; D.test(U.charAt(x + 1)); )
              x += 1;
            U.charCodeAt(x + 1) === o && (x += 1);
          }
          Z = ["word", U.slice(re, x + 1), re, x], re = x;
          break;
        }
        default: {
          V === n && U.charCodeAt(re + 1) === b ? (x = U.indexOf("*/", re + 2) + 1, x === 0 && (z || Re ? x = U.length : Ue("comment")), Z = ["comment", U.slice(re, x + 1), re, x], re = x) : (L.lastIndex = re + 1, L.test(U), L.lastIndex === 0 ? x = U.length - 1 : x = L.lastIndex - 2, Z = ["word", U.slice(re, x + 1), re, x], Ae.push(Z), re = x);
          break;
        }
      }
      return re++, Z;
    }
    function Le(De) {
      ge.push(De);
    }
    return {
      back: Le,
      endOfFile: Fe,
      nextToken: _e,
      position: We
    };
  }, gu;
}
var yu, LE;
function j$() {
  if (LE) return yu;
  LE = 1;
  let e = Qc(), t = Ca(), r = Pa(), n = ns(), i = tf(), o = k$();
  const s = {
    empty: !0,
    space: !0
  };
  function a(u) {
    for (let h = u.length - 1; h >= 0; h--) {
      let E = u[h], d = E[3] || E[2];
      if (d) return d;
    }
  }
  function l(u, h, E) {
    let d = "";
    for (let g = h; g < E; g++) d += u[g][1];
    return d;
  }
  class f {
    constructor(h) {
      this.input = h, this.root = new n(), this.current = this.root, this.spaces = "", this.semicolon = !1, this.createTokenizer(), this.root.source = { input: h, start: { column: 1, line: 1, offset: 0 } };
    }
    atrule(h) {
      let E = new e();
      E.name = h[1].slice(1), E.name === "" && this.unnamedAtrule(E, h), this.init(E, h[2]);
      let d, g, y, b = !1, _ = !1, I = [], w = [];
      for (; !this.tokenizer.endOfFile(); ) {
        if (h = this.tokenizer.nextToken(), d = h[0], d === "(" || d === "[" ? w.push(d === "(" ? ")" : "]") : d === "{" && w.length > 0 ? w.push("}") : d === w[w.length - 1] && w.pop(), w.length === 0)
          if (d === ";") {
            E.source.end = this.getPosition(h[2]), E.source.end.offset++, this.semicolon = !0;
            break;
          } else if (d === "{") {
            _ = !0;
            break;
          } else if (d === "}") {
            if (I.length > 0) {
              for (y = I.length - 1, g = I[y]; g && g[0] === "space"; )
                g = I[--y];
              g && (E.source.end = this.getPosition(g[3] || g[2]), E.source.end.offset++);
            }
            this.end(h);
            break;
          } else
            I.push(h);
        else
          I.push(h);
        if (this.tokenizer.endOfFile()) {
          b = !0;
          break;
        }
      }
      E.raws.between = this.spacesAndCommentsFromEnd(I), I.length ? (E.raws.afterName = this.spacesAndCommentsFromStart(I), this.raw(E, "params", I), b && (h = I[I.length - 1], E.source.end = this.getPosition(h[3] || h[2]), E.source.end.offset++, this.spaces = E.raws.between, E.raws.between = "")) : (E.raws.afterName = "", E.params = ""), _ && (E.nodes = [], this.current = E);
    }
    checkMissedSemicolon(h) {
      let E = this.colon(h);
      if (E === !1) return;
      let d = 0, g;
      for (let y = E - 1; y >= 0 && (g = h[y], !(g[0] !== "space" && (d += 1, d === 2))); y--)
        ;
      throw this.input.error(
        "Missed semicolon",
        g[0] === "word" ? g[3] + 1 : g[2]
      );
    }
    colon(h) {
      let E = 0, d, g, y;
      for (let [b, _] of h.entries()) {
        if (g = _, y = g[0], y === "(" && (E += 1), y === ")" && (E -= 1), E === 0 && y === ":")
          if (!d)
            this.doubleColon(g);
          else {
            if (d[0] === "word" && d[1] === "progid")
              continue;
            return b;
          }
        d = g;
      }
      return !1;
    }
    comment(h) {
      let E = new t();
      this.init(E, h[2]), E.source.end = this.getPosition(h[3] || h[2]), E.source.end.offset++;
      let d = h[1].slice(2, -2);
      if (!d.trim())
        E.text = "", E.raws.left = d, E.raws.right = "";
      else {
        let g = d.match(/^(\s*)([^]*\S)(\s*)$/);
        E.text = g[2], E.raws.left = g[1], E.raws.right = g[3];
      }
    }
    createTokenizer() {
      this.tokenizer = o(this.input);
    }
    decl(h, E) {
      let d = new r();
      this.init(d, h[0][2]);
      let g = h[h.length - 1];
      g[0] === ";" && (this.semicolon = !0, h.pop()), d.source.end = this.getPosition(
        g[3] || g[2] || a(h)
      ), d.source.end.offset++;
      let y = 0;
      for (; h[y][0] !== "word"; )
        y === h.length - 1 && this.unknownWord([h[y]]), y++;
      d.raws.before += l(h, 0, y), d.source.start = this.getPosition(h[y][2]);
      let b = y;
      for (; y < h.length; ) {
        let D = h[y][0];
        if (D === ":" || D === "space" || D === "comment")
          break;
        y++;
      }
      d.prop = l(h, b, y);
      let _ = y, I;
      for (; y < h.length && (I = h[y], y++, I[0] !== ":"); )
        I[0] === "word" && /\w/.test(I[1]) && this.unknownWord([I]);
      d.raws.between = l(h, _, y), (d.prop[0] === "_" || d.prop[0] === "*") && (d.raws.before += d.prop[0], d.prop = d.prop.slice(1));
      let w = y;
      for (; y < h.length; ) {
        let D = h[y][0];
        if (D !== "space" && D !== "comment") break;
        y++;
      }
      let L = h.slice(w, y);
      h = h.slice(y), this.precheckMissedSemicolon(h);
      for (let D = h.length - 1; D >= 0; D--) {
        if (I = h[D], I[1].toLowerCase() === "!important") {
          d.important = !0;
          let P = this.stringFrom(h, D);
          P = this.spacesFromEnd(h) + P, P !== " !important" && (d.raws.important = P);
          break;
        } else if (I[1].toLowerCase() === "important") {
          let P = h.slice(0), O = "";
          for (let F = D; F > 0; F--) {
            let U = P[F][0];
            if (O.trim().startsWith("!") && U !== "space")
              break;
            O = P.pop()[1] + O;
          }
          O.trim().startsWith("!") && (d.important = !0, d.raws.important = O, h = P);
        }
        if (I[0] !== "space" && I[0] !== "comment")
          break;
      }
      h.some((D) => D[0] !== "space" && D[0] !== "comment") && (d.raws.between += L.map((D) => D[1]).join(""), L = []), this.raw(d, "value", L.concat(h), E), d.value.includes(":") && !E && this.checkMissedSemicolon(h);
    }
    doubleColon(h) {
      throw this.input.error(
        "Double colon",
        { offset: h[2] },
        { offset: h[2] + h[1].length }
      );
    }
    emptyRule(h) {
      let E = new i();
      this.init(E, h[2]), E.selector = "", E.raws.between = "", this.current = E;
    }
    end(h) {
      this.current.nodes && this.current.nodes.length && (this.current.raws.semicolon = this.semicolon), this.semicolon = !1, this.current.raws.after = (this.current.raws.after || "") + this.spaces, this.spaces = "", this.current.parent ? (this.current.source.end = this.getPosition(h[2]), this.current.source.end.offset++, this.current = this.current.parent) : this.unexpectedClose(h);
    }
    endFile() {
      this.current.parent && this.unclosedBlock(), this.current.nodes && this.current.nodes.length && (this.current.raws.semicolon = this.semicolon), this.current.raws.after = (this.current.raws.after || "") + this.spaces, this.root.source.end = this.getPosition(this.tokenizer.position());
    }
    freeSemicolon(h) {
      if (this.spaces += h[1], this.current.nodes) {
        let E = this.current.nodes[this.current.nodes.length - 1];
        E && E.type === "rule" && !E.raws.ownSemicolon && (E.raws.ownSemicolon = this.spaces, this.spaces = "", E.source.end = this.getPosition(h[2]), E.source.end.offset++);
      }
    }
    // Helpers
    getPosition(h) {
      let E = this.input.fromOffset(h);
      return {
        column: E.col,
        line: E.line,
        offset: h
      };
    }
    init(h, E) {
      this.current.push(h), h.source = {
        input: this.input,
        start: this.getPosition(E)
      }, h.raws.before = this.spaces, this.spaces = "", h.type !== "comment" && (this.semicolon = !1);
    }
    other(h) {
      let E = !1, d = null, g = !1, y = null, b = [], _ = h[1].startsWith("--"), I = [], w = h;
      for (; w; ) {
        if (d = w[0], I.push(w), d === "(" || d === "[")
          y || (y = w), b.push(d === "(" ? ")" : "]");
        else if (_ && g && d === "{")
          y || (y = w), b.push("}");
        else if (b.length === 0)
          if (d === ";")
            if (g) {
              this.decl(I, _);
              return;
            } else
              break;
          else if (d === "{") {
            this.rule(I);
            return;
          } else if (d === "}") {
            this.tokenizer.back(I.pop()), E = !0;
            break;
          } else d === ":" && (g = !0);
        else d === b[b.length - 1] && (b.pop(), b.length === 0 && (y = null));
        w = this.tokenizer.nextToken();
      }
      if (this.tokenizer.endOfFile() && (E = !0), b.length > 0 && this.unclosedBracket(y), E && g) {
        if (!_)
          for (; I.length && (w = I[I.length - 1][0], !(w !== "space" && w !== "comment")); )
            this.tokenizer.back(I.pop());
        this.decl(I, _);
      } else
        this.unknownWord(I);
    }
    parse() {
      let h;
      for (; !this.tokenizer.endOfFile(); )
        switch (h = this.tokenizer.nextToken(), h[0]) {
          case "space":
            this.spaces += h[1];
            break;
          case ";":
            this.freeSemicolon(h);
            break;
          case "}":
            this.end(h);
            break;
          case "comment":
            this.comment(h);
            break;
          case "at-word":
            this.atrule(h);
            break;
          case "{":
            this.emptyRule(h);
            break;
          default:
            this.other(h);
            break;
        }
      this.endFile();
    }
    precheckMissedSemicolon() {
    }
    raw(h, E, d, g) {
      let y, b, _ = d.length, I = "", w = "", L = !0, R, D;
      for (let P = 0; P < _; P += 1)
        y = d[P], b = y[0], b === "space" && P === _ - 1 && !g ? L = !1 : b === "comment" ? (D = d[P - 1] ? d[P - 1][0] : "empty", R = d[P + 1] ? d[P + 1][0] : "empty", !s[D] && !s[R] ? w === "," ? L = !1 : (I += y[1], w = y[1].slice(-1)) : L = !1) : (I += y[1], w = y[1].slice(-1));
      if (!L) {
        let P = d.reduce((O, F) => O + F[1], "");
        h.raws[E] = { raw: P, value: I };
      }
      h[E] = I;
    }
    rule(h) {
      h.pop();
      let E = new i();
      this.init(E, h[0][2]), E.raws.between = this.spacesAndCommentsFromEnd(h), this.raw(E, "selector", h), this.current = E;
    }
    spacesAndCommentsFromEnd(h) {
      let E, d = "";
      for (; h.length && (E = h[h.length - 1][0], !(E !== "space" && E !== "comment")); )
        d = h.pop()[1] + d;
      return d;
    }
    // Errors
    spacesAndCommentsFromStart(h) {
      let E, d = "";
      for (; h.length && (E = h[0][0], !(E !== "space" && E !== "comment")); )
        d += h.shift()[1];
      return d;
    }
    spacesFromEnd(h) {
      let E, d = "";
      for (; h.length && (E = h[h.length - 1][0], E === "space"); )
        d = h.pop()[1] + d;
      return d;
    }
    stringFrom(h, E) {
      let d = "";
      for (let g = E; g < h.length; g++)
        d += h[g][1];
      return h.splice(E, h.length - E), d;
    }
    unclosedBlock() {
      let h = this.current.source.start;
      throw this.input.error("Unclosed block", h.line, h.column);
    }
    unclosedBracket(h) {
      throw this.input.error(
        "Unclosed bracket",
        { offset: h[2] },
        { offset: h[2] + 1 }
      );
    }
    unexpectedClose(h) {
      throw this.input.error(
        "Unexpected }",
        { offset: h[2] },
        { offset: h[2] + 1 }
      );
    }
    unknownWord(h) {
      throw this.input.error(
        "Unknown word " + h[0][1],
        { offset: h[0][2] },
        { offset: h[0][2] + h[0][1].length }
      );
    }
    unnamedAtrule(h, E) {
      throw this.input.error(
        "At-rule without name",
        { offset: E[2] },
        { offset: E[2] + E[1].length }
      );
    }
  }
  return yu = f, yu;
}
var Tu, xE;
function rf() {
  if (xE) return Tu;
  xE = 1;
  let e = an(), t = Da(), r = j$();
  function n(i, o) {
    let s = new t(i, o), a = new r(s);
    try {
      a.parse();
    } catch (l) {
      throw process.env.NODE_ENV !== "production" && l.name === "CssSyntaxError" && o && o.from && (/\.scss$/i.test(o.from) ? l.message += `
You tried to parse SCSS with the standard CSS parser; try again with the postcss-scss parser` : /\.sass/i.test(o.from) ? l.message += `
You tried to parse Sass with the standard CSS parser; try again with the postcss-sass parser` : /\.less$/i.test(o.from) && (l.message += `
You tried to parse Less with the standard CSS parser; try again with the postcss-less parser`)), l;
    }
    return a.root;
  }
  return Tu = n, n.default = n, e.registerParse(n), Tu;
}
var bu, kE;
function fA() {
  if (kE) return bu;
  kE = 1;
  let e = an(), { my: t } = wa();
  class r {
    constructor(i, o = {}) {
      if (this.type = "warning", this.text = i, o.node && o.node.source) {
        o.node[t] || e.rebuild(o.node);
        let s = o.node.rangeBy(o);
        this.line = s.start.line, this.column = s.start.column, this.endLine = s.end.line, this.endColumn = s.end.column;
      }
      for (let s in o) this[s] = o[s];
    }
    toString() {
      return this.node ? this.node.error(this.text, {
        index: this.index,
        plugin: this.plugin,
        start: this.start,
        word: this.word
      }).message : this.plugin ? this.plugin + ": " + this.text : this.text;
    }
  }
  return bu = r, r.default = r, bu;
}
var Au, jE;
function nf() {
  if (jE) return Au;
  jE = 1;
  let e = fA();
  class t {
    get content() {
      return this.css;
    }
    constructor(n, i, o) {
      this.processor = n, this.messages = [], this.root = i, this.opts = o, this.css = "", this.map = void 0;
    }
    toString() {
      return this.css;
    }
    warn(n, i = {}) {
      i.plugin || this.lastPlugin && this.lastPlugin.postcssPlugin && (i.plugin = this.lastPlugin.postcssPlugin);
      let o = new e(n, i);
      return this.messages.push(o), o;
    }
    warnings() {
      return this.messages.filter((n) => n.type === "warning");
    }
  }
  return Au = t, t.default = t, Au;
}
var vu, UE;
function dA() {
  if (UE) return vu;
  UE = 1;
  let e = {};
  return vu = function(r) {
    e[r] || (e[r] = !0, typeof console < "u" && console.warn && console.warn(r));
  }, vu;
}
var Su, $E;
function pA() {
  if ($E) return Su;
  $E = 1;
  let e = an(), t = ef(), r = cA(), n = rf(), i = nf(), o = ns(), s = Oa(), { isClean: a, my: l } = wa(), f = dA();
  const u = {
    atrule: "AtRule",
    comment: "Comment",
    decl: "Declaration",
    document: "Document",
    root: "Root",
    rule: "Rule"
  }, h = {
    AtRule: !0,
    AtRuleExit: !0,
    Comment: !0,
    CommentExit: !0,
    Declaration: !0,
    DeclarationExit: !0,
    Document: !0,
    DocumentExit: !0,
    Once: !0,
    OnceExit: !0,
    postcssPlugin: !0,
    prepare: !0,
    Root: !0,
    RootExit: !0,
    Rule: !0,
    RuleExit: !0
  }, E = {
    Once: !0,
    postcssPlugin: !0,
    prepare: !0
  }, d = 0;
  function g(L) {
    return typeof L == "object" && typeof L.then == "function";
  }
  function y(L) {
    let R = !1, D = u[L.type];
    return L.type === "decl" ? R = L.prop.toLowerCase() : L.type === "atrule" && (R = L.name.toLowerCase()), R && L.append ? [
      D,
      D + "-" + R,
      d,
      D + "Exit",
      D + "Exit-" + R
    ] : R ? [D, D + "-" + R, D + "Exit", D + "Exit-" + R] : L.append ? [D, d, D + "Exit"] : [D, D + "Exit"];
  }
  function b(L) {
    let R;
    return L.type === "document" ? R = ["Document", d, "DocumentExit"] : L.type === "root" ? R = ["Root", d, "RootExit"] : R = y(L), {
      eventIndex: 0,
      events: R,
      iterator: 0,
      node: L,
      visitorIndex: 0,
      visitors: []
    };
  }
  function _(L) {
    let R = [L];
    for (; R.length > 0; ) {
      let D = R.pop();
      if (D[a] = !1, D.nodes)
        for (let P of D.nodes) R.push(P);
    }
    return L;
  }
  let I = {};
  class w {
    get content() {
      return this.stringify().content;
    }
    get css() {
      return this.stringify().css;
    }
    get map() {
      return this.stringify().map;
    }
    get messages() {
      return this.sync().messages;
    }
    get opts() {
      return this.result.opts;
    }
    get processor() {
      return this.result.processor;
    }
    get root() {
      return this.sync().root;
    }
    get [Symbol.toStringTag]() {
      return "LazyResult";
    }
    constructor(R, D, P) {
      this.stringified = !1, this.processed = !1;
      let O;
      if (typeof D == "object" && D !== null && (D.type === "root" || D.type === "document"))
        O = _(D);
      else if (D instanceof w || D instanceof i)
        O = _(D.root), D.map && (typeof P.map > "u" && (P.map = {}), P.map.inline || (P.map.inline = !1), P.map.prev = D.map);
      else {
        let F = n;
        P.syntax && (F = P.syntax.parse), P.parser && (F = P.parser), F.parse && (F = F.parse);
        try {
          O = F(D, P);
        } catch (U) {
          this.processed = !0, this.error = U;
        }
        O && !O[l] && e.rebuild(O);
      }
      this.result = new i(R, O, P), this.helpers = { ...I, postcss: I, result: this.result }, this.plugins = this.processor.plugins.map((F) => typeof F == "object" && F.prepare ? { ...F, ...F.prepare(this.result) } : F);
    }
    async() {
      return this.error ? Promise.reject(this.error) : this.processed ? Promise.resolve(this.result) : (this.processing || (this.processing = this.runAsync()), this.processing);
    }
    catch(R) {
      return this.async().catch(R);
    }
    finally(R) {
      return this.async().finally(R);
    }
    getAsyncError() {
      throw new Error("Use process(css).then(cb) to work with async plugins");
    }
    handleError(R, D) {
      let P = this.result.lastPlugin;
      try {
        if (D && D.addToError(R), this.error = R, R.name === "CssSyntaxError" && !R.plugin)
          R.plugin = P.postcssPlugin, R.setMessage();
        else if (P.postcssVersion && process.env.NODE_ENV !== "production") {
          let O = P.postcssPlugin, F = P.postcssVersion, U = this.result.processor.version, z = F.split("."), V = U.split(".");
          (z[0] !== V[0] || parseInt(z[1]) > parseInt(V[1])) && console.error(
            "Unknown error from PostCSS plugin. Your current PostCSS version is " + U + ", but " + O + " uses " + F + ". Perhaps this is the source of the error below."
          );
        }
      } catch (O) {
        console && console.error && console.error(O);
      }
      return R;
    }
    prepareVisitors() {
      this.listeners = {};
      let R = (D, P, O) => {
        this.listeners[P] || (this.listeners[P] = []), this.listeners[P].push([D, O]);
      };
      for (let D of this.plugins)
        if (typeof D == "object")
          for (let P in D) {
            if (!h[P] && /^[A-Z]/.test(P))
              throw new Error(
                `Unknown event ${P} in ${D.postcssPlugin}. Try to update PostCSS (${this.processor.version} now).`
              );
            if (!E[P])
              if (typeof D[P] == "object")
                for (let O in D[P])
                  O === "*" ? R(D, P, D[P][O]) : R(
                    D,
                    P + "-" + O.toLowerCase(),
                    D[P][O]
                  );
              else typeof D[P] == "function" && R(D, P, D[P]);
          }
      this.hasListener = Object.keys(this.listeners).length > 0;
    }
    async runAsync() {
      this.plugin = 0;
      for (let R = 0; R < this.plugins.length; R++) {
        let D = this.plugins[R], P = this.runOnRoot(D);
        if (g(P))
          try {
            await P;
          } catch (O) {
            throw this.handleError(O);
          }
      }
      if (this.prepareVisitors(), this.hasListener) {
        let R = this.result.root;
        for (; !R[a]; ) {
          R[a] = !0;
          let D = [b(R)];
          for (; D.length > 0; ) {
            let P = this.visitTick(D);
            if (g(P))
              try {
                await P;
              } catch (O) {
                let F = D[D.length - 1].node;
                throw this.handleError(O, F);
              }
          }
        }
        if (this.listeners.OnceExit)
          for (let [D, P] of this.listeners.OnceExit) {
            this.result.lastPlugin = D;
            try {
              if (R.type === "document") {
                let O = R.nodes.map(
                  (F) => P(F, this.helpers)
                );
                await Promise.all(O);
              } else
                await P(R, this.helpers);
            } catch (O) {
              throw this.handleError(O);
            }
          }
      }
      return this.processed = !0, this.stringify();
    }
    runOnRoot(R) {
      this.result.lastPlugin = R;
      try {
        if (typeof R == "object" && R.Once) {
          if (this.result.root.type === "document") {
            let D = this.result.root.nodes.map(
              (P) => R.Once(P, this.helpers)
            );
            return g(D[0]) ? Promise.all(D) : D;
          }
          return R.Once(this.result.root, this.helpers);
        } else if (typeof R == "function")
          return R(this.result.root, this.result);
      } catch (D) {
        throw this.handleError(D);
      }
    }
    stringify() {
      if (this.error) throw this.error;
      if (this.stringified) return this.result;
      this.stringified = !0, this.sync();
      let R = this.result.opts, D = s;
      R.syntax && (D = R.syntax.stringify), R.stringifier && (D = R.stringifier), D.stringify && (D = D.stringify);
      let P = this.result.root.source;
      if (R.map === void 0 && !(P && P.input && P.input.map)) {
        let U = "";
        return D(this.result.root, (z) => {
          U += z;
        }), this.result.css = U, this.result;
      }
      let F = new r(D, this.result.root, this.result.opts).generate();
      return this.result.css = F[0], this.result.map = F[1], this.result;
    }
    sync() {
      if (this.error) throw this.error;
      if (this.processed) return this.result;
      if (this.processed = !0, this.processing)
        throw this.getAsyncError();
      for (let R of this.plugins) {
        let D = this.runOnRoot(R);
        if (g(D))
          throw this.getAsyncError();
      }
      if (this.prepareVisitors(), this.hasListener) {
        let R = this.result.root;
        for (; !R[a]; )
          R[a] = !0, this.walkSync(R);
        if (this.listeners.OnceExit)
          if (R.type === "document")
            for (let D of R.nodes)
              this.visitSync(this.listeners.OnceExit, D);
          else
            this.visitSync(this.listeners.OnceExit, R);
      }
      return this.result;
    }
    then(R, D) {
      return process.env.NODE_ENV !== "production" && ("from" in this.opts || f(
        "Without `from` option PostCSS could generate wrong source map and will not find Browserslist config. Set it to CSS file path or to `undefined` to prevent this warning."
      )), this.async().then(R, D);
    }
    toString() {
      return this.css;
    }
    visitSync(R, D) {
      for (let [P, O] of R) {
        this.result.lastPlugin = P;
        let F;
        try {
          F = O(D, this.helpers);
        } catch (U) {
          throw this.handleError(U, D.proxyOf);
        }
        if (D.type !== "root" && D.type !== "document" && !D.parent)
          return !0;
        if (g(F))
          throw this.getAsyncError();
      }
    }
    visitTick(R) {
      let D = R[R.length - 1], { node: P, visitors: O } = D;
      if (P.type !== "root" && P.type !== "document" && !P.parent) {
        R.pop();
        return;
      }
      if (O.length > 0 && D.visitorIndex < O.length) {
        let [U, z] = O[D.visitorIndex];
        D.visitorIndex += 1, D.visitorIndex === O.length && (D.visitors = [], D.visitorIndex = 0), this.result.lastPlugin = U;
        try {
          return z(P.toProxy(), this.helpers);
        } catch (V) {
          throw this.handleError(V, P);
        }
      }
      if (D.iterator !== 0) {
        let U = D.iterator;
        D.descending && (D.descending = !1, P.indexes[U] += 1);
        let z;
        for (; z = P.nodes[P.indexes[U]]; ) {
          if (!z[a]) {
            z[a] = !0, D.descending = !0, R.push(b(z));
            return;
          }
          P.indexes[U] += 1;
        }
        D.iterator = 0, delete P.indexes[U];
      }
      let F = D.events;
      for (; D.eventIndex < F.length; ) {
        let U = F[D.eventIndex];
        if (D.eventIndex += 1, U === d) {
          P.nodes && P.nodes.length && (P[a] = !0, D.iterator = P.getIterator());
          return;
        } else if (this.listeners[U]) {
          D.visitors = this.listeners[U];
          return;
        }
      }
      R.pop();
    }
    walkSync(R) {
      R[a] = !0;
      let D = [{ eventIndex: 0, events: y(R), iterator: 0, node: R }];
      for (; D.length > 0; ) {
        let P = D[D.length - 1], O = P.node;
        if (P.iterator !== 0) {
          let F = P.iterator;
          P.descending && (P.descending = !1, O.indexes[F] += 1);
          let U, z = !1;
          for (; U = O.nodes[O.indexes[F]]; ) {
            if (!U[a]) {
              U[a] = !0, P.descending = !0, D.push({
                eventIndex: 0,
                events: y(U),
                iterator: 0,
                node: U
              }), z = !0;
              break;
            }
            O.indexes[F] += 1;
          }
          if (z) continue;
          P.iterator = 0, delete O.indexes[F];
        }
        if (P.eventIndex < P.events.length) {
          let F = P.events[P.eventIndex];
          if (P.eventIndex += 1, F === d)
            O.nodes && O.nodes.length && (P.iterator = O.getIterator());
          else {
            let U = this.listeners[F];
            U && this.visitSync(U, O.toProxy()) && D.pop();
          }
          continue;
        }
        D.pop();
      }
    }
    warnings() {
      return this.sync().warnings();
    }
  }
  return w.registerPostcss = (L) => {
    I = L;
  }, Su = w, w.default = w, o.registerLazyResult(w), t.registerLazyResult(w), Su;
}
var Iu, FE;
function U$() {
  if (FE) return Iu;
  FE = 1;
  let e = cA(), t = rf(), r = nf(), n = Oa(), i = dA();
  class o {
    get content() {
      return this.result.css;
    }
    get css() {
      return this.result.css;
    }
    get map() {
      return this.result.map;
    }
    get messages() {
      return [];
    }
    get opts() {
      return this.result.opts;
    }
    get processor() {
      return this.result.processor;
    }
    get root() {
      if (this._root)
        return this._root;
      let a, l = t;
      try {
        a = l(this._css, this._opts);
      } catch (f) {
        this.error = f;
      }
      if (this.error)
        throw this.error;
      return this._root = a, a;
    }
    get [Symbol.toStringTag]() {
      return "NoWorkResult";
    }
    constructor(a, l, f) {
      l = l.toString(), this.stringified = !1, this._processor = a, this._css = l, this._opts = f, this._map = void 0;
      let u = n;
      this.result = new r(this._processor, void 0, this._opts), this.result.css = l;
      let h = this;
      Object.defineProperty(this.result, "root", {
        get() {
          return h.root;
        }
      });
      let E = new e(u, void 0, this._opts, l);
      if (E.isMap()) {
        let [d, g] = E.generate();
        d && (this.result.css = d), g && (this.result.map = g);
      } else
        E.clearAnnotation(), this.result.css = E.css;
    }
    async() {
      return this.error ? Promise.reject(this.error) : Promise.resolve(this.result);
    }
    catch(a) {
      return this.async().catch(a);
    }
    finally(a) {
      return this.async().finally(a);
    }
    sync() {
      if (this.error) throw this.error;
      return this.result;
    }
    then(a, l) {
      return process.env.NODE_ENV !== "production" && ("from" in this._opts || i(
        "Without `from` option PostCSS could generate wrong source map and will not find Browserslist config. Set it to CSS file path or to `undefined` to prevent this warning."
      )), this.async().then(a, l);
    }
    toString() {
      return this._css;
    }
    warnings() {
      return [];
    }
  }
  return Iu = o, o.default = o, Iu;
}
var _u, GE;
function $$() {
  if (GE) return _u;
  GE = 1;
  let e = ef(), t = pA(), r = U$(), n = ns();
  class i {
    constructor(s = []) {
      this.version = "8.5.32", this.plugins = this.normalize(s);
    }
    normalize(s) {
      let a = [];
      for (let l of s)
        if (l.postcss === !0 ? l = l() : l.postcss && (l = l.postcss), typeof l == "object" && Array.isArray(l.plugins))
          a = a.concat(l.plugins);
        else if (typeof l == "object" && l.postcssPlugin)
          a.push(l);
        else if (typeof l == "function")
          a.push(l);
        else if (typeof l == "object" && (l.parse || l.stringify)) {
          if (process.env.NODE_ENV !== "production")
            throw new Error(
              "PostCSS syntaxes cannot be used as plugins. Instead, please use one of the syntax/parser/stringifier options as outlined in your PostCSS runner documentation."
            );
        } else
          throw new Error(l + " is not a PostCSS plugin");
      return a;
    }
    process(s, a = {}) {
      return !this.plugins.length && !a.parser && !a.stringifier && !a.syntax ? new r(this, s, a) : new t(this, s, a);
    }
    use(s) {
      return this.plugins = this.plugins.concat(this.normalize([s])), this;
    }
  }
  return _u = i, i.default = i, n.registerProcessor(i), e.registerProcessor(i), _u;
}
var Ru, zE;
function F$() {
  if (zE) return Ru;
  zE = 1;
  let e = Qc(), t = Ca(), r = an(), n = Xc(), i = Pa(), o = ef(), s = x$(), a = Da(), l = pA(), f = lA(), u = Na(), h = rf(), E = $$(), d = nf(), g = ns(), y = tf(), b = Oa(), _ = fA();
  function I(...w) {
    return w.length === 1 && Array.isArray(w[0]) && (w = w[0]), new E(w);
  }
  return I.plugin = function(L, R) {
    let D = !1;
    function P(...F) {
      console && console.warn && !D && (D = !0, console.warn(
        L + `: postcss.plugin was deprecated. Migration guide:
https://evilmartians.com/chronicles/postcss-8-plugin-migration`
      ), process.env.LANG && process.env.LANG.startsWith("zh") && console.warn(
        L + `: 里面 postcss.plugin 被弃用. 迁移指南:
https://www.w3ctech.com/topic/2226`
      ));
      let U = R(...F);
      return U.postcssPlugin = L, U.postcssVersion = new E().version, U;
    }
    let O;
    return Object.defineProperty(P, "postcss", {
      get() {
        return O || (O = P()), O;
      }
    }), P.process = function(F, U, z) {
      return I([P(z)]).process(F, U);
    }, P;
  }, I.stringify = b, I.parse = h, I.fromJSON = s, I.list = f, I.comment = (w) => new t(w), I.atRule = (w) => new e(w), I.decl = (w) => new i(w), I.rule = (w) => new y(w), I.root = (w) => new g(w), I.document = (w) => new o(w), I.CssSyntaxError = n, I.Declaration = i, I.Container = r, I.Processor = E, I.Document = o, I.Comment = t, I.Warning = _, I.AtRule = e, I.Result = d, I.Input = a, I.Rule = y, I.Root = g, I.Node = u, l.registerPostcss(I), Ru = I, I.default = I, Ru;
}
var bs = { exports: {} }, BE;
function G$() {
  if (BE) return bs.exports;
  BE = 1;
  const e = _b();
  function t(n) {
    for (n = n.replace(/[\x00-\x20]+/g, ""); ; ) {
      const i = n.indexOf("<!--");
      if (i === -1)
        break;
      const o = n.indexOf("-->", i + 4);
      if (o === -1)
        break;
      n = n.substring(0, i) + n.substring(o + 3);
    }
    return n;
  }
  function r(n, i) {
    i = i || {};
    const o = i.allowedSchemes || ["http", "https", "ftp", "mailto", "tel", "sms"], s = i.allowProtocolRelative !== !1;
    if (typeof n != "string")
      return !1;
    n = t(n);
    const a = n.match(/^([a-zA-Z][a-zA-Z0-9.\-+]*):/);
    if (!a)
      return n.match(/^[/\\]{2}/) ? !s : !1;
    const l = a[1].toLowerCase();
    return o.indexOf(l) === -1;
  }
  return bs.exports = function(n) {
    const i = {};
    return i.options = n || {}, i.filterTag = i.options.filterTag || function(o) {
      return o = o.trim(), o.toLowerCase();
    }, i.string = function(o, s) {
      return typeof o != "string" && (typeof o == "number" || typeof o == "boolean" ? o += "" : o = ""), o = o.trim(), s !== void 0 && o === "" && (o = s), o;
    }, i.strings = function(o) {
      return Array.isArray(o) ? o.map(function(s) {
        return i.string(s);
      }) : [];
    }, i.integer = function(o, s, a, l) {
      if (s === void 0 && (s = 0), typeof o == "number")
        o = Math.floor(o);
      else
        try {
          o = parseInt(o, 10), isNaN(o) && (o = s);
        } catch {
          o = s;
        }
      return typeof a == "number" && o < a && (o = a), typeof l == "number" && o > l && (o = l), o;
    }, i.padInteger = function(o, s) {
      let a = o + "";
      for (; a.length < s; )
        a = "0" + a;
      return a;
    }, i.float = function(o, s, a, l) {
      if (s === void 0 && (s = 0), typeof o != "number")
        try {
          o = parseFloat(o, 10), isNaN(o) && (o = s);
        } catch {
          o = s;
        }
      return typeof a == "number" && o < a && (o = a), typeof l == "number" && o > l && (o = l), o;
    }, i.naughtyHref = r, i.url = function(o, s, a) {
      if (o = i.string(o, s), o === s)
        return o;
      if (o = t(o), r(o) || (o = l(o), o === null))
        return s;
      return o;
      function l(f) {
        return f.match(/^(((https?|ftp):\/\/)|((mailto|tel|sms):)|#|([^/.]+)?\/|[^/.]+$)/) ? f : f.match(/^[^/.]+\.[^/.]+/) ? (a ? "https://" : "http://") + f : null;
      }
    }, i.select = function(o, s, a) {
      if (o = i.string(o), !s || !s.length)
        return a;
      let l;
      return typeof s[0] == "object" ? (l = s.find(function(f) {
        return f.value === null || f.value === void 0 ? !1 : f.value.toString() === o;
      }), l != null ? l.value : a) : (l = s.find(function(f) {
        return f == null ? !1 : f.toString() === o;
      }), l !== void 0 ? l : a);
    }, i.boolean = function(o, s) {
      return o === !0 ? !0 : o === !1 ? !1 : (o = i.string(o, s), o === s ? o === void 0 ? !1 : o : (o = o.toLowerCase().charAt(0), o === "" || o === "n" || o === "0" || o === "f" ? !1 : o === "t" || o === "y" || o === "1"));
    }, i.addBooleanFilterToCriteria = function(o, s, a, l) {
      l === void 0 && (l = null);
      let f = typeof o == "object" && o !== null ? o[s] : o;
      f = f === void 0 ? l : f, f = i.booleanOrNull(f), f === null || (f ? a[s] = !0 : a[s] = { $ne: !0 });
    }, i.booleanOrNull = function(o, s) {
      return o === !0 || o === !1 || o === null ? o : (o = i.string(o, s), o === s ? s === void 0 ? null : o : o === "null" ? null : (o = o.toLowerCase().charAt(0), o === "" || o === "n" || o === "0" || o === "f" ? !1 : o === "t" || o === "y" || o === "1" ? !0 : o === "a" ? null : s));
    }, i.date = function(o, s, a) {
      let l;
      function f() {
        return s === void 0 && (s = e().format("YYYY-MM-DD")), s;
      }
      if (typeof o == "string") {
        if (o.match(/\//)) {
          if (l = o.split("/"), l.length === 2)
            return (a || /* @__PURE__ */ new Date()).getFullYear() + "-" + i.padInteger(l[0], 2) + "-" + i.padInteger(l[1], 2);
          if (l.length === 3) {
            if (l[2] < 100) {
              const u = a || /* @__PURE__ */ new Date(), h = u.getFullYear() % 100, E = u.getFullYear() - h;
              let d = parseInt(l[2]) + E;
              d - u.getFullYear() > 50 && (d -= 100), l[2] = d;
            }
            return i.padInteger(l[2], 4) + "-" + i.padInteger(l[0], 2) + "-" + i.padInteger(l[1], 2);
          } else
            return f();
        } else if (o.match(/-/))
          return l = o.split("-"), l.length === 2 ? (a || /* @__PURE__ */ new Date()).getFullYear() + "-" + i.padInteger(l[0], 2) + "-" + i.padInteger(l[1], 2) : l.length === 3 ? i.padInteger(l[0], 4) + "-" + i.padInteger(l[1], 2) + "-" + i.padInteger(l[2], 2) : f();
      }
      try {
        return o === null || (o = a || new Date(o), isNaN(o.getTime())) ? f() : o.getFullYear() + "-" + i.padInteger(o.getMonth() + 1, 2) + "-" + i.padInteger(o.getDate(), 2);
      } catch {
        return f();
      }
    }, i.formatDate = function(o) {
      return e(o).format("YYYY-MM-DD");
    }, i.time = function(o, s) {
      o = i.string(o).toLowerCase(), o = o.trim();
      const a = o.match(/^(\d+)([:|.](\d+))?([:|.](\d+))?\s*(am|pm|AM|PM|a|p|A|M)?$/);
      if (a) {
        let l = parseInt(a[1], 10);
        const f = a[3] !== void 0 ? parseInt(a[3], 10) : 0, u = a[5] !== void 0 ? parseInt(a[5], 10) : 0;
        let h = a[6] ? a[6].toLowerCase() : a[6];
        return h = h && h.charAt(0), l === 12 && h === "a" ? l -= 12 : l === 12 && h === "p" || h === "p" && (l += 12), (l === 24 || l === "24") && (l = 0), i.padInteger(l, 2) + ":" + i.padInteger(f, 2) + ":" + i.padInteger(u, 2);
      } else
        return s !== void 0 ? s : e().format("HH:mm");
    }, i.formatTime = function(o) {
      return e(o).format("HH:mm:ss");
    }, i.tags = function(o, s) {
      return typeof o == "string" && (o = o.split(/,\s*/)), Array.isArray(o) ? o.map((u) => i.string(u)).map(s || i.filterTag).filter((u) => u.length > 0) : [];
    }, i.idRegExp = i.options.idRegExp || /^[A-Za-z0-9_]+$/, i.id = function(o, s) {
      const a = i.string(o, s);
      return a === s || a.match(i.idRegExp) ? a : s;
    }, i.ids = function(o) {
      return Array.isArray(o) ? o.filter(function(a) {
        return i.id(a) !== void 0;
      }) : [];
    }, i;
  }, bs.exports.naughtyHref = r, bs.exports;
}
var Ou, VE;
function z$() {
  if (VE) return Ou;
  VE = 1;
  const e = R$, t = O$(), { isPlainObject: r } = w$(), n = C$(), { parse: i } = F$(), { naughtyHref: o } = G$(), s = [
    "img",
    "audio",
    "video",
    "picture",
    "svg",
    "object",
    "map",
    "iframe",
    "embed"
  ], a = ["script", "style"], l = [
    "animate",
    "animatecolor",
    "animatemotion",
    "animatetransform",
    "set"
  ], f = ["href"], u = ["debug", "info", "warn", "error"];
  function h(P) {
    const O = P && P.logger || console, F = {};
    for (const U of u)
      F[U] = typeof O[U] == "function" ? (...z) => O[U](...z) : (...z) => console[U](...z);
    return F;
  }
  function E(P, O) {
    P && Object.keys(P).forEach(function(F) {
      O(P[F], F);
    });
  }
  function d(P, O) {
    return {}.hasOwnProperty.call(P, O);
  }
  function g(P, O) {
    return !Array.isArray(P) || !Array.isArray(O) ? O : P.concat(O);
  }
  function y(P, O) {
    const F = /* @__PURE__ */ Object.create(null);
    for (const U of [P, O])
      for (const z of Object.keys(U))
        F[z] = d(F, z) ? F[z].concat(U[z]) : U[z];
    return F;
  }
  function b(P, O) {
    const F = [];
    return E(P, function(U) {
      O(U) && F.push(U);
    }), F;
  }
  function _(P) {
    for (const O in P)
      if (d(P, O))
        return !1;
    return !0;
  }
  function I(P) {
    return P.map(function(O) {
      if (!O.url)
        throw new Error("URL missing");
      return O.url + (O.w ? ` ${O.w}w` : "") + (O.h ? ` ${O.h}h` : "") + (O.d ? ` ${O.d}x` : "");
    }).join(", ");
  }
  Ou = R;
  const w = /^[^\0\t\n\f\r /<=>]+$/, L = 8;
  function R(P, O, F) {
    if (P == null)
      return "";
    const U = F && F.depth || 0, z = F && F.iframeFallbackDepth || 0;
    typeof P == "number" && (P = P.toString());
    let V = "", ae = "";
    function q(H, te) {
      const X = this;
      this.tag = H, this.attribs = te || {}, this.tagPosition = V.length, this.text = "", this.openingTagLength = 0, this.mediaChildren = [], this.updateParentNodeText = function() {
        if (Ne.length) {
          const oe = Ne[Ne.length - 1];
          oe.text += X.text;
        }
      }, this.updateParentNodeMediaChildren = function() {
        Ne.length && s.includes(this.tag) && Ne[Ne.length - 1].mediaChildren.push(this.tag);
      };
    }
    O = Object.assign({}, R.defaults, O), O.parser = Object.assign({}, D, O.parser);
    const x = h(O), B = function(H) {
      return O.allowedTags === !1 || (O.allowedTags || []).indexOf(H) > -1;
    };
    a.forEach(function(H) {
      B(H) && !O.allowVulnerableTags && x.warn(
        `Your \`allowedTags\` option includes \`${H}\`, which is inherently vulnerable to XSS attacks. Please remove it from \`allowedTags\`, or, to disable this warning, add the \`allowVulnerableTags\` option and ensure you are accounting for this risk.`
      );
    });
    const Z = O.nonTextTags || [
      "script",
      "style",
      "textarea",
      "option",
      "xmp"
    ];
    let G, Q;
    O.allowedAttributes && (G = {}, Q = {}, E(O.allowedAttributes, function(H, te) {
      G[te] = [];
      const X = [];
      H.forEach(function(oe) {
        typeof oe == "string" && oe.indexOf("*") >= 0 ? X.push(t(oe).replace(/\\\*/g, ".*")) : G[te].push(oe);
      }), X.length && (Q[te] = new RegExp("^(" + X.join("|") + ")$"));
    }));
    const K = {}, ee = {}, ne = {};
    E(O.allowedClasses, function(H, te) {
      if (G && (d(G, te) || (G[te] = []), G[te].push("class")), K[te] = H, Array.isArray(H)) {
        const X = [];
        K[te] = [], ne[te] = [], H.forEach(function(oe) {
          typeof oe == "string" && oe.indexOf("*") >= 0 ? X.push(t(oe).replace(/\\\*/g, ".*")) : oe instanceof RegExp ? ne[te].push(oe) : K[te].push(oe);
        }), X.length && (ee[te] = new RegExp("^(" + X.join("|") + ")$"));
      }
    });
    const re = {};
    let Ae;
    E(O.transformTags, function(H, te) {
      let X;
      typeof H == "function" ? X = H : typeof H == "string" && (X = R.simpleTransform(H)), te === "*" ? Ae = X : re[te] = X;
    });
    let ge, Ne, We, Ue, Fe, _e, Le, De, Re = !1;
    ti();
    const gt = new e.Parser({
      onopentag: function(H, te) {
        if (O.onOpenTag && O.onOpenTag(H, te), p(), O.enforceHtmlBoundary && H === "html" && ti(), De)
          return;
        if (Fe) {
          _e++;
          return;
        }
        const X = new q(H, te);
        Ne.push(X);
        let oe = !1;
        const He = !!X.text;
        let ot;
        if (d(re, H) && (ot = re[H](H, te), X.attribs = te = ot.attribs, ot.text !== void 0 && (X.innerText = ot.text), H !== ot.tagName && (X.name = H = ot.tagName, Ue[ge] = ot.tagName)), Ae && (ot = Ae(H, te), X.attribs = te = ot.attribs, H !== ot.tagName && (X.name = H = ot.tagName, Ue[ge] = ot.tagName)), (!B(H) || W(H, te) || O.disallowedTagsMode === "recursiveEscape" && !_(We) || O.nestingLimit != null && ge >= O.nestingLimit) && (oe = !0, We[ge] = !0, (O.disallowedTagsMode === "discard" || O.disallowedTagsMode === "completelyDiscard") && Z.indexOf(H) !== -1 && (Fe = !0, _e = 1, X.tag.toLowerCase() === "noscript" && (Le = c("noscript", gt.endIndex + 1)))), ge++, oe) {
          if (O.disallowedTagsMode === "discard" || O.disallowedTagsMode === "completelyDiscard") {
            if (X.innerText && !He) {
              const Pe = m(X.innerText);
              O.textFilter ? V += O.textFilter(Pe, H) : V += Pe, Re = !0;
            }
            return;
          }
          ae = V, V = "";
        }
        if (V += "<" + H, H === "script" && (O.allowedScriptHostnames || O.allowedScriptDomains) && (X.innerText = ""), oe && (O.disallowedTagsMode === "escape" || O.disallowedTagsMode === "recursiveEscape") && O.preserveEscapedAttributes ? E(te, function(Pe, Ee) {
          V += " " + Ee + '="' + m(Pe || "", !0) + '"';
        }) : (!G || d(G, H) || G["*"]) && E(te, function(Pe, Ee) {
          if (!w.test(Ee)) {
            delete X.attribs[Ee];
            return;
          }
          if (Pe === "" && !O.allowedEmptyAttributes.includes(Ee) && (O.nonBooleanAttributes.includes(Ee) || O.nonBooleanAttributes.includes("*"))) {
            delete X.attribs[Ee];
            return;
          }
          let ni = !1;
          if (!G || d(G, H) && G[H].indexOf(Ee) !== -1 || G["*"] && G["*"].indexOf(Ee) !== -1 || d(Q, H) && Q[H].test(Ee) || Q["*"] && Q["*"].test(Ee))
            ni = !0;
          else if (G && G[H]) {
            for (const Ge of G[H])
              if (r(Ge) && Ge.name && Ge.name === Ee) {
                ni = !0;
                let ze = "";
                if (Ge.multiple === !0) {
                  const un = Pe.split(" ");
                  for (const gr of un)
                    Ge.values.indexOf(gr) !== -1 && (ze === "" ? ze = gr : ze += " " + gr);
                } else Ge.values.indexOf(Pe) >= 0 && (ze = Pe);
                Pe = ze;
              }
          }
          if (ni) {
            if (O.allowedSchemesAppliedToAttributes.indexOf(Ee) !== -1 && T(H, Pe)) {
              delete X.attribs[Ee];
              return;
            }
            if (H === "meta" && Ee.toLowerCase() === "content" && S(te) && j(Pe)) {
              delete X.attribs[Ee];
              return;
            }
            if (H === "script" && Ee === "src") {
              let Ge = !0;
              try {
                const ze = be(Pe);
                if (O.allowedScriptHostnames || O.allowedScriptDomains) {
                  const un = (O.allowedScriptHostnames || []).find(function(Kt) {
                    return Kt === ze.url.hostname;
                  }), gr = (O.allowedScriptDomains || []).find(function(Kt) {
                    return ze.url.hostname === Kt || ze.url.hostname.endsWith(`.${Kt}`);
                  });
                  Ge = un || gr;
                }
              } catch {
                Ge = !1;
              }
              if (!Ge) {
                delete X.attribs[Ee];
                return;
              }
            }
            if (H === "iframe" && Ee === "src") {
              let Ge = !0;
              try {
                const ze = be(Pe);
                if (ze.isRelativeUrl)
                  Ge = d(O, "allowIframeRelativeUrls") ? O.allowIframeRelativeUrls : !O.allowedIframeHostnames && !O.allowedIframeDomains;
                else if (O.allowedIframeHostnames || O.allowedIframeDomains) {
                  const un = (O.allowedIframeHostnames || []).find(function(Kt) {
                    return Kt === ze.url.hostname;
                  }), gr = (O.allowedIframeDomains || []).find(function(Kt) {
                    return ze.url.hostname === Kt || ze.url.hostname.endsWith(`.${Kt}`);
                  });
                  Ge = un || gr;
                }
              } catch {
                Ge = !1;
              }
              if (!Ge) {
                delete X.attribs[Ee];
                return;
              }
            }
            if (Ee === "srcset" || Ee === "imagesrcset")
              try {
                let Ge = n(Pe);
                if (Ge.forEach(function(ze) {
                  T(H, ze.url) && (ze.evil = !0);
                }), Ge = b(Ge, function(ze) {
                  return !ze.evil;
                }), Ge.length)
                  Pe = I(b(Ge, function(ze) {
                    return !ze.evil;
                  })), X.attribs[Ee] = Pe;
                else {
                  delete X.attribs[Ee];
                  return;
                }
              } catch {
                delete X.attribs[Ee];
                return;
              }
            if (Ee === "class") {
              const Ge = K[H], ze = K["*"], un = ee[H], gr = ne[H], Kt = ne["*"], LA = ee["*"], Ef = [
                un,
                LA
              ].concat(gr, Kt).filter(function(xA) {
                return xA;
              });
              if (Ge && ze ? Pe = Ut(
                Pe,
                g(Ge, ze),
                Ef
              ) : Pe = Ut(
                Pe,
                Ge || ze,
                Ef
              ), !Pe.length) {
                delete X.attribs[Ee];
                return;
              }
            }
            if (Ee === "style") {
              if (O.parseStyleAttributes)
                try {
                  const Ge = i(H + " {" + Pe + "}", { map: !1 }), ze = me(
                    Ge,
                    O.allowedStyles
                  );
                  if (Pe = we(ze), Pe.length === 0) {
                    delete X.attribs[Ee];
                    return;
                  }
                } catch {
                  typeof window < "u" && x.warn(
                    `Failed to parse "${H} {${Pe}}". If you are running this in a browser, we recommend disabling style parsing with the parseStyleAttributes option, since it only works in a node environment due to a postcss dependency. More info: https://github.com/apostrophecms/sanitize-html/issues/547`
                  ), delete X.attribs[Ee];
                  return;
                }
              else if (O.allowedStyles)
                throw new Error("allowedStyles option cannot be used together with parseStyleAttributes: false.");
            }
            V += " " + Ee, Pe && Pe.length ? V += '="' + m(Pe, !0) + '"' : O.allowedEmptyAttributes.includes(Ee) && (V += '=""');
          } else
            delete X.attribs[Ee];
        }), O.selfClosing.indexOf(H) !== -1)
          V += " />";
        else if (V += ">", X.innerText && !He) {
          const Pe = m(X.innerText);
          O.textFilter ? V += O.textFilter(Pe, H) : V += Pe, Re = !0;
        }
        oe && (V = ae + m(V), ae = ""), X.openingTagLength = V.length - X.tagPosition;
      },
      ontext: function(H) {
        if (p(), Fe || De)
          return;
        const te = Ne[Ne.length - 1];
        let X;
        if (te && (X = te.tag, H = te.innerText !== void 0 ? te.innerText : H), O.disallowedTagsMode === "completelyDiscard" && !B(X))
          H = "";
        else if (X && B(X) && (O.disallowedTagsMode === "discard" || O.disallowedTagsMode === "completelyDiscard") && (X === "script" || X === "style"))
          V += H;
        else if (X && B(X) && (O.disallowedTagsMode === "discard" || O.disallowedTagsMode === "completelyDiscard") && (X === "textarea" || X === "xmp"))
          X === "xmp" ? V += H.replace(/</g, "&lt;").replace(/>/g, "&gt;") : V += m(H, !1);
        else if (
          // htmlparser2 treats <iframe> as a raw-text element, so markup inside
          // (including after an unclosed <iframe>) arrives as a single text node.
          // When the iframe is discarded, re-sanitize that fallback markup as HTML
          // instead of escaping it as plain text (issue #5550).
          // The nested call continues from the current depth so that
          // `nestingLimit` applies to the whole output.
          X === "iframe" && !B(X) && O.disallowedTagsMode === "discard" && z < L
        )
          V += R(H, O, {
            depth: ge,
            iframeFallbackDepth: z + 1
          });
        else if (!Re) {
          const oe = m(H, !1);
          O.textFilter ? V += O.textFilter(oe, X) : V += oe;
        }
        if (Ne.length) {
          const oe = Ne[Ne.length - 1];
          oe.text += H;
        }
      },
      onclosetag: function(H, te) {
        if (O.onCloseTag && O.onCloseTag(H, te), p(), De) {
          const He = Ne[Ne.length - 1];
          if (!He || He.tag !== H)
            return;
        } else if (Fe)
          if (_e--, !_e)
            Fe = !1, Le !== null && (De = !0);
          else
            return;
        const X = Ne.pop();
        if (!X)
          return;
        if (X.tag !== H) {
          Ne.push(X);
          return;
        }
        Fe = O.enforceHtmlBoundary ? H === "html" : !1, ge--;
        const oe = We[ge];
        if (oe) {
          if (delete We[ge], O.disallowedTagsMode === "discard" || O.disallowedTagsMode === "completelyDiscard") {
            X.updateParentNodeText();
            return;
          }
          ae = V, V = "";
        }
        if (Ue[ge] && (H = Ue[ge], delete Ue[ge]), O.exclusiveFilter) {
          const He = O.exclusiveFilter(X);
          if (He === "excludeTag") {
            oe && (V = ae, ae = ""), V = V.substring(0, X.tagPosition) + V.substring(X.tagPosition + X.openingTagLength);
            return;
          } else if (He) {
            V = V.substring(0, X.tagPosition);
            return;
          }
        }
        if (X.updateParentNodeMediaChildren(), X.updateParentNodeText(), // Already output />
        O.selfClosing.indexOf(H) !== -1 || // Escaped tag, closing tag is implied
        te && !B(H) && ["escape", "recursiveEscape"].indexOf(O.disallowedTagsMode) >= 0) {
          oe && (V = ae, ae = "");
          return;
        }
        V += "</" + H + ">", oe && (V = ae + m(V), ae = ""), Re = !1;
      }
    }, O.parser);
    if (gt.write(P), gt.end(), O.disallowedTagsMode === "escape" || O.disallowedTagsMode === "recursiveEscape") {
      const H = gt.endIndex;
      if (H != null && H >= 0 && H < P.length) {
        const te = P.substring(H);
        V += m(te);
      } else (H == null || H < 0) && P.length > 0 && V === "" && (V = m(P));
    }
    return V;
    function ti() {
      V = "", ge = U, Ne = [], We = {}, Ue = {}, Fe = !1, _e = 0, Le = null, De = !1;
    }
    function p() {
      Le !== null && gt.startIndex >= Le && (Le = null, De = !1);
    }
    function c(H, te) {
      const X = new RegExp("</" + H + "[\\t\\n\\f\\r />]", "ig");
      X.lastIndex = te;
      const oe = X.exec(P);
      return oe ? oe.index : 1 / 0;
    }
    function m(H, te) {
      return typeof H != "string" && (H = H + ""), O.parser.decodeEntities && (H = H.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;"), te && (H = H.replace(/"/g, "&quot;"))), H = H.replace(/&(?![a-zA-Z0-9#]{1,20};)/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;"), te && (H = H.replace(/"/g, "&quot;")), H;
    }
    function T(H, te) {
      const X = d(O.allowedSchemesByTag, H) ? O.allowedSchemesByTag[H] : O.allowedSchemes || [];
      return o(te, {
        allowedSchemes: X,
        allowProtocolRelative: O.allowProtocolRelative
      });
    }
    function S(H) {
      return Object.keys(H).some(function(te) {
        return te.toLowerCase() === "http-equiv" && String(H[te]).trim().toLowerCase() === "refresh";
      });
    }
    function j(H) {
      const te = String(H), X = function(Ee) {
        return Ee === " " || Ee === "	" || Ee === `
` || Ee === "\f" || Ee === "\r";
      };
      let oe = 0;
      const He = function() {
        for (; oe < te.length && X(te[oe]); )
          oe++;
      }, ot = function(Ee) {
        return (te[Ee] || "").toLowerCase();
      };
      He();
      const mf = oe;
      for (; oe < te.length && /[0-9.]/.test(te[oe]); )
        oe++;
      if (oe === mf)
        return !0;
      if (oe < te.length) {
        const Ee = te[oe];
        if (Ee !== ";" && Ee !== "," && !X(Ee))
          return !0;
        He(), (te[oe] === ";" || te[oe] === ",") && oe++, He();
      }
      if (oe >= te.length)
        return !1;
      let ri = te.slice(oe), Pe = !0;
      if (ot(oe) === "u" && (Pe = !1, ot(oe + 1) === "r" && ot(oe + 2) === "l" && (oe += 3, He(), te[oe] === "=" && (oe++, He(), Pe = !0))), Pe) {
        const Ee = te[oe];
        if ((Ee === '"' || Ee === "'") && oe++, ri = te.slice(oe), Ee === '"' || Ee === "'") {
          const ni = ri.indexOf(Ee);
          ni !== -1 && (ri = ri.slice(0, ni));
        }
      }
      return T("meta", ri);
    }
    function W(H, te) {
      if (l.indexOf(ue(H)) === -1)
        return !1;
      const X = O.allowedSchemesAppliedToAttributes || [];
      return Object.keys(te || {}).some(function(oe) {
        if (ue(oe) !== "attributename")
          return !1;
        const He = (te[oe] || "").trim().toLowerCase(), ot = He.slice(He.lastIndexOf(":") + 1);
        return f.indexOf(ot) !== -1 || X.indexOf(He) !== -1 || X.indexOf(ot) !== -1;
      });
    }
    function ue(H) {
      const te = H.toLowerCase();
      return te.slice(te.lastIndexOf(":") + 1);
    }
    function be(H) {
      if (H = H.replace(/^(\w+:)?\s*[\\/]\s*[\\/]/, "$1//"), H.startsWith("relative:"))
        throw new Error("relative: exploit attempt");
      let te = "relative://relative-site";
      for (let He = 0; He < 100; He++)
        te += `/${He}`;
      const X = new URL(H, te);
      return {
        isRelativeUrl: X && X.hostname === "relative-site" && X.protocol === "relative:",
        url: X
      };
    }
    function me(H, te) {
      if (!te)
        return H;
      const X = H.nodes[0];
      let oe;
      return te[X.selector] && te["*"] ? oe = y(
        te[X.selector],
        te["*"]
      ) : oe = te[X.selector] || te["*"], oe && (H.nodes[0].nodes = X.nodes.reduce(Oe(oe), [])), H;
    }
    function we(H) {
      return H.nodes[0].nodes.reduce(function(te, X) {
        return te.push(
          `${X.prop}:${X.value}${X.important ? " !important" : ""}`
        ), te;
      }, []).join(";");
    }
    function Oe(H) {
      return function(te, X) {
        return d(H, X.prop) && H[X.prop].some(function(He) {
          return He.test(X.value);
        }) && te.push(X), te;
      };
    }
    function Ut(H, te, X) {
      return te ? (H = H.split(/\s+/), H.filter(function(oe) {
        return te.indexOf(oe) !== -1 || X.some(function(He) {
          return He.test(oe);
        });
      }).join(" ")) : H;
    }
  }
  const D = {
    decodeEntities: !0
  };
  return R.defaults = {
    allowedTags: [
      // Sections derived from MDN element categories and limited to the more
      // benign categories.
      // https://developer.mozilla.org/en-US/docs/Web/HTML/Element
      // Content sectioning
      "address",
      "article",
      "aside",
      "footer",
      "header",
      "h1",
      "h2",
      "h3",
      "h4",
      "h5",
      "h6",
      "hgroup",
      "main",
      "nav",
      "section",
      // Text content
      "blockquote",
      "dd",
      "div",
      "dl",
      "dt",
      "figcaption",
      "figure",
      "hr",
      "li",
      "menu",
      "ol",
      "p",
      "pre",
      "ul",
      // Inline text semantics
      "a",
      "abbr",
      "b",
      "bdi",
      "bdo",
      "br",
      "cite",
      "code",
      "data",
      "dfn",
      "em",
      "i",
      "kbd",
      "mark",
      "q",
      "rb",
      "rp",
      "rt",
      "rtc",
      "ruby",
      "s",
      "samp",
      "small",
      "span",
      "strong",
      "sub",
      "sup",
      "time",
      "u",
      "var",
      "wbr",
      // Table content
      "caption",
      "col",
      "colgroup",
      "table",
      "tbody",
      "td",
      "tfoot",
      "th",
      "thead",
      "tr"
    ],
    // Tags that cannot be boolean
    nonBooleanAttributes: [
      "abbr",
      "accept",
      "accept-charset",
      "accesskey",
      "action",
      "allow",
      "alt",
      "as",
      "autocapitalize",
      "autocomplete",
      "blocking",
      "charset",
      "cite",
      "class",
      "color",
      "cols",
      "colspan",
      "content",
      "contenteditable",
      "coords",
      "crossorigin",
      "data",
      "datetime",
      "decoding",
      "dir",
      "dirname",
      "download",
      "draggable",
      "enctype",
      "enterkeyhint",
      "fetchpriority",
      "for",
      "form",
      "formaction",
      "formenctype",
      "formmethod",
      "formtarget",
      "headers",
      "height",
      "hidden",
      "high",
      "href",
      "hreflang",
      "http-equiv",
      "id",
      "imagesizes",
      "imagesrcset",
      "inputmode",
      "integrity",
      "is",
      "itemid",
      "itemprop",
      "itemref",
      "itemtype",
      "kind",
      "label",
      "lang",
      "list",
      "loading",
      "low",
      "max",
      "maxlength",
      "media",
      "method",
      "min",
      "minlength",
      "name",
      "nonce",
      "optimum",
      "pattern",
      "ping",
      "placeholder",
      "popover",
      "popovertarget",
      "popovertargetaction",
      "poster",
      "preload",
      "referrerpolicy",
      "rel",
      "rows",
      "rowspan",
      "sandbox",
      "scope",
      "shape",
      "size",
      "sizes",
      "slot",
      "span",
      "spellcheck",
      "src",
      "srcdoc",
      "srclang",
      "srcset",
      "start",
      "step",
      "style",
      "tabindex",
      "target",
      "title",
      "translate",
      "type",
      "usemap",
      "value",
      "width",
      "wrap",
      // Event handlers
      "onauxclick",
      "onafterprint",
      "onbeforematch",
      "onbeforeprint",
      "onbeforeunload",
      "onbeforetoggle",
      "onblur",
      "oncancel",
      "oncanplay",
      "oncanplaythrough",
      "onchange",
      "onclick",
      "onclose",
      "oncontextlost",
      "oncontextmenu",
      "oncontextrestored",
      "oncopy",
      "oncuechange",
      "oncut",
      "ondblclick",
      "ondrag",
      "ondragend",
      "ondragenter",
      "ondragleave",
      "ondragover",
      "ondragstart",
      "ondrop",
      "ondurationchange",
      "onemptied",
      "onended",
      "onerror",
      "onfocus",
      "onformdata",
      "onhashchange",
      "oninput",
      "oninvalid",
      "onkeydown",
      "onkeypress",
      "onkeyup",
      "onlanguagechange",
      "onload",
      "onloadeddata",
      "onloadedmetadata",
      "onloadstart",
      "onmessage",
      "onmessageerror",
      "onmousedown",
      "onmouseenter",
      "onmouseleave",
      "onmousemove",
      "onmouseout",
      "onmouseover",
      "onmouseup",
      "onoffline",
      "ononline",
      "onpagehide",
      "onpageshow",
      "onpaste",
      "onpause",
      "onplay",
      "onplaying",
      "onpopstate",
      "onprogress",
      "onratechange",
      "onreset",
      "onresize",
      "onrejectionhandled",
      "onscroll",
      "onscrollend",
      "onsecuritypolicyviolation",
      "onseeked",
      "onseeking",
      "onselect",
      "onslotchange",
      "onstalled",
      "onstorage",
      "onsubmit",
      "onsuspend",
      "ontimeupdate",
      "ontoggle",
      "onunhandledrejection",
      "onunload",
      "onvolumechange",
      "onwaiting",
      "onwheel"
    ],
    disallowedTagsMode: "discard",
    allowedAttributes: {
      a: ["href", "name", "target"],
      // We don't currently allow img itself by default, but
      // these attributes would make sense if we did.
      img: ["src", "srcset", "alt", "title", "width", "height", "loading"]
    },
    allowedEmptyAttributes: [
      "alt"
    ],
    // Lots of these won't come up by default because we don't allow them
    selfClosing: ["img", "br", "hr", "area", "base", "basefont", "input", "link", "meta", "col"],
    // URL schemes we permit
    allowedSchemes: ["http", "https", "ftp", "mailto", "tel"],
    allowedSchemesByTag: {},
    allowedSchemesAppliedToAttributes: [
      "href",
      "src",
      "cite",
      "action",
      "formaction",
      "data",
      "xlink:href",
      "poster",
      "background",
      "ping",
      "longdesc",
      "usemap",
      "codebase",
      "classid",
      "archive",
      "profile",
      "manifest",
      "itemid",
      "dynsrc",
      "lowsrc"
    ],
    allowProtocolRelative: !0,
    enforceHtmlBoundary: !1,
    parseStyleAttributes: !0,
    preserveEscapedAttributes: !1
  }, R.simpleTransform = function(P, O, F) {
    return F = F === void 0 ? !0 : F, O = O || {}, function(U, z) {
      let V;
      if (F)
        for (V in O)
          z[V] = O[V];
      else
        z = O;
      return {
        tagName: P,
        attribs: z
      };
    };
  }, Ou;
}
var B$ = /* @__PURE__ */ z$();
const WE = /* @__PURE__ */ Vc(B$), V$ = [
  "br",
  "del",
  "em",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "li",
  "ol",
  "p",
  "strong",
  "u",
  "ul"
], E4 = (e) => {
  const t = WE(e, {
    allowedTags: !1,
    allowedAttributes: !1,
    allowVulnerableTags: !0
    // Just to suppress warning. For comparison, we allow EVERYTHING here, including vulnerable stuff. That does not mean, we allow it in the final request.
  }), r = WE(e, {
    allowedTags: [...V$],
    allowedAttributes: {}
  });
  return t !== r;
};
function g4(e) {
  return M(e) ? Array.isArray(e) ? e : [e] : [];
}
function of(e) {
  return Bn(e);
}
function y4({
  pagination: e,
  data: t
}) {
  const r = Array.isArray(t) ? t : yb(t), { current: n = 1, pageSize: i = Mj(t) } = e, o = (n - 1) * i, s = o + i, a = r.slice(o, s);
  return Array.isArray(t) ? a : qj(a);
}
function Co(e) {
  const t = Ce(e);
  return t.length > 0 ? t : "---";
}
function Ce(e) {
  return vt(e) ? e : Array.isArray(e) ? e.map((t) => Ce(t)).join(" ") : Te(e) || Er(e) ? "" : Xe(e) || fa(e) ? e.toString() : String(e);
}
function W$(e) {
  return Array.isArray(e) ? e.length === 0 ? [] : e.map((t) => Ce(t)) : Te(e) || Er(e) ? [] : [Ce(e)];
}
function Pi(e) {
  return (t) => {
    if (Xe(t) && !Number.isNaN(t))
      return e(t);
    if (Array.isArray(t))
      return Pi(e)(t[0]);
    if (Te(t) || Er(t))
      return 0;
    if (vt(t)) {
      if (t === "")
        return 0;
      const r = e(t);
      return Number.isNaN(r) ? 0 : r;
    }
    return fa(t) ? t ? 1 : 0 : e(Number(t));
  };
}
function sf(e) {
  return (t) => {
    const r = Pi(e)(t);
    return Number.isFinite(r) ? r : 0;
  };
}
function hA(e) {
  return (t) => {
    const r = sf(e)(t);
    return r >= 0 ? r : 0;
  };
}
function mA(e) {
  return (t) => Array.isArray(t) ? t.length === 0 ? [] : t.map((r) => Pi(e)(r)) : Te(t) || Er(t) || fa(t) || t === "" ? [] : [Pi(e)(t)];
}
function Ma(e) {
  return Xe(e) ? Math.round(e) : parseInt(e, 10);
}
const q$ = Pi(Number), T4 = sf(Number), b4 = hA(Number), A4 = mA(Number), qE = Pi(Ma), H$ = sf(Ma), HE = hA(Ma), EA = mA(Ma);
function Y$(e) {
  if (fa(e))
    return e;
  if (Xe(e))
    return e === 1;
  const t = Ce(e);
  return /^(true|on|1)$/i.test(t);
}
function Z$(e, t) {
  return `category:${e}-${t}`;
}
function J$(e) {
  return `relation:${e}`;
}
function v4(e) {
  return q$(e.split(":")[1]);
}
function K$({
  dedicatedGroup: e,
  studentFieldValues: t,
  studentRelationIds: r
}) {
  var n;
  switch (e.kind) {
    case "none":
      return [];
    case "category": {
      const i = /* @__PURE__ */ new Map();
      for (const { id: s, value: a } of e.data) {
        const l = i.get(s);
        l ? l.push(a) : i.set(s, [a]);
      }
      const o = [];
      for (const s of t)
        for (const a of s.values)
          (n = i.get(s.fieldId)) != null && n.includes(a) && o.push(
            Z$(s.fieldId, a)
          );
      return o;
    }
    case "relation": {
      const i = new Set(e.data.map((o) => o.id));
      return r.filter((o) => i.has(o)).map((o) => J$(o));
    }
    default:
      return Et();
  }
}
function Cs({
  mapping: e,
  value: t
}) {
  return e.parse("allocationRules", t).dedi;
}
function YE({
  mapping: e,
  value: t
}) {
  return e.parse("allocationRules", t).dist;
}
function S4(e, t) {
  switch (e) {
    case Fs.enum.SPREAD:
      return t.spread;
    default:
      return Et();
  }
}
function I4({
  overrides: e,
  groupObject: t,
  mapping: r
}) {
  const n = r.parse("allocationRules", t);
  return M(e.dedicatedGroupString) && (n.dedi = JSON.parse(e.dedicatedGroupString)), M(e.distribution) && (n.dist = r.parse("allocationRules", {
    dist: e.distribution
  }).dist), JSON.stringify(n);
}
function _4({
  missingLinksLength: e,
  missingGroupsForActivitiesLength: t,
  override: r
}) {
  return r || e === 0 && t === 0;
}
function X$(e, t) {
  return e.k !== tn.NONE && t.k !== tn.NONE ? e.r === t.r && e.v === t.v : e.k === t.k;
}
function Q$({
  groups: e,
  mapping: t
}) {
  if (e.length <= 1)
    return { success: !0 };
  const r = YE({ mapping: t, value: e[0] }), n = [];
  for (const i of e) {
    const o = YE({ mapping: t, value: i });
    X$(o, r) || n.push(
      `Distribution mismatch for group ${t.parse(
        "groupName",
        i
      )} with group ${t.parse("groupName", e[0])}.`
    );
  }
  return n.length === 0 ? { success: !0 } : {
    success: !1,
    reason: n.join(`
`)
  };
}
var wu, ZE;
function eF() {
  if (ZE) return wu;
  ZE = 1;
  var e;
  return e = {
    // 1xx - The 1xx (Informational) class of status code indicates an interim response for communicating connection status or request progress prior to completing the requested action and sending a final response.
    "1xx": "Informational",
    "1xx_NAME": "INFORMATIONAL",
    "1xx_MESSAGE": "Indicates an interim response for communicating connection status or request progress prior to completing the requested action and sending a final response.",
    INFORMATIONAL: "1xx",
    // 2xx - The 2xx (Successful) class of status code indicates that the client's request was successfully received, understood, and accepted.
    "2xx": "Successful",
    "2xx_NAME": "SUCCESSFUL",
    "2xx_MESSAGE": "Indicates that the client's request was successfully received, understood, and accepted.",
    SUCCESSFUL: "2xx",
    // 3xx - The 3xx (Redirection) class of status code indicates that further action needs to be taken by the user agent in order to fulfill the request.
    "3xx": "Redirection",
    "3xx_NAME": "REDIRECTION",
    "3xx_MESSAGE": "Indicates that further action needs to be taken by the user agent in order to fulfill the request.",
    REDIRECTION: "3xx",
    // 4xx - The 4xx (Client Error) class of status code indicates that the client seems to have erred.
    "4xx": "Client Error",
    "4xx_NAME": "CLIENT_ERROR",
    "4xx_MESSAGE": "Indicates that the client seems to have erred.",
    CLIENT_ERROR: "4xx",
    // 5xx - The 5xx (Server Error) class of status code indicates that the server is aware that it has erred or is incapable of performing the requested method.
    "5xx": "Server Error",
    "5xx_NAME": "SERVER_ERROR",
    "5xx_MESSAGE": "Indicates that the server is aware that it has erred or is incapable of performing the requested method.",
    SERVER_ERROR: "5xx"
  }, wu = {
    classes: e,
    // ## Informational 1xx
    // Indicates an interim response for communicating connection status or request progress prior to completing the requested action and sending a final response.
    // 100 - The server has received the request headers and the client should proceed to send the request body.
    100: "Continue",
    "100_NAME": "CONTINUE",
    "100_MESSAGE": "The server has received the request headers and the client should proceed to send the request body.",
    "100_CLASS": e.INFORMATIONAL,
    CONTINUE: 100,
    // 101 - The requester has asked the server to switch protocols and the server has agreed to do so.
    101: "Switching Protocols",
    "101_NAME": "SWITCHING_PROTOCOLS",
    "101_MESSAGE": "The requester has asked the server to switch protocols and the server has agreed to do so.",
    "101_CLASS": e.INFORMATIONAL,
    SWITCHING_PROTOCOLS: 101,
    // 102 Processing (WebDAV; RFC 2518) - A WebDAV request may contain many sub-requests involving file operations, requiring a long time to complete the request. This code indicates that the server has received and is processing the request, but no response is available yet.[7] This prevents the client from timing out and assuming the request was lost.
    102: "Processing",
    "102_NAME": "PROCESSING",
    "102_MESSAGE": "A WebDAV request may contain many sub-requests involving file operations, requiring a long time to complete the request. This code indicates that the server has received and is processing the request, but no response is available yet.[7] This prevents the client from timing out and assuming the request was lost.",
    "102_CLASS": e.INFORMATIONAL,
    PROCESSING: 102,
    // 103 Early Hints (RFC 8297) - Used to return some response headers before final HTTP message.
    103: "Early Hints",
    "103_NAME": "EARLY_HINTS",
    "103_MESSAGE": "Used to return some response headers before final HTTP message.",
    "103_CLASS": e.INFORMATIONAL,
    EARLY_HINTS: 103,
    // ## Successful 2xx
    // Indicates that the client's request was successfully received, understood, and accepted.
    // 200 - Standard response for successful HTTP requests.
    200: "OK",
    "200_NAME": "OK",
    "200_MESSAGE": "Standard response for successful HTTP requests.",
    "200_CLASS": e.SUCCESSFUL,
    OK: 200,
    // 201 - The request has been fulfilled, resulting in the creation of a new resource.
    201: "Created",
    "201_NAME": "CREATED",
    "201_MESSAGE": "The request has been fulfilled, resulting in the creation of a new resource.",
    "201_CLASS": e.SUCCESSFUL,
    CREATED: 201,
    // 202 - The request has been accepted for processing, but the processing has not been completed.
    202: "Accepted",
    "202_NAME": "ACCEPTED",
    "202_MESSAGE": "The request has been accepted for processing, but the processing has not been completed.",
    "202_CLASS": e.SUCCESSFUL,
    ACCEPTED: 202,
    // 203 (since HTTP/1.1) - The server is a transforming proxy (e.g. a Web accelerator) that received a 200 OK from its origin, but is returning a modified version of the origin's response.
    203: "Non-Authoritative Information",
    "203_NAME": "NON_AUTHORITATIVE_INFORMATION",
    "203_MESSAGE": "The server is a transforming proxy (e.g. a Web accelerator) that received a 200 OK from its origin, but is returning a modified version of the origin's response.",
    "203_CLASS": e.SUCCESSFUL,
    NON_AUTHORITATIVE_INFORMATION: 203,
    // 204 - The server successfully processed the request and is not returning any content.
    204: "No Content",
    "204_NAME": "NO_CONTENT",
    "204_MESSAGE": "The server successfully processed the request and is not returning any content.",
    "204_CLASS": e.SUCCESSFUL,
    NO_CONTENT: 204,
    // 205 - The server successfully processed the request, but is not returning any content. Unlike a 204 response, this response requires that the requester reset the document view.
    205: "Reset Content",
    "205_NAME": "RESET_CONTENT",
    "205_MESSAGE": "The server successfully processed the request, but is not returning any content. Unlike a 204 response, this response requires that the requester reset the document view.",
    "205_CLASS": e.SUCCESSFUL,
    RESET_CONTENT: 205,
    // 206 (RFC 7233) - The server is delivering only part of the resource (byte serving) due to a range header sent by the client.
    206: "Partial Content",
    "206_NAME": "PARTIAL_CONTENT",
    "206_MESSAGE": "The server is delivering only part of the resource (byte serving) due to a range header sent by the client.",
    "206_CLASS": e.SUCCESSFUL,
    PARTIAL_CONTENT: 206,
    // 207 (WebDAV; RFC 4918) - The message body that follows is by default an XML message and can contain a number of separate response codes, depending on how many sub-requests were made.
    207: "Multi Status",
    "207_NAME": "MULTI_STATUS",
    "207_MESSAGE": "The message body that follows is by default an XML message and can contain a number of separate response codes, depending on how many sub-requests were made.",
    "207_CLASS": e.SUCCESSFUL,
    MULTI_STATUS: 207,
    // 208 (WebDAV; RFC 5842) - The members of a DAV binding have already been enumerated in a preceding part of the (multistatus) response, and are not being included again.
    208: "Already Reported",
    "208_NAME": "ALREADY_REPORTED",
    "208_MESSAGE": "The members of a DAV binding have already been enumerated in a preceding part of the (multistatus) response, and are not being included again.",
    "208_CLASS": e.SUCCESSFUL,
    ALREADY_REPORTED: 208,
    // 226 (RFC 3229) - The server has fulfilled a request for the resource, and the response is a representation of the result of one or more instance-manipulations applied to the current instance.
    226: "IM Used",
    "226_NAME": "IM_USED",
    "226_MESSAGE": "The server has fulfilled a request for the resource, and the response is a representation of the result of one or more instance-manipulations applied to the current instance.",
    "226_CLASS": e.SUCCESSFUL,
    IM_USED: 226,
    // ## Redirection 3xx
    // Indicates that further action needs to be taken by the user agent in order to fulfill the request.
    // 300 - Indicates multiple options for the resource from which the client may choose.
    300: "Multiple Choices",
    "300_NAME": "MULTIPLE_CHOICES",
    "300_MESSAGE": "Indicates multiple options for the resource from which the client may choose.",
    "300_CLASS": e.REDIRECTION,
    MULTIPLE_CHOICES: 300,
    // 301 - This and all future requests should be directed to the given URI.
    301: "Moved Permanently",
    "301_NAME": "MOVED_PERMANENTLY",
    "301_MESSAGE": "This and all future requests should be directed to the given URI.",
    "301_CLASS": e.REDIRECTION,
    MOVED_PERMANENTLY: 301,
    // 302 - This is an example of industry practice contradicting the standard. The HTTP/1.0 specification (RFC 1945) required the client to perform a temporary redirect (the original describing phrase was "Moved Temporarily"), but popular browsers implemented 302 with the functionality of a 303 See Other. Therefore, HTTP/1.1 added status codes 303 and 307 to distinguish between the two behaviours.
    302: "Found",
    "302_NAME": "FOUND",
    "302_MESSAGE": 'This is an example of industry practice contradicting the standard. The HTTP/1.0 specification (RFC 1945) required the client to perform a temporary redirect (the original describing phrase was "Moved Temporarily"), but popular browsers implemented 302 with the functionality of a 303 See Other. Therefore, HTTP/1.1 added status codes 303 and 307 to distinguish between the two behaviours.',
    "302_CLASS": e.REDIRECTION,
    FOUND: 302,
    // 303 (since HTTP/1.1) - The response to the request can be found under another URI using the GET method.
    303: "See Other",
    "303_NAME": "SEE_OTHER",
    "303_MESSAGE": "The response to the request can be found under another URI using the GET method.",
    "303_CLASS": e.REDIRECTION,
    SEE_OTHER: 303,
    // 304 (RFC 7232) - Indicates that the resource has not been modified since the version specified by the request headers If-Modified-Since or If-None-Match.
    304: "Not Modified",
    "304_NAME": "NOT_MODIFIED",
    "304_MESSAGE": "Indicates that the resource has not been modified since the version specified by the request headers If-Modified-Since or If-None-Match.",
    "304_CLASS": e.REDIRECTION,
    NOT_MODIFIED: 304,
    // 305 (since HTTP/1.1) - The requested resource is available only through a proxy, the address for which is provided in the response.
    305: "Use Proxy",
    "305_NAME": "USE_PROXY",
    "305_MESSAGE": "The requested resource is available only through a proxy, the address for which is provided in the response.",
    "305_CLASS": e.REDIRECTION,
    USE_PROXY: 305,
    // 306 - No longer used. Originally meant "Subsequent requests should use the specified proxy.
    306: "Switch Proxy",
    "306_NAME": "SWITCH_PROXY",
    "306_MESSAGE": 'No longer used. Originally meant "Subsequent requests should use the specified proxy.',
    "306_CLASS": e.REDIRECTION,
    SWITCH_PROXY: 306,
    // 307 (since HTTP/1.1) - In this case, the request should be repeated with another URI; however, future requests should still use the original URI.
    307: "Temporary Redirect",
    "307_NAME": "TEMPORARY_REDIRECT",
    "307_MESSAGE": "In this case, the request should be repeated with another URI; however, future requests should still use the original URI.",
    "307_CLASS": e.REDIRECTION,
    TEMPORARY_REDIRECT: 307,
    // 308 (RFC 7538) - The request and all future requests should be repeated using another URI.
    308: "Permanent Redirect",
    "308_NAME": "PERMANENT_REDIRECT",
    "308_MESSAGE": "The request and all future requests should be repeated using another URI.",
    "308_CLASS": e.REDIRECTION,
    PERMANENT_REDIRECT: 308,
    // ## Client Error 4xx
    // Indicates that the client seems to have erred.
    // 400 - The server cannot or will not process the request due to an apparent client error.
    400: "Bad Request",
    "400_NAME": "BAD_REQUEST",
    "400_MESSAGE": "The server cannot or will not process the request due to an apparent client error.",
    "400_CLASS": e.CLIENT_ERROR,
    BAD_REQUEST: 400,
    // 401 (RFC 7235) - Similar to 403 Forbidden, but specifically for use when authentication is required and has failed or has not yet been provided.
    401: "Unauthorized",
    "401_NAME": "UNAUTHORIZED",
    "401_MESSAGE": "Similar to 403 Forbidden, but specifically for use when authentication is required and has failed or has not yet been provided.",
    "401_CLASS": e.CLIENT_ERROR,
    UNAUTHORIZED: 401,
    // 402 - Reserved for future use. The original intention was that this code might be used as part of some form of digital cash or micropayment scheme, as proposed for example by GNU Taler, but that has not yet happened, and this code is not usually used.
    402: "Payment Required",
    "402_NAME": "PAYMENT_REQUIRED",
    "402_MESSAGE": "Reserved for future use. The original intention was that this code might be used as part of some form of digital cash or micropayment scheme, as proposed for example by GNU Taler, but that has not yet happened, and this code is not usually used.",
    "402_CLASS": e.CLIENT_ERROR,
    PAYMENT_REQUIRED: 402,
    // 403 - The request was valid, but the server is refusing action.
    403: "Forbidden",
    "403_NAME": "FORBIDDEN",
    "403_MESSAGE": "The request was valid, but the server is refusing action.",
    "403_CLASS": e.CLIENT_ERROR,
    FORBIDDEN: 403,
    // 404 - The requested resource could not be found but may be available in the future. Subsequent requests by the client are permissible.
    404: "Not Found",
    "404_NAME": "NOT_FOUND",
    "404_MESSAGE": "The requested resource could not be found but may be available in the future. Subsequent requests by the client are permissible.",
    "404_CLASS": e.CLIENT_ERROR,
    NOT_FOUND: 404,
    // 405 - A request method is not supported for the requested resource.
    405: "Method Not Allowed",
    "405_NAME": "METHOD_NOT_ALLOWED",
    "405_MESSAGE": "A request method is not supported for the requested resource.",
    "405_CLASS": e.CLIENT_ERROR,
    METHOD_NOT_ALLOWED: 405,
    // 406 - The requested resource is capable of generating only content not acceptable according to the Accept headers sent in the request.
    406: "Not Acceptable",
    "406_NAME": "NOT_ACCEPTABLE",
    "406_MESSAGE": "The requested resource is capable of generating only content not acceptable according to the Accept headers sent in the request.",
    "406_CLASS": e.CLIENT_ERROR,
    NOT_ACCEPTABLE: 406,
    // 407 (RFC 7235) - The client must first authenticate itself with the proxy.
    407: "Proxy Authentication Required",
    "407_NAME": "PROXY_AUTHENTICATION_REQUIRED",
    "407_MESSAGE": "The client must first authenticate itself with the proxy.",
    "407_CLASS": e.CLIENT_ERROR,
    PROXY_AUTHENTICATION_REQUIRED: 407,
    // 408 - The server timed out waiting for the request.
    408: "Request Time-out",
    "408_NAME": "REQUEST_TIMEOUT",
    "408_MESSAGE": "The server timed out waiting for the request.",
    "408_CLASS": e.CLIENT_ERROR,
    REQUEST_TIMEOUT: 408,
    // 409 - Indicates that the request could not be processed because of conflict in the request, such as an edit conflict between multiple simultaneous updates.
    409: "Conflict",
    "409_NAME": "CONFLICT",
    "409_MESSAGE": "Indicates that the request could not be processed because of conflict in the request, such as an edit conflict between multiple simultaneous updates.",
    "409_CLASS": e.CLIENT_ERROR,
    CONFLICT: 409,
    // 410 - Indicates that the resource requested is no longer available and will not be available again.
    410: "Gone",
    "410_NAME": "GONE",
    "410_MESSAGE": "Indicates that the resource requested is no longer available and will not be available again.",
    "410_CLASS": e.CLIENT_ERROR,
    GONE: 410,
    // 411 - The request did not specify the length of its content, which is required by the requested resource.
    411: "Length Required",
    "411_NAME": "LENGTH_REQUIRED",
    "411_MESSAGE": "The request did not specify the length of its content, which is required by the requested resource.",
    "411_CLASS": e.CLIENT_ERROR,
    LENGTH_REQUIRED: 411,
    // 412 (RFC 7232) - The server does not meet one of the preconditions that the requester put on the request.
    412: "Precondition Failed",
    "412_NAME": "PRECONDITION_FAILED",
    "412_MESSAGE": "The server does not meet one of the preconditions that the requester put on the request.",
    "412_CLASS": e.CLIENT_ERROR,
    PRECONDITION_FAILED: 412,
    // 413 (RFC 7231) - The request is larger than the server is willing or able to process. Previously called "Request Entity Too Large".
    413: "Request Entity Too Large",
    "413_NAME": "REQUEST_ENTITY_TOO_LARGE",
    "413_MESSAGE": 'The request is larger than the server is willing or able to process. Previously called "Request Entity Too Large".',
    "413_CLASS": e.CLIENT_ERROR,
    REQUEST_ENTITY_TOO_LARGE: 413,
    // 414 (RFC 7231) - The URI provided was too long for the server to process.
    414: "Request-URI Too Large",
    "414_NAME": "REQUEST_URI_TOO_LONG",
    "414_MESSAGE": "The URI provided was too long for the server to process.",
    "414_CLASS": e.CLIENT_ERROR,
    REQUEST_URI_TOO_LONG: 414,
    // 415 - The request entity has a media type which the server or resource does not support.
    415: "Unsupported Media Type",
    "415_NAME": "UNSUPPORTED_MEDIA_TYPE",
    "415_MESSAGE": "The request entity has a media type which the server or resource does not support.",
    "415_CLASS": e.CLIENT_ERROR,
    UNSUPPORTED_MEDIA_TYPE: 415,
    // 416 (RFC 7233) - The client has asked for a portion of the file (byte serving), but the server cannot supply that portion.
    416: "Requested Range not Satisfiable",
    "416_NAME": "REQUESTED_RANGE_NOT_SATISFIABLE",
    "416_MESSAGE": "The client has asked for a portion of the file (byte serving), but the server cannot supply that portion.",
    "416_CLASS": e.CLIENT_ERROR,
    REQUESTED_RANGE_NOT_SATISFIABLE: 416,
    // 417 - The server cannot meet the requirements of the Expect request-header field.
    417: "Expectation Failed",
    "417_NAME": "EXPECTATION_FAILED",
    "417_MESSAGE": "The server cannot meet the requirements of the Expect request-header field.",
    "417_CLASS": e.CLIENT_ERROR,
    EXPECTATION_FAILED: 417,
    // 418 (RFC 2324, RFC 7168) - Any attempt to brew coffee with a teapot should result in the error code "418 I'm a teapot". The resulting entity body MAY be short and stout. This code was defined in 1998 as one of the traditional IETF April Fools' jokes, in RFC 2324, Hyper Text Coffee Pot Control Protocol, and is not expected to be implemented by actual HTTP servers. The RFC specifies this code should be returned by teapots requested to brew coffee. This HTTP status is used as an Easter egg in some websites, including Google.com.
    418: "I'm a teapot",
    "418_NAME": "IM_A_TEAPOT",
    "418_MESSAGE": `Any attempt to brew coffee with a teapot should result in the error code "418 I'm a teapot". The resulting entity body MAY be short and stout.`,
    "418_CLASS": e.CLIENT_ERROR,
    IM_A_TEAPOT: 418,
    // 421 (RFC 7540) - The request was directed at a server that is not able to produce a response.
    421: "Misdirected Request",
    "421_NAME": "MISDIRECTED_REQUEST",
    "421_MESSAGE": "The request was directed at a server that is not able to produce a response.",
    "421_CLASS": e.CLIENT_ERROR,
    MISDIRECTED_REQUEST: 421,
    // 422 (WebDAV; RFC 4918) - The request was well-formed but was unable to be followed due to semantic errors.
    422: "Unprocessable Entity",
    "422_NAME": "UNPROCESSABLE_ENTITY",
    "422_MESSAGE": "The request was well-formed but was unable to be followed due to semantic errors.",
    "422_CLASS": e.CLIENT_ERROR,
    UNPROCESSABLE_ENTITY: 422,
    // 423 (WebDAV; RFC 4918) - The resource that is being accessed is locked.
    423: "Locked",
    "423_NAME": "LOCKED",
    "423_MESSAGE": "The resource that is being accessed is locked.",
    "423_CLASS": e.CLIENT_ERROR,
    LOCKED: 423,
    // 424 (WebDAV; RFC 4918) - The request failed because it depended on another request and that request failed.
    424: "Failed Dependency",
    "424_NAME": "FAILED_DEPENDENCY",
    "424_MESSAGE": "The request failed because it depended on another request and that request failed.",
    "424_CLASS": e.CLIENT_ERROR,
    FAILED_DEPENDENCY: 424,
    // 425 (RFC 8470) - The server is unwilling to risk processing a request that might be replayed.
    425: "Too Early",
    "425_NAME": "TOO_EARLY",
    "425_MESSAGE": "The server is unwilling to risk processing a request that might be replayed.",
    "425_CLASS": e.CLIENT_ERROR,
    TOO_EARLY: 425,
    // 426 - The client should switch to a different protocol such as TLS/1.0, given in the Upgrade header field.
    426: "Upgrade Required",
    "426_NAME": "UPGRADE_REQUIRED",
    "426_MESSAGE": "The client should switch to a different protocol such as TLS/1.0, given in the Upgrade header field.",
    "426_CLASS": e.CLIENT_ERROR,
    UPGRADE_REQUIRED: 426,
    // 428 (RFC 6585) - The origin server requires the request to be conditional.
    428: "Precondition Required",
    // RFC 6585
    "428_NAME": "PRECONDITION_REQUIRED",
    "428_MESSAGE": "The origin server requires the request to be conditional.",
    "428_CLASS": e.CLIENT_ERROR,
    PRECONDITION_REQUIRED: 428,
    // 429 (RFC 6585) - The user has sent too many requests in a given amount of time.
    429: "Too Many Requests",
    "429_NAME": "TOO_MANY_REQUESTS",
    "429_MESSAGE": "The user has sent too many requests in a given amount of time.",
    "429_CLASS": e.CLIENT_ERROR,
    TOO_MANY_REQUESTS: 429,
    // 431 (RFC 6585) - The server is unwilling to process the request because either an individual header field, or all the header fields collectively, are too large.
    431: "Request Header Fields Too Large",
    // RFC 6585
    "431_NAME": "REQUEST_HEADER_FIELDS_TOO_LARGE",
    "431_MESSAGE": "The server is unwilling to process the request because either an individual header field, or all the header fields collectively, are too large.",
    "431_CLASS": e.CLIENT_ERROR,
    REQUEST_HEADER_FIELDS_TOO_LARGE: 431,
    // 451 (RFC 7725) - A server operator has received a legal demand to deny access to a resource or to a set of resources that includes the requested resource.
    451: "Unavailable For Legal Reasons",
    "451_NAME": "UNAVAILABLE_FOR_LEGAL_REASONS",
    "451_MESSAGE": "A server operator has received a legal demand to deny access to a resource or to a set of resources that includes the requested resource.",
    "451_CLASS": e.CLIENT_ERROR,
    UNAVAILABLE_FOR_LEGAL_REASONS: 451,
    // ## Server Error 5xx
    // Indicates that the server is aware that it has erred or is incapable of performing the requested method.
    // 500 - A generic error message, given when an unexpected condition was encountered and no more specific message is suitable.
    500: "Internal Server Error",
    "500_NAME": "INTERNAL_SERVER_ERROR",
    "500_MESSAGE": "A generic error message, given when an unexpected condition was encountered and no more specific message is suitable.",
    "500_CLASS": e.SERVER_ERROR,
    INTERNAL_SERVER_ERROR: 500,
    // 501 - The server either does not recognize the request method, or it lacks the ability to fulfil the request. Usually this implies future availability.
    501: "Not Implemented",
    "501_NAME": "NOT_IMPLEMENTED",
    "501_MESSAGE": "The server either does not recognize the request method, or it lacks the ability to fulfil the request. Usually this implies future availability.",
    "501_CLASS": e.SERVER_ERROR,
    NOT_IMPLEMENTED: 501,
    // 502 - The server was acting as a gateway or proxy and received an invalid response from the upstream server.
    502: "Bad Gateway",
    "502_NAME": "BAD_GATEWAY",
    "502_MESSAGE": "The server was acting as a gateway or proxy and received an invalid response from the upstream server.",
    "502_CLASS": e.SERVER_ERROR,
    BAD_GATEWAY: 502,
    // 503 - The server is currently unavailable (because it is overloaded or down for maintenance). Generally, this is a temporary state.
    503: "Service Unavailable",
    "503_NAME": "SERVICE_UNAVAILABLE",
    "503_MESSAGE": "The server is currently unavailable (because it is overloaded or down for maintenance). Generally, this is a temporary state.",
    "503_CLASS": e.SERVER_ERROR,
    SERVICE_UNAVAILABLE: 503,
    // 504 - The server was acting as a gateway or proxy and did not receive a timely response from the upstream server.
    504: "Gateway Time-out",
    "504_NAME": "GATEWAY_TIMEOUT",
    "504_MESSAGE": "The server was acting as a gateway or proxy and did not receive a timely response from the upstream server.",
    "504_CLASS": e.SERVER_ERROR,
    GATEWAY_TIMEOUT: 504,
    // 505 - The server does not support the HTTP protocol version used in the request.
    505: "HTTP Version not Supported",
    "505_NAME": "HTTP_VERSION_NOT_SUPPORTED",
    "505_MESSAGE": "The server does not support the HTTP protocol version used in the request.",
    "505_CLASS": e.SERVER_ERROR,
    HTTP_VERSION_NOT_SUPPORTED: 505,
    // 506 (RFC 2295) - Transparent content negotiation for the request results in a circular reference.
    506: "Variant Also Negotiates",
    "506_NAME": "VARIANT_ALSO_NEGOTIATES",
    "506_MESSAGE": "Transparent content negotiation for the request results in a circular reference.",
    "506_CLASS": e.SERVER_ERROR,
    VARIANT_ALSO_NEGOTIATES: 506,
    // 507 (WebDAV; RFC 4918) - The server is unable to store the representation needed to complete the request.
    507: "Insufficient Storage",
    "507_NAME": "INSUFFICIENT_STORAGE",
    "507_MESSAGE": "The server is unable to store the representation needed to complete the request.",
    "507_CLASS": e.SERVER_ERROR,
    INSUFFICIENT_STORAGE: 507,
    // 508 (WebDAV; RFC 5842) - The server detected an infinite loop while processing the request.
    508: "Loop Detected",
    "508_NAME": "LOOP_DETECTED",
    "508_MESSAGE": "The server detected an infinite loop while processing the request.",
    "508_CLASS": e.SERVER_ERROR,
    LOOP_DETECTED: 508,
    // 510 (RFC 2774) - Further extensions to the request are required for the server to fulfil it.
    510: "Not Extended",
    "510_NAME": "NOT_EXTENDED",
    "510_MESSAGE": "Further extensions to the request are required for the server to fulfil it.",
    "510_CLASS": e.SERVER_ERROR,
    NOT_EXTENDED: 510,
    // 511 (RFC 6585) - The client needs to authenticate to gain network access. Intended for use by intercepting proxies used to control access to the network.
    511: "Network Authentication Required",
    "511_NAME": "NETWORK_AUTHENTICATION_REQUIRED",
    "511_MESSAGE": "The client needs to authenticate to gain network access. Intended for use by intercepting proxies used to control access to the network.",
    "511_CLASS": e.SERVER_ERROR,
    NETWORK_AUTHENTICATION_REQUIRED: 511,
    // ## Extra code
    // Extra HTTP code implemented by vendors and other specifications.
    extra: {
      // ### Unofficial codes
      // The following codes are not specified by any standard.
      unofficial: {
        // 103 - Used in the resumable requests proposal to resume aborted PUT or POST requests.
        103: "Checkpoint",
        "103_NAME": "CHECKPOINT",
        "103_MESSAGE": "Used in the resumable requests proposal to resume aborted PUT or POST requests.",
        "103_CLASS": e.INFORMATIONAL,
        CHECKPOINT: 103,
        // 419 Page Expired (Laravel Framework) - Used by the Laravel Framework when a CSRF Token is missing or expired.
        419: "Page Expired",
        "419_NAME": "PAGE_EXPIRED",
        "419_MESSAGE": "Used by the Laravel Framework when a CSRF Token is missing or expired.",
        "419_CLASS": e.CLIENT_ERROR,
        PAGE_EXPIRED: 419,
        // 218 This is fine (Apache Web Server) - Used as a catch-all error condition for allowing response bodies to flow through Apache when ProxyErrorOverride is enabled. When ProxyErrorOverride is enabled in Apache, response bodies that contain a status code of 4xx or 5xx are automatically discarded by Apache in favor of a generic response or a custom response specified by the ErrorDocument directive.
        218: "This is fine",
        "218_NAME": "THIS_IS_FINE",
        "218_MESSAGE": "Used as a catch-all error condition for allowing response bodies to flow through Apache when ProxyErrorOverride is enabled. When ProxyErrorOverride is enabled in Apache, response bodies that contain a status code of 4xx or 5xx are automatically discarded by Apache in favor of a generic response or a custom response specified by the ErrorDocument directive.",
        "218_CLASS": e.SUCCESSFUL,
        THIS_IS_FINE: 218,
        // 420 Enhance Your Calm (Twitter) - Returned by version 1 of the Twitter Search and Trends API when the client is being rate limited; versions 1.1 and later use the 429 Too Many Requests response code instead.
        420: "Enhance Your Calm",
        "420_NAME": "ENHANCE_YOUR_CALM",
        "420_MESSAGE": "Returned by version 1 of the Twitter Search and Trends API when the client is being rate limited; versions 1.1 and later use the 429 Too Many Requests response code instead.",
        "420_CLASS": e.CLIENT_ERROR,
        ENHANCE_YOUR_CALM: 420,
        // 450 Blocked by Windows Parental (Microsoft) - The Microsoft extension code indicated when Windows Parental Controls are turned on and are blocking access to the requested webpage.
        450: "Blocked by Windows Parental Controls",
        "450_NAME": "BLOCKED_BY_WINDOWS_PARENTAL_CONTROLS",
        "450_MESSAGE": "The Microsoft extension code indicated when Windows Parental Controls are turned on and are blocking access to the requested webpage.",
        "450_CLASS": e.CLIENT_ERROR,
        BLOCKED_BY_WINDOWS_PARENTAL_CONTROLS: 450,
        // 498 Invalid Token (Esri) - Returned by ArcGIS for Server. Code 498 indicates an expired or otherwise invalid token.
        498: "Invalid Token",
        "498_NAME": "INVALID_TOKEN",
        "498_MESSAGE": "Returned by ArcGIS for Server. Code 498 indicates an expired or otherwise invalid token.",
        "498_CLASS": e.CLIENT_ERROR,
        INVALID_TOKEN: 498,
        // 499 Token Required (Esri) - Returned by ArcGIS for Server. Code 499 indicates that a token is required but was not submitted.
        499: "Token Required",
        "499_NAME": "TOKEN_REQUIRED",
        "499_MESSAGE": "Returned by ArcGIS for Server. Code 499 indicates that a token is required but was not submitted.",
        "499_CLASS": e.CLIENT_ERROR,
        TOKEN_REQUIRED: 499,
        // 509 Bandwidth Limit Exceeded (Apache Web Server/cPanel) - The server has exceeded the bandwidth specified by the server administrator.
        509: "Bandwidth Limit Exceeded",
        "509_NAME": "BANDWIDTH_LIMIT_EXCEEDED",
        "509_MESSAGE": "The server has exceeded the bandwidth specified by the server administrator.",
        "509_CLASS": e.SERVER_ERROR,
        BANDWIDTH_LIMIT_EXCEEDED: 509,
        // 530 Site is frozen - Used by the Pantheon web platform to indicate a site that has been frozen due to inactivity.
        530: "Site is frozen",
        "530_NAME": "SITE_IS_FROZEN",
        "530_MESSAGE": "Used by the Pantheon web platform to indicate a site that has been frozen due to inactivity.",
        "530_CLASS": e.SERVER_ERROR,
        SITE_IS_FROZEN: 530,
        // 598 (Informal convention) Network read timeout error - Used by some HTTP proxies to signal a network read timeout behind the proxy to a client in front of the proxy.
        598: "Network read timeout error",
        "598_NAME": "NETWORK_READ_TIMEOUT_ERROR",
        "598_MESSAGE": "Used by some HTTP proxies to signal a network read timeout behind the proxy to a client in front of the proxy.",
        "598_CLASS": e.SERVER_ERROR,
        NETWORK_READ_TIMEOUT_ERROR: 598
      },
      // ### Internet Information Services (IIS)
      // Microsoft's Internet Information Services (IIS) web server expands the 4xx error space to signal errors with the client's request.
      iis: {
        // 440 - The client's session has expired and must log in again.
        440: "Login Time-out",
        "440_NAME": "LOGIN_TIME_OUT",
        "440_MESSAGE": "The client's session has expired and must log in again.",
        "440_CLASS": e.CLIENT_ERROR,
        LOGIN_TIME_OUT: 440,
        // 449 - The server cannot honour the request because the user has not provided the required information.
        449: "Retry With",
        "449_NAME": "RETRY_WITH",
        "449_MESSAGE": "The server cannot honour the request because the user has not provided the required information.",
        "449_CLASS": e.CLIENT_ERROR,
        RETRY_WITH: 449,
        // 451 - Used in Exchange ActiveSync when either a more efficient server is available or the server cannot access the users' mailbox.
        451: "Redirect",
        "451_NAME": "REDIRECT",
        "451_MESSAGE": "Used in Exchange ActiveSync when either a more efficient server is available or the server cannot access the users' mailbox.",
        "451_CLASS": e.CLIENT_ERROR,
        REDIRECT: 451
      },
      // ### NGINX
      // The NGINX web server software expands the 4xx error space to signal issues with the client's request.
      nginx: {
        // 444 - Used internally to instruct the server to return no information to the client and close the connection immediately.
        444: "No Response",
        "444_NAME": "NO_RESPONSE",
        "444_MESSAGE": "Used internally to instruct the server to return no information to the client and close the connection immediately.",
        "444_CLASS": e.CLIENT_ERROR,
        NO_RESPONSE: 444,
        // 494 - Client sent too large request or too long header line.
        494: "Request header too large",
        "494_NAME": "REQUEST_HEADER_TOO_LARGE",
        "494_MESSAGE": "Client sent too large request or too long header line.",
        "494_CLASS": e.CLIENT_ERROR,
        REQUEST_HEADER_TOO_LARGE: 494,
        // 495 - An expansion of the 400 Bad Request response code, used when the client has provided an invalid client certificate.
        495: "SSL Certificate Error",
        "495_NAME": "SSL_CERTIFICATE_ERROR",
        "495_MESSAGE": "An expansion of the 400 Bad Request response code, used when the client has provided an invalid client certificate.",
        "495_CLASS": e.CLIENT_ERROR,
        SSL_CERTIFICATE_ERROR: 495,
        // 496 - An expansion of the 400 Bad Request response code, used when a client certificate is required but not provided.
        496: "SSL Certificate Required",
        "496_NAME": "SSL_CERTIFICATE_REQUIRED",
        "496_MESSAGE": "An expansion of the 400 Bad Request response code, used when a client certificate is required but not provided.",
        "496_CLASS": e.CLIENT_ERROR,
        SSL_CERTIFICATE_REQUIRED: 496,
        // 497 - An expansion of the 400 Bad Request response code, used when the client has made a HTTP request to a port listening for HTTPS requests.
        497: "HTTP Request Sent to HTTPS Port",
        "497_NAME": "HTTP_REQUEST_SENT_TO_HTTPS_PORT",
        "497_MESSAGE": "An expansion of the 400 Bad Request response code, used when the client has made a HTTP request to a port listening for HTTPS requests.",
        "497_CLASS": e.CLIENT_ERROR,
        HTTP_REQUEST_SENT_TO_HTTPS_PORT: 497,
        // 499 - Used when the client has closed the request before the server could send a response.
        499: "Client Closed Request",
        "499_NAME": "CLIENT_CLOSED_REQUEST",
        "499_MESSAGE": "Used when the client has closed the request before the server could send a response.",
        "499_CLASS": e.CLIENT_ERROR,
        CLIENT_CLOSED_REQUEST: 499
      },
      // ### Cloudflare
      // Cloudflare's reverse proxy service expands the 5xx series of errors space to signal issues with the origin server.
      cloudflare: {
        // 520 - The 520 error is used as a "catch-all response for when the origin server returns something unexpected", listing connection resets, large headers, and empty or invalid responses as common triggers.
        520: "Unknown Error",
        "520_NAME": "UNKNOWN_ERROR",
        "520_MESSAGE": 'The 520 error is used as a "catch-all response for when the origin server returns something unexpected", listing connection resets, large headers, and empty or invalid responses as common triggers.',
        "520_CLASS": e.SERVER_ERROR,
        UNKNOWN_ERROR: 520,
        // 521 - The origin server has refused the connection from Cloudflare.
        521: "Web Server Is Down",
        "521_NAME": "WEB_SERVER_IS_DOWN",
        "521_MESSAGE": "The origin server has refused the connection from Cloudflare.",
        "521_CLASS": e.SERVER_ERROR,
        WEB_SERVER_IS_DOWN: 521,
        // 522 - Cloudflare could not negotiate a TCP handshake with the origin server.
        522: "Connection Timed Out",
        "522_NAME": "CONNECTION_TIMED_OUT",
        "522_MESSAGE": "Cloudflare could not negotiate a TCP handshake with the origin server.",
        "522_CLASS": e.SERVER_ERROR,
        CONNECTION_TIMED_OUT: 522,
        // 523 - Cloudflare could not reach the origin server.
        523: "Origin Is Unreachable",
        "523_NAME": "ORIGIN_IS_UNREACHABLE",
        "523_MESSAGE": "Cloudflare could not reach the origin server.",
        "523_CLASS": e.SERVER_ERROR,
        ORIGIN_IS_UNREACHABLE: 523,
        // 524 - Cloudflare was able to complete a TCP connection to the origin server, but did not receive a timely HTTP response.
        524: "A Timeout Occurred",
        "524_NAME": "A_TIMEOUT_OCCURRED",
        "524_MESSAGE": "Cloudflare was able to complete a TCP connection to the origin server, but did not receive a timely HTTP response.",
        "524_CLASS": e.SERVER_ERROR,
        A_TIMEOUT_OCCURRED: 524,
        // 525 - Cloudflare could not negotiate a SSL/TLS handshake with the origin server.
        525: "SSL Handshake Failed",
        "525_NAME": "SSL_HANDSHAKE_FAILED",
        "525_MESSAGE": "Cloudflare could not negotiate a SSL/TLS handshake with the origin server.",
        "525_CLASS": e.SERVER_ERROR,
        SSL_HANDSHAKE_FAILED: 525,
        // 526 - Cloudflare could not validate the SSL/TLS certificate that the origin server presented.
        526: "Invalid SSL Certificate",
        "526_NAME": "INVALID_SSL_CERTIFICATE",
        "526_MESSAGE": "Cloudflare could not validate the SSL/TLS certificate that the origin server presented.",
        "526_CLASS": e.SERVER_ERROR,
        INVALID_SSL_CERTIFICATE: 526,
        // 527 - Error 527 indicates that the request timed out or failed after the WAN connection had been established.
        527: "Railgun Error",
        "527_NAME": "RAILGUN_ERROR",
        "527_MESSAGE": "Error 527 indicates that the request timed out or failed after the WAN connection had been established.",
        "527_CLASS": e.SERVER_ERROR,
        RAILGUN_ERROR: 527
      }
    }
  }, wu;
}
var tF = eF();
const Je = /* @__PURE__ */ Vc(tF);
class je extends Error {
  constructor(r, n) {
    super(r, n);
    $(this, "errorName");
    $(this, "cause");
    this.name = this.constructor.errorName, this.errorName = this.constructor.errorName, (n == null ? void 0 : n.cause) !== void 0 && (this.cause = n.cause), Object.setPrototypeOf(this, new.target.prototype);
  }
}
$(je, "errorName");
class af extends DOMException {
  constructor(r) {
    super(r);
    $(this, "errorName");
    $(this, "name");
    this.name = this.constructor.errorName, this.errorName = this.constructor.errorName, Object.setPrototypeOf(this, new.target.prototype);
  }
}
$(af, "errorName");
class rF extends je {
  constructor(r, n, i, o) {
    super(r, o);
    $(this, "statusCode");
    $(this, "errorCode");
    this.statusCode = n ?? Je.UNPROCESSABLE_ENTITY, this.errorCode = i ?? -1, Object.setPrototypeOf(this, new.target.prototype);
  }
}
$(rF, "errorName", le.TEServerFailedError);
class nF extends je {
  constructor(r, n) {
    super(r, n);
    $(this, "statusCode");
    this.statusCode = Je.UNPROCESSABLE_ENTITY, Object.setPrototypeOf(this, new.target.prototype);
  }
}
$(nF, "errorName", le.ValidationError);
class iF extends je {
  constructor(r, n) {
    super(r, n);
    $(this, "statusCode");
    this.statusCode = Je.BAD_REQUEST, Object.setPrototypeOf(this, new.target.prototype);
  }
}
$(iF, "errorName", le.BadRequestError);
class oF extends je {
  constructor(r, n) {
    super(r, n);
    $(this, "statusCode");
    this.statusCode = Je.NOT_FOUND, Object.setPrototypeOf(this, new.target.prototype);
  }
}
$(oF, "errorName", le.NotFoundError);
class sF extends je {
  constructor(r, n) {
    super(r ?? "No student object is connected to your user.", n);
    $(this, "statusCode");
    this.statusCode = Je.BAD_REQUEST, Object.setPrototypeOf(this, new.target.prototype);
  }
}
$(sF, "errorName", le.NoStudentObjectError);
class aF extends je {
  constructor(r, n) {
    super(r ?? "Unable to create subscription", n);
    $(this, "statusCode");
    this.statusCode = Je.BAD_REQUEST, Object.setPrototypeOf(this, new.target.prototype);
  }
}
$(aF, "errorName", le.SubscribeError);
class Ho extends je {
  constructor(r, n) {
    super(r, n);
    $(this, "statusCode");
    this.statusCode = Je.UNPROCESSABLE_ENTITY, Object.setPrototypeOf(this, new.target.prototype);
  }
}
$(Ho, "errorName", le.StudentSetGroupConfigurationError);
class uF extends je {
  constructor(r, n) {
    super(r, n);
    $(this, "statusCode");
    this.statusCode = Je.UNPROCESSABLE_ENTITY, Object.setPrototypeOf(this, new.target.prototype);
  }
}
$(uF, "errorName", le.AdminConfigurationError);
class lF extends je {
  constructor(r, n = Je.INTERNAL_SERVER_ERROR, i) {
    super(r, i);
    $(this, "statusCode");
    this.statusCode = n, Object.setPrototypeOf(this, new.target.prototype);
  }
}
$(lF, "errorName", le.PacemakerFetchError);
class cF extends je {
  constructor(r, n = Je.INTERNAL_SERVER_ERROR, i) {
    super(r, i);
    $(this, "statusCode");
    this.statusCode = n, Object.setPrototypeOf(this, new.target.prototype);
  }
}
$(cF, "errorName", le.PacemakerResponseError);
class Al extends je {
  constructor(r, n) {
    super(r, n);
    $(this, "statusCode");
    this.statusCode = Je.FORBIDDEN, Object.setPrototypeOf(this, new.target.prototype);
  }
}
$(Al, "errorName", le.PermissionError);
class fF extends je {
  constructor(r, n = Je.INTERNAL_SERVER_ERROR, i) {
    super(r, i);
    $(this, "statusCode");
    this.statusCode = n, Object.setPrototypeOf(this, new.target.prototype);
  }
}
$(fF, "errorName", le.ExternalServiceError);
class dF extends je {
  constructor(r, n) {
    super(r, n);
    $(this, "statusCode");
    this.statusCode = Je.INTERNAL_SERVER_ERROR, Object.setPrototypeOf(this, new.target.prototype);
  }
}
$(dF, "errorName", le.MultiError);
class pF extends je {
  constructor(r, n = Je.INTERNAL_SERVER_ERROR, i) {
    super(r, i);
    $(this, "statusCode");
    this.statusCode = n, Object.setPrototypeOf(this, new.target.prototype);
  }
}
$(pF, "errorName", le.RegistrationApiError);
class hF extends je {
  constructor(r, n) {
    super(r, n);
    $(this, "statusCode");
    this.statusCode = Je.SERVICE_UNAVAILABLE, Object.setPrototypeOf(this, new.target.prototype);
  }
}
$(hF, "errorName", le.PopulateCacheBusyError);
class mF extends je {
  constructor(r, n) {
    super(r, n);
    $(this, "statusCode");
    this.statusCode = Je.SERVICE_UNAVAILABLE, Object.setPrototypeOf(this, new.target.prototype);
  }
}
$(mF, "errorName", le.AutoAllocateBusyError);
class EF extends je {
  constructor(r, n) {
    super(r, n);
    $(this, "statusCode");
    this.statusCode = Je.SERVICE_UNAVAILABLE, Object.setPrototypeOf(this, new.target.prototype);
  }
}
$(EF, "errorName", le.CloudJobRunningError);
class gF extends je {
  constructor(t, r) {
    super(t, r), Object.setPrototypeOf(this, new.target.prototype);
  }
}
$(gF, "errorName", le.WorkerInlineFallbackError);
class yF extends je {
  constructor(r, n) {
    super(r, n);
    $(this, "statusCode");
    this.statusCode = Je.REQUEST_TIMEOUT, Object.setPrototypeOf(this, new.target.prototype);
  }
}
$(yF, "errorName", le.WorkerTimeoutError);
class TF extends je {
  constructor(r, n) {
    super(r, n);
    $(this, "statusCode");
    this.statusCode = Je.SERVICE_UNAVAILABLE, Object.setPrototypeOf(this, new.target.prototype);
  }
}
$(TF, "errorName", le.WorkerQueueSaturated);
class bF extends je {
  constructor(r, n) {
    super(r, n);
    $(this, "statusCode");
    this.statusCode = 503, Object.setPrototypeOf(this, new.target.prototype);
  }
}
$(bF, "errorName", le.HeavyLoadError);
class AF extends af {
  constructor(r) {
    super(r);
    $(this, "code", 20);
    Object.setPrototypeOf(this, new.target.prototype);
  }
}
$(AF, "errorName", le.InterruptAbortException);
class vF extends af {
  constructor(r) {
    super(r);
    $(this, "code", 20);
    Object.setPrototypeOf(this, new.target.prototype);
  }
}
$(vF, "errorName", le.UnmountAbortException);
class SF extends je {
  constructor(r, n) {
    super(r, n);
    $(this, "statusCode");
    this.statusCode = 500, Object.setPrototypeOf(this, new.target.prototype);
  }
}
$(SF, "errorName", le.NothingToAllocateError);
class IF extends je {
  constructor(r, n = Je.INTERNAL_SERVER_ERROR, i) {
    super(r, i);
    $(this, "statusCode");
    this.statusCode = n, Object.setPrototypeOf(this, new.target.prototype);
  }
}
$(IF, "errorName", le.MaximumMembershipReachedError);
class _F extends je {
  constructor(r, n = Je.INTERNAL_SERVER_ERROR, i) {
    super(r, i);
    $(this, "statusCode");
    this.statusCode = n, Object.setPrototypeOf(this, new.target.prototype);
  }
}
$(_F, "errorName", le.MaximumMembershipReachedByTypeError);
class RF extends je {
  constructor(r, n = Je.INTERNAL_SERVER_ERROR, i) {
    super(r, i);
    $(this, "statusCode");
    this.statusCode = n, Object.setPrototypeOf(this, new.target.prototype);
  }
}
$(RF, "errorName", le.AddWaitlistError);
class OF extends je {
  constructor(r, n = Je.INTERNAL_SERVER_ERROR, i) {
    super(r, i);
    $(this, "statusCode");
    this.statusCode = n, Object.setPrototypeOf(this, new.target.prototype);
  }
}
$(OF, "errorName", le.ReservationError);
class wF extends je {
  constructor(r, n) {
    super(r, n);
    $(this, "statusCode");
    this.statusCode = Je.SERVICE_UNAVAILABLE, Object.setPrototypeOf(this, new.target.prototype);
  }
}
$(wF, "errorName", le.IssueListCacheError);
class NF extends je {
  constructor(t, r) {
    super(t, r), Object.setPrototypeOf(this, new.target.prototype);
  }
}
$(NF, "errorName", le.HistoryError);
class uf extends je {
  constructor(r) {
    const n = r.errors.reduce((i, o) => `${i}
${Dt(o)}`, "");
    super(n);
    $(this, "recover", () => location.reload());
    Object.setPrototypeOf(this, new.target.prototype), r.errors.forEach((i) => {
      Te(i) && Object.keys(i).forEach((o) => {
        o !== "message" && (Array.isArray(this[o]) || (this[o] = []), this[o].push(i[o]));
      });
    }), M(r.attemptRecovery) && (this.recover = r.attemptRecovery);
  }
}
$(uf, "errorName", le.FrontendError);
class CF extends uf {
}
$(CF, "errorName", le.RegistrationError);
class PF extends uf {
}
$(PF, "errorName", le.MyScheduleError);
class DF extends je {
  constructor(r, n) {
    super(r, n);
    $(this, "statusCode");
    this.statusCode = Je.INTERNAL_SERVER_ERROR, Object.setPrototypeOf(this, new.target.prototype);
  }
}
$(DF, "errorName", le.EnvError);
function gA({
  courseIds: e,
  group: t,
  mapping: r
}) {
  const n = r.parse("activityType", t), i = yA({
    courseIds: e,
    group: t,
    mapping: r
  });
  return i.success ? {
    success: !0,
    activityType: n
  } : {
    success: !1,
    activityType: n,
    message: i.message,
    issues: i.issues
  };
}
function MF(e, t, r) {
  const n = gA({
    courseIds: e,
    group: t,
    mapping: r
  });
  return n.success ? {
    success: !0,
    data: vl(
      JE(e) ?? -1,
      n.activityType
    )
  } : {
    success: !1,
    message: n.message,
    issues: n.issues,
    data: vl(
      JE(e) ?? -1,
      n.activityType
    )
  };
}
function JE(e) {
  return [...e].sort((t, r) => t - r)[0];
}
function LF({
  courseIds: e,
  groups: t,
  mapping: r
}) {
  const n = [], i = /* @__PURE__ */ new Set();
  for (const s of t) {
    const a = gA({
      courseIds: e,
      group: s,
      mapping: r
    });
    if (!a.success) {
      n.push(a.message);
      continue;
    }
    i.add(a.activityType);
  }
  const o = Array.from(i).sort((s, a) => s.localeCompare(a)).reduce((s, a, l) => l === 0 ? a : `${s} + ${a}`, "");
  return of(n) ? {
    success: !1,
    messages: n
  } : {
    success: !0,
    data: vl(e[0] ?? -1, o)
  };
}
function vl(e, t) {
  const r = zj(`${e}${t}`);
  return { courseId: e, activityType: t, id: r };
}
function yA({
  courseIds: e,
  group: t,
  mapping: r
}) {
  let n = {};
  const i = [];
  try {
    TA(e, t);
  } catch (o) {
    const s = gm(o), a = $s.safeParse(s);
    a.success && (n = {
      ...n,
      ...a.data
    }), i.push(Dt(o));
  }
  try {
    kF(t, r);
  } catch (o) {
    const s = gm(o), a = $s.safeParse(s);
    a.success && (n = {
      ...n,
      ...a.data
    }), i.push(Dt(o));
  }
  return Hj(n) > 0 ? {
    success: !1,
    message: i.join(`
`),
    issues: n
  } : {
    success: !0
  };
}
function TA(e, t) {
  if (e.length !== 1)
    throw new Ho(
      xF(e, t),
      {
        cause: { invalidCourseIds: !0 }
      }
    );
}
function xF(e, t) {
  return `Wrong number of course ids for student set group '${t.id}': expected '1', got '${e.length}': '${e.join(", ")}'.`;
}
function kF(e, t) {
  var i;
  const r = ((i = e == null ? void 0 : e.fields.find(
    (o) => t.getIds("activityType").includes(o.fieldId)
  )) == null ? void 0 : i.values.length) ?? 0;
  if (r !== 1)
    throw new Ho(
      `Wrong number of 'activityType' field values for student set group '${e.id}': expected '1', got '${r}'.`,
      {
        cause: { invalidActivityType: !0 }
      }
    );
  const n = t.parse("activityType", e);
  if (!$r(n))
    throw new Error(
      `Missing 'activityType' field value for student set group: '${e.id}'. Value: '${n}'.`,
      {
        cause: { invalidActivityType: !0 }
      }
    );
}
function jF({
  groups: e,
  courseIds: t,
  studentIds: r,
  mapping: n
}) {
  const i = new Set(t), o = new Set(r), s = /* @__PURE__ */ new Map();
  for (const a of e) {
    const l = Wn(
      a.relations.flatMap((y) => y.objectIds).filter((y) => i.has(y))
    ), f = a.members.reduce((y, b) => (o.has(b.objectId) && y.push(b.objectId), y), []), u = MF(l, a, n);
    if (!u.success)
      continue;
    const { id: h, courseId: E, activityType: d } = u.data, g = s.get(h);
    if (!M(g)) {
      s.set(h, {
        id: h,
        activityType: d,
        courseId: E,
        students: f,
        groups: [a]
      });
      continue;
    }
    g.groups.push(a), g.students.push(
      ...f.filter(
        (y) => !g.students.includes(y)
      )
    );
  }
  return Array.from(s.values());
}
function bA(e, t) {
  return `${e.parse("activityType", t)} ${e.parse(
    "groupNumber",
    t
  )}`;
}
function R4(e, t) {
  return t.links.length > 0 ? bA(e, t.teObject) : e.parse("groupNumber", t.teObject);
}
function O4(e, t, r) {
  return e.reduce((n, i) => {
    const o = i.relations.reduce(
      (s, { objectIds: a }) => {
        const l = a.filter((f) => t.some(({ id: u }) => u === f));
        return [...s, ...l];
      },
      []
    );
    try {
      TA(o, i);
    } catch (s) {
      return r.warn(
        `[createGroupsWithCourses]: Missconfigured student set group: ${Dt(
          s
        )}`,
        { err: s }
      ), n;
    }
    return [...n, { ...i, courseId: o[0] }];
  }, []);
}
function w4(e) {
  if (!Array.isArray(e))
    return !1;
  const t = e == null ? void 0 : e[0];
  return Te(t) && "id" in t && Xe(t.id);
}
function N4(e) {
  return Te(e) && "results" in e;
}
function C4(e) {
  return Te(e) && "objects" in e;
}
function P4(e) {
  return Te(e) && "id" in e && Xe(e.id);
}
function D4(e) {
  return "activityId" in e && "object" in e && "id" in e && typeof e.id == "number" && "courseId" in e && typeof e.courseId == "number";
}
function M4(e) {
  return Te(e) && "status" in e && "message" in e && "data" in e && Object.keys(e).length === 3;
}
function L4(e) {
  return Te(e) && "logId" in e;
}
function x4(e, t) {
  return UF(e == null ? void 0 : e.status, t);
}
function UF(e, t) {
  return e !== void 0 && QP[t].some((r) => r === e);
}
function k4(e) {
  return typeof e == "string" || typeof e == "number" || typeof e == "bigint";
}
function j4(e) {
  if (!Te(e))
    return !1;
  if (!("from" in e) || e.from === void 0)
    return !0;
  const t = e.from;
  return Te(t) && vt(t.pathname) && (t.search === void 0 || vt(t.search));
}
function AA(e, t, r = console) {
  const n = /* @__PURE__ */ new Set(), i = /* @__PURE__ */ new Set();
  for (const s of e)
    o(s);
  return n;
  function o(s) {
    if (i.has(s)) return;
    i.add(s), n.add(s);
    const a = t.get(s);
    if (!a) {
      r.warn(
        `Could not find the type ${s} in cache. Could not get subtypes for it.`
      );
      return;
    }
    if (Array.isArray(a.subTypes))
      for (const l of a.subTypes)
        o(l);
  }
}
function U4({
  cachedTypes: e,
  object: t,
  objectTypes: r,
  typeId: n,
  logger: i
}) {
  if (!M(n))
    return !0;
  const o = $e(n) ? n : [n];
  if (o.length === 0 || vA.some((f) => o.includes(f)))
    return !0;
  const s = AA(o, e, i), a = r.get(t.id);
  if (!M(a))
    return l(t.types.length, t.types);
  return l(t.types.length, a);
  function l(f, u) {
    return f > 0 && u.some((h) => s.has(h));
  }
}
const vA = [0, 1];
function $F(e) {
  return !M(e) || vA.includes(e);
}
function $4(e) {
  return M(e) ? mj(e) ? [Em(e)] : $e(e) ? e.map(Em) : [0] : [0];
}
function F4(e) {
  return (e == null ? void 0 : e.reduce((t, r) => {
    const n = r.fields.map((i) => i.fieldId).filter(M);
    return pb(t, n);
  }, [])) ?? [];
}
function FF(e) {
  const t = Ce(e), r = H$(t.replaceAll("%", "")), n = t.includes("%");
  return { size: r, isPercent: n };
}
function GF(e) {
  let t = { kind: "none", data: void 0 };
  try {
    if (WF(e)) {
      const { dist: r, ...n } = e;
      t = n;
    } else if (qF(e))
      t = e.dedi;
    else
      return { kind: "none", data: void 0 };
    if (t.kind === "category") {
      const r = t.data.reduce(
        (n, i) => (Fj(i) && n.push({ id: i.id, value: i.value }), n),
        []
      );
      return r.length === 0 ? { kind: "none", data: void 0 } : { kind: "category", data: r };
    }
    if (t.kind === "relation") {
      const r = t.data.reduce(
        (n, i) => (Gj(i) && n.push({ id: i.id }), n),
        []
      );
      return r.length === 0 ? { kind: "none", data: void 0 } : { kind: "relation", data: r };
    }
    return { kind: "none", data: void 0 };
  } catch {
    return { kind: "none", data: void 0 };
  }
}
function zF(e) {
  const t = Ce(e);
  try {
    let r = e;
    $r(t) && (r = JSON.parse(t));
    const n = GF(r), i = BF(r), o = {
      dedi: n,
      dist: i
    };
    return EP.validate(o) ? {
      dedi: n,
      dist: i
    } : {
      dedi: { kind: "none", data: void 0 },
      dist: { k: tn.NONE }
    };
  } catch {
    return {
      dedi: { kind: "none", data: void 0 },
      dist: { k: tn.NONE }
    };
  }
}
function BF(e) {
  let t = { k: tn.NONE };
  if (VF(e)) {
    const r = { ...e.dist };
    r.k !== tn.NONE && Array.isArray(r.v) && (r.v = r.v[0]);
    const n = ET.safeParse(
      r
    );
    n.success && (t = n.data);
  }
  return t;
}
function VF(e) {
  return Te(e) && "dist" in e;
}
function WF(e) {
  return !(Te(e) && "dedi" in e);
}
function qF(e) {
  return Te(e) && "dedi" in e && "dist" in e;
}
function HF(e) {
  if (M(e) && M(e.range) && M(e.range.start) && M(e.range.end))
    return {
      startDate: e.range.start,
      endDate: e.range.end
    };
}
function G4(e) {
  const t = e != null && e.currentPeriod ? Yj(e.currentPeriod) : {}, r = M(t.fields) ? EA(Object.keys(t.fields)) : [];
  return {
    ...e,
    current: t,
    dateRange: HF(t),
    currentFieldIds: r
  };
}
const YF = 0;
function Qs(e) {
  return (t) => Xe(t) ? [t] : $e(t) ? t : e(t);
}
function lf(e, t) {
  return Xe(e) ? e : $e(e) ? e[0] : t(e)[0];
}
function SA(e) {
  return (t, r) => {
    const n = (o) => {
      var a;
      const s = (a = r.fields.find((l) => l.fieldId === o)) == null ? void 0 : a.values;
      return $e(s) ? s : M(s) ? [s] : [];
    }, i = [];
    for (const o of t) {
      const s = e.fields.get(o);
      if (s != null && s.referenceFields.length) {
        const l = s.referenceFields.map(n), u = n(s.id).concat(l.map((h) => Ce(h))).filter((h) => !!h).join(s.refSeparator ?? " ");
        u && i.push(u);
        continue;
      }
      const a = n(o);
      M(a) && ($e(a) ? i.push(...a) : i.push(a));
    }
    return i;
  };
}
function ZF(e, t) {
  const r = e[t];
  if (!M(r))
    throw new Error(`No parser registered for shorthand '${t}'.`);
  return r;
}
function IA(e, t, r) {
  const n = SA(e);
  return (i, o) => {
    const s = ZF(r, i);
    if (Bc(o) && qs(o.object))
      return a(o.object);
    if (qs(o))
      return a(o);
    return s(o);
    function a(l) {
      try {
        const f = t.getIds(i);
        return s(n(f, l));
      } catch {
        return s(void 0);
      }
    }
  };
}
function cf(e, t, r) {
  const n = SA(e);
  return (i, o) => {
    if (Bc(o) && qs(o.object))
      return s(o.object);
    if (qs(o))
      return s(o);
    return Ce(o);
    function s(a) {
      try {
        const l = Xe(i) ? [i] : t.getIds(i);
        return Ce(n(l, a));
      } catch {
        return Ce(void 0);
      }
    }
  };
}
function is(e) {
  return (t) => {
    const r = $e(t) ? t : e.getIds(t);
    return r.length === 0 ? !1 : r.every((n) => n !== YF);
  };
}
function ff(e, t) {
  const r = Qn(e, t);
  return (n, i) => {
    const o = t.getTypeIds(n);
    let s = [];
    if (!M(i) || !Xe(i) && !$e(i) && !hm(i))
      return !1;
    Xe(i) && (s = [i]), hm(i) && (s = i.types), $e(i) && (s = i);
    const a = r(o), l = r(s);
    for (const f of l)
      if (a.has(f))
        return !0;
    return !1;
  };
}
function JF(e, t) {
  const r = ff(e, t);
  return (n) => (i) => r(n, i);
}
function Qn(e, t) {
  return (r) => {
    const n = $e(r) ? r : t.getIds(r);
    return AA(n, e.types, e.logger);
  };
}
function _A(e, t) {
  const r = Qn(e, t), n = /* @__PURE__ */ new Map();
  return (i) => {
    const o = t.getIds(i);
    if (o.length === 0) return [];
    const s = [];
    for (const a of e.fields.values()) {
      let l = n.get(a.id);
      M(l) || (l = r(a.types), n.set(a.id, l)), o.some((f) => l == null ? void 0 : l.has(f)) && s.push(a);
    }
    return s;
  };
}
function KF(e, t) {
  const r = is(t);
  return (n) => {
    var s;
    const i = lf(n, t.getIds);
    if (!M(i))
      return `UnknownType[${String(n)} (${i})]`;
    if (!r([i]))
      return `MissingTypeMapping[${String(n)} (${i})]`;
    if (!M(e.types))
      return (s = e.logger) == null || s.warn(
        "Trying to use mapping.typename with mapping instance that has not been initialized with types."
      ), `MissingTypeName[${String(n)} (${i})]`;
    const o = e.types.get(i);
    return M(o) ? o.name : `UnknownType[${String(n)} (${i})]`;
  };
}
function RA(e, t) {
  const r = is(t);
  return (n) => {
    const i = lf(n, t.getIds);
    if (!M(i))
      return `UnknownFieldName[${String(n)} (${i})]`;
    if (!r([i]))
      return `MissingFieldMapping[${String(n)} (${i})]`;
    const o = e.fields.get(i);
    return M(o) ? o.name : `UnknownField[${String(n)} (${i})]`;
  };
}
function OA(e, t) {
  const r = is(t);
  return (n) => {
    const i = lf(n, t.getIds);
    if (!M(i) || !r([i]))
      return;
    const o = e.fields.get(i);
    if (M(o))
      return o.mandatory ? i : void 0;
  };
}
function XF(e, t) {
  return (r) => {
    var i;
    const n = t.getIds(r);
    return n.length === 0 ? [] : Wn(
      (i = e.mappingData) == null ? void 0 : i.objectTypes.filter(
        (o) => M(o.objectTypeId) && n.includes(o.objectTypeId)
      ).flatMap((o) => o.fields).map((o) => o.fieldId).filter(Xe)
    );
  };
}
function QF(e, t) {
  return (r) => {
    var i;
    const n = t.getIds(r);
    return n.length === 0 ? [] : Wn(
      (i = e.mappingData) == null ? void 0 : i.objectTypes.filter(
        (o) => M(o.objectTypeId) && n.includes(o.objectTypeId)
      ).flatMap((o) => o.fields).filter((o) => o.isSearchable).map((o) => o.fieldId).filter(Xe)
    );
  };
}
function eG(e) {
  return Te(e) && "objectTypeGroup" in e;
}
function Sl(e, t) {
  var r;
  return typeof t == "string" ? (r = e[t]) == null ? void 0 : r.props : eG(t) ? t : void 0;
}
function tG(e, t) {
  const r = Qs((i) => {
    var a;
    const o = Sl(t, i);
    if (!M(o))
      return [];
    if (!("appProperty" in o)) {
      const l = (a = e.lookup.objectTypes) == null ? void 0 : a[o.objectTypeGroup];
      return M(l) ? l.map((f) => f.objectTypeId).filter(M) : [];
    }
    const s = e.lookup.fields[`${o.objectTypeGroup}-${o.appProperty}`];
    return M(s) ? Wn(s.flatMap((l) => l.fieldIds)) : [];
  }), n = Qs((i) => {
    var a;
    const o = Sl(t, i);
    if (!M(o))
      return [];
    const s = "appProperty" in o ? e.lookup.fields[`${o.objectTypeGroup}-${o.appProperty}`] : (a = e.lookup.objectTypes) == null ? void 0 : a[o.objectTypeGroup];
    return M(s) ? Wn(s.map((l) => l.objectTypeId).filter(M)) : [];
  });
  return { getIds: r, getTypeIds: n };
}
function rG(e) {
  return (t) => {
    const r = Sl(e, t);
    return M(r) ? "appProperty" in r ? `${r.objectTypeGroup}-${r.appProperty}` : `${r.objectTypeGroup}` : "NONE";
  };
}
function nG(e) {
  return (t) => {
    var n;
    const r = (n = e.lookup.objectTypesById[t]) == null ? void 0 : n.map(
      (i) => i.key
    );
    return M(r) ? r : [];
  };
}
function iG(e) {
  return (t) => {
    var n;
    const r = (n = e.lookup.fieldsById[t]) == null ? void 0 : n.map((i) => i.key);
    return M(r) ? r : [];
  };
}
function oG(e, t) {
  const r = Qn(e, t);
  return (n, i) => {
    const o = e.mappingData.objectTypes.find((a) => {
      if (!M(a.objectTypeId)) return !1;
      if (n.types.includes(a.objectTypeId)) return !0;
      const l = r([a.objectTypeId]);
      return M(n.types.find((f) => l.has(f)));
    }), s = o == null ? void 0 : o.fields.filter((a) => a.appProperty === i).map((a) => a.fieldId).filter(M);
    if (!M(s) || !of(s))
      throw new Error(
        `Missing mapping in Admin. ${i} is not mapped for ${o == null ? void 0 : o.objectTypeExtId} ${n.types}.`
      );
    return s;
  };
}
function sG(e) {
  return ({
    shorthandOrTypes: t,
    object: r
  }) => {
    const n = $e(t) ? t : e.getIds(t);
    if (!M(r)) return n[0];
    const i = fj(n, r.types);
    return i.length > 0 ? i[0] : r.types[0];
  };
}
function aG(e) {
  return (t) => {
    const [r] = e.getIds(t);
    if (!M(r))
      throw new Error(
        `[getRequiredTypeId]: "${String(t)}" is not mapped to a type.`
      );
    return r;
  };
}
function uG(e, t) {
  const r = Qn(e, t);
  return ({
    maxLevelsDeep: n,
    object: i
  }) => {
    const o = /* @__PURE__ */ new Set();
    return e.memberTypes.forEach((s) => {
      const a = /* @__PURE__ */ new Set();
      let l = -1;
      for (const f of s.memberTypes) {
        if (!M(f.type)) continue;
        const u = Xe(f.type) ? f.type : parseInt(f.type, 10);
        if (o.has(u)) continue;
        const h = r([
          u
        ]), E = i.types.some(
          (d) => h.has(d)
        );
        a.add({
          memberLevel: f.memberLevel,
          type: u
        }), f.memberLevel > 0 && E && (l = Math.max(l, f.memberLevel));
      }
      l !== -1 && a.forEach((f) => {
        f.memberLevel < l && l - f.memberLevel <= n && o.add(f.type);
      });
    }), o;
  };
}
function KE(e, t) {
  var r;
  return (r = Object.entries(e).find(([, n]) => n.key === t)) == null ? void 0 : r[0];
}
function lG(e, t) {
  var n;
  const r = {
    objectTypes: {},
    fields: {},
    objectTypesById: {},
    fieldsById: {}
  };
  for (const i of t)
    if (M(i.applicationObjectTypeGroup)) {
      const o = i.applicationObjectTypeGroup, s = i.objectTypeId;
      M(r.objectTypes[o]) || (r.objectTypes[o] = []);
      const a = {
        objectTypeId: s === null ? void 0 : s,
        key: o,
        shorthand: KE(e, o)
      };
      M(s) && r.objectTypes[o].unshift(a), M(s) && (M(r.objectTypesById[s]) ? r.objectTypesById[s].unshift(a) : r.objectTypesById[s] = [a]);
      for (const l of i.fields)
        if (M(l.appProperty) && l.appProperty !== "NONE") {
          const f = i.objectTypeId, u = `${o}-${l.appProperty}`, h = M(l.fieldId) ? [l.fieldId] : [];
          M(r.fields[u]) || (r.fields[u] = []);
          const E = {
            fieldIds: h,
            objectTypeId: f === null ? void 0 : f,
            objectTypeKey: o,
            key: u,
            shorthand: KE(e, u)
          }, d = (n = r.fields[u]) == null ? void 0 : n.find(
            (g) => g.objectTypeId === f
          );
          M(d) ? d.fieldIds = pb(d.fieldIds, h) : r.fields[u].unshift(E);
          for (const g of h) {
            const y = {
              objectTypeKey: E.objectTypeKey,
              key: E.key,
              shorthand: E.shorthand,
              objectTypeId: E.objectTypeId
            };
            M(r.fieldsById[g]) ? r.fieldsById[g].unshift(y) : r.fieldsById[g] = [y];
          }
        }
    }
  return r;
}
function cG({
  parsers: e,
  config: t,
  logger: r = console
}) {
  return ({
    mappingData: n,
    fields: i,
    types: o,
    memberTypes: s
  }) => {
    const a = {
      mappingData: n,
      fields: new Map(i.map((f) => [f.id, f])),
      types: new Map(o.map((f) => [f.id, f])),
      memberTypes: new Map(s.map((f) => [f.id, f])),
      logger: r,
      lookup: lG(t, n == null ? void 0 : n.objectTypes)
    }, l = tG(a, t);
    return {
      includeFields: XF(a, l),
      searchableFields: QF(a, l),
      isMapped: is(l),
      getIds: l.getIds,
      getRequiredTypeId: aG(l),
      typeCheck: ff(a, l),
      makeTypeCheck: JF(a, l),
      getParentMemberTypes: uG(a, l),
      getTypesWithSubtypes: Qn(a, l),
      getMatchingObjectType: sG(l),
      typename: KF(a, l),
      fieldname: RA(a, l),
      getMandatoryField: OA(a, l),
      getFieldsByType: _A(a, l),
      getKey: rG(t),
      getObjectTypeKeysById: nG(a),
      getFieldKeysById: iG(a),
      parse: IA(a, l, e),
      string: cf(a, l),
      fieldsToWriteTo: oG(a, l),
      store: a
    };
  };
}
function df(e, t) {
  return `${e}[${t}]`;
}
function XE(e, t) {
  const r = /^(.+)\[(\d+)\]$/.exec(t);
  if (!r) return e.lookup[t];
  const n = e.lookup[r[1]];
  return n == null ? void 0 : n.entries[Number(r[2])];
}
function wA(e) {
  if (!M(e)) return [];
  switch (e.kind) {
    case "reservation":
    case "object-field":
      return [e.fieldId];
    case "list":
      return e.entries.flatMap(wA);
    case "text":
    case "unmapped":
      return [];
    default:
      return Et();
  }
}
function La(e, t, r) {
  const n = e.lookup[t];
  return (n == null ? void 0 : n.kind) === "list" ? n.entries.map(
    (i, o) => r(i, df(t, o))
  ) : r(n, t);
}
function Po(e, t) {
  return (r, ...n) => {
    const i = typeof r == "string" ? e.lookup[r] : void 0;
    return (i == null ? void 0 : i.kind) === "list" ? i.entries.map(
      (o, s) => t(df(r, s), ...n)
    ) : t(r, ...n);
  };
}
const QE = {
  "module.name": (e) => {
    var t;
    return { defaultName: "Name", value: (t = e.module) == null ? void 0 : t.name };
  },
  "module.code": (e) => {
    var t;
    return { defaultName: "Code", value: (t = e.module) == null ? void 0 : t.code };
  },
  "location.room": (e) => {
    var t;
    return { defaultName: "Room", value: (t = e.location) == null ? void 0 : t.room };
  },
  "location.building": (e) => {
    var t;
    return {
      defaultName: "Building",
      value: (t = e.location) == null ? void 0 : t.building
    };
  },
  "location.campus": (e) => {
    var t;
    return {
      defaultName: "Campus",
      value: (t = e.location) == null ? void 0 : t.campus
    };
  },
  "location.type": (e) => {
    var t;
    return { defaultName: "Type", value: (t = e.location) == null ? void 0 : t.type };
  },
  "location.map": (e) => {
    var t;
    return { defaultName: "Map URL", value: (t = e.location) == null ? void 0 : t.map };
  },
  "location.image": (e) => {
    var t;
    return {
      defaultName: "Picture URL",
      value: (t = e.location) == null ? void 0 : t.image
    };
  },
  "location.equipment": (e) => {
    var t;
    return {
      defaultName: "Equipment",
      value: (t = e.location) == null ? void 0 : t.equipment
    };
  },
  "location.onlineMeetingLink": (e) => {
    var t;
    return {
      defaultName: "Online meeting link",
      value: (t = e.location) == null ? void 0 : t.onlineMeetingLink
    };
  },
  "digitalResources.recording": (e) => {
    var t;
    return {
      defaultName: "Recording",
      value: (t = e.digitalResources) == null ? void 0 : t.recording
    };
  },
  "digitalResources.lmsLink": (e) => {
    var t;
    return {
      defaultName: "Learning management system link",
      value: (t = e.digitalResources) == null ? void 0 : t.lmsLink
    };
  },
  "staff.name": (e) => {
    var t;
    return { defaultName: "Name", value: (t = e.staff) == null ? void 0 : t.name };
  },
  "activity.displayName": (e) => {
    var t;
    return {
      defaultName: "Display name",
      value: (t = e.activity) == null ? void 0 : t.displayName
    };
  },
  "activity.alternativeTitle": (e) => {
    var t;
    return {
      defaultName: "Alternative title",
      value: (t = e.activity) == null ? void 0 : t.alternativeTitle
    };
  },
  messageToStudent: (e) => ({
    defaultName: "Message",
    value: e.messageToStudent
  })
}, eg = {
  extraFields: (e) => e.extraFields,
  "location.extraFields": (e) => {
    var t;
    return (t = e.location) == null ? void 0 : t.extraFields;
  }
};
function tg(e, t) {
  const r = {
    displayName: t == null ? void 0 : t.displayName,
    defaultName: e
  }, n = { ...r, kind: "unmapped", text: "" };
  if (!M(t))
    return n;
  switch (t.type) {
    case "unmapped":
      return n;
    case "text":
      return { ...r, kind: "text", text: t.value };
    case "reservation":
      return { ...r, kind: "reservation", fieldId: Number(t.value) };
    case "object-field": {
      const [i, o] = t.value.split("-");
      return {
        ...r,
        kind: "object-field",
        typeId: Number(i),
        fieldId: Number(o)
      };
    }
    default:
      return Et();
  }
}
function fG(e) {
  return (t) => La(e, t, (r, n) => {
    const i = r == null ? void 0 : r.displayName;
    if (i)
      return i;
    const o = r == null ? void 0 : r.defaultName;
    return o || (e.logger.warn(
      `[reservationMapping.displayname] Could not find settings for '${n}'`
    ), `MissingDisplayName[${n}]`);
  });
}
function dG(e, t) {
  const r = is(t);
  return (n) => La(e, n, (i, o) => {
    switch (i == null ? void 0 : i.kind) {
      case "object-field":
      case "reservation":
        return r(o);
      case "text":
        return !!(i != null && i.text);
      case "unmapped":
      case void 0:
        return !1;
      default:
        return Et();
    }
  });
}
function NA(e) {
  if (!M(e)) return [];
  switch (e.kind) {
    case "object-field":
      return [e.typeId];
    case "list":
      return e.entries.flatMap(NA);
    case "reservation":
    case "text":
    case "unmapped":
      return [];
    default:
      return Et();
  }
}
function Il(e, t) {
  switch (e == null ? void 0 : e.kind) {
    case "reservation":
      return t.reservation;
    case "object-field":
      return t.object;
    case "text":
      return e == null ? void 0 : e.text;
    case "unmapped":
    case void 0:
      return;
    default:
      return Et();
  }
}
function pG(e, t, r) {
  const n = IA(e, t, r), i = cf(e, t);
  return (o, s) => {
    const a = e.lookup[o];
    return (a == null ? void 0 : a.kind) === "list" ? a.entries.map(
      (l, f) => i(df(o, f), Il(l, s))
    ) : n(
      o,
      Il(a, s)
    );
  };
}
function hG(e, t, r) {
  const n = cf(e, t);
  return (i, o) => La(
    e,
    i,
    (s, a) => n(a, Il(s, o))
  );
}
function mG(e, t) {
  const r = Qn(e, t);
  return () => r(Array.from(e.mappedTypes));
}
function EG(e) {
  return () => e.mappedTypes.size > 0;
}
function gG(e) {
  return (t) => La(e, t, (r) => r == null ? void 0 : r.kind);
}
function yG(e) {
  const t = {};
  for (const r of Object.keys(
    QE
  )) {
    const n = QE[r](e), i = n.defaultName, o = n.value;
    t[r] = tg(i, o);
  }
  for (const r of Object.keys(
    eg
  ))
    t[r] = {
      kind: "list",
      defaultName: "Extra fields",
      entries: (eg[r](e) ?? []).map(
        (n) => tg(n.label, n)
      )
    };
  return t;
}
function TG(e) {
  const t = /* @__PURE__ */ new Set(), r = (n) => {
    (n == null ? void 0 : n.kind) === "object-field" && t.add(n.typeId), (n == null ? void 0 : n.kind) === "list" && n.entries.forEach(r);
  };
  return Object.values(e).forEach(r), t;
}
function bG(e) {
  const t = Qs(
    (n) => wA(XE(e, n))
  ), r = Qs(
    (n) => NA(XE(e, n))
  );
  return { getIds: t, getTypeIds: r };
}
function z4({
  parsers: e,
  logger: t = console
}) {
  return ({ settings: r, fields: n, types: i }) => {
    const o = yG(r), s = {
      fields: n,
      types: i,
      logger: t,
      lookup: o,
      settings: r,
      mappedTypes: TG(o)
    }, a = bG(s), l = Po(s, ff(s, a));
    return {
      isMapped: dG(s, a),
      getIds: Po(s, a.getIds),
      typeCheck: l,
      makeTypeCheck: (f) => (u) => l(f, u),
      fieldname: Po(s, RA(s, a)),
      displayname: fG(s),
      getMandatoryField: Po(s, OA(s, a)),
      getFieldsByType: Po(s, _A(s, a)),
      hasObjectFieldMappings: EG(s),
      getTypesWithSubtypes: Qn(s, a),
      getAllTypesWithSubtypes: mG(s, a),
      kind: gG(s),
      parse: pG(s, a, e),
      string: hG(s, a),
      store: s
    };
  };
}
const AG = {
  activityType: {
    kind: "field",
    props: {
      objectTypeGroup: C.EApplicationObjectTypeGroup.STUDENT_SET_GROUP,
      appProperty: C.EAppProperties.ACTIVITY_TYPE,
      requiredMandatory: !0
    },
    key: `${C.EApplicationObjectTypeGroup.STUDENT_SET_GROUP}-${C.EAppProperties.ACTIVITY_TYPE}`,
    required: !0
  },
  buffer: {
    kind: "field",
    props: {
      objectTypeGroup: C.EApplicationObjectTypeGroup.STUDENT_SET_GROUP,
      appProperty: C.EAppProperties.BUFFER
    },
    key: `${C.EApplicationObjectTypeGroup.STUDENT_SET_GROUP}-${C.EAppProperties.BUFFER}`,
    required: !1
  },
  changeRequestName: {
    kind: "field",
    props: {
      objectTypeGroup: C.EApplicationObjectTypeGroup.CHANGE_REQUEST,
      appProperty: C.EAppProperties.LABEL
    },
    key: `${C.EApplicationObjectTypeGroup.CHANGE_REQUEST}-${C.EAppProperties.LABEL}`,
    required: !1
  },
  course: {
    kind: "objectType",
    props: { objectTypeGroup: C.EApplicationObjectTypeGroup.COURSE },
    key: `${C.EApplicationObjectTypeGroup.COURSE}`,
    required: !0
  },
  courseTitle: {
    kind: "field",
    props: {
      objectTypeGroup: C.EApplicationObjectTypeGroup.COURSE,
      appProperty: C.EAppProperties.TITLE,
      requiredMandatory: !0
    },
    key: `${C.EApplicationObjectTypeGroup.COURSE}-${C.EAppProperties.TITLE}`,
    required: !0
  },
  courseLabel: {
    kind: "field",
    props: {
      objectTypeGroup: C.EApplicationObjectTypeGroup.COURSE,
      appProperty: C.EAppProperties.LABEL,
      requiredMandatory: !0
    },
    key: `${C.EApplicationObjectTypeGroup.COURSE}-${C.EAppProperties.LABEL}`,
    required: !0
  },
  allocationRules: {
    kind: "field",
    props: {
      objectTypeGroup: C.EApplicationObjectTypeGroup.STUDENT_SET_GROUP,
      appProperty: C.EAppProperties.DEDICATETRACK
    },
    key: `${C.EApplicationObjectTypeGroup.STUDENT_SET_GROUP}-${C.EAppProperties.DEDICATETRACK}`,
    required: !1
  },
  endDate: {
    kind: "field",
    props: {
      objectTypeGroup: C.EApplicationObjectTypeGroup.STUDENT_SET_GROUP,
      appProperty: C.EAppProperties.END_DATE
    },
    key: `${C.EApplicationObjectTypeGroup.STUDENT_SET_GROUP}-${C.EAppProperties.END_DATE}`,
    required: !0
  },
  hideGroup: {
    kind: "field",
    props: {
      objectTypeGroup: C.EApplicationObjectTypeGroup.STUDENT_SET_GROUP,
      appProperty: C.EAppProperties.HIDETRACK
    },
    key: `${C.EApplicationObjectTypeGroup.STUDENT_SET_GROUP}-${C.EAppProperties.HIDETRACK}`,
    required: !1
  },
  maxStudents: {
    kind: "field",
    props: {
      objectTypeGroup: C.EApplicationObjectTypeGroup.STUDENT_SET_GROUP,
      appProperty: C.EAppProperties.MAX_STUDENTS,
      requiredConfiguration: {
        memberMaxCount: !0,
        memberMaxType: !0
      }
    },
    key: `${C.EApplicationObjectTypeGroup.STUDENT_SET_GROUP}-${C.EAppProperties.MAX_STUDENTS}`,
    required: !0
  },
  program: {
    kind: "objectType",
    props: { objectTypeGroup: C.EApplicationObjectTypeGroup.PROGRAM },
    key: `${C.EApplicationObjectTypeGroup.PROGRAM}`,
    required: !1
  },
  programName: {
    kind: "field",
    props: {
      objectTypeGroup: C.EApplicationObjectTypeGroup.PROGRAM,
      appProperty: C.EAppProperties.LABEL
    },
    key: `${C.EApplicationObjectTypeGroup.PROGRAM}-${C.EAppProperties.LABEL}`,
    required: !1
  },
  room: {
    kind: "objectType",
    props: { objectTypeGroup: C.EApplicationObjectTypeGroup.ROOM },
    key: `${C.EApplicationObjectTypeGroup.ROOM}`,
    required: !1
  },
  changeRequest: {
    kind: "objectType",
    props: { objectTypeGroup: C.EApplicationObjectTypeGroup.CHANGE_REQUEST },
    key: `${C.EApplicationObjectTypeGroup.CHANGE_REQUEST}`,
    required: !1
  },
  roomName: {
    kind: "field",
    props: {
      objectTypeGroup: C.EApplicationObjectTypeGroup.ROOM,
      appProperty: C.EAppProperties.LABEL
    },
    key: `${C.EApplicationObjectTypeGroup.ROOM}-${C.EAppProperties.LABEL}`,
    required: !1
  },
  roomSize: {
    kind: "field",
    props: {
      objectTypeGroup: C.EApplicationObjectTypeGroup.ROOM,
      appProperty: C.EAppProperties.SEATS
    },
    key: `${C.EApplicationObjectTypeGroup.ROOM}-${C.EAppProperties.SEATS}`,
    required: !1
  },
  roomBuilding: {
    kind: "field",
    props: {
      objectTypeGroup: C.EApplicationObjectTypeGroup.ROOM,
      appProperty: C.EAppProperties.BUILDING
    },
    key: `${C.EApplicationObjectTypeGroup.ROOM}-${C.EAppProperties.BUILDING}`,
    required: !1
  },
  roomCampus: {
    kind: "field",
    props: {
      objectTypeGroup: C.EApplicationObjectTypeGroup.ROOM,
      appProperty: C.EAppProperties.CAMPUS
    },
    key: `${C.EApplicationObjectTypeGroup.ROOM}-${C.EAppProperties.CAMPUS}`,
    required: !1
  },
  roomType: {
    kind: "field",
    props: {
      objectTypeGroup: C.EApplicationObjectTypeGroup.ROOM,
      appProperty: C.EAppProperties.ROOM_TYPE
    },
    key: `${C.EApplicationObjectTypeGroup.ROOM}-${C.EAppProperties.ROOM_TYPE}`,
    required: !1
  },
  semester: {
    kind: "field",
    props: {
      objectTypeGroup: C.EApplicationObjectTypeGroup.COURSE,
      appProperty: C.EAppProperties.SEMESTER
    },
    key: `${C.EApplicationObjectTypeGroup.COURSE}-${C.EAppProperties.SEMESTER}`,
    required: !1
  },
  staff: {
    kind: "objectType",
    props: { objectTypeGroup: C.EApplicationObjectTypeGroup.STAFF },
    key: `${C.EApplicationObjectTypeGroup.STAFF}`,
    required: !0
  },
  staffName: {
    kind: "field",
    props: {
      objectTypeGroup: C.EApplicationObjectTypeGroup.STAFF,
      appProperty: C.EAppProperties.LABEL
    },
    key: `${C.EApplicationObjectTypeGroup.STAFF}-${C.EAppProperties.LABEL}`,
    required: !1
  },
  startDate: {
    kind: "field",
    props: {
      objectTypeGroup: C.EApplicationObjectTypeGroup.STUDENT_SET_GROUP,
      appProperty: C.EAppProperties.START_DATE
    },
    key: `${C.EApplicationObjectTypeGroup.STUDENT_SET_GROUP}-${C.EAppProperties.START_DATE}`,
    required: !0
  },
  student: {
    kind: "objectType",
    props: { objectTypeGroup: C.EApplicationObjectTypeGroup.STUDENT },
    key: `${C.EApplicationObjectTypeGroup.STUDENT}`,
    required: !0
  },
  studentName: {
    kind: "field",
    props: {
      objectTypeGroup: C.EApplicationObjectTypeGroup.STUDENT,
      appProperty: C.EAppProperties.LABEL
    },
    key: `${C.EApplicationObjectTypeGroup.STUDENT}-${C.EAppProperties.LABEL}`,
    required: !0
  },
  group: {
    kind: "objectType",
    props: { objectTypeGroup: C.EApplicationObjectTypeGroup.STUDENT_SET_GROUP },
    key: `${C.EApplicationObjectTypeGroup.STUDENT_SET_GROUP}`,
    required: !0
  },
  groupName: {
    kind: "field",
    props: {
      objectTypeGroup: C.EApplicationObjectTypeGroup.STUDENT_SET_GROUP,
      appProperty: C.EAppProperties.LABEL
    },
    key: `${C.EApplicationObjectTypeGroup.STUDENT_SET_GROUP}-${C.EAppProperties.LABEL}`,
    required: !1
  },
  groupNumber: {
    kind: "field",
    props: {
      objectTypeGroup: C.EApplicationObjectTypeGroup.STUDENT_SET_GROUP,
      appProperty: C.EAppProperties.TRACK
    },
    key: `${C.EApplicationObjectTypeGroup.STUDENT_SET_GROUP}-${C.EAppProperties.TRACK}`,
    required: !0
  },
  courseOccurance: {
    kind: "field",
    props: {
      objectTypeGroup: C.EApplicationObjectTypeGroup.STUDENT_SET_GROUP,
      appProperty: C.EAppProperties.COURSE_OCCURENCE
    },
    key: `${C.EApplicationObjectTypeGroup.STUDENT_SET_GROUP}-${C.EAppProperties.COURSE_OCCURENCE}`,
    required: !1
  }
}, vG = {
  activityType: Co,
  buffer: FF,
  changeRequestName: Ce,
  courseLabel: Co,
  courseTitle: Co,
  allocationRules: zF,
  endDate: Ce,
  hideGroup: Y$,
  maxStudents: HE,
  programName: Ce,
  roomName: Ce,
  roomSize: HE,
  roomBuilding: Ce,
  roomCampus: Ce,
  roomType: Ce,
  semester: Ce,
  staffName: Ce,
  startDate: Ce,
  studentName: Co,
  groupName: Ce,
  groupNumber: Co,
  courseOccurance: Ce
}, B4 = {
  "module.name": Ce,
  "module.code": Ce,
  "location.room": Ce,
  "location.building": Ce,
  "location.campus": Ce,
  "location.type": Ce,
  "location.map": Ce,
  "location.image": Ce,
  "location.equipment": W$,
  "location.onlineMeetingLink": Ce,
  "digitalResources.recording": Ce,
  "digitalResources.lmsLink": Ce,
  "staff.name": Ce,
  "activity.displayName": Ce,
  "activity.alternativeTitle": Ce,
  messageToStudent: Ce
};
function V4(e) {
  return EA(Object.keys(e));
}
function W4(e) {
  return Array.from(
    new Set(
      Object.values(e).reduce((t, r) => (M(r) && t.push(...r), t), [])
    )
  );
}
function SG(e) {
  const t = {};
  for (const { students: r, groups: n } of e)
    r.forEach((i) => {
      M(t[i]) || (t[i] = []);
      const o = new Set(t[i]);
      n.forEach((s) => {
        o.add(s);
      }), t[i] = [...o];
    });
  return t;
}
function q4(e) {
  const t = [];
  for (const r of e.solution.assignments)
    t.push({
      students: r.students,
      groups: [r.studentSetGroupId]
    });
  return SG(t);
}
function H4(e, t) {
  return M(t) ? t.members.some((r) => r.objectId === e) : !1;
}
function pf(e) {
  return e.reduce((t, r) => (t[r.id] = r, t), {});
}
function Y4(e) {
  return new Map(e.map((t) => [t.id, t]));
}
function Z4(e, t) {
  const r = [], n = {};
  for (const i of t) {
    const o = e[i];
    M(o) ? n[i] = o : r.push(i);
  }
  return {
    missingIds: r,
    existing: n
  };
}
function J4(e, t) {
  return `${t.parse("courseLabel", e)} ${t.parse(
    "courseTitle",
    e
  )}`;
}
function IG(e) {
  return M(e) && e === 0;
}
function K4(e) {
  var r, n;
  const t = {};
  for (const i in e)
    t[i] = {
      completed: IG(
        (n = (r = e[i]) == null ? void 0 : r.incompleteStudents) == null ? void 0 : n.length
      )
    };
  return t;
}
function X4(e, t) {
  const r = [];
  for (const n in e) {
    const i = e[n];
    M(i) && r.push({
      title: t.parse("courseTitle", i.object),
      label: t.parse("courseLabel", i.object),
      id: i.object.id
    });
  }
  return r.sort((n, i) => n.label.localeCompare(i.label));
}
function _G(e) {
  return e.filter(
    (t) => M(t.categories) && t.categories.length > 0
  );
}
function Q4(e, t) {
  const n = _G(t).find((i) => i.id === e);
  return (n == null ? void 0 : n.name) || `Missing field[${e}]`;
}
function RG(e, t) {
  return t.map((r) => ({ fieldId: r, values: [e] }));
}
function eB(e, t, r, n) {
  var s;
  const i = r.fieldsToWriteTo(e, n);
  if (!of(i)) return [];
  const o = (s = e == null ? void 0 : e.fields) == null ? void 0 : s.find((a) => i.includes(a.fieldId));
  return M(o) && M(o.values[0]) && (o == null ? void 0 : o.values[0]) === t ? [] : RG(t, i);
}
const OG = "MMM";
class kn {
  /**
   * @param collection - A list of numbers to format into a shortened range string
   * @returns A formatted string where consecutive numbers are collapsed into ranges, e.g. [1,2,3,4,7,8,9] becomes "1-4, 7-9"
   */
  static pairPresent(t) {
    const r = t.sort((o, s) => o - s), n = kn.pair(r);
    return n.reduce((o, s, a) => {
      if (!Bn(s))
        return o;
      const [l, f] = s;
      if (M(f))
        return a === n.length - 1 ? [...o, l.toString(), "-", f.toString()] : [...o, l.toString(), "-", f.toString(), ", "];
      {
        const u = [...o, l.toString()];
        return a === n.length - 1 ? [...u, ""] : [...u, ", "];
      }
    }, []).join("");
  }
  /**
   * @param collection - A sorted list of numbers to group into pairs
   * @returns An array of number arrays where each sub-array represents a range (start and end) or a single value
   */
  static pair(t) {
    return kn.pairFromArray(t);
  }
  /**
   * @param array - A sorted array of numbers to group into consecutive ranges
   * @returns An array of number arrays where consecutive numbers are grouped as [start, end] pairs
   */
  static pairFromArray(t) {
    const r = [];
    let n = [];
    for (let i = 0, o = t.length; i < o; i++) {
      const s = t[i];
      if (!M(s))
        continue;
      const a = t[i - 1] ?? -10, l = t[i + 1] ?? -10;
      a + 1 === s && s + 1 === l || (a + 1 === s ? (n.push(s), n = []) : (n = [s], r.push(n)));
    }
    return r;
  }
  /**
   * @param timestamp - A unix timestamp to extract month and day from
   * @returns An object with the abbreviated month name and day of month
   */
  static formatDay(t) {
    const r = Ur.unix(t);
    return { month: r.format(OG), day: r.date() };
  }
  /**
   * @param days - A set of unix timestamps representing individual days
   * @returns A formatted string listing all days grouped by month with a count suffix, e.g. "Jan 5, 6, Feb 1 (x3)"
   */
  static daysPresent(t) {
    if (t.size === 0) return "";
    const r = [...t].sort((o, s) => o - s);
    let n = "";
    const i = [];
    for (const o of r) {
      const { month: s, day: a } = kn.formatDay(o);
      s !== n ? (n = s, i.push(`${s} ${a}`)) : i.push(`${a}`);
    }
    return `${i.join(", ")} (x${r.length})`;
  }
  /**
   * @param days - A set of unix timestamps representing individual days
   * @param showCount - Whether to append a count suffix like "(x4)". Defaults to true.
   * @returns A formatted string showing the date range from first to last day, e.g. "Jan 5-12 (x4)" or "Jan 5-12"
   */
  static daysRangePresent(t, r = !0) {
    const n = kn.daysRange(t);
    if (!n) return "";
    const i = kn.formatDay(n.startDay), o = kn.formatDay(n.endDay), s = r ? ` (x${n.count})` : "";
    return n.startDay === n.endDay ? `${i.month} ${i.day}${s}` : i.month === o.month ? `${i.month} ${i.day}-${o.day}${s}` : `${i.month} ${i.day} - ${o.month} ${o.day}${s}`;
  }
  /**
   * @param days - A set of unix timestamps representing individual days
   * @returns The first day, last day, and total count, or undefined if the set is empty
   */
  static daysRange(t) {
    const r = [...t].sort((o, s) => o - s);
    if (!Bn(r)) return;
    const [n] = r, i = r[r.length - 1];
    return { startDay: n, endDay: i, count: r.length };
  }
}
function wG(e) {
  return M(e.begin) && M(e.end);
}
function tB({
  mapping: e,
  objects: t,
  typeIds: r
}) {
  if (r != null && r.some($F))
    return t;
  const n = e.getTypesWithSubtypes(r ?? []);
  return t == null ? void 0 : t.filter((i) => n.has(i.typeId));
}
function rg({
  objects: e,
  reservations: t,
  mapping: r
}) {
  const n = pf(t), i = NG({
    reservations: t
  }), o = {}, s = /* @__PURE__ */ new Map();
  for (const l of e) {
    const f = l.id, u = l.members.map((b) => b.objectId), h = /* @__PURE__ */ new Map(), E = r.getTypesWithSubtypes(l.types), g = r.typeCheck("group", l) ? /* @__PURE__ */ new Set() : r.getParentMemberTypes({
      object: l,
      maxLevelsDeep: 1
    }), y = (b, _) => {
      var w, L;
      const I = i.get(_);
      if (M(I) && b.size !== 0)
        for (const R of I) {
          const D = n[R];
          if (!M(D)) continue;
          const P = (w = D.objects) == null ? void 0 : w.find(
            (F) => F.objectId === _
          );
          if (!M(P)) continue;
          const O = r.getTypesWithSubtypes([
            P.typeId
          ]);
          for (const F of O)
            b.has(F) && (h.set(R, D), s.has(R) || s.set(R, /* @__PURE__ */ new Set()), (L = s.get(R)) == null || L.add(f));
        }
    };
    y(E, f);
    for (const b of u)
      y(g, b);
    o[f] = Array.from(
      h.values()
    );
  }
  const a = {};
  for (const [l, f] of s)
    a[l] = Array.from(f);
  return { objectWithReservations: o, reservationWithObjectIds: a };
}
function NG({
  reservations: e
}) {
  const t = /* @__PURE__ */ new Map();
  for (const r of e)
    for (const n of r.objects ?? []) {
      const i = t.get(n.objectId);
      M(i) ? i.add(r.id) : t.set(n.objectId, /* @__PURE__ */ new Set([r.id]));
    }
  return t;
}
function rB(e) {
  const t = /* @__PURE__ */ new Map();
  for (const [r, n] of e)
    for (const i of n) {
      const o = t.get(i);
      o ? o.push(r) : t.set(i, [r]);
    }
  return t;
}
function nB({
  allocationResult: e,
  studentSetGroupLookup: t,
  courseLookup: r,
  mapping: n
}) {
  var s;
  const i = [], o = e.failedGroups;
  for (const a in o)
    (s = o[a]) == null || s.forEach((l) => {
      var y, b, _;
      const f = r[l.courseId], u = n.parse("courseLabel", f), h = (b = (y = l == null ? void 0 : l.reasons) == null ? void 0 : y.failsWithMessage) == null ? void 0 : b.systemError, E = CG({
        logId: e.logId,
        activityType: l.activity,
        courseId: l.courseId,
        activityTypeId: l.activityId,
        studentSetGroupLookup: t,
        courseLabel: u,
        systemError: h,
        studentId: a,
        mapping: n
      });
      i.push(...E);
      const d = (_ = l == null ? void 0 : l.reasons) == null ? void 0 : _.failsWithGroups, g = PG({
        activityType: l.activity,
        activityTypeId: l.activityId,
        courseId: l.courseId,
        studentSetGroupLookup: t,
        groupFailError: d,
        courseLabel: u,
        studentId: a,
        mapping: n
      });
      i.push(...g);
    });
  return i;
}
function CG({
  systemError: e,
  mapping: t,
  studentId: r,
  courseLabel: n,
  studentSetGroupLookup: i,
  courseId: o,
  activityType: s,
  activityTypeId: a,
  logId: l
}) {
  const f = [];
  return M(e) && Object.entries(e).forEach(
    ([u, h], E) => {
      const d = i[parseInt(u, 10)], g = MG(h, l);
      f.push({
        issueType: g,
        manageStudentLink: "Manage student",
        student: r,
        group: t.parse("groupName", d),
        course: n,
        activityType: s,
        activityTypeId: a,
        key: `${u}-${s}-${o}-${r}-${g}-${E}`,
        logId: l
      });
    }
  ), f;
}
function PG({
  groupFailError: e,
  studentSetGroupLookup: t,
  courseLabel: r,
  courseId: n,
  activityType: i,
  mapping: o,
  studentId: s,
  activityTypeId: a
}) {
  const l = [];
  return M(e) && Object.entries(e).forEach(([f, u]) => {
    u.forEach((h, E) => {
      const d = t[h], g = f;
      l.push({
        issueType: DG(g),
        manageStudentLink: "Manage student",
        student: s,
        group: o.parse("groupName", d),
        course: r,
        activityType: i,
        activityTypeId: a,
        key: `${h}-${i}-${n}-${s}-${g}-${E}`
      });
    });
  }), l;
}
function DG(e) {
  switch (e) {
    case "buffer":
      return "No seats (buffer)";
    case "size":
      return "No seats";
    case "doubleBooked":
      return "Already allocated";
    case "dedicated":
      return "Dedicated";
    case "hidden":
      return "Hidden";
    case "conflict":
      return "Conflict";
    case "registrationPeriod":
      return "Registration period closed";
    default:
      return Et();
  }
}
function MG(e, t) {
  switch (e == null ? void 0 : e.name) {
    case le.HeavyLoadError:
      return "Heavy load";
    case le.MaximumMembershipReachedError:
      return "No seats (server)";
    case le.MaximumMembershipReachedByTypeError:
      return "No seats (server)";
    case le.PermissionError:
      return ve.noPermission;
    default:
      return `System Error type: ${e == null ? void 0 : e.name} Code: (${e == null ? void 0 : e.code}) Message: ${e == null ? void 0 : e.message} LogId: ${t}`;
  }
}
const LG = [
  "maxStudents",
  "buffer",
  "allocationRules",
  "hideGroup",
  "startDate",
  "endDate"
];
function iB({
  id: e,
  linkedIds: t,
  groups: r,
  mapping: n,
  courseId: i,
  mustHaveLinks: o
}) {
  if (t.length === 0)
    return o ? { success: !1, message: " - No matching group." } : { success: !0, message: "" };
  const s = t.map((h) => ng(h.toString(), r)).filter(M);
  if (s.length !== t.length)
    return {
      success: !1,
      message: `${ve.getLinkingGroupsFailed}: ${t}`
    };
  const a = ng(e, r);
  if (!M(a))
    return { success: !1, message: ` - Failed to find group: ${e}` };
  const l = o ? "" : ve.linkedRulesFailed, f = [a, ...s].map((h) => Bc(h) ? h.object : Uj(h) ? h.teObject : h), u = xG(l, f, n, i);
  return { success: !$r(u), message: u };
}
function ng(e, t) {
  return t instanceof Map ? t.get(Number(e)) : t[e];
}
function xG(e, t, r, n) {
  if (t.length < 2) return e;
  const i = kG(t, r, n) + LG.filter((o) => r.isMapped(o)).map((o) => jG(t, r, o)).filter($r).join(`
`);
  return $r(i) ? Ra([e, i], ` 
 `) : "";
}
function kG(e, t, r) {
  return e.every(
    (i) => Vj(i).includes(r)
  ) ? "" : `- Not the same ${t.typename("course")}.
`;
}
function jG(e, t, r) {
  if (r === "allocationRules") {
    const o = t.parse(r, e[0]), a = e.every(
      (u) => UG(Cs({ mapping: t, value: u }), o.dedi)
    ) ? "" : Nu(e, t, r, ve.dedicateTo), f = Q$({ groups: e, mapping: t }).success ? "" : Nu(e, t, r, ve.distribution);
    return Ra([f, a], `
`);
  }
  const n = t.parse(r, e[0]);
  return e.every(
    (o) => dj(t.parse(r, o), n)
  ) ? "" : Nu(e, t, r);
}
function UG(e, t) {
  switch (e.kind) {
    case "none":
      return e.kind === t.kind;
    case "category":
      return t.kind !== "category" ? !1 : e.data.every(
        (r) => t.data.some(
          (n) => r.id === n.id && r.value === n.value
        )
      );
    case "relation":
      return t.kind !== "relation" ? !1 : e.data.every(
        (r) => t.data.some((n) => r.id === n.id)
      );
    default:
      Et();
  }
}
function Nu(e, t, r, n) {
  const i = " - " + ($r(n) ? n : t.fieldname(r)), o = e.map((s) => $G(t.parse(r, s))).filter($r).join(" vs ");
  return `${Ra([i, o], ": ")}.`;
}
function $G(e) {
  return Oi(e) ? "" : Rb(e);
}
function oB(e, t, r) {
  return t ? t === Yt.ASCFIELD || t === Yt.DESCFIELD ? !r || r < 0 ? (e.warn(
    "[createSortParams]: No `sortFieldId` provided when specifying sort = ASCFIELD | DESCFIELD, skipping sorting (make sure the mapped field is mandatory)"
  ), {}) : {
    sort: t,
    sortFieldId: r
  } : {
    sort: t
  } : {};
}
const FG = new Intl.Collator();
function hf({
  items: e,
  getValue: t,
  descending: r = !1
}) {
  return e.map((n) => {
    const i = t(n);
    return { item: n, value: i ?? "", hasContent: $r(i) };
  }).sort((n, i) => {
    if (!n.hasContent && !i.hasContent) return 0;
    if (!n.hasContent) return 1;
    if (!i.hasContent) return -1;
    const o = FG.compare(n.value, i.value);
    return r ? -o : o;
  }).map(({ item: n }) => n);
}
function sB({
  objects: e,
  sort: t,
  sortFieldId: r,
  mapping: n
}) {
  return !M(r) || Xe(r) && r <= 0 ? [...e] : hf({
    items: e,
    getValue: (i) => n.string(r, i),
    descending: t === Yt.DESCFIELD
  });
}
function ig({
  objects: e,
  sort: t,
  key: r
}) {
  return hf({
    items: e,
    getValue: (n) => Rb(n[r]),
    descending: t === Yt.DESCFIELD
  });
}
function Cu({
  ids: e,
  getLabel: t,
  descending: r = !1
}) {
  return hf({
    items: e,
    getValue: t,
    descending: r
  });
}
function aB(e, t) {
  return (e === Yt.ASCFIELD || e === Yt.DESCFIELD) && typeof t == "number" && t > 0 ? {
    sort: e,
    sortFieldId: t
  } : { sort: void 0, sortFieldId: void 0 };
}
function uB({
  course: e,
  activities: t
}) {
  const r = [];
  for (const n of e.activities) {
    const i = t[n];
    M(i) && r.push(i);
  }
  return r;
}
function lB({ course: e, groups: t, activities: r }) {
  const n = [];
  for (const i of e.activities) {
    const o = r[i];
    if (M(o))
      for (const s of o.groups) {
        const a = t[s];
        M(a) && a.courseId === e.id && n.push(a);
      }
  }
  return n;
}
function cB(e) {
  if ("ids" in e) {
    const { courses: t, groups: r, ids: n } = e;
    return Wn(
      n.flatMap((i) => t[i] ? parseInt(i, 10) : r[i] ? r[i].courseId : [])
    );
  }
  return Wn(e.groups.map((t) => t.courseId));
}
function fB({
  activity: e,
  groups: t
}) {
  const r = [];
  for (const n of e.groups) {
    const i = t[n];
    M(i) && r.push(i);
  }
  return r;
}
function dB(e) {
  var r;
  if ("groupId" in e) {
    const { groupId: n, activities: i } = e;
    return Object.values(i).find(
      (o) => M(o) && o.groups.includes(n)
    );
  }
  const t = (r = e.group) == null ? void 0 : r.activityId;
  if (M(t))
    return e.activities[t];
}
function pB({
  groups: e,
  allGroups: t
}) {
  const r = {};
  for (const n in e) {
    const i = e[n];
    M(i) && (r[i.id] = [], i.object.relations.forEach((o) => {
      o.objectIds.forEach((s) => {
        const a = t[s];
        M(a) && (M(r[i.id]) ? r[i.id].push(a.id) : r[i.id] = [a.id]);
      });
    }));
  }
  return r;
}
function hB(e, t, r) {
  return M(t == null ? void 0 : t.typeId) && M(t == null ? void 0 : t.objectIds) && r.typeCheck(e, t.typeId) ? t.objectIds : [];
}
function mB(e, t) {
  var r, n, i, o;
  for (const s of Object.values(e)) {
    const a = (n = (r = s == null ? void 0 : s.failsWithGroups) == null ? void 0 : r.size) == null ? void 0 : n.includes(t), l = (o = (i = s == null ? void 0 : s.failsWithGroups) == null ? void 0 : i.buffer) == null ? void 0 : o.includes(t);
    if (a || l)
      return !0;
  }
  return !1;
}
function EB(e) {
  return `${sl}${e}`;
}
function gB(e) {
  if (e === gT) return { kind: "allocated" };
  if (e === yT)
    return { kind: "not_allocated" };
  if (e.startsWith(sl)) {
    const t = e.slice(sl.length);
    if (/^\d+$/.test(t))
      return { kind: "to_group", groupId: Number(t) };
  }
}
function yB(e, t) {
  return Number.isInteger(e) && e >= 0 && e <= t;
}
function TB(e, t) {
  return e.enabledProducts.includes(t);
}
function ei(e, t) {
  return {
    check: e,
    assert: () => {
      if (!e())
        throw new Al(`Feature "${t}" is not enabled`);
      return !0;
    },
    safeAssert: () => e() ? { enabled: !0 } : {
      enabled: !1,
      error: new Al(`Feature "${t}" is not enabled`)
    }
  };
}
function GG(e, t) {
  return ei(
    () => {
      var r;
      return e.enabledProducts.includes(C.EAppId.TE_EXAM_V3) && !!((r = t.appPermissions) != null && r.includes(Zw.HUB.STUDENT));
    },
    "studentAssessment"
  );
}
function zG(e) {
  return ei(
    () => e.enabledProducts.includes(C.EAppId.TE_ALLOCATE_PREFERENTIAL),
    "schedulePreferences"
  );
}
function BG(e) {
  return ei(() => e.enableWaitlist, "waitlist");
}
function VG(e) {
  return ei(
    () => e.blockStudentConflict,
    "blockStudentConflict"
  );
}
function WG(e) {
  return ei(
    () => e.preferencesTimeOfDay ?? !1,
    "preferencesTimeOfDay"
  );
}
function qG(e) {
  return ei(
    () => e.preferencesTime ?? !1,
    "preferencesTime"
  );
}
function HG(e) {
  return ei(
    () => e.preferencesGroup ?? !1,
    "preferencesGroup"
  );
}
function As(e, t) {
  return t in e;
}
function bB(e) {
  const t = {};
  if (As(e, "adminSettings")) {
    const r = e.adminSettings;
    t.waitlist = BG(r), t.blockStudentConflict = VG(r), t.preferencesTimeOfDay = WG(r), t.preferencesTime = qG(r), t.preferencesGroup = HG(r);
  }
  if (As(e, "organization")) {
    const r = e.organization;
    t.schedulePreferences = zG(r);
  }
  if (As(e, "organization") && As(e, "user")) {
    const r = e.organization, n = e.user;
    t.studentAssessment = GG(r, n);
  }
  return t;
}
function AB(e) {
  if (!(!M(e) || e.length === 0))
    return e.map(
      (t) => {
        var r;
        return (r = t.building) != null && r.value ? `${t.name.value} ${t.building.value}` : t.name.value;
      }
    ).join(", ");
}
function YG(e) {
  return (e == null ? void 0 : e.map(
    (t) => [t.code.value, t.name.value].filter(Boolean).join(" - ")
  ).filter(Boolean).join(", ")) ?? "";
}
function vB(e) {
  var t;
  return e.subtitle ? e.subtitle : ((t = e.examType) == null ? void 0 : t.value) ?? YG(e.module);
}
function SB({
  catalog: e,
  mapping: t,
  preferredGroupIds: r
}) {
  const n = new Set(r), o = (e.courseIds ?? Object.keys(e.courses).map(Number)).flatMap((a) => {
    const l = e.courses[a];
    if (!M(l)) return [];
    const f = t.parse("courseLabel", l.teObject);
    return l.children.flatMap((u) => {
      const h = e.activities[u];
      if (!M(h)) return [];
      const E = /* @__PURE__ */ new Set();
      return h.children.flatMap((d) => {
        const g = e.groups[d];
        if (!s(g, E))
          return [];
        const y = [];
        for (const _ of g.links) {
          const I = e.groups[_];
          s(I, E) && y.push(I);
        }
        const b = [g, ...y];
        return b.forEach((_) => E.add(_.id)), [
          {
            groupIds: b.map((_) => _.id),
            courseLabel: f,
            groupName: Ra(
              b.map((_) => bA(t, _.teObject)).sort((_, I) => _.localeCompare(I)),
              " + "
            )
          }
        ];
      });
    });
  });
  return ig({
    objects: ig({
      objects: o,
      sort: Yt.ASCFIELD,
      key: "groupName"
    }),
    sort: Yt.ASCFIELD,
    key: "courseLabel"
  });
  function s(a, l) {
    return M(a) && n.has(a.id) && !l.has(a.id);
  }
}
class IB {
  constructor(t, r) {
    $(this, "logger");
    $(this, "transformer");
    this.logger = t, this.transformer = r;
  }
  /**
   * Logs an info message.
   * @param args - One or many arguments of any type. Same signature as the
   * arguments for console.info
   */
  info(t, ...r) {
    if (M(this.transformer)) {
      this.transformer(this.logger.info.bind(this.logger))(t, ...r);
      return;
    }
    this.logger.info(t, ...r);
  }
  /**
   * Logs a warning message.
   * @param args - One or many arguments of any type. Same signature as the
   * arguments for console.debug
   */
  warn(t, ...r) {
    if (M(this.transformer)) {
      this.transformer(this.logger.warn.bind(this.logger))(t, ...r);
      return;
    }
    this.logger.warn(t, ...r);
  }
  /**
   * Logs a debug message. Used for low level debug information.
   * @param args - One or many arguments of any type. Same signature as the
   * arguments for console.debug
   */
  debug(t, ...r) {
    if (M(this.transformer)) {
      this.transformer(this.logger.debug.bind(this.logger))(t, ...r);
      return;
    }
    this.logger.debug(t, ...r);
  }
  /**
   * Logs a error message. Used for when something goes wrong.
   * @param args - One or many arguments of any type. Same signature as the
   * arguments for console.error
   */
  error(t, ...r) {
    if (M(this.transformer)) {
      this.transformer(this.logger.error.bind(this.logger))(t, ...r);
      return;
    }
    this.logger.error(t, ...r);
  }
  trace(t, ...r) {
    if ("trace" in this.logger) {
      if (M(this.transformer)) {
        this.transformer(this.logger.trace.bind(this.logger))(t, ...r);
        return;
      }
      this.logger.trace(t, ...r);
    } else {
      if (M(this.transformer)) {
        this.transformer(this.logger.debug.bind(this.logger))(t, ...r);
        return;
      }
      this.logger.debug(t, ...r);
    }
  }
  fatal(t, ...r) {
    if ("fatal" in this.logger) {
      if (M(this.transformer)) {
        this.transformer(this.logger.fatal.bind(this.logger))(t, ...r);
        return;
      }
      this.logger.fatal(t, ...r);
    } else {
      if (M(this.transformer)) {
        this.transformer(this.logger.error.bind(this.logger))(t, ...r);
        return;
      }
      this.logger.error(t, ...r);
    }
  }
  /**
   * Creates an error function with a base message.
   * @param baseMessage - The base message
   * @returns
   * Function that logs info messages
   */
  createInfoFn(t) {
    return (r, ...n) => this.logger.info(`${t} ${r}`, ...n);
  }
  /**
   * Creates an error function with a base message.
   * @param baseMessage - The base message
   * @returns
   * Function that logs debug messages
   */
  createDebugFn(t) {
    return (r, ...n) => this.logger.debug(`${t} ${r}`, ...n);
  }
  /**
   * Creates an error function with a base message.
   * @param baseMessage - The base message
   * @returns
   * Function that logs errors
   */
  createErrorFn(t) {
    return (r, ...n) => this.logger.error(`${t} ${r}`, ...n);
  }
}
const _B = "DD/MM/YYYY", RB = "DD/MM/YYYY HH:mm:ss", OB = "YYYY-MM-DD", wB = "YYYY-MM-DDTHH.mm.ss", og = {
  extId: "CET Default",
  name: "CET Default",
  identifier: "Europe/Stockholm",
  offset: "UTC+1"
}, ZG = -1, NB = -1, CB = -1, PB = -1, DB = 120, MB = 1e3, LB = 3e4, xB = !1;
class kB {
  constructor({ serverDateTime: t, timezone: r, mapping: n }) {
    /**
     * The record that will ultimately be returned when all the steps have been
     * completed.
     */
    $(this, "registration", {
      courses: {},
      courseIds: [],
      activities: {},
      groups: {},
      events: [],
      conflicts: {},
      timezone: {
        server: og,
        user: og
      },
      studentId: 0,
      studentObject: void 0
    });
    $(this, "catalog", {
      courses: {},
      activities: {},
      groups: {}
    });
    $(this, "mapping");
    $(this, "studentRelationIds", []);
    $(this, "studentMembers", []);
    $(this, "studentFieldValues", []);
    $(this, "mode", "student");
    $(this, "groupDedicatedMatches", {});
    $(this, "waitListsLookup", {});
    $(this, "groupWaitlists", /* @__PURE__ */ new Map());
    $(this, "groupHasValidWaitlist", /* @__PURE__ */ new Set());
    $(this, "conflicts", {});
    this.registration.serverDateTime = t, this.registration.timezone = r, this.mapping = n;
  }
  /**
   * The only public method of this service. It will fetch all the data from
   * the APIs and return a registration record.
   */
  createRegistration({
    catalog: t,
    mode: r,
    studentData: n,
    adminSettings: i
  }) {
    const { studentMembers: o, studentObject: s, conflicts: a, groupWaitlists: l } = n;
    this.conflicts = a, this.catalog = t, this.mode = r ?? "student", this.mode === "student" && (this.registration.blockStudentConflict = i.blockStudentConflict), this.registration.enableWaitlist = i.enableWaitlist, this.registration.studentObject = s, this.waitListsLookup = Ej(n.waitlists, "groupId"), this.groupWaitlists = l;
    const f = this.getRelationIdsFromObjects([s]), u = s.id;
    this.studentFieldValues = s.fields, this.studentRelationIds = f ?? [], this.registration.studentId = u, this.studentMembers = o, this.precomputeValidWaitlistGroups();
    const h = this.initiateRegistrationRecord(
      this.catalog
    );
    if (!h.success)
      return h;
    this.registration.activities = this.activityFilter(
      this.registration.activities,
      this.registration.groups
    ), this.registration.courses = this.courseFilter(
      this.registration.courses,
      this.registration.activities
    ), this.sortByLabel();
    for (const E in this.catalog.groups) {
      const d = this.catalog.groups[E];
      if (!M(d))
        return {
          success: !1,
          error: new Error(
            `Group '${E}' does not exist within catalog.groups.`
          ),
          code: "general",
          message: "[createRegistration][logic error]"
        };
      this.assignSeatsHiddenDedicatedGroups(d), this.assignWaitlistStatus(d);
      const g = this.assignOpen(d);
      if (!g.success)
        return g;
    }
    for (const E in this.catalog.activities) {
      const d = this.catalog.activities[E];
      if (!M(d))
        return {
          success: !1,
          error: new Error(
            `Activity '${d}' does not exist within catalog.activities.`
          ),
          code: "general",
          message: "[createRegistration][logic error]"
        };
      this.assignAllocationSignalAndStatus(d);
    }
    return this.catalog = {
      courses: {},
      activities: {},
      groups: {}
    }, { data: this.registration, success: !0 };
  }
  initiateRegistrationRecord(t) {
    for (const r in t.courses) {
      const n = t.courses[r];
      if (!M(n))
        return {
          success: !1,
          error: new Error(
            `Course '${r}' does not exist within catalog.courses.`
          ),
          code: "general",
          message: "[initiateRegistrationRecord][logic error]"
        };
      this.registration.courses[r] = {
        ...n,
        open: !1,
        // Default value, it is set to its correct value later
        showInRegistration: !0
      };
    }
    for (const r in t.activities) {
      const n = t.activities[r];
      if (!M(n))
        return {
          success: !1,
          error: new Error(
            `Activity '${r}' does not exist within catalog.activities.`
          ),
          code: "general",
          message: "[initiateRegistrationRecord][logic error]"
        };
      this.registration.activities[r] = {
        ...n,
        open: !1,
        // Default value, it is set to its correct value later
        showInRegistration: !0,
        allocationSignal: "ISSUE",
        hasConflicts: !1,
        hasWaitlist: !1
      };
    }
    for (const r in t.groups) {
      const n = this.catalog.groups[r];
      if (!M(n))
        return {
          success: !1,
          error: new Error(
            `Group '${r}' does not exist within catalog.group.`
          ),
          code: "general",
          message: "[initiateRegistrationRecord][logic error]"
        };
      const i = this.matchDedication(
        this.catalog.groups[r]
      ), o = this.isHidden(this.catalog.groups[r]);
      this.registration.groups[r] = {
        ...n,
        open: !1,
        showInRegistration: this.shouldShowInRegistration(
          o,
          i,
          this.catalog.groups[r]
        ),
        seats: {
          taken: 0,
          available: 0,
          total: 0,
          raw: {
            taken: 0,
            available: 0,
            total: 0,
            buffer: 0
          }
        },
        dedicated: {
          kind: "none",
          data: void 0
        },
        matchDedication: i,
        hidden: o,
        allocationStatus: "NOT_ALLOCATED",
        waitlistPosition: 0,
        hasStudentsInWaitlist: !1
      };
    }
    return { success: !0 };
  }
  /**
   * @param group
   * @returns If the input group should be included (shown for the user) based on its dedications
   */
  matchDedication(t) {
    if (!M(t)) return !1;
    const r = Cs({
      mapping: this.mapping,
      value: t.teObject
    }), { dedicatedMatch: n } = this.assignGroupDedicatedMatches(t);
    return !n && r.kind === "none" ? !this.activityDedicatedMatches(
      this.catalog.activities[t.parentId]
    ) : n;
  }
  /**
   * @description If the student has any dedicated matches with any groups in the activity.
   * @param activity
   * @returns If any group in the activity has a dedicated match
   */
  activityDedicatedMatches(t) {
    return t == null ? void 0 : t.children.some(
      (r) => this.assignGroupDedicatedMatches(this.catalog.groups[r]).dedicatedMatch
    );
  }
  /**
   * @description Will assign if a group has a dedicated match.
   * @param group
   * @returns If the student and group have a dedication match or a rest match
   */
  assignGroupDedicatedMatches(t) {
    if (!M(t))
      return { dedicatedMatch: !1 };
    if (M(this.groupDedicatedMatches[t.id]))
      return this.groupDedicatedMatches[t.id];
    const r = Cs({
      mapping: this.mapping,
      value: t.teObject
    }), i = K$({
      dedicatedGroup: r,
      studentFieldValues: this.studentFieldValues,
      studentRelationIds: this.studentRelationIds
    }).length > 0;
    return this.groupDedicatedMatches[t.id] = { dedicatedMatch: i }, { dedicatedMatch: i };
  }
  isHidden(t) {
    return M(t) ? this.mapping.parse("hideGroup", t.teObject) : !1;
  }
  /**
   * Assign 'showInRegistration' for group based on dedicated group, hidden and whether
   * the group is allocated.
   */
  shouldShowInRegistration(t, r, n) {
    return M(n) ? !t && r || this.isAllocated(n) : !1;
  }
  /**
   * Assign 'showInRegistration' based on whether there are 'showInRegistration' groups that
   * belong to the activity. Assign a 'children' array containing only
   * showInRegistration groups, and an 'allChildren' array containing all groups
   * that are defined.
   * Assigning if the activity has waitlist or conflicts.
   */
  activityFilter(t, r) {
    return Object.entries(t).reduce(
      (n, [i, o]) => {
        var E;
        if (!M(o)) return n;
        const s = [], a = ((E = o.children) == null ? void 0 : E.filter((d) => {
          const g = r[d], y = M(g);
          return y && g.showInRegistration && s.push(qE(g.id)), y;
        })) ?? [], l = a.some((d) => {
          const g = this.catalog.groups[d];
          return M(g) && this.getWaitlistPosition(g) > 0;
        }), f = a.some((d) => {
          const g = this.conflicts[d];
          return M(g) ? g.allocated && g.reservations.length > 0 : !1;
        }), u = this.getChildren({ children: s, allChildren: a });
        if (!u.length) return n;
        const h = {
          ...o,
          children: u,
          showInRegistration: M(s) && s.length > 0,
          hasWaitlist: l,
          hasConflicts: f
        };
        return {
          ...n,
          [i]: h
        };
      },
      {}
    );
  }
  /**
   * Assign 'showInRegistration' based on whether there are 'showInRegistration' activities that
   * belong to the course. Assign a 'children' array containing only
   * showInRegistration activities, and an 'allChildren' array containing all activities
   * that are defined.
   */
  courseFilter(t, r) {
    return Object.entries(t).reduce(
      (n, [i, o]) => {
        var u;
        if (!M(o)) return n;
        const s = [], a = ((u = o.children) == null ? void 0 : u.filter((h) => {
          const E = r[h], d = M(E);
          return d && E.showInRegistration && s.push(qE(E.id)), d;
        })) ?? [], l = this.getChildren({ children: s, allChildren: a });
        if (!l.length) return n;
        const f = {
          ...o,
          children: l,
          showInRegistration: M(s) && s.length > 0
        };
        return {
          ...n,
          [i]: f
        };
      },
      {}
    );
  }
  /**
   * Sort the registration alphabetically by label, after filtering.
   */
  sortByLabel() {
    this.registration.courseIds = Cu({
      ids: Object.values(this.registration.courses).filter(M).map((t) => t.id),
      getLabel: (t) => {
        var r;
        return (r = this.registration.courses[t]) == null ? void 0 : r.label;
      }
    });
    for (const t in this.registration.courses) {
      const r = this.registration.courses[t];
      M(r) && (r.children = Cu({
        ids: r.children,
        getLabel: (n) => {
          var i;
          return (i = this.registration.activities[n]) == null ? void 0 : i.label;
        }
      }));
    }
    for (const t in this.registration.activities) {
      const r = this.registration.activities[t];
      M(r) && (r.children = Cu({
        ids: r.children,
        getLabel: (n) => {
          var i;
          return (i = this.registration.groups[n]) == null ? void 0 : i.label;
        }
      }));
    }
  }
  assignSeatsHiddenDedicatedGroups(t) {
    const r = this.mapping.parse("buffer", t.teObject), n = this.mapping.parse("maxStudents", t.teObject), i = r.isPercent ? Math.round(n * r.size / 100) : r.size, o = this.getStudentMembersOfGroup(t), s = Cs({
      mapping: this.mapping,
      value: t.teObject
    }), a = o.length, l = Math.max(n - i, 0), f = Math.max(l - a, 0), h = {
      available: f,
      total: l,
      taken: a,
      raw: {
        taken: a,
        total: n,
        available: f,
        buffer: i
      }
    }, E = this.registration.groups[t.id];
    M(E) && (this.registration.groups[t.id] = {
      ...E,
      allocationStatus: this.isAllocated(t, o) ? "ALLOCATED_TO_THIS" : "NOT_ALLOCATED",
      seats: h,
      dedicated: s
    });
  }
  assignWaitlistStatus(t) {
    const r = this.registration.groups[t.id];
    M(r) && (this.registration.groups[t.id] = {
      ...r,
      waitlistPosition: this.getWaitlistPosition(t),
      hasStudentsInWaitlist: this.hasValidWaitlistEntries(t)
    });
  }
  /**
   * Effective waitlist position for the current student on this group:
   * zero when they are already allocated, otherwise the raw waitlist
   * position from the lookup.
   */
  getWaitlistPosition(t) {
    const r = this.waitListsLookup[t.id];
    return !M(r) || this.isAllocated(t) ? 0 : r.position;
  }
  /**
   * A waitlist entry only counts when the student is still enrolled in
   * the owning course and isn't already a member of the group — stale
   * entries (allocated-and-waitlisted, or no longer enrolled) are ignored.
   * Membership is precomputed once per createRegistration call.
   */
  hasValidWaitlistEntries(t) {
    return this.groupHasValidWaitlist.has(t.id);
  }
  precomputeValidWaitlistGroups() {
    this.groupHasValidWaitlist = /* @__PURE__ */ new Set();
    const t = /* @__PURE__ */ new Map();
    for (const [r, n] of this.groupWaitlists) {
      if (!n.length) continue;
      const i = this.catalog.groups[r];
      if (!M(i)) continue;
      const o = this.catalog.activities[i.parentId];
      if (!M(o)) continue;
      const s = this.catalog.courses[o.parentId];
      if (!M(s)) continue;
      let a = t.get(s.id);
      a || (a = new Set(
        s.teObject.relations.flatMap((u) => u.objectIds)
      ), t.set(s.id, a));
      const l = new Set(
        i.teObject.members.map((u) => u.objectId)
      );
      n.some(
        (u) => !l.has(u) && a.has(u)
      ) && this.groupHasValidWaitlist.add(r);
    }
  }
  /**
   * Get the student members belonging to a particular group.
   */
  getStudentMembersOfGroup(t) {
    const r = t.teObject.members.map((n) => n.objectId);
    return this.studentMembers.filter(
      (n) => r.includes(n.id)
    );
  }
  /**
   * Check if the current student is allocated to a group. Pass
   * prefiltered studentMembers when the caller already has them
   * (e.g. when computing seats); otherwise the check runs directly
   * against group.teObject.members.
   */
  isAllocated(t, r) {
    return r !== void 0 ? r.some(
      (n) => n.id === this.registration.studentId
    ) : t.teObject.members.some(
      (n) => n.objectId === this.registration.studentId
    );
  }
  /**
   * After the activities have been created, we need to edit the
   * activities to include the MULTIPLE_ALLOCATIONS and
   * ALLOCATED_TO_OTHER statuses. We also need to assign the right
   * allocationSignal to the activity.
   */
  assignAllocationSignalAndStatus(t) {
    var o, s;
    let r = "ISSUE";
    const n = this.registration.activities[t.id];
    if (!M(n)) return;
    const i = ((o = t.children) == null ? void 0 : o.filter(
      (a) => {
        var l, f;
        return ((f = (l = this.registration.groups) == null ? void 0 : l[a]) == null ? void 0 : f.allocationStatus) === "ALLOCATED_TO_THIS";
      }
    )) || [];
    for (const a of (t == null ? void 0 : t.children) ?? []) {
      let l = "NOT_ALLOCATED";
      const f = (s = this.registration.groups) == null ? void 0 : s[a];
      if (!M(f)) continue;
      const u = f.links.filter(
        (E) => !i.includes(E)
      ), h = i.filter(
        (E) => !f.links.includes(E)
      );
      i.includes(sT.parse(f.id)) ? h.length > 1 ? l = "MULTIPLE_ALLOCATIONS" : (l = "ALLOCATED_TO_THIS", u.length === 0 && (r = "OK")) : h.length > 0 && (l = "ALLOCATED_TO_OTHER"), f.allocationStatus = l;
    }
    n.allocationSignal = r;
  }
  /**
   * Assign to each item in the registration record if it is open to
   * registration.
   */
  assignOpen(t) {
    const r = this.catalog.activities[t.parentId];
    if (!M(r))
      return {
        success: !1,
        error: new Error(
          `Activity '${t.parentId}' does not exist within catalog.activities.`
        ),
        code: "general",
        message: "[assignOpen][logic error]"
      };
    const n = this.catalog.courses[r.parentId];
    if (!M(n))
      return {
        success: !1,
        error: new Error(
          `Course '${r.parentId}' does not exist within catalog.courses.`
        ),
        code: "general",
        message: "[assignOpen][logic error]"
      };
    const i = this.registration.groups[t.id], o = this.registration.activities[r.id], s = this.registration.courses[n.id];
    if (!M(i) || !M(o) || !M(s))
      return { success: !0 };
    const a = this.isGroupOpen(t);
    return i.open = a, o.open = o.open || a, s.open = s.open || a, { success: !0 };
  }
  /**
   * Based on the current date time, and a number of other factors, we need
   * to determine if group is open to registration. The spec for this logic is
   * further documented in the tests.
   */
  isGroupOpen(t) {
    var i, o;
    if (!((o = (i = this.registration.groups) == null ? void 0 : i[t.id]) != null && o.showInRegistration) || !M(this.registration.serverDateTime))
      return !1;
    const r = this.mapping.parse("startDate", t.teObject), n = this.mapping.parse("endDate", t.teObject);
    return XU(
      r,
      n,
      this.registration.timezone.server.identifier,
      this.registration.serverDateTime.unix
    ) === Mr.enum.open;
  }
  /**
   * Merge all relation ids from all objects together
   */
  getRelationIdsFromObjects(t) {
    return t == null ? void 0 : t.reduce((n, i) => {
      var s;
      if (i === void 0) return n;
      const o = (s = i.relations) == null ? void 0 : s.flatMap((a) => a.objectIds).filter((a) => !n.includes(a));
      return o ? [...n, ...o] : n;
    }, []);
  }
  /**
   * Return the right children based on the registration mode
   */
  getChildren({
    children: t,
    allChildren: r
  }) {
    switch (this.mode) {
      case "teacher":
        return r;
      case "student":
        return t;
      default:
        return Et(this.mode);
    }
  }
}
class jB {
  constructor({ timezone: t }) {
    $(this, "schedule", {
      events: [],
      conflicts: {}
    });
    $(this, "timezone", "");
    this.timezone = t;
  }
  /**
   * Fetch reservations based on groups. Create the events and assign the conflicts.
   */
  createSchedule({
    studentConflicts: t,
    groupIdsByReservation: r,
    reservations: n,
    groups: i
  }) {
    return this.schedule.conflicts = t, this.createEvents({
      reservations: n,
      groups: i,
      groupIdsByReservation: r
    }), this.assignEventConflicts({
      studentConflicts: t
    }), { success: !0, data: this.schedule };
  }
  /**
   * Create the events from the reservations.
   */
  createEvents({
    groupIdsByReservation: t,
    reservations: r,
    groups: n,
    events: i
  }) {
    M(i) && (this.schedule.events = i);
    const o = /* @__PURE__ */ new Set();
    if (M(r))
      for (const s of r) {
        if (!wG(s))
          continue;
        const a = this.getGroups({
          groups: n,
          reservation: s,
          groupIdsByReservation: t
        }), l = Km(s.begin, this.timezone), f = Km(s.end, this.timezone);
        if (a.length === 0) {
          const u = {
            id: s.id,
            start: l,
            end: f,
            name: "",
            reservation: s,
            groupId: ZG,
            allocationConflicts: []
          };
          this.schedule.events.push(u);
          continue;
        }
        for (const u of a) {
          const h = {
            id: s.id,
            start: l,
            end: f,
            name: u.label,
            reservation: s,
            groupId: u.id,
            allocationConflicts: []
          };
          o.add(u.id), this.schedule.events.push(h);
        }
      }
    for (const s in n) {
      if (o.has(Number(s)))
        continue;
      const a = n[s];
      if (!M(a))
        continue;
      const l = -a.id, f = {
        id: l,
        start: Ni,
        end: Ni,
        name: a.label,
        reservation: { id: l, history: {} },
        groupId: a.id,
        allocationConflicts: []
      };
      this.schedule.events.push(f);
    }
  }
  /**
   * It takes in all conflicts and potential conflicts for the student.
   * On each event add a list of conflicting events.
   * Create a list of conflict objects that contain
   * unique combinations of allocated groups conflicting with
   * each other.
   */
  assignEventConflicts({ studentConflicts: t }) {
    for (const r of this.schedule.events) {
      if (!M(r)) continue;
      const n = t[r.groupId];
      M(n) && (r.allocationConflicts = n.reservations.map(
        (i) => ({
          reservationId: i.reservationId,
          groupId: i.studentSetGroupId
        })
      ));
    }
  }
  /**
   * @param reservation A reservation object
   * @param groups Groups for specific user
   * @param reservationGroupLookup Lookup table reservation id -> group ids
   * @returns Groups based on the reservation
   */
  getGroups({
    reservation: t,
    groups: r,
    groupIdsByReservation: n
  }) {
    const i = n[t.id];
    return M(i) ? i.map((o) => r[o]).filter(M) : [];
  }
}
class UB {
  constructor({ mapping: t, logger: r }) {
    /**
     * The record that will ultimately be returned when all the steps have been
     * completed.
     */
    $(this, "catalog", {
      courses: {},
      activities: {},
      groups: {}
    });
    $(this, "courseMap", /* @__PURE__ */ new Map());
    $(this, "mapping");
    $(this, "linkedGroupsRecord", {});
    $(this, "logger", console);
    this.mapping = t, this.logger = r;
  }
  /**
   * The only public method of this service. It will fetch all the data from
   * the APIs and return a catalog.
   */
  createCatalog({
    groupObjects: t,
    courseObjects: r,
    linkedGroupsRecord: n
  }) {
    this.linkedGroupsRecord = n, this.courseMap = new Map(r.map((a) => [a.id, !0]));
    const i = this.assignGroupsToCatalog(t);
    if (!i.success)
      return i;
    const o = this.assignCoursesToCatalog(r);
    if (!o.success)
      return o;
    this.removeOrphans();
    const s = this.createActivities();
    return s.success ? { data: this.catalog, success: !0 } : s;
  }
  assignGroupsToCatalog(t) {
    for (const r of t)
      try {
        const n = yA({
          courseIds: r.relations.flatMap((o) => o.objectIds).filter((o) => this.courseMap.has(o)),
          group: r,
          mapping: this.mapping
        });
        if (!n.success)
          throw new Ho(
            n.message,
            {
              cause: n.issues
            }
          );
        const i = this.assignCommonCatalogParameters({
          recordKey: "groups",
          teObject: r
        });
        if (!i.success)
          return i;
      } catch (n) {
        if (jU(n, Ho)) {
          this.logger.warn(
            `[assignGroupsToCatalog]: Missconfigured student set group: ${Dt(
              n
            )}`,
            { err: n }
          );
          continue;
        }
        throw n;
      }
    return { success: !0 };
  }
  assignCoursesToCatalog(t) {
    for (const r of t) {
      const n = this.assignCommonCatalogParameters({
        recordKey: "courses",
        childKey: "groups",
        teObject: r
      });
      if (!n.success)
        return n;
    }
    return { success: !0 };
  }
  assignCommonCatalogParameters({
    recordKey: t,
    childKey: r,
    teObject: n
  }) {
    const i = this.assignIdsAndData({
      recordKey: t,
      teObject: n
    });
    if (!i.success)
      return i;
    const o = this.createRelations({ childKey: r, teObject: n });
    this.assignRelations({
      recordKey: t,
      childKey: r,
      relations: o,
      objectId: n.id
    });
    const s = this.assignParentIds({
      childKey: r,
      relations: o,
      teObject: n
    });
    return s.success ? { success: !0 } : s;
  }
  /**
   * Create a set of relation ids filtered on whether they have been previously
   * added to the catalog.
   */
  createRelations({ childKey: t, teObject: r }) {
    var i;
    const n = /* @__PURE__ */ new Set();
    for (const o of ((i = r.relations) == null ? void 0 : i.flatMap((s) => s.objectIds)) ?? [])
      t !== void 0 && this.catalog[t][o] && n.add(o);
    return n;
  }
  assignRelations({
    recordKey: t,
    childKey: r,
    relations: n,
    objectId: i
  }) {
    if (r !== void 0) {
      const o = this.catalog[t][i];
      o !== void 0 && "children" in o && (o.children = Array.from(n));
    }
  }
  /**
   * Assign parentId to all relations if childKey and parentIdKey are both
   * provided.
   */
  assignParentIds({
    childKey: t,
    relations: r,
    teObject: n
  }) {
    if (t !== void 0)
      for (const i of r) {
        const o = this.catalog[t][i];
        if (!M(o)) {
          const s = new Error(
            `Relation '${i}' does not exist within catalog.${t}.`
          );
          this.logger.warn(
            `[assignParentIds][data error] ${Dt(s)}`,
            { err: s }
          );
          continue;
        }
        this.catalog[t][i] = {
          ...o,
          parentId: n.id
        };
      }
    return { success: !0 };
  }
  /**
   * Assign id:s and other data to the catalog record.
   */
  assignIdsAndData({
    recordKey: t,
    teObject: r
  }) {
    var o;
    const n = (o = this.catalog[t]) == null ? void 0 : o[r.id];
    if ((n == null ? void 0 : n.id) !== void 0)
      return { success: !0 };
    const i = t === "groups" ? this.mapping.getIds("group") : this.mapping.getIds("course");
    switch (t) {
      case "groups": {
        this.catalog[t][r.id] = {
          id: r.id,
          extId: r.extId,
          typeIds: i,
          teObject: r,
          label: this.mapping.parse("groupName", r),
          links: this.linkedGroupsRecord[r.id.toString()] ?? [],
          parentId: 0
        };
        break;
      }
      case "courses": {
        this.catalog[t][r.id] = {
          id: r.id,
          extId: r.extId,
          typeIds: i,
          teObject: r,
          label: this.mapping.parse("courseTitle", r),
          children: []
        };
        break;
      }
      default:
        Et();
    }
    return { success: !0 };
  }
  /**
   * If a group does not have a parentId, it cannot be associated with a course,
   * and we cannot create a activity for it. This indicates something is
   * missing from the data provided, and the best course of action is to remove
   * the group.
   */
  removeOrphans() {
    var t;
    for (const r in this.catalog.groups)
      if (!((t = this.catalog.groups[r]) != null && t.parentId)) {
        delete this.catalog.groups[r];
        const n = new Error(
          `Group '${r}' did not have a parentId assigned and was removed. The course with the group as a relation was not found.`
        );
        this.logger.warn(
          `[removeOrphans][data error] ${Dt(n)}`,
          { err: n }
        );
      }
  }
  /**
   * There no longer exists an actual object mapped to activity, so
   * we create activities based on the activityType
   */
  createActivities() {
    var n;
    const t = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Map();
    for (const i in this.catalog.groups) {
      const o = this.catalog.groups[Number(i)];
      if (!M(o))
        return {
          success: !1,
          error: new Error(
            `Group '${i}' does not exist within catalog.groups.`
          ),
          code: "general",
          message: "[createActivities][logic error]"
        };
      const s = o.links.reduce((d, g) => {
        var b;
        const y = (b = this.catalog.groups[g]) == null ? void 0 : b.teObject;
        return M(y) && d.push(y), d;
      }, []), a = LF({
        courseIds: [o.parentId],
        groups: [o.teObject, ...s],
        mapping: this.mapping
      });
      if (!a.success)
        continue;
      const { id: l, activityType: f } = a.data;
      if (this.catalog.activities[l] === void 0) {
        this.catalog.activities[l] = {
          id: l,
          parentId: o.parentId,
          label: f,
          children: []
        };
        const d = this.catalog.courses[o.parentId];
        if (!M(d))
          return {
            success: !1,
            error: new Error(
              `Course '${o.parentId}' does not exist within catalog.courses while removing the group reference for the parent.`
            ),
            code: "general",
            message: "[createActivities][logic error]"
          };
        d.children = ((n = d.children) == null ? void 0 : n.filter((g) => !this.catalog.groups[g])) ?? [];
      }
      const u = this.catalog.activities[l];
      if (!M(u))
        return {
          success: !1,
          error: new Error(
            `Activity '${l}' does not exist within catalog.activities.`
          ),
          code: "general",
          message: "[createActivities][logic error]"
        };
      let h = t.get(l);
      M(h) || (h = /* @__PURE__ */ new Set(), t.set(l, h)), h.add(Number(i));
      let E = r.get(o.parentId);
      M(E) || (E = /* @__PURE__ */ new Set(), r.set(o.parentId, E)), E.add(l), o.parentId = l;
    }
    for (const [i, o] of t) {
      const s = this.catalog.activities[i];
      M(s) && (s.children = Array.from(o));
    }
    for (const [i, o] of r) {
      const s = this.catalog.courses[i];
      M(s) && (s.children = [...s.children ?? [], ...o]);
    }
    return { success: !0 };
  }
}
function $B(e) {
  const {
    courses: t,
    students: r,
    conflictLookups: {
      studentReservationsByStudentId: n,
      studentSetGroupReservationsByGroupId: i,
      studentSetGroupByCourseId: o,
      studentSetGroupLookup: s,
      activityByStudentSetGroupId: a
    }
  } = e, l = pf(t), f = {};
  for (const u of r) {
    f[u.id] = {};
    const h = new Map(
      (n[u.id] ?? []).map((g) => [g.id, g])
    ), E = new Set(u.members.map((g) => g.objectId)), d = JG(
      u,
      l,
      o
    );
    for (const g of d) {
      const y = KG({
        studentSetGroupId: g,
        studentSetGroupLookup: s,
        studentReservationsMap: h,
        studentSetGroupReservationsByGroupId: i,
        activityByStudentSetGroupId: a
      });
      y.length > 0 && (f[u.id][g] = {
        reservations: y,
        allocated: E.has(g)
      });
    }
  }
  return f;
}
function FB({
  students: e,
  courses: t,
  studentSetGroups: r,
  studentReservations: n,
  studentSetGroupReservations: i,
  mapping: o
}) {
  const { objectWithReservations: s } = rg({
    objects: e,
    reservations: n,
    mapping: o
  }), {
    objectWithReservations: a,
    reservationWithObjectIds: l
  } = rg({
    objects: r,
    reservations: i,
    mapping: o
  }), f = pf(r), u = XG({
    courses: t,
    studentSetGroupLookup: f
  }), h = jF({
    groups: r,
    mapping: o,
    courseIds: t.map((d) => d.id),
    studentIds: e.map((d) => d.id)
  }), E = {};
  for (const d of h)
    for (const g of d.groups)
      E[g.id] = {
        activityId: d.id,
        courseId: d.courseId
      };
  for (const d of e) {
    const g = s[d.id] ?? [];
    let y = [];
    for (const b of d.members) {
      const _ = f[b.objectId];
      if (!M(_)) continue;
      const I = a[_.id];
      M(I) && (y = mm(y, I));
    }
    s[d.id] = mm(
      g,
      y
    );
  }
  return {
    studentReservationsByStudentId: s,
    studentSetGroupReservationsByGroupId: a,
    studentSetGroupByCourseId: u,
    activityByStudentSetGroupId: E,
    studentSetGroupLookup: f,
    groupIdsByReservation: l
  };
}
function JG(e, t, r) {
  const n = /* @__PURE__ */ new Set(), i = e.relations.flatMap((o) => o.objectIds.map((s) => t[s])).filter(M);
  for (const o of i)
    (r[o.id] ?? []).forEach((a) => n.add(a));
  return Array.from(n);
}
function KG({
  studentSetGroupId: e,
  studentSetGroupLookup: t,
  studentReservationsMap: r,
  studentSetGroupReservationsByGroupId: n,
  activityByStudentSetGroupId: i
}) {
  var l;
  const o = {}, s = n[e] ?? [], a = i[e];
  for (const f of s) {
    if (M(o[f.id])) continue;
    const u = Array.from(
      r.values()
    ).filter(
      (h) => (
        // 1. If the group reservation is the same as the student reservation, skip
        // 2. If there is no conflict, skip
        f.id !== h.id && QG(
          {
            start: f.begin ?? 0,
            end: f.end ?? 0
          },
          {
            start: h.begin ?? 0,
            end: h.end ?? 0
          }
        )
      )
    );
    for (const h of Object.values(
      u
    )) {
      if (!M(h)) continue;
      const E = (l = h.objects) == null ? void 0 : l.find(
        (d) => M(t[d.objectId]) && d.objectId !== e
      );
      if (!M(E))
        o[h.id] = {
          reservationId: h.id,
          start: h.begin ?? 0,
          end: h.end ?? 0,
          studentSetGroupId: -1,
          activityId: -1,
          courseId: -1
        };
      else {
        const d = i[E.objectId];
        if (M(d) && (a == null ? void 0 : a.activityId) === d.activityId)
          continue;
        o[h.id] = {
          reservationId: h.id,
          start: h.begin ?? 0,
          end: h.end ?? 0,
          studentSetGroupId: E.objectId,
          activityId: (d == null ? void 0 : d.activityId) ?? -1,
          courseId: (d == null ? void 0 : d.courseId) ?? -1
        };
      }
    }
  }
  return Object.values(o);
}
function XG({
  courses: e,
  studentSetGroupLookup: t
}) {
  var n;
  const r = {};
  for (const i of e) {
    r[i.id] = [];
    for (const o of i.relations)
      for (const s of o.objectIds) {
        const a = t[s];
        M(a) && ((n = r[i.id]) == null || n.push(a.id));
      }
  }
  return r;
}
function GB({
  studentConflicts: e
}) {
  const t = {};
  for (const r in e) {
    t[r] = 0;
    const n = e[r];
    if (M(n))
      for (const i in n) {
        const o = n[i];
        M(o) && o.allocated && (t[r] += 1);
      }
  }
  return t;
}
function QG(e, t) {
  return e.start >= e.end || t.start >= t.end ? !1 : e.start < t.end && t.start < e.end;
}
const zB = "64ad472b59d4e82d4f41dc55", BB = (e) => {
  switch (e) {
    case Ze.EAppEnv.DEVELOPMENT:
    case Ze.EAppEnv.BETA:
      return "65e829cc7386bf105e2e28d5";
    case Ze.EAppEnv.STAGING:
      return "65e829836880eb10b9f4edca";
    case Ze.EAppEnv.TEST:
      return "67ab2b0fbad72e0a5478c6a6";
    // Production
    default:
      return "65a938f0183d141061d386f9";
  }
};
function VB() {
  const e = UA();
  return MD.parse(e);
}
function WB(e) {
  switch (e) {
    case Ei.Success:
      return "Success";
    case Ei.Impossible:
      return ve.impossibleProposal;
    case Ei.ImpossibleInCurrent:
      return ve.impossibleInCurrentProposal;
    case Ei.NotEnoughSpaceOnPossible:
      return ve.notEnoughSpaceOnPossibleProposal;
    default:
      return "Unknown";
  }
}
var Pu = {}, Do = {}, sg;
function ez() {
  if (sg) return Do;
  sg = 1, Do.byteLength = a, Do.toByteArray = f, Do.fromByteArray = E;
  for (var e = [], t = [], r = typeof Uint8Array < "u" ? Uint8Array : Array, n = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", i = 0, o = n.length; i < o; ++i)
    e[i] = n[i], t[n.charCodeAt(i)] = i;
  t[45] = 62, t[95] = 63;
  function s(d) {
    var g = d.length;
    if (g % 4 > 0)
      throw new Error("Invalid string. Length must be a multiple of 4");
    var y = d.indexOf("=");
    y === -1 && (y = g);
    var b = y === g ? 0 : 4 - y % 4;
    return [y, b];
  }
  function a(d) {
    var g = s(d), y = g[0], b = g[1];
    return (y + b) * 3 / 4 - b;
  }
  function l(d, g, y) {
    return (g + y) * 3 / 4 - y;
  }
  function f(d) {
    var g, y = s(d), b = y[0], _ = y[1], I = new r(l(d, b, _)), w = 0, L = _ > 0 ? b - 4 : b, R;
    for (R = 0; R < L; R += 4)
      g = t[d.charCodeAt(R)] << 18 | t[d.charCodeAt(R + 1)] << 12 | t[d.charCodeAt(R + 2)] << 6 | t[d.charCodeAt(R + 3)], I[w++] = g >> 16 & 255, I[w++] = g >> 8 & 255, I[w++] = g & 255;
    return _ === 2 && (g = t[d.charCodeAt(R)] << 2 | t[d.charCodeAt(R + 1)] >> 4, I[w++] = g & 255), _ === 1 && (g = t[d.charCodeAt(R)] << 10 | t[d.charCodeAt(R + 1)] << 4 | t[d.charCodeAt(R + 2)] >> 2, I[w++] = g >> 8 & 255, I[w++] = g & 255), I;
  }
  function u(d) {
    return e[d >> 18 & 63] + e[d >> 12 & 63] + e[d >> 6 & 63] + e[d & 63];
  }
  function h(d, g, y) {
    for (var b, _ = [], I = g; I < y; I += 3)
      b = (d[I] << 16 & 16711680) + (d[I + 1] << 8 & 65280) + (d[I + 2] & 255), _.push(u(b));
    return _.join("");
  }
  function E(d) {
    for (var g, y = d.length, b = y % 3, _ = [], I = 16383, w = 0, L = y - b; w < L; w += I)
      _.push(h(d, w, w + I > L ? L : w + I));
    return b === 1 ? (g = d[y - 1], _.push(
      e[g >> 2] + e[g << 4 & 63] + "=="
    )) : b === 2 && (g = (d[y - 2] << 8) + d[y - 1], _.push(
      e[g >> 10] + e[g >> 4 & 63] + e[g << 2 & 63] + "="
    )), _.join("");
  }
  return Do;
}
var vs = {};
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
var ag;
function tz() {
  return ag || (ag = 1, vs.read = function(e, t, r, n, i) {
    var o, s, a = i * 8 - n - 1, l = (1 << a) - 1, f = l >> 1, u = -7, h = r ? i - 1 : 0, E = r ? -1 : 1, d = e[t + h];
    for (h += E, o = d & (1 << -u) - 1, d >>= -u, u += a; u > 0; o = o * 256 + e[t + h], h += E, u -= 8)
      ;
    for (s = o & (1 << -u) - 1, o >>= -u, u += n; u > 0; s = s * 256 + e[t + h], h += E, u -= 8)
      ;
    if (o === 0)
      o = 1 - f;
    else {
      if (o === l)
        return s ? NaN : (d ? -1 : 1) * (1 / 0);
      s = s + Math.pow(2, n), o = o - f;
    }
    return (d ? -1 : 1) * s * Math.pow(2, o - n);
  }, vs.write = function(e, t, r, n, i, o) {
    var s, a, l, f = o * 8 - i - 1, u = (1 << f) - 1, h = u >> 1, E = i === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0, d = n ? 0 : o - 1, g = n ? 1 : -1, y = t < 0 || t === 0 && 1 / t < 0 ? 1 : 0;
    for (t = Math.abs(t), isNaN(t) || t === 1 / 0 ? (a = isNaN(t) ? 1 : 0, s = u) : (s = Math.floor(Math.log(t) / Math.LN2), t * (l = Math.pow(2, -s)) < 1 && (s--, l *= 2), s + h >= 1 ? t += E / l : t += E * Math.pow(2, 1 - h), t * l >= 2 && (s++, l /= 2), s + h >= u ? (a = 0, s = u) : s + h >= 1 ? (a = (t * l - 1) * Math.pow(2, i), s = s + h) : (a = t * Math.pow(2, h - 1) * Math.pow(2, i), s = 0)); i >= 8; e[r + d] = a & 255, d += g, a /= 256, i -= 8)
      ;
    for (s = s << i | a, f += i; f > 0; e[r + d] = s & 255, d += g, s /= 256, f -= 8)
      ;
    e[r + d - g] |= y * 128;
  }), vs;
}
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */
var ug;
function rz() {
  return ug || (ug = 1, (function(e) {
    var t = ez(), r = tz(), n = typeof Symbol == "function" && typeof Symbol.for == "function" ? Symbol.for("nodejs.util.inspect.custom") : null;
    e.Buffer = a, e.SlowBuffer = I, e.INSPECT_MAX_BYTES = 50;
    var i = 2147483647;
    e.kMaxLength = i, a.TYPED_ARRAY_SUPPORT = o(), !a.TYPED_ARRAY_SUPPORT && typeof console < "u" && typeof console.error == "function" && console.error(
      "This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support."
    );
    function o() {
      try {
        var p = new Uint8Array(1), c = { foo: function() {
          return 42;
        } };
        return Object.setPrototypeOf(c, Uint8Array.prototype), Object.setPrototypeOf(p, c), p.foo() === 42;
      } catch {
        return !1;
      }
    }
    Object.defineProperty(a.prototype, "parent", {
      enumerable: !0,
      get: function() {
        if (a.isBuffer(this))
          return this.buffer;
      }
    }), Object.defineProperty(a.prototype, "offset", {
      enumerable: !0,
      get: function() {
        if (a.isBuffer(this))
          return this.byteOffset;
      }
    });
    function s(p) {
      if (p > i)
        throw new RangeError('The value "' + p + '" is invalid for option "size"');
      var c = new Uint8Array(p);
      return Object.setPrototypeOf(c, a.prototype), c;
    }
    function a(p, c, m) {
      if (typeof p == "number") {
        if (typeof c == "string")
          throw new TypeError(
            'The "string" argument must be of type string. Received type number'
          );
        return h(p);
      }
      return l(p, c, m);
    }
    a.poolSize = 8192;
    function l(p, c, m) {
      if (typeof p == "string")
        return E(p, c);
      if (ArrayBuffer.isView(p))
        return g(p);
      if (p == null)
        throw new TypeError(
          "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof p
        );
      if (Re(p, ArrayBuffer) || p && Re(p.buffer, ArrayBuffer) || typeof SharedArrayBuffer < "u" && (Re(p, SharedArrayBuffer) || p && Re(p.buffer, SharedArrayBuffer)))
        return y(p, c, m);
      if (typeof p == "number")
        throw new TypeError(
          'The "value" argument must not be of type number. Received type number'
        );
      var T = p.valueOf && p.valueOf();
      if (T != null && T !== p)
        return a.from(T, c, m);
      var S = b(p);
      if (S) return S;
      if (typeof Symbol < "u" && Symbol.toPrimitive != null && typeof p[Symbol.toPrimitive] == "function")
        return a.from(
          p[Symbol.toPrimitive]("string"),
          c,
          m
        );
      throw new TypeError(
        "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof p
      );
    }
    a.from = function(p, c, m) {
      return l(p, c, m);
    }, Object.setPrototypeOf(a.prototype, Uint8Array.prototype), Object.setPrototypeOf(a, Uint8Array);
    function f(p) {
      if (typeof p != "number")
        throw new TypeError('"size" argument must be of type number');
      if (p < 0)
        throw new RangeError('The value "' + p + '" is invalid for option "size"');
    }
    function u(p, c, m) {
      return f(p), p <= 0 ? s(p) : c !== void 0 ? typeof m == "string" ? s(p).fill(c, m) : s(p).fill(c) : s(p);
    }
    a.alloc = function(p, c, m) {
      return u(p, c, m);
    };
    function h(p) {
      return f(p), s(p < 0 ? 0 : _(p) | 0);
    }
    a.allocUnsafe = function(p) {
      return h(p);
    }, a.allocUnsafeSlow = function(p) {
      return h(p);
    };
    function E(p, c) {
      if ((typeof c != "string" || c === "") && (c = "utf8"), !a.isEncoding(c))
        throw new TypeError("Unknown encoding: " + c);
      var m = w(p, c) | 0, T = s(m), S = T.write(p, c);
      return S !== m && (T = T.slice(0, S)), T;
    }
    function d(p) {
      for (var c = p.length < 0 ? 0 : _(p.length) | 0, m = s(c), T = 0; T < c; T += 1)
        m[T] = p[T] & 255;
      return m;
    }
    function g(p) {
      if (Re(p, Uint8Array)) {
        var c = new Uint8Array(p);
        return y(c.buffer, c.byteOffset, c.byteLength);
      }
      return d(p);
    }
    function y(p, c, m) {
      if (c < 0 || p.byteLength < c)
        throw new RangeError('"offset" is outside of buffer bounds');
      if (p.byteLength < c + (m || 0))
        throw new RangeError('"length" is outside of buffer bounds');
      var T;
      return c === void 0 && m === void 0 ? T = new Uint8Array(p) : m === void 0 ? T = new Uint8Array(p, c) : T = new Uint8Array(p, c, m), Object.setPrototypeOf(T, a.prototype), T;
    }
    function b(p) {
      if (a.isBuffer(p)) {
        var c = _(p.length) | 0, m = s(c);
        return m.length === 0 || p.copy(m, 0, 0, c), m;
      }
      if (p.length !== void 0)
        return typeof p.length != "number" || gt(p.length) ? s(0) : d(p);
      if (p.type === "Buffer" && Array.isArray(p.data))
        return d(p.data);
    }
    function _(p) {
      if (p >= i)
        throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + i.toString(16) + " bytes");
      return p | 0;
    }
    function I(p) {
      return +p != p && (p = 0), a.alloc(+p);
    }
    a.isBuffer = function(c) {
      return c != null && c._isBuffer === !0 && c !== a.prototype;
    }, a.compare = function(c, m) {
      if (Re(c, Uint8Array) && (c = a.from(c, c.offset, c.byteLength)), Re(m, Uint8Array) && (m = a.from(m, m.offset, m.byteLength)), !a.isBuffer(c) || !a.isBuffer(m))
        throw new TypeError(
          'The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array'
        );
      if (c === m) return 0;
      for (var T = c.length, S = m.length, j = 0, W = Math.min(T, S); j < W; ++j)
        if (c[j] !== m[j]) {
          T = c[j], S = m[j];
          break;
        }
      return T < S ? -1 : S < T ? 1 : 0;
    }, a.isEncoding = function(c) {
      switch (String(c).toLowerCase()) {
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return !0;
        default:
          return !1;
      }
    }, a.concat = function(c, m) {
      if (!Array.isArray(c))
        throw new TypeError('"list" argument must be an Array of Buffers');
      if (c.length === 0)
        return a.alloc(0);
      var T;
      if (m === void 0)
        for (m = 0, T = 0; T < c.length; ++T)
          m += c[T].length;
      var S = a.allocUnsafe(m), j = 0;
      for (T = 0; T < c.length; ++T) {
        var W = c[T];
        if (Re(W, Uint8Array))
          j + W.length > S.length ? a.from(W).copy(S, j) : Uint8Array.prototype.set.call(
            S,
            W,
            j
          );
        else if (a.isBuffer(W))
          W.copy(S, j);
        else
          throw new TypeError('"list" argument must be an Array of Buffers');
        j += W.length;
      }
      return S;
    };
    function w(p, c) {
      if (a.isBuffer(p))
        return p.length;
      if (ArrayBuffer.isView(p) || Re(p, ArrayBuffer))
        return p.byteLength;
      if (typeof p != "string")
        throw new TypeError(
          'The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof p
        );
      var m = p.length, T = arguments.length > 2 && arguments[2] === !0;
      if (!T && m === 0) return 0;
      for (var S = !1; ; )
        switch (c) {
          case "ascii":
          case "latin1":
          case "binary":
            return m;
          case "utf8":
          case "utf-8":
            return Ue(p).length;
          case "ucs2":
          case "ucs-2":
          case "utf16le":
          case "utf-16le":
            return m * 2;
          case "hex":
            return m >>> 1;
          case "base64":
            return Le(p).length;
          default:
            if (S)
              return T ? -1 : Ue(p).length;
            c = ("" + c).toLowerCase(), S = !0;
        }
    }
    a.byteLength = w;
    function L(p, c, m) {
      var T = !1;
      if ((c === void 0 || c < 0) && (c = 0), c > this.length || ((m === void 0 || m > this.length) && (m = this.length), m <= 0) || (m >>>= 0, c >>>= 0, m <= c))
        return "";
      for (p || (p = "utf8"); ; )
        switch (p) {
          case "hex":
            return Q(this, c, m);
          case "utf8":
          case "utf-8":
            return q(this, c, m);
          case "ascii":
            return Z(this, c, m);
          case "latin1":
          case "binary":
            return G(this, c, m);
          case "base64":
            return ae(this, c, m);
          case "ucs2":
          case "ucs-2":
          case "utf16le":
          case "utf-16le":
            return K(this, c, m);
          default:
            if (T) throw new TypeError("Unknown encoding: " + p);
            p = (p + "").toLowerCase(), T = !0;
        }
    }
    a.prototype._isBuffer = !0;
    function R(p, c, m) {
      var T = p[c];
      p[c] = p[m], p[m] = T;
    }
    a.prototype.swap16 = function() {
      var c = this.length;
      if (c % 2 !== 0)
        throw new RangeError("Buffer size must be a multiple of 16-bits");
      for (var m = 0; m < c; m += 2)
        R(this, m, m + 1);
      return this;
    }, a.prototype.swap32 = function() {
      var c = this.length;
      if (c % 4 !== 0)
        throw new RangeError("Buffer size must be a multiple of 32-bits");
      for (var m = 0; m < c; m += 4)
        R(this, m, m + 3), R(this, m + 1, m + 2);
      return this;
    }, a.prototype.swap64 = function() {
      var c = this.length;
      if (c % 8 !== 0)
        throw new RangeError("Buffer size must be a multiple of 64-bits");
      for (var m = 0; m < c; m += 8)
        R(this, m, m + 7), R(this, m + 1, m + 6), R(this, m + 2, m + 5), R(this, m + 3, m + 4);
      return this;
    }, a.prototype.toString = function() {
      var c = this.length;
      return c === 0 ? "" : arguments.length === 0 ? q(this, 0, c) : L.apply(this, arguments);
    }, a.prototype.toLocaleString = a.prototype.toString, a.prototype.equals = function(c) {
      if (!a.isBuffer(c)) throw new TypeError("Argument must be a Buffer");
      return this === c ? !0 : a.compare(this, c) === 0;
    }, a.prototype.inspect = function() {
      var c = "", m = e.INSPECT_MAX_BYTES;
      return c = this.toString("hex", 0, m).replace(/(.{2})/g, "$1 ").trim(), this.length > m && (c += " ... "), "<Buffer " + c + ">";
    }, n && (a.prototype[n] = a.prototype.inspect), a.prototype.compare = function(c, m, T, S, j) {
      if (Re(c, Uint8Array) && (c = a.from(c, c.offset, c.byteLength)), !a.isBuffer(c))
        throw new TypeError(
          'The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof c
        );
      if (m === void 0 && (m = 0), T === void 0 && (T = c ? c.length : 0), S === void 0 && (S = 0), j === void 0 && (j = this.length), m < 0 || T > c.length || S < 0 || j > this.length)
        throw new RangeError("out of range index");
      if (S >= j && m >= T)
        return 0;
      if (S >= j)
        return -1;
      if (m >= T)
        return 1;
      if (m >>>= 0, T >>>= 0, S >>>= 0, j >>>= 0, this === c) return 0;
      for (var W = j - S, ue = T - m, be = Math.min(W, ue), me = this.slice(S, j), we = c.slice(m, T), Oe = 0; Oe < be; ++Oe)
        if (me[Oe] !== we[Oe]) {
          W = me[Oe], ue = we[Oe];
          break;
        }
      return W < ue ? -1 : ue < W ? 1 : 0;
    };
    function D(p, c, m, T, S) {
      if (p.length === 0) return -1;
      if (typeof m == "string" ? (T = m, m = 0) : m > 2147483647 ? m = 2147483647 : m < -2147483648 && (m = -2147483648), m = +m, gt(m) && (m = S ? 0 : p.length - 1), m < 0 && (m = p.length + m), m >= p.length) {
        if (S) return -1;
        m = p.length - 1;
      } else if (m < 0)
        if (S) m = 0;
        else return -1;
      if (typeof c == "string" && (c = a.from(c, T)), a.isBuffer(c))
        return c.length === 0 ? -1 : P(p, c, m, T, S);
      if (typeof c == "number")
        return c = c & 255, typeof Uint8Array.prototype.indexOf == "function" ? S ? Uint8Array.prototype.indexOf.call(p, c, m) : Uint8Array.prototype.lastIndexOf.call(p, c, m) : P(p, [c], m, T, S);
      throw new TypeError("val must be string, number or Buffer");
    }
    function P(p, c, m, T, S) {
      var j = 1, W = p.length, ue = c.length;
      if (T !== void 0 && (T = String(T).toLowerCase(), T === "ucs2" || T === "ucs-2" || T === "utf16le" || T === "utf-16le")) {
        if (p.length < 2 || c.length < 2)
          return -1;
        j = 2, W /= 2, ue /= 2, m /= 2;
      }
      function be(H, te) {
        return j === 1 ? H[te] : H.readUInt16BE(te * j);
      }
      var me;
      if (S) {
        var we = -1;
        for (me = m; me < W; me++)
          if (be(p, me) === be(c, we === -1 ? 0 : me - we)) {
            if (we === -1 && (we = me), me - we + 1 === ue) return we * j;
          } else
            we !== -1 && (me -= me - we), we = -1;
      } else
        for (m + ue > W && (m = W - ue), me = m; me >= 0; me--) {
          for (var Oe = !0, Ut = 0; Ut < ue; Ut++)
            if (be(p, me + Ut) !== be(c, Ut)) {
              Oe = !1;
              break;
            }
          if (Oe) return me;
        }
      return -1;
    }
    a.prototype.includes = function(c, m, T) {
      return this.indexOf(c, m, T) !== -1;
    }, a.prototype.indexOf = function(c, m, T) {
      return D(this, c, m, T, !0);
    }, a.prototype.lastIndexOf = function(c, m, T) {
      return D(this, c, m, T, !1);
    };
    function O(p, c, m, T) {
      m = Number(m) || 0;
      var S = p.length - m;
      T ? (T = Number(T), T > S && (T = S)) : T = S;
      var j = c.length;
      T > j / 2 && (T = j / 2);
      for (var W = 0; W < T; ++W) {
        var ue = parseInt(c.substr(W * 2, 2), 16);
        if (gt(ue)) return W;
        p[m + W] = ue;
      }
      return W;
    }
    function F(p, c, m, T) {
      return De(Ue(c, p.length - m), p, m, T);
    }
    function U(p, c, m, T) {
      return De(Fe(c), p, m, T);
    }
    function z(p, c, m, T) {
      return De(Le(c), p, m, T);
    }
    function V(p, c, m, T) {
      return De(_e(c, p.length - m), p, m, T);
    }
    a.prototype.write = function(c, m, T, S) {
      if (m === void 0)
        S = "utf8", T = this.length, m = 0;
      else if (T === void 0 && typeof m == "string")
        S = m, T = this.length, m = 0;
      else if (isFinite(m))
        m = m >>> 0, isFinite(T) ? (T = T >>> 0, S === void 0 && (S = "utf8")) : (S = T, T = void 0);
      else
        throw new Error(
          "Buffer.write(string, encoding, offset[, length]) is no longer supported"
        );
      var j = this.length - m;
      if ((T === void 0 || T > j) && (T = j), c.length > 0 && (T < 0 || m < 0) || m > this.length)
        throw new RangeError("Attempt to write outside buffer bounds");
      S || (S = "utf8");
      for (var W = !1; ; )
        switch (S) {
          case "hex":
            return O(this, c, m, T);
          case "utf8":
          case "utf-8":
            return F(this, c, m, T);
          case "ascii":
          case "latin1":
          case "binary":
            return U(this, c, m, T);
          case "base64":
            return z(this, c, m, T);
          case "ucs2":
          case "ucs-2":
          case "utf16le":
          case "utf-16le":
            return V(this, c, m, T);
          default:
            if (W) throw new TypeError("Unknown encoding: " + S);
            S = ("" + S).toLowerCase(), W = !0;
        }
    }, a.prototype.toJSON = function() {
      return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
      };
    };
    function ae(p, c, m) {
      return c === 0 && m === p.length ? t.fromByteArray(p) : t.fromByteArray(p.slice(c, m));
    }
    function q(p, c, m) {
      m = Math.min(p.length, m);
      for (var T = [], S = c; S < m; ) {
        var j = p[S], W = null, ue = j > 239 ? 4 : j > 223 ? 3 : j > 191 ? 2 : 1;
        if (S + ue <= m) {
          var be, me, we, Oe;
          switch (ue) {
            case 1:
              j < 128 && (W = j);
              break;
            case 2:
              be = p[S + 1], (be & 192) === 128 && (Oe = (j & 31) << 6 | be & 63, Oe > 127 && (W = Oe));
              break;
            case 3:
              be = p[S + 1], me = p[S + 2], (be & 192) === 128 && (me & 192) === 128 && (Oe = (j & 15) << 12 | (be & 63) << 6 | me & 63, Oe > 2047 && (Oe < 55296 || Oe > 57343) && (W = Oe));
              break;
            case 4:
              be = p[S + 1], me = p[S + 2], we = p[S + 3], (be & 192) === 128 && (me & 192) === 128 && (we & 192) === 128 && (Oe = (j & 15) << 18 | (be & 63) << 12 | (me & 63) << 6 | we & 63, Oe > 65535 && Oe < 1114112 && (W = Oe));
          }
        }
        W === null ? (W = 65533, ue = 1) : W > 65535 && (W -= 65536, T.push(W >>> 10 & 1023 | 55296), W = 56320 | W & 1023), T.push(W), S += ue;
      }
      return B(T);
    }
    var x = 4096;
    function B(p) {
      var c = p.length;
      if (c <= x)
        return String.fromCharCode.apply(String, p);
      for (var m = "", T = 0; T < c; )
        m += String.fromCharCode.apply(
          String,
          p.slice(T, T += x)
        );
      return m;
    }
    function Z(p, c, m) {
      var T = "";
      m = Math.min(p.length, m);
      for (var S = c; S < m; ++S)
        T += String.fromCharCode(p[S] & 127);
      return T;
    }
    function G(p, c, m) {
      var T = "";
      m = Math.min(p.length, m);
      for (var S = c; S < m; ++S)
        T += String.fromCharCode(p[S]);
      return T;
    }
    function Q(p, c, m) {
      var T = p.length;
      (!c || c < 0) && (c = 0), (!m || m < 0 || m > T) && (m = T);
      for (var S = "", j = c; j < m; ++j)
        S += ti[p[j]];
      return S;
    }
    function K(p, c, m) {
      for (var T = p.slice(c, m), S = "", j = 0; j < T.length - 1; j += 2)
        S += String.fromCharCode(T[j] + T[j + 1] * 256);
      return S;
    }
    a.prototype.slice = function(c, m) {
      var T = this.length;
      c = ~~c, m = m === void 0 ? T : ~~m, c < 0 ? (c += T, c < 0 && (c = 0)) : c > T && (c = T), m < 0 ? (m += T, m < 0 && (m = 0)) : m > T && (m = T), m < c && (m = c);
      var S = this.subarray(c, m);
      return Object.setPrototypeOf(S, a.prototype), S;
    };
    function ee(p, c, m) {
      if (p % 1 !== 0 || p < 0) throw new RangeError("offset is not uint");
      if (p + c > m) throw new RangeError("Trying to access beyond buffer length");
    }
    a.prototype.readUintLE = a.prototype.readUIntLE = function(c, m, T) {
      c = c >>> 0, m = m >>> 0, T || ee(c, m, this.length);
      for (var S = this[c], j = 1, W = 0; ++W < m && (j *= 256); )
        S += this[c + W] * j;
      return S;
    }, a.prototype.readUintBE = a.prototype.readUIntBE = function(c, m, T) {
      c = c >>> 0, m = m >>> 0, T || ee(c, m, this.length);
      for (var S = this[c + --m], j = 1; m > 0 && (j *= 256); )
        S += this[c + --m] * j;
      return S;
    }, a.prototype.readUint8 = a.prototype.readUInt8 = function(c, m) {
      return c = c >>> 0, m || ee(c, 1, this.length), this[c];
    }, a.prototype.readUint16LE = a.prototype.readUInt16LE = function(c, m) {
      return c = c >>> 0, m || ee(c, 2, this.length), this[c] | this[c + 1] << 8;
    }, a.prototype.readUint16BE = a.prototype.readUInt16BE = function(c, m) {
      return c = c >>> 0, m || ee(c, 2, this.length), this[c] << 8 | this[c + 1];
    }, a.prototype.readUint32LE = a.prototype.readUInt32LE = function(c, m) {
      return c = c >>> 0, m || ee(c, 4, this.length), (this[c] | this[c + 1] << 8 | this[c + 2] << 16) + this[c + 3] * 16777216;
    }, a.prototype.readUint32BE = a.prototype.readUInt32BE = function(c, m) {
      return c = c >>> 0, m || ee(c, 4, this.length), this[c] * 16777216 + (this[c + 1] << 16 | this[c + 2] << 8 | this[c + 3]);
    }, a.prototype.readIntLE = function(c, m, T) {
      c = c >>> 0, m = m >>> 0, T || ee(c, m, this.length);
      for (var S = this[c], j = 1, W = 0; ++W < m && (j *= 256); )
        S += this[c + W] * j;
      return j *= 128, S >= j && (S -= Math.pow(2, 8 * m)), S;
    }, a.prototype.readIntBE = function(c, m, T) {
      c = c >>> 0, m = m >>> 0, T || ee(c, m, this.length);
      for (var S = m, j = 1, W = this[c + --S]; S > 0 && (j *= 256); )
        W += this[c + --S] * j;
      return j *= 128, W >= j && (W -= Math.pow(2, 8 * m)), W;
    }, a.prototype.readInt8 = function(c, m) {
      return c = c >>> 0, m || ee(c, 1, this.length), this[c] & 128 ? (255 - this[c] + 1) * -1 : this[c];
    }, a.prototype.readInt16LE = function(c, m) {
      c = c >>> 0, m || ee(c, 2, this.length);
      var T = this[c] | this[c + 1] << 8;
      return T & 32768 ? T | 4294901760 : T;
    }, a.prototype.readInt16BE = function(c, m) {
      c = c >>> 0, m || ee(c, 2, this.length);
      var T = this[c + 1] | this[c] << 8;
      return T & 32768 ? T | 4294901760 : T;
    }, a.prototype.readInt32LE = function(c, m) {
      return c = c >>> 0, m || ee(c, 4, this.length), this[c] | this[c + 1] << 8 | this[c + 2] << 16 | this[c + 3] << 24;
    }, a.prototype.readInt32BE = function(c, m) {
      return c = c >>> 0, m || ee(c, 4, this.length), this[c] << 24 | this[c + 1] << 16 | this[c + 2] << 8 | this[c + 3];
    }, a.prototype.readFloatLE = function(c, m) {
      return c = c >>> 0, m || ee(c, 4, this.length), r.read(this, c, !0, 23, 4);
    }, a.prototype.readFloatBE = function(c, m) {
      return c = c >>> 0, m || ee(c, 4, this.length), r.read(this, c, !1, 23, 4);
    }, a.prototype.readDoubleLE = function(c, m) {
      return c = c >>> 0, m || ee(c, 8, this.length), r.read(this, c, !0, 52, 8);
    }, a.prototype.readDoubleBE = function(c, m) {
      return c = c >>> 0, m || ee(c, 8, this.length), r.read(this, c, !1, 52, 8);
    };
    function ne(p, c, m, T, S, j) {
      if (!a.isBuffer(p)) throw new TypeError('"buffer" argument must be a Buffer instance');
      if (c > S || c < j) throw new RangeError('"value" argument is out of bounds');
      if (m + T > p.length) throw new RangeError("Index out of range");
    }
    a.prototype.writeUintLE = a.prototype.writeUIntLE = function(c, m, T, S) {
      if (c = +c, m = m >>> 0, T = T >>> 0, !S) {
        var j = Math.pow(2, 8 * T) - 1;
        ne(this, c, m, T, j, 0);
      }
      var W = 1, ue = 0;
      for (this[m] = c & 255; ++ue < T && (W *= 256); )
        this[m + ue] = c / W & 255;
      return m + T;
    }, a.prototype.writeUintBE = a.prototype.writeUIntBE = function(c, m, T, S) {
      if (c = +c, m = m >>> 0, T = T >>> 0, !S) {
        var j = Math.pow(2, 8 * T) - 1;
        ne(this, c, m, T, j, 0);
      }
      var W = T - 1, ue = 1;
      for (this[m + W] = c & 255; --W >= 0 && (ue *= 256); )
        this[m + W] = c / ue & 255;
      return m + T;
    }, a.prototype.writeUint8 = a.prototype.writeUInt8 = function(c, m, T) {
      return c = +c, m = m >>> 0, T || ne(this, c, m, 1, 255, 0), this[m] = c & 255, m + 1;
    }, a.prototype.writeUint16LE = a.prototype.writeUInt16LE = function(c, m, T) {
      return c = +c, m = m >>> 0, T || ne(this, c, m, 2, 65535, 0), this[m] = c & 255, this[m + 1] = c >>> 8, m + 2;
    }, a.prototype.writeUint16BE = a.prototype.writeUInt16BE = function(c, m, T) {
      return c = +c, m = m >>> 0, T || ne(this, c, m, 2, 65535, 0), this[m] = c >>> 8, this[m + 1] = c & 255, m + 2;
    }, a.prototype.writeUint32LE = a.prototype.writeUInt32LE = function(c, m, T) {
      return c = +c, m = m >>> 0, T || ne(this, c, m, 4, 4294967295, 0), this[m + 3] = c >>> 24, this[m + 2] = c >>> 16, this[m + 1] = c >>> 8, this[m] = c & 255, m + 4;
    }, a.prototype.writeUint32BE = a.prototype.writeUInt32BE = function(c, m, T) {
      return c = +c, m = m >>> 0, T || ne(this, c, m, 4, 4294967295, 0), this[m] = c >>> 24, this[m + 1] = c >>> 16, this[m + 2] = c >>> 8, this[m + 3] = c & 255, m + 4;
    }, a.prototype.writeIntLE = function(c, m, T, S) {
      if (c = +c, m = m >>> 0, !S) {
        var j = Math.pow(2, 8 * T - 1);
        ne(this, c, m, T, j - 1, -j);
      }
      var W = 0, ue = 1, be = 0;
      for (this[m] = c & 255; ++W < T && (ue *= 256); )
        c < 0 && be === 0 && this[m + W - 1] !== 0 && (be = 1), this[m + W] = (c / ue >> 0) - be & 255;
      return m + T;
    }, a.prototype.writeIntBE = function(c, m, T, S) {
      if (c = +c, m = m >>> 0, !S) {
        var j = Math.pow(2, 8 * T - 1);
        ne(this, c, m, T, j - 1, -j);
      }
      var W = T - 1, ue = 1, be = 0;
      for (this[m + W] = c & 255; --W >= 0 && (ue *= 256); )
        c < 0 && be === 0 && this[m + W + 1] !== 0 && (be = 1), this[m + W] = (c / ue >> 0) - be & 255;
      return m + T;
    }, a.prototype.writeInt8 = function(c, m, T) {
      return c = +c, m = m >>> 0, T || ne(this, c, m, 1, 127, -128), c < 0 && (c = 255 + c + 1), this[m] = c & 255, m + 1;
    }, a.prototype.writeInt16LE = function(c, m, T) {
      return c = +c, m = m >>> 0, T || ne(this, c, m, 2, 32767, -32768), this[m] = c & 255, this[m + 1] = c >>> 8, m + 2;
    }, a.prototype.writeInt16BE = function(c, m, T) {
      return c = +c, m = m >>> 0, T || ne(this, c, m, 2, 32767, -32768), this[m] = c >>> 8, this[m + 1] = c & 255, m + 2;
    }, a.prototype.writeInt32LE = function(c, m, T) {
      return c = +c, m = m >>> 0, T || ne(this, c, m, 4, 2147483647, -2147483648), this[m] = c & 255, this[m + 1] = c >>> 8, this[m + 2] = c >>> 16, this[m + 3] = c >>> 24, m + 4;
    }, a.prototype.writeInt32BE = function(c, m, T) {
      return c = +c, m = m >>> 0, T || ne(this, c, m, 4, 2147483647, -2147483648), c < 0 && (c = 4294967295 + c + 1), this[m] = c >>> 24, this[m + 1] = c >>> 16, this[m + 2] = c >>> 8, this[m + 3] = c & 255, m + 4;
    };
    function re(p, c, m, T, S, j) {
      if (m + T > p.length) throw new RangeError("Index out of range");
      if (m < 0) throw new RangeError("Index out of range");
    }
    function Ae(p, c, m, T, S) {
      return c = +c, m = m >>> 0, S || re(p, c, m, 4), r.write(p, c, m, T, 23, 4), m + 4;
    }
    a.prototype.writeFloatLE = function(c, m, T) {
      return Ae(this, c, m, !0, T);
    }, a.prototype.writeFloatBE = function(c, m, T) {
      return Ae(this, c, m, !1, T);
    };
    function ge(p, c, m, T, S) {
      return c = +c, m = m >>> 0, S || re(p, c, m, 8), r.write(p, c, m, T, 52, 8), m + 8;
    }
    a.prototype.writeDoubleLE = function(c, m, T) {
      return ge(this, c, m, !0, T);
    }, a.prototype.writeDoubleBE = function(c, m, T) {
      return ge(this, c, m, !1, T);
    }, a.prototype.copy = function(c, m, T, S) {
      if (!a.isBuffer(c)) throw new TypeError("argument should be a Buffer");
      if (T || (T = 0), !S && S !== 0 && (S = this.length), m >= c.length && (m = c.length), m || (m = 0), S > 0 && S < T && (S = T), S === T || c.length === 0 || this.length === 0) return 0;
      if (m < 0)
        throw new RangeError("targetStart out of bounds");
      if (T < 0 || T >= this.length) throw new RangeError("Index out of range");
      if (S < 0) throw new RangeError("sourceEnd out of bounds");
      S > this.length && (S = this.length), c.length - m < S - T && (S = c.length - m + T);
      var j = S - T;
      return this === c && typeof Uint8Array.prototype.copyWithin == "function" ? this.copyWithin(m, T, S) : Uint8Array.prototype.set.call(
        c,
        this.subarray(T, S),
        m
      ), j;
    }, a.prototype.fill = function(c, m, T, S) {
      if (typeof c == "string") {
        if (typeof m == "string" ? (S = m, m = 0, T = this.length) : typeof T == "string" && (S = T, T = this.length), S !== void 0 && typeof S != "string")
          throw new TypeError("encoding must be a string");
        if (typeof S == "string" && !a.isEncoding(S))
          throw new TypeError("Unknown encoding: " + S);
        if (c.length === 1) {
          var j = c.charCodeAt(0);
          (S === "utf8" && j < 128 || S === "latin1") && (c = j);
        }
      } else typeof c == "number" ? c = c & 255 : typeof c == "boolean" && (c = Number(c));
      if (m < 0 || this.length < m || this.length < T)
        throw new RangeError("Out of range index");
      if (T <= m)
        return this;
      m = m >>> 0, T = T === void 0 ? this.length : T >>> 0, c || (c = 0);
      var W;
      if (typeof c == "number")
        for (W = m; W < T; ++W)
          this[W] = c;
      else {
        var ue = a.isBuffer(c) ? c : a.from(c, S), be = ue.length;
        if (be === 0)
          throw new TypeError('The value "' + c + '" is invalid for argument "value"');
        for (W = 0; W < T - m; ++W)
          this[W + m] = ue[W % be];
      }
      return this;
    };
    var Ne = /[^+/0-9A-Za-z-_]/g;
    function We(p) {
      if (p = p.split("=")[0], p = p.trim().replace(Ne, ""), p.length < 2) return "";
      for (; p.length % 4 !== 0; )
        p = p + "=";
      return p;
    }
    function Ue(p, c) {
      c = c || 1 / 0;
      for (var m, T = p.length, S = null, j = [], W = 0; W < T; ++W) {
        if (m = p.charCodeAt(W), m > 55295 && m < 57344) {
          if (!S) {
            if (m > 56319) {
              (c -= 3) > -1 && j.push(239, 191, 189);
              continue;
            } else if (W + 1 === T) {
              (c -= 3) > -1 && j.push(239, 191, 189);
              continue;
            }
            S = m;
            continue;
          }
          if (m < 56320) {
            (c -= 3) > -1 && j.push(239, 191, 189), S = m;
            continue;
          }
          m = (S - 55296 << 10 | m - 56320) + 65536;
        } else S && (c -= 3) > -1 && j.push(239, 191, 189);
        if (S = null, m < 128) {
          if ((c -= 1) < 0) break;
          j.push(m);
        } else if (m < 2048) {
          if ((c -= 2) < 0) break;
          j.push(
            m >> 6 | 192,
            m & 63 | 128
          );
        } else if (m < 65536) {
          if ((c -= 3) < 0) break;
          j.push(
            m >> 12 | 224,
            m >> 6 & 63 | 128,
            m & 63 | 128
          );
        } else if (m < 1114112) {
          if ((c -= 4) < 0) break;
          j.push(
            m >> 18 | 240,
            m >> 12 & 63 | 128,
            m >> 6 & 63 | 128,
            m & 63 | 128
          );
        } else
          throw new Error("Invalid code point");
      }
      return j;
    }
    function Fe(p) {
      for (var c = [], m = 0; m < p.length; ++m)
        c.push(p.charCodeAt(m) & 255);
      return c;
    }
    function _e(p, c) {
      for (var m, T, S, j = [], W = 0; W < p.length && !((c -= 2) < 0); ++W)
        m = p.charCodeAt(W), T = m >> 8, S = m % 256, j.push(S), j.push(T);
      return j;
    }
    function Le(p) {
      return t.toByteArray(We(p));
    }
    function De(p, c, m, T) {
      for (var S = 0; S < T && !(S + m >= c.length || S >= p.length); ++S)
        c[S + m] = p[S];
      return S;
    }
    function Re(p, c) {
      return p instanceof c || p != null && p.constructor != null && p.constructor.name != null && p.constructor.name === c.name;
    }
    function gt(p) {
      return p !== p;
    }
    var ti = (function() {
      for (var p = "0123456789abcdef", c = new Array(256), m = 0; m < 16; ++m)
        for (var T = m * 16, S = 0; S < 16; ++S)
          c[T + S] = p[m] + p[S];
      return c;
    })();
  })(Pu)), Pu;
}
var Yo = rz();
const qB = [
  {
    jobId: "job1",
    startTime: "2024-12-18T00:00:00Z",
    createdAt: "2024-12-18T00:00:00.000Z",
    // ISO string
    userId: "user1",
    inputUrl: "https://example.com/input",
    status: "pending",
    issues: 0,
    username: {
      creator: "Username1"
    },
    settings: Pt,
    selection: {
      courses: [],
      studentSetGroups: 0,
      incompleteStudents: 0,
      totalStudents: 0
    }
  }
], HB = [
  {
    jobId: "job2",
    startTime: "2024-11-18T00:00:00Z",
    createdAt: "2024-11-18T00:00:00.000Z",
    // ISO string
    userId: "user1",
    inputUrl: "https://example.com/input",
    status: "completed",
    username: {
      creator: "Username2"
    },
    issues: 5,
    proposalResult: {
      nofStudents: 10,
      nofCompleteStudents: 5
    },
    outputUrl: "gs://example.com/output",
    settings: Pt,
    selection: {
      courses: [],
      studentSetGroups: 0,
      incompleteStudents: 0,
      totalStudents: 0
    }
  }
], YB = [
  {
    jobId: "job3",
    startTime: "2024-10-18T00:00:00Z",
    createdAt: "2024-10-18T00:00:00.000Z",
    // ISO string
    userId: "user1",
    inputUrl: "https://example.com/input",
    status: "allocated",
    username: {
      creator: "Username3",
      allocator: "Username4"
    },
    issues: 5,
    proposalResult: {
      nofStudents: 10,
      nofCompleteStudents: 5
    },
    outputUrl: "gs://example.com/output",
    settings: Pt,
    selection: {
      courses: [],
      studentSetGroups: 0,
      incompleteStudents: 0,
      totalStudents: 0
    },
    allocationResult: {
      userId: "user3",
      time: "2024-11-18T00:00:00Z",
      allocationTime: "2024-11-18T00:00:00.000Z",
      // ISO string
      logId: "logid"
    }
  }
], ZB = [
  {
    jobId: "job1",
    startTime: "2024-12-18T00:00:00Z",
    createdAt: "2024-12-18T00:00:00.000Z",
    // ISO string
    userId: "user1",
    inputUrl: "https://example.com/input",
    status: "pending",
    issues: 0,
    inputData: Yo.Buffer.from("inputData"),
    settings: Pt,
    selection: {
      courses: [],
      studentSetGroups: 0,
      incompleteStudents: 0,
      totalStudents: 0
    }
  }
], JB = [
  {
    jobId: "job2",
    startTime: "2024-11-18T00:00:00Z",
    createdAt: "2024-11-18T00:00:00.000Z",
    // ISO string
    userId: "user1",
    inputUrl: "https://example.com/input",
    status: "completed",
    issues: 5,
    inputData: Yo.Buffer.from("inputData"),
    outputData: Yo.Buffer.from("outputData"),
    proposalResult: {
      nofStudents: 10,
      nofCompleteStudents: 5
    },
    outputUrl: "gs://example.com/output",
    settings: Pt,
    selection: {
      courses: [],
      studentSetGroups: 0,
      incompleteStudents: 0,
      totalStudents: 0
    }
  }
], KB = [
  {
    jobId: "job3",
    startTime: "2024-10-18T00:00:00Z",
    createdAt: "2024-10-18T00:00:00.000Z",
    // ISO string
    userId: "user1",
    inputUrl: "https://example.com/input",
    status: "allocated",
    issues: 5,
    proposalResult: {
      nofStudents: 10,
      nofCompleteStudents: 5
    },
    outputUrl: "gs://example.com/output",
    settings: Pt,
    selection: {
      courses: [],
      studentSetGroups: 0,
      incompleteStudents: 0,
      totalStudents: 0
    },
    allocationResult: {
      failedGroups: {},
      userId: "user3",
      time: "2024-11-18T00:00:00Z",
      allocationTime: "2024-11-18T00:00:00.000Z",
      // ISO string
      logId: "logid"
    },
    inputData: Yo.Buffer.from("input"),
    outputData: Yo.Buffer.from("output")
  }
], CA = {
  server: {
    extId: "SERVER",
    name: "LittleServerTimeZoneName",
    identifier: "Europe/Stockholm",
    offset: "UTC+1"
  },
  user: {
    extId: "USER",
    name: "LittleUserTimeZoneName",
    identifier: "Europe/Stockholm",
    offset: "UTC+1"
  }
}, XB = {
  currentDateTime: {
    local: "2023-08-24 00:00:00",
    timezone: "Europe/Stockholm",
    unix: 1692879672
  },
  offsetDateTime: {
    local: "2023-08-24 00:00:00",
    timezone: "Europe/Stockholm",
    unix: 1692879672
  }
}, QB = [
  {
    id: 1,
    extId: "CET",
    name: "Central European Time",
    timeZone: "CET",
    identifiers: ["Europe/Stockholm"],
    isDefault: !0,
    offset: "UTC+1"
  },
  {
    id: 2,
    extId: "NZT",
    name: "New Zealand Time",
    timeZone: "NZST",
    identifiers: ["Pacific/Auckland"],
    isDefault: !1,
    offset: "UTC+10"
  }
], Be = {
  refSeparator: " ",
  searchable: !1,
  defaultValue: "",
  checkSum: 0,
  categories: [],
  referenceFields: [],
  types: []
}, nz = [
  {
    ...Be,
    id: 101,
    extId: "ext1",
    name: "field1",
    categories: ["Cat 1", "Cat 2"],
    searchable: !0,
    fieldType: C.EFieldType.TEXT,
    mandatory: !0,
    types: [220]
  },
  {
    ...Be,
    id: 102,
    extId: "ext2",
    name: "field2",
    categories: ["Cat 3", "Cat 4", "Cat 5"],
    searchable: !0,
    fieldType: C.EFieldType.SIGNATURE,
    mandatory: !0,
    types: [220]
  },
  {
    ...Be,
    id: 103,
    extId: "ext3",
    name: "field3",
    fieldType: C.EFieldType.TEXT,
    types: [220]
  },
  {
    ...Be,
    id: 104,
    extId: "ext4",
    name: "field4",
    fieldType: C.EFieldType.TEXT,
    types: [220]
  },
  {
    ...Be,
    id: 105,
    extId: "ext5",
    name: "field5",
    fieldType: C.EFieldType.CATEGORY
  },
  {
    ...Be,
    id: 106,
    extId: "ext6",
    name: "field6",
    mandatory: !0,
    fieldType: C.EFieldType.TEXT
  },
  {
    ...Be,
    id: 107,
    extId: "ext7",
    name: "field7",
    fieldType: C.EFieldType.LENGTH
  },
  {
    ...Be,
    id: 108,
    extId: "ext8",
    name: "field8",
    fieldType: C.EFieldType.TEXT
  },
  {
    ...Be,
    id: 109,
    extId: "ext9",
    name: "Max capacity",
    fieldType: C.EFieldType.INTEGER
  },
  {
    ...Be,
    id: 118,
    extId: "ext118",
    name: "Hide group",
    fieldType: C.EFieldType.CHECKBOX
  },
  {
    ...Be,
    id: 110,
    extId: "ext10",
    name: "field10",
    fieldType: C.EFieldType.TEXT
  },
  {
    ...Be,
    id: 111,
    extId: "extActivity",
    name: "Activity",
    fieldType: C.EFieldType.TEXT
  },
  {
    ...Be,
    id: 112,
    extId: "ext12",
    name: "field12",
    fieldType: C.EFieldType.CATEGORY,
    categories: ["SELECT", "NONE", "PREFERENCES"]
  },
  {
    ...Be,
    id: 113,
    extId: "ext13",
    name: "Start date",
    fieldType: C.EFieldType.TEXT
  },
  {
    ...Be,
    id: 114,
    extId: "ext14",
    name: "End date",
    fieldType: C.EFieldType.TEXT
  },
  {
    ...Be,
    id: 115,
    extId: "ext15",
    name: "field15",
    fieldType: C.EFieldType.CATEGORY,
    categories: ["DURING_INTERVAL", "FORCE_OFF", "FORCE_ON"]
  },
  {
    ...Be,
    id: 116,
    extId: "ext16",
    name: "Buffer",
    fieldType: C.EFieldType.TEXT
  },
  {
    ...Be,
    id: 117,
    extId: "ext17",
    name: "field17",
    fieldType: C.EFieldType.TEXT
  },
  {
    ...Be,
    id: 119,
    extId: "ext19",
    name: "field19",
    fieldType: C.EFieldType.TEXT
  },
  {
    ...Be,
    id: 120,
    extId: "ext120",
    name: "field120",
    mandatory: !0,
    fieldType: C.EFieldType.TEXT
  },
  {
    ...Be,
    id: 177,
    extId: "ext177",
    name: "referenceField177",
    fieldType: C.EFieldType.TEXT,
    referenceFields: [106, 119],
    refSeparator: "-"
  },
  {
    ...Be,
    id: 182,
    extId: "ext182",
    name: "field182",
    fieldType: C.EFieldType.CATEGORY,
    categories: ["Man", "Woman"]
  },
  {
    ...Be,
    id: 301,
    extId: "ext301",
    name: "field301",
    mandatory: !0,
    fieldType: C.EFieldType.TEXT
  },
  {
    ...Be,
    id: 401,
    extId: "ext401",
    name: "field401",
    mandatory: !0,
    fieldType: C.EFieldType.TEXT
  },
  {
    ...Be,
    id: 402,
    extId: "ext402",
    name: "field402",
    mandatory: !0,
    fieldType: C.EFieldType.TEXT
  },
  {
    ...Be,
    id: 501,
    extId: "ext501",
    name: "field501",
    mandatory: !0,
    fieldType: C.EFieldType.TEXT
  },
  {
    ...Be,
    id: 502,
    extId: "ext502",
    name: "field502",
    mandatory: !0,
    fieldType: C.EFieldType.TEXT
  },
  {
    ...Be,
    id: 601,
    extId: "ext601",
    name: "field601",
    mandatory: !0,
    fieldType: C.EFieldType.TEXT
  }
], e3 = [1, 2, 3], t3 = [
  { fieldId: 201, values: ["Masters"] },
  { fieldId: 202, values: ["Swedish"] }
], r3 = "Bearer token", n3 = "university", Nt = [
  {
    id: 1,
    extId: "MATH-101",
    active: !0,
    created: 1723782775,
    abstract: !1,
    virtual: !1,
    fields: [
      {
        fieldId: 101,
        values: ["Math 101"]
      },
      {
        fieldId: 102,
        values: ["MATH-101"]
      },
      {
        fieldId: 103,
        values: ["Fall 2023"]
      },
      {
        fieldId: 173,
        values: ["MATH-101-2023"]
      }
    ],
    relations: [
      {
        start: 0,
        end: 0,
        objectIds: [4, 5, 6, 7, 8, 9, 12, 13]
      }
    ],
    members: [],
    types: [201]
  },
  {
    id: 4,
    extId: "OBJECT-1",
    active: !0,
    created: 1723782775,
    abstract: !1,
    virtual: !1,
    fields: [
      {
        fieldId: 106,
        values: ["Object 1"]
      },
      {
        fieldId: 107,
        values: ["200000"]
      },
      {
        fieldId: 109,
        values: ["5"]
      },
      {
        fieldId: 110,
        values: []
      },
      {
        fieldId: 111,
        values: ["GROUP-A"]
      },
      {
        fieldId: 112,
        values: ["SELECT"]
      },
      {
        fieldId: 113,
        values: ["17/07/2023"]
      },
      {
        fieldId: 114,
        values: ["12/11/2023"]
      },
      {
        fieldId: 115,
        values: ["DURING_INTERVAL"]
      },
      {
        fieldId: 119,
        values: ["1"]
      },
      {
        fieldId: 160,
        values: ["Group 4"]
      }
    ],
    relations: [
      {
        start: 0,
        end: 0,
        objectIds: [10]
      },
      {
        start: 0,
        end: 0,
        objectIds: [6]
      },
      {
        start: 0,
        end: 0,
        objectIds: [1]
      }
    ],
    members: [{ start: 0, end: 0, objectId: 12 }],
    types: [203]
  },
  {
    id: 5,
    extId: "OBJECT-2",
    active: !0,
    created: 1723782775,
    abstract: !1,
    virtual: !1,
    fields: [
      {
        fieldId: 106,
        values: ["Object 2"]
      },
      {
        fieldId: 107,
        values: ["300000"]
      },
      {
        fieldId: 109,
        values: ["5"]
      },
      {
        fieldId: 110,
        values: ["89"]
      },
      {
        fieldId: 111,
        values: ["GROUP-B"]
      },
      {
        fieldId: 112,
        values: ["SELECT"]
      },
      {
        fieldId: 113,
        values: ["17/07/2023"]
      },
      {
        fieldId: 114,
        values: ["12/11/2023"]
      },
      {
        fieldId: 115,
        values: [""]
      },
      {
        fieldId: 116,
        values: ["50%"]
      },
      {
        fieldId: 119,
        values: ["2"]
      },
      {
        fieldId: 160,
        values: ["Group 5"]
      }
    ],
    relations: [
      {
        start: 0,
        end: 0,
        objectIds: [1]
      }
    ],
    members: [
      { start: 0, end: 0, objectId: 12 },
      { start: 0, end: 0, objectId: 13 }
    ],
    types: [203]
  },
  {
    id: 6,
    extId: "OBJECT-3",
    active: !0,
    created: 1723782775,
    abstract: !1,
    virtual: !1,
    fields: [
      {
        fieldId: 106,
        values: ["Object 3"]
      },
      {
        fieldId: 107,
        values: ["400000"]
      },
      {
        fieldId: 109,
        values: ["5"]
      },
      {
        fieldId: 110,
        values: ["12", "89"]
      },
      {
        fieldId: 111,
        values: ["GROUP-B"]
      },
      {
        fieldId: 112,
        values: ["SELECT"]
      },
      {
        fieldId: 113,
        values: ["17/07/2023"]
      },
      {
        fieldId: 114,
        values: ["12/11/2023"]
      },
      {
        fieldId: 115,
        values: [""]
      },
      {
        fieldId: 119,
        values: ["2"]
      },
      {
        fieldId: 160,
        values: ["Group 6"]
      }
    ],
    relations: [
      {
        start: 0,
        end: 0,
        objectIds: [4]
      },
      {
        start: 0,
        end: 0,
        objectIds: [1]
      }
    ],
    types: [203],
    members: []
  },
  {
    id: 7,
    extId: "OBJECT-4",
    active: !0,
    created: 1723782775,
    abstract: !1,
    virtual: !1,
    fields: [
      {
        fieldId: 106,
        values: ["Object 4"]
      },
      {
        fieldId: 107,
        values: ["500000"]
      },
      {
        fieldId: 109,
        values: ["5"]
      },
      {
        fieldId: 110,
        values: []
      },
      {
        fieldId: 111,
        values: ["GROUP-C"]
      },
      {
        fieldId: 112,
        values: ["SELECT"]
      },
      {
        fieldId: 113,
        values: ["17/07/2023"]
      },
      {
        fieldId: 114,
        values: ["12/11/2023"]
      },
      {
        fieldId: 115,
        values: [""]
      },
      {
        fieldId: 119,
        values: ["1"]
      },
      {
        fieldId: 160,
        values: ["Group 7"]
      }
    ],
    relations: [
      {
        start: 0,
        end: 0,
        objectIds: [1]
      }
    ],
    types: [203],
    members: []
  },
  {
    id: 8,
    extId: "OBJECT-5",
    active: !0,
    created: 1723782775,
    abstract: !1,
    virtual: !1,
    fields: [
      {
        fieldId: 106,
        values: ["Object 5"]
      },
      {
        fieldId: 107,
        values: ["500000"]
      },
      {
        fieldId: 109,
        values: ["5"]
      },
      {
        fieldId: 110,
        values: []
      },
      {
        fieldId: 111,
        values: ["GROUP-C"]
      },
      {
        fieldId: 112,
        values: ["SELECT"]
      },
      {
        fieldId: 113,
        values: ["17/07/2023"]
      },
      {
        fieldId: 114,
        values: ["12/11/2023"]
      },
      {
        fieldId: 115,
        values: [""]
      },
      {
        fieldId: 119,
        values: ["2"]
      },
      {
        fieldId: 160,
        values: ["Group 8"]
      }
    ],
    relations: [
      {
        start: 0,
        end: 0,
        objectIds: [1]
      }
    ],
    types: [203],
    members: []
  },
  {
    id: 9,
    extId: "OBJECT-6",
    active: !0,
    created: 1723782775,
    abstract: !1,
    virtual: !1,
    fields: [
      {
        fieldId: 160,
        values: ["Group 9"]
      },
      {
        fieldId: 106,
        values: ["Object 6"]
      },
      {
        fieldId: 107,
        values: ["600000"]
      },
      {
        fieldId: 109,
        values: ["6"]
      },
      {
        fieldId: 110,
        values: []
      },
      {
        fieldId: 111,
        values: ["GROUP-A"]
      },
      {
        fieldId: 112,
        values: ["SELECT"]
      },
      {
        fieldId: 113,
        values: ["17/07/2023"]
      },
      {
        fieldId: 114,
        values: ["12/11/2023"]
      },
      {
        fieldId: 115,
        values: ["DURING_INTERVAL"]
      },
      {
        fieldId: 119,
        values: ["1"]
      }
    ],
    relations: [
      {
        start: 0,
        end: 0,
        objectIds: [1]
      }
    ],
    members: [{ start: 0, end: 0, objectId: 13 }],
    types: [203]
  },
  {
    id: 12,
    extId: "STUDENT-1",
    active: !0,
    created: 1723782775,
    abstract: !1,
    virtual: !1,
    fields: [
      {
        fieldId: 120,
        values: ["Student 1"]
      }
    ],
    relations: [{ start: 0, end: 0, objectIds: [1, 10] }],
    types: [220],
    members: [{ start: 0, end: 0, objectId: 1 }]
  },
  {
    id: 13,
    extId: "STUDENT-2",
    active: !0,
    created: 1723782775,
    abstract: !1,
    virtual: !1,
    fields: [
      {
        fieldId: 120,
        values: ["Student 2"]
      }
    ],
    relations: [{ start: 0, end: 0, objectIds: [1, 10] }],
    types: [220],
    members: [{ start: 0, end: 0, objectId: 1 }]
  },
  {
    id: 10,
    extId: "STEM",
    active: !0,
    created: 1723782775,
    abstract: !1,
    virtual: !1,
    fields: [],
    relations: [
      {
        start: 0,
        end: 0,
        objectIds: [12, 13]
      }
    ],
    members: [],
    types: [204]
  },
  {
    id: 5e3,
    extId: "RoomPart",
    active: !0,
    created: 1723782735,
    abstract: !1,
    virtual: !1,
    fields: [
      {
        fieldId: 501,
        values: ["Lowerpart"]
      }
    ],
    relations: [
      {
        start: 0,
        end: 0,
        objectIds: [12, 13]
      }
    ],
    members: [],
    types: [500]
  },
  {
    id: 6e3,
    extId: "RoomFull",
    active: !0,
    created: 1723782735,
    abstract: !1,
    virtual: !1,
    fields: [
      {
        fieldId: 601,
        values: ["Full room"]
      }
    ],
    relations: [
      {
        start: 0,
        end: 0,
        objectIds: [12, 13]
      }
    ],
    members: [],
    types: [600]
  },
  {
    id: 6001,
    extId: "Partical math course",
    active: !0,
    created: 1723782735,
    abstract: !1,
    virtual: !1,
    fields: [
      {
        fieldId: 601,
        values: ["Partical math course"]
      },
      {
        fieldId: 101,
        values: ["Partical math course label"]
      }
    ],
    relations: [],
    members: [],
    types: [2011]
  },
  {
    id: 6020,
    extId: "Parent computer course",
    active: !0,
    created: 1723782735,
    abstract: !1,
    virtual: !1,
    fields: [
      {
        fieldId: 601,
        values: ["Parent computer course"]
      },
      {
        fieldId: 101,
        values: ["Parent computer courseabel"]
      }
    ],
    relations: [],
    members: [],
    types: [200]
  }
], i3 = {
  201: [4, 5]
}, o3 = [
  {
    id: 201,
    extId: "RESERVATION-MANY_GROUPS",
    begin: 1690444800,
    end: 1690448400,
    objects: [
      { typeId: 203, objectId: 4 },
      { typeId: 203, objectId: 5 }
    ],
    history: {}
  }
], s3 = {
  201: [4, 5]
}, a3 = [
  {
    id: 201,
    extId: "RESERVATION-MANY_GROUPS",
    begin: 1690444800,
    end: 1690448400,
    objects: [
      { typeId: 203, objectId: 4 },
      { typeId: 203, objectId: 5 }
    ],
    history: {}
  },
  {
    id: 900,
    extId: "RESERVATION-STUDENT-ALONE",
    begin: 1690444800,
    end: 1690448400,
    objects: [{ typeId: 910, objectId: 920 }],
    history: {}
  },
  {
    id: 901,
    extId: "RESERVATION-WITHOUT-OBJECT",
    begin: 1690444800,
    end: 1690448400,
    objects: [],
    history: {}
  }
], u3 = {
  301: [4],
  302: [5],
  303: [6],
  304: [7],
  305: [6]
}, l3 = [
  {
    id: 301,
    extId: "RESERVATION-1",
    begin: 1690444800,
    end: 1690448400,
    objects: [{ typeId: 203, objectId: 4 }],
    history: {}
  },
  {
    id: 302,
    extId: "RESERVATION-2",
    begin: 1690446600,
    end: 1690450200,
    objects: [{ typeId: 203, objectId: 5 }],
    history: {}
  },
  {
    id: 303,
    extId: "RESERVATION-3",
    begin: 1690441800,
    end: 1690450200,
    objects: [{ typeId: 203, objectId: 6 }],
    history: {}
  },
  {
    id: 304,
    extId: "RESERVATION-4",
    begin: 1690441800,
    end: 1690445400,
    objects: [{ typeId: 203, objectId: 7 }],
    history: {}
  },
  {
    id: 305,
    extId: "RESERVATION-5",
    begin: 1690450200,
    end: 1690666200,
    objects: [{ typeId: 203, objectId: 6 }],
    history: {}
  }
], c3 = {
  region: gi.ERegion.EU_EES,
  id: "64a7d55ed7f76100238fa0e9",
  type: C.ETokenType.USER,
  username: "root@timeedit.com",
  email: "root@timeedit.com",
  organizationId: "6405a438ddd66a00221435f7",
  customerSignature: "cloud_timeedit_ab",
  appPermissions: [],
  scopes: [cr.REGISTRATION.USER, cr.ALLOCATE.ADMIN, cr.ROOT],
  organizationsAndRoles: [],
  iat: 1691662122,
  exp: 1723219722
}, f3 = {
  region: gi.ERegion.EU_EES,
  id: "64a7d55ed7f76100238fa0e9",
  type: C.ETokenType.USER,
  username: "consume.test@timeedit.com",
  email: "consume.test@timeedit.com",
  organizationId: "6405a438ddd66a00221435f7",
  customerSignature: "cloud_timeedit_ab",
  appPermissions: [],
  scopes: [cr.REGISTRATION.USER],
  organizationsAndRoles: [],
  iat: 1691662122,
  exp: 1723219722
}, d3 = {
  id: "64a7d55ed7f76100238fa0e9",
  email: "consume.test@timeedit.com",
  firstName: "Consume",
  lastName: "Test",
  profiles: [
    {
      id: "profile-1",
      profileName: "Default",
      organizationsAndRoles: [],
      scopes: [cr.REGISTRATION.USER],
      appPermissions: [],
      userObjects: [],
      inactiveSince: null
    }
  ],
  organizationId: "6405a438ddd66a00221435f7",
  username: "consume.test@timeedit.com",
  scopes: [cr.REGISTRATION.USER],
  appPermissions: [],
  userObjects: [],
  timezone: "Europe/Stockholm"
}, p3 = {
  courses: {
    1: {
      id: 1,
      extId: "MATH-101",
      typeIds: [201],
      label: "Math 101",
      teObject: Nt.find((e) => e.id === 1),
      children: [4, 5, 6, 7]
    }
  },
  activities: {},
  groups: {
    4: {
      id: 4,
      extId: "OBJECT-1",
      typeIds: [203],
      label: "Object 1",
      teObject: Nt.find((e) => e.id === 4),
      parentId: 1,
      links: [6]
    },
    5: {
      id: 5,
      extId: "OBJECT-2",
      typeIds: [203],
      label: "Object 2",
      teObject: Nt.find((e) => e.id === 5),
      parentId: 1,
      links: []
    },
    6: {
      id: 6,
      extId: "OBJECT-3",
      typeIds: [203],
      label: "Object 3",
      teObject: Nt.find((e) => e.id === 6),
      parentId: 1,
      links: [4]
    },
    7: {
      id: 7,
      extId: "OBJECT-4",
      typeIds: [203],
      label: "Object 4",
      teObject: Nt.find((e) => e.id === 7),
      parentId: 1,
      links: []
    },
    8: {
      id: 8,
      extId: "OBJECT-5",
      typeIds: [203],
      label: "Object 5",
      teObject: Nt.find((e) => e.id === 8),
      parentId: 1,
      links: []
    }
  }
}, Cr = {
  courses: {
    1: {
      id: 1,
      extId: "MATH-101",
      typeIds: [201],
      label: "Math 101",
      children: [1460478604, 1460478605, 1460478606],
      teObject: Nt.find((e) => e.id === 1)
    }
  },
  activities: {
    1460478604: {
      id: 1460478604,
      label: "GROUP-A",
      parentId: 1,
      children: [4, 6]
    },
    1460478605: {
      id: 1460478605,
      label: "GROUP-B",
      parentId: 1,
      children: [5]
    },
    1460478606: {
      id: 1460478606,
      label: "GROUP-C",
      parentId: 1,
      children: [7, 8]
    }
  },
  groups: {
    4: {
      id: 4,
      extId: "OBJECT-1",
      typeIds: [203],
      label: "Object 1",
      teObject: Nt.find((e) => e.id === 4),
      parentId: 1460478604,
      links: [6]
    },
    5: {
      id: 5,
      extId: "OBJECT-2",
      typeIds: [203],
      label: "Object 2",
      teObject: Nt.find((e) => e.id === 5),
      parentId: 1460478605,
      links: []
    },
    6: {
      id: 6,
      extId: "OBJECT-3",
      typeIds: [203],
      label: "Object 3",
      teObject: Nt.find((e) => e.id === 6),
      parentId: 1460478604,
      links: [4]
    },
    7: {
      id: 7,
      extId: "OBJECT-4",
      typeIds: [203],
      label: "Object 4",
      teObject: Nt.find((e) => e.id === 7),
      parentId: 1460478606,
      links: []
    },
    8: {
      id: 8,
      extId: "OBJECT-5",
      typeIds: [203],
      label: "Object 5",
      teObject: Nt.find((e) => e.id === 8),
      parentId: 1460478606,
      links: []
    }
  }
}, h3 = {
  studentId: 12,
  timezone: CA,
  events: [],
  conflicts: {},
  courseIds: [1],
  courses: {
    1: {
      ...Cr.courses[1],
      id: 1,
      children: [1460478604, 1460478605, 1460478606],
      open: !0,
      showInRegistration: !0
    }
  },
  activities: {
    1460478604: {
      ...Cr.activities[1460478604],
      id: 1460478604,
      children: [4, 6],
      parentId: 1,
      allocationSignal: "OK",
      open: !0,
      showInRegistration: !0,
      hasConflicts: !1,
      hasWaitlist: !1
    },
    1460478605: {
      ...Cr.activities[1460478605],
      id: 1460478605,
      children: [5],
      parentId: 1,
      allocationSignal: "OK",
      open: !0,
      showInRegistration: !0,
      hasConflicts: !1,
      hasWaitlist: !1
    },
    1460478606: {
      ...Cr.activities[1460478606],
      id: 1460478606,
      children: [7, 8],
      parentId: 1,
      allocationSignal: "ISSUE",
      open: !0,
      showInRegistration: !0,
      hasConflicts: !1,
      hasWaitlist: !1
    }
  },
  groups: {
    4: {
      ...Cr.groups[4],
      id: 4,
      parentId: 1460478604,
      seats: {
        taken: 1,
        available: 4,
        total: 5,
        raw: { taken: 1, available: 4, total: 5, buffer: 0 }
      },
      allocationStatus: "ALLOCATED_TO_THIS",
      open: !0,
      showInRegistration: !0,
      dedicated: {
        kind: "none",
        data: void 0
      },
      hidden: !1,
      matchDedication: !0,
      links: [6],
      waitlistPosition: 0,
      hasStudentsInWaitlist: !1
    },
    5: {
      ...Cr.groups[5],
      id: 5,
      parentId: 1460478605,
      seats: {
        taken: 0,
        available: 5,
        total: 5,
        raw: { taken: 0, available: 5, total: 5, buffer: 0 }
      },
      allocationStatus: "NOT_ALLOCATED",
      open: !0,
      showInRegistration: !0,
      dedicated: {
        kind: "none",
        data: void 0
      },
      hidden: !1,
      matchDedication: !0,
      links: [],
      waitlistPosition: 0,
      hasStudentsInWaitlist: !1
    },
    6: {
      ...Cr.groups[6],
      id: 6,
      parentId: 1460478604,
      seats: {
        taken: 0,
        available: 5,
        total: 5,
        raw: { taken: 0, available: 5, total: 5, buffer: 0 }
      },
      allocationStatus: "NOT_ALLOCATED",
      open: !0,
      showInRegistration: !0,
      dedicated: {
        kind: "none",
        data: void 0
      },
      hidden: !1,
      matchDedication: !0,
      links: [4],
      waitlistPosition: 0,
      hasStudentsInWaitlist: !1
    },
    7: {
      ...Cr.groups[7],
      id: 7,
      parentId: 1460478606,
      seats: {
        taken: 0,
        available: 5,
        total: 5,
        raw: { taken: 0, available: 5, total: 5, buffer: 0 }
      },
      allocationStatus: "NOT_ALLOCATED",
      open: !0,
      showInRegistration: !0,
      dedicated: {
        kind: "none",
        data: void 0
      },
      hidden: !1,
      matchDedication: !0,
      links: [],
      waitlistPosition: 0,
      hasStudentsInWaitlist: !1
    },
    8: {
      ...Cr.groups[8],
      id: 8,
      parentId: 1460478606,
      seats: {
        taken: 0,
        available: 5,
        total: 5,
        raw: { taken: 0, available: 5, total: 5, buffer: 0 }
      },
      allocationStatus: "NOT_ALLOCATED",
      open: !0,
      showInRegistration: !0,
      dedicated: {
        kind: "none",
        data: void 0
      },
      hidden: !1,
      matchDedication: !0,
      links: [],
      waitlistPosition: 0,
      hasStudentsInWaitlist: !1
    }
  }
}, m3 = {
  id: 5,
  extId: "course",
  name: "Course",
  active: !0
}, iz = [
  {
    id: 200,
    extId: "Parent course",
    name: "Parent course",
    active: !0,
    subTypes: [201]
  },
  {
    id: 201,
    extId: "course",
    name: "Course",
    active: !0,
    subTypes: [2011]
  },
  {
    id: 2011,
    extId: "Child course",
    name: "Child course",
    active: !0
  },
  {
    id: 202,
    extId: "activity",
    name: "Activity",
    active: !0
  },
  {
    id: 203,
    extId: "group",
    name: "Group",
    active: !0
  },
  {
    id: 204,
    extId: "program",
    name: "Program",
    active: !0
  },
  {
    id: 220,
    extId: "student",
    name: "Student",
    active: !0
  },
  {
    id: 221,
    extId: "person",
    name: "Person",
    active: !0,
    subTypes: [220]
  },
  {
    id: 222,
    extId: "course_pathway",
    name: "Course Pathway",
    active: !0
  },
  {
    id: 300,
    extId: "something",
    name: "something",
    active: !0
  },
  {
    id: 500,
    extId: "room_part",
    name: "room_part",
    active: !0
  },
  {
    id: 600,
    extId: "room_full",
    name: "room_full",
    active: !0
  }
], oz = [
  {
    id: 1e3,
    memberTypes: [
      {
        type: 201,
        memberLevel: 0
      },
      {
        type: 203,
        memberLevel: 1
      },
      {
        type: 220,
        memberLevel: 2
      }
    ],
    name: "group -> student"
  },
  {
    id: 1001,
    memberTypes: [
      {
        type: 203,
        memberLevel: 0
      },
      {
        type: 221,
        memberLevel: 1
      }
    ],
    name: "group -> person"
  },
  {
    id: 1002,
    memberTypes: [
      {
        type: 204,
        memberLevel: 0
      },
      {
        type: 201,
        memberLevel: 1
      }
    ],
    name: "program -> course"
  }
], E3 = {
  id: 301,
  extId: "RESERVATION-1",
  begin: 1690444800,
  end: 1690448400,
  objects: [{ typeId: 203, objectId: 4 }],
  history: {}
};
function g3(e) {
  return {
    course: [
      {
        id: 200,
        types: [e.getIds("course")[0]]
      }
    ],
    groups: [
      {
        id: 300,
        types: [e.getIds("group")[0]],
        fields: [
          { fieldId: e.getIds("activityType")[0], values: ["Lec"] }
        ],
        relations: [{ end: 0, start: 0, objectIds: [200] }],
        members: []
      },
      {
        id: 301,
        types: [e.getIds("group")[0]],
        fields: [
          { fieldId: e.getIds("activityType")[0], values: ["Tut"] }
        ],
        relations: [{ end: 0, start: 0, objectIds: [200] }],
        members: []
      },
      {
        id: 302,
        types: [e.getIds("group")[0]],
        fields: [
          { fieldId: e.getIds("activityType")[0], values: ["A"] }
        ],
        relations: [
          { end: 0, start: 0, objectIds: [200] },
          { end: 0, start: 0, objectIds: [303] }
        ],
        members: []
      },
      {
        id: 303,
        types: [e.getIds("group")[0]],
        fields: [
          { fieldId: e.getIds("activityType")[0], values: ["Tut"] }
        ],
        relations: [
          { end: 0, start: 0, objectIds: [200] },
          { end: 0, start: 0, objectIds: [302] }
        ],
        members: []
      },
      {
        id: 304,
        types: [e.getIds("group")[0]],
        fields: [
          { fieldId: e.getIds("activityType")[0], values: ["Lec2"] }
        ],
        relations: [
          { end: 0, start: 0, objectIds: [200] },
          { end: 0, start: 0, objectIds: [305] }
        ],
        members: []
      },
      {
        id: 305,
        types: [e.getIds("group")[0]],
        fields: [
          { fieldId: e.getIds("activityType")[0], values: ["Lec2"] }
        ],
        relations: [
          { end: 0, start: 0, objectIds: [200] },
          { end: 0, start: 0, objectIds: [304] }
        ],
        members: []
      },
      {
        id: 306,
        types: [e.getIds("group")[0]],
        fields: [
          { fieldId: e.getIds("activityType")[0], values: ["B"] }
        ],
        relations: [
          { end: 0, start: 0, objectIds: [200] },
          { end: 0, start: 0, objectIds: [307] }
        ],
        members: []
      },
      {
        id: 307,
        types: [e.getIds("group")[0]],
        fields: [
          { fieldId: e.getIds("activityType")[0], values: ["C"] }
        ],
        relations: [
          { end: 0, start: 0, objectIds: [200] },
          { end: 0, start: 0, objectIds: [306] }
        ],
        members: []
      },
      {
        id: 308,
        types: [e.getIds("group")[0]],
        fields: [
          { fieldId: e.getIds("activityType")[0], values: ["D"] }
        ],
        relations: [
          { end: 0, start: 0, objectIds: [200] },
          { end: 0, start: 0, objectIds: [309] }
        ],
        members: []
      },
      {
        id: 309,
        types: [e.getIds("group")[0]],
        fields: [
          { fieldId: e.getIds("activityType")[0], values: ["E"] }
        ],
        relations: [
          { end: 0, start: 0, objectIds: [200] },
          { end: 0, start: 0, objectIds: [308] }
        ],
        members: []
      }
    ]
  };
}
const y3 = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIxMjM0NTY3ODkwIn0.dozjgNryP4J3jVmNHl0w5N_XgL0n3I9PlFUP0THsR8U", ea = {
  id: 2,
  extId: "Course 2",
  active: !0,
  abstract: !0,
  fields: [
    {
      fieldId: 101,
      values: ["Course 2"]
    }
  ],
  relations: [
    {
      start: 0,
      end: 0,
      objectIds: [4, 5, 6, 7]
    }
  ],
  members: [],
  types: [201],
  property: C.EProperty.STANDARD,
  personalInformation: C.EPersonalInformation.STANDARD,
  created: 1e7,
  createdBy: "",
  history: [],
  availabilityRelations: [],
  optionalRelations: [],
  organizations: [],
  color: "",
  virtual: !0
}, $t = {
  id: 4,
  extId: "4",
  typeIds: [100],
  parentId: 7,
  label: "Group 4",
  links: [],
  teObject: {
    ...ea,
    fields: [
      {
        fieldId: 106,
        values: ["Exam"]
      }
    ],
    id: 4,
    extId: "4"
  }
}, hi = {
  ...$t,
  allocationStatus: "NOT_ALLOCATED",
  seats: {
    taken: 0,
    available: 5,
    total: 0,
    raw: {
      buffer: 0,
      taken: 0,
      available: 5,
      total: 0
    }
  },
  open: !1,
  showInRegistration: !0,
  dedicated: {
    kind: "none",
    data: void 0
  },
  hidden: !1,
  matchDedication: !0,
  waitlistPosition: 0,
  hasStudentsInWaitlist: !1
}, PA = {
  id: 7,
  label: "Lesson",
  parentId: 2,
  children: []
}, _l = {
  ...PA,
  allocationSignal: "ISSUE",
  open: !1,
  showInRegistration: !0,
  hasConflicts: !1,
  hasWaitlist: !1
}, DA = {
  id: 2,
  extId: "2",
  typeIds: [50],
  label: "Science",
  teObject: {
    ...ea,
    fields: [
      {
        fieldId: 101,
        values: ["Science"]
      }
    ],
    extId: "2",
    id: 2
  },
  children: [7]
}, Rl = {
  ...DA,
  open: !1,
  showInRegistration: !0
}, sz = {
  courses: {
    2: {
      id: 2,
      extId: "2",
      typeIds: [50],
      label: "Course 2",
      teObject: {
        ...ea,
        fields: [
          {
            fieldId: 101,
            values: ["Science"]
          }
        ],
        id: 2,
        extId: "2"
      },
      children: [7]
    },
    3: {
      id: 3,
      extId: "3",
      typeIds: [50],
      label: "Course 3",
      teObject: {
        ...ea,
        fields: [
          {
            fieldId: 101,
            values: ["Math"]
          }
        ],
        id: 3,
        extId: "3"
      },
      children: [10]
    }
  },
  activities: {
    7: {
      id: 7,
      label: "Lesson",
      parentId: 2,
      children: [1, 5, 11, 13]
    },
    10: {
      id: 10,
      label: "Lab",
      parentId: 3,
      children: [8]
    }
  },
  groups: {
    1: {
      ...$t,
      id: 1,
      extId: "1",
      typeIds: [100],
      parentId: 7,
      teObject: {
        ...$t.teObject,
        id: 1,
        extId: "1"
      }
    },
    5: {
      ...$t,
      id: 5,
      extId: "5",
      typeIds: [100],
      parentId: 7,
      teObject: {
        ...$t.teObject,
        id: 5,
        extId: "5"
      }
    },
    8: {
      ...$t,
      id: 8,
      extId: "8",
      typeIds: [100],
      parentId: 10,
      teObject: {
        ...$t.teObject,
        id: 8,
        extId: "8"
      }
    },
    11: {
      ...$t,
      id: 11,
      extId: "11",
      parentId: 7,
      typeIds: [100],
      teObject: {
        ...$t.teObject,
        id: 11,
        extId: "11"
      }
    },
    13: {
      ...$t,
      id: 13,
      extId: "13",
      typeIds: [100],
      parentId: 7,
      teObject: {
        ...$t.teObject,
        id: 13,
        extId: "13"
      }
    }
  }
}, az = {
  courseIds: [2, 3],
  courses: {
    2: {
      ...Rl,
      id: 2,
      children: [7]
    },
    3: {
      ...Rl,
      id: 3,
      children: [10]
    }
  },
  activities: {
    7: {
      ..._l,
      id: 7,
      parentId: 2,
      children: [1, 5, 11, 13],
      allocationSignal: "OK"
    },
    10: {
      ..._l,
      id: 10,
      parentId: 3,
      children: [8],
      allocationSignal: "ISSUE"
    }
  },
  groups: {
    1: {
      ...hi,
      id: 1,
      parentId: 7,
      allocationStatus: "ALLOCATED_TO_THIS"
    },
    5: {
      ...hi,
      id: 5,
      parentId: 7,
      allocationStatus: "NOT_ALLOCATED"
    },
    8: {
      ...hi,
      id: 8,
      parentId: 10,
      allocationStatus: "NOT_ALLOCATED",
      seats: {
        taken: 0,
        available: 5,
        total: 0,
        raw: {
          taken: 0,
          available: 5,
          total: 0,
          buffer: 0
        }
      }
    },
    11: {
      ...hi,
      id: 11,
      parentId: 7,
      allocationStatus: "NOT_ALLOCATED",
      seats: {
        taken: 0,
        available: 5,
        total: 0,
        raw: {
          taken: 0,
          available: 5,
          total: 0,
          buffer: 0
        }
      }
    },
    13: {
      ...hi,
      id: 13,
      parentId: 7,
      allocationStatus: "NOT_ALLOCATED",
      seats: {
        taken: 0,
        available: 5,
        total: 0,
        raw: {
          taken: 0,
          available: 5,
          total: 0,
          buffer: 0
        }
      }
    }
  },
  events: [],
  conflicts: {},
  timezone: CA,
  studentId: 12
}, T3 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  _mockCatalog: sz,
  _mockRegistration: az,
  exampleCatalogActivityParams: PA,
  exampleCatalogCourseParams: DA,
  exampleCatalogGroupParams: $t,
  exampleRegistrationActivityParams: _l,
  exampleRegistrationCourseParams: Rl,
  exampleRegistrationGroupParams: hi
}, Symbol.toStringTag, { value: "Module" })), b3 = [
  {
    id: 1,
    name: "Field With Categories",
    extId: "f1",
    searchable: !1,
    referenceFields: [],
    types: [],
    fieldType: "",
    refSeparator: void 0,
    defaultValue: void 0,
    checkSum: void 0,
    categories: ["Cat A"]
    // Non-empty categories
  },
  {
    id: 2,
    name: "Field Without Categories",
    extId: "f2",
    searchable: !1,
    referenceFields: [],
    types: [],
    fieldType: "",
    refSeparator: void 0,
    defaultValue: void 0,
    checkSum: void 0,
    categories: []
    // Empty categories
  },
  {
    id: 3,
    name: "Field With Undefined Categories",
    extId: "f3",
    searchable: !1,
    referenceFields: [],
    types: [],
    fieldType: "",
    refSeparator: void 0,
    defaultValue: void 0,
    checkSum: void 0,
    categories: void 0
  },
  {
    id: 4,
    name: "Another Field With Categories",
    extId: "f4",
    searchable: !1,
    referenceFields: [],
    types: [],
    fieldType: "",
    refSeparator: void 0,
    defaultValue: void 0,
    checkSum: void 0,
    categories: ["Cat B", "Cat C"]
  },
  {
    id: 5,
    name: "Field With Null Categories",
    extId: "f5",
    searchable: !1,
    referenceFields: [],
    types: [],
    fieldType: "",
    refSeparator: void 0,
    defaultValue: void 0,
    checkSum: void 0,
    categories: null
    // Simulate null categories
  }
], nt = {
  appFieldName: "field_name",
  fieldLabel: "Field name",
  isSearchable: !0
}, Hr = {
  applicationObjectTypeName: "type_name",
  applicationObjectTypeLabel: "Type name",
  status: C.EObjectTypeMappingStatuses.MAPPED
}, uz = {
  appId: C.EAppId.TE_REGISTRATION,
  objectTypes: [
    {
      ...Hr,
      applicationObjectTypeGroup: C.EApplicationObjectTypeGroup.ROOM,
      // First kind of room
      objectTypeId: 500,
      fields: [
        {
          ...nt,
          appProperty: C.EAppProperties.LABEL,
          fieldId: 501
        },
        {
          ...nt,
          appProperty: C.EAppProperties.TITLE,
          fieldId: 502
        }
      ]
    },
    {
      ...Hr,
      applicationObjectTypeGroup: C.EApplicationObjectTypeGroup.ROOM,
      // Second kind of room
      objectTypeId: 600,
      fields: [
        {
          ...nt,
          appProperty: C.EAppProperties.LABEL,
          fieldId: 601
        },
        {
          ...nt,
          appProperty: C.EAppProperties.TITLE,
          fieldId: 602
        }
      ]
    },
    {
      ...Hr,
      applicationObjectTypeGroup: C.EApplicationObjectTypeGroup.PROGRAM,
      objectTypeId: 204,
      fields: [
        {
          ...nt,
          appProperty: C.EAppProperties.LABEL,
          fieldId: 101
        },
        {
          ...nt,
          appProperty: C.EAppProperties.TITLE,
          fieldId: 102
        }
      ]
    },
    {
      ...Hr,
      applicationObjectTypeGroup: C.EApplicationObjectTypeGroup.COURSE,
      objectTypeId: 201,
      fields: [
        {
          ...nt,
          appProperty: C.EAppProperties.LABEL,
          fieldId: 101
        },
        {
          ...nt,
          appProperty: C.EAppProperties.TITLE,
          fieldId: 102
        },
        {
          ...nt,
          appProperty: C.EAppProperties.MAX_STUDENTS,
          fieldId: 110,
          isSearchable: !1
        },
        {
          ...nt,
          appProperty: C.EAppProperties.MAX_STUDENTS,
          fieldId: 111,
          isSearchable: !1
        }
      ]
    },
    {
      ...Hr,
      applicationObjectTypeGroup: C.EApplicationObjectTypeGroup.STUDENT_SET_GROUP,
      objectTypeId: 203,
      fields: [
        {
          ...nt,
          appProperty: C.EAppProperties.LABEL,
          fieldId: 106
        },
        {
          ...nt,
          appProperty: C.EAppProperties.MAX_STUDENTS,
          fieldId: 109
        },
        {
          ...nt,
          appProperty: C.EAppProperties.ACTIVITY_TYPE,
          fieldId: 111
        },
        {
          ...nt,
          appProperty: C.EAppProperties.START_DATE,
          fieldId: 113
        },
        {
          ...nt,
          appProperty: C.EAppProperties.END_DATE,
          fieldId: 114
        },
        {
          ...nt,
          appProperty: C.EAppProperties.BUFFER,
          fieldId: 116
        },
        {
          ...nt,
          appProperty: C.EAppProperties.DEDICATETRACK,
          fieldId: 117
        },
        {
          ...nt,
          appProperty: C.EAppProperties.HIDETRACK,
          fieldId: 118
        },
        {
          ...nt,
          appProperty: C.EAppProperties.TRACK,
          fieldId: 119
        }
      ]
    },
    {
      ...Hr,
      applicationObjectTypeGroup: C.EApplicationObjectTypeGroup.STUDENT,
      objectTypeId: 220,
      fields: [
        {
          ...nt,
          appProperty: C.EAppProperties.LABEL,
          fieldId: 120
        }
      ]
    },
    {
      ...Hr,
      applicationObjectTypeGroup: C.EApplicationObjectTypeGroup.STAFF,
      objectTypeId: 300,
      fields: [
        {
          ...nt,
          appProperty: C.EAppProperties.LABEL,
          fieldId: 301
        }
      ]
    },
    {
      ...Hr,
      applicationObjectTypeGroup: C.EApplicationObjectTypeGroup.ROOM,
      objectTypeId: 204,
      fields: [
        {
          ...nt,
          appProperty: C.EAppProperties.LABEL,
          fieldId: 401
        }
      ]
    }
  ]
}, MA = cG({
  parsers: vG,
  config: AG,
  logger: console
})({
  mappingData: uz,
  fields: nz,
  types: iz,
  memberTypes: oz
});
function A3(e, t) {
  return Nt.filter(
    (r) => MA.makeTypeCheck(e)(r) && (!M(t) || t.includes(r.id))
  );
}
function v3(e, t) {
  const r = Nt.find(
    (n) => MA.makeTypeCheck(e)(n) && (!M(t) || t === n.id)
  );
  if (!M(r))
    throw new Error(`No '${e}'${t ? ` with id '${t}'` : ""} found.`);
  return r;
}
export {
  RF as AddWaitlistError,
  uF as AdminConfigurationError,
  cM as AllocateTreeTableLevel,
  mF as AutoAllocateBusyError,
  iF as BadRequestError,
  UB as CatalogService,
  EF as CloudJobRunningError,
  LB as DEFAULT_TIMEOUT_MS,
  og as DEFAULT_TIMEZONE,
  xB as ENABLE_STUDENT_TO_DEALLCOATE,
  fz as ERROR,
  DF as EnvError,
  le as ErrorName,
  fF as ExternalServiceError,
  uf as FrontendError,
  bF as HeavyLoadError,
  NF as HistoryError,
  AF as InterruptAbortException,
  wF as IssueListCacheError,
  IB as LogService,
  DB as MAX_TIMEOUTS,
  _F as MaximumMembershipReachedByTypeError,
  IF as MaximumMembershipReachedError,
  dF as MultiError,
  PF as MyScheduleError,
  PB as NO_COURSE_ID,
  Ni as NO_DATE,
  ZG as NO_GROUP_ID,
  CB as NO_GROUP_NUMBER,
  sF as NoStudentObjectError,
  oF as NotFoundError,
  SF as NothingToAllocateError,
  Bz as ONE_DAY,
  qU as PARSE_DATE_CACHE_MAX_ENTRIES,
  MB as POLL_INTERVAL_MS,
  lF as PacemakerFetchError,
  cF as PacemakerResponseError,
  Al as PermissionError,
  hF as PopulateCacheBusyError,
  kn as RangeReduce,
  pF as RegistrationApiError,
  CF as RegistrationError,
  kB as RegistrationService,
  OF as ReservationError,
  jB as ScheduleService,
  Ho as StudentSetGroupConfigurationError,
  aF as SubscribeError,
  y3 as TEST_TOKEN,
  rF as TEServerFailedError,
  Ez as TeServerErrorCodes,
  NB as UNKNOWN_ID,
  vF as UnmountAbortException,
  nF as ValidationError,
  gF as WorkerInlineFallbackError,
  TF as WorkerQueueSaturated,
  yF as WorkerTimeoutError,
  BU as affectedSubjects,
  F4 as allFieldsFor,
  gz as allMembersAndRelatedIdsSet,
  yz as allMembersUniqIds,
  gb as allMembersUniqIdsSet,
  Vj as allRelatedUniqIds,
  Bj as allRelatedUniqIdsSet,
  _B as allocateDateFormat,
  RB as allocateDateTimeFormat,
  Ch as allocateDateTimeFormatRegex,
  EB as allocationFilterValueForGroup,
  zF as allocationRulesParser,
  V$ as allowedHtmlTags,
  of as arrayHasValues,
  qj as arrayToRecordById,
  Em as asInt,
  TA as assertCourseConfiguration,
  pz as assertNonEmptyArray,
  Y$ as booleanParser,
  FF as bufferParser,
  wz as calculateSignalSummary,
  $B as calculateStudentConflicts,
  E4 as checkIfStringContainsDangerousHtml,
  QG as checkIsConflict,
  iB as checkLinkedGroups,
  n4 as clearParseDateCache,
  Be as commonFieldProps,
  AG as config,
  Vz as convertToServerTime,
  Rb as convertToString,
  jF as createActivities,
  vl as createActivityId,
  MF as createActivityIdOrError,
  nB as createAllocationResultDataSource,
  I4 as createAllocationRulesString,
  Z$ as createCategoryProperty,
  FB as createConflictLookups,
  X4 as createCourseSelectionInfo,
  Pz as createErrorDatabaseEntry,
  bB as createFeats,
  ei as createFeatureCheck,
  aB as createFieldSort,
  O4 as createGroupsWithCourses,
  zj as createIdNumberFromString,
  K4 as createIssuesCourses,
  pf as createLookup,
  Y4 as createLookupMap,
  cG as createMappingUtilsForApp,
  LF as createMergedActivityIdOrError,
  g3 as createMockLinkedGroupsData,
  kz as createMultiStatus,
  rg as createObjectWithReservations,
  J$ as createRelationProperty,
  z4 as createReservationMappingUtilsForApp,
  oB as createSortParams,
  c4 as customerPath,
  Lr as customerPathFromSignature,
  qz as daysBetween,
  K$ as dedicationMatchingProperties,
  s4 as defaultCalendarDate,
  S4 as distributionRuleToString,
  Et as exhaustiveMatchingGuard,
  A3 as filterMockTeObjects,
  Iz as filterRecord,
  _z as filterRecordToArray,
  tB as filterReservationObjects,
  cB as findCourseIds,
  Z4 as findMissingObjectIdsFromObjects,
  v3 as findMockTeObject,
  H$ as finiteIntegerParser,
  T4 as finiteNumberParser,
  vz as firstRelated,
  ZU as formatDateString,
  vB as formatEventSubtitle,
  YG as formatModules,
  i4 as formatMongodbTimestamp,
  AB as formatRoom,
  o4 as formatTimeRange,
  fB as getActivityGroups,
  h4 as getAdminUrl,
  d4 as getAllocateUrl,
  _G as getCategoryFields,
  Q4 as getCategoryFromFieldId,
  uB as getCourseActivities,
  lB as getCourseGroups,
  GB as getCurrentConflicts,
  a4 as getDateIntervalsForStudentSetGroups,
  Cs as getDedication,
  YE as getDistributionSetting,
  hz as getEntries,
  gm as getErrorCause,
  eU as getErrorLogIds,
  Dt as getErrorMessage,
  qn as getErrorName,
  dB as getGroupActivity,
  pB as getGroupsLinks,
  v4 as getIdFromRelationProperty,
  DG as getIssueTypeGroupError,
  MG as getIssueTypeSystemError,
  xz as getKnownErrorTexts,
  BB as getLaunchDarklyClientId,
  Lz as getLogLevel,
  rU as getManyErrorCause,
  Qj as getManyErrorLogIds,
  bb as getManyErrorName,
  tU as getManyStatusCode,
  nU as getManyTeServerErrorCode,
  Oz as getObjectsFromRecord,
  u4 as getRegionFromAccessToken,
  l4 as getRegionalUrlForEnv,
  es as getStatusCode,
  iU as getTeServerErrorCode,
  p2 as getTimeEditDomain,
  Dz as getTimeOfDayLabels,
  Mz as getTranslations,
  AA as getTypesWithSubtypes,
  f2 as getUrlForEnvWithRegionPlaceholder,
  p4 as getViewerUrl,
  bA as groupName,
  W4 as groupsFromStudentInfo,
  mz as hasData,
  L4 as hasLogId,
  C4 as hasObjects,
  TB as hasProduct,
  N4 as hasResults,
  X$ as hasSameDistribution,
  mB as hasSizeOrBufferFailure,
  wG as hasTime,
  U4 as hasType,
  Az as ids,
  hB as idsFromRelations,
  Rz as idsInRecord,
  yB as inStepRange,
  qr as includesErrorName,
  EA as integerArrayParser,
  qE as integerParser,
  rB as invertMap,
  $F as isAllTypes,
  Bc as isAllocateDataStructure,
  D4 as isAllocateGroup,
  $e as isArray,
  w4 as isArrayOfObjectsWithId,
  fa as isBoolean,
  IG as isCourseComplete,
  jU as isCustomError,
  Fj as isDedicatedCategory,
  Gj as isDedicatedRelation,
  M as isDefined,
  Xn as isEmptyString,
  Tb as isErrorWithCause,
  Kj as isErrorWithErrorName,
  Zj as isErrorWithLogId,
  G1 as isErrorWithMessage,
  Xj as isErrorWithName,
  Jj as isErrorWithStack,
  x4 as isJobWithStatusOfLevel,
  k4 as isKey,
  j4 as isLinkState,
  H4 as isMember,
  Hz as isMoreThenOneDay,
  Bn as isNonEmptyArray,
  Er as isNullish,
  Xe as isNumber,
  qs as isObjectWithFields,
  P4 as isObjectWithId,
  $j as isObjectWithMembers,
  mb as isObjectWithRelations,
  hm as isObjectWithTypes,
  dz as isPositiveNumber,
  Te as isRecord,
  Uj as isRegistrationGroup,
  qm as isSameDay,
  Wz as isStartOrEndDay,
  UF as isStatusOfLevel,
  vt as isString,
  M4 as isSuccessHandlerResponse,
  Jm as isValidDate,
  Sz as isValidId,
  m4 as isValidUrl,
  OB as isoDateformat,
  Ra as joinTexts,
  rT as jsonStringify,
  Nz as jsonToText,
  ml as languageTranslations,
  SG as makeStudentInfo,
  MA as mappingMock,
  mm as mergeById,
  Wj as mergeFieldOnId,
  Tz as mergeFieldsOnObjects,
  r3 as mockAuthorization,
  Cr as mockCatalog,
  p3 as mockCatalogPreActivity,
  n3 as mockCustomerSignature,
  XB as mockDateTime,
  b3 as mockFields,
  YB as mockFrontendOptimizerProposalAllocatedStatus,
  HB as mockFrontendOptimizerProposalCompletedStatus,
  qB as mockFrontendOptimizerProposalPendingStatus,
  uz as mockMappingData,
  KB as mockOptimizerProposalAllocatedStatus,
  JB as mockOptimizerProposalCompletedStatus,
  ZB as mockOptimizerProposalPendingStatus,
  h3 as mockRegistration,
  c3 as mockRootUser,
  t3 as mockStudentFields,
  e3 as mockStudentRelationIds,
  nz as mockTeFields,
  oz as mockTeMemberTypes,
  Nt as mockTeObjects,
  E3 as mockTeReservation,
  o3 as mockTeReservationWithTwoGroups,
  a3 as mockTeReservationWithTwoGroupsAndStudentReservations,
  s3 as mockTeReservationWithTwoGroupsAndStudentReservationsLookup,
  i3 as mockTeReservationWithTwoGroupsLookup,
  l3 as mockTeReservations,
  u3 as mockTeReservationsLookup,
  m3 as mockTeType,
  iz as mockTeTypes,
  d3 as mockTeUser,
  CA as mockTimeZoneNamed,
  QB as mockTimeZones,
  f3 as mockUser,
  Co as nonEmptyStringParser,
  HE as nonNegativeFiniteIntegerParser,
  b4 as nonNegativeFiniteNumberParser,
  A4 as numberArrayParser,
  q$ as numberParser,
  wB as optimizeTimeFormat,
  zB as organizationId1,
  Yz as overlapsDay,
  y4 as paginateData,
  gB as parseAllocationFilterValue,
  oU as parseCause,
  Hs as parseDate,
  r4 as parseDateCacheSize,
  HF as parseDateRange,
  Km as parseSafeDate,
  $4 as parseTypeIds,
  G4 as parseViewLink,
  vG as parsers,
  q4 as prepareStudentInfo,
  J4 as presentCourse,
  Jz as presentDate,
  t4 as presentDateAndTime,
  YU as presentDateInfo,
  e4 as presentDateInfoDateTime,
  Qz as presentDateInfoRange,
  gl as presentDateInfoTime,
  Zz as presentDateWithOptionalTime,
  R4 as presentGroupName,
  Ym as presentIsoDate,
  Zm as presentLongDate,
  Xz as presentLongDateRange,
  Kz as presentRange,
  $z as presentText,
  Hm as presentTime,
  WB as readableOptimizerStatusCode,
  Hj as recordSize,
  l2 as regionMapping,
  T3 as registrationMocks,
  XU as registrationPeriodOpen,
  Fz as removeLinebreaks,
  zz as replaceBraces,
  c2 as replaceRegionPlaceholder,
  B4 as reservationParsers,
  Ab as resolveMultiError,
  Cz as safeFromJSONArray,
  Yj as safeFromJSONObject,
  RG as setFieldValue,
  _4 as shouldSaveDistribution,
  Gz as sortEmptyStringsLast,
  Cu as sortIdsByLabel,
  sB as sortObjectsByField,
  ig as sortObjectsByKey,
  W$ as stringArrayParser,
  $r as stringHasContent,
  jz as stringLength,
  Ce as stringParser,
  f4 as stripCustomerPart,
  V4 as studentsFromStudentInfo,
  SB as summarizePreferredGroups,
  g4 as toArray,
  sU as toSafeError,
  Uz as toTitleCase,
  ve as translations,
  bz as uniq,
  yb as unsafeRecordValues,
  eB as updateFieldIfChanged,
  n2 as updateStartAndEnd,
  VB as useFeatureFlags,
  Q$ as validateDistribution,
  yA as validateGroupConfiguration,
  gA as validateOrErrorActivity
};
//# sourceMappingURL=lib.mjs.map
